var D4 = Object.defineProperty;
var I4 = (e, t, r) => t in e ? D4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var it = (e, t, r) => (I4(e, typeof t != "symbol" ? t + "" : t, r), r);
import { shallowRef as ir, isRef as _a, watch as He, shallowReadonly as N4, getCurrentScope as eT, onScopeDispose as D1, onMounted as ct, nextTick as Pt, toValue as rr, getCurrentInstance as Mi, hasInjectionContext as tT, inject as sr, computed as N, reactive as Sn, ref as ne, watchEffect as Nr, unref as U, defineComponent as Ae, defineAsyncComponent as Dl, markRaw as rT, openBlock as R, createElementBlock as K, normalizeStyle as Ir, createBlock as Le, resolveDynamicComponent as Za, mergeProps as Mt, onBeforeUnmount as Ai, useSlots as lu, h as Ht, effectScope as $4, onUnmounted as Tr, Fragment as Qe, createVNode as Fe, Text as L4, useAttrs as $d, useCssVars as I1, normalizeClass as pe, createElementVNode as ue, renderSlot as ke, toDisplayString as Ie, createCommentVNode as fe, resolveDirective as R4, renderList as kt, withCtx as Pe, withDirectives as ea, triggerRef as Sy, cloneVNode as aT, provide as Mr, toRaw as fr, Teleport as Oo, createTextVNode as jt, vShow as $a, Transition as Hn, pushScopeId as nT, popScopeId as iT, createSlots as Ma, normalizeProps as jr, guardReactiveProps as oa, withModifiers as zr, toRef as ql, withKeys as Ot, onBeforeUpdate as j4, onErrorCaptured as F4, createStaticVNode as B4, watchPostEffect as q4, vModelDynamic as sT, resolveComponent as H4, toRefs as uo, vModelText as V4 } from "vue";
import { RouterLink as uu } from "vue-router";
function mo(e) {
  return eT() ? (D1(e), !0) : !1;
}
const vf = /* @__PURE__ */ new WeakMap(), U4 = (...e) => {
  var t;
  const r = e[0], a = (t = Mi()) == null ? void 0 : t.proxy;
  if (a == null && !tT())
    throw new Error("injectLocal must be called in setup");
  return a && vf.has(a) && r in vf.get(a) ? vf.get(a)[r] : sr(...e);
}, pd = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const z4 = (e) => typeof e < "u", oT = (e) => e != null, Y4 = Object.prototype.toString, W4 = (e) => Y4.call(e) === "[object Object]", la = () => {
}, G4 = /* @__PURE__ */ X4();
function X4() {
  var e, t;
  return pd && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function N1(e, t) {
  function r(...a) {
    return new Promise((n, i) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(n).catch(i);
    });
  }
  return r;
}
const K4 = (e) => e();
function lT(e, t = {}) {
  let r, a, n = la;
  const i = (l) => {
    clearTimeout(l), n(), n = la;
  };
  let s;
  return (l) => {
    const u = rr(e), d = rr(t.maxWait);
    return r && i(r), u <= 0 || d !== void 0 && d <= 0 ? (a && (i(a), a = null), Promise.resolve(l())) : new Promise((f, c) => {
      n = t.rejectOnCancel ? c : f, s = l, d && !a && (a = setTimeout(() => {
        r && i(r), a = null, f(s());
      }, d)), r = setTimeout(() => {
        a && i(a), a = null, f(l());
      }, u);
    });
  };
}
function J4(...e) {
  let t = 0, r, a = !0, n = la, i, s, o, l, u;
  !_a(e[0]) && typeof e[0] == "object" ? { delay: s, trailing: o = !0, leading: l = !0, rejectOnCancel: u = !1 } = e[0] : [s, o = !0, l = !0, u = !1] = e;
  const d = () => {
    r && (clearTimeout(r), r = void 0, n(), n = la);
  };
  return (c) => {
    const p = rr(s), v = Date.now() - t, h = () => i = c();
    return d(), p <= 0 ? (t = Date.now(), h()) : (v > p && (l || !a) ? (t = Date.now(), h()) : o && (i = new Promise((g, m) => {
      n = u ? m : g, r = setTimeout(() => {
        t = Date.now(), a = !0, g(h()), d();
      }, Math.max(0, p - v));
    })), !l && !r && (r = setTimeout(() => a = !0, p)), a = !1, i);
  };
}
function hp(e, t = !1, r = "Timeout") {
  return new Promise((a, n) => {
    setTimeout(t ? () => n(r) : a, e);
  });
}
function Ey(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Il(e) {
  return Array.isArray(e) ? e : [e];
}
function Q4(e) {
  return e || Mi();
}
function Z4(e, t = 200, r = {}) {
  return N1(
    lT(t, r),
    e
  );
}
function e5(e, t = 200, r = !1, a = !0, n = !1) {
  return N1(
    J4(t, r, a, n),
    e
  );
}
function t5(e, t, r = {}) {
  const {
    eventFilter: a = K4,
    ...n
  } = r;
  return He(
    e,
    N1(
      a,
      t
    ),
    n
  );
}
function $1(e, t = !0, r) {
  Q4(r) ? ct(e, r) : t ? e() : Pt(e);
}
function gp(e, t = !1) {
  function r(f, { flush: c = "sync", deep: p = !1, timeout: v, throwOnTimeout: h } = {}) {
    let g = null;
    const b = [new Promise((y) => {
      g = He(
        e,
        (_) => {
          f(_) !== t && (g ? g() : Pt(() => g == null ? void 0 : g()), y(_));
        },
        {
          flush: c,
          deep: p,
          immediate: !0
        }
      );
    })];
    return v != null && b.push(
      hp(v, h).then(() => rr(e)).finally(() => g == null ? void 0 : g())
    ), Promise.race(b);
  }
  function a(f, c) {
    if (!_a(f))
      return r((_) => _ === f, c);
    const { flush: p = "sync", deep: v = !1, timeout: h, throwOnTimeout: g } = c ?? {};
    let m = null;
    const y = [new Promise((_) => {
      m = He(
        [e, f],
        ([x, w]) => {
          t !== (x === w) && (m ? m() : Pt(() => m == null ? void 0 : m()), _(x));
        },
        {
          flush: p,
          deep: v,
          immediate: !0
        }
      );
    })];
    return h != null && y.push(
      hp(h, g).then(() => rr(e)).finally(() => (m == null || m(), rr(e)))
    ), Promise.race(y);
  }
  function n(f) {
    return r((c) => !!c, f);
  }
  function i(f) {
    return a(null, f);
  }
  function s(f) {
    return a(void 0, f);
  }
  function o(f) {
    return r(Number.isNaN, f);
  }
  function l(f, c) {
    return r((p) => {
      const v = Array.from(p);
      return v.includes(f) || v.includes(rr(f));
    }, c);
  }
  function u(f) {
    return d(1, f);
  }
  function d(f = 1, c) {
    let p = -1;
    return r(() => (p += 1, p >= f), c);
  }
  return Array.isArray(rr(e)) ? {
    toMatch: r,
    toContains: l,
    changed: u,
    changedTimes: d,
    get not() {
      return gp(e, !t);
    }
  } : {
    toMatch: r,
    toBe: a,
    toBeTruthy: n,
    toBeNull: i,
    toBeNaN: o,
    toBeUndefined: s,
    changed: u,
    changedTimes: d,
    get not() {
      return gp(e, !t);
    }
  };
}
function r5(e) {
  return gp(e);
}
function a5(e, t = 1e3, r = {}) {
  const {
    immediate: a = !0,
    immediateCallback: n = !1
  } = r;
  let i = null;
  const s = ir(!1);
  function o() {
    i && (clearInterval(i), i = null);
  }
  function l() {
    s.value = !1, o();
  }
  function u() {
    const d = rr(t);
    d <= 0 || (s.value = !0, n && e(), o(), s.value && (i = setInterval(e, d)));
  }
  if (a && pd && u(), _a(t) || typeof t == "function") {
    const d = He(t, () => {
      s.value && pd && u();
    });
    mo(d);
  }
  return mo(l), {
    isActive: N4(s),
    pause: l,
    resume: u
  };
}
function L1(e = !1, t = {}) {
  const {
    truthyValue: r = !0,
    falsyValue: a = !1
  } = t, n = _a(e), i = ir(e);
  function s(o) {
    if (arguments.length)
      return i.value = o, i.value;
    {
      const l = rr(r);
      return i.value = i.value === l ? rr(a) : l, i.value;
    }
  }
  return n ? s : [i, s];
}
function n5(e, t, r = {}) {
  const {
    debounce: a = 0,
    maxWait: n = void 0,
    ...i
  } = r;
  return t5(
    e,
    t,
    {
      ...i,
      eventFilter: lT(a, { maxWait: n })
    }
  );
}
function i5(e, t, r) {
  return He(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
const es = pd ? window : void 0;
function Da(e) {
  var t;
  const r = rr(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function yn(...e) {
  const t = [], r = () => {
    t.forEach((o) => o()), t.length = 0;
  }, a = (o, l, u, d) => (o.addEventListener(l, u, d), () => o.removeEventListener(l, u, d)), n = N(() => {
    const o = Il(rr(e[0])).filter((l) => l != null);
    return o.every((l) => typeof l != "string") ? o : void 0;
  }), i = i5(
    () => {
      var o, l;
      return [
        (l = (o = n.value) == null ? void 0 : o.map((u) => Da(u))) != null ? l : [es].filter((u) => u != null),
        Il(rr(n.value ? e[1] : e[0])),
        Il(U(n.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        rr(n.value ? e[3] : e[2])
      ];
    },
    ([o, l, u, d]) => {
      if (r(), !(o != null && o.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const f = W4(d) ? { ...d } : d;
      t.push(
        ...o.flatMap(
          (c) => l.flatMap(
            (p) => u.map((v) => a(c, p, v, f))
          )
        )
      );
    },
    { flush: "post" }
  ), s = () => {
    i(), r();
  };
  return mo(r), s;
}
let Oy = !1;
function du(e, t, r = {}) {
  const { window: a = es, ignore: n = [], capture: i = !0, detectIframe: s = !1, controls: o = !1 } = r;
  if (!a)
    return o ? { stop: la, cancel: la, trigger: la } : la;
  if (G4 && !Oy) {
    Oy = !0;
    const g = { passive: !0 };
    Array.from(a.document.body.children).forEach((m) => m.addEventListener("click", la, g)), a.document.documentElement.addEventListener("click", la, g);
  }
  let l = !0;
  const u = (g) => rr(n).some((m) => {
    if (typeof m == "string")
      return Array.from(a.document.querySelectorAll(m)).some((b) => b === g.target || g.composedPath().includes(b));
    {
      const b = Da(m);
      return b && (g.target === b || g.composedPath().includes(b));
    }
  });
  function d(g) {
    const m = rr(g);
    return m && m.$.subTree.shapeFlag === 16;
  }
  function f(g, m) {
    const b = rr(g), y = b.$.subTree && b.$.subTree.children;
    return y == null || !Array.isArray(y) ? !1 : y.some((_) => _.el === m.target || m.composedPath().includes(_.el));
  }
  const c = (g) => {
    const m = Da(e);
    if (g.target != null && !(!(m instanceof Element) && d(e) && f(e, g)) && !(!m || m === g.target || g.composedPath().includes(m))) {
      if ("detail" in g && g.detail === 0 && (l = !u(g)), !l) {
        l = !0;
        return;
      }
      t(g);
    }
  };
  let p = !1;
  const v = [
    yn(a, "click", (g) => {
      p || (p = !0, setTimeout(() => {
        p = !1;
      }, 0), c(g));
    }, { passive: !0, capture: i }),
    yn(a, "pointerdown", (g) => {
      const m = Da(e);
      l = !u(g) && !!(m && !g.composedPath().includes(m));
    }, { passive: !0 }),
    s && yn(a, "blur", (g) => {
      setTimeout(() => {
        var m;
        const b = Da(e);
        ((m = a.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(b != null && b.contains(a.document.activeElement)) && t(g);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), h = () => v.forEach((g) => g());
  return o ? {
    stop: h,
    cancel: () => {
      l = !1;
    },
    trigger: (g) => {
      l = !0, c(g), l = !1;
    }
  } : h;
}
function s5() {
  const e = ir(!1), t = Mi();
  return t && ct(() => {
    e.value = !0;
  }, t), e;
}
function Ld(e) {
  const t = s5();
  return N(() => (t.value, !!e()));
}
function o5(e, t, r = {}) {
  const { window: a = es, ...n } = r;
  let i;
  const s = Ld(() => a && "MutationObserver" in a), o = () => {
    i && (i.disconnect(), i = void 0);
  }, l = N(() => {
    const c = rr(e), p = Il(c).map(Da).filter(oT);
    return new Set(p);
  }), u = He(
    () => l.value,
    (c) => {
      o(), s.value && c.size && (i = new MutationObserver(t), c.forEach((p) => i.observe(p, n)));
    },
    { immediate: !0, flush: "post" }
  ), d = () => i == null ? void 0 : i.takeRecords(), f = () => {
    u(), o();
  };
  return mo(f), {
    isSupported: s,
    stop: f,
    takeRecords: d
  };
}
function l5(e, t, r) {
  const {
    immediate: a = !0,
    delay: n = 0,
    onError: i = la,
    onSuccess: s = la,
    resetOnExecute: o = !0,
    shallow: l = !0,
    throwError: u
  } = r ?? {}, d = l ? ir(t) : ne(t), f = ir(!1), c = ir(!1), p = ir(void 0);
  async function v(m = 0, ...b) {
    o && (d.value = t), p.value = void 0, f.value = !1, c.value = !0, m > 0 && await hp(m);
    const y = typeof e == "function" ? e(...b) : e;
    try {
      const _ = await y;
      d.value = _, f.value = !0, s(_);
    } catch (_) {
      if (p.value = _, i(_), u)
        throw _;
    } finally {
      c.value = !1;
    }
    return d.value;
  }
  a && v(n);
  const h = {
    state: d,
    isReady: f,
    isLoading: c,
    error: p,
    execute: v
  };
  function g() {
    return new Promise((m, b) => {
      r5(c).toBe(!1).then(() => m(h)).catch(b);
    });
  }
  return {
    ...h,
    then(m, b) {
      return g().then(m, b);
    }
  };
}
const u5 = Symbol("vueuse-ssr-width");
function d5() {
  const e = tT() ? U4(u5, null) : null;
  return typeof e == "number" ? e : void 0;
}
function c5(e, t = {}) {
  const { window: r = es, ssrWidth: a = d5() } = t, n = Ld(() => r && "matchMedia" in r && typeof r.matchMedia == "function"), i = ir(typeof a == "number"), s = ir(), o = ir(!1), l = (u) => {
    o.value = u.matches;
  };
  return Nr(() => {
    if (i.value) {
      i.value = !n.value;
      const u = rr(e).split(",");
      o.value = u.some((d) => {
        const f = d.includes("not all"), c = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), p = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let v = !!(c || p);
        return c && v && (v = a >= Ey(c[1])), p && v && (v = a <= Ey(p[1])), f ? !v : v;
      });
      return;
    }
    n.value && (s.value = r.matchMedia(rr(e)), o.value = s.value.matches);
  }), yn(s, "change", l, { passive: !0 }), N(() => o.value);
}
function f5(e) {
  return JSON.parse(JSON.stringify(e));
}
function uT(e, t, r = {}) {
  const { window: a = es, ...n } = r;
  let i;
  const s = Ld(() => a && "ResizeObserver" in a), o = () => {
    i && (i.disconnect(), i = void 0);
  }, l = N(() => {
    const f = rr(e);
    return Array.isArray(f) ? f.map((c) => Da(c)) : [Da(f)];
  }), u = He(
    l,
    (f) => {
      if (o(), s.value && a) {
        i = new ResizeObserver(t);
        for (const c of f)
          c && i.observe(c, n);
      }
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    o(), u();
  };
  return mo(d), {
    isSupported: s,
    stop: d
  };
}
function Cy(e, t = {}) {
  const {
    reset: r = !0,
    windowResize: a = !0,
    windowScroll: n = !0,
    immediate: i = !0,
    updateTiming: s = "sync"
  } = t, o = ir(0), l = ir(0), u = ir(0), d = ir(0), f = ir(0), c = ir(0), p = ir(0), v = ir(0);
  function h() {
    const m = Da(e);
    if (!m) {
      r && (o.value = 0, l.value = 0, u.value = 0, d.value = 0, f.value = 0, c.value = 0, p.value = 0, v.value = 0);
      return;
    }
    const b = m.getBoundingClientRect();
    o.value = b.height, l.value = b.bottom, u.value = b.left, d.value = b.right, f.value = b.top, c.value = b.width, p.value = b.x, v.value = b.y;
  }
  function g() {
    s === "sync" ? h() : s === "next-frame" && requestAnimationFrame(() => h());
  }
  return uT(e, g), He(() => Da(e), (m) => !m && g()), o5(e, g, {
    attributeFilter: ["style", "class"]
  }), n && yn("scroll", g, { capture: !0, passive: !0 }), a && yn("resize", g, { passive: !0 }), $1(() => {
    i && g();
  }), {
    height: o,
    bottom: l,
    left: u,
    right: d,
    top: f,
    width: c,
    x: p,
    y: v,
    update: g
  };
}
function p5(e, t, r = {}) {
  const {
    root: a,
    rootMargin: n = "0px",
    threshold: i = 0,
    window: s = es,
    immediate: o = !0
  } = r, l = Ld(() => s && "IntersectionObserver" in s), u = N(() => {
    const v = rr(e);
    return Il(v).map(Da).filter(oT);
  });
  let d = la;
  const f = ir(o), c = l.value ? He(
    () => [u.value, Da(a), f.value],
    ([v, h]) => {
      if (d(), !f.value || !v.length)
        return;
      const g = new IntersectionObserver(
        t,
        {
          root: Da(h),
          rootMargin: n,
          threshold: i
        }
      );
      v.forEach((m) => m && g.observe(m)), d = () => {
        g.disconnect(), d = la;
      };
    },
    { immediate: o, flush: "post" }
  ) : la, p = () => {
    d(), c(), f.value = !1;
  };
  return mo(p), {
    isSupported: l,
    isActive: f,
    pause() {
      d(), f.value = !1;
    },
    resume() {
      f.value = !0;
    },
    stop: p
  };
}
function v5(e, t = {}) {
  const { initialValue: r = !1, focusVisible: a = !1, preventScroll: n = !1 } = t, i = ir(!1), s = N(() => Da(e)), o = { passive: !0 };
  yn(s, "focus", (u) => {
    var d, f;
    (!a || (f = (d = u.target).matches) != null && f.call(d, ":focus-visible")) && (i.value = !0);
  }, o), yn(s, "blur", () => i.value = !1, o);
  const l = N({
    get: () => i.value,
    set(u) {
      var d, f;
      !u && i.value ? (d = s.value) == null || d.blur() : u && !i.value && ((f = s.value) == null || f.focus({ preventScroll: n }));
    }
  });
  return He(
    s,
    () => {
      l.value = r;
    },
    { immediate: !0, flush: "post" }
  ), { focused: l };
}
async function m5(e) {
  return new Promise((t, r) => {
    const a = new Image(), { src: n, srcset: i, sizes: s, class: o, loading: l, crossorigin: u, referrerPolicy: d, width: f, height: c, decoding: p, fetchPriority: v, ismap: h, usemap: g } = e;
    a.src = n, i != null && (a.srcset = i), s != null && (a.sizes = s), o != null && (a.className = o), l != null && (a.loading = l), u != null && (a.crossOrigin = u), d != null && (a.referrerPolicy = d), f != null && (a.width = f), c != null && (a.height = c), p != null && (a.decoding = p), v != null && (a.fetchPriority = v), h != null && (a.isMap = h), g != null && (a.useMap = g), a.onload = () => t(a), a.onerror = r;
  });
}
function h5(e, t = {}) {
  const r = l5(
    () => m5(rr(e)),
    void 0,
    {
      resetOnExecute: !0,
      ...t
    }
  );
  return He(
    () => rr(e),
    () => r.execute(t.delay),
    { deep: !0 }
  ), r;
}
const ky = 1;
function dT(e, t = {}) {
  const {
    throttle: r = 0,
    idle: a = 200,
    onStop: n = la,
    onScroll: i = la,
    offset: s = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: o = {
      capture: !1,
      passive: !0
    },
    behavior: l = "auto",
    window: u = es,
    onError: d = (k) => {
      console.error(k);
    }
  } = t, f = ir(0), c = ir(0), p = N({
    get() {
      return f.value;
    },
    set(k) {
      h(k, void 0);
    }
  }), v = N({
    get() {
      return c.value;
    },
    set(k) {
      h(void 0, k);
    }
  });
  function h(k, S) {
    var P, A, E, O;
    if (!u)
      return;
    const T = rr(e);
    if (!T)
      return;
    (E = T instanceof Document ? u.document.body : T) == null || E.scrollTo({
      top: (P = rr(S)) != null ? P : v.value,
      left: (A = rr(k)) != null ? A : p.value,
      behavior: rr(l)
    });
    const D = ((O = T == null ? void 0 : T.document) == null ? void 0 : O.documentElement) || (T == null ? void 0 : T.documentElement) || T;
    p != null && (f.value = D.scrollLeft), v != null && (c.value = D.scrollTop);
  }
  const g = ir(!1), m = Sn({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), b = Sn({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), y = (k) => {
    g.value && (g.value = !1, b.left = !1, b.right = !1, b.top = !1, b.bottom = !1, n(k));
  }, _ = Z4(y, r + a), x = (k) => {
    var S;
    if (!u)
      return;
    const P = ((S = k == null ? void 0 : k.document) == null ? void 0 : S.documentElement) || (k == null ? void 0 : k.documentElement) || Da(k), { display: A, flexDirection: E, direction: O } = getComputedStyle(P), T = O === "rtl" ? -1 : 1, D = P.scrollLeft;
    b.left = D < f.value, b.right = D > f.value;
    const $ = Math.abs(D * T) <= (s.left || 0), I = Math.abs(D * T) + P.clientWidth >= P.scrollWidth - (s.right || 0) - ky;
    A === "flex" && E === "row-reverse" ? (m.left = I, m.right = $) : (m.left = $, m.right = I), f.value = D;
    let F = P.scrollTop;
    k === u.document && !F && (F = u.document.body.scrollTop), b.top = F < c.value, b.bottom = F > c.value;
    const j = Math.abs(F) <= (s.top || 0), M = Math.abs(F) + P.clientHeight >= P.scrollHeight - (s.bottom || 0) - ky;
    A === "flex" && E === "column-reverse" ? (m.top = M, m.bottom = j) : (m.top = j, m.bottom = M), c.value = F;
  }, w = (k) => {
    var S;
    if (!u)
      return;
    const P = (S = k.target.documentElement) != null ? S : k.target;
    x(P), g.value = !0, _(k), i(k);
  };
  return yn(
    e,
    "scroll",
    r ? e5(w, r, !0, !1) : w,
    o
  ), $1(() => {
    try {
      const k = rr(e);
      if (!k)
        return;
      x(k);
    } catch (k) {
      d(k);
    }
  }), yn(
    e,
    "scrollend",
    y,
    o
  ), {
    x: p,
    y: v,
    isScrolling: g,
    arrivedState: m,
    directions: b,
    measure() {
      const k = rr(e);
      u && k && x(k);
    }
  };
}
function $r(e, t, r, a = {}) {
  var n, i, s;
  const {
    clone: o = !1,
    passive: l = !1,
    eventName: u,
    deep: d = !1,
    defaultValue: f,
    shouldEmit: c
  } = a, p = Mi(), v = r || (p == null ? void 0 : p.emit) || ((n = p == null ? void 0 : p.$emit) == null ? void 0 : n.bind(p)) || ((s = (i = p == null ? void 0 : p.proxy) == null ? void 0 : i.$emit) == null ? void 0 : s.bind(p == null ? void 0 : p.proxy));
  let h = u;
  t || (t = "modelValue"), h = h || `update:${t.toString()}`;
  const g = (y) => o ? typeof o == "function" ? o(y) : f5(y) : y, m = () => z4(e[t]) ? g(e[t]) : f, b = (y) => {
    c ? c(y) && v(h, y) : v(h, y);
  };
  if (l) {
    const y = m(), _ = ne(y);
    let x = !1;
    return He(
      () => e[t],
      (w) => {
        x || (x = !0, _.value = g(w), Pt(() => x = !1));
      }
    ), He(
      _,
      (w) => {
        !x && (w !== e[t] || d) && b(w);
      },
      { deep: d }
    ), _;
  } else
    return N({
      get() {
        return m();
      },
      set(y) {
        b(y);
      }
    });
}
function cT(e = {}) {
  const {
    window: t = es,
    initialWidth: r = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: n = !0,
    includeScrollbar: i = !0,
    type: s = "inner"
  } = e, o = ir(r), l = ir(a), u = () => {
    if (t)
      if (s === "outer")
        o.value = t.outerWidth, l.value = t.outerHeight;
      else if (s === "visual" && t.visualViewport) {
        const { width: f, height: c, scale: p } = t.visualViewport;
        o.value = Math.round(f * p), l.value = Math.round(c * p);
      } else
        i ? (o.value = t.innerWidth, l.value = t.innerHeight) : (o.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  u(), $1(u);
  const d = { passive: !0 };
  if (yn("resize", u, d), t && s === "visual" && t.visualViewport && yn(t.visualViewport, "resize", u, d), n) {
    const f = c5("(orientation: portrait)");
    He(f, () => u());
  }
  return { width: o, height: l };
}
const R1 = (e, t) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((a, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(n.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, gt = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JIcon",
  props: {
    name: {},
    size: { default: 24 }
  },
  setup(e) {
    const t = e, r = {}, a = ne(), n = ne(), [i, s] = L1(!0);
    return He(
      () => t.name,
      async (o) => {
        if (r[o])
          n.value = r[o], s(!1);
        else {
          const l = await Dl(
            () => R1(/* @__PURE__ */ Object.assign({ "../../assets/icons/add-square-linear.svg": () => import("./add-square-linear-5df35007.mjs"), "../../assets/icons/add-user-linear.svg": () => import("./add-user-linear-850ce994.mjs"), "../../assets/icons/adults.svg": () => import("./adults-7596a362.mjs"), "../../assets/icons/airplane-outline.svg": () => import("./airplane-outline-a9ce097d.mjs"), "../../assets/icons/airplane.svg": () => import("./airplane-9c301a21.mjs"), "../../assets/icons/alt-arrow-down-filled.svg": () => import("./alt-arrow-down-filled-d84d71fb.mjs"), "../../assets/icons/alt-arrow-down.svg": () => import("./alt-arrow-down-a153d6dd.mjs"), "../../assets/icons/alt-arrow-left-line.svg": () => import("./alt-arrow-left-line-459a25d2.mjs"), "../../assets/icons/alt-arrow-right-filled.svg": () => import("./alt-arrow-right-filled-595c4d92.mjs"), "../../assets/icons/alt-arrow-right-line.svg": () => import("./alt-arrow-right-line-d347b22e.mjs"), "../../assets/icons/alt-arrow-up-down.svg": () => import("./alt-arrow-up-down-57ba5e85.mjs"), "../../assets/icons/alt-arrow-up.svg": () => import("./alt-arrow-up-7aff5c9c.mjs"), "../../assets/icons/arrow-circle-up.svg": () => import("./arrow-circle-up-5eeaa283.mjs"), "../../assets/icons/arrow-left.svg": () => import("./arrow-left-e032002d.mjs"), "../../assets/icons/arrow-right-outline.svg": () => import("./arrow-right-outline-d46f06be.mjs"), "../../assets/icons/arrow-right.svg": () => import("./arrow-right-1d165252.mjs"), "../../assets/icons/arrows-action.svg": () => import("./arrows-action-49fbb889.mjs"), "../../assets/icons/backpack.svg": () => import("./backpack-65477277.mjs"), "../../assets/icons/bag-1-off-outline.svg": () => import("./bag-1-off-outline-1e67db86.mjs"), "../../assets/icons/bag-1-outline.svg": () => import("./bag-1-outline-01d8d9f2.mjs"), "../../assets/icons/bag-2-off-outline.svg": () => import("./bag-2-off-outline-b74822fd.mjs"), "../../assets/icons/bag-2-outline.svg": () => import("./bag-2-outline-58a43ec9.mjs"), "../../assets/icons/bag-3-off-outline.svg": () => import("./bag-3-off-outline-3513040d.mjs"), "../../assets/icons/bag-3-outline.svg": () => import("./bag-3-outline-09ec5f5b.mjs"), "../../assets/icons/bag.svg": () => import("./bag-223d0c93.mjs"), "../../assets/icons/bar-chart.svg": () => import("./bar-chart-3daaa187.mjs"), "../../assets/icons/bed-double.svg": () => import("./bed-double-8397d144.mjs"), "../../assets/icons/bed-from-top.svg": () => import("./bed-from-top-e82e503e.mjs"), "../../assets/icons/bed-linear.svg": () => import("./bed-linear-5cf6e9f8.mjs"), "../../assets/icons/bed-single.svg": () => import("./bed-single-0dcc9ab4.mjs"), "../../assets/icons/bed.svg": () => import("./bed-619e5f3e.mjs"), "../../assets/icons/bedroom.svg": () => import("./bedroom-a4274cd7.mjs"), "../../assets/icons/bell.svg": () => import("./bell-1c995d7f.mjs"), "../../assets/icons/box-search.svg": () => import("./box-search-e682f2b5.mjs"), "../../assets/icons/breakfast.svg": () => import("./breakfast-4372ca66.mjs"), "../../assets/icons/briefcase.svg": () => import("./briefcase-33e60bdb.mjs"), "../../assets/icons/budget.svg": () => import("./budget-415bdca2.mjs"), "../../assets/icons/building-outline.svg": () => import("./building-outline-7efdd315.mjs"), "../../assets/icons/buildings-2.svg": () => import("./buildings-2-94226d1d.mjs"), "../../assets/icons/bullet-outlined.svg": () => import("./bullet-outlined-54f97403.mjs"), "../../assets/icons/bullet.svg": () => import("./bullet-71cd7c3b.mjs"), "../../assets/icons/calendar-outline.svg": () => import("./calendar-outline-0bab25a5.mjs"), "../../assets/icons/car-opened-door.svg": () => import("./car-opened-door-470361d7.mjs"), "../../assets/icons/car-outline.svg": () => import("./car-outline-71c52609.mjs"), "../../assets/icons/car-seat.svg": () => import("./car-seat-9fdafe0d.mjs"), "../../assets/icons/car.svg": () => import("./car-074cb6f1.mjs"), "../../assets/icons/card-pos.svg": () => import("./card-pos-cdee1ff6.mjs"), "../../assets/icons/card-transfer.svg": () => import("./card-transfer-01fb4f7f.mjs"), "../../assets/icons/chart.svg": () => import("./chart-130d089d.mjs"), "../../assets/icons/chat.svg": () => import("./chat-962f17a1.mjs"), "../../assets/icons/check-circle-bold-2.svg": () => import("./check-circle-bold-2-0c3a73e5.mjs"), "../../assets/icons/check-circle-bold.svg": () => import("./check-circle-bold-dd462db4.mjs"), "../../assets/icons/check.svg": () => import("./check-607238c5.mjs"), "../../assets/icons/child-outlined.svg": () => import("./child-outlined-2ef5791b.mjs"), "../../assets/icons/children.svg": () => import("./children-e3b080e3.mjs"), "../../assets/icons/circle-right-icon.svg": () => import("./circle-right-icon-f1aea87a.mjs"), "../../assets/icons/circle-top-up.svg": () => import("./circle-top-up-d60aeb17.mjs"), "../../assets/icons/civic-(cvc).svg": () => import("./civic-(cvc)-39f17a69.mjs"), "../../assets/icons/clock-circle-outline.svg": () => import("./clock-circle-outline-9fc9d46a.mjs"), "../../assets/icons/close-circle-bold.svg": () => import("./close-circle-bold-958fcb5f.mjs"), "../../assets/icons/close-circle-outline.svg": () => import("./close-circle-outline-a0c3536b.mjs"), "../../assets/icons/close.svg": () => import("./close-e48f810f.mjs"), "../../assets/icons/coins.svg": () => import("./coins-f66e597c.mjs"), "../../assets/icons/copy.svg": () => import("./copy-03cf67c6.mjs"), "../../assets/icons/crown.svg": () => import("./crown-f5fac33c.mjs"), "../../assets/icons/cup.svg": () => import("./cup-5589df01.mjs"), "../../assets/icons/danger-circle.svg": () => import("./danger-circle-43dcbf04.mjs"), "../../assets/icons/data-2.svg": () => import("./data-2-bbcb00d6.mjs"), "../../assets/icons/datepicker-accept.svg": () => import("./datepicker-accept-77ca9c27.mjs"), "../../assets/icons/day-and-night.svg": () => import("./day-and-night-39514a87.mjs"), "../../assets/icons/diagram.svg": () => import("./diagram-235598c0.mjs"), "../../assets/icons/document-download.svg": () => import("./document-download-6165a71f.mjs"), "../../assets/icons/document-text-filled.svg": () => import("./document-text-filled-e6399cac.mjs"), "../../assets/icons/document-text.svg": () => import("./document-text-93ecbfaf.mjs"), "../../assets/icons/dollar-outline.svg": () => import("./dollar-outline-e91bd9c6.mjs"), "../../assets/icons/dots.svg": () => import("./dots-9fbdd207.mjs"), "../../assets/icons/envelop.svg": () => import("./envelop-3736a261.mjs"), "../../assets/icons/eur-outline.svg": () => import("./eur-outline-018b7a73.mjs"), "../../assets/icons/export.svg": () => import("./export-4ad733e9.mjs"), "../../assets/icons/eye-hide.svg": () => import("./eye-hide-16dde7ec.mjs"), "../../assets/icons/eye.svg": () => import("./eye-35056563.mjs"), "../../assets/icons/filled-adult.svg": () => import("./filled-adult-9c06741a.mjs"), "../../assets/icons/filled-child.svg": () => import("./filled-child-414d3144.mjs"), "../../assets/icons/filled-document.svg": () => import("./filled-document-3ccbc1fe.mjs"), "../../assets/icons/filled-eye.svg": () => import("./filled-eye-d9e9bc67.mjs"), "../../assets/icons/filter.svg": () => import("./filter-2d4e13e2.mjs"), "../../assets/icons/forbidden.svg": () => import("./forbidden-c171b2d0.mjs"), "../../assets/icons/gallery-add.svg": () => import("./gallery-add-3890f27c.mjs"), "../../assets/icons/gears-shift.svg": () => import("./gears-shift-55d679c7.mjs"), "../../assets/icons/globe-outline.svg": () => import("./globe-outline-e680f9db.mjs"), "../../assets/icons/guest.svg": () => import("./guest-938c6d44.mjs"), "../../assets/icons/home.svg": () => import("./home-59953492.mjs"), "../../assets/icons/hotel-bed.svg": () => import("./hotel-bed-18af605a.mjs"), "../../assets/icons/hotel.svg": () => import("./hotel-c8f7664c.mjs"), "../../assets/icons/inbox-linear.svg": () => import("./inbox-linear-3bd9ba80.mjs"), "../../assets/icons/infants.svg": () => import("./infants-d14602cf.mjs"), "../../assets/icons/info-outline.svg": () => import("./info-outline-4c035c44.mjs"), "../../assets/icons/leader.svg": () => import("./leader-c5f7e3e7.mjs"), "../../assets/icons/leaner-lock.svg": () => import("./leaner-lock-fd163004.mjs"), "../../assets/icons/like-shapes.svg": () => import("./like-shapes-8fd21057.mjs"), "../../assets/icons/location.svg": () => import("./location-7e81badb.mjs"), "../../assets/icons/login-circle.svg": () => import("./login-circle-1e88acc3.mjs"), "../../assets/icons/logout-circle.svg": () => import("./logout-circle-9c4bbc83.mjs"), "../../assets/icons/logout.svg": () => import("./logout-7ad1beb4.mjs"), "../../assets/icons/long-arrow-right.svg": () => import("./long-arrow-right-0fcaf3ac.mjs"), "../../assets/icons/luggage.svg": () => import("./luggage-3e381be0.mjs"), "../../assets/icons/magnifier-bold.svg": () => import("./magnifier-bold-cd10911c.mjs"), "../../assets/icons/magnifier-outline.svg": () => import("./magnifier-outline-b098e255.mjs"), "../../assets/icons/mail-inbox.svg": () => import("./mail-inbox-0f63d083.mjs"), "../../assets/icons/man-with-baggage.svg": () => import("./man-with-baggage-3dddcaa2.mjs"), "../../assets/icons/map-point-outline.svg": () => import("./map-point-outline-e59d8de8.mjs"), "../../assets/icons/map.svg": () => import("./map-7b2e898c.mjs"), "../../assets/icons/medal.svg": () => import("./medal-7accb3f2.mjs"), "../../assets/icons/menu.svg": () => import("./menu-54ea8a36.mjs"), "../../assets/icons/message-question.svg": () => import("./message-question-d0713a7f.mjs"), "../../assets/icons/message-time.svg": () => import("./message-time-766bfb30.mjs"), "../../assets/icons/messages-2.svg": () => import("./messages-2-9b32dc53.mjs"), "../../assets/icons/minus-circle.svg": () => import("./minus-circle-87e3c940.mjs"), "../../assets/icons/money-change.svg": () => import("./money-change-3be00846.mjs"), "../../assets/icons/money-forbidden.svg": () => import("./money-forbidden-40802948.mjs"), "../../assets/icons/money-send.svg": () => import("./money-send-7793b614.mjs"), "../../assets/icons/money.svg": () => import("./money-3b33f5cc.mjs"), "../../assets/icons/moneys.svg": () => import("./moneys-1c2fe4b8.mjs"), "../../assets/icons/more.svg": () => import("./more-3dd858a3.mjs"), "../../assets/icons/navigation.svg": () => import("./navigation-f116b7b1.mjs"), "../../assets/icons/notification-status.svg": () => import("./notification-status-1f2cef43.mjs"), "../../assets/icons/oneway-trip.svg": () => import("./oneway-trip-98a7e250.mjs"), "../../assets/icons/payment-protection.svg": () => import("./payment-protection-fc8abfda.mjs"), "../../assets/icons/pen-bold-outlined.svg": () => import("./pen-bold-outlined-7b376707.mjs"), "../../assets/icons/pen-bold.svg": () => import("./pen-bold-caeb5d9f.mjs"), "../../assets/icons/pen-outline.svg": () => import("./pen-outline-ba67ac31.mjs"), "../../assets/icons/person.svg": () => import("./person-e57f9aaa.mjs"), "../../assets/icons/personalcard.svg": () => import("./personalcard-14684ba9.mjs"), "../../assets/icons/pet-outliend.svg": () => import("./pet-outliend-a1d1e48f.mjs"), "../../assets/icons/phone-outline.svg": () => import("./phone-outline-5676e8cc.mjs"), "../../assets/icons/pie-chart-outline.svg": () => import("./pie-chart-outline-436ad69d.mjs"), "../../assets/icons/plane-land-outline.svg": () => import("./plane-land-outline-1a3acff7.mjs"), "../../assets/icons/plane-land.svg": () => import("./plane-land-c158bc35.mjs"), "../../assets/icons/plane-outline.svg": () => import("./plane-outline-181c1dc8.mjs"), "../../assets/icons/plane-take-off-outline.svg": () => import("./plane-take-off-outline-ec985fbe.mjs"), "../../assets/icons/plane-take-off.svg": () => import("./plane-take-off-00e41c10.mjs"), "../../assets/icons/plane.svg": () => import("./plane-346a345e.mjs"), "../../assets/icons/plus-circle.svg": () => import("./plus-circle-b874d693.mjs"), "../../assets/icons/printer.svg": () => import("./printer-3afe9718.mjs"), "../../assets/icons/profile-2user.svg": () => import("./profile-2user-b40e8f3b.mjs"), "../../assets/icons/question-mark-outline.svg": () => import("./question-mark-outline-9733c4d0.mjs"), "../../assets/icons/refresh-circle.svg": () => import("./refresh-circle-edeb42f2.mjs"), "../../assets/icons/refresh.svg": () => import("./refresh-8971f7de.mjs"), "../../assets/icons/refund.svg": () => import("./refund-82274397.mjs"), "../../assets/icons/report.svg": () => import("./report-10023b84.mjs"), "../../assets/icons/resend.svg": () => import("./resend-15a617e6.mjs"), "../../assets/icons/round-trip-rounded.svg": () => import("./round-trip-rounded-db3cc9ae.mjs"), "../../assets/icons/round-trip.svg": () => import("./round-trip-05163ac6.mjs"), "../../assets/icons/sand-clock.svg": () => import("./sand-clock-9c213739.mjs"), "../../assets/icons/search-zoom-in.svg": () => import("./search-zoom-in-4d2b711b.mjs"), "../../assets/icons/security-user.svg": () => import("./security-user-c18d0b90.mjs"), "../../assets/icons/setting-4.svg": () => import("./setting-4-8cc983a9.mjs"), "../../assets/icons/setting-renew-outline.svg": () => import("./setting-renew-outline-6ba356a3.mjs"), "../../assets/icons/setting.svg": () => import("./setting-112337e3.mjs"), "../../assets/icons/settings-outline.svg": () => import("./settings-outline-9299e30a.mjs"), "../../assets/icons/share-bold.svg": () => import("./share-bold-2c3cbb81.mjs"), "../../assets/icons/share-ios.svg": () => import("./share-ios-79903fbf.mjs"), "../../assets/icons/share-outline.svg": () => import("./share-outline-8d5f19da.mjs"), "../../assets/icons/smileys.svg": () => import("./smileys-a3e8f3f9.mjs"), "../../assets/icons/smocking-outlined.svg": () => import("./smocking-outlined-7bbf04b3.mjs"), "../../assets/icons/solid_plus.svg": () => import("./solid_plus-bad958df.mjs"), "../../assets/icons/sort.svg": () => import("./sort-ae31bb5b.mjs"), "../../assets/icons/spinner.svg": () => import("./spinner-5353e9d6.mjs"), "../../assets/icons/star-half.svg": () => import("./star-half-9da2eb06.mjs"), "../../assets/icons/star-outline.svg": () => import("./star-outline-cd5a4fd9.mjs"), "../../assets/icons/star.svg": () => import("./star-f8917de6.mjs"), "../../assets/icons/sterling-outline.svg": () => import("./sterling-outline-4bc9390e.mjs"), "../../assets/icons/suitcase-outlined.svg": () => import("./suitcase-outlined-9053c50d.mjs"), "../../assets/icons/support.svg": () => import("./support-f49a78bb.mjs"), "../../assets/icons/swap.svg": () => import("./swap-4f6f933e.mjs"), "../../assets/icons/tick-circle.svg": () => import("./tick-circle-0ea98171.mjs"), "../../assets/icons/tick-square.svg": () => import("./tick-square-15612e23.mjs"), "../../assets/icons/ticket-2.svg": () => import("./ticket-2-336e1559.mjs"), "../../assets/icons/ticket-star.svg": () => import("./ticket-star-9ded5233.mjs"), "../../assets/icons/timer.svg": () => import("./timer-92adfb32.mjs"), "../../assets/icons/trash-bin.svg": () => import("./trash-bin-1874ba67.mjs"), "../../assets/icons/trash.svg": () => import("./trash-0eba02fb.mjs"), "../../assets/icons/upload-outline.svg": () => import("./upload-outline-08702571.mjs"), "../../assets/icons/user-accept.svg": () => import("./user-accept-a8cd71bf.mjs"), "../../assets/icons/user-add.svg": () => import("./user-add-5c1f78c7.mjs"), "../../assets/icons/user-filled.svg": () => import("./user-filled-495ef2cf.mjs"), "../../assets/icons/user-outline.svg": () => import("./user-outline-e13ecb37.mjs"), "../../assets/icons/user-search.svg": () => import("./user-search-6bc8f5a3.mjs"), "../../assets/icons/user-setting.svg": () => import("./user-setting-72139efa.mjs"), "../../assets/icons/users.svg": () => import("./users-75f392d7.mjs"), "../../assets/icons/wallet-3.svg": () => import("./wallet-3-b9351e56.mjs"), "../../assets/icons/wallet-money.svg": () => import("./wallet-money-6c6cb90f.mjs"), "../../assets/icons/warning-2.svg": () => import("./warning-2-704fc92a.mjs"), "../../assets/icons/warning-triangle-outlined.svg": () => import("./warning-triangle-outlined-c5fbe5e1.mjs"), "../../assets/icons/warning-triangle.svg": () => import("./warning-triangle-5adfe54b.mjs"), "../../assets/icons/wheelie-bag.svg": () => import("./wheelie-bag-7a2ffc61.mjs"), "../../assets/icons/wifi-off.svg": () => import("./wifi-off-b0bceff6.mjs"), "../../assets/icons/workbench.svg": () => import("./workbench-a3bc17f1.mjs"), "../../assets/icons/world.svg": () => import("./world-dbddd0f2.mjs") }), `../../assets/icons/${o}.svg`)
          );
          a.value = rT(l), r[o] = l, n.value = l, s(!1);
        }
      },
      {
        immediate: !0
      }
    ), (o, l) => U(i) ? (R(), K("div", {
      key: 0,
      style: Ir({ width: `${o.size}px`, height: `${o.size}px` })
    }, null, 4)) : (R(), Le(Za(n.value), Mt({ key: 1 }, o.$attrs, {
      width: o.size,
      height: o.size
    }), null, 16, ["width", "height"]));
  }
});
function g5(e, t) {
  const r = Mi();
  if (!r)
    throw new Error(
      `[TripMentor] ${e} ${t || "must be called from inside a setup function"}`
    );
  return r;
}
let fT = 0, ad = /* @__PURE__ */ new WeakMap();
function cu() {
  const e = g5("useUid");
  if (ad.has(e))
    return ad.get(e);
  const t = fT++;
  return ad.set(e, t), t;
}
cu.reset = () => {
  fT = 0, ad = /* @__PURE__ */ new WeakMap();
};
var Ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Rd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bp = { exports: {} };
(function(e, t) {
  (function(r, a) {
    var n = "1.0.37", i = "", s = "?", o = "function", l = "undefined", u = "object", d = "string", f = "major", c = "model", p = "name", v = "type", h = "vendor", g = "version", m = "architecture", b = "console", y = "mobile", _ = "tablet", x = "smarttv", w = "wearable", k = "embedded", S = 500, P = "Amazon", A = "Apple", E = "ASUS", O = "BlackBerry", T = "Browser", D = "Chrome", $ = "Edge", I = "Firefox", F = "Google", j = "Huawei", M = "LG", q = "Microsoft", le = "Motorola", Z = "Opera", G = "Samsung", H = "Sharp", W = "Sony", ie = "Xiaomi", we = "Zebra", Be = "Facebook", Ve = "Chromium OS", et = "Mac OS", nt = function(Je, he) {
      var ye = {};
      for (var Ke in Je)
        he[Ke] && he[Ke].length % 2 === 0 ? ye[Ke] = he[Ke].concat(Je[Ke]) : ye[Ke] = Je[Ke];
      return ye;
    }, xe = function(Je) {
      for (var he = {}, ye = 0; ye < Je.length; ye++)
        he[Je[ye].toUpperCase()] = Je[ye];
      return he;
    }, J = function(Je, he) {
      return typeof Je === d ? se(he).indexOf(se(Je)) !== -1 : !1;
    }, se = function(Je) {
      return Je.toLowerCase();
    }, _e = function(Je) {
      return typeof Je === d ? Je.replace(/[^\d\.]/g, i).split(".")[0] : a;
    }, Se = function(Je, he) {
      if (typeof Je === d)
        return Je = Je.replace(/^\s\s*/, i), typeof he === l ? Je : Je.substring(0, S);
    }, Re = function(Je, he) {
      for (var ye = 0, Ke, Q, L, Te, Oe, Y; ye < he.length && !Oe; ) {
        var de = he[ye], Ne = he[ye + 1];
        for (Ke = Q = 0; Ke < de.length && !Oe && de[Ke]; )
          if (Oe = de[Ke++].exec(Je), Oe)
            for (L = 0; L < Ne.length; L++)
              Y = Oe[++Q], Te = Ne[L], typeof Te === u && Te.length > 0 ? Te.length === 2 ? typeof Te[1] == o ? this[Te[0]] = Te[1].call(this, Y) : this[Te[0]] = Te[1] : Te.length === 3 ? typeof Te[1] === o && !(Te[1].exec && Te[1].test) ? this[Te[0]] = Y ? Te[1].call(this, Y, Te[2]) : a : this[Te[0]] = Y ? Y.replace(Te[1], Te[2]) : a : Te.length === 4 && (this[Te[0]] = Y ? Te[3].call(this, Y.replace(Te[1], Te[2])) : a) : this[Te] = Y || a;
        ye += 2;
      }
    }, rt = function(Je, he) {
      for (var ye in he)
        if (typeof he[ye] === u && he[ye].length > 0) {
          for (var Ke = 0; Ke < he[ye].length; Ke++)
            if (J(he[ye][Ke], Je))
              return ye === s ? a : ye;
        } else if (J(he[ye], Je))
          return ye === s ? a : ye;
      return Je;
    }, Dt = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, It = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, Ye = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [p, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [p, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [p, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [p, Z + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [p, Z]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [g, [p, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [p, g],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [p, "UC" + T]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [p, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [p, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [p, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [p, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [g, [p, "Smart Lenovo " + T]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[p, /(.+)/, "$1 Secure " + T], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [p, I + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [p, Z + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [p, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [p, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [p, Z + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [p, "MIUI " + T]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [g, [p, I]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[p, "360 " + T]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[p, /(.+)/, "$1 " + T], g],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [g, [p, G + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[p, /_/g, " "], g],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [g, [p, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[p, "Sogou Mobile"], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [p, g],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [p],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[p, Be], g],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [p, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [p, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [g, [p, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [p, D + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[p, D + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [p, "Android " + T]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [p, g],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [p, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, p],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [p, [g, rt, Dt]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [p, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[p, "Netscape"], g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [p, I + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [p, g],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [p, [g, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[m, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[m, se]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[m, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[m, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[m, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[m, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[m, /ower/, i, se]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[m, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[m, se]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [c, [h, G], [v, _]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [c, [h, G], [v, y]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [c, [h, A], [v, y]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [c, [h, A], [v, _]],
        [
          /(macintosh);/i
        ],
        [c, [h, A]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [c, [h, H], [v, y]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [c, [h, j], [v, _]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [c, [h, j], [v, y]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[c, /_/g, " "], [h, ie], [v, y]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[c, /_/g, " "], [h, ie], [v, _]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [c, [h, "OPPO"], [v, y]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [c, [h, "Vivo"], [v, y]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [c, [h, "Realme"], [v, y]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [c, [h, le], [v, y]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [c, [h, le], [v, _]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [c, [h, M], [v, _]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [c, [h, M], [v, y]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [c, [h, "Lenovo"], [v, _]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[c, /_/g, " "], [h, "Nokia"], [v, y]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [c, [h, F], [v, _]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [c, [h, F], [v, y]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [c, [h, W], [v, y]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[c, "Xperia Tablet"], [h, W], [v, _]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [c, [h, "OnePlus"], [v, y]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [c, [h, P], [v, _]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[c, /(.+)/g, "Fire Phone $1"], [h, P], [v, y]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [c, h, [v, _]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [c, [h, O], [v, y]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [c, [h, E], [v, _]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [c, [h, E], [v, y]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [c, [h, "HTC"], [v, _]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [h, [c, /_/g, " "], [v, y]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [c, [h, "Acer"], [v, _]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [c, [h, "Meizu"], [v, y]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [c, [h, "Ulefone"], [v, y]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [h, c, [v, y]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [h, c, [v, _]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [c, [h, q], [v, _]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [c, [h, "Fairphone"], [v, y]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [c, [h, "AT&T"], [v, y]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [c, [h, "Siemens"], [v, y]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [c, [h, "RCA"], [v, _]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [c, [h, "Dell"], [v, _]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [c, [h, "Verizon"], [v, _]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [c, [h, "Barnes & Noble"], [v, _]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [c, [h, "NuVision"], [v, _]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [c, [h, "ZTE"], [v, _]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [c, [h, "ZTE"], [v, y]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [c, [h, "Swiss"], [v, y]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [c, [h, "Swiss"], [v, _]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [c, [h, "Zeki"], [v, _]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[h, "Dragon Touch"], c, [v, _]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [c, [h, "Insignia"], [v, _]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [c, [h, "NextBook"], [v, _]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[h, "Voice"], c, [v, y]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[h, "LvTel"], c, [v, y]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [c, [h, "Essential"], [v, y]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [c, [h, "Envizen"], [v, _]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [c, [h, "MachSpeed"], [v, _]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [c, [h, "Rotor"], [v, _]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [c, [h, "Nvidia"], [v, _]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [h, c, [v, y]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[c, /\./g, " "], [h, q], [v, y]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [c, [h, we], [v, _]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [c, [h, we], [v, y]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [h, [v, x]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[c, /^/, "SmartTV"], [h, G], [v, x]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[h, M], [v, x]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [h, [c, A + " TV"], [v, x]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[c, D + "cast"], [h, F], [v, x]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [c, [h, P], [v, x]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [c, [h, H], [v, x]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [c, [h, W], [v, x]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [c, [h, ie], [v, x]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [h, c, [v, x]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[h, Se], [c, Se], [v, x]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[v, x]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [h, c, [v, b]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [c, [h, "Nvidia"], [v, b]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [c, [h, W], [v, b]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [c, [h, q], [v, b]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [h, c, [v, w]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [c, [h, A], [v, w]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [c, [h, F], [v, w]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [c, [h, we], [v, w]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [c, [h, Be], [v, w]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [h, [v, k]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [c, [h, P], [v, k]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [c, [v, y]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [c, [v, _]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[v, _]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[v, y]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [c, [h, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [p, $ + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [p, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [p, g],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, p]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [p, g],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [p, [g, rt, It]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[g, rt, It], [p, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [p, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[p, et], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [g, p],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [p, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [p, O]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [p, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [p, I + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [p, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [g, [p, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [p, D + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[p, Ve], g],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [p, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[p, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [p, g]
      ]
    }, at = function(Je, he) {
      if (typeof Je === u && (he = Je, Je = a), !(this instanceof at))
        return new at(Je, he).getResult();
      var ye = typeof r !== l && r.navigator ? r.navigator : a, Ke = Je || (ye && ye.userAgent ? ye.userAgent : i), Q = ye && ye.userAgentData ? ye.userAgentData : a, L = he ? nt(Ye, he) : Ye, Te = ye && ye.userAgent == Ke;
      return this.getBrowser = function() {
        var Oe = {};
        return Oe[p] = a, Oe[g] = a, Re.call(Oe, Ke, L.browser), Oe[f] = _e(Oe[g]), Te && ye && ye.brave && typeof ye.brave.isBrave == o && (Oe[p] = "Brave"), Oe;
      }, this.getCPU = function() {
        var Oe = {};
        return Oe[m] = a, Re.call(Oe, Ke, L.cpu), Oe;
      }, this.getDevice = function() {
        var Oe = {};
        return Oe[h] = a, Oe[c] = a, Oe[v] = a, Re.call(Oe, Ke, L.device), Te && !Oe[v] && Q && Q.mobile && (Oe[v] = y), Te && Oe[c] == "Macintosh" && ye && typeof ye.standalone !== l && ye.maxTouchPoints && ye.maxTouchPoints > 2 && (Oe[c] = "iPad", Oe[v] = _), Oe;
      }, this.getEngine = function() {
        var Oe = {};
        return Oe[p] = a, Oe[g] = a, Re.call(Oe, Ke, L.engine), Oe;
      }, this.getOS = function() {
        var Oe = {};
        return Oe[p] = a, Oe[g] = a, Re.call(Oe, Ke, L.os), Te && !Oe[p] && Q && Q.platform != "Unknown" && (Oe[p] = Q.platform.replace(/chrome os/i, Ve).replace(/macos/i, et)), Oe;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return Ke;
      }, this.setUA = function(Oe) {
        return Ke = typeof Oe === d && Oe.length > S ? Se(Oe, S) : Oe, this;
      }, this.setUA(Ke), this;
    };
    at.VERSION = n, at.BROWSER = xe([p, g, f]), at.CPU = xe([m]), at.DEVICE = xe([c, h, v, b, y, x, _, w, k]), at.ENGINE = at.OS = xe([p, g]), e.exports && (t = e.exports = at), t.UAParser = at;
    var ut = typeof r !== l && (r.jQuery || r.Zepto);
    if (ut && !ut.ua) {
      var Gt = new at();
      ut.ua = Gt.getResult(), ut.ua.get = function() {
        return Gt.getUA();
      }, ut.ua.set = function(Je) {
        Gt.setUA(Je);
        var he = Gt.getResult();
        for (var ye in he)
          ut.ua[ye] = he[ye];
      };
    }
  })(typeof window == "object" ? window : Ba);
})(bp, bp.exports);
var b5 = bp.exports;
function pT() {
  const e = ne(!1), t = ne(!1), r = () => {
    const { device: a } = b5.UAParser();
    e.value = a.type === "mobile", t.value = a.type === "tablet";
  };
  return r(), ct(() => {
    window.addEventListener("resize", r);
  }), Ai(() => {
    window.removeEventListener("resize", r);
  }), { isMobile: e };
}
function Vn() {
  function e(t) {
    return !!lu()[t];
  }
  return e;
}
/*!
  * shared v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const jn = typeof window < "u";
let Ka, Os;
if (process.env.NODE_ENV !== "production") {
  const e = jn && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Ka = (t) => {
    e.mark(t);
  }, Os = (t, r, a) => {
    e.measure(t, r, a), e.clearMarks(r), e.clearMarks(a);
  });
}
const y5 = /\{([0-9a-zA-Z]+)\}/g;
function j1(e, ...t) {
  return t.length === 1 && Vt(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(y5, (r, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const ci = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), _5 = (e, t, r) => x5({ l: e, k: t, s: r }), x5 = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), na = (e) => typeof e == "number" && isFinite(e), w5 = (e) => mT(e) === "[object Date]", vd = (e) => mT(e) === "[object RegExp]", jd = (e) => Bt(e) && Object.keys(e).length === 0, ga = Object.assign;
let Py;
const F1 = () => Py || (Py = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function My(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const T5 = Object.prototype.hasOwnProperty;
function md(e, t) {
  return T5.call(e, t);
}
const Yr = Array.isArray, kr = (e) => typeof e == "function", st = (e) => typeof e == "string", Pr = (e) => typeof e == "boolean", Vt = (e) => e !== null && typeof e == "object", S5 = (e) => Vt(e) && kr(e.then) && kr(e.catch), vT = Object.prototype.toString, mT = (e) => vT.call(e), Bt = (e) => {
  if (!Vt(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, E5 = (e) => e == null ? "" : Yr(e) || Bt(e) && e.toString === vT ? JSON.stringify(e, null, 2) : String(e);
function O5(e, t = "") {
  return e.reduce((r, a, n) => n === 0 ? r + a : r + t + a, "");
}
const Ay = 2;
function C5(e, t = 0, r = e.length) {
  const a = e.split(/\r?\n/);
  let n = 0;
  const i = [];
  for (let s = 0; s < a.length; s++)
    if (n += a[s].length + 1, n >= t) {
      for (let o = s - Ay; o <= s + Ay || r > n; o++) {
        if (o < 0 || o >= a.length)
          continue;
        const l = o + 1;
        i.push(`${l}${" ".repeat(3 - String(l).length)}|  ${a[o]}`);
        const u = a[o].length;
        if (o === s) {
          const d = t - (n - u) + 1, f = Math.max(1, r > n ? u - d : r - t);
          i.push("   |  " + " ".repeat(d) + "^".repeat(f));
        } else if (o > s) {
          if (r > n) {
            const d = Math.max(Math.min(r - n, u), 1);
            i.push("   |  " + "^".repeat(d));
          }
          n += u + 1;
        }
      }
      break;
    }
  return i.join(`
`);
}
function B1(e) {
  let t = e;
  return () => ++t;
}
function Di(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Dy = {};
function k5(e) {
  Dy[e] || (Dy[e] = !0, Di(e));
}
function hT() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(r, a) {
      const n = e.get(r);
      n && n.push(a) || e.set(r, [a]);
    },
    off(r, a) {
      const n = e.get(r);
      n && n.splice(n.indexOf(a) >>> 0, 1);
    },
    emit(r, a) {
      (e.get(r) || []).slice().map((n) => n(a)), (e.get("*") || []).slice().map((n) => n(r, a));
    }
  };
}
const ju = (e) => !Vt(e) || Yr(e);
function nd(e, t) {
  if (ju(e) || ju(t))
    throw new Error("Invalid value");
  const r = [{ src: e, des: t }];
  for (; r.length; ) {
    const { src: a, des: n } = r.pop();
    Object.keys(a).forEach((i) => {
      ju(a[i]) || ju(n[i]) ? n[i] = a[i] : r.push({ src: a[i], des: n[i] });
    });
  }
}
/*!
  * message-compiler v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function P5(e, t, r) {
  return { line: e, column: t, offset: r };
}
function yp(e, t, r) {
  const a = { start: e, end: t };
  return r != null && (a.source = r), a;
}
const M5 = /\{([0-9a-zA-Z]+)\}/g;
function A5(e, ...t) {
  return t.length === 1 && D5(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(M5, (r, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const gT = Object.assign, Iy = (e) => typeof e == "string", D5 = (e) => e !== null && typeof e == "object";
function bT(e, t = "") {
  return e.reduce((r, a, n) => n === 0 ? r + a : r + t + a, "");
}
const Tt = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, I5 = {
  // tokenizer error messages
  [Tt.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Tt.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Tt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Tt.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Tt.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Tt.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Tt.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Tt.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Tt.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Tt.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Tt.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Tt.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Tt.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Tt.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Tt.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Tt.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Co(e, t, r = {}) {
  const { domain: a, messages: n, args: i } = r, s = A5((n || I5)[e] || "", ...i || []), o = new SyntaxError(String(s));
  return o.code = e, t && (o.location = t), o.domain = a, o;
}
function N5(e) {
  throw e;
}
const $5 = /<\/?[\w\s="/.':;#-\/]+>/, L5 = (e) => $5.test(e), yi = " ", R5 = "\r", ka = `
`, j5 = String.fromCharCode(8232), F5 = String.fromCharCode(8233);
function B5(e) {
  const t = e;
  let r = 0, a = 1, n = 1, i = 0;
  const s = (k) => t[k] === R5 && t[k + 1] === ka, o = (k) => t[k] === ka, l = (k) => t[k] === F5, u = (k) => t[k] === j5, d = (k) => s(k) || o(k) || l(k) || u(k), f = () => r, c = () => a, p = () => n, v = () => i, h = (k) => s(k) || l(k) || u(k) ? ka : t[k], g = () => h(r), m = () => h(r + i);
  function b() {
    return i = 0, d(r) && (a++, n = 0), s(r) && r++, r++, n++, t[r];
  }
  function y() {
    return s(r + i) && i++, i++, t[r + i];
  }
  function _() {
    r = 0, a = 1, n = 1, i = 0;
  }
  function x(k = 0) {
    i = k;
  }
  function w() {
    const k = r + i;
    for (; k !== r; )
      b();
    i = 0;
  }
  return {
    index: f,
    line: c,
    column: p,
    peekOffset: v,
    charAt: h,
    currentChar: g,
    currentPeek: m,
    next: b,
    peek: y,
    reset: _,
    resetPeek: x,
    skipToPeek: w
  };
}
const qi = void 0, q5 = ".", Ny = "'", H5 = "tokenizer";
function V5(e, t = {}) {
  const r = t.location !== !1, a = B5(e), n = () => a.index(), i = () => P5(a.line(), a.column(), a.index()), s = i(), o = n(), l = {
    currentType: 14,
    offset: o,
    startLoc: s,
    endLoc: s,
    lastType: 14,
    lastOffset: o,
    lastStartLoc: s,
    lastEndLoc: s,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => l, { onError: d } = t;
  function f(J, se, _e, ...Se) {
    const Re = u();
    if (se.column += _e, se.offset += _e, d) {
      const rt = r ? yp(Re.startLoc, se) : null, Dt = Co(J, rt, {
        domain: H5,
        args: Se
      });
      d(Dt);
    }
  }
  function c(J, se, _e) {
    J.endLoc = i(), J.currentType = se;
    const Se = { type: se };
    return r && (Se.loc = yp(J.startLoc, J.endLoc)), _e != null && (Se.value = _e), Se;
  }
  const p = (J) => c(
    J,
    14
    /* TokenTypes.EOF */
  );
  function v(J, se) {
    return J.currentChar() === se ? (J.next(), se) : (f(Tt.EXPECTED_TOKEN, i(), 0, se), "");
  }
  function h(J) {
    let se = "";
    for (; J.currentPeek() === yi || J.currentPeek() === ka; )
      se += J.currentPeek(), J.peek();
    return se;
  }
  function g(J) {
    const se = h(J);
    return J.skipToPeek(), se;
  }
  function m(J) {
    if (J === qi)
      return !1;
    const se = J.charCodeAt(0);
    return se >= 97 && se <= 122 || // a-z
    se >= 65 && se <= 90 || // A-Z
    se === 95;
  }
  function b(J) {
    if (J === qi)
      return !1;
    const se = J.charCodeAt(0);
    return se >= 48 && se <= 57;
  }
  function y(J, se) {
    const { currentType: _e } = se;
    if (_e !== 2)
      return !1;
    h(J);
    const Se = m(J.currentPeek());
    return J.resetPeek(), Se;
  }
  function _(J, se) {
    const { currentType: _e } = se;
    if (_e !== 2)
      return !1;
    h(J);
    const Se = J.currentPeek() === "-" ? J.peek() : J.currentPeek(), Re = b(Se);
    return J.resetPeek(), Re;
  }
  function x(J, se) {
    const { currentType: _e } = se;
    if (_e !== 2)
      return !1;
    h(J);
    const Se = J.currentPeek() === Ny;
    return J.resetPeek(), Se;
  }
  function w(J, se) {
    const { currentType: _e } = se;
    if (_e !== 8)
      return !1;
    h(J);
    const Se = J.currentPeek() === ".";
    return J.resetPeek(), Se;
  }
  function k(J, se) {
    const { currentType: _e } = se;
    if (_e !== 9)
      return !1;
    h(J);
    const Se = m(J.currentPeek());
    return J.resetPeek(), Se;
  }
  function S(J, se) {
    const { currentType: _e } = se;
    if (!(_e === 8 || _e === 12))
      return !1;
    h(J);
    const Se = J.currentPeek() === ":";
    return J.resetPeek(), Se;
  }
  function P(J, se) {
    const { currentType: _e } = se;
    if (_e !== 10)
      return !1;
    const Se = () => {
      const rt = J.currentPeek();
      return rt === "{" ? m(J.peek()) : rt === "@" || rt === "%" || rt === "|" || rt === ":" || rt === "." || rt === yi || !rt ? !1 : rt === ka ? (J.peek(), Se()) : m(rt);
    }, Re = Se();
    return J.resetPeek(), Re;
  }
  function A(J) {
    h(J);
    const se = J.currentPeek() === "|";
    return J.resetPeek(), se;
  }
  function E(J) {
    const se = h(J), _e = J.currentPeek() === "%" && J.peek() === "{";
    return J.resetPeek(), {
      isModulo: _e,
      hasSpace: se.length > 0
    };
  }
  function O(J, se = !0) {
    const _e = (Re = !1, rt = "", Dt = !1) => {
      const It = J.currentPeek();
      return It === "{" ? rt === "%" ? !1 : Re : It === "@" || !It ? rt === "%" ? !0 : Re : It === "%" ? (J.peek(), _e(Re, "%", !0)) : It === "|" ? rt === "%" || Dt ? !0 : !(rt === yi || rt === ka) : It === yi ? (J.peek(), _e(!0, yi, Dt)) : It === ka ? (J.peek(), _e(!0, ka, Dt)) : !0;
    }, Se = _e();
    return se && J.resetPeek(), Se;
  }
  function T(J, se) {
    const _e = J.currentChar();
    return _e === qi ? qi : se(_e) ? (J.next(), _e) : null;
  }
  function D(J) {
    return T(J, (_e) => {
      const Se = _e.charCodeAt(0);
      return Se >= 97 && Se <= 122 || // a-z
      Se >= 65 && Se <= 90 || // A-Z
      Se >= 48 && Se <= 57 || // 0-9
      Se === 95 || // _
      Se === 36;
    });
  }
  function $(J) {
    return T(J, (_e) => {
      const Se = _e.charCodeAt(0);
      return Se >= 48 && Se <= 57;
    });
  }
  function I(J) {
    return T(J, (_e) => {
      const Se = _e.charCodeAt(0);
      return Se >= 48 && Se <= 57 || // 0-9
      Se >= 65 && Se <= 70 || // A-F
      Se >= 97 && Se <= 102;
    });
  }
  function F(J) {
    let se = "", _e = "";
    for (; se = $(J); )
      _e += se;
    return _e;
  }
  function j(J) {
    g(J);
    const se = J.currentChar();
    return se !== "%" && f(Tt.EXPECTED_TOKEN, i(), 0, se), J.next(), "%";
  }
  function M(J) {
    let se = "";
    for (; ; ) {
      const _e = J.currentChar();
      if (_e === "{" || _e === "}" || _e === "@" || _e === "|" || !_e)
        break;
      if (_e === "%")
        if (O(J))
          se += _e, J.next();
        else
          break;
      else if (_e === yi || _e === ka)
        if (O(J))
          se += _e, J.next();
        else {
          if (A(J))
            break;
          se += _e, J.next();
        }
      else
        se += _e, J.next();
    }
    return se;
  }
  function q(J) {
    g(J);
    let se = "", _e = "";
    for (; se = D(J); )
      _e += se;
    return J.currentChar() === qi && f(Tt.UNTERMINATED_CLOSING_BRACE, i(), 0), _e;
  }
  function le(J) {
    g(J);
    let se = "";
    return J.currentChar() === "-" ? (J.next(), se += `-${F(J)}`) : se += F(J), J.currentChar() === qi && f(Tt.UNTERMINATED_CLOSING_BRACE, i(), 0), se;
  }
  function Z(J) {
    g(J), v(J, "'");
    let se = "", _e = "";
    const Se = (rt) => rt !== Ny && rt !== ka;
    for (; se = T(J, Se); )
      se === "\\" ? _e += G(J) : _e += se;
    const Re = J.currentChar();
    return Re === ka || Re === qi ? (f(Tt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, i(), 0), Re === ka && (J.next(), v(J, "'")), _e) : (v(J, "'"), _e);
  }
  function G(J) {
    const se = J.currentChar();
    switch (se) {
      case "\\":
      case "'":
        return J.next(), `\\${se}`;
      case "u":
        return H(J, se, 4);
      case "U":
        return H(J, se, 6);
      default:
        return f(Tt.UNKNOWN_ESCAPE_SEQUENCE, i(), 0, se), "";
    }
  }
  function H(J, se, _e) {
    v(J, se);
    let Se = "";
    for (let Re = 0; Re < _e; Re++) {
      const rt = I(J);
      if (!rt) {
        f(Tt.INVALID_UNICODE_ESCAPE_SEQUENCE, i(), 0, `\\${se}${Se}${J.currentChar()}`);
        break;
      }
      Se += rt;
    }
    return `\\${se}${Se}`;
  }
  function W(J) {
    g(J);
    let se = "", _e = "";
    const Se = (Re) => Re !== "{" && Re !== "}" && Re !== yi && Re !== ka;
    for (; se = T(J, Se); )
      _e += se;
    return _e;
  }
  function ie(J) {
    let se = "", _e = "";
    for (; se = D(J); )
      _e += se;
    return _e;
  }
  function we(J) {
    const se = (_e = !1, Se) => {
      const Re = J.currentChar();
      return Re === "{" || Re === "%" || Re === "@" || Re === "|" || Re === "(" || Re === ")" || !Re || Re === yi ? Se : Re === ka || Re === q5 ? (Se += Re, J.next(), se(_e, Se)) : (Se += Re, J.next(), se(!0, Se));
    };
    return se(!1, "");
  }
  function Be(J) {
    g(J);
    const se = v(
      J,
      "|"
      /* TokenChars.Pipe */
    );
    return g(J), se;
  }
  function Ve(J, se) {
    let _e = null;
    switch (J.currentChar()) {
      case "{":
        return se.braceNest >= 1 && f(Tt.NOT_ALLOW_NEST_PLACEHOLDER, i(), 0), J.next(), _e = c(
          se,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), g(J), se.braceNest++, _e;
      case "}":
        return se.braceNest > 0 && se.currentType === 2 && f(Tt.EMPTY_PLACEHOLDER, i(), 0), J.next(), _e = c(
          se,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), se.braceNest--, se.braceNest > 0 && g(J), se.inLinked && se.braceNest === 0 && (se.inLinked = !1), _e;
      case "@":
        return se.braceNest > 0 && f(Tt.UNTERMINATED_CLOSING_BRACE, i(), 0), _e = et(J, se) || p(se), se.braceNest = 0, _e;
      default:
        let Re = !0, rt = !0, Dt = !0;
        if (A(J))
          return se.braceNest > 0 && f(Tt.UNTERMINATED_CLOSING_BRACE, i(), 0), _e = c(se, 1, Be(J)), se.braceNest = 0, se.inLinked = !1, _e;
        if (se.braceNest > 0 && (se.currentType === 5 || se.currentType === 6 || se.currentType === 7))
          return f(Tt.UNTERMINATED_CLOSING_BRACE, i(), 0), se.braceNest = 0, nt(J, se);
        if (Re = y(J, se))
          return _e = c(se, 5, q(J)), g(J), _e;
        if (rt = _(J, se))
          return _e = c(se, 6, le(J)), g(J), _e;
        if (Dt = x(J, se))
          return _e = c(se, 7, Z(J)), g(J), _e;
        if (!Re && !rt && !Dt)
          return _e = c(se, 13, W(J)), f(Tt.INVALID_TOKEN_IN_PLACEHOLDER, i(), 0, _e.value), g(J), _e;
        break;
    }
    return _e;
  }
  function et(J, se) {
    const { currentType: _e } = se;
    let Se = null;
    const Re = J.currentChar();
    switch ((_e === 8 || _e === 9 || _e === 12 || _e === 10) && (Re === ka || Re === yi) && f(Tt.INVALID_LINKED_FORMAT, i(), 0), Re) {
      case "@":
        return J.next(), Se = c(
          se,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), se.inLinked = !0, Se;
      case ".":
        return g(J), J.next(), c(
          se,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return g(J), J.next(), c(
          se,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return A(J) ? (Se = c(se, 1, Be(J)), se.braceNest = 0, se.inLinked = !1, Se) : w(J, se) || S(J, se) ? (g(J), et(J, se)) : k(J, se) ? (g(J), c(se, 12, ie(J))) : P(J, se) ? (g(J), Re === "{" ? Ve(J, se) || Se : c(se, 11, we(J))) : (_e === 8 && f(Tt.INVALID_LINKED_FORMAT, i(), 0), se.braceNest = 0, se.inLinked = !1, nt(J, se));
    }
  }
  function nt(J, se) {
    let _e = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (se.braceNest > 0)
      return Ve(J, se) || p(se);
    if (se.inLinked)
      return et(J, se) || p(se);
    switch (J.currentChar()) {
      case "{":
        return Ve(J, se) || p(se);
      case "}":
        return f(Tt.UNBALANCED_CLOSING_BRACE, i(), 0), J.next(), c(
          se,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return et(J, se) || p(se);
      default:
        if (A(J))
          return _e = c(se, 1, Be(J)), se.braceNest = 0, se.inLinked = !1, _e;
        const { isModulo: Re, hasSpace: rt } = E(J);
        if (Re)
          return rt ? c(se, 0, M(J)) : c(se, 4, j(J));
        if (O(J))
          return c(se, 0, M(J));
        break;
    }
    return _e;
  }
  function xe() {
    const { currentType: J, offset: se, startLoc: _e, endLoc: Se } = l;
    return l.lastType = J, l.lastOffset = se, l.lastStartLoc = _e, l.lastEndLoc = Se, l.offset = n(), l.startLoc = i(), a.currentChar() === qi ? c(
      l,
      14
      /* TokenTypes.EOF */
    ) : nt(a, l);
  }
  return {
    nextToken: xe,
    currentOffset: n,
    currentPosition: i,
    context: u
  };
}
const U5 = "parser", z5 = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Y5(e, t, r) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || r, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function W5(e = {}) {
  const t = e.location !== !1, { onError: r } = e;
  function a(m, b, y, _, ...x) {
    const w = m.currentPosition();
    if (w.offset += _, w.column += _, r) {
      const k = t ? yp(y, w) : null, S = Co(b, k, {
        domain: U5,
        args: x
      });
      r(S);
    }
  }
  function n(m, b, y) {
    const _ = { type: m };
    return t && (_.start = b, _.end = b, _.loc = { start: y, end: y }), _;
  }
  function i(m, b, y, _) {
    _ && (m.type = _), t && (m.end = b, m.loc && (m.loc.end = y));
  }
  function s(m, b) {
    const y = m.context(), _ = n(3, y.offset, y.startLoc);
    return _.value = b, i(_, m.currentOffset(), m.currentPosition()), _;
  }
  function o(m, b) {
    const y = m.context(), { lastOffset: _, lastStartLoc: x } = y, w = n(5, _, x);
    return w.index = parseInt(b, 10), m.nextToken(), i(w, m.currentOffset(), m.currentPosition()), w;
  }
  function l(m, b) {
    const y = m.context(), { lastOffset: _, lastStartLoc: x } = y, w = n(4, _, x);
    return w.key = b, m.nextToken(), i(w, m.currentOffset(), m.currentPosition()), w;
  }
  function u(m, b) {
    const y = m.context(), { lastOffset: _, lastStartLoc: x } = y, w = n(9, _, x);
    return w.value = b.replace(z5, Y5), m.nextToken(), i(w, m.currentOffset(), m.currentPosition()), w;
  }
  function d(m) {
    const b = m.nextToken(), y = m.context(), { lastOffset: _, lastStartLoc: x } = y, w = n(8, _, x);
    return b.type !== 12 ? (a(m, Tt.UNEXPECTED_EMPTY_LINKED_MODIFIER, y.lastStartLoc, 0), w.value = "", i(w, _, x), {
      nextConsumeToken: b,
      node: w
    }) : (b.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, ti(b)), w.value = b.value || "", i(w, m.currentOffset(), m.currentPosition()), {
      node: w
    });
  }
  function f(m, b) {
    const y = m.context(), _ = n(7, y.offset, y.startLoc);
    return _.value = b, i(_, m.currentOffset(), m.currentPosition()), _;
  }
  function c(m) {
    const b = m.context(), y = n(6, b.offset, b.startLoc);
    let _ = m.nextToken();
    if (_.type === 9) {
      const x = d(m);
      y.modifier = x.node, _ = x.nextConsumeToken || m.nextToken();
    }
    switch (_.type !== 10 && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(_)), _ = m.nextToken(), _.type === 2 && (_ = m.nextToken()), _.type) {
      case 11:
        _.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(_)), y.key = f(m, _.value || "");
        break;
      case 5:
        _.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(_)), y.key = l(m, _.value || "");
        break;
      case 6:
        _.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(_)), y.key = o(m, _.value || "");
        break;
      case 7:
        _.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(_)), y.key = u(m, _.value || "");
        break;
      default:
        a(m, Tt.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const x = m.context(), w = n(7, x.offset, x.startLoc);
        return w.value = "", i(w, x.offset, x.startLoc), y.key = w, i(y, x.offset, x.startLoc), {
          nextConsumeToken: _,
          node: y
        };
    }
    return i(y, m.currentOffset(), m.currentPosition()), {
      node: y
    };
  }
  function p(m) {
    const b = m.context(), y = b.currentType === 1 ? m.currentOffset() : b.offset, _ = b.currentType === 1 ? b.endLoc : b.startLoc, x = n(2, y, _);
    x.items = [];
    let w = null;
    do {
      const P = w || m.nextToken();
      switch (w = null, P.type) {
        case 0:
          P.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(P)), x.items.push(s(m, P.value || ""));
          break;
        case 6:
          P.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(P)), x.items.push(o(m, P.value || ""));
          break;
        case 5:
          P.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(P)), x.items.push(l(m, P.value || ""));
          break;
        case 7:
          P.value == null && a(m, Tt.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, ti(P)), x.items.push(u(m, P.value || ""));
          break;
        case 8:
          const A = c(m);
          x.items.push(A.node), w = A.nextConsumeToken || null;
          break;
      }
    } while (b.currentType !== 14 && b.currentType !== 1);
    const k = b.currentType === 1 ? b.lastOffset : m.currentOffset(), S = b.currentType === 1 ? b.lastEndLoc : m.currentPosition();
    return i(x, k, S), x;
  }
  function v(m, b, y, _) {
    const x = m.context();
    let w = _.items.length === 0;
    const k = n(1, b, y);
    k.cases = [], k.cases.push(_);
    do {
      const S = p(m);
      w || (w = S.items.length === 0), k.cases.push(S);
    } while (x.currentType !== 14);
    return w && a(m, Tt.MUST_HAVE_MESSAGES_IN_PLURAL, y, 0), i(k, m.currentOffset(), m.currentPosition()), k;
  }
  function h(m) {
    const b = m.context(), { offset: y, startLoc: _ } = b, x = p(m);
    return b.currentType === 14 ? x : v(m, y, _, x);
  }
  function g(m) {
    const b = V5(m, gT({}, e)), y = b.context(), _ = n(0, y.offset, y.startLoc);
    return t && _.loc && (_.loc.source = m), _.body = h(b), e.onCacheKey && (_.cacheKey = e.onCacheKey(m)), y.currentType !== 14 && a(b, Tt.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, m[y.offset] || ""), i(_, b.currentOffset(), b.currentPosition()), _;
  }
  return { parse: g };
}
function ti(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function G5(e, t = {}) {
  const r = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => r, helper: (i) => (r.helpers.add(i), i) };
}
function $y(e, t) {
  for (let r = 0; r < e.length; r++)
    q1(e[r], t);
}
function q1(e, t) {
  switch (e.type) {
    case 1:
      $y(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      $y(e.items, t);
      break;
    case 6:
      q1(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function X5(e, t = {}) {
  const r = G5(e);
  r.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && q1(e.body, r);
  const a = r.context();
  e.helpers = Array.from(a.helpers);
}
function K5(e) {
  const t = e.body;
  return t.type === 2 ? Ly(t) : t.cases.forEach((r) => Ly(r)), e;
}
function Ly(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let r = 0; r < e.items.length; r++) {
      const a = e.items[r];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = bT(t);
      for (let r = 0; r < e.items.length; r++) {
        const a = e.items[r];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const J5 = "minifier";
function ro(e) {
  switch (e.t = e.type, e.type) {
    case 0:
      const t = e;
      ro(t.body), t.b = t.body, delete t.body;
      break;
    case 1:
      const r = e, a = r.cases;
      for (let d = 0; d < a.length; d++)
        ro(a[d]);
      r.c = a, delete r.cases;
      break;
    case 2:
      const n = e, i = n.items;
      for (let d = 0; d < i.length; d++)
        ro(i[d]);
      n.i = i, delete n.items, n.static && (n.s = n.static, delete n.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const s = e;
      s.value && (s.v = s.value, delete s.value);
      break;
    case 6:
      const o = e;
      ro(o.key), o.k = o.key, delete o.key, o.modifier && (ro(o.modifier), o.m = o.modifier, delete o.modifier);
      break;
    case 5:
      const l = e;
      l.i = l.index, delete l.index;
      break;
    case 4:
      const u = e;
      u.k = u.key, delete u.key;
      break;
    default:
      throw Co(Tt.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: J5,
        args: [e.type]
      });
  }
  delete e.type;
}
const Q5 = "parser";
function Z5(e, t) {
  const { sourceMap: r, filename: a, breakLineCode: n, needIndent: i } = t, s = t.location !== !1, o = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: n,
    needIndent: i,
    indentLevel: 0
  };
  s && e.loc && (o.source = e.loc.source);
  const l = () => o;
  function u(g, m) {
    o.code += g;
  }
  function d(g, m = !0) {
    const b = m ? n : "";
    u(i ? b + "  ".repeat(g) : b);
  }
  function f(g = !0) {
    const m = ++o.indentLevel;
    g && d(m);
  }
  function c(g = !0) {
    const m = --o.indentLevel;
    g && d(m);
  }
  function p() {
    d(o.indentLevel);
  }
  return {
    context: l,
    push: u,
    indent: f,
    deindent: c,
    newline: p,
    helper: (g) => `_${g}`,
    needIndent: () => o.needIndent
  };
}
function ek(e, t) {
  const { helper: r } = e;
  e.push(`${r(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), ho(e, t.key), t.modifier ? (e.push(", "), ho(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function tk(e, t) {
  const { helper: r, needIndent: a } = e;
  e.push(`${r(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const n = t.items.length;
  for (let i = 0; i < n && (ho(e, t.items[i]), i !== n - 1); i++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function rk(e, t) {
  const { helper: r, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${r(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const n = t.cases.length;
    for (let i = 0; i < n && (ho(e, t.cases[i]), i !== n - 1); i++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function ak(e, t) {
  t.body ? ho(e, t.body) : e.push("null");
}
function ho(e, t) {
  const { helper: r } = e;
  switch (t.type) {
    case 0:
      ak(e, t);
      break;
    case 1:
      rk(e, t);
      break;
    case 2:
      tk(e, t);
      break;
    case 6:
      ek(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Co(Tt.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Q5,
        args: [t.type]
      });
  }
}
const nk = (e, t = {}) => {
  const r = Iy(t.mode) ? t.mode : "normal", a = Iy(t.filename) ? t.filename : "message.intl", n = !!t.sourceMap, i = t.breakLineCode != null ? t.breakLineCode : r === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : r !== "arrow", o = e.helpers || [], l = Z5(e, {
    mode: r,
    filename: a,
    sourceMap: n,
    breakLineCode: i,
    needIndent: s
  });
  l.push(r === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(s), o.length > 0 && (l.push(`const { ${bT(o.map((f) => `${f}: _${f}`), ", ")} } = ctx`), l.newline()), l.push("return "), ho(l, e), l.deindent(s), l.push("}"), delete e.helpers;
  const { code: u, map: d } = l.context();
  return {
    ast: e,
    code: u,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function ik(e, t = {}) {
  const r = gT({}, t), a = !!r.jit, n = !!r.minify, i = r.optimize == null ? !0 : r.optimize, o = W5(r).parse(e);
  return a ? (i && K5(o), n && ro(o), { ast: o, code: "" }) : (X5(o, r), nk(o, r));
}
/*!
  * core-base v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function sk() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (F1().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ts = [];
ts[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ts[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ts[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ts[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ts[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ts[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ts[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const ok = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function lk(e) {
  return ok.test(e);
}
function uk(e) {
  const t = e.charCodeAt(0), r = e.charCodeAt(e.length - 1);
  return t === r && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function dk(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function ck(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : lk(t) ? uk(t) : "*" + t;
}
function fk(e) {
  const t = [];
  let r = -1, a = 0, n = 0, i, s, o, l, u, d, f;
  const c = [];
  c[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = o : s += o;
  }, c[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (t.push(s), s = void 0);
  }, c[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    c[
      0
      /* Actions.APPEND */
    ](), n++;
  }, c[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (n > 0)
      n--, a = 4, c[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (n = 0, s === void 0 || (s = ck(s), s === !1))
        return !1;
      c[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function p() {
    const v = e[r + 1];
    if (a === 5 && v === "'" || a === 6 && v === '"')
      return r++, o = "\\" + v, c[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (r++, i = e[r], !(i === "\\" && p())) {
      if (l = dk(i), f = ts[a], u = f[l] || f.l || 8, u === 8 || (a = u[0], u[1] !== void 0 && (d = c[u[1]], d && (o = i, d() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const Ry = /* @__PURE__ */ new Map();
function pk(e, t) {
  return Vt(e) ? e[t] : null;
}
function vk(e, t) {
  if (!Vt(e))
    return null;
  let r = Ry.get(t);
  if (r || (r = fk(t), r && Ry.set(t, r)), !r)
    return null;
  const a = r.length;
  let n = e, i = 0;
  for (; i < a; ) {
    const s = n[r[i]];
    if (s === void 0 || kr(n))
      return null;
    n = s, i++;
  }
  return n;
}
const mk = (e) => e, hk = (e) => "", gk = "text", bk = (e) => e.length === 0 ? "" : O5(e), yk = E5;
function jy(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function _k(e) {
  const t = na(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (na(e.named.count) || na(e.named.n)) ? na(e.named.count) ? e.named.count : na(e.named.n) ? e.named.n : t : t;
}
function xk(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function wk(e = {}) {
  const t = e.locale, r = _k(e), a = Vt(e.pluralRules) && st(t) && kr(e.pluralRules[t]) ? e.pluralRules[t] : jy, n = Vt(e.pluralRules) && st(t) && kr(e.pluralRules[t]) ? jy : void 0, i = (m) => m[a(r, m.length, n)], s = e.list || [], o = (m) => s[m], l = e.named || {};
  na(e.pluralIndex) && xk(r, l);
  const u = (m) => l[m];
  function d(m) {
    const b = kr(e.messages) ? e.messages(m) : Vt(e.messages) ? e.messages[m] : !1;
    return b || (e.parent ? e.parent.message(m) : hk);
  }
  const f = (m) => e.modifiers ? e.modifiers[m] : mk, c = Bt(e.processor) && kr(e.processor.normalize) ? e.processor.normalize : bk, p = Bt(e.processor) && kr(e.processor.interpolate) ? e.processor.interpolate : yk, v = Bt(e.processor) && st(e.processor.type) ? e.processor.type : gk, g = {
    list: o,
    named: u,
    plural: i,
    linked: (m, ...b) => {
      const [y, _] = b;
      let x = "text", w = "";
      b.length === 1 ? Vt(y) ? (w = y.modifier || w, x = y.type || x) : st(y) && (w = y || w) : b.length === 2 && (st(y) && (w = y || w), st(_) && (x = _ || x));
      const k = d(m)(g), S = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        x === "vnode" && Yr(k) && w ? k[0] : k
      );
      return w ? f(w)(S, x) : S;
    },
    message: d,
    type: v,
    interpolate: p,
    normalize: c,
    values: ga({}, s, l)
  };
  return g;
}
let Hl = null;
function Tk(e) {
  Hl = e;
}
function Sk(e, t, r) {
  Hl && Hl.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: r
  });
}
const Ek = /* @__PURE__ */ Ok(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Ok(e) {
  return (t) => Hl && Hl.emit(e, t);
}
const Pa = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, Ck = {
  [Pa.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Pa.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Pa.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Pa.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Pa.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Pa.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Pa.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Cs(e, ...t) {
  return j1(Ck[e], ...t);
}
const yT = Tt.__EXTEND_POINT__, gs = B1(yT), aa = {
  INVALID_ARGUMENT: yT,
  INVALID_DATE_ARGUMENT: gs(),
  INVALID_ISO_DATE_ARGUMENT: gs(),
  NOT_SUPPORT_NON_STRING_MESSAGE: gs(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: gs(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: gs(),
  NOT_SUPPORT_LOCALE_TYPE: gs(),
  __EXTEND_POINT__: gs()
  // 25
};
function ni(e) {
  return Co(e, null, process.env.NODE_ENV !== "production" ? { messages: kk } : void 0);
}
const kk = {
  [aa.INVALID_ARGUMENT]: "Invalid arguments",
  [aa.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [aa.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [aa.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [aa.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [aa.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [aa.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function H1(e, t) {
  return t.locale != null ? Fy(t.locale) : Fy(e.locale);
}
let mf;
function Fy(e) {
  if (st(e))
    return e;
  if (kr(e)) {
    if (e.resolvedOnce && mf != null)
      return mf;
    if (e.constructor.name === "Function") {
      const t = e();
      if (S5(t))
        throw ni(aa.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return mf = t;
    } else
      throw ni(aa.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ni(aa.NOT_SUPPORT_LOCALE_TYPE);
}
function Pk(e, t, r) {
  return [.../* @__PURE__ */ new Set([
    r,
    ...Yr(t) ? t : Vt(t) ? Object.keys(t) : st(t) ? [t] : [r]
  ])];
}
function _T(e, t, r) {
  const a = st(r) ? r : hd, n = e;
  n.__localeChainCache || (n.__localeChainCache = /* @__PURE__ */ new Map());
  let i = n.__localeChainCache.get(a);
  if (!i) {
    i = [];
    let s = [r];
    for (; Yr(s); )
      s = By(i, s, t);
    const o = Yr(t) || !Bt(t) ? t : t.default ? t.default : null;
    s = st(o) ? [o] : o, Yr(s) && By(i, s, !1), n.__localeChainCache.set(a, i);
  }
  return i;
}
function By(e, t, r) {
  let a = !0;
  for (let n = 0; n < t.length && Pr(a); n++) {
    const i = t[n];
    st(i) && (a = Mk(e, t[n], r));
  }
  return a;
}
function Mk(e, t, r) {
  let a;
  const n = t.split("-");
  do {
    const i = n.join("-");
    a = Ak(e, i, r), n.splice(-1, 1);
  } while (n.length && a === !0);
  return a;
}
function Ak(e, t, r) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const n = t.replace(/!/g, "");
    e.push(n), (Yr(r) || Bt(r)) && r[n] && (a = r[n]);
  }
  return a;
}
const Dk = "9.9.1", Fd = -1, hd = "en-US", gd = "", qy = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Ik() {
  return {
    upper: (e, t) => t === "text" && st(e) ? e.toUpperCase() : t === "vnode" && Vt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && st(e) ? e.toLowerCase() : t === "vnode" && Vt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && st(e) ? qy(e) : t === "vnode" && Vt(e) && "__v_isVNode" in e ? qy(e.children) : e
  };
}
let xT;
function Nk(e) {
  xT = e;
}
let wT;
function $k(e) {
  wT = e;
}
let TT;
function Lk(e) {
  TT = e;
}
let ST = null;
const Rk = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ST = e;
}, jk = /* @__NO_SIDE_EFFECTS__ */ () => ST;
let ET = null;
const Hy = (e) => {
  ET = e;
}, Fk = () => ET;
let Vy = 0;
function Bk(e = {}) {
  const t = kr(e.onWarn) ? e.onWarn : Di, r = st(e.version) ? e.version : Dk, a = st(e.locale) || kr(e.locale) ? e.locale : hd, n = kr(a) ? hd : a, i = Yr(e.fallbackLocale) || Bt(e.fallbackLocale) || st(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : n, s = Bt(e.messages) ? e.messages : { [n]: {} }, o = Bt(e.datetimeFormats) ? e.datetimeFormats : { [n]: {} }, l = Bt(e.numberFormats) ? e.numberFormats : { [n]: {} }, u = ga({}, e.modifiers || {}, Ik()), d = e.pluralRules || {}, f = kr(e.missing) ? e.missing : null, c = Pr(e.missingWarn) || vd(e.missingWarn) ? e.missingWarn : !0, p = Pr(e.fallbackWarn) || vd(e.fallbackWarn) ? e.fallbackWarn : !0, v = !!e.fallbackFormat, h = !!e.unresolving, g = kr(e.postTranslation) ? e.postTranslation : null, m = Bt(e.processor) ? e.processor : null, b = Pr(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter, _ = kr(e.messageCompiler) ? e.messageCompiler : xT;
  process.env.NODE_ENV !== "production" && kr(e.messageCompiler) && k5(Cs(Pa.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const x = kr(e.messageResolver) ? e.messageResolver : wT || pk, w = kr(e.localeFallbacker) ? e.localeFallbacker : TT || Pk, k = Vt(e.fallbackContext) ? e.fallbackContext : void 0, S = e, P = Vt(S.__datetimeFormatters) ? S.__datetimeFormatters : /* @__PURE__ */ new Map(), A = Vt(S.__numberFormatters) ? S.__numberFormatters : /* @__PURE__ */ new Map(), E = Vt(S.__meta) ? S.__meta : {};
  Vy++;
  const O = {
    version: r,
    cid: Vy,
    locale: a,
    fallbackLocale: i,
    messages: s,
    modifiers: u,
    pluralRules: d,
    missing: f,
    missingWarn: c,
    fallbackWarn: p,
    fallbackFormat: v,
    unresolving: h,
    postTranslation: g,
    processor: m,
    warnHtmlMessage: b,
    escapeParameter: y,
    messageCompiler: _,
    messageResolver: x,
    localeFallbacker: w,
    fallbackContext: k,
    onWarn: t,
    __meta: E
  };
  return O.datetimeFormats = o, O.numberFormats = l, O.__datetimeFormatters = P, O.__numberFormatters = A, process.env.NODE_ENV !== "production" && (O.__v_emitter = S.__v_emitter != null ? S.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Sk(O, r, E), O;
}
function Bd(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function OT(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function V1(e, t, r, a, n) {
  const { missing: i, onWarn: s } = e;
  if (process.env.NODE_ENV !== "production") {
    const o = e.__v_emitter;
    o && o.emit("missing", {
      locale: r,
      key: t,
      type: n,
      groupId: `${n}:${t}`
    });
  }
  if (i !== null) {
    const o = i(e, r, t, n);
    return st(o) ? o : t;
  } else
    return process.env.NODE_ENV !== "production" && OT(a, t) && s(Cs(Pa.NOT_FOUND_KEY, { key: t, locale: r })), t;
}
function cl(e, t, r) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, r, t);
}
const qk = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Hk(e, t) {
  t && L5(e) && Di(j1(qk, { source: e }));
}
const Vk = (e) => e;
let Uy = /* @__PURE__ */ Object.create(null);
const ks = (e) => Vt(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function Uk(e, t = {}) {
  let r = !1;
  const a = t.onError || N5;
  return t.onError = (n) => {
    r = !0, a(n);
  }, { ...ik(e, t), detectError: r };
}
const zk = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!st(e))
    throw ni(aa.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const r = Pr(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Hk(e, r);
    const n = (t.onCacheKey || Vk)(e), i = Uy[n];
    if (i)
      return i;
    const { code: s, detectError: o } = Uk(e, t), l = new Function(`return ${s}`)();
    return o ? l : Uy[n] = l;
  }
}, zy = () => "", cn = (e) => kr(e);
function Yy(e, ...t) {
  const { fallbackFormat: r, postTranslation: a, unresolving: n, messageCompiler: i, fallbackLocale: s, messages: o } = e, [l, u] = _p(...t), d = Pr(u.missingWarn) ? u.missingWarn : e.missingWarn, f = Pr(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, c = Pr(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, p = !!u.resolvedMessage, v = st(u.default) || Pr(u.default) ? Pr(u.default) ? i ? l : () => l : u.default : r ? i ? l : () => l : "", h = r || v !== "", g = H1(e, u);
  c && Yk(u);
  let [m, b, y] = p ? [
    l,
    g,
    o[g] || {}
  ] : CT(e, l, g, s, f, d), _ = m, x = l;
  if (!p && !(st(_) || ks(_) || cn(_)) && h && (_ = v, x = _), !p && (!(st(_) || ks(_) || cn(_)) || !st(b)))
    return n ? Fd : l;
  if (process.env.NODE_ENV !== "production" && st(_) && e.messageCompiler == null)
    return Di(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let w = !1;
  const k = () => {
    w = !0;
  }, S = cn(_) ? _ : kT(e, l, b, _, x, k);
  if (w)
    return _;
  const P = Kk(e, b, y, u), A = wk(P), E = Wk(e, S, A), O = a ? a(E, l) : E;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const T = {
      timestamp: Date.now(),
      key: st(l) ? l : cn(_) ? _.key : "",
      locale: b || (cn(_) ? _.locale : ""),
      format: st(_) ? _ : cn(_) ? _.source : "",
      message: O
    };
    T.meta = ga({}, e.__meta, /* @__PURE__ */ jk() || {}), Ek(T);
  }
  return O;
}
function Yk(e) {
  Yr(e.list) ? e.list = e.list.map((t) => st(t) ? My(t) : t) : Vt(e.named) && Object.keys(e.named).forEach((t) => {
    st(e.named[t]) && (e.named[t] = My(e.named[t]));
  });
}
function CT(e, t, r, a, n, i) {
  const { messages: s, onWarn: o, messageResolver: l, localeFallbacker: u } = e, d = u(e, a, r);
  let f = {}, c, p = null, v = r, h = null;
  const g = "translate";
  for (let m = 0; m < d.length; m++) {
    if (c = h = d[m], process.env.NODE_ENV !== "production" && r !== c && Bd(n, t) && o(Cs(Pa.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: c
    })), process.env.NODE_ENV !== "production" && r !== c) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: g,
        key: t,
        from: v,
        to: h,
        groupId: `${g}:${t}`
      });
    }
    f = s[c] || {};
    let b = null, y, _;
    if (process.env.NODE_ENV !== "production" && jn && (b = window.performance.now(), y = "intlify-message-resolve-start", _ = "intlify-message-resolve-end", Ka && Ka(y)), (p = l(f, t)) === null && (p = f[t]), process.env.NODE_ENV !== "production" && jn) {
      const w = window.performance.now(), k = e.__v_emitter;
      k && b && p && k.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: p,
        time: w - b,
        groupId: `${g}:${t}`
      }), y && _ && Ka && Os && (Ka(_), Os("intlify message resolve", y, _));
    }
    if (st(p) || ks(p) || cn(p))
      break;
    const x = V1(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      t,
      c,
      i,
      g
    );
    x !== t && (p = x), v = h;
  }
  return [p, c, f];
}
function kT(e, t, r, a, n, i) {
  const { messageCompiler: s, warnHtmlMessage: o } = e;
  if (cn(a)) {
    const c = a;
    return c.locale = c.locale || r, c.key = c.key || t, c;
  }
  if (s == null) {
    const c = () => a;
    return c.locale = r, c.key = t, c;
  }
  let l = null, u, d;
  process.env.NODE_ENV !== "production" && jn && (l = window.performance.now(), u = "intlify-message-compilation-start", d = "intlify-message-compilation-end", Ka && Ka(u));
  const f = s(a, Gk(e, r, n, a, o, i));
  if (process.env.NODE_ENV !== "production" && jn) {
    const c = window.performance.now(), p = e.__v_emitter;
    p && l && p.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: c - l,
      groupId: `translate:${t}`
    }), u && d && Ka && Os && (Ka(d), Os("intlify message compilation", u, d));
  }
  return f.locale = r, f.key = t, f.source = a, f;
}
function Wk(e, t, r) {
  let a = null, n, i;
  process.env.NODE_ENV !== "production" && jn && (a = window.performance.now(), n = "intlify-message-evaluation-start", i = "intlify-message-evaluation-end", Ka && Ka(n));
  const s = t(r);
  if (process.env.NODE_ENV !== "production" && jn) {
    const o = window.performance.now(), l = e.__v_emitter;
    l && a && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: o - a,
      groupId: `translate:${t.key}`
    }), n && i && Ka && Os && (Ka(i), Os("intlify message evaluation", n, i));
  }
  return s;
}
function _p(...e) {
  const [t, r, a] = e, n = {};
  if (!st(t) && !na(t) && !cn(t) && !ks(t))
    throw ni(aa.INVALID_ARGUMENT);
  const i = na(t) ? String(t) : (cn(t), t);
  return na(r) ? n.plural = r : st(r) ? n.default = r : Bt(r) && !jd(r) ? n.named = r : Yr(r) && (n.list = r), na(a) ? n.plural = a : st(a) ? n.default = a : Bt(a) && ga(n, a), [i, n];
}
function Gk(e, t, r, a, n, i) {
  return {
    locale: t,
    key: r,
    warnHtmlMessage: n,
    onError: (s) => {
      if (i && i(s), process.env.NODE_ENV !== "production") {
        const o = Xk(a), l = `Message compilation error: ${s.message}`, u = s.location && o && C5(o, s.location.start.offset, s.location.end.offset), d = e.__v_emitter;
        d && o && d.emit("compile-error", {
          message: o,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${r}`
        }), console.error(u ? `${l}
${u}` : l);
      } else
        throw s;
    },
    onCacheKey: (s) => _5(t, r, s)
  };
}
function Xk(e) {
  if (st(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Kk(e, t, r, a) {
  const { modifiers: n, pluralRules: i, messageResolver: s, fallbackLocale: o, fallbackWarn: l, missingWarn: u, fallbackContext: d } = e, c = {
    locale: t,
    modifiers: n,
    pluralRules: i,
    messages: (p) => {
      let v = s(r, p);
      if (v == null && d) {
        const [, , h] = CT(d, p, t, o, l, u);
        v = s(h, p);
      }
      if (st(v) || ks(v)) {
        let h = !1;
        const m = kT(e, p, t, v, p, () => {
          h = !0;
        });
        return h ? zy : m;
      } else
        return cn(v) ? v : zy;
    }
  };
  return e.processor && (c.processor = e.processor), a.list && (c.list = a.list), a.named && (c.named = a.named), na(a.plural) && (c.pluralIndex = a.plural), c;
}
const Wy = typeof Intl < "u", PT = {
  dateTimeFormat: Wy && typeof Intl.DateTimeFormat < "u",
  numberFormat: Wy && typeof Intl.NumberFormat < "u"
};
function Gy(e, ...t) {
  const { datetimeFormats: r, unresolving: a, fallbackLocale: n, onWarn: i, localeFallbacker: s } = e, { __datetimeFormatters: o } = e;
  if (process.env.NODE_ENV !== "production" && !PT.dateTimeFormat)
    return i(Cs(Pa.CANNOT_FORMAT_DATE)), gd;
  const [l, u, d, f] = xp(...t), c = Pr(d.missingWarn) ? d.missingWarn : e.missingWarn, p = Pr(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, v = !!d.part, h = H1(e, d), g = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    n,
    h
  );
  if (!st(l) || l === "")
    return new Intl.DateTimeFormat(h, f).format(u);
  let m = {}, b, y = null, _ = h, x = null;
  const w = "datetime format";
  for (let P = 0; P < g.length; P++) {
    if (b = x = g[P], process.env.NODE_ENV !== "production" && h !== b && Bd(p, l) && i(Cs(Pa.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && h !== b) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: w,
        key: l,
        from: _,
        to: x,
        groupId: `${w}:${l}`
      });
    }
    if (m = r[b] || {}, y = m[l], Bt(y))
      break;
    V1(e, l, b, c, w), _ = x;
  }
  if (!Bt(y) || !st(b))
    return a ? Fd : l;
  let k = `${b}__${l}`;
  jd(f) || (k = `${k}__${JSON.stringify(f)}`);
  let S = o.get(k);
  return S || (S = new Intl.DateTimeFormat(b, ga({}, y, f)), o.set(k, S)), v ? S.formatToParts(u) : S.format(u);
}
const MT = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function xp(...e) {
  const [t, r, a, n] = e, i = {};
  let s = {}, o;
  if (st(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw ni(aa.INVALID_ISO_DATE_ARGUMENT);
    const u = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    o = new Date(u);
    try {
      o.toISOString();
    } catch {
      throw ni(aa.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (w5(t)) {
    if (isNaN(t.getTime()))
      throw ni(aa.INVALID_DATE_ARGUMENT);
    o = t;
  } else if (na(t))
    o = t;
  else
    throw ni(aa.INVALID_ARGUMENT);
  return st(r) ? i.key = r : Bt(r) && Object.keys(r).forEach((l) => {
    MT.includes(l) ? s[l] = r[l] : i[l] = r[l];
  }), st(a) ? i.locale = a : Bt(a) && (s = a), Bt(n) && (s = n), [i.key || "", o, i, s];
}
function Xy(e, t, r) {
  const a = e;
  for (const n in r) {
    const i = `${t}__${n}`;
    a.__datetimeFormatters.has(i) && a.__datetimeFormatters.delete(i);
  }
}
function Ky(e, ...t) {
  const { numberFormats: r, unresolving: a, fallbackLocale: n, onWarn: i, localeFallbacker: s } = e, { __numberFormatters: o } = e;
  if (process.env.NODE_ENV !== "production" && !PT.numberFormat)
    return i(Cs(Pa.CANNOT_FORMAT_NUMBER)), gd;
  const [l, u, d, f] = wp(...t), c = Pr(d.missingWarn) ? d.missingWarn : e.missingWarn, p = Pr(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, v = !!d.part, h = H1(e, d), g = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    n,
    h
  );
  if (!st(l) || l === "")
    return new Intl.NumberFormat(h, f).format(u);
  let m = {}, b, y = null, _ = h, x = null;
  const w = "number format";
  for (let P = 0; P < g.length; P++) {
    if (b = x = g[P], process.env.NODE_ENV !== "production" && h !== b && Bd(p, l) && i(Cs(Pa.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && h !== b) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: w,
        key: l,
        from: _,
        to: x,
        groupId: `${w}:${l}`
      });
    }
    if (m = r[b] || {}, y = m[l], Bt(y))
      break;
    V1(e, l, b, c, w), _ = x;
  }
  if (!Bt(y) || !st(b))
    return a ? Fd : l;
  let k = `${b}__${l}`;
  jd(f) || (k = `${k}__${JSON.stringify(f)}`);
  let S = o.get(k);
  return S || (S = new Intl.NumberFormat(b, ga({}, y, f)), o.set(k, S)), v ? S.formatToParts(u) : S.format(u);
}
const AT = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function wp(...e) {
  const [t, r, a, n] = e, i = {};
  let s = {};
  if (!na(t))
    throw ni(aa.INVALID_ARGUMENT);
  const o = t;
  return st(r) ? i.key = r : Bt(r) && Object.keys(r).forEach((l) => {
    AT.includes(l) ? s[l] = r[l] : i[l] = r[l];
  }), st(a) ? i.locale = a : Bt(a) && (s = a), Bt(n) && (s = n), [i.key || "", o, i, s];
}
function Jy(e, t, r) {
  const a = e;
  for (const n in r) {
    const i = `${t}__${n}`;
    a.__numberFormatters.has(i) && a.__numberFormatters.delete(i);
  }
}
sk();
function Jk() {
  return DT().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function DT() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Qk = typeof Proxy == "function", Zk = "devtools-plugin:setup", eP = "plugin:settings:set";
let Js, Tp;
function tP() {
  var e;
  return Js !== void 0 || (typeof window < "u" && window.performance ? (Js = !0, Tp = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Js = !0, Tp = globalThis.perf_hooks.performance) : Js = !1), Js;
}
function rP() {
  return tP() ? Tp.now() : Date.now();
}
class aP {
  constructor(t, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = r;
    const a = {};
    if (t.settings)
      for (const s in t.settings) {
        const o = t.settings[s];
        a[s] = o.defaultValue;
      }
    const n = `__vue-devtools-plugin-settings__${t.id}`;
    let i = Object.assign({}, a);
    try {
      const s = localStorage.getItem(n), o = JSON.parse(s);
      Object.assign(i, o);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(s) {
        try {
          localStorage.setItem(n, JSON.stringify(s));
        } catch {
        }
        i = s;
      },
      now() {
        return rP();
      }
    }, r && r.on(eP, (s, o) => {
      s === this.plugin.id && this.fallbacks.setSettings(o);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, o) => this.target ? this.target.on[o] : (...l) => {
        this.onQueue.push({
          method: o,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, o) => this.target ? this.target[o] : o === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(o) ? (...l) => (this.targetQueue.push({
        method: o,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[o](...l)) : (...l) => new Promise((u) => {
        this.targetQueue.push({
          method: o,
          args: l,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function nP(e, t) {
  const r = e, a = DT(), n = Jk(), i = Qk && r.enableEarlyProxy;
  if (n && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !i))
    n.emit(Zk, e, t);
  else {
    const s = i ? new aP(r, n) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: t,
      proxy: s
    }), s && t(s.proxiedTarget);
  }
}
/*!
  * vue-i18n v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const iP = "9.9.1";
function sP() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (F1().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const IT = Pa.__EXTEND_POINT__, Hi = B1(IT), Fa = {
  FALLBACK_TO_ROOT: IT,
  NOT_SUPPORTED_PRESERVE: Hi(),
  NOT_SUPPORTED_FORMATTER: Hi(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Hi(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: Hi(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: Hi(),
  NOT_FOUND_PARENT_SCOPE: Hi(),
  IGNORE_OBJ_FLATTEN: Hi(),
  NOTICE_DROP_ALLOW_COMPOSITION: Hi()
  // 17
}, oP = {
  [Fa.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Fa.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Fa.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Fa.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Fa.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Fa.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Fa.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Fa.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Fa.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function fu(e, ...t) {
  return j1(oP[e], ...t);
}
const NT = aa.__EXTEND_POINT__, ja = B1(NT), cr = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: NT,
  // legacy module errors
  INVALID_ARGUMENT: ja(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: ja(),
  NOT_INSTALLED: ja(),
  NOT_AVAILABLE_IN_LEGACY_MODE: ja(),
  // directive module errors
  REQUIRED_VALUE: ja(),
  INVALID_VALUE: ja(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: ja(),
  NOT_INSTALLED_WITH_PROVIDE: ja(),
  // unexpected error
  UNEXPECTED_ERROR: ja(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: ja(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: ja(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: ja(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: ja(),
  // for enhancement
  __EXTEND_POINT__: ja()
  // 40
};
function En(e, ...t) {
  return Co(e, null, process.env.NODE_ENV !== "production" ? { messages: lP, args: t } : void 0);
}
const lP = {
  [cr.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [cr.INVALID_ARGUMENT]: "Invalid argument",
  [cr.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [cr.NOT_INSTALLED]: "Need to install with `app.use` function",
  [cr.UNEXPECTED_ERROR]: "Unexpected error",
  [cr.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [cr.REQUIRED_VALUE]: "Required in value: {0}",
  [cr.INVALID_VALUE]: "Invalid value",
  [cr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [cr.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [cr.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [cr.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [cr.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [cr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Sp = /* @__PURE__ */ ci("__translateVNode"), Ep = /* @__PURE__ */ ci("__datetimeParts"), Op = /* @__PURE__ */ ci("__numberParts"), Vl = /* @__PURE__ */ ci("__enableEmitter"), Cp = /* @__PURE__ */ ci("__disableEmitter"), uP = ci("__setPluralRules"), dP = /* @__PURE__ */ ci("__injectWithOption"), kp = /* @__PURE__ */ ci("__dispose");
function Ul(e) {
  if (!Vt(e))
    return e;
  for (const t in e)
    if (md(e, t))
      if (!t.includes("."))
        Vt(e[t]) && Ul(e[t]);
      else {
        const r = t.split("."), a = r.length - 1;
        let n = e, i = !1;
        for (let s = 0; s < a; s++) {
          if (r[s] in n || (n[r[s]] = {}), !Vt(n[r[s]])) {
            process.env.NODE_ENV !== "production" && Di(fu(Fa.IGNORE_OBJ_FLATTEN, {
              key: r[s]
            })), i = !0;
            break;
          }
          n = n[r[s]];
        }
        i || (n[r[a]] = e[t], delete e[t]), Vt(n[r[a]]) && Ul(n[r[a]]);
      }
  return e;
}
function $T(e, t) {
  const { messages: r, __i18n: a, messageResolver: n, flatJson: i } = t, s = Bt(r) ? r : Yr(a) ? {} : { [e]: {} };
  if (Yr(a) && a.forEach((o) => {
    if ("locale" in o && "resource" in o) {
      const { locale: l, resource: u } = o;
      l ? (s[l] = s[l] || {}, nd(u, s[l])) : nd(u, s);
    } else
      st(o) && nd(JSON.parse(o), s);
  }), n == null && i)
    for (const o in s)
      md(s, o) && Ul(s[o]);
  return s;
}
function LT(e) {
  return e.type;
}
function cP(e, t, r) {
  let a = Vt(t.messages) ? t.messages : {};
  "__i18nGlobal" in r && (a = $T(e.locale.value, {
    messages: a,
    __i18n: r.__i18nGlobal
  }));
  const n = Object.keys(a);
  n.length && n.forEach((i) => {
    e.mergeLocaleMessage(i, a[i]);
  });
  {
    if (Vt(t.datetimeFormats)) {
      const i = Object.keys(t.datetimeFormats);
      i.length && i.forEach((s) => {
        e.mergeDateTimeFormat(s, t.datetimeFormats[s]);
      });
    }
    if (Vt(t.numberFormats)) {
      const i = Object.keys(t.numberFormats);
      i.length && i.forEach((s) => {
        e.mergeNumberFormat(s, t.numberFormats[s]);
      });
    }
  }
}
function Qy(e) {
  return Fe(L4, null, e, 0);
}
const Zy = "__INTLIFY_META__", e_ = () => [], fP = () => !1;
let t_ = 0;
function r_(e) {
  return (t, r, a, n) => e(r, a, Mi() || void 0, n);
}
const pP = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Mi();
  let t = null;
  return e && (t = LT(e)[Zy]) ? { [Zy]: t } : null;
};
function RT(e = {}, t) {
  const { __root: r, __injectWithOption: a } = e, n = r === void 0, i = e.flatJson, s = jn ? ne : ir;
  let o = Pr(e.inheritLocale) ? e.inheritLocale : !0;
  const l = s(
    // prettier-ignore
    r && o ? r.locale.value : st(e.locale) ? e.locale : hd
  ), u = s(
    // prettier-ignore
    r && o ? r.fallbackLocale.value : st(e.fallbackLocale) || Yr(e.fallbackLocale) || Bt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : l.value
  ), d = s($T(l.value, e)), f = s(Bt(e.datetimeFormats) ? e.datetimeFormats : { [l.value]: {} }), c = s(Bt(e.numberFormats) ? e.numberFormats : { [l.value]: {} });
  let p = r ? r.missingWarn : Pr(e.missingWarn) || vd(e.missingWarn) ? e.missingWarn : !0, v = r ? r.fallbackWarn : Pr(e.fallbackWarn) || vd(e.fallbackWarn) ? e.fallbackWarn : !0, h = r ? r.fallbackRoot : Pr(e.fallbackRoot) ? e.fallbackRoot : !0, g = !!e.fallbackFormat, m = kr(e.missing) ? e.missing : null, b = kr(e.missing) ? r_(e.missing) : null, y = kr(e.postTranslation) ? e.postTranslation : null, _ = r ? r.warnHtmlMessage : Pr(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter;
  const w = r ? r.modifiers : Bt(e.modifiers) ? e.modifiers : {};
  let k = e.pluralRules || r && r.pluralRules, S;
  S = (() => {
    n && Hy(null);
    const he = {
      version: iP,
      locale: l.value,
      fallbackLocale: u.value,
      messages: d.value,
      modifiers: w,
      pluralRules: k,
      missing: b === null ? void 0 : b,
      missingWarn: p,
      fallbackWarn: v,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: y === null ? void 0 : y,
      warnHtmlMessage: _,
      escapeParameter: x,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    he.datetimeFormats = f.value, he.numberFormats = c.value, he.__datetimeFormatters = Bt(S) ? S.__datetimeFormatters : void 0, he.__numberFormatters = Bt(S) ? S.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (he.__v_emitter = Bt(S) ? S.__v_emitter : void 0);
    const ye = Bk(he);
    return n && Hy(ye), ye;
  })(), cl(S, l.value, u.value);
  function A() {
    return [
      l.value,
      u.value,
      d.value,
      f.value,
      c.value
    ];
  }
  const E = N({
    get: () => l.value,
    set: (he) => {
      l.value = he, S.locale = l.value;
    }
  }), O = N({
    get: () => u.value,
    set: (he) => {
      u.value = he, S.fallbackLocale = u.value, cl(S, l.value, he);
    }
  }), T = N(() => d.value), D = /* @__PURE__ */ N(() => f.value), $ = /* @__PURE__ */ N(() => c.value);
  function I() {
    return kr(y) ? y : null;
  }
  function F(he) {
    y = he, S.postTranslation = he;
  }
  function j() {
    return m;
  }
  function M(he) {
    he !== null && (b = r_(he)), m = he, S.missing = b;
  }
  function q(he, ye) {
    return he !== "translate" || !ye.resolvedMessage;
  }
  const le = (he, ye, Ke, Q, L, Te) => {
    A();
    let Oe;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (S.fallbackContext = r ? Fk() : void 0), Oe = he(S);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (S.fallbackContext = void 0);
    }
    if (Ke !== "translate exists" && // for not `te` (e.g `t`)
    na(Oe) && Oe === Fd || Ke === "translate exists" && !Oe) {
      const [Y, de] = ye();
      if (process.env.NODE_ENV !== "production" && r && st(Y) && q(Ke, de) && (h && (Bd(v, Y) || OT(p, Y)) && Di(fu(Fa.FALLBACK_TO_ROOT, {
        key: Y,
        type: Ke
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ne } = S;
        Ne && h && Ne.emit("fallback", {
          type: Ke,
          key: Y,
          to: "global",
          groupId: `${Ke}:${Y}`
        });
      }
      return r && h ? Q(r) : L(Y);
    } else {
      if (Te(Oe))
        return Oe;
      throw En(cr.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Z(...he) {
    return le((ye) => Reflect.apply(Yy, null, [ye, ...he]), () => _p(...he), "translate", (ye) => Reflect.apply(ye.t, ye, [...he]), (ye) => ye, (ye) => st(ye));
  }
  function G(...he) {
    const [ye, Ke, Q] = he;
    if (Q && !Vt(Q))
      throw En(cr.INVALID_ARGUMENT);
    return Z(ye, Ke, ga({ resolvedMessage: !0 }, Q || {}));
  }
  function H(...he) {
    return le((ye) => Reflect.apply(Gy, null, [ye, ...he]), () => xp(...he), "datetime format", (ye) => Reflect.apply(ye.d, ye, [...he]), () => gd, (ye) => st(ye));
  }
  function W(...he) {
    return le((ye) => Reflect.apply(Ky, null, [ye, ...he]), () => wp(...he), "number format", (ye) => Reflect.apply(ye.n, ye, [...he]), () => gd, (ye) => st(ye));
  }
  function ie(he) {
    return he.map((ye) => st(ye) || na(ye) || Pr(ye) ? Qy(String(ye)) : ye);
  }
  const Be = {
    normalize: ie,
    interpolate: (he) => he,
    type: "vnode"
  };
  function Ve(...he) {
    return le(
      (ye) => {
        let Ke;
        const Q = ye;
        try {
          Q.processor = Be, Ke = Reflect.apply(Yy, null, [Q, ...he]);
        } finally {
          Q.processor = null;
        }
        return Ke;
      },
      () => _p(...he),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ye) => ye[Sp](...he),
      (ye) => [Qy(ye)],
      (ye) => Yr(ye)
    );
  }
  function et(...he) {
    return le(
      (ye) => Reflect.apply(Ky, null, [ye, ...he]),
      () => wp(...he),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ye) => ye[Op](...he),
      e_,
      (ye) => st(ye) || Yr(ye)
    );
  }
  function nt(...he) {
    return le(
      (ye) => Reflect.apply(Gy, null, [ye, ...he]),
      () => xp(...he),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ye) => ye[Ep](...he),
      e_,
      (ye) => st(ye) || Yr(ye)
    );
  }
  function xe(he) {
    k = he, S.pluralRules = k;
  }
  function J(he, ye) {
    return le(() => {
      if (!he)
        return !1;
      const Ke = st(ye) ? ye : l.value, Q = Se(Ke), L = S.messageResolver(Q, he);
      return ks(L) || cn(L) || st(L);
    }, () => [he], "translate exists", (Ke) => Reflect.apply(Ke.te, Ke, [he, ye]), fP, (Ke) => Pr(Ke));
  }
  function se(he) {
    let ye = null;
    const Ke = _T(S, u.value, l.value);
    for (let Q = 0; Q < Ke.length; Q++) {
      const L = d.value[Ke[Q]] || {}, Te = S.messageResolver(L, he);
      if (Te != null) {
        ye = Te;
        break;
      }
    }
    return ye;
  }
  function _e(he) {
    const ye = se(he);
    return ye ?? (r ? r.tm(he) || {} : {});
  }
  function Se(he) {
    return d.value[he] || {};
  }
  function Re(he, ye) {
    if (i) {
      const Ke = { [he]: ye };
      for (const Q in Ke)
        md(Ke, Q) && Ul(Ke[Q]);
      ye = Ke[he];
    }
    d.value[he] = ye, S.messages = d.value;
  }
  function rt(he, ye) {
    d.value[he] = d.value[he] || {};
    const Ke = { [he]: ye };
    if (i)
      for (const Q in Ke)
        md(Ke, Q) && Ul(Ke[Q]);
    ye = Ke[he], nd(ye, d.value[he]), S.messages = d.value;
  }
  function Dt(he) {
    return f.value[he] || {};
  }
  function It(he, ye) {
    f.value[he] = ye, S.datetimeFormats = f.value, Xy(S, he, ye);
  }
  function Ye(he, ye) {
    f.value[he] = ga(f.value[he] || {}, ye), S.datetimeFormats = f.value, Xy(S, he, ye);
  }
  function at(he) {
    return c.value[he] || {};
  }
  function ut(he, ye) {
    c.value[he] = ye, S.numberFormats = c.value, Jy(S, he, ye);
  }
  function Gt(he, ye) {
    c.value[he] = ga(c.value[he] || {}, ye), S.numberFormats = c.value, Jy(S, he, ye);
  }
  t_++, r && jn && (He(r.locale, (he) => {
    o && (l.value = he, S.locale = he, cl(S, l.value, u.value));
  }), He(r.fallbackLocale, (he) => {
    o && (u.value = he, S.fallbackLocale = he, cl(S, l.value, u.value));
  }));
  const Je = {
    id: t_,
    locale: E,
    fallbackLocale: O,
    get inheritLocale() {
      return o;
    },
    set inheritLocale(he) {
      o = he, he && r && (l.value = r.locale.value, u.value = r.fallbackLocale.value, cl(S, l.value, u.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: T,
    get modifiers() {
      return w;
    },
    get pluralRules() {
      return k || {};
    },
    get isGlobal() {
      return n;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(he) {
      p = he, S.missingWarn = p;
    },
    get fallbackWarn() {
      return v;
    },
    set fallbackWarn(he) {
      v = he, S.fallbackWarn = v;
    },
    get fallbackRoot() {
      return h;
    },
    set fallbackRoot(he) {
      h = he;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(he) {
      g = he, S.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return _;
    },
    set warnHtmlMessage(he) {
      _ = he, S.warnHtmlMessage = he;
    },
    get escapeParameter() {
      return x;
    },
    set escapeParameter(he) {
      x = he, S.escapeParameter = he;
    },
    t: Z,
    getLocaleMessage: Se,
    setLocaleMessage: Re,
    mergeLocaleMessage: rt,
    getPostTranslationHandler: I,
    setPostTranslationHandler: F,
    getMissingHandler: j,
    setMissingHandler: M,
    [uP]: xe
  };
  return Je.datetimeFormats = D, Je.numberFormats = $, Je.rt = G, Je.te = J, Je.tm = _e, Je.d = H, Je.n = W, Je.getDateTimeFormat = Dt, Je.setDateTimeFormat = It, Je.mergeDateTimeFormat = Ye, Je.getNumberFormat = at, Je.setNumberFormat = ut, Je.mergeNumberFormat = Gt, Je[dP] = a, Je[Sp] = Ve, Je[Ep] = nt, Je[Op] = et, process.env.NODE_ENV !== "production" && (Je[Vl] = (he) => {
    S.__v_emitter = he;
  }, Je[Cp] = () => {
    S.__v_emitter = void 0;
  }), Je;
}
const U1 = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function vP({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, n) => [
    ...a,
    // prettier-ignore
    ...n.type === Qe ? n.children : [n]
  ], []) : t.reduce((r, a) => {
    const n = e[a];
    return n && (r[a] = n()), r;
  }, {});
}
function jT(e) {
  return Qe;
}
const mP = /* @__PURE__ */ Ae({
  /* eslint-disable */
  name: "i18n-t",
  props: ga({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => na(e) || !isNaN(e)
    }
  }, U1),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: r, attrs: a } = t, n = e.i18n || Y1({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const i = Object.keys(r).filter((f) => f !== "_"), s = {};
      e.locale && (s.locale = e.locale), e.plural !== void 0 && (s.plural = st(e.plural) ? +e.plural : e.plural);
      const o = vP(t, i), l = n[Sp](e.keypath, o, s), u = ga({}, a), d = st(e.tag) || Vt(e.tag) ? e.tag : jT();
      return Ht(d, u, l);
    };
  }
}), hf = mP;
function hP(e) {
  return Yr(e) && !st(e[0]);
}
function FT(e, t, r, a) {
  const { slots: n, attrs: i } = t;
  return () => {
    const s = { part: !0 };
    let o = {};
    e.locale && (s.locale = e.locale), st(e.format) ? s.key = e.format : Vt(e.format) && (st(e.format.key) && (s.key = e.format.key), o = Object.keys(e.format).reduce((c, p) => r.includes(p) ? ga({}, c, { [p]: e.format[p] }) : c, {}));
    const l = a(e.value, s, o);
    let u = [s.key];
    Yr(l) ? u = l.map((c, p) => {
      const v = n[c.type], h = v ? v({ [c.type]: c.value, index: p, parts: l }) : [c.value];
      return hP(h) && (h[0].key = `${c.type}-${p}`), h;
    }) : st(l) && (u = [l]);
    const d = ga({}, i), f = st(e.tag) || Vt(e.tag) ? e.tag : jT();
    return Ht(f, d, u);
  };
}
const gP = /* @__PURE__ */ Ae({
  /* eslint-disable */
  name: "i18n-n",
  props: ga({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, U1),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const r = e.i18n || Y1({
      useScope: "parent",
      __useComponent: !0
    });
    return FT(e, t, AT, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[Op](...a)
    ));
  }
}), a_ = gP, bP = /* @__PURE__ */ Ae({
  /* eslint-disable */
  name: "i18n-d",
  props: ga({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, U1),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const r = e.i18n || Y1({
      useScope: "parent",
      __useComponent: !0
    });
    return FT(e, t, MT, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[Ep](...a)
    ));
  }
}), n_ = bP;
function yP(e, t) {
  const r = e;
  if (e.mode === "composition")
    return r.__getInstance(t) || e.global;
  {
    const a = r.__getInstance(t);
    return a != null ? a.__composer : e.global.__composer;
  }
}
function _P(e) {
  const t = (s) => {
    const { instance: o, modifiers: l, value: u } = s;
    if (!o || !o.$)
      throw En(cr.UNEXPECTED_ERROR);
    const d = yP(e, o.$);
    process.env.NODE_ENV !== "production" && l.preserve && Di(fu(Fa.NOT_SUPPORTED_PRESERVE));
    const f = i_(u);
    return [
      Reflect.apply(d.t, d, [...s_(f)]),
      d
    ];
  };
  return {
    created: (s, o) => {
      const [l, u] = t(o);
      jn && e.global === u && (s.__i18nWatcher = He(u.locale, () => {
        o.instance && o.instance.$forceUpdate();
      })), s.__composer = u, s.textContent = l;
    },
    unmounted: (s) => {
      jn && s.__i18nWatcher && (s.__i18nWatcher(), s.__i18nWatcher = void 0, delete s.__i18nWatcher), s.__composer && (s.__composer = void 0, delete s.__composer);
    },
    beforeUpdate: (s, { value: o }) => {
      if (s.__composer) {
        const l = s.__composer, u = i_(o);
        s.textContent = Reflect.apply(l.t, l, [
          ...s_(u)
        ]);
      }
    },
    getSSRProps: (s) => {
      const [o] = t(s);
      return { textContent: o };
    }
  };
}
function i_(e) {
  if (st(e))
    return { path: e };
  if (Bt(e)) {
    if (!("path" in e))
      throw En(cr.REQUIRED_VALUE, "path");
    return e;
  } else
    throw En(cr.INVALID_VALUE);
}
function s_(e) {
  const { path: t, locale: r, args: a, choice: n, plural: i } = e, s = {}, o = a || {};
  return st(r) && (s.locale = r), na(n) && (s.plural = n), na(i) && (s.plural = i), [t, o, s];
}
function xP(e, t, ...r) {
  const a = Bt(r[0]) ? r[0] : {}, n = !!a.useI18nComponentName, i = Pr(a.globalInstall) ? a.globalInstall : !0;
  process.env.NODE_ENV !== "production" && i && n && Di(fu(Fa.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: hf.name
  })), i && ([n ? "i18n" : hf.name, "I18nT"].forEach((s) => e.component(s, hf)), [a_.name, "I18nN"].forEach((s) => e.component(s, a_)), [n_.name, "I18nD"].forEach((s) => e.component(s, n_))), e.directive("t", _P(t));
}
const gf = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, wP = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, TP = {
  "vue-i18n-timeline": 16764185
}, BT = "vue-i18n: composer properties";
let Pp;
async function SP(e, t) {
  return new Promise((r, a) => {
    try {
      nP({
        id: "vue-devtools-plugin-vue-i18n",
        label: gf[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [BT],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (n) => {
        Pp = n, n.on.visitComponentTree(({ componentInstance: s, treeNode: o }) => {
          EP(s, o, t);
        }), n.on.inspectComponent(({ componentInstance: s, instanceData: o }) => {
          s.vnode.el && s.vnode.el.__VUE_I18N__ && o && (t.mode === "legacy" ? s.vnode.el.__VUE_I18N__ !== t.global.__composer && o_(o, s.vnode.el.__VUE_I18N__) : o_(o, s.vnode.el.__VUE_I18N__));
        }), n.addInspector({
          id: "vue-i18n-resource-inspector",
          label: gf[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: wP[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), n.on.getInspectorTree((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && MP(s, t);
        });
        const i = /* @__PURE__ */ new Map();
        n.on.getInspectorState(async (s) => {
          if (s.app === e && s.inspectorId === "vue-i18n-resource-inspector")
            if (n.unhighlightElement(), DP(s, t), s.nodeId === "global") {
              if (!i.has(s.app)) {
                const [o] = await n.getComponentInstances(s.app);
                i.set(s.app, o);
              }
              n.highlightElement(i.get(s.app));
            } else {
              const o = AP(s.nodeId, t);
              o && n.highlightElement(o);
            }
        }), n.on.editInspectorState((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && NP(s, t);
        }), n.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: gf[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: TP[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), r(!0);
      });
    } catch (n) {
      console.error(n), a(!1);
    }
  });
}
function qT(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function EP(e, t, r) {
  const a = r.mode === "composition" ? r.global : r.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== a) {
    const n = {
      label: `i18n (${qT(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(n);
  }
}
function o_(e, t) {
  const r = BT;
  e.state.push({
    type: r,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: r,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: r,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: r,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: r,
    key: "messages",
    editable: !1,
    value: z1(t.messages.value)
  }), e.state.push({
    type: r,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: r,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function z1(e) {
  const t = {};
  return Object.keys(e).forEach((r) => {
    const a = e[r];
    kr(a) && "source" in a ? t[r] = PP(a) : ks(a) && a.loc && a.loc.source ? t[r] = a.loc.source : Vt(a) ? t[r] = z1(a) : t[r] = a;
  }), t;
}
const OP = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function CP(e) {
  return e.replace(/[<>"&]/g, kP);
}
function kP(e) {
  return OP[e] || e;
}
function PP(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${CP(e.source)}")` : "(?)"}`
    }
  };
}
function MP(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const r = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [a, n] of t.__instances) {
    const i = t.mode === "composition" ? n : n.__composer;
    r !== i && e.rootNodes.push({
      id: i.id.toString(),
      label: `${qT(a)} Scope`
    });
  }
}
function AP(e, t) {
  let r = null;
  if (e !== "global") {
    for (const [a, n] of t.__instances.entries())
      if (n.id.toString() === e) {
        r = a;
        break;
      }
  }
  return r;
}
function HT(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const r = Array.from(t.__instances.values()).find((a) => a.id.toString() === e);
    return r ? t.mode === "composition" ? r : r.__composer : null;
  }
}
function DP(e, t) {
  const r = HT(e.nodeId, t);
  return r && (e.state = IP(r)), null;
}
function IP(e) {
  const t = {}, r = "Locale related info", a = [
    {
      type: r,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: r,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: r,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: r,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[r] = a;
  const n = "Locale messages info", i = [
    {
      type: n,
      key: "messages",
      editable: !1,
      value: z1(e.messages.value)
    }
  ];
  t[n] = i;
  {
    const s = "Datetime formats info", o = [
      {
        type: s,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[s] = o;
    const l = "Datetime formats info", u = [
      {
        type: l,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[l] = u;
  }
  return t;
}
function Mp(e, t) {
  if (Pp) {
    let r;
    t && "groupId" in t && (r = t.groupId, delete t.groupId), Pp.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: r,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function NP(e, t) {
  const r = HT(e.nodeId, t);
  if (r) {
    const [a] = e.path;
    a === "locale" && st(e.state.value) ? r.locale.value = e.state.value : a === "fallbackLocale" && (st(e.state.value) || Yr(e.state.value) || Vt(e.state.value)) ? r.fallbackLocale.value = e.state.value : a === "inheritLocale" && Pr(e.state.value) && (r.inheritLocale = e.state.value);
  }
}
const $P = /* @__PURE__ */ ci("global-vue-i18n");
function LP(e = {}, t) {
  const r = Pr(e.globalInjection) ? e.globalInjection : !0, a = !0, n = /* @__PURE__ */ new Map(), [i, s] = RP(e), o = /* @__PURE__ */ ci(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV;
  function l(f) {
    return n.get(f) || null;
  }
  function u(f, c) {
    n.set(f, c);
  }
  function d(f) {
    n.delete(f);
  }
  {
    const f = {
      // mode
      get mode() {
        return "composition";
      },
      // allowComposition
      get allowComposition() {
        return a;
      },
      // install plugin
      async install(c, ...p) {
        if (process.env.NODE_ENV !== "production" && (c.__VUE_I18N__ = f), c.__VUE_I18N_SYMBOL__ = o, c.provide(c.__VUE_I18N_SYMBOL__, f), Bt(p[0])) {
          const g = p[0];
          f.__composerExtend = g.__composerExtend, f.__vueI18nExtend = g.__vueI18nExtend;
        }
        let v = null;
        r && (v = zP(c, f.global)), xP(c, f, ...p);
        const h = c.unmount;
        if (c.unmount = () => {
          v && v(), f.dispose(), h();
        }, process.env.NODE_ENV !== "production") {
          if (!await SP(c, f))
            throw En(cr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const m = hT();
          {
            const b = s;
            b[Vl] && b[Vl](m);
          }
          m.on("*", Mp);
        }
      },
      // global accessor
      get global() {
        return s;
      },
      dispose() {
        i.stop();
      },
      // @internal
      __instances: n,
      // @internal
      __getInstance: l,
      // @internal
      __setInstance: u,
      // @internal
      __deleteInstance: d
    };
    return f;
  }
}
function Y1(e = {}) {
  const t = Mi();
  if (t == null)
    throw En(cr.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw En(cr.NOT_INSTALLED);
  const r = jP(t), a = BP(r), n = LT(t), i = FP(e, n);
  if (i === "global")
    return cP(a, e, n), a;
  if (i === "parent") {
    let l = qP(r, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Di(fu(Fa.NOT_FOUND_PARENT_SCOPE)), l = a), l;
  }
  const s = r;
  let o = s.__getInstance(t);
  if (o == null) {
    const l = ga({}, e);
    "__i18n" in n && (l.__i18n = n.__i18n), a && (l.__root = a), o = RT(l), s.__composerExtend && (o[kp] = s.__composerExtend(o)), VP(s, t, o), s.__setInstance(t, o);
  }
  return o;
}
function RP(e, t, r) {
  const a = $4();
  {
    const n = a.run(() => RT(e));
    if (n == null)
      throw En(cr.UNEXPECTED_ERROR);
    return [a, n];
  }
}
function jP(e) {
  {
    const t = sr(e.isCE ? $P : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw En(e.isCE ? cr.NOT_INSTALLED_WITH_PROVIDE : cr.UNEXPECTED_ERROR);
    return t;
  }
}
function FP(e, t) {
  return jd(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function BP(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function qP(e, t, r = !1) {
  let a = null;
  const n = t.root;
  let i = HP(t, r);
  for (; i != null; ) {
    const s = e;
    if (e.mode === "composition" && (a = s.__getInstance(i)), a != null || n === i)
      break;
    i = i.parent;
  }
  return a;
}
function HP(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function VP(e, t, r) {
  let a = null;
  ct(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = r, a = hT();
      const n = r;
      n[Vl] && n[Vl](a), a.on("*", Mp);
    }
  }, t), Tr(() => {
    const n = r;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", Mp), n[Cp] && n[Cp](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const i = n[kp];
    i && (i(), delete n[kp]);
  }, t);
}
const UP = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], l_ = ["t", "rt", "d", "n", "tm", "te"];
function zP(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  return UP.forEach((n) => {
    const i = Object.getOwnPropertyDescriptor(t, n);
    if (!i)
      throw En(cr.UNEXPECTED_ERROR);
    const s = _a(i.value) ? {
      get() {
        return i.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(o) {
        i.value.value = o;
      }
    } : {
      get() {
        return i.get && i.get();
      }
    };
    Object.defineProperty(r, n, s);
  }), e.config.globalProperties.$i18n = r, l_.forEach((n) => {
    const i = Object.getOwnPropertyDescriptor(t, n);
    if (!i || !i.value)
      throw En(cr.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${n}`, i);
  }), () => {
    delete e.config.globalProperties.$i18n, l_.forEach((n) => {
      delete e.config.globalProperties[`$${n}`];
    });
  };
}
sP();
Nk(zk);
$k(vk);
Lk(_T);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = F1();
  e.__INTLIFY__ = !0, Tk(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const YP = "Nothing Found.", WP = "Loading...", GP = {
  notFound: YP,
  loading: WP
}, XP = "لم يتم العثور على شيء.", KP = "جاري التحميل...", JP = {
  notFound: XP,
  loading: KP
}, QP = "Nichts gefunden.", ZP = "Wird geladen...", eM = {
  notFound: QP,
  loading: ZP
}, tM = "No se encontró nada.", rM = "Cargando...", aM = {
  notFound: tM,
  loading: rM
}, nM = "Rien n'a été trouvé.", iM = "Chargement en cours...", sM = {
  notFound: nM,
  loading: iM
}, oM = "Nessun risultato trovato.", lM = "Caricamento in corso...", uM = {
  notFound: oM,
  loading: lM
}, dM = "Nada Encontrado.", cM = "Carregando...", fM = {
  notFound: dM,
  loading: cM
}, pM = "Ništa nije pronađeno.", vM = "Učitavanje...", mM = {
  notFound: pM,
  loading: vM
}, VT = [
  {
    code: "en",
    title: "English",
    flag: "england",
    rtl: !1
  },
  {
    code: "ar",
    title: "Arabic",
    flag: "arabia",
    rtl: !0
  },
  {
    code: "es",
    title: "Spanish",
    flag: "spain",
    rtl: !1
  },
  {
    code: "de",
    title: "German",
    flag: "germany",
    rtl: !1
  },
  {
    code: "it",
    title: "Italian",
    flag: "italy",
    rtl: !1
  },
  {
    code: "fr",
    title: "French",
    flag: "france",
    rtl: !1
  },
  {
    code: "pt",
    title: "Portuguese",
    flag: "portugal",
    rtl: !1
  },
  {
    code: "sr",
    title: "Serbian",
    flag: "serbia",
    rtl: !1
  }
], Ap = VT[0], hM = {
  en: {
    currencyFormat: {
      style: "currency",
      currency: "USD"
    }
  },
  ar: {
    currencyFormat: {
      style: "currency",
      currency: "RUB"
    }
  }
}, gM = {
  en: {
    shortFormath: {
      dateStyle: "short"
    },
    longFormat: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  },
  ar: {
    shortFormat: {
      dateStyle: "short"
    },
    longFormat: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  }
};
function bM(e, t) {
  if (e === 0)
    return 0;
  const r = e > 10 && e < 20, a = e % 10 === 1;
  return !r && a ? 1 : !r && e % 10 >= 2 && e % 10 <= 4 || t < 4 ? 2 : 3;
}
const yM = {
  ar: bM
}, bf = LP({
  legacy: !1,
  locale: Ap.code,
  globalInjection: !0,
  messages: {
    en: GP,
    ar: JP,
    es: eM,
    de: aM,
    fr: sM,
    it: uM,
    pt: fM,
    sr: mM
  },
  pluralRules: yM,
  numberFormats: hM,
  datetimeFormats: gM,
  fallbackLocale: Ap.code
});
function Ii() {
  const e = ne(bf.global.locale), t = N(
    () => o(e.value) || Ap
  );
  function r(l) {
    var u, d;
    l ? (u = document.querySelector("html")) == null || u.setAttribute("dir", "rtl") : (d = document.querySelector("html")) == null || d.setAttribute("dir", "ltr");
  }
  function a(l) {
    var u;
    (u = document.querySelector("html")) == null || u.setAttribute("lang", l);
  }
  async function n(l) {
    if (!bf.global.availableLocales.includes(l)) {
      const u = await R1(/* @__PURE__ */ Object.assign({}), `../modules/Core/localization/${l}/${l}.json`);
      bf.global.setLocaleMessage(l, u.default);
    }
    return Pt();
  }
  async function i(l) {
    await n(l.code), e.value = l.code, a(l.code), r(l.rtl), localStorage.setItem("user-locale", l.code);
  }
  const s = async () => {
    const l = window.localStorage.getItem("user-locale");
    l && (e.value = l), await i(t.value);
  };
  function o(l) {
    return VT.find((u) => u.code === l);
  }
  return ct(s), {
    currentLocale: e,
    switchLanguage: i,
    currentLocaleItem: t
  };
}
function Gr() {
  const e = $d();
  return (r, a = !1) => a ? r in e ? typeof e[r] === "boolean" ? !!e[r] : e[r] !== "false" : !1 : r in e;
}
function W1(e, t, r) {
  const { top: a, bottom: n, left: i, width: s, height: o } = Cy(e, {
    updateTiming: "next-frame"
  }), { height: l } = Cy(t), { height: u } = cT(), d = N(() => {
    if (!r)
      return `${o.value}px`;
    const p = window.scrollY;
    return l.value ? n.value + l.value >= u.value ? `${a.value - 4 + p}px` : `${a.value + o.value + p}px` : `${a.value + o.value + 200}px`;
  });
  function f(p, v, h, g) {
    return `translate(0%, ${p + v >= h ? g ? -100 : -125 : 0}%)`;
  }
  const c = N(() => f(
    n.value,
    l.value,
    u.value,
    r
  ));
  return {
    comboOptionsTop: d,
    comboOptionsTransform: c,
    elementBounding: { top: a, bottom: n, left: i, width: s, height: o }
  };
}
let Fu;
function _M() {
  var n;
  if (typeof window > "u")
    return 0;
  if (Fu !== void 0)
    return Fu;
  const e = document.createElement("div");
  e.style.visibility = "hidden", e.style.width = "100px", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e);
  const t = e.offsetWidth;
  e.style.overflow = "scroll";
  const r = document.createElement("div");
  r.style.width = "100%", e.appendChild(r);
  const a = r.offsetWidth;
  return (n = e == null ? void 0 : e.parentNode) == null || n.removeChild(e), Fu = t - a, Fu;
}
function u_(e) {
  try {
    const t = document == null ? void 0 : document.documentElement, r = t.clientHeight < (document == null ? void 0 : document.body.scrollHeight);
    if (e) {
      const a = _M();
      t.style.setProperty("--scrollbar-width", `${a}px`), t.setAttribute("data-has-popup", "true"), t.setAttribute(
        "data-locked-overflow",
        r ? "true" : "false"
      ), setTimeout(() => {
        t.style.overflow = "hidden";
      }, 0);
    } else
      t.removeAttribute("data-has-popup"), t.removeAttribute("data-locked-overflow"), t.style.overflow = "";
  } catch (t) {
    console.warn(t);
  }
}
function xM() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
const co = ne([]);
function d_(e, t) {
  co.value.unshift({ uid: e, type: t });
}
function c_(e) {
  co.value = co.value.filter((t) => t.uid !== e);
}
function G1({ type: e, isOpen: t }) {
  const r = ne(xM()), a = ne(20), { getNewZIndex: n } = pu();
  async function i(l) {
    await Pt(), l ? u_(!0) : co.value.length || u_(!1);
  }
  function s() {
    t.value && (a.value = n());
  }
  He(
    () => t.value,
    () => {
      c_(r.value), t.value && d_(r.value, e), i(!!t.value);
    }
  ), He(
    () => t.value,
    () => s(),
    { immediate: !0 }
  ), ct(() => {
    t.value && (d_(r.value, e), i(!0));
  });
  const o = N(() => {
    const [l] = co.value;
    return (l == null ? void 0 : l.uid) === r.value;
  });
  return Ai(() => c_(r.value)), Tr(() => i(!1)), {
    uid: r,
    zIndex: a,
    isOnTop: o,
    openPopups: co
  };
}
function UT(e, t, r = 0) {
  let a = null;
  function n(o) {
    const l = e == null ? void 0 : e.value;
    if (!l)
      return;
    const d = o.touches[0].target;
    l === d || l.contains(d) || (a = setTimeout(() => {
      t(o);
    }, r));
  }
  function i() {
    a && (clearTimeout(a), a = null);
  }
  function s() {
    a && (clearTimeout(a), a = null);
  }
  ct(() => {
    document.addEventListener("touchstart", n), document.addEventListener("touchend", i), document.addEventListener("touchmove", s);
  }), Ai(() => {
    a && clearTimeout(a), document.removeEventListener("touchstart", n), document.removeEventListener("touchend", i), document.removeEventListener("touchmove", s);
  });
}
function wM({
  uid: e,
  type: t,
  isOnTop: r,
  persist: a,
  isOpen: n,
  onClose: i,
  enabled: s,
  onBeforeClose: o
}) {
  function l() {
    const d = {
      uid: e,
      type: t,
      timestamp: Date.now(),
      isCustomHistory: !0
    };
    window.history.pushState(d, "", "");
  }
  function u(d) {
    if (!s)
      return;
    const f = !d.state || d.state && d.state.uid !== e;
    !r.value || !f || (a || typeof o == "function" && !o() ? history.forward() : i());
  }
  He(n, () => {
    s && (n.value ? setTimeout(l, 50) : window.history.state.uid === e && window.history.back());
  }), ct(() => {
    window.addEventListener("popstate", u);
  }), Ai(() => {
    window.removeEventListener("popstate", u);
  });
}
function f_() {
  let e = 1;
  const t = document.querySelectorAll("body *");
  for (let r = 0, a = t.length; r < a; r += 1) {
    const n = t[r], i = Number.parseFloat(
      window.getComputedStyle(n).zIndex || n.style.zIndex
    );
    i > e && (e = i);
  }
  return e;
}
let bs;
function pu() {
  function e() {
    return bs === void 0 && (bs = f_()), bs;
  }
  function t() {
    return bs === void 0 && (bs = f_()), ++bs;
  }
  function r() {
    return bs !== void 0;
  }
  return { isInitialized: r, getMaxZIndex: e, getNewZIndex: t };
}
const TM = { key: 1 }, SM = /* @__PURE__ */ Ae({
  __name: "JAccordion",
  props: {
    title: { default: "" },
    modelValue: { type: Boolean, default: !1 },
    titleClass: { default: "" },
    activeClass: { default: "" },
    activeTitleClass: { default: "" },
    headerClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    I1((g) => ({
      "1b95988a": p.value
    }));
    const r = e, a = t, n = Vn(), i = n("title"), s = n("toggleTitleSlot"), o = n("footer"), l = $r(r, "modelValue", a), u = () => l.value = !1, d = () => l.value = !0, f = () => l.value ? u() : d(), c = N(() => l.value ? "h-auto py-24 border-gray-300" : "h-0 border-transparent overflow-hidden"), p = N(
      () => l.value ? "180deg" : "0deg"
    ), v = N(
      () => l.value ? r.activeClass : ""
    ), h = N(() => {
      const g = `${r.titleClass} text-dark`;
      return l.value ? r.activeTitleClass ?? g : g;
    });
    return (g, m) => (R(), K("div", {
      class: pe(["accordion rounded-md border border-solid border-line", v.value])
    }, [
      ue("div", {
        class: pe(["accordion__header px-12 py-12 font-medium", g.headerClass])
      }, [
        ke(g.$slots, "headerPrepend", {}, void 0, !0),
        ue("div", {
          class: pe(["flex cursor-pointer flex-row items-center justify-between", [h.value]]),
          onClick: f
        }, [
          U(i) ? ke(g.$slots, "title", { key: 0 }, void 0, !0) : (R(), K("span", TM, Ie(g.title), 1)),
          ue("span", {
            class: pe(U(s) && "inline-flex select-none items-center")
          }, [
            U(s) ? ke(g.$slots, "toggleTitleSlot", { key: 0 }, void 0, !0) : fe("", !0),
            Fe(gt, {
              size: 24,
              name: "alt-arrow-down",
              class: "accordion__header__icon transition-all"
            })
          ], 2)
        ], 2),
        ke(g.$slots, "headerAppend", {}, void 0, !0)
      ], 2),
      ue("div", {
        class: pe(["border-t border-solid px-16 transition-all", c.value])
      }, [
        ke(g.$slots, "default", {}, void 0, !0)
      ], 2),
      U(o) ? ke(g.$slots, "footer", { key: 0 }, void 0, !0) : fe("", !0)
    ], 2));
  }
});
const rs = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [a, n] of t)
    r[a] = n;
  return r;
}, EM = /* @__PURE__ */ rs(SM, [["__scopeId", "data-v-79fbaada"]]), OM = { key: 0 }, CM = { key: 1 }, foe = /* @__PURE__ */ Ae({
  __name: "JAccordionGroup",
  props: {
    accordions: { default: () => [] },
    modelValue: {},
    closeOnClickOutside: { type: Boolean, default: !1 },
    accordionActiveClass: { default: "" },
    accordionTitleClass: { default: "" },
    accordionActiveTitleClass: { default: "text-primary" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = ne([]);
    He(
      () => r.accordions,
      (d) => {
        i.value = d;
      },
      {
        immediate: !0
      }
    );
    function s(d, f) {
      if (f) {
        n.value = d;
        return;
      }
      n.value = -1;
    }
    function o(d) {
      return typeof d == "string" || d instanceof HTMLElement;
    }
    function l(d, f = !1) {
      return f ? n.value === d : !0;
    }
    const u = ne(null);
    return du(u, () => {
      r.closeOnClickOutside && (n.value = -1);
    }), (d, f) => {
      const c = R4("sanitize");
      return R(), K("div", {
        ref_key: "accordionGroupWrapper",
        ref: u
      }, [
        (R(!0), K(Qe, null, kt(i.value, (p, v) => (R(), Le(EM, {
          key: p.title,
          modelValue: v === U(n),
          title: p.title,
          class: "mb-16",
          activeClass: `${d.accordionActiveClass} accordion--active`,
          titleClass: d.accordionTitleClass,
          activeTitleClass: d.accordionActiveTitleClass,
          "onUpdate:modelValue": (h) => s(v, h)
        }, {
          default: Pe(() => [
            o(p.content) ? ea((R(), K("div", OM, null, 512)), [
              [c, [
                {
                  allowedClasses: {
                    h3: [
                      "text-primary-hover",
                      "text-primary",
                      "mb-8",
                      "font-semi-bold"
                    ],
                    h4: ["font-medium", "text-metadata-limited", "mb-8"],
                    p: ["text-gray-600", "text-metadata-limited"],
                    div: ["mb-16"]
                  }
                },
                p.content
              ]]
            ]) : (R(), K("div", CM, [
              l(v, p.lazy) ? (R(), Le(Za(p.content), { key: 0 })) : fe("", !0)
            ]))
          ]),
          _: 2
        }, 1032, ["modelValue", "title", "activeClass", "titleClass", "activeTitleClass", "onUpdate:modelValue"]))), 128))
      ], 512);
    };
  }
});
function Qs(e, t, r) {
  let a = r.initialDeps ?? [], n;
  return () => {
    var i, s, o, l;
    let u;
    r.key && ((i = r.debug) != null && i.call(r)) && (u = Date.now());
    const d = e();
    if (!(d.length !== a.length || d.some((p, v) => a[v] !== p)))
      return n;
    a = d;
    let c;
    if (r.key && ((s = r.debug) != null && s.call(r)) && (c = Date.now()), n = t(...d), r.key && ((o = r.debug) != null && o.call(r))) {
      const p = Math.round((Date.now() - u) * 100) / 100, v = Math.round((Date.now() - c) * 100) / 100, h = v / 16, g = (m, b) => {
        for (m = String(m); m.length < b; )
          m = " " + m;
        return m;
      };
      console.info(
        `%c⏱ ${g(v, 5)} /${g(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * h, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (l = r == null ? void 0 : r.onChange) == null || l.call(r, n), n;
  };
}
function yf(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const kM = (e, t) => Math.abs(e - t) < 1, PM = (e) => e, MM = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let n = t; n <= r; n++)
    a.push(n);
  return a;
}, AM = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const a = (i) => {
    const { width: s, height: o } = i;
    t({ width: Math.round(s), height: Math.round(o) });
  };
  if (a(r.getBoundingClientRect()), typeof ResizeObserver > "u")
    return () => {
    };
  const n = new ResizeObserver((i) => {
    const s = i[0];
    if (s != null && s.borderBoxSize) {
      const o = s.borderBoxSize[0];
      if (o) {
        a({ width: o.inlineSize, height: o.blockSize });
        return;
      }
    }
    a(r.getBoundingClientRect());
  });
  return n.observe(r, { box: "border-box" }), () => {
    n.unobserve(r);
  };
}, DM = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const a = () => {
    t(r[e.options.horizontal ? "scrollLeft" : "scrollTop"]);
  };
  return a(), r.addEventListener("scroll", a, {
    passive: !0
  }), () => {
    r.removeEventListener("scroll", a);
  };
}, IM = (e, t, r) => {
  if (t != null && t.borderBoxSize) {
    const a = t.borderBoxSize[0];
    if (a)
      return Math.round(
        a[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, NM = (e, {
  adjustments: t = 0,
  behavior: r
}, a) => {
  var n, i;
  const s = e + t;
  (i = (n = a.scrollElement) == null ? void 0 : n.scrollTo) == null || i.call(n, {
    [a.options.horizontal ? "left" : "top"]: s,
    behavior: r
  });
};
class $M {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const a = () => r || (typeof ResizeObserver < "u" ? r = new ResizeObserver((n) => {
        n.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }) : null);
      return {
        disconnect: () => {
          var n;
          return (n = a()) == null ? void 0 : n.disconnect();
        },
        observe: (n) => {
          var i;
          return (i = a()) == null ? void 0 : i.observe(n, { box: "border-box" });
        },
        unobserve: (n) => {
          var i;
          return (i = a()) == null ? void 0 : i.unobserve(n);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([a, n]) => {
        typeof n > "u" && delete r[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: PM,
        rangeExtractor: MM,
        onChange: () => {
        },
        measureElement: IM,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        scrollingDelay: 150,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        ...r
      };
    }, this.notify = (r) => {
      var a, n;
      (n = (a = this.options).onChange) == null || n.call(a, this, r);
    }, this.maybeNotify = Qs(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.scrollElement = null;
    }, this._didMount = () => (this.measureElementCache.forEach(this.observer.observe), () => {
      this.observer.disconnect(), this.cleanup();
    }), this._willUpdate = () => {
      const r = this.options.getScrollElement();
      this.scrollElement !== r && (this.cleanup(), this.scrollElement = r, this._scrollToOffset(this.scrollOffset, {
        adjustments: void 0,
        behavior: void 0
      }), this.unsubs.push(
        this.options.observeElementRect(this, (a) => {
          this.scrollRect = a, this.maybeNotify();
        })
      ), this.unsubs.push(
        this.options.observeElementOffset(this, (a) => {
          this.scrollAdjustments = 0, this.scrollOffset !== a && (this.isScrollingTimeoutId !== null && (clearTimeout(this.isScrollingTimeoutId), this.isScrollingTimeoutId = null), this.isScrolling = !0, this.scrollDirection = this.scrollOffset < a ? "forward" : "backward", this.scrollOffset = a, this.maybeNotify(), this.isScrollingTimeoutId = setTimeout(() => {
            this.isScrollingTimeoutId = null, this.isScrolling = !1, this.scrollDirection = null, this.maybeNotify();
          }, this.options.scrollingDelay));
        })
      ));
    }, this.getSize = () => this.scrollRect[this.options.horizontal ? "width" : "height"], this.memoOptions = Qs(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey
      ],
      (r, a, n, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: a,
        scrollMargin: n,
        getItemKey: i
      }),
      {
        key: !1
      }
    ), this.getFurthestMeasurement = (r, a) => {
      const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = a - 1; s >= 0; s--) {
        const o = r[s];
        if (n.has(o.lane))
          continue;
        const l = i.get(
          o.lane
        );
        if (l == null || o.end > l.end ? i.set(o.lane, o) : o.end < l.end && n.set(o.lane, !0), n.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, o) => s.end === o.end ? s.index - o.index : s.end - o.end)[0] : void 0;
    }, this.getMeasurements = Qs(
      () => [this.memoOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: a, scrollMargin: n, getItemKey: i }, s) => {
        const o = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const l = this.measurementsCache.slice(0, o);
        for (let u = o; u < r; u++) {
          const d = i(u), f = this.options.lanes === 1 ? l[u - 1] : this.getFurthestMeasurement(l, u), c = f ? f.end : a + n, p = s.get(d), v = typeof p == "number" ? p : this.options.estimateSize(u), h = c + v, g = f ? f.lane : u % this.options.lanes;
          l[u] = {
            index: u,
            start: c,
            size: v,
            end: h,
            key: d,
            lane: g
          };
        }
        return this.measurementsCache = l, l;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Qs(
      () => [this.getMeasurements(), this.getSize(), this.scrollOffset],
      (r, a, n) => this.range = r.length > 0 && a > 0 ? LM({
        measurements: r,
        outerSize: a,
        scrollOffset: n
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Qs(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, a, n, i) => a === null ? [] : r({
        ...a,
        overscan: n,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const a = this.options.indexAttribute, n = r.getAttribute(a);
      return n ? parseInt(n, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, a) => {
      const n = this.measurementsCache[this.indexFromElement(r)];
      if (!n || !r.isConnected) {
        this.measureElementCache.forEach((o, l) => {
          o === r && (this.observer.unobserve(r), this.measureElementCache.delete(l));
        });
        return;
      }
      const i = this.measureElementCache.get(n.key);
      i !== r && (i && this.observer.unobserve(i), this.observer.observe(r), this.measureElementCache.set(n.key, r));
      const s = this.options.measureElement(r, a, this);
      this.resizeItem(n, s);
    }, this.resizeItem = (r, a) => {
      const n = this.itemSizeCache.get(r.key) ?? r.size, i = a - n;
      i !== 0 && (r.start < this.scrollOffset + this.scrollAdjustments && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", i), this._scrollToOffset(this.scrollOffset, {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(r.index), this.itemSizeCache = new Map(this.itemSizeCache.set(r.key, a)), this.notify(!1));
    }, this.measureElement = (r) => {
      r && this._measureElement(r, void 0);
    }, this.getVirtualItems = Qs(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, a) => {
        const n = [];
        for (let i = 0, s = r.length; i < s; i++) {
          const o = r[i], l = a[o];
          n.push(l);
        }
        return n;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const a = this.getMeasurements();
      return yf(
        a[zT(
          0,
          a.length - 1,
          (n) => yf(a[n]).start,
          r
        )]
      );
    }, this.getOffsetForAlignment = (r, a) => {
      const n = this.getSize();
      a === "auto" && (r <= this.scrollOffset ? a = "start" : r >= this.scrollOffset + n ? a = "end" : a = "start"), a === "start" ? r = r : a === "end" ? r = r - n : a === "center" && (r = r - n / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", o = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - this.getSize();
      return Math.max(Math.min(o, r), 0);
    }, this.getOffsetForIndex = (r, a = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const n = yf(this.getMeasurements()[r]);
      if (a === "auto")
        if (n.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd)
          a = "end";
        else if (n.start <= this.scrollOffset + this.options.scrollPaddingStart)
          a = "start";
        else
          return [this.scrollOffset, a];
      const i = a === "end" ? n.end + this.options.scrollPaddingEnd : n.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(i, a), a];
    }, this.isDynamicMode = () => this.measureElementCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && (clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: a = "start", behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, a), {
        adjustments: void 0,
        behavior: n
      });
    }, this.scrollToIndex = (r, { align: a = "auto", behavior: n } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const [i, s] = this.getOffsetForIndex(r, a);
      this._scrollToOffset(i, { adjustments: void 0, behavior: n }), n !== "smooth" && this.isDynamicMode() && (this.scrollToIndexTimeoutId = setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.measureElementCache.has(
          this.options.getItemKey(r)
        )) {
          const [l] = this.getOffsetForIndex(r, s);
          kM(l, this.scrollOffset) || this.scrollToIndex(r, { align: s, behavior: n });
        } else
          this.scrollToIndex(r, { align: s, behavior: n });
      }));
    }, this.scrollBy = (r, { behavior: a } = {}) => {
      this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.scrollOffset + r, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var r;
      const a = this.getMeasurements();
      let n;
      return a.length === 0 ? n = this.options.paddingStart : n = this.options.lanes === 1 ? ((r = a[a.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...a.slice(-this.options.lanes).map((i) => i.end)
      ), n - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (r, {
      adjustments: a,
      behavior: n
    }) => {
      this.options.scrollToFn(r, { behavior: n, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((r) => {
      this.itemSizeCache.set(r.key, r.size);
    }), this.maybeNotify();
  }
}
const zT = (e, t, r, a) => {
  for (; e <= t; ) {
    const n = (e + t) / 2 | 0, i = r(n);
    if (i < a)
      e = n + 1;
    else if (i > a)
      t = n - 1;
    else
      return n;
  }
  return e > 0 ? e - 1 : 0;
};
function LM({
  measurements: e,
  outerSize: t,
  scrollOffset: r
}) {
  const a = e.length - 1, i = zT(0, a, (o) => e[o].start, r);
  let s = i;
  for (; s < a && e[s].end < r + t; )
    s++;
  return { startIndex: i, endIndex: s };
}
function RM(e) {
  const t = new $M(U(e)), r = ir(t), a = t._didMount();
  return He(
    () => U(e).getScrollElement(),
    (n) => {
      n && t._willUpdate();
    },
    {
      immediate: !0
    }
  ), He(
    () => U(e),
    (n) => {
      t.setOptions({
        ...n,
        onChange: (i, s) => {
          var o;
          Sy(r), (o = n.onChange) == null || o.call(n, i, s);
        }
      }), t._willUpdate(), Sy(r);
    },
    {
      immediate: !0
    }
  ), D1(a), r;
}
function jM(e) {
  return RM(
    N(() => ({
      observeElementRect: AM,
      observeElementOffset: DM,
      scrollToFn: NM,
      ...U(e)
    }))
  );
}
function qd(e, t, r) {
  let a = ne(r == null ? void 0 : r.value), n = N(() => e.value !== void 0);
  return [N(() => n.value ? e.value : a.value), function(i) {
    return n.value || (a.value = i), t == null ? void 0 : t(i);
  }];
}
let FM = Symbol("headlessui.useid"), BM = 0;
function Sr() {
  return sr(FM, () => `${++BM}`)();
}
function je(e) {
  var t;
  if (e == null || e.value == null)
    return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function or(e, t, ...r) {
  if (e in t) {
    let n = t[e];
    return typeof n == "function" ? n(...r) : n;
  }
  let a = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((n) => `"${n}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(a, or), a;
}
var qM = Object.defineProperty, HM = (e, t, r) => t in e ? qM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, p_ = (e, t, r) => (HM(e, typeof t != "symbol" ? t + "" : t, r), r);
let VM = class {
  constructor() {
    p_(this, "current", this.detect()), p_(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, vu = new VM();
function Qa(e) {
  if (vu.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = je(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
let Dp = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Cr = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Cr || {}), zi = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(zi || {}), UM = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(UM || {});
function YT(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Dp)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Hd = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Hd || {});
function Vd(e, t = 0) {
  var r;
  return e === ((r = Qa(e)) == null ? void 0 : r.body) ? !1 : or(t, { 0() {
    return e.matches(Dp);
  }, 1() {
    let a = e;
    for (; a !== null; ) {
      if (a.matches(Dp))
        return !0;
      a = a.parentElement;
    }
    return !1;
  } });
}
function WT(e) {
  let t = Qa(e);
  Pt(() => {
    t && !Vd(t.activeElement, 0) && Ki(e);
  });
}
var zM = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(zM || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Ki(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let YM = ["textarea", "input"].join(",");
function WM(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, YM)) != null ? r : !1;
}
function ai(e, t = (r) => r) {
  return e.slice().sort((r, a) => {
    let n = t(r), i = t(a);
    if (n === null || i === null)
      return 0;
    let s = n.compareDocumentPosition(i);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function GM(e, t) {
  return Xa(YT(), t, { relativeTo: e });
}
function Xa(e, t, { sorted: r = !0, relativeTo: a = null, skipElements: n = [] } = {}) {
  var i;
  let s = (i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? i : document, o = Array.isArray(e) ? r ? ai(e) : e : YT(e);
  n.length > 0 && o.length > 1 && (o = o.filter((v) => !n.includes(v))), a = a ?? s.activeElement;
  let l = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, o.indexOf(a)) - 1;
    if (t & 4)
      return Math.max(0, o.indexOf(a)) + 1;
    if (t & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = t & 32 ? { preventScroll: !0 } : {}, f = 0, c = o.length, p;
  do {
    if (f >= c || f + c <= 0)
      return 0;
    let v = u + f;
    if (t & 16)
      v = (v + c) % c;
    else {
      if (v < 0)
        return 3;
      if (v >= c)
        return 1;
    }
    p = o[v], p == null || p.focus(d), f += l;
  } while (p !== s.activeElement);
  return t & 6 && WM(p) && p.select(), 2;
}
function GT() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function XM() {
  return /Android/gi.test(window.navigator.userAgent);
}
function XT() {
  return GT() || XM();
}
function Bu(e, t, r) {
  vu.isServer || Nr((a) => {
    document.addEventListener(e, t, r), a(() => document.removeEventListener(e, t, r));
  });
}
function KT(e, t, r) {
  vu.isServer || Nr((a) => {
    window.addEventListener(e, t, r), a(() => window.removeEventListener(e, t, r));
  });
}
function Ud(e, t, r = N(() => !0)) {
  function a(i, s) {
    if (!r.value || i.defaultPrevented)
      return;
    let o = s(i);
    if (o === null || !o.getRootNode().contains(o))
      return;
    let l = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of l) {
      if (u === null)
        continue;
      let d = u instanceof HTMLElement ? u : je(u);
      if (d != null && d.contains(o) || i.composed && i.composedPath().includes(d))
        return;
    }
    return !Vd(o, Hd.Loose) && o.tabIndex !== -1 && i.preventDefault(), t(i, o);
  }
  let n = ne(null);
  Bu("pointerdown", (i) => {
    var s, o;
    r.value && (n.value = ((o = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), Bu("mousedown", (i) => {
    var s, o;
    r.value && (n.value = ((o = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), Bu("click", (i) => {
    XT() || n.value && (a(i, () => n.value), n.value = null);
  }, !0), Bu("touchend", (i) => a(i, () => i.target instanceof HTMLElement ? i.target : null), !0), KT("blur", (i) => a(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function v_(e, t) {
  if (e)
    return e;
  let r = t ?? "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function mu(e, t) {
  let r = ne(v_(e.value.type, e.value.as));
  return ct(() => {
    r.value = v_(e.value.type, e.value.as);
  }), Nr(() => {
    var a;
    r.value || je(t) && je(t) instanceof HTMLButtonElement && !((a = je(t)) != null && a.hasAttribute("type")) && (r.value = "button");
  }), r;
}
function m_(e) {
  return [e.screenX, e.screenY];
}
function X1() {
  let e = ne([-1, -1]);
  return { wasMoved(t) {
    let r = m_(t);
    return e.value[0] === r[0] && e.value[1] === r[1] ? !1 : (e.value = r, !0);
  }, update(t) {
    e.value = m_(t);
  } };
}
function K1({ container: e, accept: t, walk: r, enabled: a }) {
  Nr(() => {
    let n = e.value;
    if (!n || a !== void 0 && !a.value)
      return;
    let i = Qa(e);
    if (!i)
      return;
    let s = Object.assign((l) => t(l), { acceptNode: t }), o = i.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; o.nextNode(); )
      r(o.currentNode);
  });
}
var Ha = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ha || {}), Yi = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Yi || {});
function $t({ visible: e = !0, features: t = 0, ourProps: r, theirProps: a, ...n }) {
  var i;
  let s = QT(a, r), o = Object.assign(n, { props: s });
  if (e || t & 2 && s.static)
    return _f(o);
  if (t & 1) {
    let l = (i = s.unmount) == null || i ? 0 : 1;
    return or(l, { 0() {
      return null;
    }, 1() {
      return _f({ ...n, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return _f(o);
}
function _f({ props: e, attrs: t, slots: r, slot: a, name: n }) {
  var i, s;
  let { as: o, ...l } = Ni(e, ["unmount", "static"]), u = (i = r.default) == null ? void 0 : i.call(r, a), d = {};
  if (a) {
    let f = !1, c = [];
    for (let [p, v] of Object.entries(a))
      typeof v == "boolean" && (f = !0), v === !0 && c.push(p);
    f && (d["data-headlessui-state"] = c.join(" "));
  }
  if (o === "template") {
    if (u = JT(u ?? []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [f, ...c] = u ?? [];
      if (!KM(f) || c.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${n} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((h) => h.trim()).filter((h, g, m) => m.indexOf(h) === g).sort((h, g) => h.localeCompare(g)).map((h) => `  - ${h}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((h) => `  - ${h}`).join(`
`)].join(`
`));
      let p = QT((s = f.props) != null ? s : {}, l, d), v = aT(f, p, !0);
      for (let h in p)
        h.startsWith("on") && (v.props || (v.props = {}), v.props[h] = p[h]);
      return v;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return Ht(o, Object.assign({}, l, d), { default: () => u });
}
function JT(e) {
  return e.flatMap((t) => t.type === Qe ? JT(t.children) : [t]);
}
function QT(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let a of e)
    for (let n in a)
      n.startsWith("on") && typeof a[n] == "function" ? (r[n] != null || (r[n] = []), r[n].push(a[n])) : t[n] = a[n];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(r).map((a) => [a, void 0])));
  for (let a in r)
    Object.assign(t, { [a](n, ...i) {
      let s = r[a];
      for (let o of s) {
        if (n instanceof Event && n.defaultPrevented)
          return;
        o(n, ...i);
      }
    } });
  return t;
}
function zd(e) {
  let t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function Ni(e, t = []) {
  let r = Object.assign({}, e);
  for (let a of t)
    a in r && delete r[a];
  return r;
}
function KM(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Si = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Si || {});
let Ei = Ae({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var a;
    let { features: n, ...i } = e, s = { "aria-hidden": (n & 2) === 2 ? !0 : (a = i["aria-hidden"]) != null ? a : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
    return $t({ ourProps: s, theirProps: i, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), ZT = Symbol("Context");
var wr = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(wr || {});
function JM() {
  return ko() !== null;
}
function ko() {
  return sr(ZT, null);
}
function Yd(e) {
  Mr(ZT, e);
}
var lt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(lt || {});
function QM(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let xi = [];
QM(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && xi[0] !== t.target && (xi.unshift(t.target), xi = xi.filter((r) => r != null && r.isConnected), xi.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function ZM(e) {
  throw new Error("Unexpected object: " + e);
}
var Ct = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Ct || {});
function bd(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0)
    return null;
  let a = t.resolveActiveIndex(), n = a ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 1: {
      n === -1 && (n = r.length);
      for (let i = n - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 2: {
      for (let i = n + 1; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 3: {
      for (let i = r.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 4: {
      for (let i = 0; i < r.length; ++i)
        if (t.resolveId(r[i], i, r) === e.id)
          return i;
      return a;
    }
    case 5:
      return null;
    default:
      ZM(e);
  }
}
function Wd(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Ps() {
  let e = [], t = { addEventListener(r, a, n, i) {
    return r.addEventListener(a, n, i), t.add(() => r.removeEventListener(a, n, i));
  }, requestAnimationFrame(...r) {
    let a = requestAnimationFrame(...r);
    t.add(() => cancelAnimationFrame(a));
  }, nextFrame(...r) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let a = setTimeout(...r);
    t.add(() => clearTimeout(a));
  }, microTask(...r) {
    let a = { current: !0 };
    return Wd(() => {
      a.current && r[0]();
    }), t.add(() => {
      a.current = !1;
    });
  }, style(r, a, n) {
    let i = r.style.getPropertyValue(a);
    return Object.assign(r.style, { [a]: n }), this.add(() => {
      Object.assign(r.style, { [a]: i });
    });
  }, group(r) {
    let a = Ps();
    return r(a), this.add(() => a.dispose());
  }, add(r) {
    return e.push(r), () => {
      let a = e.indexOf(r);
      if (a >= 0)
        for (let n of e.splice(a, 1))
          n();
    };
  }, dispose() {
    for (let r of e.splice(0))
      r();
  } };
  return t;
}
function Gd(e = {}, t = null, r = []) {
  for (let [a, n] of Object.entries(e))
    tS(r, eS(t, a), n);
  return r;
}
function eS(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function tS(e, t, r) {
  if (Array.isArray(r))
    for (let [a, n] of r.entries())
      tS(e, eS(t, a.toString()), n);
  else
    r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : Gd(r, t, e);
}
function rS(e) {
  var t, r;
  let a = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (a) {
    for (let n of a.elements)
      if (n !== e && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
        n.click();
        return;
      }
    (r = a.requestSubmit) == null || r.call(a);
  }
}
function eA(e, t) {
  return e === t;
}
var tA = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(tA || {}), rA = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(rA || {}), aA = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(aA || {});
let aS = Symbol("ComboboxContext");
function Ns(e) {
  let t = sr(aS, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ns), r;
  }
  return t;
}
let nS = Symbol("VirtualContext"), nA = Ae({ name: "VirtualProvider", setup(e, { slots: t }) {
  let r = Ns("VirtualProvider"), a = N(() => {
    let o = je(r.optionsRef);
    if (!o)
      return { start: 0, end: 0 };
    let l = window.getComputedStyle(o);
    return { start: parseFloat(l.paddingBlockStart || l.paddingTop), end: parseFloat(l.paddingBlockEnd || l.paddingBottom) };
  }), n = jM(N(() => ({ scrollPaddingStart: a.value.start, scrollPaddingEnd: a.value.end, count: r.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return je(r.optionsRef);
  }, overscan: 12 }))), i = N(() => {
    var o;
    return (o = r.virtual.value) == null ? void 0 : o.options;
  }), s = ne(0);
  return He([i], () => {
    s.value += 1;
  }), Mr(nS, r.virtual.value ? n : null), () => [Ht("div", { style: { position: "relative", width: "100%", height: `${n.value.getTotalSize()}px` }, ref: (o) => {
    if (o) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || r.activationTrigger.value === 0)
        return;
      r.activeOptionIndex.value !== null && r.virtual.value.options.length > r.activeOptionIndex.value && n.value.scrollToIndex(r.activeOptionIndex.value);
    }
  } }, n.value.getVirtualItems().map((o) => aT(t.default({ option: r.virtual.value.options[o.index], open: r.comboboxState.value === 0 })[0], { key: `${s.value}-${o.index}`, "data-index": o.index, "aria-setsize": r.virtual.value.options.length, "aria-posinset": o.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${o.start}px)`, overflowAnchor: "none" } })))];
} }), iS = Ae({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(e, { slots: t, attrs: r, emit: a }) {
  let n = ne(1), i = ne(null), s = ne(null), o = ne(null), l = ne(null), u = ne({ static: !1, hold: !1 }), d = ne([]), f = ne(null), c = ne(2), p = ne(!1);
  function v(A = (E) => E) {
    let E = f.value !== null ? d.value[f.value] : null, O = A(d.value.slice()), T = O.length > 0 && O[0].dataRef.order.value !== null ? O.sort(($, I) => $.dataRef.order.value - I.dataRef.order.value) : ai(O, ($) => je($.dataRef.domRef)), D = E ? T.indexOf(E) : null;
    return D === -1 && (D = null), { options: T, activeOptionIndex: D };
  }
  let h = N(() => e.multiple ? 1 : 0), g = N(() => e.nullable), [m, b] = qd(N(() => e.modelValue), (A) => a("update:modelValue", A), N(() => e.defaultValue)), y = N(() => m.value === void 0 ? or(h.value, { 1: [], 0: void 0 }) : m.value), _ = null, x = null;
  function w(A) {
    return or(h.value, { 0() {
      return b == null ? void 0 : b(A);
    }, 1: () => {
      let E = fr(S.value.value).slice(), O = fr(A), T = E.findIndex((D) => S.compare(O, fr(D)));
      return T === -1 ? E.push(O) : E.splice(T, 1), b == null ? void 0 : b(E);
    } });
  }
  let k = N(() => {
  });
  He([k], ([A], [E]) => {
    if (S.virtual.value && A && E && f.value !== null) {
      let O = A.indexOf(E[f.value]);
      O !== -1 ? f.value = O : f.value = null;
    }
  });
  let S = { comboboxState: n, value: y, mode: h, compare(A, E) {
    if (typeof e.by == "string") {
      let O = e.by;
      return (A == null ? void 0 : A[O]) === (E == null ? void 0 : E[O]);
    }
    return e.by === null ? eA(A, E) : e.by(A, E);
  }, calculateIndex(A) {
    return S.virtual.value ? e.by === null ? S.virtual.value.options.indexOf(A) : S.virtual.value.options.findIndex((E) => S.compare(E, A)) : d.value.findIndex((E) => S.compare(E.dataRef.value, A));
  }, defaultValue: N(() => e.defaultValue), nullable: g, immediate: N(() => !1), virtual: N(() => null), inputRef: s, labelRef: i, buttonRef: o, optionsRef: l, disabled: N(() => e.disabled), options: d, change(A) {
    b(A);
  }, activeOptionIndex: N(() => {
    if (p.value && f.value === null && (S.virtual.value ? S.virtual.value.options.length > 0 : d.value.length > 0)) {
      if (S.virtual.value) {
        let E = S.virtual.value.options.findIndex((O) => {
          var T;
          return !((T = S.virtual.value) != null && T.disabled(O));
        });
        if (E !== -1)
          return E;
      }
      let A = d.value.findIndex((E) => !E.dataRef.disabled);
      if (A !== -1)
        return A;
    }
    return f.value;
  }), activationTrigger: c, optionsPropsRef: u, closeCombobox() {
    p.value = !1, !e.disabled && n.value !== 1 && (n.value = 1, f.value = null);
  }, openCombobox() {
    if (p.value = !0, !e.disabled && n.value !== 0) {
      if (S.value.value) {
        let A = S.calculateIndex(S.value.value);
        A !== -1 && (f.value = A);
      }
      n.value = 0;
    }
  }, setActivationTrigger(A) {
    c.value = A;
  }, goToOption(A, E, O) {
    p.value = !1, _ !== null && cancelAnimationFrame(_), _ = requestAnimationFrame(() => {
      if (e.disabled || l.value && !u.value.static && n.value === 1)
        return;
      if (S.virtual.value) {
        f.value = A === Ct.Specific ? E : bd({ focus: A }, { resolveItems: () => S.virtual.value.options, resolveActiveIndex: () => {
          var $, I;
          return (I = ($ = S.activeOptionIndex.value) != null ? $ : S.virtual.value.options.findIndex((F) => {
            var j;
            return !((j = S.virtual.value) != null && j.disabled(F));
          })) != null ? I : null;
        }, resolveDisabled: ($) => S.virtual.value.disabled($), resolveId() {
          throw new Error("Function not implemented.");
        } }), c.value = O ?? 2;
        return;
      }
      let T = v();
      if (T.activeOptionIndex === null) {
        let $ = T.options.findIndex((I) => !I.dataRef.disabled);
        $ !== -1 && (T.activeOptionIndex = $);
      }
      let D = A === Ct.Specific ? E : bd({ focus: A }, { resolveItems: () => T.options, resolveActiveIndex: () => T.activeOptionIndex, resolveId: ($) => $.id, resolveDisabled: ($) => $.dataRef.disabled });
      f.value = D, c.value = O ?? 2, d.value = T.options;
    });
  }, selectOption(A) {
    let E = d.value.find((T) => T.id === A);
    if (!E)
      return;
    let { dataRef: O } = E;
    w(O.value);
  }, selectActiveOption() {
    if (S.activeOptionIndex.value !== null) {
      if (S.virtual.value)
        w(S.virtual.value.options[S.activeOptionIndex.value]);
      else {
        let { dataRef: A } = d.value[S.activeOptionIndex.value];
        w(A.value);
      }
      S.goToOption(Ct.Specific, S.activeOptionIndex.value);
    }
  }, registerOption(A, E) {
    let O = Sn({ id: A, dataRef: E });
    if (S.virtual.value) {
      d.value.push(O);
      return;
    }
    x && cancelAnimationFrame(x);
    let T = v((D) => (D.push(O), D));
    f.value === null && S.isSelected(E.value.value) && (T.activeOptionIndex = T.options.indexOf(O)), d.value = T.options, f.value = T.activeOptionIndex, c.value = 2, T.options.some((D) => !je(D.dataRef.domRef)) && (x = requestAnimationFrame(() => {
      let D = v();
      d.value = D.options, f.value = D.activeOptionIndex;
    }));
  }, unregisterOption(A, E) {
    if (_ !== null && cancelAnimationFrame(_), E && (p.value = !0), S.virtual.value) {
      d.value = d.value.filter((T) => T.id !== A);
      return;
    }
    let O = v((T) => {
      let D = T.findIndex(($) => $.id === A);
      return D !== -1 && T.splice(D, 1), T;
    });
    d.value = O.options, f.value = O.activeOptionIndex, c.value = 2;
  }, isSelected(A) {
    return or(h.value, { 0: () => S.compare(fr(S.value.value), fr(A)), 1: () => fr(S.value.value).some((E) => S.compare(fr(E), fr(A))) });
  }, isActive(A) {
    return f.value === S.calculateIndex(A);
  } };
  Ud([s, o, l], () => S.closeCombobox(), N(() => n.value === 0)), Mr(aS, S), Yd(N(() => or(n.value, { 0: wr.Open, 1: wr.Closed })));
  let P = N(() => {
    var A;
    return (A = je(s)) == null ? void 0 : A.closest("form");
  });
  return ct(() => {
    He([P], () => {
      if (!P.value || e.defaultValue === void 0)
        return;
      function A() {
        S.change(e.defaultValue);
      }
      return P.value.addEventListener("reset", A), () => {
        var E;
        (E = P.value) == null || E.removeEventListener("reset", A);
      };
    }, { immediate: !0 });
  }), () => {
    var A, E, O;
    let { name: T, disabled: D, form: $, ...I } = e, F = { open: n.value === 0, disabled: D, activeIndex: S.activeOptionIndex.value, activeOption: S.activeOptionIndex.value === null ? null : S.virtual.value ? S.virtual.value.options[(A = S.activeOptionIndex.value) != null ? A : 0] : (O = (E = S.options.value[S.activeOptionIndex.value]) == null ? void 0 : E.dataRef.value) != null ? O : null, value: y.value };
    return Ht(Qe, [...T != null && y.value != null ? Gd({ [T]: y.value }).map(([j, M]) => Ht(Ei, zd({ features: Si.Hidden, key: j, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: $, name: j, value: M }))) : [], $t({ theirProps: { ...r, ...Ni(I, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: F, slots: t, attrs: r, name: "Combobox" })]);
  };
} }), iA = Ae({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-combobox-label-${Sr()}`, i = Ns("ComboboxLabel");
  function s() {
    var o;
    (o = je(i.inputRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: i.comboboxState.value === 0, disabled: i.disabled.value }, { ...l } = e, u = { id: n, ref: i.labelRef, onClick: s };
    return $t({ ourProps: u, theirProps: l, slot: o, attrs: t, slots: r, name: "ComboboxLabel" });
  };
} }), h_ = Ae({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-combobox-button-${Sr()}`, s = Ns("ComboboxButton");
  a({ el: s.buttonRef, $el: s.buttonRef });
  function o(d) {
    s.disabled.value || (s.comboboxState.value === 0 ? s.closeCombobox() : (d.preventDefault(), s.openCombobox()), Pt(() => {
      var f;
      return (f = je(s.inputRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    }));
  }
  function l(d) {
    switch (d.key) {
      case lt.ArrowDown:
        d.preventDefault(), d.stopPropagation(), s.comboboxState.value === 1 && s.openCombobox(), Pt(() => {
          var f;
          return (f = s.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
      case lt.ArrowUp:
        d.preventDefault(), d.stopPropagation(), s.comboboxState.value === 1 && (s.openCombobox(), Pt(() => {
          s.value.value || s.goToOption(Ct.Last);
        })), Pt(() => {
          var f;
          return (f = s.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
      case lt.Escape:
        if (s.comboboxState.value !== 0)
          return;
        d.preventDefault(), s.optionsRef.value && !s.optionsPropsRef.value.static && d.stopPropagation(), s.closeCombobox(), Pt(() => {
          var f;
          return (f = s.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let u = mu(N(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var d, f;
    let c = { open: s.comboboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...p } = e, v = { ref: s.buttonRef, id: i, type: u.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (d = je(s.optionsRef)) == null ? void 0 : d.id, "aria-expanded": s.comboboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(f = je(s.labelRef)) == null ? void 0 : f.id, i].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: l, onClick: o };
    return $t({ ourProps: v, theirProps: p, slot: c, attrs: t, slots: r, name: "ComboboxButton" });
  };
} }), sA = Ae({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (e) => !0 }, setup(e, { emit: t, attrs: r, slots: a, expose: n }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-combobox-input-${Sr()}`, o = Ns("ComboboxInput"), l = N(() => Qa(je(o.inputRef))), u = { value: !1 };
  n({ el: o.inputRef, $el: o.inputRef });
  function d() {
    o.change(null);
    let _ = je(o.optionsRef);
    _ && (_.scrollTop = 0), o.goToOption(Ct.Nothing);
  }
  let f = N(() => {
    var _;
    let x = o.value.value;
    return je(o.inputRef) ? typeof e.displayValue < "u" && x !== void 0 ? (_ = e.displayValue(x)) != null ? _ : "" : typeof x == "string" ? x : "" : "";
  });
  ct(() => {
    He([f, o.comboboxState, l], ([_, x], [w, k]) => {
      if (u.value)
        return;
      let S = je(o.inputRef);
      S && ((k === 0 && x === 1 || _ !== w) && (S.value = _), requestAnimationFrame(() => {
        var P;
        if (u.value || !S || ((P = l.value) == null ? void 0 : P.activeElement) !== S)
          return;
        let { selectionStart: A, selectionEnd: E } = S;
        Math.abs((E ?? 0) - (A ?? 0)) === 0 && A === 0 && S.setSelectionRange(S.value.length, S.value.length);
      }));
    }, { immediate: !0 }), He([o.comboboxState], ([_], [x]) => {
      if (_ === 0 && x === 1) {
        if (u.value)
          return;
        let w = je(o.inputRef);
        if (!w)
          return;
        let k = w.value, { selectionStart: S, selectionEnd: P, selectionDirection: A } = w;
        w.value = "", w.value = k, A !== null ? w.setSelectionRange(S, P, A) : w.setSelectionRange(S, P);
      }
    });
  });
  let c = ne(!1);
  function p() {
    c.value = !0;
  }
  function v() {
    Ps().nextFrame(() => {
      c.value = !1;
    });
  }
  function h(_) {
    switch (u.value = !0, _.key) {
      case lt.Enter:
        if (u.value = !1, o.comboboxState.value !== 0 || c.value)
          return;
        if (_.preventDefault(), _.stopPropagation(), o.activeOptionIndex.value === null) {
          o.closeCombobox();
          return;
        }
        o.selectActiveOption(), o.mode.value === 0 && o.closeCombobox();
        break;
      case lt.ArrowDown:
        return u.value = !1, _.preventDefault(), _.stopPropagation(), or(o.comboboxState.value, { 0: () => o.goToOption(Ct.Next), 1: () => o.openCombobox() });
      case lt.ArrowUp:
        return u.value = !1, _.preventDefault(), _.stopPropagation(), or(o.comboboxState.value, { 0: () => o.goToOption(Ct.Previous), 1: () => {
          o.openCombobox(), Pt(() => {
            o.value.value || o.goToOption(Ct.Last);
          });
        } });
      case lt.Home:
        if (_.shiftKey)
          break;
        return u.value = !1, _.preventDefault(), _.stopPropagation(), o.goToOption(Ct.First);
      case lt.PageUp:
        return u.value = !1, _.preventDefault(), _.stopPropagation(), o.goToOption(Ct.First);
      case lt.End:
        if (_.shiftKey)
          break;
        return u.value = !1, _.preventDefault(), _.stopPropagation(), o.goToOption(Ct.Last);
      case lt.PageDown:
        return u.value = !1, _.preventDefault(), _.stopPropagation(), o.goToOption(Ct.Last);
      case lt.Escape:
        if (u.value = !1, o.comboboxState.value !== 0)
          return;
        _.preventDefault(), o.optionsRef.value && !o.optionsPropsRef.value.static && _.stopPropagation(), o.nullable.value && o.mode.value === 0 && o.value.value === null && d(), o.closeCombobox();
        break;
      case lt.Tab:
        if (u.value = !1, o.comboboxState.value !== 0)
          return;
        o.mode.value === 0 && o.activationTrigger.value !== 1 && o.selectActiveOption(), o.closeCombobox();
        break;
    }
  }
  function g(_) {
    t("change", _), o.nullable.value && o.mode.value === 0 && _.target.value === "" && d(), o.openCombobox();
  }
  function m(_) {
    var x, w, k;
    let S = (x = _.relatedTarget) != null ? x : xi.find((P) => P !== _.currentTarget);
    if (u.value = !1, !((w = je(o.optionsRef)) != null && w.contains(S)) && !((k = je(o.buttonRef)) != null && k.contains(S)) && o.comboboxState.value === 0)
      return _.preventDefault(), o.mode.value === 0 && (o.nullable.value && o.value.value === null ? d() : o.activationTrigger.value !== 1 && o.selectActiveOption()), o.closeCombobox();
  }
  function b(_) {
    var x, w, k;
    let S = (x = _.relatedTarget) != null ? x : xi.find((P) => P !== _.currentTarget);
    (w = je(o.buttonRef)) != null && w.contains(S) || (k = je(o.optionsRef)) != null && k.contains(S) || o.disabled.value || o.immediate.value && o.comboboxState.value !== 0 && (o.openCombobox(), Ps().nextFrame(() => {
      o.setActivationTrigger(1);
    }));
  }
  let y = N(() => {
    var _, x, w, k;
    return (k = (w = (x = e.defaultValue) != null ? x : o.defaultValue.value !== void 0 ? (_ = e.displayValue) == null ? void 0 : _.call(e, o.defaultValue.value) : null) != null ? w : o.defaultValue.value) != null ? k : "";
  });
  return () => {
    var _, x, w, k, S, P, A;
    let E = { open: o.comboboxState.value === 0 }, { displayValue: O, onChange: T, ...D } = e, $ = { "aria-controls": (_ = o.optionsRef.value) == null ? void 0 : _.id, "aria-expanded": o.comboboxState.value === 0, "aria-activedescendant": o.activeOptionIndex.value === null ? void 0 : o.virtual.value ? (x = o.options.value.find((I) => !o.virtual.value.disabled(I.dataRef.value) && o.compare(I.dataRef.value, o.virtual.value.options[o.activeOptionIndex.value]))) == null ? void 0 : x.id : (w = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : w.id, "aria-labelledby": (P = (k = je(o.labelRef)) == null ? void 0 : k.id) != null ? P : (S = je(o.buttonRef)) == null ? void 0 : S.id, "aria-autocomplete": "list", id: s, onCompositionstart: p, onCompositionend: v, onKeydown: h, onInput: g, onFocus: b, onBlur: m, role: "combobox", type: (A = r.type) != null ? A : "text", tabIndex: 0, ref: o.inputRef, defaultValue: y.value, disabled: o.disabled.value === !0 ? !0 : void 0 };
    return $t({ ourProps: $, theirProps: D, slot: E, attrs: r, slots: a, features: Ha.RenderStrategy | Ha.Static, name: "ComboboxInput" });
  };
} }), sS = Ae({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: t, slots: r, expose: a }) {
  let n = Ns("ComboboxOptions"), i = `headlessui-combobox-options-${Sr()}`;
  a({ el: n.optionsRef, $el: n.optionsRef }), Nr(() => {
    n.optionsPropsRef.value.static = e.static;
  }), Nr(() => {
    n.optionsPropsRef.value.hold = e.hold;
  });
  let s = ko(), o = N(() => s !== null ? (s.value & wr.Open) === wr.Open : n.comboboxState.value === 0);
  return K1({ container: N(() => je(n.optionsRef)), enabled: N(() => n.comboboxState.value === 0), accept(l) {
    return l.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : l.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(l) {
    l.setAttribute("role", "none");
  } }), () => {
    var l, u, d;
    let f = { open: n.comboboxState.value === 0 }, c = { "aria-labelledby": (d = (l = je(n.labelRef)) == null ? void 0 : l.id) != null ? d : (u = je(n.buttonRef)) == null ? void 0 : u.id, id: i, ref: n.optionsRef, role: "listbox", "aria-multiselectable": n.mode.value === 1 ? !0 : void 0 }, p = Ni(e, ["hold"]);
    return $t({ ourProps: c, theirProps: p, slot: f, attrs: t, slots: n.virtual.value && n.comboboxState.value === 0 ? { ...r, default: () => [Ht(nA, {}, r.default)] } : r, features: Ha.RenderStrategy | Ha.Static, visible: o.value, name: "ComboboxOptions" });
  };
} }), yd = Ae({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(e, { slots: t, attrs: r, expose: a }) {
  let n = Ns("ComboboxOption"), i = `headlessui-combobox-option-${Sr()}`, s = ne(null);
  a({ el: s, $el: s });
  let o = N(() => {
    var m;
    return n.virtual.value ? n.activeOptionIndex.value === n.calculateIndex(e.value) : n.activeOptionIndex.value === null ? !1 : ((m = n.options.value[n.activeOptionIndex.value]) == null ? void 0 : m.id) === i;
  }), l = N(() => n.isSelected(e.value)), u = sr(nS, null), d = N(() => ({ disabled: e.disabled, value: e.value, domRef: s, order: N(() => e.order) }));
  ct(() => n.registerOption(i, d)), Tr(() => n.unregisterOption(i, o.value)), Nr(() => {
    let m = je(s);
    m && (u == null || u.value.measureElement(m));
  }), Nr(() => {
    n.comboboxState.value === 0 && o.value && (n.virtual.value || n.activationTrigger.value !== 0 && Pt(() => {
      var m, b;
      return (b = (m = je(s)) == null ? void 0 : m.scrollIntoView) == null ? void 0 : b.call(m, { block: "nearest" });
    }));
  });
  function f(m) {
    var b;
    if (e.disabled || (b = n.virtual.value) != null && b.disabled(e.value))
      return m.preventDefault();
    n.selectOption(i), XT() || requestAnimationFrame(() => {
      var y;
      return (y = je(n.inputRef)) == null ? void 0 : y.focus({ preventScroll: !0 });
    }), n.mode.value === 0 && requestAnimationFrame(() => n.closeCombobox());
  }
  function c() {
    var m;
    if (e.disabled || (m = n.virtual.value) != null && m.disabled(e.value))
      return n.goToOption(Ct.Nothing);
    let b = n.calculateIndex(e.value);
    n.goToOption(Ct.Specific, b);
  }
  let p = X1();
  function v(m) {
    p.update(m);
  }
  function h(m) {
    var b;
    if (!p.wasMoved(m) || e.disabled || (b = n.virtual.value) != null && b.disabled(e.value) || o.value)
      return;
    let y = n.calculateIndex(e.value);
    n.goToOption(Ct.Specific, y, 0);
  }
  function g(m) {
    var b;
    p.wasMoved(m) && (e.disabled || (b = n.virtual.value) != null && b.disabled(e.value) || o.value && (n.optionsPropsRef.value.hold || n.goToOption(Ct.Nothing)));
  }
  return () => {
    let { disabled: m } = e, b = { active: o.value, selected: l.value, disabled: m }, y = { id: i, ref: s, role: "option", tabIndex: m === !0 ? void 0 : -1, "aria-disabled": m === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onClick: f, onFocus: c, onPointerenter: v, onMouseenter: v, onPointermove: h, onMousemove: h, onPointerleave: g, onMouseleave: g }, _ = Ni(e, ["order", "value"]);
    return $t({ ourProps: y, theirProps: _, slot: b, attrs: r, slots: t, name: "ComboboxOption" });
  };
} });
function oS(e, t, r, a) {
  vu.isServer || Nr((n) => {
    e = e ?? window, e.addEventListener(t, r, a), n(() => e.removeEventListener(t, r, a));
  });
}
var Cl = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Cl || {});
function oA() {
  let e = ne(0);
  return KT("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function lS(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.value) {
    let a = je(r);
    a instanceof HTMLElement && t.add(a);
  }
  return t;
}
var uS = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(uS || {});
let fl = Object.assign(Ae({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: ne(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: a }) {
  let n = ne(null);
  a({ el: n, $el: n });
  let i = N(() => Qa(n)), s = ne(!1);
  ct(() => s.value = !0), Tr(() => s.value = !1), uA({ ownerDocument: i }, N(() => s.value && !!(e.features & 16)));
  let o = dA({ ownerDocument: i, container: n, initialFocus: N(() => e.initialFocus) }, N(() => s.value && !!(e.features & 2)));
  cA({ ownerDocument: i, container: n, containers: e.containers, previousActiveElement: o }, N(() => s.value && !!(e.features & 8)));
  let l = oA();
  function u(p) {
    let v = je(n);
    v && ((h) => h())(() => {
      or(l.value, { [Cl.Forwards]: () => {
        Xa(v, Cr.First, { skipElements: [p.relatedTarget] });
      }, [Cl.Backwards]: () => {
        Xa(v, Cr.Last, { skipElements: [p.relatedTarget] });
      } });
    });
  }
  let d = ne(!1);
  function f(p) {
    p.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function c(p) {
    if (!s.value)
      return;
    let v = lS(e.containers);
    je(n) instanceof HTMLElement && v.add(je(n));
    let h = p.relatedTarget;
    h instanceof HTMLElement && h.dataset.headlessuiFocusGuard !== "true" && (dS(v, h) || (d.value ? Xa(je(n), or(l.value, { [Cl.Forwards]: () => Cr.Next, [Cl.Backwards]: () => Cr.Previous }) | Cr.WrapAround, { relativeTo: p.target }) : p.target instanceof HTMLElement && Ki(p.target)));
  }
  return () => {
    let p = {}, v = { ref: n, onKeydown: f, onFocusout: c }, { features: h, initialFocus: g, containers: m, ...b } = e;
    return Ht(Qe, [!!(h & 4) && Ht(Ei, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: Si.Focusable }), $t({ ourProps: v, theirProps: { ...t, ...b }, slot: p, attrs: t, slots: r, name: "FocusTrap" }), !!(h & 4) && Ht(Ei, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: Si.Focusable })]);
  };
} }), { features: uS });
function lA(e) {
  let t = ne(xi.slice());
  return He([e], ([r], [a]) => {
    a === !0 && r === !1 ? Wd(() => {
      t.value.splice(0);
    }) : a === !1 && r === !0 && (t.value = xi.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = t.value.find((a) => a != null && a.isConnected)) != null ? r : null;
  };
}
function uA({ ownerDocument: e }, t) {
  let r = lA(t);
  ct(() => {
    Nr(() => {
      var a, n;
      t.value || ((a = e.value) == null ? void 0 : a.activeElement) === ((n = e.value) == null ? void 0 : n.body) && Ki(r());
    }, { flush: "post" });
  }), Tr(() => {
    t.value && Ki(r());
  });
}
function dA({ ownerDocument: e, container: t, initialFocus: r }, a) {
  let n = ne(null), i = ne(!1);
  return ct(() => i.value = !0), Tr(() => i.value = !1), ct(() => {
    He([t, r, a], (s, o) => {
      if (s.every((u, d) => (o == null ? void 0 : o[d]) === u) || !a.value)
        return;
      let l = je(t);
      l && Wd(() => {
        var u, d;
        if (!i.value)
          return;
        let f = je(r), c = (u = e.value) == null ? void 0 : u.activeElement;
        if (f) {
          if (f === c) {
            n.value = c;
            return;
          }
        } else if (l.contains(c)) {
          n.value = c;
          return;
        }
        f ? Ki(f) : Xa(l, Cr.First | Cr.NoScroll) === zi.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), n.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), n;
}
function cA({ ownerDocument: e, container: t, containers: r, previousActiveElement: a }, n) {
  var i;
  oS((i = e.value) == null ? void 0 : i.defaultView, "focus", (s) => {
    if (!n.value)
      return;
    let o = lS(r);
    je(t) instanceof HTMLElement && o.add(je(t));
    let l = a.value;
    if (!l)
      return;
    let u = s.target;
    u && u instanceof HTMLElement ? dS(o, u) ? (a.value = u, Ki(u)) : (s.preventDefault(), s.stopPropagation(), Ki(l)) : Ki(a.value);
  }, !0);
}
function dS(e, t) {
  for (let r of e)
    if (r.contains(t))
      return !0;
  return !1;
}
function fA(e) {
  let t = ir(e.getSnapshot());
  return Tr(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function pA(e, t) {
  let r = e(), a = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(n) {
    return a.add(n), () => a.delete(n);
  }, dispatch(n, ...i) {
    let s = t[n].call(r, ...i);
    s && (r = s, a.forEach((o) => o()));
  } };
}
function vA() {
  let e;
  return { before({ doc: t }) {
    var r;
    let a = t.documentElement;
    e = ((r = t.defaultView) != null ? r : window).innerWidth - a.clientWidth;
  }, after({ doc: t, d: r }) {
    let a = t.documentElement, n = a.clientWidth - a.offsetWidth, i = e - n;
    r.style(a, "paddingRight", `${i}px`);
  } };
}
function mA() {
  return GT() ? { before({ doc: e, d: t, meta: r }) {
    function a(n) {
      return r.containers.flatMap((i) => i()).some((i) => i.contains(n));
    }
    t.microTask(() => {
      var n;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let o = Ps();
        o.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => o.dispose()));
      }
      let i = (n = window.scrollY) != null ? n : window.pageYOffset, s = null;
      t.addEventListener(e, "click", (o) => {
        if (o.target instanceof HTMLElement)
          try {
            let l = o.target.closest("a");
            if (!l)
              return;
            let { hash: u } = new URL(l.href), d = e.querySelector(u);
            d && !a(d) && (s = d);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (o) => {
        if (o.target instanceof HTMLElement)
          if (a(o.target)) {
            let l = o.target;
            for (; l.parentElement && a(l.parentElement); )
              l = l.parentElement;
            t.style(l, "overscrollBehavior", "contain");
          } else
            t.style(o.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (o) => {
        if (o.target instanceof HTMLElement)
          if (a(o.target)) {
            let l = o.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); )
              l = l.parentElement;
            l.dataset.headlessuiPortal === "" && o.preventDefault();
          } else
            o.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var o;
        let l = (o = window.scrollY) != null ? o : window.pageYOffset;
        i !== l && window.scrollTo(0, i), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function hA() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function gA(e) {
  let t = {};
  for (let r of e)
    Object.assign(t, r(t));
  return t;
}
let Ts = pA(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let a = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: Ps(), meta: /* @__PURE__ */ new Set() };
  return a.count++, a.meta.add(t), this.set(e, a), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let a = { doc: e, d: t, meta: gA(r) }, n = [mA(), vA(), hA()];
  n.forEach(({ before: i }) => i == null ? void 0 : i(a)), n.forEach(({ after: i }) => i == null ? void 0 : i(a));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Ts.subscribe(() => {
  let e = Ts.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e)
    t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let a = t.get(r.doc) === "hidden", n = r.count !== 0;
    (n && !a || !n && a) && Ts.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Ts.dispatch("TEARDOWN", r);
  }
});
function bA(e, t, r) {
  let a = fA(Ts), n = N(() => {
    let i = e.value ? a.value.get(e.value) : void 0;
    return i ? i.count > 0 : !1;
  });
  return He([e, t], ([i, s], [o], l) => {
    if (!i || !s)
      return;
    Ts.dispatch("PUSH", i, r);
    let u = !1;
    l(() => {
      u || (Ts.dispatch("POP", o ?? i, r), u = !0);
    });
  }, { immediate: !0 }), n;
}
let xf = /* @__PURE__ */ new Map(), pl = /* @__PURE__ */ new Map();
function g_(e, t = ne(!0)) {
  Nr((r) => {
    var a;
    if (!t.value)
      return;
    let n = je(e);
    if (!n)
      return;
    r(function() {
      var s;
      if (!n)
        return;
      let o = (s = pl.get(n)) != null ? s : 1;
      if (o === 1 ? pl.delete(n) : pl.set(n, o - 1), o !== 1)
        return;
      let l = xf.get(n);
      l && (l["aria-hidden"] === null ? n.removeAttribute("aria-hidden") : n.setAttribute("aria-hidden", l["aria-hidden"]), n.inert = l.inert, xf.delete(n));
    });
    let i = (a = pl.get(n)) != null ? a : 0;
    pl.set(n, i + 1), i === 0 && (xf.set(n, { "aria-hidden": n.getAttribute("aria-hidden"), inert: n.inert }), n.setAttribute("aria-hidden", "true"), n.inert = !0);
  });
}
function yA({ defaultContainers: e = [], portals: t, mainTreeNodeRef: r } = {}) {
  let a = ne(null), n = Qa(a);
  function i() {
    var s, o, l;
    let u = [];
    for (let d of e)
      d !== null && (d instanceof HTMLElement ? u.push(d) : "value" in d && d.value instanceof HTMLElement && u.push(d.value));
    if (t != null && t.value)
      for (let d of t.value)
        u.push(d);
    for (let d of (s = n == null ? void 0 : n.querySelectorAll("html > *, body > *")) != null ? s : [])
      d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(je(a)) || d.contains((l = (o = je(a)) == null ? void 0 : o.getRootNode()) == null ? void 0 : l.host) || u.some((f) => d.contains(f)) || u.push(d));
    return u;
  }
  return { resolveContainers: i, contains(s) {
    return i().some((o) => o.contains(s));
  }, mainTreeNodeRef: a, MainTreeNode() {
    return r != null ? null : Ht(Ei, { features: Si.Hidden, ref: a });
  } };
}
let cS = Symbol("ForcePortalRootContext");
function _A() {
  return sr(cS, !1);
}
let Ip = Ae({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: r }) {
  return Mr(cS, e.force), () => {
    let { force: a, ...n } = e;
    return $t({ theirProps: n, ourProps: {}, slot: {}, slots: t, attrs: r, name: "ForcePortalRoot" });
  };
} }), fS = Symbol("StackContext");
var Np = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Np || {});
function xA() {
  return sr(fS, () => {
  });
}
function wA({ type: e, enabled: t, element: r, onUpdate: a }) {
  let n = xA();
  function i(...s) {
    a == null || a(...s), n(...s);
  }
  ct(() => {
    He(t, (s, o) => {
      s ? i(0, e, r) : o === !0 && i(1, e, r);
    }, { immediate: !0, flush: "sync" });
  }), Tr(() => {
    t.value && i(1, e, r);
  }), Mr(fS, i);
}
let pS = Symbol("DescriptionContext");
function TA() {
  let e = sr(pS, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function Xd({ slot: e = ne({}), name: t = "Description", props: r = {} } = {}) {
  let a = ne([]);
  function n(i) {
    return a.value.push(i), () => {
      let s = a.value.indexOf(i);
      s !== -1 && a.value.splice(s, 1);
    };
  }
  return Mr(pS, { register: n, slot: e, name: t, props: r }), N(() => a.value.length > 0 ? a.value.join(" ") : void 0);
}
let SA = Ae({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-description-${Sr()}`, i = TA();
  return ct(() => Tr(i.register(n))), () => {
    let { name: s = "Description", slot: o = ne({}), props: l = {} } = i, { ...u } = e, d = { ...Object.entries(l).reduce((f, [c, p]) => Object.assign(f, { [c]: U(p) }), {}), id: n };
    return $t({ ourProps: d, theirProps: u, slot: o.value, attrs: t, slots: r, name: s });
  };
} });
function EA(e) {
  let t = Qa(e);
  if (!t) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let r = t.getElementById("headlessui-portal-root");
  if (r)
    return r;
  let a = t.createElement("div");
  return a.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(a);
}
let vS = Ae({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let a = ne(null), n = N(() => Qa(a)), i = _A(), s = sr(mS, null), o = ne(i === !0 || s == null ? EA(a.value) : s.resolveTarget()), l = ne(!1);
  ct(() => {
    l.value = !0;
  }), Nr(() => {
    i || s != null && (o.value = s.resolveTarget());
  });
  let u = sr($p, null), d = !1, f = Mi();
  return He(a, () => {
    if (d || !u)
      return;
    let c = je(a);
    c && (Tr(u.register(c), f), d = !0);
  }), Tr(() => {
    var c, p;
    let v = (c = n.value) == null ? void 0 : c.getElementById("headlessui-portal-root");
    v && o.value === v && o.value.children.length <= 0 && ((p = o.value.parentElement) == null || p.removeChild(o.value));
  }), () => {
    if (!l.value || o.value === null)
      return null;
    let c = { ref: a, "data-headlessui-portal": "" };
    return Ht(Oo, { to: o.value }, $t({ ourProps: c, theirProps: e, slot: {}, attrs: r, slots: t, name: "Portal" }));
  };
} }), $p = Symbol("PortalParentContext");
function OA() {
  let e = sr($p, null), t = ne([]);
  function r(i) {
    return t.value.push(i), e && e.register(i), () => a(i);
  }
  function a(i) {
    let s = t.value.indexOf(i);
    s !== -1 && t.value.splice(s, 1), e && e.unregister(i);
  }
  let n = { register: r, unregister: a, portals: t };
  return [t, Ae({ name: "PortalWrapper", setup(i, { slots: s }) {
    return Mr($p, n), () => {
      var o;
      return (o = s.default) == null ? void 0 : o.call(s);
    };
  } })];
}
let mS = Symbol("PortalGroupContext"), CA = Ae({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: r }) {
  let a = Sn({ resolveTarget() {
    return e.target;
  } });
  return Mr(mS, a), () => {
    let { target: n, ...i } = e;
    return $t({ theirProps: i, ourProps: {}, slot: {}, attrs: t, slots: r, name: "PortalGroup" });
  };
} });
var kA = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(kA || {});
let Lp = Symbol("DialogContext");
function hu(e) {
  let t = sr(Lp, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, hu), r;
  }
  return t;
}
let qu = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", J1 = Ae({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: qu }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: r, slots: a, expose: n }) {
  var i, s;
  let o = (i = e.id) != null ? i : `headlessui-dialog-${Sr()}`, l = ne(!1);
  ct(() => {
    l.value = !0;
  });
  let u = !1, d = N(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), f = ne(0), c = ko(), p = N(() => e.open === qu && c !== null ? (c.value & wr.Open) === wr.Open : e.open), v = ne(null), h = N(() => Qa(v));
  if (n({ el: v, $el: v }), !(e.open !== qu || c !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof p.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${p.value === qu ? void 0 : e.open}`);
  let g = N(() => l.value && p.value ? 0 : 1), m = N(() => g.value === 0), b = N(() => f.value > 1), y = sr(Lp, null) !== null, [_, x] = OA(), { resolveContainers: w, mainTreeNodeRef: k, MainTreeNode: S } = yA({ portals: _, defaultContainers: [N(() => {
    var le;
    return (le = F.panelRef.value) != null ? le : v.value;
  })] }), P = N(() => b.value ? "parent" : "leaf"), A = N(() => c !== null ? (c.value & wr.Closing) === wr.Closing : !1), E = N(() => y || A.value ? !1 : m.value), O = N(() => {
    var le, Z, G;
    return (G = Array.from((Z = (le = h.value) == null ? void 0 : le.querySelectorAll("body > *")) != null ? Z : []).find((H) => H.id === "headlessui-portal-root" ? !1 : H.contains(je(k)) && H instanceof HTMLElement)) != null ? G : null;
  });
  g_(O, E);
  let T = N(() => b.value ? !0 : m.value), D = N(() => {
    var le, Z, G;
    return (G = Array.from((Z = (le = h.value) == null ? void 0 : le.querySelectorAll("[data-headlessui-portal]")) != null ? Z : []).find((H) => H.contains(je(k)) && H instanceof HTMLElement)) != null ? G : null;
  });
  g_(D, T), wA({ type: "Dialog", enabled: N(() => g.value === 0), element: v, onUpdate: (le, Z) => {
    if (Z === "Dialog")
      return or(le, { [Np.Add]: () => f.value += 1, [Np.Remove]: () => f.value -= 1 });
  } });
  let $ = Xd({ name: "DialogDescription", slot: N(() => ({ open: p.value })) }), I = ne(null), F = { titleId: I, panelRef: ne(null), dialogState: g, setTitleId(le) {
    I.value !== le && (I.value = le);
  }, close() {
    t("close", !1);
  } };
  Mr(Lp, F);
  let j = N(() => !(!m.value || b.value));
  Ud(w, (le, Z) => {
    F.close(), Pt(() => Z == null ? void 0 : Z.focus());
  }, j);
  let M = N(() => !(b.value || g.value !== 0));
  oS((s = h.value) == null ? void 0 : s.defaultView, "keydown", (le) => {
    M.value && (le.defaultPrevented || le.key === lt.Escape && (le.preventDefault(), le.stopPropagation(), F.close()));
  });
  let q = N(() => !(A.value || g.value !== 0 || y));
  return bA(h, q, (le) => {
    var Z;
    return { containers: [...(Z = le.containers) != null ? Z : [], w] };
  }), Nr((le) => {
    if (g.value !== 0)
      return;
    let Z = je(v);
    if (!Z)
      return;
    let G = new ResizeObserver((H) => {
      for (let W of H) {
        let ie = W.target.getBoundingClientRect();
        ie.x === 0 && ie.y === 0 && ie.width === 0 && ie.height === 0 && F.close();
      }
    });
    G.observe(Z), le(() => G.disconnect());
  }), () => {
    let { open: le, initialFocus: Z, ...G } = e, H = { ...r, ref: v, id: o, role: d.value, "aria-modal": g.value === 0 ? !0 : void 0, "aria-labelledby": I.value, "aria-describedby": $.value }, W = { open: g.value === 0 };
    return Ht(Ip, { force: !0 }, () => [Ht(vS, () => Ht(CA, { target: v.value }, () => Ht(Ip, { force: !1 }, () => Ht(fl, { initialFocus: Z, containers: w, features: m.value ? or(P.value, { parent: fl.features.RestoreFocus, leaf: fl.features.All & ~fl.features.FocusLock }) : fl.features.None }, () => Ht(x, {}, () => $t({ ourProps: H, theirProps: { ...G, ...r }, slot: W, attrs: r, slots: a, visible: g.value === 0, features: Ha.RenderStrategy | Ha.Static, name: "Dialog" })))))), Ht(S)]);
  };
} });
Ae({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-dialog-overlay-${Sr()}`, i = hu("DialogOverlay");
  function s(o) {
    o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), i.close());
  }
  return () => {
    let { ...o } = e;
    return $t({ ourProps: { id: n, "aria-hidden": !0, onClick: s }, theirProps: o, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogOverlay" });
  };
} });
Ae({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-dialog-backdrop-${Sr()}`, s = hu("DialogBackdrop"), o = ne(null);
  return a({ el: o, $el: o }), ct(() => {
    if (s.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...l } = e, u = { id: i, ref: o, "aria-hidden": !0 };
    return Ht(Ip, { force: !0 }, () => Ht(vS, () => $t({ ourProps: u, theirProps: { ...t, ...l }, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogBackdrop" })));
  };
} });
let Q1 = Ae({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-dialog-panel-${Sr()}`, s = hu("DialogPanel");
  a({ el: s.panelRef, $el: s.panelRef });
  function o(l) {
    l.stopPropagation();
  }
  return () => {
    let { ...l } = e, u = { id: i, ref: s.panelRef, onClick: o };
    return $t({ ourProps: u, theirProps: l, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogPanel" });
  };
} }), hS = Ae({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-dialog-title-${Sr()}`, i = hu("DialogTitle");
  return ct(() => {
    i.setTitleId(n), Tr(() => i.setTitleId(null));
  }), () => {
    let { ...s } = e;
    return $t({ ourProps: { id: n }, theirProps: s, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogTitle" });
  };
} }), PA = SA, b_ = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function y_(e) {
  var t, r;
  let a = (t = e.innerText) != null ? t : "", n = e.cloneNode(!0);
  if (!(n instanceof HTMLElement))
    return a;
  let i = !1;
  for (let o of n.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    o.remove(), i = !0;
  let s = i ? (r = n.innerText) != null ? r : "" : a;
  return b_.test(s) && (s = s.replace(b_, "")), s;
}
function MA(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let a = r.split(" ").map((n) => {
      let i = document.getElementById(n);
      if (i) {
        let s = i.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : y_(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (a.length > 0)
      return a.join(", ");
  }
  return y_(e).trim();
}
function gS(e) {
  let t = ne(""), r = ne("");
  return () => {
    let a = je(e);
    if (!a)
      return "";
    let n = a.innerText;
    if (t.value === n)
      return r.value;
    let i = MA(a).trim().toLowerCase();
    return t.value = n, r.value = i, i;
  };
}
function AA(e, t) {
  return e === t;
}
var DA = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(DA || {}), IA = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(IA || {}), NA = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(NA || {});
function $A(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let bS = Symbol("ListboxContext");
function gu(e) {
  let t = sr(bS, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, gu), r;
  }
  return t;
}
let LA = Ae({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => AA }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: r, emit: a }) {
  let n = ne(1), i = ne(null), s = ne(null), o = ne(null), l = ne([]), u = ne(""), d = ne(null), f = ne(1);
  function c(y = (_) => _) {
    let _ = d.value !== null ? l.value[d.value] : null, x = ai(y(l.value.slice()), (k) => je(k.dataRef.domRef)), w = _ ? x.indexOf(_) : null;
    return w === -1 && (w = null), { options: x, activeOptionIndex: w };
  }
  let p = N(() => e.multiple ? 1 : 0), [v, h] = qd(N(() => e.modelValue), (y) => a("update:modelValue", y), N(() => e.defaultValue)), g = N(() => v.value === void 0 ? or(p.value, { 1: [], 0: void 0 }) : v.value), m = { listboxState: n, value: g, mode: p, compare(y, _) {
    if (typeof e.by == "string") {
      let x = e.by;
      return (y == null ? void 0 : y[x]) === (_ == null ? void 0 : _[x]);
    }
    return e.by(y, _);
  }, orientation: N(() => e.horizontal ? "horizontal" : "vertical"), labelRef: i, buttonRef: s, optionsRef: o, disabled: N(() => e.disabled), options: l, searchQuery: u, activeOptionIndex: d, activationTrigger: f, closeListbox() {
    e.disabled || n.value !== 1 && (n.value = 1, d.value = null);
  }, openListbox() {
    e.disabled || n.value !== 0 && (n.value = 0);
  }, goToOption(y, _, x) {
    if (e.disabled || n.value === 1)
      return;
    let w = c(), k = bd(y === Ct.Specific ? { focus: Ct.Specific, id: _ } : { focus: y }, { resolveItems: () => w.options, resolveActiveIndex: () => w.activeOptionIndex, resolveId: (S) => S.id, resolveDisabled: (S) => S.dataRef.disabled });
    u.value = "", d.value = k, f.value = x ?? 1, l.value = w.options;
  }, search(y) {
    if (e.disabled || n.value === 1)
      return;
    let _ = u.value !== "" ? 0 : 1;
    u.value += y.toLowerCase();
    let x = (d.value !== null ? l.value.slice(d.value + _).concat(l.value.slice(0, d.value + _)) : l.value).find((k) => k.dataRef.textValue.startsWith(u.value) && !k.dataRef.disabled), w = x ? l.value.indexOf(x) : -1;
    w === -1 || w === d.value || (d.value = w, f.value = 1);
  }, clearSearch() {
    e.disabled || n.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption(y, _) {
    let x = c((w) => [...w, { id: y, dataRef: _ }]);
    l.value = x.options, d.value = x.activeOptionIndex;
  }, unregisterOption(y) {
    let _ = c((x) => {
      let w = x.findIndex((k) => k.id === y);
      return w !== -1 && x.splice(w, 1), x;
    });
    l.value = _.options, d.value = _.activeOptionIndex, f.value = 1;
  }, theirOnChange(y) {
    e.disabled || h(y);
  }, select(y) {
    e.disabled || h(or(p.value, { 0: () => y, 1: () => {
      let _ = fr(m.value.value).slice(), x = fr(y), w = _.findIndex((k) => m.compare(x, fr(k)));
      return w === -1 ? _.push(x) : _.splice(w, 1), _;
    } }));
  } };
  Ud([s, o], (y, _) => {
    var x;
    m.closeListbox(), Vd(_, Hd.Loose) || (y.preventDefault(), (x = je(s)) == null || x.focus());
  }, N(() => n.value === 0)), Mr(bS, m), Yd(N(() => or(n.value, { 0: wr.Open, 1: wr.Closed })));
  let b = N(() => {
    var y;
    return (y = je(s)) == null ? void 0 : y.closest("form");
  });
  return ct(() => {
    He([b], () => {
      if (!b.value || e.defaultValue === void 0)
        return;
      function y() {
        m.theirOnChange(e.defaultValue);
      }
      return b.value.addEventListener("reset", y), () => {
        var _;
        (_ = b.value) == null || _.removeEventListener("reset", y);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: y, modelValue: _, disabled: x, form: w, ...k } = e, S = { open: n.value === 0, disabled: x, value: g.value };
    return Ht(Qe, [...y != null && g.value != null ? Gd({ [y]: g.value }).map(([P, A]) => Ht(Ei, zd({ features: Si.Hidden, key: P, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: w, name: P, value: A }))) : [], $t({ ourProps: {}, theirProps: { ...r, ...Ni(k, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: S, slots: t, attrs: r, name: "Listbox" })]);
  };
} });
Ae({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-listbox-label-${Sr()}`, i = gu("ListboxLabel");
  function s() {
    var o;
    (o = je(i.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: i.listboxState.value === 0, disabled: i.disabled.value }, { ...l } = e, u = { id: n, ref: i.labelRef, onClick: s };
    return $t({ ourProps: u, theirProps: l, slot: o, attrs: t, slots: r, name: "ListboxLabel" });
  };
} });
let Hu = Ae({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-listbox-button-${Sr()}`, s = gu("ListboxButton");
  a({ el: s.buttonRef, $el: s.buttonRef });
  function o(f) {
    switch (f.key) {
      case lt.Space:
      case lt.Enter:
      case lt.ArrowDown:
        f.preventDefault(), s.openListbox(), Pt(() => {
          var c;
          (c = je(s.optionsRef)) == null || c.focus({ preventScroll: !0 }), s.value.value || s.goToOption(Ct.First);
        });
        break;
      case lt.ArrowUp:
        f.preventDefault(), s.openListbox(), Pt(() => {
          var c;
          (c = je(s.optionsRef)) == null || c.focus({ preventScroll: !0 }), s.value.value || s.goToOption(Ct.Last);
        });
        break;
    }
  }
  function l(f) {
    switch (f.key) {
      case lt.Space:
        f.preventDefault();
        break;
    }
  }
  function u(f) {
    s.disabled.value || (s.listboxState.value === 0 ? (s.closeListbox(), Pt(() => {
      var c;
      return (c = je(s.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })) : (f.preventDefault(), s.openListbox(), $A(() => {
      var c;
      return (c = je(s.optionsRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })));
  }
  let d = mu(N(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var f, c;
    let p = { open: s.listboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...v } = e, h = { ref: s.buttonRef, id: i, type: d.value, "aria-haspopup": "listbox", "aria-controls": (f = je(s.optionsRef)) == null ? void 0 : f.id, "aria-expanded": s.listboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(c = je(s.labelRef)) == null ? void 0 : c.id, i].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: l, onClick: u };
    return $t({ ourProps: h, theirProps: v, slot: p, attrs: t, slots: r, name: "ListboxButton" });
  };
} }), __ = Ae({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-listbox-options-${Sr()}`, s = gu("ListboxOptions"), o = ne(null);
  a({ el: s.optionsRef, $el: s.optionsRef });
  function l(f) {
    switch (o.value && clearTimeout(o.value), f.key) {
      case lt.Space:
        if (s.searchQuery.value !== "")
          return f.preventDefault(), f.stopPropagation(), s.search(f.key);
      case lt.Enter:
        if (f.preventDefault(), f.stopPropagation(), s.activeOptionIndex.value !== null) {
          let c = s.options.value[s.activeOptionIndex.value];
          s.select(c.dataRef.value);
        }
        s.mode.value === 0 && (s.closeListbox(), Pt(() => {
          var c;
          return (c = je(s.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
        }));
        break;
      case or(s.orientation.value, { vertical: lt.ArrowDown, horizontal: lt.ArrowRight }):
        return f.preventDefault(), f.stopPropagation(), s.goToOption(Ct.Next);
      case or(s.orientation.value, { vertical: lt.ArrowUp, horizontal: lt.ArrowLeft }):
        return f.preventDefault(), f.stopPropagation(), s.goToOption(Ct.Previous);
      case lt.Home:
      case lt.PageUp:
        return f.preventDefault(), f.stopPropagation(), s.goToOption(Ct.First);
      case lt.End:
      case lt.PageDown:
        return f.preventDefault(), f.stopPropagation(), s.goToOption(Ct.Last);
      case lt.Escape:
        f.preventDefault(), f.stopPropagation(), s.closeListbox(), Pt(() => {
          var c;
          return (c = je(s.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
        });
        break;
      case lt.Tab:
        f.preventDefault(), f.stopPropagation();
        break;
      default:
        f.key.length === 1 && (s.search(f.key), o.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  let u = ko(), d = N(() => u !== null ? (u.value & wr.Open) === wr.Open : s.listboxState.value === 0);
  return () => {
    var f, c;
    let p = { open: s.listboxState.value === 0 }, { ...v } = e, h = { "aria-activedescendant": s.activeOptionIndex.value === null || (f = s.options.value[s.activeOptionIndex.value]) == null ? void 0 : f.id, "aria-multiselectable": s.mode.value === 1 ? !0 : void 0, "aria-labelledby": (c = je(s.buttonRef)) == null ? void 0 : c.id, "aria-orientation": s.orientation.value, id: i, onKeydown: l, role: "listbox", tabIndex: 0, ref: s.optionsRef };
    return $t({ ourProps: h, theirProps: v, slot: p, attrs: t, slots: r, features: Ha.RenderStrategy | Ha.Static, visible: d.value, name: "ListboxOptions" });
  };
} }), x_ = Ae({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-listbox-option-${Sr()}`, s = gu("ListboxOption"), o = ne(null);
  a({ el: o, $el: o });
  let l = N(() => s.activeOptionIndex.value !== null ? s.options.value[s.activeOptionIndex.value].id === i : !1), u = N(() => or(s.mode.value, { 0: () => s.compare(fr(s.value.value), fr(e.value)), 1: () => fr(s.value.value).some((y) => s.compare(fr(y), fr(e.value))) })), d = N(() => or(s.mode.value, { 1: () => {
    var y;
    let _ = fr(s.value.value);
    return ((y = s.options.value.find((x) => _.some((w) => s.compare(fr(w), fr(x.dataRef.value))))) == null ? void 0 : y.id) === i;
  }, 0: () => u.value })), f = gS(o), c = N(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return f();
  }, domRef: o }));
  ct(() => s.registerOption(i, c)), Tr(() => s.unregisterOption(i)), ct(() => {
    He([s.listboxState, u], () => {
      s.listboxState.value === 0 && u.value && or(s.mode.value, { 1: () => {
        d.value && s.goToOption(Ct.Specific, i);
      }, 0: () => {
        s.goToOption(Ct.Specific, i);
      } });
    }, { immediate: !0 });
  }), Nr(() => {
    s.listboxState.value === 0 && l.value && s.activationTrigger.value !== 0 && Pt(() => {
      var y, _;
      return (_ = (y = je(o)) == null ? void 0 : y.scrollIntoView) == null ? void 0 : _.call(y, { block: "nearest" });
    });
  });
  function p(y) {
    if (e.disabled)
      return y.preventDefault();
    s.select(e.value), s.mode.value === 0 && (s.closeListbox(), Pt(() => {
      var _;
      return (_ = je(s.buttonRef)) == null ? void 0 : _.focus({ preventScroll: !0 });
    }));
  }
  function v() {
    if (e.disabled)
      return s.goToOption(Ct.Nothing);
    s.goToOption(Ct.Specific, i);
  }
  let h = X1();
  function g(y) {
    h.update(y);
  }
  function m(y) {
    h.wasMoved(y) && (e.disabled || l.value || s.goToOption(Ct.Specific, i, 0));
  }
  function b(y) {
    h.wasMoved(y) && (e.disabled || l.value && s.goToOption(Ct.Nothing));
  }
  return () => {
    let { disabled: y } = e, _ = { active: l.value, selected: u.value, disabled: y }, { value: x, disabled: w, ...k } = e, S = { id: i, ref: o, role: "option", tabIndex: y === !0 ? void 0 : -1, "aria-disabled": y === !0 ? !0 : void 0, "aria-selected": u.value, disabled: void 0, onClick: p, onFocus: v, onPointerenter: g, onMouseenter: g, onPointermove: m, onMousemove: m, onPointerleave: b, onMouseleave: b };
    return $t({ ourProps: S, theirProps: k, slot: _, attrs: r, slots: t, name: "ListboxOption" });
  };
} });
var RA = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(RA || {}), jA = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(jA || {});
function FA(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let yS = Symbol("MenuContext");
function Kd(e) {
  let t = sr(yS, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Kd), r;
  }
  return t;
}
let BA = Ae({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: r }) {
  let a = ne(1), n = ne(null), i = ne(null), s = ne([]), o = ne(""), l = ne(null), u = ne(1);
  function d(c = (p) => p) {
    let p = l.value !== null ? s.value[l.value] : null, v = ai(c(s.value.slice()), (g) => je(g.dataRef.domRef)), h = p ? v.indexOf(p) : null;
    return h === -1 && (h = null), { items: v, activeItemIndex: h };
  }
  let f = { menuState: a, buttonRef: n, itemsRef: i, items: s, searchQuery: o, activeItemIndex: l, activationTrigger: u, closeMenu: () => {
    a.value = 1, l.value = null;
  }, openMenu: () => a.value = 0, goToItem(c, p, v) {
    let h = d(), g = bd(c === Ct.Specific ? { focus: Ct.Specific, id: p } : { focus: c }, { resolveItems: () => h.items, resolveActiveIndex: () => h.activeItemIndex, resolveId: (m) => m.id, resolveDisabled: (m) => m.dataRef.disabled });
    o.value = "", l.value = g, u.value = v ?? 1, s.value = h.items;
  }, search(c) {
    let p = o.value !== "" ? 0 : 1;
    o.value += c.toLowerCase();
    let v = (l.value !== null ? s.value.slice(l.value + p).concat(s.value.slice(0, l.value + p)) : s.value).find((g) => g.dataRef.textValue.startsWith(o.value) && !g.dataRef.disabled), h = v ? s.value.indexOf(v) : -1;
    h === -1 || h === l.value || (l.value = h, u.value = 1);
  }, clearSearch() {
    o.value = "";
  }, registerItem(c, p) {
    let v = d((h) => [...h, { id: c, dataRef: p }]);
    s.value = v.items, l.value = v.activeItemIndex, u.value = 1;
  }, unregisterItem(c) {
    let p = d((v) => {
      let h = v.findIndex((g) => g.id === c);
      return h !== -1 && v.splice(h, 1), v;
    });
    s.value = p.items, l.value = p.activeItemIndex, u.value = 1;
  } };
  return Ud([n, i], (c, p) => {
    var v;
    f.closeMenu(), Vd(p, Hd.Loose) || (c.preventDefault(), (v = je(n)) == null || v.focus());
  }, N(() => a.value === 0)), Mr(yS, f), Yd(N(() => or(a.value, { 0: wr.Open, 1: wr.Closed }))), () => {
    let c = { open: a.value === 0, close: f.closeMenu };
    return $t({ ourProps: {}, theirProps: e, slot: c, slots: t, attrs: r, name: "Menu" });
  };
} }), qA = Ae({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-menu-button-${Sr()}`, s = Kd("MenuButton");
  a({ el: s.buttonRef, $el: s.buttonRef });
  function o(f) {
    switch (f.key) {
      case lt.Space:
      case lt.Enter:
      case lt.ArrowDown:
        f.preventDefault(), f.stopPropagation(), s.openMenu(), Pt(() => {
          var c;
          (c = je(s.itemsRef)) == null || c.focus({ preventScroll: !0 }), s.goToItem(Ct.First);
        });
        break;
      case lt.ArrowUp:
        f.preventDefault(), f.stopPropagation(), s.openMenu(), Pt(() => {
          var c;
          (c = je(s.itemsRef)) == null || c.focus({ preventScroll: !0 }), s.goToItem(Ct.Last);
        });
        break;
    }
  }
  function l(f) {
    switch (f.key) {
      case lt.Space:
        f.preventDefault();
        break;
    }
  }
  function u(f) {
    e.disabled || (s.menuState.value === 0 ? (s.closeMenu(), Pt(() => {
      var c;
      return (c = je(s.buttonRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })) : (f.preventDefault(), s.openMenu(), FA(() => {
      var c;
      return (c = je(s.itemsRef)) == null ? void 0 : c.focus({ preventScroll: !0 });
    })));
  }
  let d = mu(N(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var f;
    let c = { open: s.menuState.value === 0 }, { ...p } = e, v = { ref: s.buttonRef, id: i, type: d.value, "aria-haspopup": "menu", "aria-controls": (f = je(s.itemsRef)) == null ? void 0 : f.id, "aria-expanded": s.menuState.value === 0, onKeydown: o, onKeyup: l, onClick: u };
    return $t({ ourProps: v, theirProps: p, slot: c, attrs: t, slots: r, name: "MenuButton" });
  };
} }), HA = Ae({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-menu-items-${Sr()}`, s = Kd("MenuItems"), o = ne(null);
  a({ el: s.itemsRef, $el: s.itemsRef }), K1({ container: N(() => je(s.itemsRef)), enabled: N(() => s.menuState.value === 0), accept(c) {
    return c.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : c.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(c) {
    c.setAttribute("role", "none");
  } });
  function l(c) {
    var p;
    switch (o.value && clearTimeout(o.value), c.key) {
      case lt.Space:
        if (s.searchQuery.value !== "")
          return c.preventDefault(), c.stopPropagation(), s.search(c.key);
      case lt.Enter:
        if (c.preventDefault(), c.stopPropagation(), s.activeItemIndex.value !== null) {
          let v = s.items.value[s.activeItemIndex.value];
          (p = je(v.dataRef.domRef)) == null || p.click();
        }
        s.closeMenu(), WT(je(s.buttonRef));
        break;
      case lt.ArrowDown:
        return c.preventDefault(), c.stopPropagation(), s.goToItem(Ct.Next);
      case lt.ArrowUp:
        return c.preventDefault(), c.stopPropagation(), s.goToItem(Ct.Previous);
      case lt.Home:
      case lt.PageUp:
        return c.preventDefault(), c.stopPropagation(), s.goToItem(Ct.First);
      case lt.End:
      case lt.PageDown:
        return c.preventDefault(), c.stopPropagation(), s.goToItem(Ct.Last);
      case lt.Escape:
        c.preventDefault(), c.stopPropagation(), s.closeMenu(), Pt(() => {
          var v;
          return (v = je(s.buttonRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        break;
      case lt.Tab:
        c.preventDefault(), c.stopPropagation(), s.closeMenu(), Pt(() => GM(je(s.buttonRef), c.shiftKey ? Cr.Previous : Cr.Next));
        break;
      default:
        c.key.length === 1 && (s.search(c.key), o.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  function u(c) {
    switch (c.key) {
      case lt.Space:
        c.preventDefault();
        break;
    }
  }
  let d = ko(), f = N(() => d !== null ? (d.value & wr.Open) === wr.Open : s.menuState.value === 0);
  return () => {
    var c, p;
    let v = { open: s.menuState.value === 0 }, { ...h } = e, g = { "aria-activedescendant": s.activeItemIndex.value === null || (c = s.items.value[s.activeItemIndex.value]) == null ? void 0 : c.id, "aria-labelledby": (p = je(s.buttonRef)) == null ? void 0 : p.id, id: i, onKeydown: l, onKeyup: u, role: "menu", tabIndex: 0, ref: s.itemsRef };
    return $t({ ourProps: g, theirProps: h, slot: v, attrs: t, slots: r, features: Ha.RenderStrategy | Ha.Static, visible: f.value, name: "MenuItems" });
  };
} }), VA = Ae({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-menu-item-${Sr()}`, s = Kd("MenuItem"), o = ne(null);
  a({ el: o, $el: o });
  let l = N(() => s.activeItemIndex.value !== null ? s.items.value[s.activeItemIndex.value].id === i : !1), u = gS(o), d = N(() => ({ disabled: e.disabled, get textValue() {
    return u();
  }, domRef: o }));
  ct(() => s.registerItem(i, d)), Tr(() => s.unregisterItem(i)), Nr(() => {
    s.menuState.value === 0 && l.value && s.activationTrigger.value !== 0 && Pt(() => {
      var m, b;
      return (b = (m = je(o)) == null ? void 0 : m.scrollIntoView) == null ? void 0 : b.call(m, { block: "nearest" });
    });
  });
  function f(m) {
    if (e.disabled)
      return m.preventDefault();
    s.closeMenu(), WT(je(s.buttonRef));
  }
  function c() {
    if (e.disabled)
      return s.goToItem(Ct.Nothing);
    s.goToItem(Ct.Specific, i);
  }
  let p = X1();
  function v(m) {
    p.update(m);
  }
  function h(m) {
    p.wasMoved(m) && (e.disabled || l.value || s.goToItem(Ct.Specific, i, 0));
  }
  function g(m) {
    p.wasMoved(m) && (e.disabled || l.value && s.goToItem(Ct.Nothing));
  }
  return () => {
    let { disabled: m } = e, b = { active: l.value, disabled: m, close: s.closeMenu }, { ...y } = e;
    return $t({ ourProps: { id: i, ref: o, role: "menuitem", tabIndex: m === !0 ? void 0 : -1, "aria-disabled": m === !0 ? !0 : void 0, disabled: void 0, onClick: f, onFocus: c, onPointerenter: v, onMouseenter: v, onPointermove: h, onMousemove: h, onPointerleave: g, onMouseleave: g }, theirProps: { ...r, ...y }, slot: b, attrs: r, slots: t, name: "MenuItem" });
  };
} }), _S = Symbol("LabelContext");
function xS() {
  let e = sr(_S, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, xS), t;
  }
  return e;
}
function Z1({ slot: e = {}, name: t = "Label", props: r = {} } = {}) {
  let a = ne([]);
  function n(i) {
    return a.value.push(i), () => {
      let s = a.value.indexOf(i);
      s !== -1 && a.value.splice(s, 1);
    };
  }
  return Mr(_S, { register: n, slot: e, name: t, props: r }), N(() => a.value.length > 0 ? a.value.join(" ") : void 0);
}
let wS = Ae({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r }) {
  var a;
  let n = (a = e.id) != null ? a : `headlessui-label-${Sr()}`, i = xS();
  return ct(() => Tr(i.register(n))), () => {
    let { name: s = "Label", slot: o = {}, props: l = {} } = i, { passive: u, ...d } = e, f = { ...Object.entries(l).reduce((c, [p, v]) => Object.assign(c, { [p]: U(v) }), {}), id: n };
    return u && (delete f.onClick, delete f.htmlFor, delete d.onClick), $t({ ourProps: f, theirProps: d, slot: o, attrs: r, slots: t, name: s });
  };
} });
function UA(e, t) {
  return e === t;
}
let TS = Symbol("RadioGroupContext");
function SS(e) {
  let t = sr(TS, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, SS), r;
  }
  return t;
}
let ES = Ae({ name: "RadioGroup", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => UA }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: r, slots: a, expose: n }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-radiogroup-${Sr()}`, o = ne(null), l = ne([]), u = Z1({ name: "RadioGroupLabel" }), d = Xd({ name: "RadioGroupDescription" });
  n({ el: o, $el: o });
  let [f, c] = qd(N(() => e.modelValue), (g) => t("update:modelValue", g), N(() => e.defaultValue)), p = { options: l, value: f, disabled: N(() => e.disabled), firstOption: N(() => l.value.find((g) => !g.propsRef.disabled)), containsCheckedOption: N(() => l.value.some((g) => p.compare(fr(g.propsRef.value), fr(e.modelValue)))), compare(g, m) {
    if (typeof e.by == "string") {
      let b = e.by;
      return (g == null ? void 0 : g[b]) === (m == null ? void 0 : m[b]);
    }
    return e.by(g, m);
  }, change(g) {
    var m;
    if (e.disabled || p.compare(fr(f.value), fr(g)))
      return !1;
    let b = (m = l.value.find((y) => p.compare(fr(y.propsRef.value), fr(g)))) == null ? void 0 : m.propsRef;
    return b != null && b.disabled ? !1 : (c(g), !0);
  }, registerOption(g) {
    l.value.push(g), l.value = ai(l.value, (m) => m.element);
  }, unregisterOption(g) {
    let m = l.value.findIndex((b) => b.id === g);
    m !== -1 && l.value.splice(m, 1);
  } };
  Mr(TS, p), K1({ container: N(() => je(o)), accept(g) {
    return g.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : g.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(g) {
    g.setAttribute("role", "none");
  } });
  function v(g) {
    if (!o.value || !o.value.contains(g.target))
      return;
    let m = l.value.filter((b) => b.propsRef.disabled === !1).map((b) => b.element);
    switch (g.key) {
      case lt.Enter:
        rS(g.currentTarget);
        break;
      case lt.ArrowLeft:
      case lt.ArrowUp:
        if (g.preventDefault(), g.stopPropagation(), Xa(m, Cr.Previous | Cr.WrapAround) === zi.Success) {
          let b = l.value.find((y) => {
            var _;
            return y.element === ((_ = Qa(o)) == null ? void 0 : _.activeElement);
          });
          b && p.change(b.propsRef.value);
        }
        break;
      case lt.ArrowRight:
      case lt.ArrowDown:
        if (g.preventDefault(), g.stopPropagation(), Xa(m, Cr.Next | Cr.WrapAround) === zi.Success) {
          let b = l.value.find((y) => {
            var _;
            return y.element === ((_ = Qa(y.element)) == null ? void 0 : _.activeElement);
          });
          b && p.change(b.propsRef.value);
        }
        break;
      case lt.Space:
        {
          g.preventDefault(), g.stopPropagation();
          let b = l.value.find((y) => {
            var _;
            return y.element === ((_ = Qa(y.element)) == null ? void 0 : _.activeElement);
          });
          b && p.change(b.propsRef.value);
        }
        break;
    }
  }
  let h = N(() => {
    var g;
    return (g = je(o)) == null ? void 0 : g.closest("form");
  });
  return ct(() => {
    He([h], () => {
      if (!h.value || e.defaultValue === void 0)
        return;
      function g() {
        p.change(e.defaultValue);
      }
      return h.value.addEventListener("reset", g), () => {
        var m;
        (m = h.value) == null || m.removeEventListener("reset", g);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: g, name: m, form: b, ...y } = e, _ = { ref: o, id: s, role: "radiogroup", "aria-labelledby": u.value, "aria-describedby": d.value, onKeydown: v };
    return Ht(Qe, [...m != null && f.value != null ? Gd({ [m]: f.value }).map(([x, w]) => Ht(Ei, zd({ features: Si.Hidden, key: x, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: b, name: x, value: w }))) : [], $t({ ourProps: _, theirProps: { ...r, ...Ni(y, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: r, slots: a, name: "RadioGroup" })]);
  };
} });
var zA = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(zA || {});
let OS = Ae({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-radiogroup-option-${Sr()}`, s = SS("RadioGroupOption"), o = Z1({ name: "RadioGroupLabel" }), l = Xd({ name: "RadioGroupDescription" }), u = ne(null), d = N(() => ({ value: e.value, disabled: e.disabled })), f = ne(1);
  a({ el: u, $el: u });
  let c = N(() => je(u));
  ct(() => s.registerOption({ id: i, element: c, propsRef: d })), Tr(() => s.unregisterOption(i));
  let p = N(() => {
    var _;
    return ((_ = s.firstOption.value) == null ? void 0 : _.id) === i;
  }), v = N(() => s.disabled.value || e.disabled), h = N(() => s.compare(fr(s.value.value), fr(e.value))), g = N(() => v.value ? -1 : h.value || !s.containsCheckedOption.value && p.value ? 0 : -1);
  function m() {
    var _;
    s.change(e.value) && (f.value |= 2, (_ = je(u)) == null || _.focus());
  }
  function b() {
    f.value |= 2;
  }
  function y() {
    f.value &= -3;
  }
  return () => {
    let { value: _, disabled: x, ...w } = e, k = { checked: h.value, disabled: v.value, active: !!(f.value & 2) }, S = { id: i, ref: u, role: "radio", "aria-checked": h.value ? "true" : "false", "aria-labelledby": o.value, "aria-describedby": l.value, "aria-disabled": v.value ? !0 : void 0, tabIndex: g.value, onClick: v.value ? void 0 : m, onFocus: v.value ? void 0 : b, onBlur: v.value ? void 0 : y };
    return $t({ ourProps: S, theirProps: w, slot: k, attrs: t, slots: r, name: "RadioGroupOption" });
  };
} }), CS = wS, kS = Symbol("GroupContext"), YA = Ae({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: r }) {
  let a = ne(null), n = Z1({ name: "SwitchLabel", props: { htmlFor: N(() => {
    var s;
    return (s = a.value) == null ? void 0 : s.id;
  }), onClick(s) {
    a.value && (s.currentTarget.tagName === "LABEL" && s.preventDefault(), a.value.click(), a.value.focus({ preventScroll: !0 }));
  } } }), i = Xd({ name: "SwitchDescription" });
  return Mr(kS, { switchRef: a, labelledby: n, describedby: i }), () => $t({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: r, name: "SwitchGroup" });
} }), WA = Ae({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: r, slots: a, expose: n }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-switch-${Sr()}`, o = sr(kS, null), [l, u] = qd(N(() => e.modelValue), (b) => t("update:modelValue", b), N(() => e.defaultChecked));
  function d() {
    u(!l.value);
  }
  let f = ne(null), c = o === null ? f : o.switchRef, p = mu(N(() => ({ as: e.as, type: r.type })), c);
  n({ el: c, $el: c });
  function v(b) {
    b.preventDefault(), d();
  }
  function h(b) {
    b.key === lt.Space ? (b.preventDefault(), d()) : b.key === lt.Enter && rS(b.currentTarget);
  }
  function g(b) {
    b.preventDefault();
  }
  let m = N(() => {
    var b, y;
    return (y = (b = je(c)) == null ? void 0 : b.closest) == null ? void 0 : y.call(b, "form");
  });
  return ct(() => {
    He([m], () => {
      if (!m.value || e.defaultChecked === void 0)
        return;
      function b() {
        u(e.defaultChecked);
      }
      return m.value.addEventListener("reset", b), () => {
        var y;
        (y = m.value) == null || y.removeEventListener("reset", b);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: b, value: y, form: _, ...x } = e, w = { checked: l.value }, k = { id: s, ref: c, role: "switch", type: p.value, tabIndex: 0, "aria-checked": l.value, "aria-labelledby": o == null ? void 0 : o.labelledby.value, "aria-describedby": o == null ? void 0 : o.describedby.value, onClick: v, onKeyup: h, onKeypress: g };
    return Ht(Qe, [b != null && l.value != null ? Ht(Ei, zd({ features: Si.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: l.value, form: _, name: b, value: y })) : null, $t({ ourProps: k, theirProps: { ...r, ...Ni(x, ["modelValue", "defaultChecked"]) }, slot: w, attrs: r, slots: a, name: "Switch" })]);
  };
} }), GA = wS, XA = Ae({ props: { onFocus: { type: Function, required: !0 } }, setup(e) {
  let t = ne(!0);
  return () => t.value ? Ht(Ei, { as: "button", type: "button", features: Si.Focusable, onFocus(r) {
    r.preventDefault();
    let a, n = 50;
    function i() {
      var s;
      if (n-- <= 0) {
        a && cancelAnimationFrame(a);
        return;
      }
      if ((s = e.onFocus) != null && s.call(e)) {
        t.value = !1, cancelAnimationFrame(a);
        return;
      }
      a = requestAnimationFrame(i);
    }
    a = requestAnimationFrame(i);
  } }) : null;
} });
var KA = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(KA || {}), JA = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(JA || {});
let PS = Symbol("TabsContext");
function bu(e) {
  let t = sr(PS, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <TabGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, bu), r;
  }
  return t;
}
let eb = Symbol("TabsSSRContext"), QA = Ae({ name: "TabGroup", emits: { change: (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, selectedIndex: { type: [Number], default: null }, defaultIndex: { type: [Number], default: 0 }, vertical: { type: [Boolean], default: !1 }, manual: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: r, emit: a }) {
  var n;
  let i = ne((n = e.selectedIndex) != null ? n : e.defaultIndex), s = ne([]), o = ne([]), l = N(() => e.selectedIndex !== null), u = N(() => l.value ? e.selectedIndex : i.value);
  function d(h) {
    var g;
    let m = ai(f.tabs.value, je), b = ai(f.panels.value, je), y = m.filter((_) => {
      var x;
      return !((x = je(_)) != null && x.hasAttribute("disabled"));
    });
    if (h < 0 || h > m.length - 1) {
      let _ = or(i.value === null ? 0 : Math.sign(h - i.value), { [-1]: () => 1, 0: () => or(Math.sign(h), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 }), x = or(_, { 0: () => m.indexOf(y[0]), 1: () => m.indexOf(y[y.length - 1]) });
      x !== -1 && (i.value = x), f.tabs.value = m, f.panels.value = b;
    } else {
      let _ = m.slice(0, h), x = [...m.slice(h), ..._].find((k) => y.includes(k));
      if (!x)
        return;
      let w = (g = m.indexOf(x)) != null ? g : f.selectedIndex.value;
      w === -1 && (w = f.selectedIndex.value), i.value = w, f.tabs.value = m, f.panels.value = b;
    }
  }
  let f = { selectedIndex: N(() => {
    var h, g;
    return (g = (h = i.value) != null ? h : e.defaultIndex) != null ? g : null;
  }), orientation: N(() => e.vertical ? "vertical" : "horizontal"), activation: N(() => e.manual ? "manual" : "auto"), tabs: s, panels: o, setSelectedIndex(h) {
    u.value !== h && a("change", h), l.value || d(h);
  }, registerTab(h) {
    var g;
    if (s.value.includes(h))
      return;
    let m = s.value[i.value];
    s.value.push(h), s.value = ai(s.value, je);
    let b = (g = s.value.indexOf(m)) != null ? g : i.value;
    b !== -1 && (i.value = b);
  }, unregisterTab(h) {
    let g = s.value.indexOf(h);
    g !== -1 && s.value.splice(g, 1);
  }, registerPanel(h) {
    o.value.includes(h) || (o.value.push(h), o.value = ai(o.value, je));
  }, unregisterPanel(h) {
    let g = o.value.indexOf(h);
    g !== -1 && o.value.splice(g, 1);
  } };
  Mr(PS, f);
  let c = ne({ tabs: [], panels: [] }), p = ne(!1);
  ct(() => {
    p.value = !0;
  }), Mr(eb, N(() => p.value ? null : c.value));
  let v = N(() => e.selectedIndex);
  return ct(() => {
    He([v], () => {
      var h;
      return d((h = e.selectedIndex) != null ? h : e.defaultIndex);
    }, { immediate: !0 });
  }), Nr(() => {
    if (!l.value || u.value == null || f.tabs.value.length <= 0)
      return;
    let h = ai(f.tabs.value, je);
    h.some((g, m) => je(f.tabs.value[m]) !== je(g)) && f.setSelectedIndex(h.findIndex((g) => je(g) === je(f.tabs.value[u.value])));
  }), () => {
    let h = { selectedIndex: i.value };
    return Ht(Qe, [s.value.length <= 0 && Ht(XA, { onFocus: () => {
      for (let g of s.value) {
        let m = je(g);
        if ((m == null ? void 0 : m.tabIndex) === 0)
          return m.focus(), !0;
      }
      return !1;
    } }), $t({ theirProps: { ...r, ...Ni(e, ["selectedIndex", "defaultIndex", "manual", "vertical", "onChange"]) }, ourProps: {}, slot: h, slots: t, attrs: r, name: "TabGroup" })]);
  };
} }), ZA = Ae({ name: "TabList", props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: r }) {
  let a = bu("TabList");
  return () => {
    let n = { selectedIndex: a.selectedIndex.value }, i = { role: "tablist", "aria-orientation": a.orientation.value };
    return $t({ ourProps: i, theirProps: e, slot: n, attrs: t, slots: r, name: "TabList" });
  };
} }), eD = Ae({ name: "Tab", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-tabs-tab-${Sr()}`, s = bu("Tab"), o = ne(null);
  a({ el: o, $el: o }), ct(() => s.registerTab(o)), Tr(() => s.unregisterTab(o));
  let l = sr(eb), u = N(() => {
    if (l.value) {
      let b = l.value.tabs.indexOf(i);
      return b === -1 ? l.value.tabs.push(i) - 1 : b;
    }
    return -1;
  }), d = N(() => {
    let b = s.tabs.value.indexOf(o);
    return b === -1 ? u.value : b;
  }), f = N(() => d.value === s.selectedIndex.value);
  function c(b) {
    var y;
    let _ = b();
    if (_ === zi.Success && s.activation.value === "auto") {
      let x = (y = Qa(o)) == null ? void 0 : y.activeElement, w = s.tabs.value.findIndex((k) => je(k) === x);
      w !== -1 && s.setSelectedIndex(w);
    }
    return _;
  }
  function p(b) {
    let y = s.tabs.value.map((_) => je(_)).filter(Boolean);
    if (b.key === lt.Space || b.key === lt.Enter) {
      b.preventDefault(), b.stopPropagation(), s.setSelectedIndex(d.value);
      return;
    }
    switch (b.key) {
      case lt.Home:
      case lt.PageUp:
        return b.preventDefault(), b.stopPropagation(), c(() => Xa(y, Cr.First));
      case lt.End:
      case lt.PageDown:
        return b.preventDefault(), b.stopPropagation(), c(() => Xa(y, Cr.Last));
    }
    if (c(() => or(s.orientation.value, { vertical() {
      return b.key === lt.ArrowUp ? Xa(y, Cr.Previous | Cr.WrapAround) : b.key === lt.ArrowDown ? Xa(y, Cr.Next | Cr.WrapAround) : zi.Error;
    }, horizontal() {
      return b.key === lt.ArrowLeft ? Xa(y, Cr.Previous | Cr.WrapAround) : b.key === lt.ArrowRight ? Xa(y, Cr.Next | Cr.WrapAround) : zi.Error;
    } })) === zi.Success)
      return b.preventDefault();
  }
  let v = ne(!1);
  function h() {
    var b;
    v.value || (v.value = !0, !e.disabled && ((b = je(o)) == null || b.focus({ preventScroll: !0 }), s.setSelectedIndex(d.value), Wd(() => {
      v.value = !1;
    })));
  }
  function g(b) {
    b.preventDefault();
  }
  let m = mu(N(() => ({ as: e.as, type: t.type })), o);
  return () => {
    var b;
    let y = { selected: f.value }, { ..._ } = e, x = { ref: o, onKeydown: p, onMousedown: g, onClick: h, id: i, role: "tab", type: m.value, "aria-controls": (b = je(s.panels.value[d.value])) == null ? void 0 : b.id, "aria-selected": f.value, tabIndex: f.value ? 0 : -1, disabled: e.disabled ? !0 : void 0 };
    return $t({ ourProps: x, theirProps: _, slot: y, attrs: t, slots: r, name: "Tab" });
  };
} }), tD = Ae({ name: "TabPanels", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let a = bu("TabPanels");
  return () => {
    let n = { selectedIndex: a.selectedIndex.value };
    return $t({ theirProps: e, ourProps: {}, slot: n, attrs: r, slots: t, name: "TabPanels" });
  };
} }), rD = Ae({ name: "TabPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null }, tabIndex: { type: Number, default: 0 } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var n;
  let i = (n = e.id) != null ? n : `headlessui-tabs-panel-${Sr()}`, s = bu("TabPanel"), o = ne(null);
  a({ el: o, $el: o }), ct(() => s.registerPanel(o)), Tr(() => s.unregisterPanel(o));
  let l = sr(eb), u = N(() => {
    if (l.value) {
      let c = l.value.panels.indexOf(i);
      return c === -1 ? l.value.panels.push(i) - 1 : c;
    }
    return -1;
  }), d = N(() => {
    let c = s.panels.value.indexOf(o);
    return c === -1 ? u.value : c;
  }), f = N(() => d.value === s.selectedIndex.value);
  return () => {
    var c;
    let p = { selected: f.value }, { tabIndex: v, ...h } = e, g = { ref: o, id: i, role: "tabpanel", "aria-labelledby": (c = je(s.tabs.value[d.value])) == null ? void 0 : c.id, tabIndex: f.value ? v : -1 };
    return !f.value && e.unmount && !e.static ? Ht(Ei, { as: "span", "aria-hidden": !0, ...g }) : $t({ ourProps: g, theirProps: h, slot: p, attrs: t, slots: r, features: Ha.Static | Ha.RenderStrategy, visible: f.value, name: "TabPanel" });
  };
} });
function aD(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called)
      return t.called = !0, e(...r);
  };
}
function wf(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Vu(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Rp = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Rp || {});
function nD(e, t) {
  let r = Ps();
  if (!e)
    return r.dispose;
  let { transitionDuration: a, transitionDelay: n } = getComputedStyle(e), [i, s] = [a, n].map((o) => {
    let [l = 0] = o.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, d) => d - u);
    return l;
  });
  return i !== 0 ? r.setTimeout(() => t("finished"), i + s) : t("finished"), r.add(() => t("cancelled")), r.dispose;
}
function w_(e, t, r, a, n, i) {
  let s = Ps(), o = i !== void 0 ? aD(i) : () => {
  };
  return Vu(e, ...n), wf(e, ...t, ...r), s.nextFrame(() => {
    Vu(e, ...r), wf(e, ...a), s.add(nD(e, (l) => (Vu(e, ...a, ...t), wf(e, ...n), o(l))));
  }), s.add(() => Vu(e, ...t, ...r, ...a, ...n)), s.add(() => o("cancelled")), s.dispose;
}
function ys(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let tb = Symbol("TransitionContext");
var iD = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(iD || {});
function sD() {
  return sr(tb, null) !== null;
}
function oD() {
  let e = sr(tb, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function lD() {
  let e = sr(rb, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let rb = Symbol("NestingContext");
function Jd(e) {
  return "children" in e ? Jd(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function MS(e) {
  let t = ne([]), r = ne(!1);
  ct(() => r.value = !0), Tr(() => r.value = !1);
  function a(i, s = Yi.Hidden) {
    let o = t.value.findIndex(({ id: l }) => l === i);
    o !== -1 && (or(s, { [Yi.Unmount]() {
      t.value.splice(o, 1);
    }, [Yi.Hidden]() {
      t.value[o].state = "hidden";
    } }), !Jd(t) && r.value && (e == null || e()));
  }
  function n(i) {
    let s = t.value.find(({ id: o }) => o === i);
    return s ? s.state !== "visible" && (s.state = "visible") : t.value.push({ id: i, state: "visible" }), () => a(i, Yi.Unmount);
  }
  return { children: t, register: n, unregister: a };
}
let AS = Ha.RenderStrategy, zl = Ae({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: a, expose: n }) {
  let i = ne(0);
  function s() {
    i.value |= wr.Opening, t("beforeEnter");
  }
  function o() {
    i.value &= ~wr.Opening, t("afterEnter");
  }
  function l() {
    i.value |= wr.Closing, t("beforeLeave");
  }
  function u() {
    i.value &= ~wr.Closing, t("afterLeave");
  }
  if (!sD() && JM())
    return () => Ht(ab, { ...e, onBeforeEnter: s, onAfterEnter: o, onBeforeLeave: l, onAfterLeave: u }, a);
  let d = ne(null), f = N(() => e.unmount ? Yi.Unmount : Yi.Hidden);
  n({ el: d, $el: d });
  let { show: c, appear: p } = oD(), { register: v, unregister: h } = lD(), g = ne(c.value ? "visible" : "hidden"), m = { value: !0 }, b = Sr(), y = { value: !1 }, _ = MS(() => {
    !y.value && g.value !== "hidden" && (g.value = "hidden", h(b), u());
  });
  ct(() => {
    let T = v(b);
    Tr(T);
  }), Nr(() => {
    if (f.value === Yi.Hidden && b) {
      if (c.value && g.value !== "visible") {
        g.value = "visible";
        return;
      }
      or(g.value, { hidden: () => h(b), visible: () => v(b) });
    }
  });
  let x = ys(e.enter), w = ys(e.enterFrom), k = ys(e.enterTo), S = ys(e.entered), P = ys(e.leave), A = ys(e.leaveFrom), E = ys(e.leaveTo);
  ct(() => {
    Nr(() => {
      if (g.value === "visible") {
        let T = je(d);
        if (T instanceof Comment && T.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function O(T) {
    let D = m.value && !p.value, $ = je(d);
    !$ || !($ instanceof HTMLElement) || D || (y.value = !0, c.value && s(), c.value || l(), T(c.value ? w_($, x, w, k, S, (I) => {
      y.value = !1, I === Rp.Finished && o();
    }) : w_($, P, A, E, S, (I) => {
      y.value = !1, I === Rp.Finished && (Jd(_) || (g.value = "hidden", h(b), u()));
    })));
  }
  return ct(() => {
    He([c], (T, D, $) => {
      O($), m.value = !1;
    }, { immediate: !0 });
  }), Mr(rb, _), Yd(N(() => or(g.value, { visible: wr.Open, hidden: wr.Closed }) | i.value)), () => {
    let { appear: T, show: D, enter: $, enterFrom: I, enterTo: F, entered: j, leave: M, leaveFrom: q, leaveTo: le, ...Z } = e, G = { ref: d }, H = { ...Z, ...p.value && c.value && vu.isServer ? { class: pe([r.class, Z.class, ...x, ...w]) } : {} };
    return $t({ theirProps: H, ourProps: G, slot: {}, slots: a, attrs: r, features: AS, visible: g.value === "visible", name: "TransitionChild" });
  };
} }), uD = zl, ab = Ae({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: a }) {
  let n = ko(), i = N(() => e.show === null && n !== null ? (n.value & wr.Open) === wr.Open : e.show);
  Nr(() => {
    if (![!0, !1].includes(i.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = ne(i.value ? "visible" : "hidden"), o = MS(() => {
    s.value = "hidden";
  }), l = ne(!0), u = { show: i, appear: N(() => e.appear || !l.value) };
  return ct(() => {
    Nr(() => {
      l.value = !1, i.value ? s.value = "visible" : Jd(o) || (s.value = "hidden");
    });
  }), Mr(rb, o), Mr(tb, u), () => {
    let d = Ni(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), f = { unmount: e.unmount };
    return $t({ ourProps: { ...f, as: "template" }, theirProps: {}, slot: {}, slots: { ...a, default: () => [Ht(uD, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...r, ...f, ...d }, a.default)] }, attrs: {}, features: AS, visible: s.value === "visible", name: "Transition" });
  };
} });
const dD = {
  width: "84",
  height: "84",
  viewBox: "0 0 84 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cD = /* @__PURE__ */ ue("path", {
  opacity: "0.5",
  d: "M84 42C84 65.1966 65.1966 84 42 84C18.8034 84 0 65.1966 0 42C0 18.8034 18.8034 0 42 0C65.1966 0 84 18.8034 84 42Z",
  fill: "#22B44B"
}, null, -1), fD = /* @__PURE__ */ ue("path", {
  d: "M58.9261 30.2728C59.516 30.8634 59.8473 31.664 59.8473 32.4988C59.8473 33.3335 59.516 34.1342 58.9261 34.7248L37.9261 55.7248C37.3355 56.3147 36.5349 56.646 35.7001 56.646C34.8654 56.646 34.0647 56.3147 33.4741 55.7248L25.0741 47.3248C24.7646 47.0364 24.5164 46.6886 24.3442 46.3022C24.1721 45.9159 24.0795 45.4987 24.072 45.0758C24.0646 44.6528 24.1424 44.2327 24.3008 43.8405C24.4592 43.4482 24.695 43.0919 24.9941 42.7928C25.2933 42.4937 25.6496 42.2579 26.0418 42.0995C26.434 41.941 26.8541 41.8632 27.2771 41.8707C27.7001 41.8782 28.1172 41.9707 28.5036 42.1429C28.89 42.3151 29.2377 42.5633 29.5261 42.8728L35.7001 49.0468L45.0871 39.6556L54.4741 30.2728C55.0647 29.6829 55.8654 29.3516 56.7001 29.3516C57.5349 29.3516 58.3355 29.6829 58.9261 30.2728Z",
  fill: "#22B44B"
}, null, -1), pD = [
  cD,
  fD
];
function vD(e, t) {
  return R(), K("svg", dD, [...pD]);
}
const mD = { render: vD }, hD = {
  width: "84",
  height: "84",
  viewBox: "0 0 84 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gD = /* @__PURE__ */ ue("path", {
  opacity: "0.5",
  d: "M84 42C84 65.1966 65.1966 84 42 84C18.8034 84 0 65.1966 0 42C0 18.8034 18.8034 0 42 0C65.1966 0 84 18.8034 84 42Z",
  fill: "#E47259"
}, null, -1), bD = /* @__PURE__ */ ue("path", {
  d: "M29.2738 29.275C29.8644 28.6851 30.665 28.3538 31.4998 28.3538C32.3345 28.3538 33.1351 28.6851 33.7258 29.275L41.9998 37.549L50.2738 29.275C50.5621 28.9656 50.9099 28.7173 51.2963 28.5452C51.6827 28.373 52.0998 28.2804 52.5228 28.273C52.9457 28.2655 53.3658 28.3433 53.7581 28.5017C54.1503 28.6601 54.5066 28.896 54.8057 29.1951C55.1048 29.4942 55.3407 29.8505 55.4991 30.2427C55.6575 30.635 55.7353 31.0551 55.7279 31.478C55.7204 31.901 55.6278 32.3181 55.4556 32.7045C55.2835 33.0909 55.0352 33.4387 54.7258 33.727L46.4518 42.001L54.7258 50.275C55.2822 50.8722 55.5851 51.662 55.5707 52.478C55.5563 53.2941 55.2257 54.0727 54.6486 54.6498C54.0714 55.227 53.2928 55.5576 52.4768 55.572C51.6607 55.5864 50.8709 55.2835 50.2738 54.727L41.9998 46.453L33.7258 54.727C33.1286 55.2835 32.3388 55.5864 31.5228 55.572C30.7067 55.5576 29.9281 55.227 29.351 54.6498C28.7738 54.0727 28.4432 53.2941 28.4288 52.478C28.4144 51.662 28.7174 50.8722 29.2738 50.275L37.5478 42.001L29.2738 33.727C28.6839 33.1364 28.3525 32.3358 28.3525 31.501C28.3525 30.6663 28.6839 29.8657 29.2738 29.275Z",
  fill: "#E47259"
}, null, -1), yD = [
  gD,
  bD
];
function _D(e, t) {
  return R(), K("svg", hD, [...yD]);
}
const xD = { render: _D }, Qd = /* @__PURE__ */ Ae({
  __name: "JOverlay",
  props: {
    opacity: { default: 0.5 }
  },
  setup(e) {
    const t = e, r = N(() => ({
      backgroundColor: `rgba(0, 0, 0, ${t.opacity})`
    }));
    return (a, n) => (R(), K("div", {
      style: Ir(r.value),
      class: "fixed bottom-0 left-0 right-0 top-0 h-full w-full"
    }, null, 4));
  }
}), wD = {
  sm: "btn--sm",
  md: "btn--md",
  lg: "btn--lg"
}, TD = {
  sm: 24,
  md: 26,
  lg: 28
}, voe = {
  "add-square-linear": "add-square-linear.svg",
  "add-user-linear": "add-user-linear.svg",
  adults: "adults.svg",
  "airplane-outline": "airplane-outline.svg",
  airplane: "airplane.svg",
  "alt-arrow-down-filled": "alt-arrow-down-filled.svg",
  "alt-arrow-down": "alt-arrow-down.svg",
  "alt-arrow-left-line": "alt-arrow-left-line.svg",
  "alt-arrow-right-filled": "alt-arrow-right-filled.svg",
  "alt-arrow-right-line": "alt-arrow-right-line.svg",
  "alt-arrow-up-down": "alt-arrow-up-down.svg",
  "alt-arrow-up": "alt-arrow-up.svg",
  "arrow-circle-up": "arrow-circle-up.svg",
  "arrow-left": "arrow-left.svg",
  "arrow-right-outline": "arrow-right-outline.svg",
  "arrow-right": "arrow-right.svg",
  "arrows-action": "arrows-action.svg",
  backpack: "backpack.svg",
  "bag-1-off-outline": "bag-1-off-outline.svg",
  "bag-1-outline": "bag-1-outline.svg",
  "bag-2-off-outline": "bag-2-off-outline.svg",
  "bag-2-outline": "bag-2-outline.svg",
  "bag-3-off-outline": "bag-3-off-outline.svg",
  "bag-3-outline": "bag-3-outline.svg",
  bag: "bag.svg",
  "bar-chart": "bar-chart.svg",
  "bed-double": "bed-double.svg",
  "bed-from-top": "bed-from-top.svg",
  "bed-linear": "bed-linear.svg",
  "bed-single": "bed-single.svg",
  bed: "bed.svg",
  bedroom: "bedroom.svg",
  bell: "bell.svg",
  "box-search": "box-search.svg",
  breakfast: "breakfast.svg",
  briefcase: "briefcase.svg",
  budget: "budget.svg",
  "building-outline": "building-outline.svg",
  "buildings-2": "buildings-2.svg",
  "bullet-outlined": "bullet-outlined.svg",
  bullet: "bullet.svg",
  "calendar-outline": "calendar-outline.svg",
  "car-opened-door": "car-opened-door.svg",
  "car-outline": "car-outline.svg",
  "car-seat": "car-seat.svg",
  car: "car.svg",
  "card-pos": "card-pos.svg",
  "card-transfer": "card-transfer.svg",
  chart: "chart.svg",
  chat: "chat.svg",
  "check-circle-bold-2": "check-circle-bold-2.svg",
  "check-circle-bold": "check-circle-bold.svg",
  check: "check.svg",
  "child-outlined": "child-outlined.svg",
  children: "children.svg",
  "circle-right-icon": "circle-right-icon.svg",
  "circle-top-up": "circle-top-up.svg",
  "civic-(cvc)": "civic-(cvc).svg",
  "clock-circle-outline": "clock-circle-outline.svg",
  "close-circle-bold": "close-circle-bold.svg",
  "close-circle-outline": "close-circle-outline.svg",
  close: "close.svg",
  coins: "coins.svg",
  copy: "copy.svg",
  crown: "crown.svg",
  cup: "cup.svg",
  "danger-circle": "danger-circle.svg",
  "data-2": "data-2.svg",
  "datepicker-accept": "datepicker-accept.svg",
  "day-and-night": "day-and-night.svg",
  diagram: "diagram.svg",
  "document-download": "document-download.svg",
  "document-text-filled": "document-text-filled.svg",
  "document-text": "document-text.svg",
  "dollar-outline": "dollar-outline.svg",
  dots: "dots.svg",
  envelop: "envelop.svg",
  "eur-outline": "eur-outline.svg",
  export: "export.svg",
  "eye-hide": "eye-hide.svg",
  eye: "eye.svg",
  "filled-adult": "filled-adult.svg",
  "filled-child": "filled-child.svg",
  "filled-document": "filled-document.svg",
  "filled-eye": "filled-eye.svg",
  filter: "filter.svg",
  forbidden: "forbidden.svg",
  "gallery-add": "gallery-add.svg",
  "gears-shift": "gears-shift.svg",
  "globe-outline": "globe-outline.svg",
  guest: "guest.svg",
  home: "home.svg",
  "hotel-bed": "hotel-bed.svg",
  hotel: "hotel.svg",
  "inbox-linear": "inbox-linear.svg",
  infants: "infants.svg",
  "info-outline": "info-outline.svg",
  leader: "leader.svg",
  "leaner-lock": "leaner-lock.svg",
  "like-shapes": "like-shapes.svg",
  location: "location.svg",
  "login-circle": "login-circle.svg",
  "logout-circle": "logout-circle.svg",
  logout: "logout.svg",
  "long-arrow-right": "long-arrow-right.svg",
  luggage: "luggage.svg",
  "magnifier-bold": "magnifier-bold.svg",
  "magnifier-outline": "magnifier-outline.svg",
  "mail-inbox": "mail-inbox.svg",
  "man-with-baggage": "man-with-baggage.svg",
  "map-point-outline": "map-point-outline.svg",
  map: "map.svg",
  medal: "medal.svg",
  menu: "menu.svg",
  "message-question": "message-question.svg",
  "message-time": "message-time.svg",
  "messages-2": "messages-2.svg",
  "minus-circle": "minus-circle.svg",
  "money-change": "money-change.svg",
  "money-forbidden": "money-forbidden.svg",
  "money-send": "money-send.svg",
  money: "money.svg",
  moneys: "moneys.svg",
  more: "more.svg",
  navigation: "navigation.svg",
  "notification-status": "notification-status.svg",
  "oneway-trip": "oneway-trip.svg",
  "payment-protection": "payment-protection.svg",
  "pen-bold-outlined": "pen-bold-outlined.svg",
  "pen-bold": "pen-bold.svg",
  "pen-outline": "pen-outline.svg",
  person: "person.svg",
  personalcard: "personalcard.svg",
  "pet-outliend": "pet-outliend.svg",
  "phone-outline": "phone-outline.svg",
  "pie-chart-outline": "pie-chart-outline.svg",
  "plane-land-outline": "plane-land-outline.svg",
  "plane-land": "plane-land.svg",
  "plane-outline": "plane-outline.svg",
  "plane-take-off-outline": "plane-take-off-outline.svg",
  "plane-take-off": "plane-take-off.svg",
  plane: "plane.svg",
  "plus-circle": "plus-circle.svg",
  printer: "printer.svg",
  "profile-2user": "profile-2user.svg",
  "question-mark-outline": "question-mark-outline.svg",
  "refresh-circle": "refresh-circle.svg",
  refresh: "refresh.svg",
  refund: "refund.svg",
  report: "report.svg",
  resend: "resend.svg",
  "round-trip-rounded": "round-trip-rounded.svg",
  "round-trip": "round-trip.svg",
  "sand-clock": "sand-clock.svg",
  "search-zoom-in": "search-zoom-in.svg",
  "security-user": "security-user.svg",
  "setting-4": "setting-4.svg",
  "setting-renew-outline": "setting-renew-outline.svg",
  setting: "setting.svg",
  "settings-outline": "settings-outline.svg",
  "share-bold": "share-bold.svg",
  "share-ios": "share-ios.svg",
  "share-outline": "share-outline.svg",
  smileys: "smileys.svg",
  "smocking-outlined": "smocking-outlined.svg",
  solid_plus: "solid_plus.svg",
  sort: "sort.svg",
  spinner: "spinner.svg",
  "star-half": "star-half.svg",
  "star-outline": "star-outline.svg",
  star: "star.svg",
  "sterling-outline": "sterling-outline.svg",
  "suitcase-outlined": "suitcase-outlined.svg",
  support: "support.svg",
  swap: "swap.svg",
  "tick-circle": "tick-circle.svg",
  "tick-square": "tick-square.svg",
  "ticket-2": "ticket-2.svg",
  "ticket-star": "ticket-star.svg",
  timer: "timer.svg",
  "trash-bin": "trash-bin.svg",
  trash: "trash.svg",
  "upload-outline": "upload-outline.svg",
  "user-accept": "user-accept.svg",
  "user-add": "user-add.svg",
  "user-filled": "user-filled.svg",
  "user-outline": "user-outline.svg",
  "user-search": "user-search.svg",
  "user-setting": "user-setting.svg",
  users: "users.svg",
  "wallet-3": "wallet-3.svg",
  "wallet-money": "wallet-money.svg",
  "warning-2": "warning-2.svg",
  "warning-triangle-outlined": "warning-triangle-outlined.svg",
  "warning-triangle": "warning-triangle.svg",
  "wheelie-bag": "wheelie-bag.svg",
  "wifi-off": "wifi-off.svg",
  workbench: "workbench.svg",
  world: "world.svg"
}, moe = {
  sm: "sm",
  md: "md",
  lg: "lg"
}, Yl = {
  primary: "border-primary",
  "primary-hover": "border-primary-hover",
  "primary-light": "border-primary-light",
  "primary-lighter": "border-primary-lighter",
  secondary: "border-secondary",
  "secondary-hover": "border-secondary-hover",
  "secondary-light": "border-secondary-light",
  "secondary-lighter": "border-secondary-lighter",
  success: "border-success",
  danger: "border-danger",
  white: "border-white",
  warning: "border-warning",
  "gray-100": "border-gray-100",
  "gray-200": "border-gray-200",
  "gray-300": "border-gray-300",
  "gray-400": "border-gray-400",
  "gray-500": "border-gray-500",
  "gray-600": "border-gray-600",
  dark: "border-dark",
  disabled: "border-disabled",
  black: "border-black",
  placeholder: "border-placeholder",
  line: "border-line",
  transparent: "border-transparent"
}, Zd = {
  primary: "outline-primary",
  "primary-hover": "outline-primary-hover",
  "primary-light": "outline-primary-light",
  "primary-lighter": "outline-primary-lighter",
  secondary: "outline-secondary",
  "secondary-hover": "outline-secondary-hover",
  "secondary-light": "outline-secondary-light",
  "secondary-lighter": "outline-secondary-lighter",
  success: "outline-success",
  danger: "outline-danger",
  white: "outline-white",
  warning: "outline-warning",
  "gray-100": "outline-gray-100",
  "gray-200": "outline-gray-200",
  "gray-300": "outline-gray-300",
  "gray-400": "outline-gray-400",
  "gray-500": "outline-gray-500",
  "gray-600": "outline-gray-600",
  dark: "outline-dark",
  disabled: "outline-disabled",
  black: "outline-black",
  placeholder: "outline-placeholder",
  line: "outline-line",
  transparent: "outline-transparent"
}, hoe = {
  contained: "contained",
  outlined: "outlined"
}, SD = {
  0: "px-0",
  1: "px-1",
  2: "px-2",
  3: "px-3",
  4: "px-4",
  8: "px-8",
  12: "px-12",
  16: "px-16",
  20: "px-20",
  24: "px-24",
  28: "px-28"
}, ED = {
  0: "md:px-0",
  1: "md:px-1",
  2: "md:px-2",
  3: "md:px-3",
  4: "md:px-4",
  8: "md:px-8",
  12: "md:px-12",
  16: "md:px-16",
  20: "md:px-20",
  24: "md:px-24",
  28: "md:px-28"
}, OD = {
  0: "lg:px-0",
  1: "lg:px-1",
  2: "lg:px-2",
  3: "lg:px-3",
  4: "lg:px-4",
  8: "lg:px-8",
  12: "lg:px-12",
  16: "lg:px-16",
  20: "lg:px-20",
  24: "lg:px-24",
  28: "lg:px-28"
}, CD = {
  0: "xl:px-0",
  1: "xl:px-1",
  2: "xl:px-2",
  3: "xl:px-3",
  4: "xl:px-4",
  8: "xl:px-8",
  12: "xl:px-12",
  16: "xl:px-16",
  20: "xl:px-20",
  24: "xl:px-24",
  28: "xl:px-28"
}, kD = {
  0: "-mx-0",
  1: "-mx-1",
  2: "-mx-2",
  3: "-mx-3",
  4: "-mx-4",
  8: "-mx-8",
  12: "-mx-12",
  16: "-mx-16",
  20: "-mx-20",
  24: "-mx-24",
  28: "-mx-28"
}, PD = {
  0: "md:-mx-0",
  1: "md:-mx-1",
  2: "md:-mx-2",
  3: "md:-mx-3",
  4: "md:-mx-4",
  8: "md:-mx-8",
  12: "md:-mx-12",
  16: "md:-mx-16",
  20: "md:-mx-20",
  24: "md:-mx-24",
  28: "md:-mx-28"
}, MD = {
  0: "lg:-mx-0",
  1: "lg:-mx-1",
  2: "lg:-mx-2",
  3: "lg:-mx-3",
  4: "lg:-mx-4",
  8: "lg:-mx-8",
  12: "lg:-mx-12",
  16: "lg:-mx-16",
  20: "lg:-mx-20",
  24: "lg:-mx-24",
  28: "lg:-mx-28"
}, AD = {
  0: "xl:-mx-0",
  1: "xl:-mx-1",
  2: "xl:-mx-2",
  3: "xl:-mx-3",
  4: "xl:-mx-4",
  8: "xl:-mx-8",
  12: "xl:-mx-12",
  16: "xl:-mx-16",
  20: "xl:-mx-20",
  24: "xl:-mx-24",
  28: "xl:-mx-28"
}, qa = {
  primary: "bg-primary",
  "primary-hover": "bg-primary-hover",
  "primary-light": "bg-primary-light",
  "primary-lighter": "bg-primary-lighter",
  secondary: "bg-secondary",
  "secondary-hover": "bg-secondary-hover",
  "secondary-light": "bg-secondary-light",
  "secondary-lighter": "bg-secondary-lighter",
  success: "bg-success",
  danger: "bg-danger",
  white: "bg-white",
  "gray-100": "bg-gray-100",
  "gray-200": "bg-gray-200",
  "gray-300": "bg-gray-300",
  "gray-400": "bg-gray-400",
  "gray-500": "bg-gray-500",
  "gray-600": "bg-gray-600",
  dark: "bg-dark",
  disabled: "bg-disabled",
  black: "bg-black",
  placeholder: "bg-placeholder",
  line: "bg-line",
  warning: "bg-warning",
  transparent: "bg-transparent"
}, DD = {
  primary: "hover:bg-primary",
  "primary-hover": "hover:bg-primary-hover",
  "primary-light": "hover:bg-primary-light",
  "primary-lighter": "hover:bg-primary-lighter",
  secondary: "hover:bg-secondary",
  "secondary-hover": "hover:bg-secondary-hover",
  "secondary-light": "hover:bg-secondary-light",
  "secondary-lighter": "hover:bg-secondary-lighter",
  success: "hover:bg-success",
  danger: "hover:bg-danger",
  white: "hover:bg-white",
  "gray-100": "hover:bg-gray-100",
  "gray-200": "hover:bg-gray-200",
  "gray-300": "hover:bg-gray-300",
  "gray-400": "hover:bg-gray-400",
  "gray-500": "hover:bg-gray-500",
  "gray-600": "hover:bg-gray-600",
  dark: "hover:bg-dark",
  disabled: "hover:bg-disabled",
  black: "hover:bg-black",
  placeholder: "hover:bg-placeholder",
  line: "hover:bg-line",
  warning: "hover:bg-warning",
  transparent: "hover:bg-transparent"
}, gn = {
  primary: "text-primary",
  "primary-hover": "text-primary-hover",
  "primary-light": "text-primary-light",
  "primary-lighter": "text-primary-lighter",
  secondary: "text-secondary",
  "secondary-hover": "text-secondary-hover",
  "secondary-light": "text-secondary-light",
  "secondary-lighter": "text-secondary-lighter",
  success: "text-success",
  danger: "text-danger",
  white: "text-white",
  warning: "text-warning",
  "gray-100": "text-gray-100",
  "gray-200": "text-gray-200",
  "gray-300": "text-gray-300",
  "gray-400": "text-gray-400",
  "gray-500": "text-gray-500",
  "gray-600": "text-gray-600",
  dark: "text-dark",
  disabled: "text-disabled",
  black: "text-black",
  placeholder: "text-placeholder",
  line: "text-line",
  transparent: "text-transparent"
}, ID = {
  primary: "checked:bg-primary",
  "primary-hover": "checked:bg-primary-hover",
  "primary-light": "checked:bg-primary-light",
  "primary-lighter": "checked:bg-primary-lighter",
  secondary: "checked:bg-secondary",
  "secondary-hover": "checked:bg-secondary-hover",
  "secondary-light": "checked:bg-secondary-light",
  "secondary-lighter": "checked:bg-secondary-lighter",
  success: "checked:bg-success",
  danger: "checked:bg-danger",
  white: "checked:bg-white",
  "gray-100": "checked:bg-gray-100",
  "gray-200": "checked:bg-gray-200",
  "gray-300": "checked:bg-gray-300",
  "gray-400": "checked:bg-gray-400",
  "gray-500": "checked:bg-gray-500",
  "gray-600": "checked:bg-gray-600",
  dark: "checked:bg-dark",
  disabled: "checked:bg-disabled",
  black: "checked:bg-black",
  placeholder: "checked:bg-placeholder",
  line: "checked:bg-line",
  warning: "checked:bg-warning",
  transparent: "checked:bg-transparent"
}, ND = {
  key: 0,
  class: "flex items-center justify-center"
}, $D = { class: "relative flex items-center justify-center space-x-3" }, LD = /* @__PURE__ */ Ae({
  __name: "JLoading",
  props: {
    size: { default: "md" },
    variant: { default: "dot" },
    color: { default: "primary" }
  },
  setup(e) {
    return (t, r) => t.variant === "dot" ? (R(), K("div", ND, [
      ue("div", $D, [
        (R(), K(Qe, null, kt(3, (a) => ue("div", {
          key: a,
          class: pe(["dot-flashing rounded-full", [
            `bg-${t.color}`,
            {
              "h-5 w-5": t.size === "sm",
              "h-8 w-8": t.size === "md",
              "h-10 w-10": t.size === "lg"
            }
          ]])
        }, null, 2)), 64))
      ])
    ])) : t.variant === "progress" ? (R(), K("div", {
      key: 1,
      class: pe(["relative w-full rounded-sm bg-gray-300", {
        "h-3": t.size === "sm",
        "h-5": t.size === "md",
        "h-8": t.size === "lg"
      }])
    }, [
      ue("span", {
        class: pe(["progress-animate-loading absolute h-full w-1/3 rounded-sm", `bg-${t.color}`])
      }, null, 2)
    ], 2)) : fe("", !0);
  }
});
const RD = /* @__PURE__ */ rs(LD, [["__scopeId", "data-v-498fb15c"]]), jD = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform"
}, Wl = /* @__PURE__ */ Ae({
  __name: "JButton",
  props: {
    color: { default: "primary" },
    size: { default: "md" },
    variant: { default: "contained" },
    isLoading: { default: !1 },
    icon: {},
    block: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    to: {},
    href: {},
    iconClass: { default: "" },
    label: { default: "" }
  },
  setup(e) {
    const t = e, a = Vn()("default"), n = N(
      () => !a && t.icon && t.shrink
    ), i = N(() => t.to ? uu : t.href ? "a" : "button"), s = N(() => {
      if (t.variant === "contained") {
        const c = {
          primary: "hover:bg-primary-hover focus:bg-primary focus:outline-primary text-white",
          secondary: "hover:bg-secondary focus:bg-secondary focus:outline-secondary text-white",
          danger: n.value ? "bg-danger/20 hover:bg-danger/20 focus:bg-danger/20 focus:outline-danger/20 text-danger" : "hover:bg-danger-hover focus:bg-danger focus:outline-danger text-white",
          success: "hover:bg-success-hover focus:bg-success focus:outline-success text-white",
          dark: "hover:bg-dark-hover focus:bg-dark focus:outline-dark text-white",
          "primary-light": "text-primary",
          warning: n.value ? "bg-warning/20 hover:bg-warning/20 focus:bg-warning/20 focus:outline-warning/20 text-warning" : "hover:bg-warning focus:bg-warning focus:outline-warning text-white",
          white: "text-primary"
        };
        return `border-transparent ${qa[t.color]} ${c[t.color]}`;
      }
      return `bg-transparent disabled:border-gray-400 ${{
        primary: "text-primary border-primary hover:bg-primary focus:bg-primary focus:outline-primary hover:text-white focus:text-white",
        secondary: "text-secondary border-secondary hover:bg-secondary focus:bg-secondary focus:outline-secondary hover:text-white focus:text-white",
        danger: "text-danger border-danger hover:bg-danger focus:bg-danger focus:outline-danger hover:text-white focus:text-white",
        success: "text-success border-success hover:bg-success focus:bg-success focus:outline-success hover:text-white focus:text-white",
        dark: "text-dark border-dark hover:bg-dark focus:bg-dark focus:outline-dark hover:text-white focus:text-white",
        white: "text-gray-500 border-line focus:bg-line focus:outline-line hover:text-dark focus:text-dark"
      }[t.color]}`;
    }), o = N(() => t.shrink ? t.size === "lg" ? "btn--shrink p-12" : "btn--shrink" : wD[t.size]), l = N(() => t.shrink ? a ? 14 : 16 : TD[t.size]), u = Gr(), d = N(() => u("disabled", !0) || t.isLoading);
    return (f, c) => (R(), Le(Za(i.value), {
      to: f.to,
      class: pe(["btn", [
        s.value,
        o.value,
        f.isLoading && "cursor-progress",
        f.block && "block w-full",
        !f.shrink && "font-medium",
        n.value && "rounded-full"
      ]]),
      "aria-disabled": d.value,
      disabled: d.value,
      href: f.href
    }, {
      default: Pe(() => [
        ue("span", {
          class: pe([[
            f.isLoading && "invisible opacity-0",
            f.shrink ? "gap-4" : "gap-8",
            f.block && "justify-center"
          ], "flex items-center"])
        }, [
          f.icon ? (R(), Le(gt, {
            key: 0,
            size: l.value,
            name: f.icon,
            class: pe(f.iconClass)
          }, null, 8, ["size", "name", "class"])) : fe("", !0),
          ke(f.$slots, "default", {}, () => [
            jt(Ie(f.label), 1)
          ])
        ], 2),
        f.isLoading ? (R(), K("div", jD, [
          Fe(RD, {
            variant: "dot",
            color: "white"
          })
        ])) : fe("", !0)
      ]),
      _: 3
    }, 8, ["to", "class", "aria-disabled", "disabled", "href"]));
  }
}), FD = { class: "fixed inset-0 overflow-y-auto" }, BD = { class: "fixed inset-0 flex items-center justify-center p-4" }, qD = { class: "mx-auto flex h-[8rem] w-[8rem] items-center justify-center rounded-full" }, goe = /* @__PURE__ */ Ae({
  __name: "JAlert",
  props: {
    title: {},
    description: {},
    closeText: { default: "Close" },
    type: {},
    modelValue: { type: Boolean }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a);
    function i() {
      n.value = !1, a("close");
    }
    return (s, o) => (R(), Le(U(J1), {
      open: U(n),
      onClose: o[0] || (o[0] = (l) => n.value = !1)
    }, {
      default: Pe(() => [
        ea(Fe(Qd, null, null, 512), [
          [$a, U(n)]
        ]),
        ue("div", FD, [
          ue("div", BD, [
            Fe(U(Q1), { class: "rounded w-full max-w-2xl rounded-md bg-white px-32 pb-20 pt-32 shadow-sm" }, {
              default: Pe(() => [
                ue("div", qD, [
                  s.type === "success" ? (R(), Le(U(mD), { key: 0 })) : (R(), Le(U(xD), { key: 1 }))
                ]),
                Fe(U(hS), { class: "mb-16 mt-24 text-center text-pane-header font-medium text-dark" }, {
                  default: Pe(() => [
                    jt(Ie(s.title), 1)
                  ]),
                  _: 1
                }),
                Fe(U(PA), { class: "mb-24 text-justify text-base font-light text-dark" }, {
                  default: Pe(() => [
                    jt(Ie(s.description), 1)
                  ]),
                  _: 1
                }),
                Fe(Wl, {
                  block: "",
                  color: s.type,
                  variant: "outlined",
                  onClick: i
                }, {
                  default: Pe(() => [
                    jt(Ie(s.closeText), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), T_ = 0.4, HD = 300;
var VD = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(e) {
  (function(t, r, a, n) {
    var i = ["", "webkit", "Moz", "MS", "ms", "o"], s = r.createElement("div"), o = "function", l = Math.round, u = Math.abs, d = Date.now;
    function f(B, z, ae) {
      return setTimeout(y(B, ae), z);
    }
    function c(B, z, ae) {
      return Array.isArray(B) ? (p(B, ae[z], ae), !0) : !1;
    }
    function p(B, z, ae) {
      var be;
      if (B)
        if (B.forEach)
          B.forEach(z, ae);
        else if (B.length !== n)
          for (be = 0; be < B.length; )
            z.call(ae, B[be], be, B), be++;
        else
          for (be in B)
            B.hasOwnProperty(be) && z.call(ae, B[be], be, B);
    }
    function v(B, z, ae) {
      var be = "DEPRECATED METHOD: " + z + `
` + ae + ` AT 
`;
      return function() {
        var $e = new Error("get-stack-trace"), Ge = $e && $e.stack ? $e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", Et = t.console && (t.console.warn || t.console.log);
        return Et && Et.call(t.console, be, Ge), B.apply(this, arguments);
      };
    }
    var h;
    typeof Object.assign != "function" ? h = function(z) {
      if (z === n || z === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var ae = Object(z), be = 1; be < arguments.length; be++) {
        var $e = arguments[be];
        if ($e !== n && $e !== null)
          for (var Ge in $e)
            $e.hasOwnProperty(Ge) && (ae[Ge] = $e[Ge]);
      }
      return ae;
    } : h = Object.assign;
    var g = v(function(z, ae, be) {
      for (var $e = Object.keys(ae), Ge = 0; Ge < $e.length; )
        (!be || be && z[$e[Ge]] === n) && (z[$e[Ge]] = ae[$e[Ge]]), Ge++;
      return z;
    }, "extend", "Use `assign`."), m = v(function(z, ae) {
      return g(z, ae, !0);
    }, "merge", "Use `assign`.");
    function b(B, z, ae) {
      var be = z.prototype, $e;
      $e = B.prototype = Object.create(be), $e.constructor = B, $e._super = be, ae && h($e, ae);
    }
    function y(B, z) {
      return function() {
        return B.apply(z, arguments);
      };
    }
    function _(B, z) {
      return typeof B == o ? B.apply(z && z[0] || n, z) : B;
    }
    function x(B, z) {
      return B === n ? z : B;
    }
    function w(B, z, ae) {
      p(A(z), function(be) {
        B.addEventListener(be, ae, !1);
      });
    }
    function k(B, z, ae) {
      p(A(z), function(be) {
        B.removeEventListener(be, ae, !1);
      });
    }
    function S(B, z) {
      for (; B; ) {
        if (B == z)
          return !0;
        B = B.parentNode;
      }
      return !1;
    }
    function P(B, z) {
      return B.indexOf(z) > -1;
    }
    function A(B) {
      return B.trim().split(/\s+/g);
    }
    function E(B, z, ae) {
      if (B.indexOf && !ae)
        return B.indexOf(z);
      for (var be = 0; be < B.length; ) {
        if (ae && B[be][ae] == z || !ae && B[be] === z)
          return be;
        be++;
      }
      return -1;
    }
    function O(B) {
      return Array.prototype.slice.call(B, 0);
    }
    function T(B, z, ae) {
      for (var be = [], $e = [], Ge = 0; Ge < B.length; ) {
        var Et = z ? B[Ge][z] : B[Ge];
        E($e, Et) < 0 && be.push(B[Ge]), $e[Ge] = Et, Ge++;
      }
      return ae && (z ? be = be.sort(function(ce, ge) {
        return ce[z] > ge[z];
      }) : be = be.sort()), be;
    }
    function D(B, z) {
      for (var ae, be, $e = z[0].toUpperCase() + z.slice(1), Ge = 0; Ge < i.length; ) {
        if (ae = i[Ge], be = ae ? ae + $e : z, be in B)
          return be;
        Ge++;
      }
      return n;
    }
    var $ = 1;
    function I() {
      return $++;
    }
    function F(B) {
      var z = B.ownerDocument || B;
      return z.defaultView || z.parentWindow || t;
    }
    var j = /mobile|tablet|ip(ad|hone|od)|android/i, M = "ontouchstart" in t, q = D(t, "PointerEvent") !== n, le = M && j.test(navigator.userAgent), Z = "touch", G = "pen", H = "mouse", W = "kinect", ie = 25, we = 1, Be = 2, Ve = 4, et = 8, nt = 1, xe = 2, J = 4, se = 8, _e = 16, Se = xe | J, Re = se | _e, rt = Se | Re, Dt = ["x", "y"], It = ["clientX", "clientY"];
    function Ye(B, z) {
      var ae = this;
      this.manager = B, this.callback = z, this.element = B.element, this.target = B.options.inputTarget, this.domHandler = function(be) {
        _(B.options.enable, [B]) && ae.handler(be);
      }, this.init();
    }
    Ye.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && w(this.element, this.evEl, this.domHandler), this.evTarget && w(this.target, this.evTarget, this.domHandler), this.evWin && w(F(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && k(this.element, this.evEl, this.domHandler), this.evTarget && k(this.target, this.evTarget, this.domHandler), this.evWin && k(F(this.element), this.evWin, this.domHandler);
      }
    };
    function at(B) {
      var z, ae = B.options.inputClass;
      return ae ? z = ae : q ? z = _t : le ? z = rn : M ? z = Va : z = Nt, new z(B, ut);
    }
    function ut(B, z, ae) {
      var be = ae.pointers.length, $e = ae.changedPointers.length, Ge = z & we && be - $e === 0, Et = z & (Ve | et) && be - $e === 0;
      ae.isFirst = !!Ge, ae.isFinal = !!Et, Ge && (B.session = {}), ae.eventType = z, Gt(B, ae), B.emit("hammer.input", ae), B.recognize(ae), B.session.prevInput = ae;
    }
    function Gt(B, z) {
      var ae = B.session, be = z.pointers, $e = be.length;
      ae.firstInput || (ae.firstInput = ye(z)), $e > 1 && !ae.firstMultiple ? ae.firstMultiple = ye(z) : $e === 1 && (ae.firstMultiple = !1);
      var Ge = ae.firstInput, Et = ae.firstMultiple, te = Et ? Et.center : Ge.center, ce = z.center = Ke(be);
      z.timeStamp = d(), z.deltaTime = z.timeStamp - Ge.timeStamp, z.angle = Oe(te, ce), z.distance = Te(te, ce), Je(ae, z), z.offsetDirection = L(z.deltaX, z.deltaY);
      var ge = Q(z.deltaTime, z.deltaX, z.deltaY);
      z.overallVelocityX = ge.x, z.overallVelocityY = ge.y, z.overallVelocity = u(ge.x) > u(ge.y) ? ge.x : ge.y, z.scale = Et ? de(Et.pointers, be) : 1, z.rotation = Et ? Y(Et.pointers, be) : 0, z.maxPointers = ae.prevInput ? z.pointers.length > ae.prevInput.maxPointers ? z.pointers.length : ae.prevInput.maxPointers : z.pointers.length, he(ae, z);
      var Me = B.element;
      S(z.srcEvent.target, Me) && (Me = z.srcEvent.target), z.target = Me;
    }
    function Je(B, z) {
      var ae = z.center, be = B.offsetDelta || {}, $e = B.prevDelta || {}, Ge = B.prevInput || {};
      (z.eventType === we || Ge.eventType === Ve) && ($e = B.prevDelta = {
        x: Ge.deltaX || 0,
        y: Ge.deltaY || 0
      }, be = B.offsetDelta = {
        x: ae.x,
        y: ae.y
      }), z.deltaX = $e.x + (ae.x - be.x), z.deltaY = $e.y + (ae.y - be.y);
    }
    function he(B, z) {
      var ae = B.lastInterval || z, be = z.timeStamp - ae.timeStamp, $e, Ge, Et, te;
      if (z.eventType != et && (be > ie || ae.velocity === n)) {
        var ce = z.deltaX - ae.deltaX, ge = z.deltaY - ae.deltaY, Me = Q(be, ce, ge);
        Ge = Me.x, Et = Me.y, $e = u(Me.x) > u(Me.y) ? Me.x : Me.y, te = L(ce, ge), B.lastInterval = z;
      } else
        $e = ae.velocity, Ge = ae.velocityX, Et = ae.velocityY, te = ae.direction;
      z.velocity = $e, z.velocityX = Ge, z.velocityY = Et, z.direction = te;
    }
    function ye(B) {
      for (var z = [], ae = 0; ae < B.pointers.length; )
        z[ae] = {
          clientX: l(B.pointers[ae].clientX),
          clientY: l(B.pointers[ae].clientY)
        }, ae++;
      return {
        timeStamp: d(),
        pointers: z,
        center: Ke(z),
        deltaX: B.deltaX,
        deltaY: B.deltaY
      };
    }
    function Ke(B) {
      var z = B.length;
      if (z === 1)
        return {
          x: l(B[0].clientX),
          y: l(B[0].clientY)
        };
      for (var ae = 0, be = 0, $e = 0; $e < z; )
        ae += B[$e].clientX, be += B[$e].clientY, $e++;
      return {
        x: l(ae / z),
        y: l(be / z)
      };
    }
    function Q(B, z, ae) {
      return {
        x: z / B || 0,
        y: ae / B || 0
      };
    }
    function L(B, z) {
      return B === z ? nt : u(B) >= u(z) ? B < 0 ? xe : J : z < 0 ? se : _e;
    }
    function Te(B, z, ae) {
      ae || (ae = Dt);
      var be = z[ae[0]] - B[ae[0]], $e = z[ae[1]] - B[ae[1]];
      return Math.sqrt(be * be + $e * $e);
    }
    function Oe(B, z, ae) {
      ae || (ae = Dt);
      var be = z[ae[0]] - B[ae[0]], $e = z[ae[1]] - B[ae[1]];
      return Math.atan2($e, be) * 180 / Math.PI;
    }
    function Y(B, z) {
      return Oe(z[1], z[0], It) + Oe(B[1], B[0], It);
    }
    function de(B, z) {
      return Te(z[0], z[1], It) / Te(B[0], B[1], It);
    }
    var Ne = {
      mousedown: we,
      mousemove: Be,
      mouseup: Ve
    }, We = "mousedown", mt = "mousemove mouseup";
    function Nt() {
      this.evEl = We, this.evWin = mt, this.pressed = !1, Ye.apply(this, arguments);
    }
    b(Nt, Ye, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(z) {
        var ae = Ne[z.type];
        ae & we && z.button === 0 && (this.pressed = !0), ae & Be && z.which !== 1 && (ae = Ve), this.pressed && (ae & Ve && (this.pressed = !1), this.callback(this.manager, ae, {
          pointers: [z],
          changedPointers: [z],
          pointerType: H,
          srcEvent: z
        }));
      }
    });
    var St = {
      pointerdown: we,
      pointermove: Be,
      pointerup: Ve,
      pointercancel: et,
      pointerout: et
    }, me = {
      2: Z,
      3: G,
      4: H,
      5: W
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, Ue = "pointerdown", bt = "pointermove pointerup pointercancel";
    t.MSPointerEvent && !t.PointerEvent && (Ue = "MSPointerDown", bt = "MSPointerMove MSPointerUp MSPointerCancel");
    function _t() {
      this.evEl = Ue, this.evWin = bt, Ye.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    b(_t, Ye, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(z) {
        var ae = this.store, be = !1, $e = z.type.toLowerCase().replace("ms", ""), Ge = St[$e], Et = me[z.pointerType] || z.pointerType, te = Et == Z, ce = E(ae, z.pointerId, "pointerId");
        Ge & we && (z.button === 0 || te) ? ce < 0 && (ae.push(z), ce = ae.length - 1) : Ge & (Ve | et) && (be = !0), !(ce < 0) && (ae[ce] = z, this.callback(this.manager, Ge, {
          pointers: ae,
          changedPointers: [z],
          pointerType: Et,
          srcEvent: z
        }), be && ae.splice(ce, 1));
      }
    });
    var pr = {
      touchstart: we,
      touchmove: Be,
      touchend: Ve,
      touchcancel: et
    }, Ze = "touchstart", vr = "touchstart touchmove touchend touchcancel";
    function yt() {
      this.evTarget = Ze, this.evWin = vr, this.started = !1, Ye.apply(this, arguments);
    }
    b(yt, Ye, {
      handler: function(z) {
        var ae = pr[z.type];
        if (ae === we && (this.started = !0), !!this.started) {
          var be = Xr.call(this, z, ae);
          ae & (Ve | et) && be[0].length - be[1].length === 0 && (this.started = !1), this.callback(this.manager, ae, {
            pointers: be[0],
            changedPointers: be[1],
            pointerType: Z,
            srcEvent: z
          });
        }
      }
    });
    function Xr(B, z) {
      var ae = O(B.touches), be = O(B.changedTouches);
      return z & (Ve | et) && (ae = T(ae.concat(be), "identifier", !0)), [ae, be];
    }
    var La = {
      touchstart: we,
      touchmove: Be,
      touchend: Ve,
      touchcancel: et
    }, Ar = "touchstart touchmove touchend touchcancel";
    function rn() {
      this.evTarget = Ar, this.targetIds = {}, Ye.apply(this, arguments);
    }
    b(rn, Ye, {
      handler: function(z) {
        var ae = La[z.type], be = Gn.call(this, z, ae);
        be && this.callback(this.manager, ae, {
          pointers: be[0],
          changedPointers: be[1],
          pointerType: Z,
          srcEvent: z
        });
      }
    });
    function Gn(B, z) {
      var ae = O(B.touches), be = this.targetIds;
      if (z & (we | Be) && ae.length === 1)
        return be[ae[0].identifier] = !0, [ae, ae];
      var $e, Ge, Et = O(B.changedTouches), te = [], ce = this.target;
      if (Ge = ae.filter(function(ge) {
        return S(ge.target, ce);
      }), z === we)
        for ($e = 0; $e < Ge.length; )
          be[Ge[$e].identifier] = !0, $e++;
      for ($e = 0; $e < Et.length; )
        be[Et[$e].identifier] && te.push(Et[$e]), z & (Ve | et) && delete be[Et[$e].identifier], $e++;
      if (te.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          T(Ge.concat(te), "identifier", !0),
          te
        ];
    }
    var pi = 2500, Cn = 25;
    function Va() {
      Ye.apply(this, arguments);
      var B = y(this.handler, this);
      this.touch = new rn(this.manager, B), this.mouse = new Nt(this.manager, B), this.primaryTouch = null, this.lastTouches = [];
    }
    b(Va, Ye, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(z, ae, be) {
        var $e = be.pointerType == Z, Ge = be.pointerType == H;
        if (!(Ge && be.sourceCapabilities && be.sourceCapabilities.firesTouchEvents)) {
          if ($e)
            Er.call(this, ae, be);
          else if (Ge && kn.call(this, be))
            return;
          this.callback(z, ae, be);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function Er(B, z) {
      B & we ? (this.primaryTouch = z.changedPointers[0].identifier, an.call(this, z)) : B & (Ve | et) && an.call(this, z);
    }
    function an(B) {
      var z = B.changedPointers[0];
      if (z.identifier === this.primaryTouch) {
        var ae = { x: z.clientX, y: z.clientY };
        this.lastTouches.push(ae);
        var be = this.lastTouches, $e = function() {
          var Ge = be.indexOf(ae);
          Ge > -1 && be.splice(Ge, 1);
        };
        setTimeout($e, pi);
      }
    }
    function kn(B) {
      for (var z = B.srcEvent.clientX, ae = B.srcEvent.clientY, be = 0; be < this.lastTouches.length; be++) {
        var $e = this.lastTouches[be], Ge = Math.abs(z - $e.x), Et = Math.abs(ae - $e.y);
        if (Ge <= Cn && Et <= Cn)
          return !0;
      }
      return !1;
    }
    var Pn = D(s.style, "touchAction"), Xn = Pn !== n, Kn = "compute", Or = "auto", Mn = "manipulation", xa = "none", wa = "pan-x", Ta = "pan-y", Ua = Jn();
    function lr(B, z) {
      this.manager = B, this.set(z);
    }
    lr.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(B) {
        B == Kn && (B = this.compute()), Xn && this.manager.element.style && Ua[B] && (this.manager.element.style[Pn] = B), this.actions = B.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var B = [];
        return p(this.manager.recognizers, function(z) {
          _(z.options.enable, [z]) && (B = B.concat(z.getTouchAction()));
        }), vi(B.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(B) {
        var z = B.srcEvent, ae = B.offsetDirection;
        if (this.manager.session.prevented) {
          z.preventDefault();
          return;
        }
        var be = this.actions, $e = P(be, xa) && !Ua[xa], Ge = P(be, Ta) && !Ua[Ta], Et = P(be, wa) && !Ua[wa];
        if ($e) {
          var te = B.pointers.length === 1, ce = B.distance < 2, ge = B.deltaTime < 250;
          if (te && ce && ge)
            return;
        }
        if (!(Et && Ge) && ($e || Ge && ae & Se || Et && ae & Re))
          return this.preventSrc(z);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(B) {
        this.manager.session.prevented = !0, B.preventDefault();
      }
    };
    function vi(B) {
      if (P(B, xa))
        return xa;
      var z = P(B, wa), ae = P(B, Ta);
      return z && ae ? xa : z || ae ? z ? wa : Ta : P(B, Mn) ? Mn : Or;
    }
    function Jn() {
      if (!Xn)
        return !1;
      var B = {}, z = t.CSS && t.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(ae) {
        B[ae] = z ? t.CSS.supports("touch-action", ae) : !0;
      }), B;
    }
    var nn = 1, Vr = 2, Ra = 4, qr = 8, Ur = qr, da = 16, hr = 32;
    function Kr(B) {
      this.options = h({}, this.defaults, B || {}), this.id = I(), this.manager = null, this.options.enable = x(this.options.enable, !0), this.state = nn, this.simultaneous = {}, this.requireFail = [];
    }
    Kr.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(B) {
        return h(this.options, B), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(B) {
        if (c(B, "recognizeWith", this))
          return this;
        var z = this.simultaneous;
        return B = on(B, this), z[B.id] || (z[B.id] = B, B.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(B) {
        return c(B, "dropRecognizeWith", this) ? this : (B = on(B, this), delete this.simultaneous[B.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(B) {
        if (c(B, "requireFailure", this))
          return this;
        var z = this.requireFail;
        return B = on(B, this), E(z, B) === -1 && (z.push(B), B.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(B) {
        if (c(B, "dropRequireFailure", this))
          return this;
        B = on(B, this);
        var z = E(this.requireFail, B);
        return z > -1 && this.requireFail.splice(z, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(B) {
        return !!this.simultaneous[B.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(B) {
        var z = this, ae = this.state;
        function be($e) {
          z.manager.emit($e, B);
        }
        ae < qr && be(z.options.event + Qn(ae)), be(z.options.event), B.additionalEvent && be(B.additionalEvent), ae >= qr && be(z.options.event + Qn(ae));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(B) {
        if (this.canEmit())
          return this.emit(B);
        this.state = hr;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var B = 0; B < this.requireFail.length; ) {
          if (!(this.requireFail[B].state & (hr | nn)))
            return !1;
          B++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(B) {
        var z = h({}, B);
        if (!_(this.options.enable, [this, z])) {
          this.reset(), this.state = hr;
          return;
        }
        this.state & (Ur | da | hr) && (this.state = nn), this.state = this.process(z), this.state & (Vr | Ra | qr | da) && this.tryEmit(z);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(B) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function Qn(B) {
      return B & da ? "cancel" : B & qr ? "end" : B & Ra ? "move" : B & Vr ? "start" : "";
    }
    function sn(B) {
      return B == _e ? "down" : B == se ? "up" : B == xe ? "left" : B == J ? "right" : "";
    }
    function on(B, z) {
      var ae = z.manager;
      return ae ? ae.get(B) : B;
    }
    function Dr() {
      Kr.apply(this, arguments);
    }
    b(Dr, Kr, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(B) {
        var z = this.options.pointers;
        return z === 0 || B.pointers.length === z;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(B) {
        var z = this.state, ae = B.eventType, be = z & (Vr | Ra), $e = this.attrTest(B);
        return be && (ae & et || !$e) ? z | da : be || $e ? ae & Ve ? z | qr : z & Vr ? z | Ra : Vr : hr;
      }
    });
    function Xt() {
      Dr.apply(this, arguments), this.pX = null, this.pY = null;
    }
    b(Xt, Dr, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: rt
      },
      getTouchAction: function() {
        var B = this.options.direction, z = [];
        return B & Se && z.push(Ta), B & Re && z.push(wa), z;
      },
      directionTest: function(B) {
        var z = this.options, ae = !0, be = B.distance, $e = B.direction, Ge = B.deltaX, Et = B.deltaY;
        return $e & z.direction || (z.direction & Se ? ($e = Ge === 0 ? nt : Ge < 0 ? xe : J, ae = Ge != this.pX, be = Math.abs(B.deltaX)) : ($e = Et === 0 ? nt : Et < 0 ? se : _e, ae = Et != this.pY, be = Math.abs(B.deltaY))), B.direction = $e, ae && be > z.threshold && $e & z.direction;
      },
      attrTest: function(B) {
        return Dr.prototype.attrTest.call(this, B) && (this.state & Vr || !(this.state & Vr) && this.directionTest(B));
      },
      emit: function(B) {
        this.pX = B.deltaX, this.pY = B.deltaY;
        var z = sn(B.direction);
        z && (B.additionalEvent = this.options.event + z), this._super.emit.call(this, B);
      }
    });
    function ia() {
      Dr.apply(this, arguments);
    }
    b(ia, Dr, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [xa];
      },
      attrTest: function(B) {
        return this._super.attrTest.call(this, B) && (Math.abs(B.scale - 1) > this.options.threshold || this.state & Vr);
      },
      emit: function(B) {
        if (B.scale !== 1) {
          var z = B.scale < 1 ? "in" : "out";
          B.additionalEvent = this.options.event + z;
        }
        this._super.emit.call(this, B);
      }
    });
    function Sa() {
      Kr.apply(this, arguments), this._timer = null, this._input = null;
    }
    b(Sa, Kr, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [Or];
      },
      process: function(B) {
        var z = this.options, ae = B.pointers.length === z.pointers, be = B.distance < z.threshold, $e = B.deltaTime > z.time;
        if (this._input = B, !be || !ae || B.eventType & (Ve | et) && !$e)
          this.reset();
        else if (B.eventType & we)
          this.reset(), this._timer = f(function() {
            this.state = Ur, this.tryEmit();
          }, z.time, this);
        else if (B.eventType & Ve)
          return Ur;
        return hr;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(B) {
        this.state === Ur && (B && B.eventType & Ve ? this.manager.emit(this.options.event + "up", B) : (this._input.timeStamp = d(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function ca() {
      Dr.apply(this, arguments);
    }
    b(ca, Dr, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [xa];
      },
      attrTest: function(B) {
        return this._super.attrTest.call(this, B) && (Math.abs(B.rotation) > this.options.threshold || this.state & Vr);
      }
    });
    function za() {
      Dr.apply(this, arguments);
    }
    b(za, Dr, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: Se | Re,
        pointers: 1
      },
      getTouchAction: function() {
        return Xt.prototype.getTouchAction.call(this);
      },
      attrTest: function(B) {
        var z = this.options.direction, ae;
        return z & (Se | Re) ? ae = B.overallVelocity : z & Se ? ae = B.overallVelocityX : z & Re && (ae = B.overallVelocityY), this._super.attrTest.call(this, B) && z & B.offsetDirection && B.distance > this.options.threshold && B.maxPointers == this.options.pointers && u(ae) > this.options.velocity && B.eventType & Ve;
      },
      emit: function(B) {
        var z = sn(B.offsetDirection);
        z && this.manager.emit(this.options.event + z, B), this.manager.emit(this.options.event, B);
      }
    });
    function Ya() {
      Kr.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    b(Ya, Kr, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [Mn];
      },
      process: function(B) {
        var z = this.options, ae = B.pointers.length === z.pointers, be = B.distance < z.threshold, $e = B.deltaTime < z.time;
        if (this.reset(), B.eventType & we && this.count === 0)
          return this.failTimeout();
        if (be && $e && ae) {
          if (B.eventType != Ve)
            return this.failTimeout();
          var Ge = this.pTime ? B.timeStamp - this.pTime < z.interval : !0, Et = !this.pCenter || Te(this.pCenter, B.center) < z.posThreshold;
          this.pTime = B.timeStamp, this.pCenter = B.center, !Et || !Ge ? this.count = 1 : this.count += 1, this._input = B;
          var te = this.count % z.taps;
          if (te === 0)
            return this.hasRequireFailures() ? (this._timer = f(function() {
              this.state = Ur, this.tryEmit();
            }, z.interval, this), Vr) : Ur;
        }
        return hr;
      },
      failTimeout: function() {
        return this._timer = f(function() {
          this.state = hr;
        }, this.options.interval, this), hr;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == Ur && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function Jr(B, z) {
      return z = z || {}, z.recognizers = x(z.recognizers, Jr.defaults.preset), new ln(B, z);
    }
    Jr.VERSION = "2.0.7", Jr.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: Kn,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [ca, { enable: !1 }],
        [ia, { enable: !1 }, ["rotate"]],
        [za, { direction: Se }],
        [Xt, { direction: Se }, ["swipe"]],
        [Ya],
        [Ya, { event: "doubletap", taps: 2 }, ["tap"]],
        [Sa]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var Ea = 1, An = 2;
    function ln(B, z) {
      this.options = h({}, Jr.defaults, z || {}), this.options.inputTarget = this.options.inputTarget || B, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = B, this.input = at(this), this.touchAction = new lr(this, this.options.touchAction), Oa(this, !0), p(this.options.recognizers, function(ae) {
        var be = this.add(new ae[0](ae[1]));
        ae[2] && be.recognizeWith(ae[2]), ae[3] && be.requireFailure(ae[3]);
      }, this);
    }
    ln.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(B) {
        return h(this.options, B), B.touchAction && this.touchAction.update(), B.inputTarget && (this.input.destroy(), this.input.target = B.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(B) {
        this.session.stopped = B ? An : Ea;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(B) {
        var z = this.session;
        if (!z.stopped) {
          this.touchAction.preventDefaults(B);
          var ae, be = this.recognizers, $e = z.curRecognizer;
          (!$e || $e && $e.state & Ur) && ($e = z.curRecognizer = null);
          for (var Ge = 0; Ge < be.length; )
            ae = be[Ge], z.stopped !== An && // 1
            (!$e || ae == $e || // 2
            ae.canRecognizeWith($e)) ? ae.recognize(B) : ae.reset(), !$e && ae.state & (Vr | Ra | qr) && ($e = z.curRecognizer = ae), Ge++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(B) {
        if (B instanceof Kr)
          return B;
        for (var z = this.recognizers, ae = 0; ae < z.length; ae++)
          if (z[ae].options.event == B)
            return z[ae];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(B) {
        if (c(B, "add", this))
          return this;
        var z = this.get(B.options.event);
        return z && this.remove(z), this.recognizers.push(B), B.manager = this, this.touchAction.update(), B;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(B) {
        if (c(B, "remove", this))
          return this;
        if (B = this.get(B), B) {
          var z = this.recognizers, ae = E(z, B);
          ae !== -1 && (z.splice(ae, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(B, z) {
        if (B !== n && z !== n) {
          var ae = this.handlers;
          return p(A(B), function(be) {
            ae[be] = ae[be] || [], ae[be].push(z);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(B, z) {
        if (B !== n) {
          var ae = this.handlers;
          return p(A(B), function(be) {
            z ? ae[be] && ae[be].splice(E(ae[be], z), 1) : delete ae[be];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(B, z) {
        this.options.domEvents && mi(B, z);
        var ae = this.handlers[B] && this.handlers[B].slice();
        if (!(!ae || !ae.length)) {
          z.type = B, z.preventDefault = function() {
            z.srcEvent.preventDefault();
          };
          for (var be = 0; be < ae.length; )
            ae[be](z), be++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && Oa(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function Oa(B, z) {
      var ae = B.element;
      if (ae.style) {
        var be;
        p(B.options.cssProps, function($e, Ge) {
          be = D(ae.style, Ge), z ? (B.oldCssProps[be] = ae.style[be], ae.style[be] = $e) : ae.style[be] = B.oldCssProps[be] || "";
        }), z || (B.oldCssProps = {});
      }
    }
    function mi(B, z) {
      var ae = r.createEvent("Event");
      ae.initEvent(B, !0, !0), ae.gesture = z, z.target.dispatchEvent(ae);
    }
    h(Jr, {
      INPUT_START: we,
      INPUT_MOVE: Be,
      INPUT_END: Ve,
      INPUT_CANCEL: et,
      STATE_POSSIBLE: nn,
      STATE_BEGAN: Vr,
      STATE_CHANGED: Ra,
      STATE_ENDED: qr,
      STATE_RECOGNIZED: Ur,
      STATE_CANCELLED: da,
      STATE_FAILED: hr,
      DIRECTION_NONE: nt,
      DIRECTION_LEFT: xe,
      DIRECTION_RIGHT: J,
      DIRECTION_UP: se,
      DIRECTION_DOWN: _e,
      DIRECTION_HORIZONTAL: Se,
      DIRECTION_VERTICAL: Re,
      DIRECTION_ALL: rt,
      Manager: ln,
      Input: Ye,
      TouchAction: lr,
      TouchInput: rn,
      MouseInput: Nt,
      PointerEventInput: _t,
      TouchMouseInput: Va,
      SingleTouchInput: yt,
      Recognizer: Kr,
      AttrRecognizer: Dr,
      Tap: Ya,
      Pan: Xt,
      Swipe: za,
      Pinch: ia,
      Rotate: ca,
      Press: Sa,
      on: w,
      off: k,
      each: p,
      merge: m,
      extend: g,
      assign: h,
      inherit: b,
      bindFn: y,
      prefixed: D
    });
    var hi = typeof t < "u" ? t : typeof self < "u" ? self : {};
    hi.Hammer = Jr, typeof n == "function" && n.amd ? n(function() {
      return Jr;
    }) : e.exports ? e.exports = Jr : t[a] = Jr;
  })(window, document, "Hammer");
})(VD);
const UD = (e) => (nT("data-v-78eb7227"), e = e(), iT(), e), zD = /* @__PURE__ */ UD(() => /* @__PURE__ */ ue("div", { class: "h-32" }, [
  /* @__PURE__ */ ue("div", { class: "relative top-12 mx-auto h-4 w-60 rounded-md bg-gray-300" })
], -1)), YD = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JBottomSheetContent",
  props: {
    backgroundColor: { default: "white" },
    fullScreen: { type: Boolean, default: !1 },
    modelValue: { type: Boolean },
    disableSwipe: { type: Boolean, default: !1 },
    persist: { type: Boolean, default: !1 },
    stickyHeader: { type: Boolean, default: !1 },
    stickyFooter: { type: Boolean, default: !1 },
    contentClass: { default: "" },
    keepMounted: { type: Boolean },
    hasPopstate: { type: Boolean, default: !1 },
    onBeforeClose: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = ne(!1), o = Vn()("footer"), { uid: l, isOnTop: u, zIndex: d } = G1({
      type: "bottom-sheet",
      isOpen: n
    }), f = ne(null), c = ne(null), p = ne(null), { width: v, height: h } = cT({
      listenOrientation: !0
    }), g = ne(-document.body.scrollHeight), m = ne(0);
    function b() {
      g.value = -document.body.scrollHeight;
    }
    function y() {
      var G, H, W;
      const q = ((G = f.value) == null ? void 0 : G.offsetHeight) ?? 0, le = ((H = c.value) == null ? void 0 : H.scrollHeight) ?? 0, Z = ((W = p.value) == null ? void 0 : W.offsetHeight) ?? 0;
      return le + q + Z;
    }
    function _() {
      c.value && (m.value = -y(), T(n.value));
    }
    uT(c, () => {
      _();
    }), He(v, b), He(h, _);
    const x = N(
      () => r.fullScreen ? (h.value || v.value) && -window.innerHeight : Math.min(m.value, window.innerHeight)
    ), w = N(() => r.fullScreen ? "lg:w-full" : "lg:w-8/12"), k = N(() => !r.fullScreen && "rounded-t-xl"), S = N(
      () => T_ - g.value / x.value * T_
    ), P = () => n.value = !1, { currentLocaleItem: A } = Ii(), E = N(() => n.value && "shadow-md"), O = N(() => {
      const q = g.value, le = x.value, Z = n.value, G = A.value.rtl ? "50%" : "-50%", H = Z ? `${Math.abs(q)}px` : "100%", W = `translate(${G}, ${H})`, ie = Math.min(h.value, Math.abs(le)), we = Z && r.fullScreen ? "100%" : `${ie}px`;
      return {
        transform: W,
        height: we,
        zIndex: d.value,
        top: r.fullScreen ? 0 : ""
      };
    });
    function T(q) {
      if (q) {
        g.value = 0;
        return;
      }
      b();
    }
    He(n, T);
    function D() {
      if (!f.value || !(f.value instanceof HTMLElement))
        return;
      const q = new Hammer(f.value, {});
      q.get("pan").set({ direction: Hammer.DIRECTION_VERTICAL }), q.on("pan", (le) => {
        const Z = le.deltaY;
        if (Z > 0 && (g.value = 0 - Z), !!le.isFinal) {
          if (le.velocityY > 0.6) {
            M();
            return;
          }
          g.value <= m.value * 0.6 ? M() : g.value = 0;
        }
      }), q.on("panstart", () => {
        i.value = !0;
      }), q.on("panend", () => {
        i.value = !1;
      });
    }
    ct(() => {
      r.disableSwipe || D();
    });
    function $() {
      document.body.style.overflowY = "hidden", document.body.classList.add("no-touch-interaction");
    }
    function I() {
      document.body.style.removeProperty("overflow-y"), document.body.classList.remove("no-touch-interaction");
    }
    function F(q) {
      q ? $() : I();
    }
    He(n, F), Ai(I);
    const j = N(() => qa[r.backgroundColor]);
    function M() {
      if (r.persist || typeof r.onBeforeClose == "function" && !r.onBeforeClose()) {
        g.value = 0;
        return;
      }
      P();
    }
    return wM({
      isOnTop: u,
      uid: l.value,
      type: "bottom-sheet",
      persist: r.persist,
      enabled: r.hasPopstate,
      isOpen: n,
      onBeforeClose: r.onBeforeClose,
      onClose: P
    }), (q, le) => (R(), Le(Oo, { to: "body" }, [
      Fe(Hn, {
        enterActiveClass: "transition duration-300 ease-out",
        enterFromClass: "opacity-0",
        enterToClass: "opacity-100",
        leaveActiveClass: "transition duration-200 ease-in",
        leaveFromClass: "opacity-100",
        leaveToClass: "opacity-0"
      }, {
        default: Pe(() => [
          U(n) ? (R(), Le(U(Qd), {
            key: 0,
            opacity: S.value,
            style: Ir({ zIndex: U(d) }),
            onClick: M
          }, null, 8, ["opacity", "style"])) : fe("", !0)
        ]),
        _: 1
      }),
      ue("div", Mt(q.$attrs, {
        class: ["bottom-sheet fixed bottom-0 right-0 start-1/2 flex w-full flex-col overflow-auto", [
          w.value,
          k.value,
          E.value,
          j.value,
          { "transition-transform duration-300": !i.value }
        ]],
        style: O.value
      }), [
        ue("div", {
          ref_key: "handle",
          ref: f,
          class: pe(["flex w-full flex-col", [j.value, { "sticky top-0 z-20": q.stickyHeader }]])
        }, [
          ke(q.$slots, "header", {}, () => [
            zD
          ], !0)
        ], 2),
        ue("div", {
          class: pe({ "flex flex-1": q.fullScreen })
        }, [
          ue("div", {
            ref_key: "content",
            ref: c,
            class: pe(["w-full", [q.contentClass]])
          }, [
            ke(q.$slots, "default", {}, void 0, !0)
          ], 2)
        ], 2),
        U(o) ? (R(), K("div", {
          key: 0,
          ref_key: "footer",
          ref: p,
          class: pe(["flex w-full flex-col", [j.value, { "sticky bottom-0 z-20": q.stickyFooter }]])
        }, [
          ke(q.$slots, "footer", {}, void 0, !0)
        ], 2)) : fe("", !0)
      ], 16)
    ]));
  }
});
const WD = /* @__PURE__ */ rs(YD, [["__scopeId", "data-v-78eb7227"]]), GD = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JBottomSheet",
  props: {
    backgroundColor: {},
    fullScreen: { type: Boolean },
    modelValue: { type: Boolean, default: !1 },
    disableSwipe: { type: Boolean },
    persist: { type: Boolean },
    stickyHeader: { type: Boolean },
    stickyFooter: { type: Boolean },
    contentClass: {},
    keepMounted: { type: Boolean, default: !1 },
    hasPopstate: { type: Boolean },
    onBeforeClose: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = ne(!1), i = ne(!1), s = ne(), o = Vn(), l = o("header"), u = o("footer");
    function d() {
      i.value = !1, s.value = setTimeout(() => {
        r.keepMounted || (n.value = !1), a("update:modelValue", !1);
      }, HD);
    }
    function f() {
      clearTimeout(s.value), n.value = !0, Pt(() => {
        i.value = !0;
      });
    }
    return He(
      () => r.modelValue,
      (c) => {
        c !== i.value && (c ? f() : d());
      },
      { immediate: !0 }
    ), Ai(() => {
      clearTimeout(s.value);
    }), (c, p) => n.value ? (R(), Le(U(WD), Mt({ key: 0 }, { ...r, ...c.$attrs }, {
      modelValue: i.value,
      "onUpdate:modelValue": d
    }), Ma({
      default: Pe(() => [
        ke(c.$slots, "default")
      ]),
      _: 2
    }, [
      U(l) ? {
        name: "header",
        fn: Pe(() => [
          ke(c.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      U(u) ? {
        name: "footer",
        fn: Pe(() => [
          ke(c.$slots, "footer")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["modelValue"])) : fe("", !0);
  }
}), XD = {
  sm: "btn-dropdown--sm",
  md: "btn-dropdown--md",
  lg: "btn-dropdown--lg"
}, KD = {
  sm: 24,
  md: 26,
  lg: 28
}, JD = (e) => (nT("data-v-5d31708d"), e = e(), iT(), e), QD = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform"
}, ZD = /* @__PURE__ */ JD(() => /* @__PURE__ */ ue("div", { class: "flex items-center justify-center" }, [
  /* @__PURE__ */ ue("div", { class: "relative flex items-center justify-center space-x-3" }, [
    /* @__PURE__ */ ue("div", { class: "dot-flashing h-8 w-8 rounded-full" })
  ])
], -1)), eI = [
  ZD
], tI = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JButtonDropdown",
  props: {
    color: { default: "primary" },
    size: { default: "md" },
    variant: { default: "contained" },
    isLoading: { type: Boolean, default: !1 },
    icon: {},
    block: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    to: {},
    href: {},
    iconClass: { default: "" },
    label: { default: "" },
    teleport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, a = Vn()("default"), n = N(
      () => !a && t.icon && t.shrink
    ), i = N(() => t.to ? uu : t.href ? "a" : "button"), s = N(() => {
      if (t.variant === "contained") {
        const _ = {
          primary: "hover:bg-primary-hover focus:bg-primary focus:outline-primary text-white",
          secondary: "hover:bg-secondary focus:bg-secondary focus:outline-secondary text-white",
          danger: n.value ? "bg-danger/20 hover:bg-danger/20 focus:bg-danger/20 focus:outline-danger/20 text-danger" : "hover:bg-danger-hover focus:bg-danger focus:outline-danger text-white",
          success: "hover:bg-success-hover focus:bg-success focus:outline-success text-white",
          dark: "hover:bg-dark-hover focus:bg-dark focus:outline-dark text-white",
          "primary-light": "text-primary",
          warning: n.value ? "bg-warning/20 hover:bg-warning/20 focus:bg-warning/20 focus:outline-warning/20 text-warning" : "hover:bg-warning focus:bg-warning focus:outline-warning text-white",
          white: "text-primary"
        };
        return `border-transparent ${qa[t.color]} ${_[t.color]}`;
      }
      return `bg-transparent disabled:border-gray-400 ${{
        primary: "text-primary border-primary hover:bg-primary focus:bg-primary focus:outline-primary hover:text-white focus:text-white",
        secondary: "text-secondary border-secondary hover:bg-secondary focus:bg-secondary focus:outline-secondary hover:text-white focus:text-white",
        danger: "text-danger border-danger hover:bg-danger focus:bg-danger focus:outline-danger hover:text-white focus:text-white",
        success: "text-success border-success hover:bg-success focus:bg-success focus:outline-success hover:text-white focus:text-white",
        dark: "text-dark border-dark hover:bg-dark focus:bg-dark focus:outline-dark hover:text-white focus:text-white",
        white: "text-gray-500 border-line focus:bg-line focus:outline-line hover:text-dark focus:text-dark"
      }[t.color]}`;
    }), o = N(() => t.shrink ? t.size === "lg" ? "btn--shrink p-12" : "btn--shrink" : XD[t.size]), l = N(() => t.shrink ? a ? 14 : 16 : KD[t.size]), d = Gr()("disabled", !0), f = N(() => d || t.isLoading), c = N(() => t.teleport ? Oo : "div"), p = ne(null), v = ne(null), {
      comboOptionsTop: h,
      comboOptionsTransform: g,
      elementBounding: { left: m, width: b }
    } = W1(p, v, t.teleport);
    return (y, _) => (R(), K("div", {
      ref_key: "buttonRef",
      ref: p,
      class: pe(["relative items-stretch", [
        y.isLoading && "cursor-progress",
        y.block ? "flex w-full" : "inline-flex w-max",
        !y.shrink && "font-medium",
        n.value && "rounded-full",
        f.value && "rounded-md bg-gray-300"
      ]])
    }, [
      (R(), Le(Za(i.value), Mt(y.$attrs, {
        to: y.to,
        "aria-disabled": f.value,
        disabled: f.value,
        href: y.href,
        class: [[
          s.value,
          o.value,
          y.isLoading && "invisible opacity-0",
          y.shrink ? "gap-4" : "gap-8",
          y.block && "flex-1"
        ], "btn flex items-center rounded-s-md !outline-none"]
      }), {
        default: Pe(() => [
          y.icon ? (R(), Le(gt, {
            key: 0,
            size: l.value,
            name: y.icon,
            class: pe(y.iconClass)
          }, null, 8, ["size", "name", "class"])) : fe("", !0),
          ke(y.$slots, "default", {}, () => [
            jt(Ie(y.label), 1)
          ], !0)
        ]),
        _: 3
      }, 16, ["to", "aria-disabled", "disabled", "href", "class"])),
      Fe(U(BA), null, {
        default: Pe(({ open: x }) => [
          Fe(U(qA), {
            class: pe([[s.value, o.value, y.isLoading && "invisible opacity-0"], "btn flex items-center rounded-e-md !outline-none"]),
            "aria-disabled": f.value,
            disabled: f.value
          }, {
            default: Pe(() => [
              Fe(gt, {
                name: "alt-arrow-down-filled",
                class: "rotate-180",
                size: "12"
              })
            ]),
            _: 1
          }, 8, ["class", "aria-disabled", "disabled"]),
          (R(), Le(Za(c.value), jr(oa(y.teleport && { to: "body" })), {
            default: Pe(() => [
              Fe(Hn, {
                enterActiveClass: "transition duration-100 ease-out",
                enterFromClass: "transform scale-95 opacity-0",
                enterToClass: "transform scale-100 opacity-100",
                leaveActiveClass: "transition duration-75 ease-in",
                leaveFromClass: "transform scale-100 opacity-100",
                leaveToClass: "transform scale-95 opacity-0"
              }, {
                default: Pe(() => [
                  ea(ue("div", {
                    ref_key: "dropdownRef",
                    ref: v,
                    class: pe(["absolute z-30 mt-6 flex min-w-max origin-top-left flex-col gap-y-4 divide-y divide-gray-100 rounded-md border border-line bg-white p-4 shadow-lg focus:outline-none", {
                      "top-full ltr:right-0 rtl:left-0": !y.teleport
                    }]),
                    style: Ir({
                      top: U(h),
                      left: y.teleport ? `${U(m)}px` : 0,
                      width: `${U(b)}px`,
                      transform: U(g)
                    })
                  }, [
                    Fe(U(HA), {
                      static: "",
                      disabled: f.value
                    }, {
                      default: Pe(() => [
                        ke(y.$slots, "options", {}, void 0, !0)
                      ]),
                      _: 3
                    }, 8, ["disabled"])
                  ], 6), [
                    [$a, x]
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040))
        ]),
        _: 3
      }),
      y.isLoading ? (R(), K("div", QD, eI)) : fe("", !0)
    ], 2));
  }
});
const boe = /* @__PURE__ */ rs(tI, [["__scopeId", "data-v-5d31708d"]]), yoe = /* @__PURE__ */ Ae({
  __name: "JButtonDropdownItem",
  props: {
    to: {},
    href: {}
  },
  setup(e) {
    const t = e, r = N(() => t.to ? uu : t.href ? "a" : "button"), n = Gr()("disabled", !0), i = N(() => n);
    return (s, o) => (R(), Le(U(VA), {
      is: r.value,
      as: r.value,
      to: s.to,
      "aria-disabled": i.value,
      disabled: i.value,
      href: s.href,
      class: "bg-gray-100 p-8 text-start no-underline hover:bg-gray-200"
    }, {
      default: Pe(() => [
        ke(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["is", "as", "to", "aria-disabled", "disabled", "href"]));
  }
}), rI = { class: "rounded-xl border border-gray-300 bg-white" }, aI = { class: "border-b border-gray-300 p-16" }, nI = {
  key: 0,
  class: "text-subject font-bold text-primary"
}, iI = { class: "p-16" }, _oe = /* @__PURE__ */ Ae({
  __name: "JCard",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, r) => (R(), K("div", rI, [
      ue("div", aI, [
        t.title ? (R(), K("h3", nI, Ie(t.title), 1)) : ke(t.$slots, "header", { key: 1 })
      ]),
      ue("div", iI, [
        ke(t.$slots, "default")
      ])
    ]));
  }
});
function S_(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function nb(e = {}, t = {}) {
  Object.keys(t).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : S_(t[r]) && S_(e[r]) && Object.keys(t[r]).length > 0 && nb(e[r], t[r]);
  });
}
const DS = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function ba() {
  const e = typeof document < "u" ? document : {};
  return nb(e, DS), e;
}
const sI = {
  document: DS,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function Br() {
  const e = typeof window < "u" ? window : {};
  return nb(e, sI), e;
}
function oI(e) {
  const t = e;
  Object.keys(t).forEach((r) => {
    try {
      t[r] = null;
    } catch {
    }
    try {
      delete t[r];
    } catch {
    }
  });
}
function Ms(e, t = 0) {
  return setTimeout(e, t);
}
function vn() {
  return Date.now();
}
function lI(e) {
  const t = Br();
  let r;
  return t.getComputedStyle && (r = t.getComputedStyle(e, null)), !r && e.currentStyle && (r = e.currentStyle), r || (r = e.style), r;
}
function jp(e, t = "x") {
  const r = Br();
  let a, n, i;
  const s = lI(e);
  return r.WebKitCSSMatrix ? (n = s.transform || s.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((o) => o.replace(",", ".")).join(", ")), i = new r.WebKitCSSMatrix(n === "none" ? "" : n)) : (i = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), a = i.toString().split(",")), t === "x" && (r.WebKitCSSMatrix ? n = i.m41 : a.length === 16 ? n = parseFloat(a[12]) : n = parseFloat(a[4])), t === "y" && (r.WebKitCSSMatrix ? n = i.m42 : a.length === 16 ? n = parseFloat(a[13]) : n = parseFloat(a[5])), n || 0;
}
function kl(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function uI(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function Ga(...e) {
  const t = Object(e[0]), r = ["__proto__", "constructor", "prototype"];
  for (let a = 1; a < e.length; a += 1) {
    const n = e[a];
    if (n != null && !uI(n)) {
      const i = Object.keys(Object(n)).filter((s) => r.indexOf(s) < 0);
      for (let s = 0, o = i.length; s < o; s += 1) {
        const l = i[s], u = Object.getOwnPropertyDescriptor(n, l);
        u !== void 0 && u.enumerable && (kl(t[l]) && kl(n[l]) ? n[l].__swiper__ ? t[l] = n[l] : Ga(t[l], n[l]) : !kl(t[l]) && kl(n[l]) ? (t[l] = {}, n[l].__swiper__ ? t[l] = n[l] : Ga(t[l], n[l])) : t[l] = n[l]);
      }
    }
  }
  return t;
}
function Pl(e, t, r) {
  e.style.setProperty(t, r);
}
function IS({
  swiper: e,
  targetPosition: t,
  side: r
}) {
  const a = Br(), n = -e.translate;
  let i = null, s;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", a.cancelAnimationFrame(e.cssModeFrameID);
  const l = t > n ? "next" : "prev", u = (f, c) => l === "next" && f >= c || l === "prev" && f <= c, d = () => {
    s = (/* @__PURE__ */ new Date()).getTime(), i === null && (i = s);
    const f = Math.max(Math.min((s - i) / o, 1), 0), c = 0.5 - Math.cos(f * Math.PI) / 2;
    let p = n + c * (t - n);
    if (u(p, t) && (p = t), e.wrapperEl.scrollTo({
      [r]: p
    }), u(p, t)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [r]: p
        });
      }), a.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = a.requestAnimationFrame(d);
  };
  d();
}
function $s(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowEl && e.shadowEl.querySelector(".swiper-slide-transform") || e;
}
function ha(e, t = "") {
  return [...e.children].filter((r) => r.matches(t));
}
function Ln(e, t = []) {
  const r = document.createElement(e);
  return r.classList.add(...Array.isArray(t) ? t : [t]), r;
}
function _d(e) {
  const t = Br(), r = ba(), a = e.getBoundingClientRect(), n = r.body, i = e.clientTop || n.clientTop || 0, s = e.clientLeft || n.clientLeft || 0, o = e === t ? t.scrollY : e.scrollTop, l = e === t ? t.scrollX : e.scrollLeft;
  return {
    top: a.top + o - i,
    left: a.left + l - s
  };
}
function dI(e, t) {
  const r = [];
  for (; e.previousElementSibling; ) {
    const a = e.previousElementSibling;
    t ? a.matches(t) && r.push(a) : r.push(a), e = a;
  }
  return r;
}
function cI(e, t) {
  const r = [];
  for (; e.nextElementSibling; ) {
    const a = e.nextElementSibling;
    t ? a.matches(t) && r.push(a) : r.push(a), e = a;
  }
  return r;
}
function Wi(e, t) {
  return Br().getComputedStyle(e, null).getPropertyValue(t);
}
function Gl(e) {
  let t = e, r;
  if (t) {
    for (r = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (r += 1);
    return r;
  }
}
function Es(e, t) {
  const r = [];
  let a = e.parentElement;
  for (; a; )
    t ? a.matches(t) && r.push(a) : r.push(a), a = a.parentElement;
  return r;
}
function Nl(e, t) {
  function r(a) {
    a.target === e && (t.call(e, a), e.removeEventListener("transitionend", r));
  }
  t && e.addEventListener("transitionend", r);
}
function Fp(e, t, r) {
  const a = Br();
  return r ? e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(a.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(a.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
let Tf;
function fI() {
  const e = Br(), t = ba();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function NS() {
  return Tf || (Tf = fI()), Tf;
}
let Sf;
function pI({
  userAgent: e
} = {}) {
  const t = NS(), r = Br(), a = r.navigator.platform, n = e || r.navigator.userAgent, i = {
    ios: !1,
    android: !1
  }, s = r.screen.width, o = r.screen.height, l = n.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = n.match(/(iPad).*OS\s([\d_]+)/);
  const d = n.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/), c = a === "Win32";
  let p = a === "MacIntel";
  const v = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && t.touch && v.indexOf(`${s}x${o}`) >= 0 && (u = n.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), l && !c && (i.os = "android", i.android = !0), (u || f || d) && (i.os = "ios", i.ios = !0), i;
}
function vI(e = {}) {
  return Sf || (Sf = pI(e)), Sf;
}
let Ef;
function mI() {
  const e = Br();
  let t = !1;
  function r() {
    const a = e.navigator.userAgent.toLowerCase();
    return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0;
  }
  if (r()) {
    const a = String(e.navigator.userAgent);
    if (a.includes("Version/")) {
      const [n, i] = a.split("Version/")[1].split(" ")[0].split(".").map((s) => Number(s));
      t = n < 16 || n === 16 && i < 2;
    }
  }
  return {
    isSafari: t || r(),
    needPerspectiveFix: t,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function hI() {
  return Ef || (Ef = mI()), Ef;
}
function gI({
  swiper: e,
  on: t,
  emit: r
}) {
  const a = Br();
  let n = null, i = null;
  const s = () => {
    !e || e.destroyed || !e.initialized || (r("beforeResize"), r("resize"));
  }, o = () => {
    !e || e.destroyed || !e.initialized || (n = new ResizeObserver((d) => {
      i = a.requestAnimationFrame(() => {
        const {
          width: f,
          height: c
        } = e;
        let p = f, v = c;
        d.forEach(({
          contentBoxSize: h,
          contentRect: g,
          target: m
        }) => {
          m && m !== e.el || (p = g ? g.width : (h[0] || h).inlineSize, v = g ? g.height : (h[0] || h).blockSize);
        }), (p !== f || v !== c) && s();
      });
    }), n.observe(e.el));
  }, l = () => {
    i && a.cancelAnimationFrame(i), n && n.unobserve && e.el && (n.unobserve(e.el), n = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || r("orientationchange");
  };
  t("init", () => {
    if (e.params.resizeObserver && typeof a.ResizeObserver < "u") {
      o();
      return;
    }
    a.addEventListener("resize", s), a.addEventListener("orientationchange", u);
  }), t("destroy", () => {
    l(), a.removeEventListener("resize", s), a.removeEventListener("orientationchange", u);
  });
}
function bI({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = [], i = Br(), s = (u, d = {}) => {
    const f = i.MutationObserver || i.WebkitMutationObserver, c = new f((p) => {
      if (e.__preventObserver__)
        return;
      if (p.length === 1) {
        a("observerUpdate", p[0]);
        return;
      }
      const v = function() {
        a("observerUpdate", p[0]);
      };
      i.requestAnimationFrame ? i.requestAnimationFrame(v) : i.setTimeout(v, 0);
    });
    c.observe(u, {
      attributes: typeof d.attributes > "u" ? !0 : d.attributes,
      childList: typeof d.childList > "u" ? !0 : d.childList,
      characterData: typeof d.characterData > "u" ? !0 : d.characterData
    }), n.push(c);
  }, o = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = Es(e.el);
        for (let d = 0; d < u.length; d += 1)
          s(u[d]);
      }
      s(e.el, {
        childList: e.params.observeSlideChildren
      }), s(e.wrapperEl, {
        attributes: !1
      });
    }
  }, l = () => {
    n.forEach((u) => {
      u.disconnect();
    }), n.splice(0, n.length);
  };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", o), r("destroy", l);
}
const yI = {
  on(e, t, r) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof t != "function")
      return a;
    const n = r ? "unshift" : "push";
    return e.split(" ").forEach((i) => {
      a.eventsListeners[i] || (a.eventsListeners[i] = []), a.eventsListeners[i][n](t);
    }), a;
  },
  once(e, t, r) {
    const a = this;
    if (!a.eventsListeners || a.destroyed || typeof t != "function")
      return a;
    function n(...i) {
      a.off(e, n), n.__emitterProxy && delete n.__emitterProxy, t.apply(a, i);
    }
    return n.__emitterProxy = t, a.on(e, n, r);
  },
  onAny(e, t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function")
      return r;
    const a = t ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[a](e), r;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners)
      return t;
    const r = t.eventsAnyListeners.indexOf(e);
    return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
  },
  off(e, t) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || e.split(" ").forEach((a) => {
      typeof t > "u" ? r.eventsListeners[a] = [] : r.eventsListeners[a] && r.eventsListeners[a].forEach((n, i) => {
        (n === t || n.__emitterProxy && n.__emitterProxy === t) && r.eventsListeners[a].splice(i, 1);
      });
    }), r;
  },
  emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners)
      return t;
    let r, a, n;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (r = e[0], a = e.slice(1, e.length), n = t) : (r = e[0].events, a = e[0].data, n = e[0].context || t), a.unshift(n), (Array.isArray(r) ? r : r.split(" ")).forEach((s) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((o) => {
        o.apply(n, [s, ...a]);
      }), t.eventsListeners && t.eventsListeners[s] && t.eventsListeners[s].forEach((o) => {
        o.apply(n, a);
      });
    }), t;
  }
};
function _I() {
  const e = this;
  let t, r;
  const a = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = a.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? r = e.params.height : r = a.clientHeight, !(t === 0 && e.isHorizontal() || r === 0 && e.isVertical()) && (t = t - parseInt(Wi(a, "padding-left") || 0, 10) - parseInt(Wi(a, "padding-right") || 0, 10), r = r - parseInt(Wi(a, "padding-top") || 0, 10) - parseInt(Wi(a, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(r) && (r = 0), Object.assign(e, {
    width: t,
    height: r,
    size: e.isHorizontal() ? t : r
  }));
}
function xI() {
  const e = this;
  function t(E) {
    return e.isHorizontal() ? E : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[E];
  }
  function r(E, O) {
    return parseFloat(E.getPropertyValue(t(O)) || 0);
  }
  const a = e.params, {
    wrapperEl: n,
    slidesEl: i,
    size: s,
    rtlTranslate: o,
    wrongRTL: l
  } = e, u = e.virtual && a.virtual.enabled, d = u ? e.virtual.slides.length : e.slides.length, f = ha(i, `.${e.params.slideClass}, swiper-slide`), c = u ? e.virtual.slides.length : f.length;
  let p = [];
  const v = [], h = [];
  let g = a.slidesOffsetBefore;
  typeof g == "function" && (g = a.slidesOffsetBefore.call(e));
  let m = a.slidesOffsetAfter;
  typeof m == "function" && (m = a.slidesOffsetAfter.call(e));
  const b = e.snapGrid.length, y = e.slidesGrid.length;
  let _ = a.spaceBetween, x = -g, w = 0, k = 0;
  if (typeof s > "u")
    return;
  typeof _ == "string" && _.indexOf("%") >= 0 ? _ = parseFloat(_.replace("%", "")) / 100 * s : typeof _ == "string" && (_ = parseFloat(_)), e.virtualSize = -_, f.forEach((E) => {
    o ? E.style.marginLeft = "" : E.style.marginRight = "", E.style.marginBottom = "", E.style.marginTop = "";
  }), a.centeredSlides && a.cssMode && (Pl(n, "--swiper-centered-offset-before", ""), Pl(n, "--swiper-centered-offset-after", ""));
  const S = a.grid && a.grid.rows > 1 && e.grid;
  S && e.grid.initSlides(c);
  let P;
  const A = a.slidesPerView === "auto" && a.breakpoints && Object.keys(a.breakpoints).filter((E) => typeof a.breakpoints[E].slidesPerView < "u").length > 0;
  for (let E = 0; E < c; E += 1) {
    P = 0;
    let O;
    if (f[E] && (O = f[E]), S && e.grid.updateSlide(E, O, c, t), !(f[E] && Wi(O, "display") === "none")) {
      if (a.slidesPerView === "auto") {
        A && (f[E].style[t("width")] = "");
        const T = getComputedStyle(O), D = O.style.transform, $ = O.style.webkitTransform;
        if (D && (O.style.transform = "none"), $ && (O.style.webkitTransform = "none"), a.roundLengths)
          P = e.isHorizontal() ? Fp(O, "width", !0) : Fp(O, "height", !0);
        else {
          const I = r(T, "width"), F = r(T, "padding-left"), j = r(T, "padding-right"), M = r(T, "margin-left"), q = r(T, "margin-right"), le = T.getPropertyValue("box-sizing");
          if (le && le === "border-box")
            P = I + M + q;
          else {
            const {
              clientWidth: Z,
              offsetWidth: G
            } = O;
            P = I + F + j + M + q + (G - Z);
          }
        }
        D && (O.style.transform = D), $ && (O.style.webkitTransform = $), a.roundLengths && (P = Math.floor(P));
      } else
        P = (s - (a.slidesPerView - 1) * _) / a.slidesPerView, a.roundLengths && (P = Math.floor(P)), f[E] && (f[E].style[t("width")] = `${P}px`);
      f[E] && (f[E].swiperSlideSize = P), h.push(P), a.centeredSlides ? (x = x + P / 2 + w / 2 + _, w === 0 && E !== 0 && (x = x - s / 2 - _), E === 0 && (x = x - s / 2 - _), Math.abs(x) < 1 / 1e3 && (x = 0), a.roundLengths && (x = Math.floor(x)), k % a.slidesPerGroup === 0 && p.push(x), v.push(x)) : (a.roundLengths && (x = Math.floor(x)), (k - Math.min(e.params.slidesPerGroupSkip, k)) % e.params.slidesPerGroup === 0 && p.push(x), v.push(x), x = x + P + _), e.virtualSize += P + _, w = P, k += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, s) + m, o && l && (a.effect === "slide" || a.effect === "coverflow") && (n.style.width = `${e.virtualSize + _}px`), a.setWrapperSize && (n.style[t("width")] = `${e.virtualSize + _}px`), S && e.grid.updateWrapperSize(P, p, t), !a.centeredSlides) {
    const E = [];
    for (let O = 0; O < p.length; O += 1) {
      let T = p[O];
      a.roundLengths && (T = Math.floor(T)), p[O] <= e.virtualSize - s && E.push(T);
    }
    p = E, Math.floor(e.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - s);
  }
  if (u && a.loop) {
    const E = h[0] + _;
    if (a.slidesPerGroup > 1) {
      const O = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / a.slidesPerGroup), T = E * a.slidesPerGroup;
      for (let D = 0; D < O; D += 1)
        p.push(p[p.length - 1] + T);
    }
    for (let O = 0; O < e.virtual.slidesBefore + e.virtual.slidesAfter; O += 1)
      a.slidesPerGroup === 1 && p.push(p[p.length - 1] + E), v.push(v[v.length - 1] + E), e.virtualSize += E;
  }
  if (p.length === 0 && (p = [0]), _ !== 0) {
    const E = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
    f.filter((O, T) => !a.cssMode || a.loop ? !0 : T !== f.length - 1).forEach((O) => {
      O.style[E] = `${_}px`;
    });
  }
  if (a.centeredSlides && a.centeredSlidesBounds) {
    let E = 0;
    h.forEach((T) => {
      E += T + (_ || 0);
    }), E -= _;
    const O = E - s;
    p = p.map((T) => T <= 0 ? -g : T > O ? O + m : T);
  }
  if (a.centerInsufficientSlides) {
    let E = 0;
    if (h.forEach((O) => {
      E += O + (_ || 0);
    }), E -= _, E < s) {
      const O = (s - E) / 2;
      p.forEach((T, D) => {
        p[D] = T - O;
      }), v.forEach((T, D) => {
        v[D] = T + O;
      });
    }
  }
  if (Object.assign(e, {
    slides: f,
    snapGrid: p,
    slidesGrid: v,
    slidesSizesGrid: h
  }), a.centeredSlides && a.cssMode && !a.centeredSlidesBounds) {
    Pl(n, "--swiper-centered-offset-before", `${-p[0]}px`), Pl(n, "--swiper-centered-offset-after", `${e.size / 2 - h[h.length - 1] / 2}px`);
    const E = -e.snapGrid[0], O = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((T) => T + E), e.slidesGrid = e.slidesGrid.map((T) => T + O);
  }
  if (c !== d && e.emit("slidesLengthChange"), p.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), v.length !== y && e.emit("slidesGridLengthChange"), a.watchSlidesProgress && e.updateSlidesOffset(), !u && !a.cssMode && (a.effect === "slide" || a.effect === "fade")) {
    const E = `${a.containerModifierClass}backface-hidden`, O = e.el.classList.contains(E);
    c <= a.maxBackfaceHiddenSlides ? O || e.el.classList.add(E) : O && e.el.classList.remove(E);
  }
}
function wI(e) {
  const t = this, r = [], a = t.virtual && t.params.virtual.enabled;
  let n = 0, i;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const s = (o) => a ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        r.push(o);
      });
    else
      for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        const o = t.activeIndex + i;
        if (o > t.slides.length && !a)
          break;
        r.push(s(o));
      }
  else
    r.push(s(t.activeIndex));
  for (i = 0; i < r.length; i += 1)
    if (typeof r[i] < "u") {
      const o = r[i].offsetHeight;
      n = o > n ? o : n;
    }
  (n || n === 0) && (t.wrapperEl.style.height = `${n}px`);
}
function TI() {
  const e = this, t = e.slides, r = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let a = 0; a < t.length; a += 1)
    t[a].swiperSlideOffset = (e.isHorizontal() ? t[a].offsetLeft : t[a].offsetTop) - r - e.cssOverflowAdjustment();
}
function SI(e = this && this.translate || 0) {
  const t = this, r = t.params, {
    slides: a,
    rtlTranslate: n,
    snapGrid: i
  } = t;
  if (a.length === 0)
    return;
  typeof a[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let s = -e;
  n && (s = e), a.forEach((l) => {
    l.classList.remove(r.slideVisibleClass);
  }), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = r.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < a.length; l += 1) {
    const u = a[l];
    let d = u.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (d -= a[0].swiperSlideOffset);
    const f = (s + (r.centeredSlides ? t.minTranslate() : 0) - d) / (u.swiperSlideSize + o), c = (s - i[0] + (r.centeredSlides ? t.minTranslate() : 0) - d) / (u.swiperSlideSize + o), p = -(s - d), v = p + t.slidesSizesGrid[l];
    (p >= 0 && p < t.size - 1 || v > 1 && v <= t.size || p <= 0 && v >= t.size) && (t.visibleSlides.push(u), t.visibleSlidesIndexes.push(l), a[l].classList.add(r.slideVisibleClass)), u.progress = n ? -f : f, u.originalProgress = n ? -c : c;
  }
}
function EI(e) {
  const t = this;
  if (typeof e > "u") {
    const d = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * d || 0;
  }
  const r = t.params, a = t.maxTranslate() - t.minTranslate();
  let {
    progress: n,
    isBeginning: i,
    isEnd: s,
    progressLoop: o
  } = t;
  const l = i, u = s;
  if (a === 0)
    n = 0, i = !0, s = !0;
  else {
    n = (e - t.minTranslate()) / a;
    const d = Math.abs(e - t.minTranslate()) < 1, f = Math.abs(e - t.maxTranslate()) < 1;
    i = d || n <= 0, s = f || n >= 1, d && (n = 0), f && (n = 1);
  }
  if (r.loop) {
    const d = t.getSlideIndexByData(0), f = t.getSlideIndexByData(t.slides.length - 1), c = t.slidesGrid[d], p = t.slidesGrid[f], v = t.slidesGrid[t.slidesGrid.length - 1], h = Math.abs(e);
    h >= c ? o = (h - c) / v : o = (h + v - p) / v, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: n,
    progressLoop: o,
    isBeginning: i,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), i && !l && t.emit("reachBeginning toEdge"), s && !u && t.emit("reachEnd toEdge"), (l && !i || u && !s) && t.emit("fromEdge"), t.emit("progress", n);
}
function OI() {
  const e = this, {
    slides: t,
    params: r,
    slidesEl: a,
    activeIndex: n
  } = e, i = e.virtual && r.virtual.enabled, s = (l) => ha(a, `.${r.slideClass}${l}, swiper-slide${l}`)[0];
  t.forEach((l) => {
    l.classList.remove(r.slideActiveClass, r.slideNextClass, r.slidePrevClass);
  });
  let o;
  if (i)
    if (r.loop) {
      let l = n - e.virtual.slidesBefore;
      l < 0 && (l = e.virtual.slides.length + l), l >= e.virtual.slides.length && (l -= e.virtual.slides.length), o = s(`[data-swiper-slide-index="${l}"]`);
    } else
      o = s(`[data-swiper-slide-index="${n}"]`);
  else
    o = t[n];
  if (o) {
    o.classList.add(r.slideActiveClass);
    let l = cI(o, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !l && (l = t[0]), l && l.classList.add(r.slideNextClass);
    let u = dI(o, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !u === 0 && (u = t[t.length - 1]), u && u.classList.add(r.slidePrevClass);
  }
  e.emitSlidesClasses();
}
const id = (e, t) => {
  if (!e || e.destroyed || !e.params)
    return;
  const r = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, a = t.closest(r());
  if (a) {
    const n = a.querySelector(`.${e.params.lazyPreloaderClass}`);
    n && n.remove();
  }
}, Of = (e, t) => {
  if (!e.slides[t])
    return;
  const r = e.slides[t].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, Bp = (e) => {
  if (!e || e.destroyed || !e.params)
    return;
  let t = e.params.lazyPreloadPrevNext;
  const r = e.slides.length;
  if (!r || !t || t < 0)
    return;
  t = Math.min(t, r);
  const a = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), n = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const s = n, o = [s - t];
    o.push(...Array.from({
      length: t
    }).map((l, u) => s + a + u)), e.slides.forEach((l, u) => {
      o.includes(l.column) && Of(e, u);
    });
    return;
  }
  const i = n + a - 1;
  if (e.params.rewind || e.params.loop)
    for (let s = n - t; s <= i + t; s += 1) {
      const o = (s % r + r) % r;
      (o < n || o > i) && Of(e, o);
    }
  else
    for (let s = Math.max(n - t, 0); s <= Math.min(i + t, r - 1); s += 1)
      s !== n && (s > i || s < n) && Of(e, s);
};
function CI(e) {
  const {
    slidesGrid: t,
    params: r
  } = e, a = e.rtlTranslate ? e.translate : -e.translate;
  let n;
  for (let i = 0; i < t.length; i += 1)
    typeof t[i + 1] < "u" ? a >= t[i] && a < t[i + 1] - (t[i + 1] - t[i]) / 2 ? n = i : a >= t[i] && a < t[i + 1] && (n = i + 1) : a >= t[i] && (n = i);
  return r.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function kI(e) {
  const t = this, r = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: a,
    params: n,
    activeIndex: i,
    realIndex: s,
    snapIndex: o
  } = t;
  let l = e, u;
  const d = (c) => {
    let p = c - t.virtual.slidesBefore;
    return p < 0 && (p = t.virtual.slides.length + p), p >= t.virtual.slides.length && (p -= t.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = CI(t)), a.indexOf(r) >= 0)
    u = a.indexOf(r);
  else {
    const c = Math.min(n.slidesPerGroupSkip, l);
    u = c + Math.floor((l - c) / n.slidesPerGroup);
  }
  if (u >= a.length && (u = a.length - 1), l === i) {
    u !== o && (t.snapIndex = u, t.emit("snapIndexChange")), t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = d(l));
    return;
  }
  let f;
  t.virtual && n.virtual.enabled && n.loop ? f = d(l) : t.slides[l] ? f = parseInt(t.slides[l].getAttribute("data-swiper-slide-index") || l, 10) : f = l, Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: u,
    previousRealIndex: s,
    realIndex: f,
    previousIndex: i,
    activeIndex: l
  }), t.initialized && Bp(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), s !== f && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
}
function PI(e) {
  const t = this, r = t.params, a = e.closest(`.${r.slideClass}, swiper-slide`);
  let n = !1, i;
  if (a) {
    for (let s = 0; s < t.slides.length; s += 1)
      if (t.slides[s] === a) {
        n = !0, i = s;
        break;
      }
  }
  if (a && n)
    t.clickedSlide = a, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(a.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = i;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
const MI = {
  updateSize: _I,
  updateSlides: xI,
  updateAutoHeight: wI,
  updateSlidesOffset: TI,
  updateSlidesProgress: SI,
  updateProgress: EI,
  updateSlidesClasses: OI,
  updateActiveIndex: kI,
  updateClickedSlide: PI
};
function AI(e = this.isHorizontal() ? "x" : "y") {
  const t = this, {
    params: r,
    rtlTranslate: a,
    translate: n,
    wrapperEl: i
  } = t;
  if (r.virtualTranslate)
    return a ? -n : n;
  if (r.cssMode)
    return n;
  let s = jp(i, e);
  return s += t.cssOverflowAdjustment(), a && (s = -s), s || 0;
}
function DI(e, t) {
  const r = this, {
    rtlTranslate: a,
    params: n,
    wrapperEl: i,
    progress: s
  } = r;
  let o = 0, l = 0;
  const u = 0;
  r.isHorizontal() ? o = a ? -e : e : l = e, n.roundLengths && (o = Math.floor(o), l = Math.floor(l)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? o : l, n.cssMode ? i[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -o : -l : n.virtualTranslate || (r.isHorizontal() ? o -= r.cssOverflowAdjustment() : l -= r.cssOverflowAdjustment(), i.style.transform = `translate3d(${o}px, ${l}px, ${u}px)`);
  let d;
  const f = r.maxTranslate() - r.minTranslate();
  f === 0 ? d = 0 : d = (e - r.minTranslate()) / f, d !== s && r.updateProgress(e), r.emit("setTranslate", r.translate, t);
}
function II() {
  return -this.snapGrid[0];
}
function NI() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function $I(e = 0, t = this.params.speed, r = !0, a = !0, n) {
  const i = this, {
    params: s,
    wrapperEl: o
  } = i;
  if (i.animating && s.preventInteractionOnTransition)
    return !1;
  const l = i.minTranslate(), u = i.maxTranslate();
  let d;
  if (a && e > l ? d = l : a && e < u ? d = u : d = e, i.updateProgress(d), s.cssMode) {
    const f = i.isHorizontal();
    if (t === 0)
      o[f ? "scrollLeft" : "scrollTop"] = -d;
    else {
      if (!i.support.smoothScroll)
        return IS({
          swiper: i,
          targetPosition: -d,
          side: f ? "left" : "top"
        }), !0;
      o.scrollTo({
        [f ? "left" : "top"]: -d,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (i.setTransition(0), i.setTranslate(d), r && (i.emit("beforeTransitionStart", t, n), i.emit("transitionEnd"))) : (i.setTransition(t), i.setTranslate(d), r && (i.emit("beforeTransitionStart", t, n), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(c) {
    !i || i.destroyed || c.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, r && i.emit("transitionEnd"));
  }), i.wrapperEl.addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd))), !0;
}
const LI = {
  getTranslate: AI,
  setTranslate: DI,
  minTranslate: II,
  maxTranslate: NI,
  translateTo: $I
};
function RI(e, t) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${e}ms`), r.emit("setTransition", e, t);
}
function $S({
  swiper: e,
  runCallbacks: t,
  direction: r,
  step: a
}) {
  const {
    activeIndex: n,
    previousIndex: i
  } = e;
  let s = r;
  if (s || (n > i ? s = "next" : n < i ? s = "prev" : s = "reset"), e.emit(`transition${a}`), t && n !== i) {
    if (s === "reset") {
      e.emit(`slideResetTransition${a}`);
      return;
    }
    e.emit(`slideChangeTransition${a}`), s === "next" ? e.emit(`slideNextTransition${a}`) : e.emit(`slidePrevTransition${a}`);
  }
}
function jI(e = !0, t) {
  const r = this, {
    params: a
  } = r;
  a.cssMode || (a.autoHeight && r.updateAutoHeight(), $S({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function FI(e = !0, t) {
  const r = this, {
    params: a
  } = r;
  r.animating = !1, !a.cssMode && (r.setTransition(0), $S({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
const BI = {
  setTransition: RI,
  transitionStart: jI,
  transitionEnd: FI
};
function qI(e = 0, t = this.params.speed, r = !0, a, n) {
  typeof e == "string" && (e = parseInt(e, 10));
  const i = this;
  let s = e;
  s < 0 && (s = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: u,
    previousIndex: d,
    activeIndex: f,
    rtlTranslate: c,
    wrapperEl: p,
    enabled: v
  } = i;
  if (i.animating && o.preventInteractionOnTransition || !v && !a && !n)
    return !1;
  const h = Math.min(i.params.slidesPerGroupSkip, s);
  let g = h + Math.floor((s - h) / i.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const m = -l[g];
  if (o.normalizeSlideIndex)
    for (let y = 0; y < u.length; y += 1) {
      const _ = -Math.floor(m * 100), x = Math.floor(u[y] * 100), w = Math.floor(u[y + 1] * 100);
      typeof u[y + 1] < "u" ? _ >= x && _ < w - (w - x) / 2 ? s = y : _ >= x && _ < w && (s = y + 1) : _ >= x && (s = y);
    }
  if (i.initialized && s !== f && (!i.allowSlideNext && (c ? m > i.translate && m > i.minTranslate() : m < i.translate && m < i.minTranslate()) || !i.allowSlidePrev && m > i.translate && m > i.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (d || 0) && r && i.emit("beforeSlideChangeStart"), i.updateProgress(m);
  let b;
  if (s > f ? b = "next" : s < f ? b = "prev" : b = "reset", c && -m === i.translate || !c && m === i.translate)
    return i.updateActiveIndex(s), o.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), o.effect !== "slide" && i.setTranslate(m), b !== "reset" && (i.transitionStart(r, b), i.transitionEnd(r, b)), !1;
  if (o.cssMode) {
    const y = i.isHorizontal(), _ = c ? m : -m;
    if (t === 0) {
      const x = i.virtual && i.params.virtual.enabled;
      x && (i.wrapperEl.style.scrollSnapType = "none", i._immediateVirtual = !0), x && !i._cssModeVirtualInitialSet && i.params.initialSlide > 0 ? (i._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        p[y ? "scrollLeft" : "scrollTop"] = _;
      })) : p[y ? "scrollLeft" : "scrollTop"] = _, x && requestAnimationFrame(() => {
        i.wrapperEl.style.scrollSnapType = "", i._immediateVirtual = !1;
      });
    } else {
      if (!i.support.smoothScroll)
        return IS({
          swiper: i,
          targetPosition: _,
          side: y ? "left" : "top"
        }), !0;
      p.scrollTo({
        [y ? "left" : "top"]: _,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i.setTransition(t), i.setTranslate(m), i.updateActiveIndex(s), i.updateSlidesClasses(), i.emit("beforeTransitionStart", t, a), i.transitionStart(r, b), t === 0 ? i.transitionEnd(r, b) : i.animating || (i.animating = !0, i.onSlideToWrapperTransitionEnd || (i.onSlideToWrapperTransitionEnd = function(_) {
    !i || i.destroyed || _.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.onSlideToWrapperTransitionEnd = null, delete i.onSlideToWrapperTransitionEnd, i.transitionEnd(r, b));
  }), i.wrapperEl.addEventListener("transitionend", i.onSlideToWrapperTransitionEnd)), !0;
}
function HI(e = 0, t = this.params.speed, r = !0, a) {
  typeof e == "string" && (e = parseInt(e, 10));
  const n = this;
  let i = e;
  return n.params.loop && (n.virtual && n.params.virtual.enabled ? i = i + n.virtual.slidesBefore : i = n.getSlideIndexByData(i)), n.slideTo(i, t, r, a);
}
function VI(e = this.params.speed, t = !0, r) {
  const a = this, {
    enabled: n,
    params: i,
    animating: s
  } = a;
  if (!n)
    return a;
  let o = i.slidesPerGroup;
  i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (o = Math.max(a.slidesPerViewDynamic("current", !0), 1));
  const l = a.activeIndex < i.slidesPerGroupSkip ? 1 : o, u = a.virtual && i.virtual.enabled;
  if (i.loop) {
    if (s && !u && i.loopPreventsSliding)
      return !1;
    a.loopFix({
      direction: "next"
    }), a._clientLeft = a.wrapperEl.clientLeft;
  }
  return i.rewind && a.isEnd ? a.slideTo(0, e, t, r) : a.slideTo(a.activeIndex + l, e, t, r);
}
function UI(e = this.params.speed, t = !0, r) {
  const a = this, {
    params: n,
    snapGrid: i,
    slidesGrid: s,
    rtlTranslate: o,
    enabled: l,
    animating: u
  } = a;
  if (!l)
    return a;
  const d = a.virtual && n.virtual.enabled;
  if (n.loop) {
    if (u && !d && n.loopPreventsSliding)
      return !1;
    a.loopFix({
      direction: "prev"
    }), a._clientLeft = a.wrapperEl.clientLeft;
  }
  const f = o ? a.translate : -a.translate;
  function c(m) {
    return m < 0 ? -Math.floor(Math.abs(m)) : Math.floor(m);
  }
  const p = c(f), v = i.map((m) => c(m));
  let h = i[v.indexOf(p) - 1];
  if (typeof h > "u" && n.cssMode) {
    let m;
    i.forEach((b, y) => {
      p >= b && (m = y);
    }), typeof m < "u" && (h = i[m > 0 ? m - 1 : m]);
  }
  let g = 0;
  if (typeof h < "u" && (g = s.indexOf(h), g < 0 && (g = a.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (g = g - a.slidesPerViewDynamic("previous", !0) + 1, g = Math.max(g, 0))), n.rewind && a.isBeginning) {
    const m = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
    return a.slideTo(m, e, t, r);
  }
  return a.slideTo(g, e, t, r);
}
function zI(e = this.params.speed, t = !0, r) {
  const a = this;
  return a.slideTo(a.activeIndex, e, t, r);
}
function YI(e = this.params.speed, t = !0, r, a = 0.5) {
  const n = this;
  let i = n.activeIndex;
  const s = Math.min(n.params.slidesPerGroupSkip, i), o = s + Math.floor((i - s) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[o]) {
    const u = n.snapGrid[o], d = n.snapGrid[o + 1];
    l - u > (d - u) * a && (i += n.params.slidesPerGroup);
  } else {
    const u = n.snapGrid[o - 1], d = n.snapGrid[o];
    l - u <= (d - u) * a && (i -= n.params.slidesPerGroup);
  }
  return i = Math.max(i, 0), i = Math.min(i, n.slidesGrid.length - 1), n.slideTo(i, e, t, r);
}
function WI() {
  const e = this, {
    params: t,
    slidesEl: r
  } = e, a = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let n = e.clickedIndex, i;
  const s = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating)
      return;
    i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? n < e.loopedSlides - a / 2 || n > e.slides.length - e.loopedSlides + a / 2 ? (e.loopFix(), n = e.getSlideIndex(ha(r, `${s}[data-swiper-slide-index="${i}"]`)[0]), Ms(() => {
      e.slideTo(n);
    })) : e.slideTo(n) : n > e.slides.length - a ? (e.loopFix(), n = e.getSlideIndex(ha(r, `${s}[data-swiper-slide-index="${i}"]`)[0]), Ms(() => {
      e.slideTo(n);
    })) : e.slideTo(n);
  } else
    e.slideTo(n);
}
const GI = {
  slideTo: qI,
  slideToLoop: HI,
  slideNext: VI,
  slidePrev: UI,
  slideReset: zI,
  slideToClosest: YI,
  slideToClickedSlide: WI
};
function XI(e) {
  const t = this, {
    params: r,
    slidesEl: a
  } = t;
  if (!r.loop || t.virtual && t.params.virtual.enabled)
    return;
  ha(a, `.${r.slideClass}, swiper-slide`).forEach((i, s) => {
    i.setAttribute("data-swiper-slide-index", s);
  }), t.loopFix({
    slideRealIndex: e,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function KI({
  slideRealIndex: e,
  slideTo: t = !0,
  direction: r,
  setTranslate: a,
  activeSlideIndex: n,
  byController: i,
  byMousewheel: s
} = {}) {
  const o = this;
  if (!o.params.loop)
    return;
  o.emit("beforeLoopFix");
  const {
    slides: l,
    allowSlidePrev: u,
    allowSlideNext: d,
    slidesEl: f,
    params: c
  } = o;
  if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && c.virtual.enabled) {
    t && (!c.centeredSlides && o.snapIndex === 0 ? o.slideTo(o.virtual.slides.length, 0, !1, !0) : c.centeredSlides && o.snapIndex < c.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0)), o.allowSlidePrev = u, o.allowSlideNext = d, o.emit("loopFix");
    return;
  }
  const p = c.slidesPerView === "auto" ? o.slidesPerViewDynamic() : Math.ceil(parseFloat(c.slidesPerView, 10));
  let v = c.loopedSlides || p;
  v % c.slidesPerGroup !== 0 && (v += c.slidesPerGroup - v % c.slidesPerGroup), o.loopedSlides = v;
  const h = [], g = [];
  let m = o.activeIndex;
  typeof n > "u" ? n = o.getSlideIndex(o.slides.filter((w) => w.classList.contains(c.slideActiveClass))[0]) : m = n;
  const b = r === "next" || !r, y = r === "prev" || !r;
  let _ = 0, x = 0;
  if (n < v) {
    _ = Math.max(v - n, c.slidesPerGroup);
    for (let w = 0; w < v - n; w += 1) {
      const k = w - Math.floor(w / l.length) * l.length;
      h.push(l.length - k - 1);
    }
  } else if (n > o.slides.length - v * 2) {
    x = Math.max(n - (o.slides.length - v * 2), c.slidesPerGroup);
    for (let w = 0; w < x; w += 1) {
      const k = w - Math.floor(w / l.length) * l.length;
      g.push(k);
    }
  }
  if (y && h.forEach((w) => {
    o.slides[w].swiperLoopMoveDOM = !0, f.prepend(o.slides[w]), o.slides[w].swiperLoopMoveDOM = !1;
  }), b && g.forEach((w) => {
    o.slides[w].swiperLoopMoveDOM = !0, f.append(o.slides[w]), o.slides[w].swiperLoopMoveDOM = !1;
  }), o.recalcSlides(), c.slidesPerView === "auto" && o.updateSlides(), c.watchSlidesProgress && o.updateSlidesOffset(), t) {
    if (h.length > 0 && y)
      if (typeof e > "u") {
        const w = o.slidesGrid[m], S = o.slidesGrid[m + _] - w;
        s ? o.setTranslate(o.translate - S) : (o.slideTo(m + _, 0, !1, !0), a && (o.touches[o.isHorizontal() ? "startX" : "startY"] += S));
      } else
        a && o.slideToLoop(e, 0, !1, !0);
    else if (g.length > 0 && b)
      if (typeof e > "u") {
        const w = o.slidesGrid[m], S = o.slidesGrid[m - x] - w;
        s ? o.setTranslate(o.translate - S) : (o.slideTo(m - x, 0, !1, !0), a && (o.touches[o.isHorizontal() ? "startX" : "startY"] += S));
      } else
        o.slideToLoop(e, 0, !1, !0);
  }
  if (o.allowSlidePrev = u, o.allowSlideNext = d, o.controller && o.controller.control && !i) {
    const w = {
      slideRealIndex: e,
      slideTo: !1,
      direction: r,
      setTranslate: a,
      activeSlideIndex: n,
      byController: !0
    };
    Array.isArray(o.controller.control) ? o.controller.control.forEach((k) => {
      !k.destroyed && k.params.loop && k.loopFix(w);
    }) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix(w);
  }
  o.emit("loopFix");
}
function JI() {
  const e = this, {
    params: t,
    slidesEl: r
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled)
    return;
  e.recalcSlides();
  const a = [];
  e.slides.forEach((n) => {
    const i = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    a[i] = n;
  }), e.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), a.forEach((n) => {
    r.append(n);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
const QI = {
  loopCreate: XI,
  loopFix: KI,
  loopDestroy: JI
};
function ZI(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
    return;
  const r = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function e6() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
const t6 = {
  setGrabCursor: ZI,
  unsetGrabCursor: e6
};
function r6(e, t = this) {
  function r(a) {
    if (!a || a === ba() || a === Br())
      return null;
    a.assignedSlot && (a = a.assignedSlot);
    const n = a.closest(e);
    return !n && !a.getRootNode ? null : n || r(a.getRootNode().host);
  }
  return r(t);
}
function a6(e) {
  const t = this, r = ba(), a = Br(), n = t.touchEventsData;
  n.evCache.push(e);
  const {
    params: i,
    touches: s,
    enabled: o
  } = t;
  if (!o || !i.simulateTouch && e.pointerType === "mouse" || t.animating && i.preventInteractionOnTransition)
    return;
  !t.animating && i.cssMode && i.loop && t.loopFix();
  let l = e;
  l.originalEvent && (l = l.originalEvent);
  let u = l.target;
  if (i.touchEventsTarget === "wrapper" && !t.wrapperEl.contains(u) || "which" in l && l.which === 3 || "button" in l && l.button > 0 || n.isTouched && n.isMoved)
    return;
  const d = !!i.noSwipingClass && i.noSwipingClass !== "", f = e.composedPath ? e.composedPath() : e.path;
  d && l.target && l.target.shadowRoot && f && (u = f[0]);
  const c = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`, p = !!(l.target && l.target.shadowRoot);
  if (i.noSwiping && (p ? r6(c, u) : u.closest(c))) {
    t.allowClick = !0;
    return;
  }
  if (i.swipeHandler && !u.closest(i.swipeHandler))
    return;
  s.currentX = l.pageX, s.currentY = l.pageY;
  const v = s.currentX, h = s.currentY, g = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection, m = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
  if (g && (v <= m || v >= a.innerWidth - m))
    if (g === "prevent")
      e.preventDefault();
    else
      return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = v, s.startY = h, n.touchStartTime = vn(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, i.threshold > 0 && (n.allowThresholdMove = !1);
  let b = !0;
  u.matches(n.focusableElements) && (b = !1, u.nodeName === "SELECT" && (n.isTouched = !1)), r.activeElement && r.activeElement.matches(n.focusableElements) && r.activeElement !== u && r.activeElement.blur();
  const y = b && t.allowTouchMove && i.touchStartPreventDefault;
  (i.touchStartForcePreventDefault || y) && !u.isContentEditable && l.preventDefault(), i.freeMode && i.freeMode.enabled && t.freeMode && t.animating && !i.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", l);
}
function n6(e) {
  const t = ba(), r = this, a = r.touchEventsData, {
    params: n,
    touches: i,
    rtlTranslate: s,
    enabled: o
  } = r;
  if (!o || !n.simulateTouch && e.pointerType === "mouse")
    return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), !a.isTouched) {
    a.startMoving && a.isScrolling && r.emit("touchMoveOpposite", l);
    return;
  }
  const u = a.evCache.findIndex((w) => w.pointerId === l.pointerId);
  u >= 0 && (a.evCache[u] = l);
  const d = a.evCache.length > 1 ? a.evCache[0] : l, f = d.pageX, c = d.pageY;
  if (l.preventedByNestedSwiper) {
    i.startX = f, i.startY = c;
    return;
  }
  if (!r.allowTouchMove) {
    l.target.matches(a.focusableElements) || (r.allowClick = !1), a.isTouched && (Object.assign(i, {
      startX: f,
      startY: c,
      prevX: r.touches.currentX,
      prevY: r.touches.currentY,
      currentX: f,
      currentY: c
    }), a.touchStartTime = vn());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (r.isVertical()) {
      if (c < i.startY && r.translate <= r.maxTranslate() || c > i.startY && r.translate >= r.minTranslate()) {
        a.isTouched = !1, a.isMoved = !1;
        return;
      }
    } else if (f < i.startX && r.translate <= r.maxTranslate() || f > i.startX && r.translate >= r.minTranslate())
      return;
  }
  if (t.activeElement && l.target === t.activeElement && l.target.matches(a.focusableElements)) {
    a.isMoved = !0, r.allowClick = !1;
    return;
  }
  if (a.allowTouchCallbacks && r.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)
    return;
  i.currentX = f, i.currentY = c;
  const p = i.currentX - i.startX, v = i.currentY - i.startY;
  if (r.params.threshold && Math.sqrt(p ** 2 + v ** 2) < r.params.threshold)
    return;
  if (typeof a.isScrolling > "u") {
    let w;
    r.isHorizontal() && i.currentY === i.startY || r.isVertical() && i.currentX === i.startX ? a.isScrolling = !1 : p * p + v * v >= 25 && (w = Math.atan2(Math.abs(v), Math.abs(p)) * 180 / Math.PI, a.isScrolling = r.isHorizontal() ? w > n.touchAngle : 90 - w > n.touchAngle);
  }
  if (a.isScrolling && r.emit("touchMoveOpposite", l), typeof a.startMoving > "u" && (i.currentX !== i.startX || i.currentY !== i.startY) && (a.startMoving = !0), a.isScrolling || r.zoom && r.params.zoom && r.params.zoom.enabled && a.evCache.length > 1) {
    a.isTouched = !1;
    return;
  }
  if (!a.startMoving)
    return;
  r.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let h = r.isHorizontal() ? p : v, g = r.isHorizontal() ? i.currentX - i.previousX : i.currentY - i.previousY;
  n.oneWayMovement && (h = Math.abs(h) * (s ? 1 : -1), g = Math.abs(g) * (s ? 1 : -1)), i.diff = h, h *= n.touchRatio, s && (h = -h, g = -g);
  const m = r.touchesDirection;
  r.swipeDirection = h > 0 ? "prev" : "next", r.touchesDirection = g > 0 ? "prev" : "next";
  const b = r.params.loop && !n.cssMode;
  if (!a.isMoved) {
    if (b && r.loopFix({
      direction: r.swipeDirection
    }), a.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const w = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      r.wrapperEl.dispatchEvent(w);
    }
    a.allowMomentumBounce = !1, n.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
  }
  let y;
  a.isMoved && m !== r.touchesDirection && b && Math.abs(h) >= 1 && (r.loopFix({
    direction: r.swipeDirection,
    setTranslate: !0
  }), y = !0), r.emit("sliderMove", l), a.isMoved = !0, a.currentTranslate = h + a.startTranslate;
  let _ = !0, x = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (x = 0), h > 0 ? (b && !y && a.currentTranslate > (n.centeredSlides ? r.minTranslate() - r.size / 2 : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), a.currentTranslate > r.minTranslate() && (_ = !1, n.resistance && (a.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + a.startTranslate + h) ** x))) : h < 0 && (b && !y && a.currentTranslate < (n.centeredSlides ? r.maxTranslate() + r.size / 2 : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (n.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), a.currentTranslate < r.maxTranslate() && (_ = !1, n.resistance && (a.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - a.startTranslate - h) ** x))), _ && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (a.currentTranslate = a.startTranslate), n.threshold > 0)
    if (Math.abs(h) > n.threshold || a.allowThresholdMove) {
      if (!a.allowThresholdMove) {
        a.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, a.currentTranslate = a.startTranslate, i.diff = r.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
        return;
      }
    } else {
      a.currentTranslate = a.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && r.freeMode || n.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(a.currentTranslate), r.setTranslate(a.currentTranslate));
}
function i6(e) {
  const t = this, r = t.touchEventsData, a = r.evCache.findIndex((y) => y.pointerId === e.pointerId);
  if (a >= 0 && r.evCache.splice(a, 1), ["pointercancel", "pointerout", "pointerleave"].includes(e.type) && !(e.type === "pointercancel" && (t.browser.isSafari || t.browser.isWebView)))
    return;
  const {
    params: n,
    touches: i,
    rtlTranslate: s,
    slidesGrid: o,
    enabled: l
  } = t;
  if (!l || !n.simulateTouch && e.pointerType === "mouse")
    return;
  let u = e;
  if (u.originalEvent && (u = u.originalEvent), r.allowTouchCallbacks && t.emit("touchEnd", u), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && n.grabCursor && t.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  n.grabCursor && r.isMoved && r.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const d = vn(), f = d - r.touchStartTime;
  if (t.allowClick) {
    const y = u.path || u.composedPath && u.composedPath();
    t.updateClickedSlide(y && y[0] || u.target), t.emit("tap click", u), f < 300 && d - r.lastClickTime < 300 && t.emit("doubleTap doubleClick", u);
  }
  if (r.lastClickTime = vn(), Ms(() => {
    t.destroyed || (t.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !t.swipeDirection || i.diff === 0 || r.currentTranslate === r.startTranslate) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let c;
  if (n.followFinger ? c = s ? t.translate : -t.translate : c = -r.currentTranslate, n.cssMode)
    return;
  if (n.freeMode && n.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: c
    });
    return;
  }
  let p = 0, v = t.slidesSizesGrid[0];
  for (let y = 0; y < o.length; y += y < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup) {
    const _ = y < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
    typeof o[y + _] < "u" ? c >= o[y] && c < o[y + _] && (p = y, v = o[y + _] - o[y]) : c >= o[y] && (p = y, v = o[o.length - 1] - o[o.length - 2]);
  }
  let h = null, g = null;
  n.rewind && (t.isBeginning ? g = n.virtual && n.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
  const m = (c - o[p]) / v, b = p < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
  if (f > n.longSwipesMs) {
    if (!n.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (m >= n.longSwipesRatio ? t.slideTo(n.rewind && t.isEnd ? h : p + b) : t.slideTo(p)), t.swipeDirection === "prev" && (m > 1 - n.longSwipesRatio ? t.slideTo(p + b) : g !== null && m < 0 && Math.abs(m) > n.longSwipesRatio ? t.slideTo(g) : t.slideTo(p));
  } else {
    if (!n.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (u.target === t.navigation.nextEl || u.target === t.navigation.prevEl) ? u.target === t.navigation.nextEl ? t.slideTo(p + b) : t.slideTo(p) : (t.swipeDirection === "next" && t.slideTo(h !== null ? h : p + b), t.swipeDirection === "prev" && t.slideTo(g !== null ? g : p));
  }
}
function E_() {
  const e = this, {
    params: t,
    el: r
  } = e;
  if (r && r.offsetWidth === 0)
    return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: a,
    allowSlidePrev: n,
    snapGrid: i
  } = e, s = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = s && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !s ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = n, e.allowSlideNext = a, e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
}
function s6(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function o6() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: r,
    enabled: a
  } = e;
  if (!a)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let n;
  const i = e.maxTranslate() - e.minTranslate();
  i === 0 ? n = 0 : n = (e.translate - e.minTranslate()) / i, n !== e.progress && e.updateProgress(r ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function l6(e) {
  const t = this;
  id(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
let O_ = !1;
function u6() {
}
const LS = (e, t) => {
  const r = ba(), {
    params: a,
    el: n,
    wrapperEl: i,
    device: s
  } = e, o = !!a.nested, l = t === "on" ? "addEventListener" : "removeEventListener", u = t;
  n[l]("pointerdown", e.onTouchStart, {
    passive: !1
  }), r[l]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("pointerup", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), (a.preventClicks || a.preventClicksPropagation) && n[l]("click", e.onClick, !0), a.cssMode && i[l]("scroll", e.onScroll), a.updateOnWindowResize ? e[u](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", E_, !0) : e[u]("observerUpdate", E_, !0), n[l]("load", e.onLoad, {
    capture: !0
  });
};
function d6() {
  const e = this, t = ba(), {
    params: r
  } = e;
  e.onTouchStart = a6.bind(e), e.onTouchMove = n6.bind(e), e.onTouchEnd = i6.bind(e), r.cssMode && (e.onScroll = o6.bind(e)), e.onClick = s6.bind(e), e.onLoad = l6.bind(e), O_ || (t.addEventListener("touchstart", u6), O_ = !0), LS(e, "on");
}
function c6() {
  LS(this, "off");
}
const f6 = {
  attachEvents: d6,
  detachEvents: c6
}, C_ = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function p6() {
  const e = this, {
    realIndex: t,
    initialized: r,
    params: a,
    el: n
  } = e, i = a.breakpoints;
  if (!i || i && Object.keys(i).length === 0)
    return;
  const s = e.getBreakpoint(i, e.params.breakpointsBase, e.el);
  if (!s || e.currentBreakpoint === s)
    return;
  const l = (s in i ? i[s] : void 0) || e.originalParams, u = C_(e, a), d = C_(e, l), f = a.enabled;
  u && !d ? (n.classList.remove(`${a.containerModifierClass}grid`, `${a.containerModifierClass}grid-column`), e.emitContainerClasses()) : !u && d && (n.classList.add(`${a.containerModifierClass}grid`), (l.grid.fill && l.grid.fill === "column" || !l.grid.fill && a.grid.fill === "column") && n.classList.add(`${a.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((h) => {
    if (typeof l[h] > "u")
      return;
    const g = a[h] && a[h].enabled, m = l[h] && l[h].enabled;
    g && !m && e[h].disable(), !g && m && e[h].enable();
  });
  const c = l.direction && l.direction !== a.direction, p = a.loop && (l.slidesPerView !== a.slidesPerView || c);
  c && r && e.changeDirection(), Ga(e.params, l);
  const v = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), f && !v ? e.disable() : !f && v && e.enable(), e.currentBreakpoint = s, e.emit("_beforeBreakpoint", l), p && r && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()), e.emit("breakpoint", l);
}
function v6(e, t = "window", r) {
  if (!e || t === "container" && !r)
    return;
  let a = !1;
  const n = Br(), i = t === "window" ? n.innerHeight : r.clientHeight, s = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: i * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  s.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < s.length; o += 1) {
    const {
      point: l,
      value: u
    } = s[o];
    t === "window" ? n.matchMedia(`(min-width: ${u}px)`).matches && (a = l) : u <= r.clientWidth && (a = l);
  }
  return a || "max";
}
const m6 = {
  setBreakpoint: p6,
  getBreakpoint: v6
};
function h6(e, t) {
  const r = [];
  return e.forEach((a) => {
    typeof a == "object" ? Object.keys(a).forEach((n) => {
      a[n] && r.push(t + n);
    }) : typeof a == "string" && r.push(t + a);
  }), r;
}
function g6() {
  const e = this, {
    classNames: t,
    params: r,
    rtl: a,
    el: n,
    device: i
  } = e, s = h6(["initialized", r.direction, {
    "free-mode": e.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: a
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: i.android
  }, {
    ios: i.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  t.push(...s), n.classList.add(...t), e.emitContainerClasses();
}
function b6() {
  const e = this, {
    el: t,
    classNames: r
  } = e;
  t.classList.remove(...r), e.emitContainerClasses();
}
const y6 = {
  addClasses: g6,
  removeClasses: b6
};
function _6() {
  const e = this, {
    isLocked: t,
    params: r
  } = e, {
    slidesOffsetBefore: a
  } = r;
  if (a) {
    const n = e.slides.length - 1, i = e.slidesGrid[n] + e.slidesSizesGrid[n] + a * 2;
    e.isLocked = e.size > i;
  } else
    e.isLocked = e.snapGrid.length === 1;
  r.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), r.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const x6 = {
  checkOverflow: _6
}, qp = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function w6(e, t) {
  return function(a = {}) {
    const n = Object.keys(a)[0], i = a[n];
    if (typeof i != "object" || i === null) {
      Ga(t, a);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 && e[n] === !0 && (e[n] = {
      auto: !0
    }), !(n in e && "enabled" in i)) {
      Ga(t, a);
      return;
    }
    e[n] === !0 && (e[n] = {
      enabled: !0
    }), typeof e[n] == "object" && !("enabled" in e[n]) && (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), Ga(t, a);
  };
}
const Cf = {
  eventsEmitter: yI,
  update: MI,
  translate: LI,
  transition: BI,
  slide: GI,
  loop: QI,
  grabCursor: t6,
  events: f6,
  breakpoints: m6,
  checkOverflow: x6,
  classes: y6
}, kf = {};
class Wa {
  constructor(...t) {
    let r, a;
    t.length === 1 && t[0].constructor && Object.prototype.toString.call(t[0]).slice(8, -1) === "Object" ? a = t[0] : [r, a] = t, a || (a = {}), a = Ga({}, a), r && !a.el && (a.el = r);
    const n = ba();
    if (a.el && typeof a.el == "string" && n.querySelectorAll(a.el).length > 1) {
      const l = [];
      return n.querySelectorAll(a.el).forEach((u) => {
        const d = Ga({}, a, {
          el: u
        });
        l.push(new Wa(d));
      }), l;
    }
    const i = this;
    i.__swiper__ = !0, i.support = NS(), i.device = vI({
      userAgent: a.userAgent
    }), i.browser = hI(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], a.modules && Array.isArray(a.modules) && i.modules.push(...a.modules);
    const s = {};
    i.modules.forEach((l) => {
      l({
        params: a,
        swiper: i,
        extendParams: w6(a, s),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const o = Ga({}, qp, s);
    return i.params = Ga({}, o, kf, a), i.originalParams = Ga({}, i.params), i.passedParams = Ga({}, a), i.params && i.params.on && Object.keys(i.params.on).forEach((l) => {
      i.on(l, i.params.on[l]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), Object.assign(i, {
      enabled: i.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return i.params.direction === "horizontal";
      },
      isVertical() {
        return i.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: i.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  getSlideIndex(t) {
    const {
      slidesEl: r,
      params: a
    } = this, n = ha(r, `.${a.slideClass}, swiper-slide`), i = Gl(n[0]);
    return Gl(t) - i;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.filter((r) => r.getAttribute("data-swiper-slide-index") * 1 === t)[0]);
  }
  recalcSlides() {
    const t = this, {
      slidesEl: r,
      params: a
    } = t;
    t.slides = ha(r, `.${a.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, r) {
    const a = this;
    t = Math.min(Math.max(t, 0), 1);
    const n = a.minTranslate(), s = (a.maxTranslate() - n) * t + n;
    a.translateTo(s, typeof r > "u" ? 0 : r), a.updateActiveIndex(), a.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const r = t.el.className.split(" ").filter((a) => a.indexOf("swiper") === 0 || a.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(t) {
    const r = this;
    return r.destroyed ? "" : t.className.split(" ").filter((a) => a.indexOf("swiper-slide") === 0 || a.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const r = [];
    t.slides.forEach((a) => {
      const n = t.getSlideClasses(a);
      r.push({
        slideEl: a,
        classNames: n
      }), t.emit("_slideClass", a, n);
    }), t.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(t = "current", r = !1) {
    const a = this, {
      params: n,
      slides: i,
      slidesGrid: s,
      slidesSizesGrid: o,
      size: l,
      activeIndex: u
    } = a;
    let d = 1;
    if (n.centeredSlides) {
      let f = i[u] ? i[u].swiperSlideSize : 0, c;
      for (let p = u + 1; p < i.length; p += 1)
        i[p] && !c && (f += i[p].swiperSlideSize, d += 1, f > l && (c = !0));
      for (let p = u - 1; p >= 0; p -= 1)
        i[p] && !c && (f += i[p].swiperSlideSize, d += 1, f > l && (c = !0));
    } else if (t === "current")
      for (let f = u + 1; f < i.length; f += 1)
        (r ? s[f] + o[f] - s[u] < l : s[f] - s[u] < l) && (d += 1);
    else
      for (let f = u - 1; f >= 0; f -= 1)
        s[u] - s[f] < l && (d += 1);
    return d;
  }
  update() {
    const t = this;
    if (!t || t.destroyed)
      return;
    const {
      snapGrid: r,
      params: a
    } = t;
    a.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && id(t, s);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function n() {
      const s = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(s, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let i;
    if (a.freeMode && a.freeMode.enabled && !a.cssMode)
      n(), a.autoHeight && t.updateAutoHeight();
    else {
      if ((a.slidesPerView === "auto" || a.slidesPerView > 1) && t.isEnd && !a.centeredSlides) {
        const s = t.virtual && a.virtual.enabled ? t.virtual.slides : t.slides;
        i = t.slideTo(s.length - 1, 0, !1, !0);
      } else
        i = t.slideTo(t.activeIndex, 0, !1, !0);
      i || n();
    }
    a.watchOverflow && r !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, r = !0) {
    const a = this, n = a.params.direction;
    return t || (t = n === "horizontal" ? "vertical" : "horizontal"), t === n || t !== "horizontal" && t !== "vertical" || (a.el.classList.remove(`${a.params.containerModifierClass}${n}`), a.el.classList.add(`${a.params.containerModifierClass}${t}`), a.emitContainerClasses(), a.params.direction = t, a.slides.forEach((i) => {
      t === "vertical" ? i.style.width = "" : i.style.height = "";
    }), a.emit("changeDirection"), r && a.update()), a;
  }
  changeLanguageDirection(t) {
    const r = this;
    r.rtl && t === "rtl" || !r.rtl && t === "ltr" || (r.rtl = t === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(t) {
    const r = this;
    if (r.mounted)
      return !0;
    let a = t || r.params.el;
    if (typeof a == "string" && (a = document.querySelector(a)), !a)
      return !1;
    a.swiper = r, a.shadowEl && (r.isElement = !0);
    const n = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = (() => a && a.shadowRoot && a.shadowRoot.querySelector ? a.shadowRoot.querySelector(n()) : ha(a, n())[0])();
    return !s && r.params.createElements && (s = Ln("div", r.params.wrapperClass), a.append(s), ha(a, `.${r.params.slideClass}`).forEach((o) => {
      s.append(o);
    })), Object.assign(r, {
      el: a,
      wrapperEl: s,
      slidesEl: r.isElement ? a : s,
      mounted: !0,
      // RTL
      rtl: a.dir.toLowerCase() === "rtl" || Wi(a, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (a.dir.toLowerCase() === "rtl" || Wi(a, "direction") === "rtl"),
      wrongRTL: Wi(s, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const r = this;
    return r.initialized || r.mount(t) === !1 || (r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents(), [...r.el.querySelectorAll('[loading="lazy"]')].forEach((n) => {
      n.complete ? id(r, n) : n.addEventListener("load", (i) => {
        id(r, i.target);
      });
    }), Bp(r), r.initialized = !0, Bp(r), r.emit("init"), r.emit("afterInit")), r;
  }
  destroy(t = !0, r = !0) {
    const a = this, {
      params: n,
      el: i,
      wrapperEl: s,
      slides: o
    } = a;
    return typeof a.params > "u" || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), n.loop && a.loopDestroy(), r && (a.removeClasses(), i.removeAttribute("style"), s.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), a.emit("destroy"), Object.keys(a.eventsListeners).forEach((l) => {
      a.off(l);
    }), t !== !1 && (a.el.swiper = null, oI(a)), a.destroyed = !0), null;
  }
  static extendDefaults(t) {
    Ga(kf, t);
  }
  static get extendedDefaults() {
    return kf;
  }
  static get defaults() {
    return qp;
  }
  static installModule(t) {
    Wa.prototype.__modules__ || (Wa.prototype.__modules__ = []);
    const r = Wa.prototype.__modules__;
    typeof t == "function" && r.indexOf(t) < 0 && r.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((r) => Wa.installModule(r)), Wa) : (Wa.installModule(t), Wa);
  }
}
Object.keys(Cf).forEach((e) => {
  Object.keys(Cf[e]).forEach((t) => {
    Wa.prototype[t] = Cf[e][t];
  });
});
Wa.use([gI, bI]);
function T6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  t({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let n;
  const i = ba();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const s = i.createElement("div");
  function o(p, v) {
    const h = e.params.virtual;
    if (h.cache && e.virtual.cache[v])
      return e.virtual.cache[v];
    let g;
    return h.renderSlide ? (g = h.renderSlide.call(e, p, v), typeof g == "string" && (s.innerHTML = g, g = s.children[0])) : e.isElement ? g = Ln("swiper-slide") : g = Ln("div", e.params.slideClass), g.setAttribute("data-swiper-slide-index", v), h.renderSlide || (g.innerHTML = p), h.cache && (e.virtual.cache[v] = g), g;
  }
  function l(p) {
    const {
      slidesPerView: v,
      slidesPerGroup: h,
      centeredSlides: g,
      loop: m
    } = e.params, {
      addSlidesBefore: b,
      addSlidesAfter: y
    } = e.params.virtual, {
      from: _,
      to: x,
      slides: w,
      slidesGrid: k,
      offset: S
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const P = e.activeIndex || 0;
    let A;
    e.rtlTranslate ? A = "right" : A = e.isHorizontal() ? "left" : "top";
    let E, O;
    g ? (E = Math.floor(v / 2) + h + y, O = Math.floor(v / 2) + h + b) : (E = v + (h - 1) + y, O = (m ? v : h) + b);
    let T = P - O, D = P + E;
    m || (T = Math.max(T, 0), D = Math.min(D, w.length - 1));
    let $ = (e.slidesGrid[T] || 0) - (e.slidesGrid[0] || 0);
    m && P >= O ? (T -= O, g || ($ += e.slidesGrid[0])) : m && P < O && (T = -O, g && ($ += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: T,
      to: D,
      offset: $,
      slidesGrid: e.slidesGrid,
      slidesBefore: O,
      slidesAfter: E
    });
    function I() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), a("virtualUpdate");
    }
    if (_ === T && x === D && !p) {
      e.slidesGrid !== k && $ !== S && e.slides.forEach((Z) => {
        Z.style[A] = `${$ - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), a("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: $,
        from: T,
        to: D,
        slides: function() {
          const G = [];
          for (let H = T; H <= D; H += 1)
            G.push(w[H]);
          return G;
        }()
      }), e.params.virtual.renderExternalUpdate ? I() : a("virtualUpdate");
      return;
    }
    const F = [], j = [], M = (Z) => {
      let G = Z;
      return Z < 0 ? G = w.length + Z : G >= w.length && (G = G - w.length), G;
    };
    if (p)
      e.slidesEl.querySelectorAll(`.${e.params.slideClass}, swiper-slide`).forEach((Z) => {
        Z.remove();
      });
    else
      for (let Z = _; Z <= x; Z += 1)
        if (Z < T || Z > D) {
          const G = M(Z);
          e.slidesEl.querySelectorAll(`.${e.params.slideClass}[data-swiper-slide-index="${G}"], swiper-slide[data-swiper-slide-index="${G}"]`).forEach((H) => {
            H.remove();
          });
        }
    const q = m ? -w.length : 0, le = m ? w.length * 2 : w.length;
    for (let Z = q; Z < le; Z += 1)
      if (Z >= T && Z <= D) {
        const G = M(Z);
        typeof x > "u" || p ? j.push(G) : (Z > x && j.push(G), Z < _ && F.push(G));
      }
    if (j.forEach((Z) => {
      e.slidesEl.append(o(w[Z], Z));
    }), m)
      for (let Z = F.length - 1; Z >= 0; Z -= 1) {
        const G = F[Z];
        e.slidesEl.prepend(o(w[G], G));
      }
    else
      F.sort((Z, G) => G - Z), F.forEach((Z) => {
        e.slidesEl.prepend(o(w[Z], Z));
      });
    ha(e.slidesEl, ".swiper-slide, swiper-slide").forEach((Z) => {
      Z.style[A] = `${$ - Math.abs(e.cssOverflowAdjustment())}px`;
    }), I();
  }
  function u(p) {
    if (typeof p == "object" && "length" in p)
      for (let v = 0; v < p.length; v += 1)
        p[v] && e.virtual.slides.push(p[v]);
    else
      e.virtual.slides.push(p);
    l(!0);
  }
  function d(p) {
    const v = e.activeIndex;
    let h = v + 1, g = 1;
    if (Array.isArray(p)) {
      for (let m = 0; m < p.length; m += 1)
        p[m] && e.virtual.slides.unshift(p[m]);
      h = v + p.length, g = p.length;
    } else
      e.virtual.slides.unshift(p);
    if (e.params.virtual.cache) {
      const m = e.virtual.cache, b = {};
      Object.keys(m).forEach((y) => {
        const _ = m[y], x = _.getAttribute("data-swiper-slide-index");
        x && _.setAttribute("data-swiper-slide-index", parseInt(x, 10) + g), b[parseInt(y, 10) + g] = _;
      }), e.virtual.cache = b;
    }
    l(!0), e.slideTo(h, 0);
  }
  function f(p) {
    if (typeof p > "u" || p === null)
      return;
    let v = e.activeIndex;
    if (Array.isArray(p))
      for (let h = p.length - 1; h >= 0; h -= 1)
        e.virtual.slides.splice(p[h], 1), e.params.virtual.cache && delete e.virtual.cache[p[h]], p[h] < v && (v -= 1), v = Math.max(v, 0);
    else
      e.virtual.slides.splice(p, 1), e.params.virtual.cache && delete e.virtual.cache[p], p < v && (v -= 1), v = Math.max(v, 0);
    l(!0), e.slideTo(v, 0);
  }
  function c() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), l(!0), e.slideTo(0, 0);
  }
  r("beforeInit", () => {
    if (!e.params.virtual.enabled)
      return;
    let p;
    if (typeof e.passedParams.virtual.slides > "u") {
      const v = [...e.slidesEl.children].filter((h) => h.matches(`.${e.params.slideClass}, swiper-slide`));
      v && v.length && (e.virtual.slides = [...v], p = !0, v.forEach((h, g) => {
        h.setAttribute("data-swiper-slide-index", g), e.virtual.cache[g] = h, h.remove();
      }));
    }
    p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, e.params.initialSlide || l();
  }), r("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(n), n = setTimeout(() => {
      l();
    }, 100)) : l());
  }), r("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && Pl(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: u,
    prependSlide: d,
    removeSlide: f,
    removeAllSlides: c,
    update: l
  });
}
function S6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = ba(), i = Br();
  e.keyboard = {
    enabled: !1
  }, t({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function s(u) {
    if (!e.enabled)
      return;
    const {
      rtlTranslate: d
    } = e;
    let f = u;
    f.originalEvent && (f = f.originalEvent);
    const c = f.keyCode || f.charCode, p = e.params.keyboard.pageUpDown, v = p && c === 33, h = p && c === 34, g = c === 37, m = c === 39, b = c === 38, y = c === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && m || e.isVertical() && y || h) || !e.allowSlidePrev && (e.isHorizontal() && g || e.isVertical() && b || v))
      return !1;
    if (!(f.shiftKey || f.altKey || f.ctrlKey || f.metaKey) && !(n.activeElement && n.activeElement.nodeName && (n.activeElement.nodeName.toLowerCase() === "input" || n.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (v || h || g || m || b || y)) {
        let _ = !1;
        if (Es(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Es(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const x = e.el, w = x.clientWidth, k = x.clientHeight, S = i.innerWidth, P = i.innerHeight, A = _d(x);
        d && (A.left -= x.scrollLeft);
        const E = [[A.left, A.top], [A.left + w, A.top], [A.left, A.top + k], [A.left + w, A.top + k]];
        for (let O = 0; O < E.length; O += 1) {
          const T = E[O];
          if (T[0] >= 0 && T[0] <= S && T[1] >= 0 && T[1] <= P) {
            if (T[0] === 0 && T[1] === 0)
              continue;
            _ = !0;
          }
        }
        if (!_)
          return;
      }
      e.isHorizontal() ? ((v || h || g || m) && (f.preventDefault ? f.preventDefault() : f.returnValue = !1), ((h || m) && !d || (v || g) && d) && e.slideNext(), ((v || g) && !d || (h || m) && d) && e.slidePrev()) : ((v || h || b || y) && (f.preventDefault ? f.preventDefault() : f.returnValue = !1), (h || y) && e.slideNext(), (v || b) && e.slidePrev()), a("keyPress", c);
    }
  }
  function o() {
    e.keyboard.enabled || (n.addEventListener("keydown", s), e.keyboard.enabled = !0);
  }
  function l() {
    e.keyboard.enabled && (n.removeEventListener("keydown", s), e.keyboard.enabled = !1);
  }
  r("init", () => {
    e.params.keyboard.enabled && o();
  }), r("destroy", () => {
    e.keyboard.enabled && l();
  }), Object.assign(e.keyboard, {
    enable: o,
    disable: l
  });
}
function E6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = Br();
  t({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let i, s = vn(), o;
  const l = [];
  function u(b) {
    let w = 0, k = 0, S = 0, P = 0;
    return "detail" in b && (k = b.detail), "wheelDelta" in b && (k = -b.wheelDelta / 120), "wheelDeltaY" in b && (k = -b.wheelDeltaY / 120), "wheelDeltaX" in b && (w = -b.wheelDeltaX / 120), "axis" in b && b.axis === b.HORIZONTAL_AXIS && (w = k, k = 0), S = w * 10, P = k * 10, "deltaY" in b && (P = b.deltaY), "deltaX" in b && (S = b.deltaX), b.shiftKey && !S && (S = P, P = 0), (S || P) && b.deltaMode && (b.deltaMode === 1 ? (S *= 40, P *= 40) : (S *= 800, P *= 800)), S && !w && (w = S < 1 ? -1 : 1), P && !k && (k = P < 1 ? -1 : 1), {
      spinX: w,
      spinY: k,
      pixelX: S,
      pixelY: P
    };
  }
  function d() {
    e.enabled && (e.mouseEntered = !0);
  }
  function f() {
    e.enabled && (e.mouseEntered = !1);
  }
  function c(b) {
    return e.params.mousewheel.thresholdDelta && b.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && vn() - s < e.params.mousewheel.thresholdTime ? !1 : b.delta >= 6 && vn() - s < 60 ? !0 : (b.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), a("scroll", b.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), a("scroll", b.raw)), s = new n.Date().getTime(), !1);
  }
  function p(b) {
    const y = e.params.mousewheel;
    if (b.direction < 0) {
      if (e.isEnd && !e.params.loop && y.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && y.releaseOnEdges)
      return !0;
    return !1;
  }
  function v(b) {
    let y = b, _ = !0;
    if (!e.enabled || b.target.closest(`.${e.params.mousewheel.noMousewheelClass}`))
      return;
    const x = e.params.mousewheel;
    e.params.cssMode && y.preventDefault();
    let w = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (w = document.querySelector(e.params.mousewheel.eventsTarget));
    const k = w && w.contains(y.target);
    if (!e.mouseEntered && !k && !x.releaseOnEdges)
      return !0;
    y.originalEvent && (y = y.originalEvent);
    let S = 0;
    const P = e.rtlTranslate ? -1 : 1, A = u(y);
    if (x.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(A.pixelX) > Math.abs(A.pixelY))
          S = -A.pixelX * P;
        else
          return !0;
      else if (Math.abs(A.pixelY) > Math.abs(A.pixelX))
        S = -A.pixelY;
      else
        return !0;
    else
      S = Math.abs(A.pixelX) > Math.abs(A.pixelY) ? -A.pixelX * P : -A.pixelY;
    if (S === 0)
      return !0;
    x.invert && (S = -S);
    let E = e.getTranslate() + S * x.sensitivity;
    if (E >= e.minTranslate() && (E = e.minTranslate()), E <= e.maxTranslate() && (E = e.maxTranslate()), _ = e.params.loop ? !0 : !(E === e.minTranslate() || E === e.maxTranslate()), _ && e.params.nested && y.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const O = {
        time: vn(),
        delta: Math.abs(S),
        direction: Math.sign(S),
        raw: b
      };
      l.length >= 2 && l.shift();
      const T = l.length ? l[l.length - 1] : void 0;
      if (l.push(O), T ? (O.direction !== T.direction || O.delta > T.delta || O.time > T.time + 150) && c(O) : c(O), p(O))
        return !0;
    } else {
      const O = {
        time: vn(),
        delta: Math.abs(S),
        direction: Math.sign(S)
      }, T = o && O.time < o.time + 500 && O.delta <= o.delta && O.direction === o.direction;
      if (!T) {
        o = void 0;
        let D = e.getTranslate() + S * x.sensitivity;
        const $ = e.isBeginning, I = e.isEnd;
        if (D >= e.minTranslate() && (D = e.minTranslate()), D <= e.maxTranslate() && (D = e.maxTranslate()), e.setTransition(0), e.setTranslate(D), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!$ && e.isBeginning || !I && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: O.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(i), i = void 0, l.length >= 15 && l.shift();
          const F = l.length ? l[l.length - 1] : void 0, j = l[0];
          if (l.push(O), F && (O.delta > F.delta || O.direction !== F.direction))
            l.splice(0);
          else if (l.length >= 15 && O.time - j.time < 500 && j.delta - O.delta >= 1 && O.delta <= 6) {
            const M = S > 0 ? 0.8 : 0.2;
            o = O, l.splice(0), i = Ms(() => {
              e.slideToClosest(e.params.speed, !0, void 0, M);
            }, 0);
          }
          i || (i = Ms(() => {
            o = O, l.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
          }, 500));
        }
        if (T || a("scroll", y), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), D === e.minTranslate() || D === e.maxTranslate())
          return !0;
      }
    }
    return y.preventDefault ? y.preventDefault() : y.returnValue = !1, !1;
  }
  function h(b) {
    let y = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (y = document.querySelector(e.params.mousewheel.eventsTarget)), y[b]("mouseenter", d), y[b]("mouseleave", f), y[b]("wheel", v);
  }
  function g() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", v), !0) : e.mousewheel.enabled ? !1 : (h("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function m() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, v), !0) : e.mousewheel.enabled ? (h("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  r("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && m(), e.params.mousewheel.enabled && g();
  }), r("destroy", () => {
    e.params.cssMode && g(), e.mousewheel.enabled && m();
  }), Object.assign(e.mousewheel, {
    enable: g,
    disable: m
  });
}
function ib(e, t, r, a) {
  return e.params.createElements && Object.keys(a).forEach((n) => {
    if (!r[n] && r.auto === !0) {
      let i = ha(e.el, `.${a[n]}`)[0];
      i || (i = Ln("div", a[n]), i.className = a[n], e.el.append(i)), r[n] = i, t[n] = i;
    }
  }), r;
}
function O6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  const n = (v) => (Array.isArray(v) || (v = [v].filter((h) => !!h)), v);
  function i(v) {
    let h;
    return v && typeof v == "string" && e.isElement && (h = e.el.shadowRoot.querySelector(v), h) ? h : (v && (typeof v == "string" && (h = [...document.querySelectorAll(v)]), e.params.uniqueNavElements && typeof v == "string" && h.length > 1 && e.el.querySelectorAll(v).length === 1 && (h = e.el.querySelector(v))), v && !h ? v : h);
  }
  function s(v, h) {
    const g = e.params.navigation;
    v = n(v), v.forEach((m) => {
      m && (m.classList[h ? "add" : "remove"](...g.disabledClass.split(" ")), m.tagName === "BUTTON" && (m.disabled = h), e.params.watchOverflow && e.enabled && m.classList[e.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  function o() {
    const {
      nextEl: v,
      prevEl: h
    } = e.navigation;
    if (e.params.loop) {
      s(h, !1), s(v, !1);
      return;
    }
    s(h, e.isBeginning && !e.params.rewind), s(v, e.isEnd && !e.params.rewind);
  }
  function l(v) {
    v.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), a("navigationPrev"));
  }
  function u(v) {
    v.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), a("navigationNext"));
  }
  function d() {
    const v = e.params.navigation;
    if (e.params.navigation = ib(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(v.nextEl || v.prevEl))
      return;
    let h = i(v.nextEl), g = i(v.prevEl);
    Object.assign(e.navigation, {
      nextEl: h,
      prevEl: g
    }), h = n(h), g = n(g);
    const m = (b, y) => {
      b && b.addEventListener("click", y === "next" ? u : l), !e.enabled && b && b.classList.add(...v.lockClass.split(" "));
    };
    h.forEach((b) => m(b, "next")), g.forEach((b) => m(b, "prev"));
  }
  function f() {
    let {
      nextEl: v,
      prevEl: h
    } = e.navigation;
    v = n(v), h = n(h);
    const g = (m, b) => {
      m.removeEventListener("click", b === "next" ? u : l), m.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    v.forEach((m) => g(m, "next")), h.forEach((m) => g(m, "prev"));
  }
  r("init", () => {
    e.params.navigation.enabled === !1 ? p() : (d(), o());
  }), r("toEdge fromEdge lock unlock", () => {
    o();
  }), r("destroy", () => {
    f();
  }), r("enable disable", () => {
    let {
      nextEl: v,
      prevEl: h
    } = e.navigation;
    v = n(v), h = n(h), [...v, ...h].filter((g) => !!g).forEach((g) => g.classList[e.enabled ? "remove" : "add"](e.params.navigation.lockClass));
  }), r("click", (v, h) => {
    let {
      nextEl: g,
      prevEl: m
    } = e.navigation;
    g = n(g), m = n(m);
    const b = h.target;
    if (e.params.navigation.hideOnClick && !m.includes(b) && !g.includes(b)) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === b || e.pagination.el.contains(b)))
        return;
      let y;
      g.length ? y = g[0].classList.contains(e.params.navigation.hiddenClass) : m.length && (y = m[0].classList.contains(e.params.navigation.hiddenClass)), a(y === !0 ? "navigationShow" : "navigationHide"), [...g, ...m].filter((_) => !!_).forEach((_) => _.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const c = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), d(), o();
  }, p = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), f();
  };
  Object.assign(e.navigation, {
    enable: c,
    disable: p,
    update: o,
    init: d,
    destroy: f
  });
}
function Ui(e = "") {
  return `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function C6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = "swiper-pagination";
  t({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (m) => m,
      formatFractionTotal: (m) => m,
      bulletClass: `${n}-bullet`,
      bulletActiveClass: `${n}-bullet-active`,
      modifierClass: `${n}-`,
      currentClass: `${n}-current`,
      totalClass: `${n}-total`,
      hiddenClass: `${n}-hidden`,
      progressbarFillClass: `${n}-progressbar-fill`,
      progressbarOppositeClass: `${n}-progressbar-opposite`,
      clickableClass: `${n}-clickable`,
      lockClass: `${n}-lock`,
      horizontalClass: `${n}-horizontal`,
      verticalClass: `${n}-vertical`,
      paginationDisabledClass: `${n}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let i, s = 0;
  const o = (m) => (Array.isArray(m) || (m = [m].filter((b) => !!b)), m);
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function u(m, b) {
    const {
      bulletActiveClass: y
    } = e.params.pagination;
    m && (m = m[`${b === "prev" ? "previous" : "next"}ElementSibling`], m && (m.classList.add(`${y}-${b}`), m = m[`${b === "prev" ? "previous" : "next"}ElementSibling`], m && m.classList.add(`${y}-${b}-${b}`)));
  }
  function d(m) {
    const b = m.target.closest(Ui(e.params.pagination.bulletClass));
    if (!b)
      return;
    m.preventDefault();
    const y = Gl(b) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === y)
        return;
      const _ = e.getSlideIndexByData(y), x = e.getSlideIndexByData(e.realIndex);
      _ > e.slides.length - e.loopedSlides && e.loopFix({
        direction: _ > x ? "next" : "prev",
        activeSlideIndex: _,
        slideTo: !1
      }), e.slideToLoop(y);
    } else
      e.slideTo(y);
  }
  function f() {
    const m = e.rtl, b = e.params.pagination;
    if (l())
      return;
    let y = e.pagination.el;
    y = o(y);
    let _, x;
    const w = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, k = e.params.loop ? Math.ceil(w / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (x = e.previousRealIndex || 0, _ = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (_ = e.snapIndex, x = e.previousSnapIndex) : (x = e.previousIndex || 0, _ = e.activeIndex || 0), b.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const S = e.pagination.bullets;
      let P, A, E;
      if (b.dynamicBullets && (i = Fp(S[0], e.isHorizontal() ? "width" : "height", !0), y.forEach((O) => {
        O.style[e.isHorizontal() ? "width" : "height"] = `${i * (b.dynamicMainBullets + 4)}px`;
      }), b.dynamicMainBullets > 1 && x !== void 0 && (s += _ - (x || 0), s > b.dynamicMainBullets - 1 ? s = b.dynamicMainBullets - 1 : s < 0 && (s = 0)), P = Math.max(_ - s, 0), A = P + (Math.min(S.length, b.dynamicMainBullets) - 1), E = (A + P) / 2), S.forEach((O) => {
        const T = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((D) => `${b.bulletActiveClass}${D}`)].map((D) => typeof D == "string" && D.includes(" ") ? D.split(" ") : D).flat();
        O.classList.remove(...T);
      }), y.length > 1)
        S.forEach((O) => {
          const T = Gl(O);
          T === _ ? O.classList.add(...b.bulletActiveClass.split(" ")) : e.isElement && O.setAttribute("part", "bullet"), b.dynamicBullets && (T >= P && T <= A && O.classList.add(...`${b.bulletActiveClass}-main`.split(" ")), T === P && u(O, "prev"), T === A && u(O, "next"));
        });
      else {
        const O = S[_];
        if (O && O.classList.add(...b.bulletActiveClass.split(" ")), e.isElement && S.forEach((T, D) => {
          T.setAttribute("part", D === _ ? "bullet-active" : "bullet");
        }), b.dynamicBullets) {
          const T = S[P], D = S[A];
          for (let $ = P; $ <= A; $ += 1)
            S[$] && S[$].classList.add(...`${b.bulletActiveClass}-main`.split(" "));
          u(T, "prev"), u(D, "next");
        }
      }
      if (b.dynamicBullets) {
        const O = Math.min(S.length, b.dynamicMainBullets + 4), T = (i * O - i) / 2 - E * i, D = m ? "right" : "left";
        S.forEach(($) => {
          $.style[e.isHorizontal() ? D : "top"] = `${T}px`;
        });
      }
    }
    y.forEach((S, P) => {
      if (b.type === "fraction" && (S.querySelectorAll(Ui(b.currentClass)).forEach((A) => {
        A.textContent = b.formatFractionCurrent(_ + 1);
      }), S.querySelectorAll(Ui(b.totalClass)).forEach((A) => {
        A.textContent = b.formatFractionTotal(k);
      })), b.type === "progressbar") {
        let A;
        b.progressbarOpposite ? A = e.isHorizontal() ? "vertical" : "horizontal" : A = e.isHorizontal() ? "horizontal" : "vertical";
        const E = (_ + 1) / k;
        let O = 1, T = 1;
        A === "horizontal" ? O = E : T = E, S.querySelectorAll(Ui(b.progressbarFillClass)).forEach((D) => {
          D.style.transform = `translate3d(0,0,0) scaleX(${O}) scaleY(${T})`, D.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      b.type === "custom" && b.renderCustom ? (S.innerHTML = b.renderCustom(e, _ + 1, k), P === 0 && a("paginationRender", S)) : (P === 0 && a("paginationRender", S), a("paginationUpdate", S)), e.params.watchOverflow && e.enabled && S.classList[e.isLocked ? "add" : "remove"](b.lockClass);
    });
  }
  function c() {
    const m = e.params.pagination;
    if (l())
      return;
    const b = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length;
    let y = e.pagination.el;
    y = o(y);
    let _ = "";
    if (m.type === "bullets") {
      let x = e.params.loop ? Math.ceil(b / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && x > b && (x = b);
      for (let w = 0; w < x; w += 1)
        m.renderBullet ? _ += m.renderBullet.call(e, w, m.bulletClass) : _ += `<${m.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${m.bulletClass}"></${m.bulletElement}>`;
    }
    m.type === "fraction" && (m.renderFraction ? _ = m.renderFraction.call(e, m.currentClass, m.totalClass) : _ = `<span class="${m.currentClass}"></span> / <span class="${m.totalClass}"></span>`), m.type === "progressbar" && (m.renderProgressbar ? _ = m.renderProgressbar.call(e, m.progressbarFillClass) : _ = `<span class="${m.progressbarFillClass}"></span>`), e.pagination.bullets = [], y.forEach((x) => {
      m.type !== "custom" && (x.innerHTML = _ || ""), m.type === "bullets" && e.pagination.bullets.push(...x.querySelectorAll(Ui(m.bulletClass)));
    }), m.type !== "custom" && a("paginationRender", y[0]);
  }
  function p() {
    e.params.pagination = ib(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const m = e.params.pagination;
    if (!m.el)
      return;
    let b;
    typeof m.el == "string" && e.isElement && (b = e.el.shadowRoot.querySelector(m.el)), !b && typeof m.el == "string" && (b = [...document.querySelectorAll(m.el)]), b || (b = m.el), !(!b || b.length === 0) && (e.params.uniqueNavElements && typeof m.el == "string" && Array.isArray(b) && b.length > 1 && (b = [...e.el.querySelectorAll(m.el)], b.length > 1 && (b = b.filter((y) => Es(y, ".swiper")[0] === e.el)[0])), Array.isArray(b) && b.length === 1 && (b = b[0]), Object.assign(e.pagination, {
      el: b
    }), b = o(b), b.forEach((y) => {
      m.type === "bullets" && m.clickable && y.classList.add(m.clickableClass), y.classList.add(m.modifierClass + m.type), y.classList.add(e.isHorizontal() ? m.horizontalClass : m.verticalClass), m.type === "bullets" && m.dynamicBullets && (y.classList.add(`${m.modifierClass}${m.type}-dynamic`), s = 0, m.dynamicMainBullets < 1 && (m.dynamicMainBullets = 1)), m.type === "progressbar" && m.progressbarOpposite && y.classList.add(m.progressbarOppositeClass), m.clickable && y.addEventListener("click", d), e.enabled || y.classList.add(m.lockClass);
    }));
  }
  function v() {
    const m = e.params.pagination;
    if (l())
      return;
    let b = e.pagination.el;
    b && (b = o(b), b.forEach((y) => {
      y.classList.remove(m.hiddenClass), y.classList.remove(m.modifierClass + m.type), y.classList.remove(e.isHorizontal() ? m.horizontalClass : m.verticalClass), m.clickable && y.removeEventListener("click", d);
    })), e.pagination.bullets && e.pagination.bullets.forEach((y) => y.classList.remove(...m.bulletActiveClass.split(" ")));
  }
  r("changeDirection", () => {
    if (!e.pagination || !e.pagination.el)
      return;
    const m = e.params.pagination;
    let {
      el: b
    } = e.pagination;
    b = o(b), b.forEach((y) => {
      y.classList.remove(m.horizontalClass, m.verticalClass), y.classList.add(e.isHorizontal() ? m.horizontalClass : m.verticalClass);
    });
  }), r("init", () => {
    e.params.pagination.enabled === !1 ? g() : (p(), c(), f());
  }), r("activeIndexChange", () => {
    typeof e.snapIndex > "u" && f();
  }), r("snapIndexChange", () => {
    f();
  }), r("snapGridLengthChange", () => {
    c(), f();
  }), r("destroy", () => {
    v();
  }), r("enable disable", () => {
    let {
      el: m
    } = e.pagination;
    m && (m = o(m), m.forEach((b) => b.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), r("lock unlock", () => {
    f();
  }), r("click", (m, b) => {
    const y = b.target;
    let {
      el: _
    } = e.pagination;
    if (Array.isArray(_) || (_ = [_].filter((x) => !!x)), e.params.pagination.el && e.params.pagination.hideOnClick && _ && _.length > 0 && !y.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && y === e.navigation.nextEl || e.navigation.prevEl && y === e.navigation.prevEl))
        return;
      const x = _[0].classList.contains(e.params.pagination.hiddenClass);
      a(x === !0 ? "paginationShow" : "paginationHide"), _.forEach((w) => w.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const h = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = e.pagination;
    m && (m = o(m), m.forEach((b) => b.classList.remove(e.params.pagination.paginationDisabledClass))), p(), c(), f();
  }, g = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = e.pagination;
    m && (m = o(m), m.forEach((b) => b.classList.add(e.params.pagination.paginationDisabledClass))), v();
  };
  Object.assign(e.pagination, {
    enable: h,
    disable: g,
    render: c,
    update: f,
    init: p,
    destroy: v
  });
}
function k6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = ba();
  let i = !1, s = null, o = null, l, u, d, f;
  t({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function c() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: E,
      rtlTranslate: O
    } = e, {
      dragEl: T,
      el: D
    } = E, $ = e.params.scrollbar, I = e.params.loop ? e.progressLoop : e.progress;
    let F = u, j = (d - u) * I;
    O ? (j = -j, j > 0 ? (F = u - j, j = 0) : -j + u > d && (F = d + j)) : j < 0 ? (F = u + j, j = 0) : j + u > d && (F = d - j), e.isHorizontal() ? (T.style.transform = `translate3d(${j}px, 0, 0)`, T.style.width = `${F}px`) : (T.style.transform = `translate3d(0px, ${j}px, 0)`, T.style.height = `${F}px`), $.hide && (clearTimeout(s), D.style.opacity = 1, s = setTimeout(() => {
      D.style.opacity = 0, D.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function p(E) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${E}ms`);
  }
  function v() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: E
    } = e, {
      dragEl: O,
      el: T
    } = E;
    O.style.width = "", O.style.height = "", d = e.isHorizontal() ? T.offsetWidth : T.offsetHeight, f = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? u = d * f : u = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? O.style.width = `${u}px` : O.style.height = `${u}px`, f >= 1 ? T.style.display = "none" : T.style.display = "", e.params.scrollbar.hide && (T.style.opacity = 0), e.params.watchOverflow && e.enabled && E.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function h(E) {
    return e.isHorizontal() ? E.clientX : E.clientY;
  }
  function g(E) {
    const {
      scrollbar: O,
      rtlTranslate: T
    } = e, {
      el: D
    } = O;
    let $;
    $ = (h(E) - _d(D)[e.isHorizontal() ? "left" : "top"] - (l !== null ? l : u / 2)) / (d - u), $ = Math.max(Math.min($, 1), 0), T && ($ = 1 - $);
    const I = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * $;
    e.updateProgress(I), e.setTranslate(I), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function m(E) {
    const O = e.params.scrollbar, {
      scrollbar: T,
      wrapperEl: D
    } = e, {
      el: $,
      dragEl: I
    } = T;
    i = !0, l = E.target === I ? h(E) - E.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, E.preventDefault(), E.stopPropagation(), D.style.transitionDuration = "100ms", I.style.transitionDuration = "100ms", g(E), clearTimeout(o), $.style.transitionDuration = "0ms", O.hide && ($.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), a("scrollbarDragStart", E);
  }
  function b(E) {
    const {
      scrollbar: O,
      wrapperEl: T
    } = e, {
      el: D,
      dragEl: $
    } = O;
    i && (E.preventDefault ? E.preventDefault() : E.returnValue = !1, g(E), T.style.transitionDuration = "0ms", D.style.transitionDuration = "0ms", $.style.transitionDuration = "0ms", a("scrollbarDragMove", E));
  }
  function y(E) {
    const O = e.params.scrollbar, {
      scrollbar: T,
      wrapperEl: D
    } = e, {
      el: $
    } = T;
    i && (i = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", D.style.transitionDuration = ""), O.hide && (clearTimeout(o), o = Ms(() => {
      $.style.opacity = 0, $.style.transitionDuration = "400ms";
    }, 1e3)), a("scrollbarDragEnd", E), O.snapOnRelease && e.slideToClosest());
  }
  function _(E) {
    const {
      scrollbar: O,
      params: T
    } = e, D = O.el;
    if (!D)
      return;
    const $ = D, I = T.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, F = T.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!$)
      return;
    const j = E === "on" ? "addEventListener" : "removeEventListener";
    $[j]("pointerdown", m, I), n[j]("pointermove", b, I), n[j]("pointerup", y, F);
  }
  function x() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("on");
  }
  function w() {
    !e.params.scrollbar.el || !e.scrollbar.el || _("off");
  }
  function k() {
    const {
      scrollbar: E,
      el: O
    } = e;
    e.params.scrollbar = ib(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const T = e.params.scrollbar;
    if (!T.el)
      return;
    let D;
    typeof T.el == "string" && e.isElement && (D = e.el.shadowRoot.querySelector(T.el)), !D && typeof T.el == "string" ? D = n.querySelectorAll(T.el) : D || (D = T.el), e.params.uniqueNavElements && typeof T.el == "string" && D.length > 1 && O.querySelectorAll(T.el).length === 1 && (D = O.querySelector(T.el)), D.length > 0 && (D = D[0]), D.classList.add(e.isHorizontal() ? T.horizontalClass : T.verticalClass);
    let $;
    D && ($ = D.querySelector(`.${e.params.scrollbar.dragClass}`), $ || ($ = Ln("div", e.params.scrollbar.dragClass), D.append($))), Object.assign(E, {
      el: D,
      dragEl: $
    }), T.draggable && x(), D && D.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
  }
  function S() {
    const E = e.params.scrollbar, O = e.scrollbar.el;
    O && O.classList.remove(e.isHorizontal() ? E.horizontalClass : E.verticalClass), w();
  }
  r("init", () => {
    e.params.scrollbar.enabled === !1 ? A() : (k(), v(), c());
  }), r("update resize observerUpdate lock unlock", () => {
    v();
  }), r("setTranslate", () => {
    c();
  }), r("setTransition", (E, O) => {
    p(O);
  }), r("enable disable", () => {
    const {
      el: E
    } = e.scrollbar;
    E && E.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
  }), r("destroy", () => {
    S();
  });
  const P = () => {
    e.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), k(), v(), c();
  }, A = () => {
    e.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), S();
  };
  Object.assign(e.scrollbar, {
    enable: P,
    disable: A,
    updateSize: v,
    setTranslate: c,
    init: k,
    destroy: S
  });
}
function P6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    parallax: {
      enabled: !1
    }
  });
  const a = (s, o) => {
    const {
      rtl: l
    } = e, u = l ? -1 : 1, d = s.getAttribute("data-swiper-parallax") || "0";
    let f = s.getAttribute("data-swiper-parallax-x"), c = s.getAttribute("data-swiper-parallax-y");
    const p = s.getAttribute("data-swiper-parallax-scale"), v = s.getAttribute("data-swiper-parallax-opacity"), h = s.getAttribute("data-swiper-parallax-rotate");
    if (f || c ? (f = f || "0", c = c || "0") : e.isHorizontal() ? (f = d, c = "0") : (c = d, f = "0"), f.indexOf("%") >= 0 ? f = `${parseInt(f, 10) * o * u}%` : f = `${f * o * u}px`, c.indexOf("%") >= 0 ? c = `${parseInt(c, 10) * o}%` : c = `${c * o}px`, typeof v < "u" && v !== null) {
      const m = v - (v - 1) * (1 - Math.abs(o));
      s.style.opacity = m;
    }
    let g = `translate3d(${f}, ${c}, 0px)`;
    if (typeof p < "u" && p !== null) {
      const m = p - (p - 1) * (1 - Math.abs(o));
      g += ` scale(${m})`;
    }
    if (h && typeof h < "u" && h !== null) {
      const m = h * o * -1;
      g += ` rotate(${m}deg)`;
    }
    s.style.transform = g;
  }, n = () => {
    const {
      el: s,
      slides: o,
      progress: l,
      snapGrid: u
    } = e;
    ha(s, "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((d) => {
      a(d, l);
    }), o.forEach((d, f) => {
      let c = d.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (c += Math.ceil(f / 2) - l * (u.length - 1)), c = Math.min(Math.max(c, -1), 1), d.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach((p) => {
        a(p, c);
      });
    });
  }, i = (s = e.params.speed) => {
    const {
      el: o
    } = e;
    o.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((l) => {
      let u = parseInt(l.getAttribute("data-swiper-parallax-duration"), 10) || s;
      s === 0 && (u = 0), l.style.transitionDuration = `${u}ms`;
    });
  };
  r("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), r("init", () => {
    e.params.parallax.enabled && n();
  }), r("setTranslate", () => {
    e.params.parallax.enabled && n();
  }), r("setTransition", (s, o) => {
    e.params.parallax.enabled && i(o);
  });
}
function M6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a
}) {
  const n = Br();
  t({
    zoom: {
      enabled: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let i = 1, s = !1, o, l;
  const u = [], d = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, f = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, c = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let p = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return p;
    },
    set(I) {
      if (p !== I) {
        const F = d.imageEl, j = d.slideEl;
        a("zoomChange", I, F, j);
      }
      p = I;
    }
  });
  function v() {
    if (u.length < 2)
      return 1;
    const I = u[0].pageX, F = u[0].pageY, j = u[1].pageX, M = u[1].pageY;
    return Math.sqrt((j - I) ** 2 + (M - F) ** 2);
  }
  function h() {
    if (u.length < 2)
      return {
        x: null,
        y: null
      };
    const I = d.imageEl.getBoundingClientRect();
    return [(u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - I.x) / i, (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - I.y) / i];
  }
  function g() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function m(I) {
    const F = g();
    return !!(I.target.matches(F) || e.slides.filter((j) => j.contains(I.target)).length > 0);
  }
  function b(I) {
    const F = `.${e.params.zoom.containerClass}`;
    return !!(I.target.matches(F) || [...e.el.querySelectorAll(F)].filter((j) => j.contains(I.target)).length > 0);
  }
  function y(I) {
    if (I.pointerType === "mouse" && u.splice(0, u.length), !m(I))
      return;
    const F = e.params.zoom;
    if (o = !1, l = !1, u.push(I), !(u.length < 2)) {
      if (o = !0, d.scaleStart = v(), !d.slideEl) {
        d.slideEl = I.target.closest(`.${e.params.slideClass}, swiper-slide`), d.slideEl || (d.slideEl = e.slides[e.activeIndex]);
        let j = d.slideEl.querySelector(`.${F.containerClass}`);
        if (j && (j = j.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = j, j ? d.imageWrapEl = Es(d.imageEl, `.${F.containerClass}`)[0] : d.imageWrapEl = void 0, !d.imageWrapEl) {
          d.imageEl = void 0;
          return;
        }
        d.maxRatio = d.imageWrapEl.getAttribute("data-swiper-zoom") || F.maxRatio;
      }
      if (d.imageEl) {
        const [j, M] = h();
        d.originX = j, d.originY = M, d.imageEl.style.transitionDuration = "0ms";
      }
      s = !0;
    }
  }
  function _(I) {
    if (!m(I))
      return;
    const F = e.params.zoom, j = e.zoom, M = u.findIndex((q) => q.pointerId === I.pointerId);
    M >= 0 && (u[M] = I), !(u.length < 2) && (l = !0, d.scaleMove = v(), d.imageEl && (j.scale = d.scaleMove / d.scaleStart * i, j.scale > d.maxRatio && (j.scale = d.maxRatio - 1 + (j.scale - d.maxRatio + 1) ** 0.5), j.scale < F.minRatio && (j.scale = F.minRatio + 1 - (F.minRatio - j.scale + 1) ** 0.5), d.imageEl.style.transform = `translate3d(0,0,0) scale(${j.scale})`));
  }
  function x(I) {
    if (!m(I) || I.pointerType === "mouse" && I.type === "pointerout")
      return;
    const F = e.params.zoom, j = e.zoom, M = u.findIndex((q) => q.pointerId === I.pointerId);
    M >= 0 && u.splice(M, 1), !(!o || !l) && (o = !1, l = !1, d.imageEl && (j.scale = Math.max(Math.min(j.scale, d.maxRatio), F.minRatio), d.imageEl.style.transitionDuration = `${e.params.speed}ms`, d.imageEl.style.transform = `translate3d(0,0,0) scale(${j.scale})`, i = j.scale, s = !1, j.scale > 1 && d.slideEl ? d.slideEl.classList.add(`${F.zoomedSlideClass}`) : j.scale <= 1 && d.slideEl && d.slideEl.classList.remove(`${F.zoomedSlideClass}`), j.scale === 1 && (d.originX = 0, d.originY = 0, d.slideEl = void 0)));
  }
  function w(I) {
    const F = e.device;
    if (!d.imageEl || f.isTouched)
      return;
    F.android && I.cancelable && I.preventDefault(), f.isTouched = !0;
    const j = u.length > 0 ? u[0] : I;
    f.touchesStart.x = j.pageX, f.touchesStart.y = j.pageY;
  }
  function k(I) {
    if (!m(I) || !b(I))
      return;
    const F = e.zoom;
    if (!d.imageEl || !f.isTouched || !d.slideEl)
      return;
    f.isMoved || (f.width = d.imageEl.offsetWidth, f.height = d.imageEl.offsetHeight, f.startX = jp(d.imageWrapEl, "x") || 0, f.startY = jp(d.imageWrapEl, "y") || 0, d.slideWidth = d.slideEl.offsetWidth, d.slideHeight = d.slideEl.offsetHeight, d.imageWrapEl.style.transitionDuration = "0ms");
    const j = f.width * F.scale, M = f.height * F.scale;
    if (j < d.slideWidth && M < d.slideHeight)
      return;
    if (f.minX = Math.min(d.slideWidth / 2 - j / 2, 0), f.maxX = -f.minX, f.minY = Math.min(d.slideHeight / 2 - M / 2, 0), f.maxY = -f.minY, f.touchesCurrent.x = u.length > 0 ? u[0].pageX : I.pageX, f.touchesCurrent.y = u.length > 0 ? u[0].pageY : I.pageY, Math.max(Math.abs(f.touchesCurrent.x - f.touchesStart.x), Math.abs(f.touchesCurrent.y - f.touchesStart.y)) > 5 && (e.allowClick = !1), !f.isMoved && !s) {
      if (e.isHorizontal() && (Math.floor(f.minX) === Math.floor(f.startX) && f.touchesCurrent.x < f.touchesStart.x || Math.floor(f.maxX) === Math.floor(f.startX) && f.touchesCurrent.x > f.touchesStart.x)) {
        f.isTouched = !1;
        return;
      }
      if (!e.isHorizontal() && (Math.floor(f.minY) === Math.floor(f.startY) && f.touchesCurrent.y < f.touchesStart.y || Math.floor(f.maxY) === Math.floor(f.startY) && f.touchesCurrent.y > f.touchesStart.y)) {
        f.isTouched = !1;
        return;
      }
    }
    I.cancelable && I.preventDefault(), I.stopPropagation(), f.isMoved = !0;
    const le = (F.scale - i) / (d.maxRatio - e.params.zoom.minRatio), {
      originX: Z,
      originY: G
    } = d;
    f.currentX = f.touchesCurrent.x - f.touchesStart.x + f.startX + le * (f.width - Z * 2), f.currentY = f.touchesCurrent.y - f.touchesStart.y + f.startY + le * (f.height - G * 2), f.currentX < f.minX && (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8), f.currentX > f.maxX && (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8), f.currentY < f.minY && (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8), f.currentY > f.maxY && (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8), c.prevPositionX || (c.prevPositionX = f.touchesCurrent.x), c.prevPositionY || (c.prevPositionY = f.touchesCurrent.y), c.prevTime || (c.prevTime = Date.now()), c.x = (f.touchesCurrent.x - c.prevPositionX) / (Date.now() - c.prevTime) / 2, c.y = (f.touchesCurrent.y - c.prevPositionY) / (Date.now() - c.prevTime) / 2, Math.abs(f.touchesCurrent.x - c.prevPositionX) < 2 && (c.x = 0), Math.abs(f.touchesCurrent.y - c.prevPositionY) < 2 && (c.y = 0), c.prevPositionX = f.touchesCurrent.x, c.prevPositionY = f.touchesCurrent.y, c.prevTime = Date.now(), d.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`;
  }
  function S() {
    const I = e.zoom;
    if (!d.imageEl)
      return;
    if (!f.isTouched || !f.isMoved) {
      f.isTouched = !1, f.isMoved = !1;
      return;
    }
    f.isTouched = !1, f.isMoved = !1;
    let F = 300, j = 300;
    const M = c.x * F, q = f.currentX + M, le = c.y * j, Z = f.currentY + le;
    c.x !== 0 && (F = Math.abs((q - f.currentX) / c.x)), c.y !== 0 && (j = Math.abs((Z - f.currentY) / c.y));
    const G = Math.max(F, j);
    f.currentX = q, f.currentY = Z;
    const H = f.width * I.scale, W = f.height * I.scale;
    f.minX = Math.min(d.slideWidth / 2 - H / 2, 0), f.maxX = -f.minX, f.minY = Math.min(d.slideHeight / 2 - W / 2, 0), f.maxY = -f.minY, f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX), f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY), d.imageWrapEl.style.transitionDuration = `${G}ms`, d.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`;
  }
  function P() {
    const I = e.zoom;
    d.slideEl && e.activeIndex !== e.slides.indexOf(d.slideEl) && (d.imageEl && (d.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), d.imageWrapEl && (d.imageWrapEl.style.transform = "translate3d(0,0,0)"), d.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), I.scale = 1, i = 1, d.slideEl = void 0, d.imageEl = void 0, d.imageWrapEl = void 0, d.originX = 0, d.originY = 0);
  }
  function A(I) {
    const F = e.zoom, j = e.params.zoom;
    if (!d.slideEl) {
      I && I.target && (d.slideEl = I.target.closest(`.${e.params.slideClass}, swiper-slide`)), d.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? d.slideEl = ha(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : d.slideEl = e.slides[e.activeIndex]);
      let rt = d.slideEl.querySelector(`.${j.containerClass}`);
      rt && (rt = rt.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = rt, rt ? d.imageWrapEl = Es(d.imageEl, `.${j.containerClass}`)[0] : d.imageWrapEl = void 0;
    }
    if (!d.imageEl || !d.imageWrapEl)
      return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), d.slideEl.classList.add(`${j.zoomedSlideClass}`);
    let M, q, le, Z, G, H, W, ie, we, Be, Ve, et, nt, xe, J, se, _e, Se;
    typeof f.touchesStart.x > "u" && I ? (M = I.pageX, q = I.pageY) : (M = f.touchesStart.x, q = f.touchesStart.y);
    const Re = typeof I == "number" ? I : null;
    i === 1 && Re && (M = void 0, q = void 0), F.scale = Re || d.imageWrapEl.getAttribute("data-swiper-zoom") || j.maxRatio, i = Re || d.imageWrapEl.getAttribute("data-swiper-zoom") || j.maxRatio, I && !(i === 1 && Re) ? (_e = d.slideEl.offsetWidth, Se = d.slideEl.offsetHeight, le = _d(d.slideEl).left + n.scrollX, Z = _d(d.slideEl).top + n.scrollY, G = le + _e / 2 - M, H = Z + Se / 2 - q, we = d.imageEl.offsetWidth, Be = d.imageEl.offsetHeight, Ve = we * F.scale, et = Be * F.scale, nt = Math.min(_e / 2 - Ve / 2, 0), xe = Math.min(Se / 2 - et / 2, 0), J = -nt, se = -xe, W = G * F.scale, ie = H * F.scale, W < nt && (W = nt), W > J && (W = J), ie < xe && (ie = xe), ie > se && (ie = se)) : (W = 0, ie = 0), Re && F.scale === 1 && (d.originX = 0, d.originY = 0), d.imageWrapEl.style.transitionDuration = "300ms", d.imageWrapEl.style.transform = `translate3d(${W}px, ${ie}px,0)`, d.imageEl.style.transitionDuration = "300ms", d.imageEl.style.transform = `translate3d(0,0,0) scale(${F.scale})`;
  }
  function E() {
    const I = e.zoom, F = e.params.zoom;
    if (!d.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? d.slideEl = ha(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : d.slideEl = e.slides[e.activeIndex];
      let j = d.slideEl.querySelector(`.${F.containerClass}`);
      j && (j = j.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = j, j ? d.imageWrapEl = Es(d.imageEl, `.${F.containerClass}`)[0] : d.imageWrapEl = void 0;
    }
    !d.imageEl || !d.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), I.scale = 1, i = 1, d.imageWrapEl.style.transitionDuration = "300ms", d.imageWrapEl.style.transform = "translate3d(0,0,0)", d.imageEl.style.transitionDuration = "300ms", d.imageEl.style.transform = "translate3d(0,0,0) scale(1)", d.slideEl.classList.remove(`${F.zoomedSlideClass}`), d.slideEl = void 0, d.originX = 0, d.originY = 0);
  }
  function O(I) {
    const F = e.zoom;
    F.scale && F.scale !== 1 ? E() : A(I);
  }
  function T() {
    const I = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, F = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: I,
      activeListenerWithCapture: F
    };
  }
  function D() {
    const I = e.zoom;
    if (I.enabled)
      return;
    I.enabled = !0;
    const {
      passiveListener: F,
      activeListenerWithCapture: j
    } = T();
    e.wrapperEl.addEventListener("pointerdown", y, F), e.wrapperEl.addEventListener("pointermove", _, j), ["pointerup", "pointercancel", "pointerout"].forEach((M) => {
      e.wrapperEl.addEventListener(M, x, F);
    }), e.wrapperEl.addEventListener("pointermove", k, j);
  }
  function $() {
    const I = e.zoom;
    if (!I.enabled)
      return;
    I.enabled = !1;
    const {
      passiveListener: F,
      activeListenerWithCapture: j
    } = T();
    e.wrapperEl.removeEventListener("pointerdown", y, F), e.wrapperEl.removeEventListener("pointermove", _, j), ["pointerup", "pointercancel", "pointerout"].forEach((M) => {
      e.wrapperEl.removeEventListener(M, x, F);
    }), e.wrapperEl.removeEventListener("pointermove", k, j);
  }
  r("init", () => {
    e.params.zoom.enabled && D();
  }), r("destroy", () => {
    $();
  }), r("touchStart", (I, F) => {
    e.zoom.enabled && w(F);
  }), r("touchEnd", (I, F) => {
    e.zoom.enabled && S();
  }), r("doubleTap", (I, F) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && O(F);
  }), r("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && P();
  }), r("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && P();
  }), Object.assign(e.zoom, {
    enable: D,
    disable: $,
    in: A,
    out: E,
    toggle: O
  });
}
function A6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function a(l, u) {
    const d = function() {
      let v, h, g;
      return (m, b) => {
        for (h = -1, v = m.length; v - h > 1; )
          g = v + h >> 1, m[g] <= b ? h = g : v = g;
        return v;
      };
    }();
    this.x = l, this.y = u, this.lastIndex = l.length - 1;
    let f, c;
    return this.interpolate = function(v) {
      return v ? (c = d(this.x, v), f = c - 1, (v - this.x[f]) * (this.y[c] - this.y[f]) / (this.x[c] - this.x[f]) + this.y[f]) : 0;
    }, this;
  }
  function n(l) {
    e.controller.spline = e.params.loop ? new a(e.slidesGrid, l.slidesGrid) : new a(e.snapGrid, l.snapGrid);
  }
  function i(l, u) {
    const d = e.controller.control;
    let f, c;
    const p = e.constructor;
    function v(h) {
      if (h.destroyed)
        return;
      const g = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (n(h), c = -e.controller.spline.interpolate(-g)), (!c || e.params.controller.by === "container") && (f = (h.maxTranslate() - h.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(f) || !Number.isFinite(f)) && (f = 1), c = (g - e.minTranslate()) * f + h.minTranslate()), e.params.controller.inverse && (c = h.maxTranslate() - c), h.updateProgress(c), h.setTranslate(c, e), h.updateActiveIndex(), h.updateSlidesClasses();
    }
    if (Array.isArray(d))
      for (let h = 0; h < d.length; h += 1)
        d[h] !== u && d[h] instanceof p && v(d[h]);
    else
      d instanceof p && u !== d && v(d);
  }
  function s(l, u) {
    const d = e.constructor, f = e.controller.control;
    let c;
    function p(v) {
      v.destroyed || (v.setTransition(l, e), l !== 0 && (v.transitionStart(), v.params.autoHeight && Ms(() => {
        v.updateAutoHeight();
      }), Nl(v.wrapperEl, () => {
        f && v.transitionEnd();
      })));
    }
    if (Array.isArray(f))
      for (c = 0; c < f.length; c += 1)
        f[c] !== u && f[c] instanceof d && p(f[c]);
    else
      f instanceof d && u !== f && p(f);
  }
  function o() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  r("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      const l = document.querySelector(e.params.controller.control);
      if (l && l.swiper)
        e.controller.control = l.swiper;
      else if (l) {
        const u = (d) => {
          e.controller.control = d.detail[0], e.update(), l.removeEventListener("init", u);
        };
        l.addEventListener("init", u);
      }
      return;
    }
    e.controller.control = e.params.controller.control;
  }), r("update", () => {
    o();
  }), r("resize", () => {
    o();
  }), r("observerUpdate", () => {
    o();
  }), r("setTranslate", (l, u, d) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(u, d);
  }), r("setTransition", (l, u, d) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(u, d);
  }), Object.assign(e.controller, {
    setTranslate: i,
    setTransition: s
  });
}
function D6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  }), e.a11y = {
    clicked: !1
  };
  let a = null;
  function n(T) {
    const D = a;
    D.length !== 0 && (D.innerHTML = "", D.innerHTML = T);
  }
  const i = (T) => (Array.isArray(T) || (T = [T].filter((D) => !!D)), T);
  function s(T = 16) {
    const D = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(T).replace(/x/g, D);
  }
  function o(T) {
    T = i(T), T.forEach((D) => {
      D.setAttribute("tabIndex", "0");
    });
  }
  function l(T) {
    T = i(T), T.forEach((D) => {
      D.setAttribute("tabIndex", "-1");
    });
  }
  function u(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("role", D);
    });
  }
  function d(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("aria-roledescription", D);
    });
  }
  function f(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("aria-controls", D);
    });
  }
  function c(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("aria-label", D);
    });
  }
  function p(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("id", D);
    });
  }
  function v(T, D) {
    T = i(T), T.forEach(($) => {
      $.setAttribute("aria-live", D);
    });
  }
  function h(T) {
    T = i(T), T.forEach((D) => {
      D.setAttribute("aria-disabled", !0);
    });
  }
  function g(T) {
    T = i(T), T.forEach((D) => {
      D.setAttribute("aria-disabled", !1);
    });
  }
  function m(T) {
    if (T.keyCode !== 13 && T.keyCode !== 32)
      return;
    const D = e.params.a11y, $ = T.target;
    e.pagination && e.pagination.el && ($ === e.pagination.el || e.pagination.el.contains(T.target)) && !T.target.matches(Ui(e.params.pagination.bulletClass)) || (e.navigation && e.navigation.nextEl && $ === e.navigation.nextEl && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? n(D.lastSlideMessage) : n(D.nextSlideMessage)), e.navigation && e.navigation.prevEl && $ === e.navigation.prevEl && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? n(D.firstSlideMessage) : n(D.prevSlideMessage)), e.pagination && $.matches(Ui(e.params.pagination.bulletClass)) && $.click());
  }
  function b() {
    if (e.params.loop || e.params.rewind || !e.navigation)
      return;
    const {
      nextEl: T,
      prevEl: D
    } = e.navigation;
    D && (e.isBeginning ? (h(D), l(D)) : (g(D), o(D))), T && (e.isEnd ? (h(T), l(T)) : (g(T), o(T)));
  }
  function y() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function _() {
    return y() && e.params.pagination.clickable;
  }
  function x() {
    const T = e.params.a11y;
    y() && e.pagination.bullets.forEach((D) => {
      e.params.pagination.clickable && (o(D), e.params.pagination.renderBullet || (u(D, "button"), c(D, T.paginationBulletMessage.replace(/\{\{index\}\}/, Gl(D) + 1)))), D.matches(Ui(e.params.pagination.bulletActiveClass)) ? D.setAttribute("aria-current", "true") : D.removeAttribute("aria-current");
    });
  }
  const w = (T, D, $) => {
    o(T), T.tagName !== "BUTTON" && (u(T, "button"), T.addEventListener("keydown", m)), c(T, $), f(T, D);
  }, k = () => {
    e.a11y.clicked = !0;
  }, S = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, P = (T) => {
    if (e.a11y.clicked)
      return;
    const D = T.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!D || !e.slides.includes(D))
      return;
    const $ = e.slides.indexOf(D) === e.activeIndex, I = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(D);
    $ || I || T.sourceCapabilities && T.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, e.slideTo(e.slides.indexOf(D), 0));
  }, A = () => {
    const T = e.params.a11y;
    T.itemRoleDescriptionMessage && d(e.slides, T.itemRoleDescriptionMessage), T.slideRole && u(e.slides, T.slideRole);
    const D = e.slides.length;
    T.slideLabelMessage && e.slides.forEach(($, I) => {
      const F = e.params.loop ? parseInt($.getAttribute("data-swiper-slide-index"), 10) : I, j = T.slideLabelMessage.replace(/\{\{index\}\}/, F + 1).replace(/\{\{slidesLength\}\}/, D);
      c($, j);
    });
  }, E = () => {
    const T = e.params.a11y;
    e.isElement ? e.el.shadowEl.append(a) : e.el.append(a);
    const D = e.el;
    T.containerRoleDescriptionMessage && d(D, T.containerRoleDescriptionMessage), T.containerMessage && c(D, T.containerMessage);
    const $ = e.wrapperEl, I = T.id || $.getAttribute("id") || `swiper-wrapper-${s(16)}`, F = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    p($, I), v($, F), A();
    let {
      nextEl: j,
      prevEl: M
    } = e.navigation ? e.navigation : {};
    j = i(j), M = i(M), j && j.forEach((q) => w(q, I, T.nextSlideMessage)), M && M.forEach((q) => w(q, I, T.prevSlideMessage)), _() && (Array.isArray(e.pagination.el) ? e.pagination.el : [e.pagination.el]).forEach((le) => {
      le.addEventListener("keydown", m);
    }), e.el.addEventListener("focus", P, !0), e.el.addEventListener("pointerdown", k, !0), e.el.addEventListener("pointerup", S, !0);
  };
  function O() {
    a && a.remove();
    let {
      nextEl: T,
      prevEl: D
    } = e.navigation ? e.navigation : {};
    T = i(T), D = i(D), T && T.forEach(($) => $.removeEventListener("keydown", m)), D && D.forEach(($) => $.removeEventListener("keydown", m)), _() && (Array.isArray(e.pagination.el) ? e.pagination.el : [e.pagination.el]).forEach((I) => {
      I.removeEventListener("keydown", m);
    }), e.el.removeEventListener("focus", P, !0), e.el.removeEventListener("pointerdown", k, !0), e.el.removeEventListener("pointerup", S, !0);
  }
  r("beforeInit", () => {
    a = Ln("span", e.params.a11y.notificationClass), a.setAttribute("aria-live", "assertive"), a.setAttribute("aria-atomic", "true");
  }), r("afterInit", () => {
    e.params.a11y.enabled && E();
  }), r("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && A();
  }), r("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && b();
  }), r("paginationUpdate", () => {
    e.params.a11y.enabled && x();
  }), r("destroy", () => {
    e.params.a11y.enabled && O();
  });
}
function I6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let a = !1, n = {};
  const i = (c) => c.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), s = (c) => {
    const p = Br();
    let v;
    c ? v = new URL(c) : v = p.location;
    const h = v.pathname.slice(1).split("/").filter((y) => y !== ""), g = h.length, m = h[g - 2], b = h[g - 1];
    return {
      key: m,
      value: b
    };
  }, o = (c, p) => {
    const v = Br();
    if (!a || !e.params.history.enabled)
      return;
    let h;
    e.params.url ? h = new URL(e.params.url) : h = v.location;
    const g = e.slides[p];
    let m = i(g.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let y = e.params.history.root;
      y[y.length - 1] === "/" && (y = y.slice(0, y.length - 1)), m = `${y}/${c ? `${c}/` : ""}${m}`;
    } else
      h.pathname.includes(c) || (m = `${c ? `${c}/` : ""}${m}`);
    e.params.history.keepQuery && (m += h.search);
    const b = v.history.state;
    b && b.value === m || (e.params.history.replaceState ? v.history.replaceState({
      value: m
    }, null, m) : v.history.pushState({
      value: m
    }, null, m));
  }, l = (c, p, v) => {
    if (p)
      for (let h = 0, g = e.slides.length; h < g; h += 1) {
        const m = e.slides[h];
        if (i(m.getAttribute("data-history")) === p) {
          const y = e.getSlideIndex(m);
          e.slideTo(y, c, v);
        }
      }
    else
      e.slideTo(0, c, v);
  }, u = () => {
    n = s(e.params.url), l(e.params.speed, n.value, !1);
  }, d = () => {
    const c = Br();
    if (e.params.history) {
      if (!c.history || !c.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (a = !0, n = s(e.params.url), !n.key && !n.value) {
        e.params.history.replaceState || c.addEventListener("popstate", u);
        return;
      }
      l(0, n.value, e.params.runCallbacksOnInit), e.params.history.replaceState || c.addEventListener("popstate", u);
    }
  }, f = () => {
    const c = Br();
    e.params.history.replaceState || c.removeEventListener("popstate", u);
  };
  r("init", () => {
    e.params.history.enabled && d();
  }), r("destroy", () => {
    e.params.history.enabled && f();
  }), r("transitionEnd _freeModeNoMomentumRelease", () => {
    a && o(e.params.history.key, e.activeIndex);
  }), r("slideChange", () => {
    a && e.params.cssMode && o(e.params.history.key, e.activeIndex);
  });
}
function N6({
  swiper: e,
  extendParams: t,
  emit: r,
  on: a
}) {
  let n = !1;
  const i = ba(), s = Br();
  t({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(f, c) {
        if (e.virtual && e.params.virtual.enabled) {
          const p = e.slides.filter((h) => h.getAttribute("data-hash") === c)[0];
          return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(ha(e.slidesEl, `.${e.params.slideClass}[data-hash="${c}"], swiper-slide[data-hash="${c}"]`)[0]);
      }
    }
  });
  const o = () => {
    r("hashChange");
    const f = i.location.hash.replace("#", ""), c = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = c ? c.getAttribute("data-hash") : "";
    if (f !== p) {
      const v = e.params.hashNavigation.getSlideIndex(e, f);
      if (typeof v > "u" || Number.isNaN(v))
        return;
      e.slideTo(v);
    }
  }, l = () => {
    if (!n || !e.params.hashNavigation.enabled)
      return;
    const f = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], c = f ? f.getAttribute("data-hash") || f.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && s.history && s.history.replaceState ? (s.history.replaceState(null, null, `#${c}` || ""), r("hashSet")) : (i.location.hash = c || "", r("hashSet"));
  }, u = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)
      return;
    n = !0;
    const f = i.location.hash.replace("#", "");
    if (f) {
      const p = e.params.hashNavigation.getSlideIndex(e, f);
      e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && s.addEventListener("hashchange", o);
  }, d = () => {
    e.params.hashNavigation.watchState && s.removeEventListener("hashchange", o);
  };
  a("init", () => {
    e.params.hashNavigation.enabled && u();
  }), a("destroy", () => {
    e.params.hashNavigation.enabled && d();
  }), a("transitionEnd _freeModeNoMomentumRelease", () => {
    n && l();
  }), a("slideChange", () => {
    n && e.params.cssMode && l();
  });
}
function $6({
  swiper: e,
  extendParams: t,
  on: r,
  emit: a,
  params: n
}) {
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, t({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let i, s, o = n && n.autoplay ? n.autoplay.delay : 3e3, l = n && n.autoplay ? n.autoplay.delay : 3e3, u, d = (/* @__PURE__ */ new Date()).getTime, f, c, p, v, h, g;
  function m(I) {
    !e || e.destroyed || !e.wrapperEl || I.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", m), S());
  }
  const b = () => {
    if (e.destroyed || !e.autoplay.running)
      return;
    e.autoplay.paused ? f = !0 : f && (l = u, f = !1);
    const I = e.autoplay.paused ? u : d + l - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = I, a("autoplayTimeLeft", I, I / o), s = requestAnimationFrame(() => {
      b();
    });
  }, y = () => {
    let I;
    return e.virtual && e.params.virtual.enabled ? I = e.slides.filter((j) => j.classList.contains("swiper-slide-active"))[0] : I = e.slides[e.activeIndex], I ? parseInt(I.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, _ = (I) => {
    if (e.destroyed || !e.autoplay.running)
      return;
    cancelAnimationFrame(s), b();
    let F = typeof I > "u" ? e.params.autoplay.delay : I;
    o = e.params.autoplay.delay, l = e.params.autoplay.delay;
    const j = y();
    !Number.isNaN(j) && j > 0 && typeof I > "u" && (F = j, o = j, l = j), u = F;
    const M = e.params.speed, q = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(M, !0, !0), a("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, M, !0, !0), a("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(M, !0, !0), a("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, M, !0, !0), a("autoplay")), e.params.cssMode && (d = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        _();
      })));
    };
    return F > 0 ? (clearTimeout(i), i = setTimeout(() => {
      q();
    }, F)) : requestAnimationFrame(() => {
      q();
    }), F;
  }, x = () => {
    e.autoplay.running = !0, _(), a("autoplayStart");
  }, w = () => {
    e.autoplay.running = !1, clearTimeout(i), cancelAnimationFrame(s), a("autoplayStop");
  }, k = (I, F) => {
    if (e.destroyed || !e.autoplay.running)
      return;
    clearTimeout(i), I || (g = !0);
    const j = () => {
      a("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", m) : S();
    };
    if (e.autoplay.paused = !0, F) {
      h && (u = e.params.autoplay.delay), h = !1, j();
      return;
    }
    u = (u || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - d), !(e.isEnd && u < 0 && !e.params.loop) && (u < 0 && (u = 0), j());
  }, S = () => {
    e.isEnd && u < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (d = (/* @__PURE__ */ new Date()).getTime(), g ? (g = !1, _(u)) : _(), e.autoplay.paused = !1, a("autoplayResume"));
  }, P = () => {
    if (e.destroyed || !e.autoplay.running)
      return;
    const I = ba();
    I.visibilityState === "hidden" && (g = !0, k(!0)), I.visibilityState === "visible" && S();
  }, A = (I) => {
    I.pointerType === "mouse" && (g = !0, k(!0));
  }, E = (I) => {
    I.pointerType === "mouse" && e.autoplay.paused && S();
  }, O = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", A), e.el.addEventListener("pointerleave", E));
  }, T = () => {
    e.el.removeEventListener("pointerenter", A), e.el.removeEventListener("pointerleave", E);
  }, D = () => {
    ba().addEventListener("visibilitychange", P);
  }, $ = () => {
    ba().removeEventListener("visibilitychange", P);
  };
  r("init", () => {
    e.params.autoplay.enabled && (O(), D(), d = (/* @__PURE__ */ new Date()).getTime(), x());
  }), r("destroy", () => {
    T(), $(), e.autoplay.running && w();
  }), r("beforeTransitionStart", (I, F, j) => {
    e.destroyed || !e.autoplay.running || (j || !e.params.autoplay.disableOnInteraction ? k(!0, !0) : w());
  }), r("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        w();
        return;
      }
      c = !0, p = !1, g = !1, v = setTimeout(() => {
        g = !0, p = !0, k(!0);
      }, 200);
    }
  }), r("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !c)) {
      if (clearTimeout(v), clearTimeout(i), e.params.autoplay.disableOnInteraction) {
        p = !1, c = !1;
        return;
      }
      p && e.params.cssMode && S(), p = !1, c = !1;
    }
  }), r("slideChange", () => {
    e.destroyed || !e.autoplay.running || (h = !0);
  }), Object.assign(e.autoplay, {
    start: x,
    stop: w,
    pause: k,
    resume: S
  });
}
function L6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let a = !1, n = !1;
  e.thumbs = {
    swiper: null
  };
  function i() {
    const l = e.thumbs.swiper;
    if (!l || l.destroyed)
      return;
    const u = l.clickedIndex, d = l.clickedSlide;
    if (d && d.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null)
      return;
    let f;
    l.params.loop ? f = parseInt(l.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : f = u, e.params.loop ? e.slideToLoop(f) : e.slideTo(f);
  }
  function s() {
    const {
      thumbs: l
    } = e.params;
    if (a)
      return !1;
    a = !0;
    const u = e.constructor;
    if (l.swiper instanceof u)
      e.thumbs.swiper = l.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    else if (kl(l.swiper)) {
      const d = Object.assign({}, l.swiper);
      Object.assign(d, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new u(d), n = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", i), !0;
  }
  function o(l) {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed)
      return;
    const d = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let f = 1;
    const c = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (f = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (f = 1), f = Math.floor(f), u.slides.forEach((h) => h.classList.remove(c)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let h = 0; h < f; h += 1)
        ha(u.slidesEl, `[data-swiper-slide-index="${e.realIndex + h}"]`).forEach((g) => {
          g.classList.add(c);
        });
    else
      for (let h = 0; h < f; h += 1)
        u.slides[e.realIndex + h] && u.slides[e.realIndex + h].classList.add(c);
    const p = e.params.thumbs.autoScrollOffset, v = p && !u.params.loop;
    if (e.realIndex !== u.realIndex || v) {
      const h = u.activeIndex;
      let g, m;
      if (u.params.loop) {
        const b = u.slides.filter((y) => y.getAttribute("data-swiper-slide-index") === `${e.realIndex}`)[0];
        g = u.slides.indexOf(b), m = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        g = e.realIndex, m = g > e.previousIndex ? "next" : "prev";
      v && (g += m === "next" ? p : -1 * p), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(g) < 0 && (u.params.centeredSlides ? g > h ? g = g - Math.floor(d / 2) + 1 : g = g + Math.floor(d / 2) - 1 : g > h && u.params.slidesPerGroup, u.slideTo(g, l ? 0 : void 0));
    }
  }
  r("beforeInit", () => {
    const {
      thumbs: l
    } = e.params;
    if (!(!l || !l.swiper))
      if (typeof l.swiper == "string" || l.swiper instanceof HTMLElement) {
        const u = ba(), d = () => {
          const c = typeof l.swiper == "string" ? u.querySelector(l.swiper) : l.swiper;
          if (c && c.swiper)
            l.swiper = c.swiper, s(), o(!0);
          else if (c) {
            const p = (v) => {
              l.swiper = v.detail[0], c.removeEventListener("init", p), s(), o(!0), l.swiper.update(), e.update();
            };
            c.addEventListener("init", p);
          }
          return c;
        }, f = () => {
          if (e.destroyed)
            return;
          d() || requestAnimationFrame(f);
        };
        requestAnimationFrame(f);
      } else
        s(), o(!0);
  }), r("slideChange update resize observerUpdate", () => {
    o();
  }), r("setTransition", (l, u) => {
    const d = e.thumbs.swiper;
    !d || d.destroyed || d.setTransition(u);
  }), r("beforeDestroy", () => {
    const l = e.thumbs.swiper;
    !l || l.destroyed || n && l.destroy();
  }), Object.assign(e.thumbs, {
    init: s,
    update: o
  });
}
function R6({
  swiper: e,
  extendParams: t,
  emit: r,
  once: a
}) {
  t({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function n() {
    if (e.params.cssMode)
      return;
    const o = e.getTranslate();
    e.setTranslate(o), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function i() {
    if (e.params.cssMode)
      return;
    const {
      touchEventsData: o,
      touches: l
    } = e;
    o.velocities.length === 0 && o.velocities.push({
      position: l[e.isHorizontal() ? "startX" : "startY"],
      time: o.touchStartTime
    }), o.velocities.push({
      position: l[e.isHorizontal() ? "currentX" : "currentY"],
      time: vn()
    });
  }
  function s({
    currentPos: o
  }) {
    if (e.params.cssMode)
      return;
    const {
      params: l,
      wrapperEl: u,
      rtlTranslate: d,
      snapGrid: f,
      touchEventsData: c
    } = e, v = vn() - c.touchStartTime;
    if (o < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (o > -e.maxTranslate()) {
      e.slides.length < f.length ? e.slideTo(f.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (l.freeMode.momentum) {
      if (c.velocities.length > 1) {
        const w = c.velocities.pop(), k = c.velocities.pop(), S = w.position - k.position, P = w.time - k.time;
        e.velocity = S / P, e.velocity /= 2, Math.abs(e.velocity) < l.freeMode.minimumVelocity && (e.velocity = 0), (P > 150 || vn() - w.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= l.freeMode.momentumVelocityRatio, c.velocities.length = 0;
      let h = 1e3 * l.freeMode.momentumRatio;
      const g = e.velocity * h;
      let m = e.translate + g;
      d && (m = -m);
      let b = !1, y;
      const _ = Math.abs(e.velocity) * 20 * l.freeMode.momentumBounceRatio;
      let x;
      if (m < e.maxTranslate())
        l.freeMode.momentumBounce ? (m + e.maxTranslate() < -_ && (m = e.maxTranslate() - _), y = e.maxTranslate(), b = !0, c.allowMomentumBounce = !0) : m = e.maxTranslate(), l.loop && l.centeredSlides && (x = !0);
      else if (m > e.minTranslate())
        l.freeMode.momentumBounce ? (m - e.minTranslate() > _ && (m = e.minTranslate() + _), y = e.minTranslate(), b = !0, c.allowMomentumBounce = !0) : m = e.minTranslate(), l.loop && l.centeredSlides && (x = !0);
      else if (l.freeMode.sticky) {
        let w;
        for (let k = 0; k < f.length; k += 1)
          if (f[k] > -m) {
            w = k;
            break;
          }
        Math.abs(f[w] - m) < Math.abs(f[w - 1] - m) || e.swipeDirection === "next" ? m = f[w] : m = f[w - 1], m = -m;
      }
      if (x && a("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (d ? h = Math.abs((-m - e.translate) / e.velocity) : h = Math.abs((m - e.translate) / e.velocity), l.freeMode.sticky) {
          const w = Math.abs((d ? -m : m) - e.translate), k = e.slidesSizesGrid[e.activeIndex];
          w < k ? h = l.speed : w < 2 * k ? h = l.speed * 1.5 : h = l.speed * 2.5;
        }
      } else if (l.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      l.freeMode.momentumBounce && b ? (e.updateProgress(y), e.setTransition(h), e.setTranslate(m), e.transitionStart(!0, e.swipeDirection), e.animating = !0, Nl(u, () => {
        !e || e.destroyed || !c.allowMomentumBounce || (r("momentumBounce"), e.setTransition(l.speed), setTimeout(() => {
          e.setTranslate(y), Nl(u, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (r("_freeModeNoMomentumRelease"), e.updateProgress(m), e.setTransition(h), e.setTranslate(m), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, Nl(u, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(m), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (l.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else
      l.freeMode && r("_freeModeNoMomentumRelease");
    (!l.freeMode.momentum || v >= l.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: n,
      onTouchMove: i,
      onTouchEnd: s
    }
  });
}
function j6({
  swiper: e,
  extendParams: t
}) {
  t({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let r, a, n;
  const i = () => {
    let u = e.params.spaceBetween;
    return typeof u == "string" && u.indexOf("%") >= 0 ? u = parseFloat(u.replace("%", "")) / 100 * e.size : typeof u == "string" && (u = parseFloat(u)), u;
  }, s = (u) => {
    const {
      slidesPerView: d
    } = e.params, {
      rows: f,
      fill: c
    } = e.params.grid;
    n = Math.floor(u / f), Math.floor(u / f) === u / f ? r = u : r = Math.ceil(u / f) * f, d !== "auto" && c === "row" && (r = Math.max(r, d * f)), a = r / f;
  }, o = (u, d, f, c) => {
    const {
      slidesPerGroup: p
    } = e.params, v = i(), {
      rows: h,
      fill: g
    } = e.params.grid;
    let m, b, y;
    if (g === "row" && p > 1) {
      const _ = Math.floor(u / (p * h)), x = u - h * p * _, w = _ === 0 ? p : Math.min(Math.ceil((f - _ * h * p) / h), p);
      y = Math.floor(x / w), b = x - y * w + _ * p, m = b + y * r / h, d.style.order = m;
    } else
      g === "column" ? (b = Math.floor(u / h), y = u - b * h, (b > n || b === n && y === h - 1) && (y += 1, y >= h && (y = 0, b += 1))) : (y = Math.floor(u / a), b = u - y * a);
    d.row = y, d.column = b, d.style[c("margin-top")] = y !== 0 ? v && `${v}px` : "";
  }, l = (u, d, f) => {
    const {
      centeredSlides: c,
      roundLengths: p
    } = e.params, v = i(), {
      rows: h
    } = e.params.grid;
    if (e.virtualSize = (u + v) * r, e.virtualSize = Math.ceil(e.virtualSize / h) - v, e.wrapperEl.style[f("width")] = `${e.virtualSize + v}px`, c) {
      const g = [];
      for (let m = 0; m < d.length; m += 1) {
        let b = d[m];
        p && (b = Math.floor(b)), d[m] < e.virtualSize + d[0] && g.push(b);
      }
      d.splice(0, d.length), d.push(...g);
    }
  };
  e.grid = {
    initSlides: s,
    updateSlide: o,
    updateWrapperSize: l
  };
}
function F6(e) {
  const t = this, {
    params: r,
    slidesEl: a
  } = t;
  r.loop && t.loopDestroy();
  const n = (i) => {
    if (typeof i == "string") {
      const s = document.createElement("div");
      s.innerHTML = i, a.append(s.children[0]), s.innerHTML = "";
    } else
      a.append(i);
  };
  if (typeof e == "object" && "length" in e)
    for (let i = 0; i < e.length; i += 1)
      e[i] && n(e[i]);
  else
    n(e);
  t.recalcSlides(), r.loop && t.loopCreate(), (!r.observer || t.isElement) && t.update();
}
function B6(e) {
  const t = this, {
    params: r,
    activeIndex: a,
    slidesEl: n
  } = t;
  r.loop && t.loopDestroy();
  let i = a + 1;
  const s = (o) => {
    if (typeof o == "string") {
      const l = document.createElement("div");
      l.innerHTML = o, n.prepend(l.children[0]), l.innerHTML = "";
    } else
      n.prepend(o);
  };
  if (typeof e == "object" && "length" in e) {
    for (let o = 0; o < e.length; o += 1)
      e[o] && s(e[o]);
    i = a + e.length;
  } else
    s(e);
  t.recalcSlides(), r.loop && t.loopCreate(), (!r.observer || t.isElement) && t.update(), t.slideTo(i, 0, !1);
}
function q6(e, t) {
  const r = this, {
    params: a,
    activeIndex: n,
    slidesEl: i
  } = r;
  let s = n;
  a.loop && (s -= r.loopedSlides, r.loopDestroy(), r.recalcSlides());
  const o = r.slides.length;
  if (e <= 0) {
    r.prependSlide(t);
    return;
  }
  if (e >= o) {
    r.appendSlide(t);
    return;
  }
  let l = s > e ? s + 1 : s;
  const u = [];
  for (let d = o - 1; d >= e; d -= 1) {
    const f = r.slides[d];
    f.remove(), u.unshift(f);
  }
  if (typeof t == "object" && "length" in t) {
    for (let d = 0; d < t.length; d += 1)
      t[d] && i.append(t[d]);
    l = s > e ? s + t.length : s;
  } else
    i.append(t);
  for (let d = 0; d < u.length; d += 1)
    i.append(u[d]);
  r.recalcSlides(), a.loop && r.loopCreate(), (!a.observer || r.isElement) && r.update(), a.loop ? r.slideTo(l + r.loopedSlides, 0, !1) : r.slideTo(l, 0, !1);
}
function H6(e) {
  const t = this, {
    params: r,
    activeIndex: a
  } = t;
  let n = a;
  r.loop && (n -= t.loopedSlides, t.loopDestroy());
  let i = n, s;
  if (typeof e == "object" && "length" in e) {
    for (let o = 0; o < e.length; o += 1)
      s = e[o], t.slides[s] && t.slides[s].remove(), s < i && (i -= 1);
    i = Math.max(i, 0);
  } else
    s = e, t.slides[s] && t.slides[s].remove(), s < i && (i -= 1), i = Math.max(i, 0);
  t.recalcSlides(), r.loop && t.loopCreate(), (!r.observer || t.isElement) && t.update(), r.loop ? t.slideTo(i + t.loopedSlides, 0, !1) : t.slideTo(i, 0, !1);
}
function V6() {
  const e = this, t = [];
  for (let r = 0; r < e.slides.length; r += 1)
    t.push(r);
  e.removeSlide(t);
}
function U6({
  swiper: e
}) {
  Object.assign(e, {
    appendSlide: F6.bind(e),
    prependSlide: B6.bind(e),
    addSlide: q6.bind(e),
    removeSlide: H6.bind(e),
    removeAllSlides: V6.bind(e)
  });
}
function Po(e) {
  const {
    effect: t,
    swiper: r,
    on: a,
    setTranslate: n,
    setTransition: i,
    overwriteParams: s,
    perspective: o,
    recreateShadows: l,
    getEffectParams: u
  } = e;
  a("beforeInit", () => {
    if (r.params.effect !== t)
      return;
    r.classNames.push(`${r.params.containerModifierClass}${t}`), o && o() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const f = s ? s() : {};
    Object.assign(r.params, f), Object.assign(r.originalParams, f);
  }), a("setTranslate", () => {
    r.params.effect === t && n();
  }), a("setTransition", (f, c) => {
    r.params.effect === t && i(c);
  }), a("transitionEnd", () => {
    if (r.params.effect === t && l) {
      if (!u || !u().slideShadows)
        return;
      r.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((c) => c.remove());
      }), l();
    }
  });
  let d;
  a("virtualUpdate", () => {
    r.params.effect === t && (r.slides.length || (d = !0), requestAnimationFrame(() => {
      d && r.slides && r.slides.length && (n(), d = !1);
    }));
  });
}
function yu(e, t) {
  const r = $s(t);
  return r !== t && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function ec({
  swiper: e,
  duration: t,
  transformElements: r,
  allSlides: a
}) {
  const {
    activeIndex: n
  } = e, i = (s) => s.parentElement ? s.parentElement : e.slides.filter((l) => l.shadowEl && l.shadowEl === s.parentNode)[0];
  if (e.params.virtualTranslate && t !== 0) {
    let s = !1, o;
    a ? o = r : o = r.filter((l) => {
      const u = l.classList.contains("swiper-slide-transform") ? i(l) : l;
      return e.getSlideIndex(u) === n;
    }), o.forEach((l) => {
      Nl(l, () => {
        if (s || !e || e.destroyed)
          return;
        s = !0, e.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function z6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    fadeEffect: {
      crossFade: !1
    }
  }), Po({
    effect: "fade",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: i
      } = e, s = e.params.fadeEffect;
      for (let o = 0; o < i.length; o += 1) {
        const l = e.slides[o];
        let d = -l.swiperSlideOffset;
        e.params.virtualTranslate || (d -= e.translate);
        let f = 0;
        e.isHorizontal() || (f = d, d = 0);
        const c = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(l.progress), 0) : 1 + Math.min(Math.max(l.progress, -1), 0), p = yu(s, l);
        p.style.opacity = c, p.style.transform = `translate3d(${d}px, ${f}px, 0px)`;
      }
    },
    setTransition: (i) => {
      const s = e.slides.map((o) => $s(o));
      s.forEach((o) => {
        o.style.transitionDuration = `${i}ms`;
      }), ec({
        swiper: e,
        duration: i,
        transformElements: s,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function Y6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const a = (o, l, u) => {
    let d = u ? o.querySelector(".swiper-slide-shadow-left") : o.querySelector(".swiper-slide-shadow-top"), f = u ? o.querySelector(".swiper-slide-shadow-right") : o.querySelector(".swiper-slide-shadow-bottom");
    d || (d = Ln("div", `swiper-slide-shadow-${u ? "left" : "top"}`), o.append(d)), f || (f = Ln("div", `swiper-slide-shadow-${u ? "right" : "bottom"}`), o.append(f)), d && (d.style.opacity = Math.max(-l, 0)), f && (f.style.opacity = Math.max(l, 0));
  };
  Po({
    effect: "cube",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        el: o,
        wrapperEl: l,
        slides: u,
        width: d,
        height: f,
        rtlTranslate: c,
        size: p,
        browser: v
      } = e, h = e.params.cubeEffect, g = e.isHorizontal(), m = e.virtual && e.params.virtual.enabled;
      let b = 0, y;
      h.shadow && (g ? (y = e.slidesEl.querySelector(".swiper-cube-shadow"), y || (y = Ln("div", "swiper-cube-shadow"), e.slidesEl.append(y)), y.style.height = `${d}px`) : (y = o.querySelector(".swiper-cube-shadow"), y || (y = Ln("div", "swiper-cube-shadow"), o.append(y))));
      for (let x = 0; x < u.length; x += 1) {
        const w = u[x];
        let k = x;
        m && (k = parseInt(w.getAttribute("data-swiper-slide-index"), 10));
        let S = k * 90, P = Math.floor(S / 360);
        c && (S = -S, P = Math.floor(-S / 360));
        const A = Math.max(Math.min(w.progress, 1), -1);
        let E = 0, O = 0, T = 0;
        k % 4 === 0 ? (E = -P * 4 * p, T = 0) : (k - 1) % 4 === 0 ? (E = 0, T = -P * 4 * p) : (k - 2) % 4 === 0 ? (E = p + P * 4 * p, T = p) : (k - 3) % 4 === 0 && (E = -p, T = 3 * p + p * 4 * P), c && (E = -E), g || (O = E, E = 0);
        const D = `rotateX(${g ? 0 : -S}deg) rotateY(${g ? S : 0}deg) translate3d(${E}px, ${O}px, ${T}px)`;
        A <= 1 && A > -1 && (b = k * 90 + A * 90, c && (b = -k * 90 - A * 90)), w.style.transform = D, h.slideShadows && a(w, A, g);
      }
      if (l.style.transformOrigin = `50% 50% -${p / 2}px`, l.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, h.shadow)
        if (g)
          y.style.transform = `translate3d(0px, ${d / 2 + h.shadowOffset}px, ${-d / 2}px) rotateX(90deg) rotateZ(0deg) scale(${h.shadowScale})`;
        else {
          const x = Math.abs(b) - Math.floor(Math.abs(b) / 90) * 90, w = 1.5 - (Math.sin(x * 2 * Math.PI / 360) / 2 + Math.cos(x * 2 * Math.PI / 360) / 2), k = h.shadowScale, S = h.shadowScale / w, P = h.shadowOffset;
          y.style.transform = `scale3d(${k}, 1, ${S}) translate3d(0px, ${f / 2 + P}px, ${-f / 2 / S}px) rotateX(-90deg)`;
        }
      const _ = (v.isSafari || v.isWebView) && v.needPerspectiveFix ? -p / 2 : 0;
      l.style.transform = `translate3d(0px,0,${_}px) rotateX(${e.isHorizontal() ? 0 : b}deg) rotateY(${e.isHorizontal() ? -b : 0}deg)`, l.style.setProperty("--swiper-cube-translate-z", `${_}px`);
    },
    setTransition: (o) => {
      const {
        el: l,
        slides: u
      } = e;
      if (u.forEach((d) => {
        d.style.transitionDuration = `${o}ms`, d.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => {
          f.style.transitionDuration = `${o}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const d = l.querySelector(".swiper-cube-shadow");
        d && (d.style.transitionDuration = `${o}ms`);
      }
    },
    recreateShadows: () => {
      const o = e.isHorizontal();
      e.slides.forEach((l) => {
        const u = Math.max(Math.min(l.progress, 1), -1);
        a(l, u, o);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function go(e, t, r) {
  const a = `swiper-slide-shadow${r ? `-${r}` : ""}`, n = $s(t);
  let i = n.querySelector(`.${a}`);
  return i || (i = Ln("div", `swiper-slide-shadow${r ? `-${r}` : ""}`), n.append(i)), i;
}
function W6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const a = (o, l, u) => {
    let d = e.isHorizontal() ? o.querySelector(".swiper-slide-shadow-left") : o.querySelector(".swiper-slide-shadow-top"), f = e.isHorizontal() ? o.querySelector(".swiper-slide-shadow-right") : o.querySelector(".swiper-slide-shadow-bottom");
    d || (d = go(u, o, e.isHorizontal() ? "left" : "top")), f || (f = go(u, o, e.isHorizontal() ? "right" : "bottom")), d && (d.style.opacity = Math.max(-l, 0)), f && (f.style.opacity = Math.max(l, 0));
  };
  Po({
    effect: "flip",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: o,
        rtlTranslate: l
      } = e, u = e.params.flipEffect;
      for (let d = 0; d < o.length; d += 1) {
        const f = o[d];
        let c = f.progress;
        e.params.flipEffect.limitRotation && (c = Math.max(Math.min(f.progress, 1), -1));
        const p = f.swiperSlideOffset;
        let h = -180 * c, g = 0, m = e.params.cssMode ? -p - e.translate : -p, b = 0;
        e.isHorizontal() ? l && (h = -h) : (b = m, m = 0, g = -h, h = 0), f.style.zIndex = -Math.abs(Math.round(c)) + o.length, u.slideShadows && a(f, c, u);
        const y = `translate3d(${m}px, ${b}px, 0px) rotateX(${g}deg) rotateY(${h}deg)`, _ = yu(u, f);
        _.style.transform = y;
      }
    },
    setTransition: (o) => {
      const l = e.slides.map((u) => $s(u));
      l.forEach((u) => {
        u.style.transitionDuration = `${o}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      }), ec({
        swiper: e,
        duration: o,
        transformElements: l
      });
    },
    recreateShadows: () => {
      const o = e.params.flipEffect;
      e.slides.forEach((l) => {
        let u = l.progress;
        e.params.flipEffect.limitRotation && (u = Math.max(Math.min(l.progress, 1), -1)), a(l, u, o);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function G6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), Po({
    effect: "coverflow",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        width: i,
        height: s,
        slides: o,
        slidesSizesGrid: l
      } = e, u = e.params.coverflowEffect, d = e.isHorizontal(), f = e.translate, c = d ? -f + i / 2 : -f + s / 2, p = d ? u.rotate : -u.rotate, v = u.depth;
      for (let h = 0, g = o.length; h < g; h += 1) {
        const m = o[h], b = l[h], y = m.swiperSlideOffset, _ = (c - y - b / 2) / b, x = typeof u.modifier == "function" ? u.modifier(_) : _ * u.modifier;
        let w = d ? p * x : 0, k = d ? 0 : p * x, S = -v * Math.abs(x), P = u.stretch;
        typeof P == "string" && P.indexOf("%") !== -1 && (P = parseFloat(u.stretch) / 100 * b);
        let A = d ? 0 : P * x, E = d ? P * x : 0, O = 1 - (1 - u.scale) * Math.abs(x);
        Math.abs(E) < 1e-3 && (E = 0), Math.abs(A) < 1e-3 && (A = 0), Math.abs(S) < 1e-3 && (S = 0), Math.abs(w) < 1e-3 && (w = 0), Math.abs(k) < 1e-3 && (k = 0), Math.abs(O) < 1e-3 && (O = 0);
        const T = `translate3d(${E}px,${A}px,${S}px)  rotateX(${k}deg) rotateY(${w}deg) scale(${O})`, D = yu(u, m);
        if (D.style.transform = T, m.style.zIndex = -Math.abs(Math.round(x)) + 1, u.slideShadows) {
          let $ = d ? m.querySelector(".swiper-slide-shadow-left") : m.querySelector(".swiper-slide-shadow-top"), I = d ? m.querySelector(".swiper-slide-shadow-right") : m.querySelector(".swiper-slide-shadow-bottom");
          $ || ($ = go(u, m, d ? "left" : "top")), I || (I = go(u, m, d ? "right" : "bottom")), $ && ($.style.opacity = x > 0 ? x : 0), I && (I.style.opacity = -x > 0 ? -x : 0);
        }
      }
    },
    setTransition: (i) => {
      e.slides.map((o) => $s(o)).forEach((o) => {
        o.style.transitionDuration = `${i}ms`, o.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((l) => {
          l.style.transitionDuration = `${i}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function X6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const a = (s) => typeof s == "string" ? s : `${s}px`;
  Po({
    effect: "creative",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: s,
        wrapperEl: o,
        slidesSizesGrid: l
      } = e, u = e.params.creativeEffect, {
        progressMultiplier: d
      } = u, f = e.params.centeredSlides;
      if (f) {
        const c = l[0] / 2 - e.params.slidesOffsetBefore || 0;
        o.style.transform = `translateX(calc(50% - ${c}px))`;
      }
      for (let c = 0; c < s.length; c += 1) {
        const p = s[c], v = p.progress, h = Math.min(Math.max(p.progress, -u.limitProgress), u.limitProgress);
        let g = h;
        f || (g = Math.min(Math.max(p.originalProgress, -u.limitProgress), u.limitProgress));
        const m = p.swiperSlideOffset, b = [e.params.cssMode ? -m - e.translate : -m, 0, 0], y = [0, 0, 0];
        let _ = !1;
        e.isHorizontal() || (b[1] = b[0], b[0] = 0);
        let x = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        h < 0 ? (x = u.next, _ = !0) : h > 0 && (x = u.prev, _ = !0), b.forEach((O, T) => {
          b[T] = `calc(${O}px + (${a(x.translate[T])} * ${Math.abs(h * d)}))`;
        }), y.forEach((O, T) => {
          y[T] = x.rotate[T] * Math.abs(h * d);
        }), p.style.zIndex = -Math.abs(Math.round(v)) + s.length;
        const w = b.join(", "), k = `rotateX(${y[0]}deg) rotateY(${y[1]}deg) rotateZ(${y[2]}deg)`, S = g < 0 ? `scale(${1 + (1 - x.scale) * g * d})` : `scale(${1 - (1 - x.scale) * g * d})`, P = g < 0 ? 1 + (1 - x.opacity) * g * d : 1 - (1 - x.opacity) * g * d, A = `translate3d(${w}) ${k} ${S}`;
        if (_ && x.shadow || !_) {
          let O = p.querySelector(".swiper-slide-shadow");
          if (!O && x.shadow && (O = go(u, p)), O) {
            const T = u.shadowPerProgress ? h * (1 / u.limitProgress) : h;
            O.style.opacity = Math.min(Math.max(Math.abs(T), 0), 1);
          }
        }
        const E = yu(u, p);
        E.style.transform = A, E.style.opacity = P, x.origin && (E.style.transformOrigin = x.origin);
      }
    },
    setTransition: (s) => {
      const o = e.slides.map((l) => $s(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${s}ms`;
        });
      }), ec({
        swiper: e,
        duration: s,
        transformElements: o,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function K6({
  swiper: e,
  extendParams: t,
  on: r
}) {
  t({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), Po({
    effect: "cards",
    swiper: e,
    on: r,
    setTranslate: () => {
      const {
        slides: i,
        activeIndex: s,
        rtlTranslate: o
      } = e, l = e.params.cardsEffect, {
        startTranslate: u,
        isTouched: d
      } = e.touchEventsData, f = o ? -e.translate : e.translate;
      for (let c = 0; c < i.length; c += 1) {
        const p = i[c], v = p.progress, h = Math.min(Math.max(v, -4), 4);
        let g = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (g -= i[0].swiperSlideOffset);
        let m = e.params.cssMode ? -g - e.translate : -g, b = 0;
        const y = -100 * Math.abs(h);
        let _ = 1, x = -l.perSlideRotate * h, w = l.perSlideOffset - Math.abs(h) * 0.75;
        const k = e.virtual && e.params.virtual.enabled ? e.virtual.from + c : c, S = (k === s || k === s - 1) && h > 0 && h < 1 && (d || e.params.cssMode) && f < u, P = (k === s || k === s + 1) && h < 0 && h > -1 && (d || e.params.cssMode) && f > u;
        if (S || P) {
          const T = (1 - Math.abs((Math.abs(h) - 0.5) / 0.5)) ** 0.5;
          x += -28 * h * T, _ += -0.5 * T, w += 96 * T, b = `${-25 * T * Math.abs(h)}%`;
        }
        if (h < 0 ? m = `calc(${m}px ${o ? "-" : "+"} (${w * Math.abs(h)}%))` : h > 0 ? m = `calc(${m}px ${o ? "-" : "+"} (-${w * Math.abs(h)}%))` : m = `${m}px`, !e.isHorizontal()) {
          const T = b;
          b = m, m = T;
        }
        const A = h < 0 ? `${1 + (1 - _) * h}` : `${1 - (1 - _) * h}`, E = `
        translate3d(${m}, ${b}, ${y}px)
        rotateZ(${l.rotate ? o ? -x : x : 0}deg)
        scale(${A})
      `;
        if (l.slideShadows) {
          let T = p.querySelector(".swiper-slide-shadow");
          T || (T = go(l, p)), T && (T.style.opacity = Math.min(Math.max((Math.abs(h) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(v)) + i.length;
        const O = yu(l, p);
        O.style.transform = E;
      }
    },
    setTransition: (i) => {
      const s = e.slides.map((o) => $s(o));
      s.forEach((o) => {
        o.style.transitionDuration = `${i}ms`, o.querySelectorAll(".swiper-slide-shadow").forEach((l) => {
          l.style.transitionDuration = `${i}ms`;
        });
      }), ec({
        swiper: e,
        duration: i,
        transformElements: s
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const J6 = [T6, S6, E6, O6, C6, k6, P6, M6, A6, D6, I6, N6, $6, L6, R6, j6, U6, z6, Y6, W6, G6, X6, K6];
Wa.use(J6);
const tc = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function xd(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function wd(e, t) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((a) => r.indexOf(a) < 0).forEach((a) => {
    typeof e[a] > "u" ? e[a] = t[a] : xd(t[a]) && xd(e[a]) && Object.keys(t[a]).length > 0 ? t[a].__swiper__ ? e[a] = t[a] : wd(e[a], t[a]) : e[a] = t[a];
  });
}
function Q6(e = {}) {
  return e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function Z6(e = {}) {
  return e.pagination && typeof e.pagination.el > "u";
}
function eN(e = {}) {
  return e.scrollbar && typeof e.scrollbar.el > "u";
}
function sd(e = "") {
  return e.replace(/-[a-z]/g, (t) => t.toUpperCase().replace("-", ""));
}
const k_ = (e) => {
  if (parseFloat(e) === Number(e))
    return Number(e);
  if (e === "true" || e === "")
    return !0;
  if (e === "false")
    return !1;
  if (e === "null")
    return null;
  if (e !== "undefined")
    return e;
}, P_ = [
  "a11y",
  "autoplay",
  "controller",
  "cards-effect",
  "coverflow-effect",
  "creative-effect",
  "cube-effect",
  "fade-effect",
  "flip-effect",
  "free-mode",
  "grid",
  "hash-navigation",
  "history",
  "keyboard",
  "mousewheel",
  "navigation",
  "pagination",
  "parallax",
  "scrollbar",
  "thumbs",
  "virtual",
  "zoom"
];
function M_(e, t, r) {
  const a = {}, n = {};
  wd(a, qp);
  const i = [...tc, "on"], s = i.map((l) => l.replace(/_/, ""));
  i.forEach((l) => {
    l = l.replace("_", ""), typeof e[l] < "u" && (n[l] = e[l]);
  });
  const o = [...e.attributes];
  return typeof t == "string" && typeof r < "u" && o.push({ name: t, value: r }), o.forEach((l) => {
    const u = P_.filter(
      (d) => l.name.indexOf(`${d}-`) === 0
    )[0];
    if (u) {
      const d = sd(u), f = sd(l.name.split(`${u}-`)[1]);
      typeof n[d] > "u" && (n[d] = {}), n[d] === !0 && (n[d] = { enabled: !0 }), n[d][f] = k_(l.value);
    } else {
      const d = sd(l.name);
      if (!s.includes(d))
        return;
      const f = k_(l.value);
      n[d] && P_.includes(l.name) ? (n[d].constructor !== Object && (n[d] = {}), n[d].enabled = f) : n[d] = f;
    }
  }), wd(a, n), a.navigation ? a.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...a.navigation !== !0 ? a.navigation : {}
  } : a.navigation === !1 && delete a.navigation, a.scrollbar ? a.scrollbar = {
    el: ".swiper-scrollbar",
    ...a.scrollbar !== !0 ? a.scrollbar : {}
  } : a.scrollbar === !1 && delete a.scrollbar, a.pagination ? a.pagination = {
    el: ".swiper-pagination",
    ...a.pagination !== !0 ? a.pagination : {}
  } : a.pagination === !1 && delete a.pagination, { params: a, passedParams: n };
}
function tN({
  swiper: e,
  slides: t,
  passedParams: r,
  changedParams: a,
  nextEl: n,
  prevEl: i,
  scrollbarEl: s,
  paginationEl: o
}) {
  const l = a.filter((S) => S !== "children" && S !== "direction" && S !== "wrapperClass"), {
    params: u,
    pagination: d,
    navigation: f,
    scrollbar: c,
    virtual: p,
    thumbs: v
  } = e;
  let h, g, m, b, y, _, x, w;
  a.includes("thumbs") && r.thumbs && r.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (h = !0), a.includes("controller") && r.controller && r.controller.control && u.controller && !u.controller.control && (g = !0), a.includes("pagination") && r.pagination && (r.pagination.el || o) && (u.pagination || u.pagination === !1) && d && !d.el && (m = !0), a.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || s) && (u.scrollbar || u.scrollbar === !1) && c && !c.el && (b = !0), a.includes("navigation") && r.navigation && (r.navigation.prevEl || i) && (r.navigation.nextEl || n) && (u.navigation || u.navigation === !1) && f && !f.prevEl && !f.nextEl && (y = !0);
  const k = (S) => {
    e[S] && (e[S].destroy(), S === "navigation" ? (e.isElement && (e[S].prevEl.remove(), e[S].nextEl.remove()), u[S].prevEl = void 0, u[S].nextEl = void 0, e[S].prevEl = void 0, e[S].nextEl = void 0) : (e.isElement && e[S].el.remove(), u[S].el = void 0, e[S].el = void 0));
  };
  a.includes("loop") && e.isElement && (u.loop && !r.loop ? _ = !0 : !u.loop && r.loop ? x = !0 : w = !0), l.forEach((S) => {
    if (xd(u[S]) && xd(r[S]))
      wd(u[S], r[S]), (S === "navigation" || S === "pagination" || S === "scrollbar") && "enabled" in r[S] && !r[S].enabled && k(S);
    else {
      const P = r[S];
      (P === !0 || P === !1) && (S === "navigation" || S === "pagination" || S === "scrollbar") ? P === !1 && k(S) : u[S] = r[S];
    }
  }), l.includes("controller") && !g && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), a.includes("children") && t && p && u.virtual.enabled && (p.slides = t, p.update(!0)), a.includes("children") && t && u.loop && (w = !0), h && v.init() && v.update(!0), g && (e.controller.control = u.controller.control), m && (e.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-pagination"), e.el.shadowEl.appendChild(o)), o && (u.pagination.el = o), d.init(), d.render(), d.update()), b && (e.isElement && (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-scrollbar"), e.el.shadowEl.appendChild(s)), s && (u.scrollbar.el = s), c.init(), c.updateSize(), c.setTranslate()), y && (e.isElement && ((!n || typeof n == "string") && (n = document.createElement("div"), n.classList.add("swiper-button-next"), e.el.shadowEl.appendChild(n)), (!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-prev"), e.el.shadowEl.appendChild(i))), n && (u.navigation.nextEl = n), i && (u.navigation.prevEl = i), f.init(), f.update()), a.includes("allowSlideNext") && (e.allowSlideNext = r.allowSlideNext), a.includes("allowSlidePrev") && (e.allowSlidePrev = r.allowSlidePrev), a.includes("direction") && e.changeDirection(r.direction, !1), (_ || w) && e.loopDestroy(), (x || w) && e.loopCreate(), e.update();
}
const rN = "@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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');font-weight:400;font-style:normal}", aN = ":root{--swiper-theme-color:#007aff}.swiper,swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}:host(.swiper-vertical)>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight swiper-slide{height:auto}:host(.swiper-autoheight) .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}:host(.swiper-3d.swiper-css-mode) .swiper-wrapper{perspective:1200px}:host(.swiper-3d) .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d swiper-slide{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}:host(.swiper-css-mode)>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}:host(.swiper-css-mode)>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>swiper-slide{scroll-snap-align:start start}:host(.swiper-horizontal.swiper-css-mode)>.swiper-wrapper{scroll-snap-type:x mandatory}:host(.swiper-vertical.swiper-css-mode)>.swiper-wrapper{scroll-snap-type:y mandatory}:host(.swiper-css-mode.swiper-free-mode)>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>swiper-slide{scroll-snap-align:none}:host(.swiper-centered)>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered>swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-centered.swiper-horizontal>swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}:host(.swiper-centered.swiper-horizontal)>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}:host(.swiper-centered.swiper-vertical)>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,swiper-container:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.swiper-virtual swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}:host(.swiper-virtual.swiper-css-mode) .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}:host(.swiper-virtual.swiper-css-mode.swiper-horizontal) .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}:host(.swiper-virtual.swiper-css-mode.swiper-vertical) .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,:host(.swiper-rtl) .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-prev:after,:host(.swiper-rtl) .swiper-button-next:after{content:'prev'}.swiper-button-next,:host(.swiper-rtl) .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-next:after,:host(.swiper-rtl) .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,:host(.swiper-horizontal.swiper-rtl) .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}:host(.swiper-rtl) .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;-ms-touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move;touch-action:none}.swiper .swiper-notification,swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}:host(.swiper-free-mode)>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}:host(.swiper-grid)>.swiper-wrapper{flex-wrap:wrap}:host(.swiper-grid-column)>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode swiper-slide{transition-timing-function:ease-out}.swiper-fade swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade swiper-slide swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube swiper-slide swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-prev,.swiper-cube swiper-slide-next+swiper-slide{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-flip{overflow:visible}.swiper-flip swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip swiper-slide swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-creative swiper-slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards swiper-slide{transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}";
let Td = !0;
const Hp = (e, t) => {
  let r = document.querySelector("style#swiper-element-styles");
  const a = r && r.preInit && !e;
  !e && t && t.cssLinks().forEach((n) => {
    const i = document.createElement("link");
    i.rel = "stylesheet", i.href = n, document.head.prepend(i);
  }), (!r || a) && (r = r || document.createElement("style"), r.textContent = [rN, t ? t.cssStyles() : ""].join(`
`), r.id = "swiper-element-styles", r.preInit = e, document.head.prepend(r));
};
class nN {
}
const RS = typeof window > "u" || typeof HTMLElement > "u" ? nN : HTMLElement;
class jS extends RS {
  constructor() {
    super(), this.tempDiv = document.createElement("div"), this.shadowEl = this.attachShadow({ mode: "open" });
  }
  cssStyles() {
    return [
      Td ? aN : "",
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  render() {
    if (this.rendered)
      return;
    Td && Hp(!1, this);
    const t = this.cssStyles();
    t.length && (this.stylesEl = document.createElement("style"), this.stylesEl.textContent = t, this.shadowEl.appendChild(this.stylesEl)), this.cssLinks().forEach((r) => {
      if (this.shadowEl.querySelector(`link[href="${r}"]`))
        return;
      const n = document.createElement("link");
      n.rel = "stylesheet", n.href = r, this.shadowEl.appendChild(n);
    }), this.tempDiv.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
      <slot name="container-end"></slot>
      ${Q6(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev"></div>
        <div part="button-next" class="swiper-button-next"></div>
      ` : ""}
      ${Z6(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${eN(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, [...this.tempDiv.children].forEach((r) => {
      this.shadowEl.appendChild(r);
    }), this.rendered = !0;
  }
  initialize() {
    if (this.initialized)
      return;
    this.initialized = !0;
    const { params: t, passedParams: r } = M_(this);
    this.swiperParams = t, this.passedParams = r, delete this.swiperParams.init, this.render(), this.swiper = new Wa(this, {
      ...t,
      touchEventsTarget: "container",
      ...t.virtual ? {} : { observer: !0 },
      onAny: (a, ...n) => {
        const i = t.eventsPrefix ? `${t.eventsPrefix}${a.toLowerCase()}` : a.toLowerCase(), s = new CustomEvent(i, {
          detail: n,
          bubbles: !0,
          cancelable: !0
        });
        this.dispatchEvent(s);
      }
    });
  }
  connectedCallback() {
    if (!(this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM)) {
      if (this.init === !1 || this.getAttribute("init") === "false") {
        Hp(!0, this);
        return;
      }
      this.initialize();
    }
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || (this.swiper && this.swiper.destroy && this.swiper.destroy(), this.initialized = !1);
  }
  updateSwiperOnPropChange(t, r) {
    const { params: a, passedParams: n } = M_(this, t, r);
    this.passedParams = n, this.swiperParams = a, tN({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [sd(t)],
      ...t === "navigation" && n[t] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...t === "pagination" && n[t] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...t === "scrollbar" && n[t] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(t, r, a) {
    this.initialized && (r === "true" && a === null && (a = !1), this.updateSwiperOnPropChange(t, a));
  }
  static get observedAttributes() {
    return tc.filter((r) => r.includes("_")).map(
      (r) => r.replace(/[A-Z]/g, (a) => `-${a}`).replace("_", "").toLowerCase()
    );
  }
}
tc.forEach((e) => {
  e !== "init" && (e = e.replace("_", ""), Object.defineProperty(jS.prototype, e, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[e];
    },
    set(t) {
      this.passedParams || (this.passedParams = {}), this.passedParams[e] = t, this.initialized && this.updateSwiperOnPropChange(e);
    }
  }));
});
class iN extends RS {
  constructor() {
    super(), this.tempDiv = document.createElement("div"), this.shadowEl = this.attachShadow({ mode: "open" });
  }
  render() {
    const t = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (this.tempDiv.innerHTML = "<slot />", [...this.tempDiv.children].forEach((r) => {
      this.shadowEl.appendChild(r);
    }), t) {
      const r = document.createElement("div");
      r.classList.add("swiper-lazy-preloader"), this.appendChild(r);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.initialize();
  }
}
const sN = (e = !0) => {
  typeof window > "u" || (e || (Td = !1), Td && Hp(!0), window.customElements.get("swiper-container") || window.customElements.define("swiper-container", jS), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", iN));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (e) => {
  tc.push(...e);
});
const oN = ["dir"], lN = {
  key: 0,
  class: "absolute top-1/2 z-10 flex w-full -translate-y-1/2 transform justify-between"
}, uN = {
  key: 1,
  class: "flex justify-between"
}, dN = { class: "text-title font-semi-bold text-dark" }, cN = { class: "flex" }, fN = ["dir", "slidesPerView", "spaceBetween", "allowTouchMove", "navigation", "options", "centeredSlides", "loop"], pN = ["dir", "slidesPerView", "spaceBetween"], vN = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JCarousel",
  props: {
    title: {},
    slidesPerView: { default: 3 },
    isSingleSwiper: { type: Boolean, default: !1 },
    spaceBetween: { default: 30 },
    options: {},
    navigation: { type: Boolean, default: !0 },
    center: { type: Boolean, default: !1 },
    loop: { type: Boolean, default: !1 },
    thumbs: { type: Boolean, default: !1 },
    thumbSlidesPerView: { default: 4 },
    thumbSpaceBetween: { default: 10 },
    showNavigationForSingleItem: { type: Boolean, default: !1 }
  },
  setup(e, { expose: t }) {
    const r = N(() => cu().toString());
    sN();
    const { currentLocaleItem: a } = Ii(), n = ne(null), i = ne(null), s = ne(0);
    function o(d) {
      s.value = d.currentTarget.swiper.activeIndex, i.value && i.value.swiper.slideTo(d.currentTarget.swiper.activeIndex);
    }
    function l(d) {
      n.value && n.value.swiper.slideTo(d.currentTarget.swiper.activeIndex);
    }
    function u(d) {
      if (!n.value)
        return;
      const { clickedIndex: f } = d.currentTarget.swiper;
      n.value.swiper.slideTo(f);
    }
    return t({
      activeIndex: s,
      mainSwiper: n
    }), (d, f) => (R(), K(Qe, null, [
      ue("div", {
        class: "relative z-0",
        dir: U(a).rtl ? "rtl" : "ltr"
      }, [
        d.isSingleSwiper && d.navigation && !d.showNavigationForSingleItem ? (R(), K("div", lN, [
          ue("button", {
            class: pe([`swiper-prev-button-${r.value}`, "group disabled:invisible"]),
            onClick: f[0] || (f[0] = zr(() => {
            }, ["stop"]))
          }, [
            Fe(gt, {
              name: "alt-arrow-right-filled",
              class: pe(["ms-16 text-white", { "rotate-180": !U(a).rtl }])
            }, null, 8, ["class"])
          ], 2),
          ue("button", {
            class: pe([`swiper-next-button-${r.value}`, "group disabled:invisible"]),
            onClick: f[1] || (f[1] = zr(() => {
            }, ["stop"]))
          }, [
            Fe(gt, {
              name: "alt-arrow-right-filled",
              class: pe(["me-16 text-white", { "rotate-180": U(a).rtl }])
            }, null, 8, ["class"])
          ], 2)
        ])) : (R(), K("div", uN, [
          ue("div", dN, Ie(d.title), 1),
          ue("div", cN, [
            ke(d.$slots, "actions", {}, void 0, !0),
            d.navigation ? (R(), K(Qe, { key: 0 }, [
              ue("button", {
                class: pe([`swiper-prev-button-${r.value}`, "group me-12 disabled:cursor-not-allowed"])
              }, [
                Fe(gt, {
                  name: "circle-right-icon",
                  size: "40",
                  class: pe(["text-gray-600 hover:text-primary group-disabled:text-gray-400", { "rotate-180": !U(a).rtl }])
                }, null, 8, ["class"])
              ], 2),
              ue("button", {
                class: pe([`swiper-next-button-${r.value}`, "group disabled:cursor-not-allowed"])
              }, [
                Fe(gt, {
                  name: "circle-right-icon",
                  size: "40",
                  class: pe(["text-gray-600 hover:text-primary group-disabled:text-gray-400", { "rotate-180": U(a).rtl }])
                }, null, 8, ["class"])
              ], 2)
            ], 64)) : fe("", !0)
          ])
        ])),
        ke(d.$slots, "header", {}, void 0, !0),
        ue("swiper-container", Mt({
          ref_key: "mainSwiper",
          ref: n,
          dir: U(a).rtl ? "rtl" : "ltr",
          slidesPerView: d.slidesPerView,
          spaceBetween: d.spaceBetween,
          allowTouchMove: !d.isSingleSwiper,
          navigation: d.navigation && {
            prevEl: `.swiper-prev-button-${r.value}`,
            nextEl: `.swiper-next-button-${r.value}`
          }
        }, d.$attrs, {
          options: d.options,
          centeredSlides: d.center,
          loop: d.loop,
          onSlidechange: o
        }), [
          ke(d.$slots, "default", {}, void 0, !0)
        ], 16, fN)
      ], 8, oN),
      d.thumbs ? (R(), K("swiper-container", {
        key: 0,
        ref_key: "swiperThumb",
        ref: i,
        dir: U(a).rtl ? "rtl" : "ltr",
        slidesPerView: d.thumbSlidesPerView,
        spaceBetween: d.thumbSpaceBetween,
        class: "mt-20 !aspect-auto",
        onSlidechange: l,
        onClick: u
      }, [
        ke(d.$slots, "default", {}, void 0, !0)
      ], 40, pN)) : fe("", !0)
    ], 64));
  }
});
const xoe = /* @__PURE__ */ rs(vN, [["__scopeId", "data-v-4462e355"]]);
function A_(e) {
  const t = getComputedStyle(e), r = Number.parseFloat;
  return e.scrollHeight + r(t.marginTop) + r(t.paddingTop) + r(t.marginBottom) + r(t.paddingBottom);
}
const woe = /* @__PURE__ */ Ae({
  __name: "JCollapse",
  props: {
    show: { type: Boolean, default: !1 },
    duration: { default: 300 },
    keepMounted: { type: Boolean, default: !1 },
    isInitiallyMounted: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = ne(t.isInitiallyMounted), a = ne();
    function n(c) {
      const p = c;
      p.style.height = "0", p.style.transitionDuration = `${t.duration}ms`, p.style.transitionProperty = "height";
    }
    function i(c, p) {
      const v = c;
      clearTimeout(a.value), setTimeout(() => {
        v.style.height = `${A_(v)}px`;
      }, 1), a.value = setTimeout(() => {
        p();
      }, t.duration);
    }
    function s(c) {
      const p = c;
      p.style.height = "";
    }
    function o() {
    }
    function l(c) {
      const p = c;
      p.style.transitionDuration = `${t.duration}ms`, p.style.transitionProperty = "height", p.style.height = `${A_(p)}px`;
    }
    function u(c, p) {
      const v = c;
      clearTimeout(a.value), setTimeout(() => {
        v.style.height = "0";
      }, 1), a.value = setTimeout(() => {
        p();
      }, t.duration);
    }
    function d(c) {
      const p = c;
      p.style.height = "", r.value = t.keepMounted;
    }
    function f() {
    }
    return (c, p) => (R(), Le(Hn, {
      css: !1,
      onBeforeEnter: n,
      onEnter: i,
      onAfterEnter: s,
      onEnterCancelled: o,
      onBeforeLeave: l,
      onLeave: u,
      onAfterLeave: d,
      onLeaveCancelled: f
    }, {
      default: Pe(() => [
        c.show || r.value ? ea((R(), K("div", {
          key: 0,
          class: pe(["overflow-hidden", `duration-${c.duration}`])
        }, [
          ke(c.$slots, "default")
        ], 2)), [
          [$a, c.show]
        ]) : fe("", !0)
      ]),
      _: 3
    }));
  }
}), mN = { class: "carousel-item" }, hN = /* @__PURE__ */ Ae({
  __name: "JCarouselItem",
  setup(e) {
    I1((a) => ({
      "6c51206e": r.value
    }));
    const { currentLocaleItem: t } = Ii(), r = N(() => t.value.rtl ? "rtl" : "ltr");
    return (a, n) => (R(), K("swiper-slide", mN, [
      ke(a.$slots, "default", {}, void 0, !0)
    ]));
  }
});
const Toe = /* @__PURE__ */ rs(hN, [["__scopeId", "data-v-8922f68b"]]), FS = {};
Object.keys(qa).forEach((e) => {
  FS[e] = `border-${e} ${ID[e]} checked:border-0`;
});
const D_ = {
  sm: "h-16 w-16 text-base",
  md: "h-20 w-20 text-base",
  lg: "h-24 w-24 text-subject"
}, gN = { class: "flex" }, bN = ["for", "aria-disabled"], yN = { class: "relative flex h-max" }, _N = ["id", "checked", "disabled", "aria-disabled", "name", "required", "value"], xN = /* @__PURE__ */ ue("polyline", { points: "20 6 9 17 4 12" }, null, -1), wN = [
  xN
], TN = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JCheckBox",
  props: {
    modelValue: { type: [Boolean, String, Number, Array], default: !1 },
    value: { type: [Boolean, String, Number] },
    color: { default: "primary" },
    id: {},
    label: {},
    name: {},
    checked: { type: Boolean, default: void 0 },
    size: { default: "md" },
    filled: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    labelClass: {},
    containerClass: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, i = Vn()("default"), s = Gr(), o = N(() => s("disabled", !0)), l = N(() => s("required", !0)), u = N(() => r.checked !== void 0), d = N(() => r.id || `checkbox-${cu()}`), f = N(() => u.value ? r.checked : h(r.modelValue, r.value));
    function c(x) {
      if (u.value) {
        x.preventDefault();
        return;
      }
      v(!f.value);
    }
    function p(x) {
      if (u.value) {
        x.preventDefault();
        return;
      }
      const w = x.target;
      v(w.checked);
    }
    function v(x) {
      const { modelValue: w, value: k } = r;
      Array.isArray(w) && k !== void 0 ? a("update:modelValue", g(w, k, x)) : a("update:modelValue", x);
    }
    function h(x, w) {
      return Array.isArray(x) ? x.includes(w ?? "") : !!x;
    }
    function g(x, w, k) {
      return k ? Array.from(/* @__PURE__ */ new Set([...x, w])) : x.filter((S) => S !== w);
    }
    const m = N(() => [
      FS[r.color],
      r.rounded ? "rounded-3xl" : "rounded-sm",
      r.filled ? "hidden checked:block" : "",
      D_[r.size],
      o.value || u.value ? "cursor-not-allowed" : "cursor-pointer"
    ]), b = N(
      () => r.filled ? [
        `border border-${r.color}`,
        `text-${r.color}`,
        "h-fit p-4 rounded-sm items-center",
        o.value ? "cursor-not-allowed" : "cursor-pointer"
      ].join(" ") : ""
    ), y = N(
      () => r.filled ? "hidden peer-checked:block" : ""
    ), _ = N(() => D_[r.size]);
    return (x, w) => (R(), K("div", gN, [
      ue("label", {
        for: d.value,
        class: pe(["flex w-max cursor-pointer select-none flex-row items-center gap-4", [b.value, x.containerClass]]),
        "aria-disabled": o.value
      }, [
        ue("div", yN, [
          ue("input", Mt({
            id: d.value,
            checked: f.value,
            type: "checkbox",
            class: [m.value, "peer m-2 shrink-0 appearance-none border-2 bg-white p-2 disabled:border-gray-300 disabled:bg-disabled"],
            disabled: o.value,
            "aria-disabled": o.value,
            name: x.name,
            required: l.value,
            value: x.value
          }, x.$attrs, {
            onClick: c,
            onInput: p
          }), null, 16, _N),
          (R(), K("svg", {
            class: pe(["pointer-events-none absolute top-0 m-2 hidden peer-checked:block peer-disabled:hidden", [y.value, _.value]]),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "#ffffff",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, wN, 2))
        ]),
        U(i) ? ke(x.$slots, "default", { key: 0 }) : !U(i) && x.label ? (R(), K("span", {
          key: 1,
          class: pe(x.labelClass)
        }, Ie(x.label), 3)) : fe("", !0)
      ], 10, bN)
    ]));
  }
}), SN = {
  sm: "px-4 py-2 text-metadata",
  md: "px-8 py-4 text-metadata-limited",
  lg: "px-12 py-4 text-base"
}, EN = {
  key: 0,
  class: "flex h-full"
}, Soe = /* @__PURE__ */ Ae({
  __name: "JChip",
  props: {
    variant: { default: "outlined" },
    color: { default: "primary" },
    size: { default: "sm" },
    rounded: { default: "xs" },
    label: { default: "text" },
    editable: { type: Boolean, default: !1 },
    icon: {},
    textColor: { default: "dark" },
    borderColor: {},
    labelClass: { default: "ms-4" },
    as: { default: "div" }
  },
  emits: ["edit", "remove"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = N(() => `rounded-${r.rounded}`), i = N(() => r.variant === "filled" ? `border-transparent ${qa[r.color]}` : `bg-transparent disabled:border-gray-400 border border-${r.borderColor || r.color} ${gn[r.textColor]}`), s = N(() => SN[r.size]), o = N(() => ({
      sm: 16,
      md: 18,
      lg: 20
    })[r.size]);
    function l() {
      a("remove");
    }
    function u() {
      a("edit");
    }
    return (d, f) => (R(), Le(Za(d.as), {
      class: pe(["inline-flex w-fit select-none items-center justify-between overflow-hidden font-medium outline outline-2 outline-transparent focus:outline-offset-1", [i.value, n.value, r.icon && "h-fit"]])
    }, {
      default: Pe(() => [
        ue("div", {
          class: pe([[s.value], "flex items-center"])
        }, [
          d.icon ? (R(), Le(gt, {
            key: 0,
            size: o.value,
            name: d.icon
          }, null, 8, ["size", "name"])) : fe("", !0),
          ue("span", {
            class: pe([[d.labelClass], "capitalize"])
          }, Ie(r.label), 3)
        ], 2),
        r.editable ? (R(), K("div", EN, [
          ue("button", {
            class: pe(["hover:bg-warning-hover bg-warning text-white", [s.value]]),
            onClick: u
          }, [
            Fe(gt, {
              size: o.value,
              name: "pen-bold"
            }, null, 8, ["size"])
          ], 2),
          ue("button", {
            class: pe(["bg-danger text-white hover:bg-danger-hover", [s.value]]),
            onClick: l
          }, [
            Fe(gt, {
              size: o.value,
              name: "close"
            }, null, 8, ["size"])
          ], 2)
        ])) : fe("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), ON = {
  key: 0,
  class: "mx-auto mb-32 mt-12 flex max-h-[20rem] max-w-[20rem] justify-center"
}, CN = ["src"], kN = {
  key: 0,
  class: "rounded-full border border-gray-300 bg-gray-100 p-8"
}, PN = { class: "text-subject font-bold" }, MN = { class: "flex-between flex flex-row-reverse gap-16 py-24" }, Eoe = /* @__PURE__ */ Ae({
  __name: "JConfirmation",
  props: {
    title: { default: "" },
    modelValue: { type: Boolean, default: !1 },
    size: { default: "sm" },
    persistent: { type: Boolean, default: !1 },
    modalProps: { default: () => ({}) },
    color: { default: "primary" },
    icon: { default: "danger-circle" },
    image: { default: "" },
    description: { default: "" },
    cancelText: { default: "Cancel" },
    confirmText: { default: "Confirm" },
    isLoading: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !1 }
  },
  emits: ["confirm", "cancel", "close", "update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a), i = N(() => ({
      size: r.size,
      showClose: r.showCloseButton,
      persistent: r.persistent || r.isLoading,
      ...r.modalProps
    })), s = N(() => !!r.image);
    He(n, (u) => {
      u || a("close");
    });
    function o() {
      r.isLoading || a("cancel");
    }
    function l() {
      r.isLoading || a("confirm");
    }
    return (u, d) => (R(), Le(U(vV), Mt(i.value, {
      modelValue: U(n),
      "onUpdate:modelValue": d[0] || (d[0] = (f) => _a(n) ? n.value = f : null),
      center: ""
    }), {
      default: Pe(() => [
        ue("div", {
          class: pe(["flex flex-col justify-center", { "justify-center": s.value }])
        }, [
          ke(u.$slots, "default", {}, () => [
            s.value ? (R(), K("div", ON, [
              typeof u.image == "string" ? (R(), K("img", {
                key: 0,
                src: u.image,
                alt: " "
              }, null, 8, CN)) : (R(), Le(Za(u.image), { key: 1 }))
            ])) : fe("", !0),
            u.title ? (R(), K("p", {
              key: 1,
              class: pe(["mb-12 flex items-center gap-12", { "justify-center": s.value }])
            }, [
              s.value ? fe("", !0) : (R(), K("span", kN, [
                Fe(U(gt), {
                  name: u.icon,
                  size: "16",
                  class: "text-gray-500"
                }, null, 8, ["name"])
              ])),
              ue("span", PN, Ie(u.title), 1)
            ], 2)) : fe("", !0),
            u.description ? (R(), K("p", {
              key: 2,
              class: pe(["font-medium text-gray-600", { "justify-center": s.value }])
            }, Ie(u.description), 3)) : fe("", !0)
          ])
        ], 2),
        ue("div", MN, [
          ke(u.$slots, "actions", {}, () => [
            Fe(U(Wl), {
              color: u.color,
              class: "flex-1 rounded-sm",
              label: u.confirmText,
              isLoading: u.isLoading,
              onClick: l
            }, null, 8, ["color", "label", "isLoading"]),
            u.cancelText ? (R(), Le(U(Wl), {
              key: 0,
              color: "dark",
              variant: "outlined",
              label: u.cancelText,
              class: "flex-1 rounded-sm",
              onClick: o
            }, null, 8, ["label"])) : fe("", !0)
          ])
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), Ooe = /* @__PURE__ */ Ae({
  __name: "JCountDown",
  props: {
    seconds: {}
  },
  emits: ["stop"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = ne(r.seconds), i = () => n.value -= 1;
    function s() {
      n.value <= 0 || i();
    }
    a5(s, 1e3);
    const o = () => a("stop");
    function l() {
      n.value > 0 || o();
    }
    He(n, l), He(
      () => r.seconds,
      (d) => n.value = d
    );
    const u = N(() => {
      const d = Math.floor(n.value / 60), f = n.value % 60, c = d.toString().padStart(2, "0"), p = f.toString().padStart(2, "0");
      return `${c}:${p}`;
    });
    return (d, f) => (R(), K("span", null, Ie(u.value), 1));
  }
}), AN = { class: "inline-flex items-center" }, DN = ["disabled"], IN = { class: "w-32 text-center text-metadata-limited font-medium text-dark" }, NN = ["disabled"], $N = /* @__PURE__ */ Ae({
  __name: "JCounter",
  props: {
    modelValue: { default: 0 },
    min: { default: 0 },
    max: { default: Number.POSITIVE_INFINITY },
    step: { default: 1 },
    isFixed: { type: Boolean },
    iconSize: { default: 24 },
    color: { default: "primary" }
  },
  emits: ["update:modelValue", "inc", "dec"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a), i = N(
      () => Number(n.value)
    ), s = N(() => !Number.isInteger(r.modelValue));
    function o() {
      let d;
      s.value ? d = Math.round(i.value) : d = i.value + r.step, i.value <= r.max && (n.value = d), a("inc", d);
    }
    function l() {
      let d;
      s.value ? d = Math.floor(i.value) : d = i.value - r.step, i.value >= r.min && (n.value = d), a("dec", d);
    }
    const u = N(() => gn[r.color]);
    return (d, f) => (R(), K("div", AN, [
      ue("button", {
        type: "button",
        class: pe([[
          i.value === d.min ? "text-gray-400" : u.value
        ], "touch-manipulation"]),
        disabled: i.value === d.min,
        onClick: f[0] || (f[0] = (c) => l())
      }, [
        Fe(gt, {
          name: "minus-circle",
          size: d.iconSize
        }, null, 8, ["size"])
      ], 10, DN),
      ue("div", IN, Ie(d.isFixed ? i.value.toFixed(1) : i.value), 1),
      ue("button", {
        type: "button",
        class: pe([[
          i.value === d.max ? "text-gray-400" : u.value
        ], "touch-manipulation"]),
        disabled: i.value === d.max,
        onClick: f[1] || (f[1] = (c) => o())
      }, [
        Fe(gt, {
          name: "plus-circle",
          size: d.iconSize
        }, null, 8, ["size"])
      ], 10, NN)
    ]));
  }
}), LN = { class: "input" }, RN = { class: "flex items-center gap-x-8" }, jN = {
  key: 0,
  class: "input__error mb-4"
}, FN = {
  key: 1,
  class: "input__hint mb-4"
}, Coe = /* @__PURE__ */ Ae({
  __name: "JCounterInput",
  props: {
    label: {},
    hint: {},
    error: {},
    icon: {},
    modelValue: { default: 0 },
    min: {},
    max: {},
    step: {},
    isFixed: { type: Boolean },
    iconSize: {},
    color: {}
  },
  emits: ["update:modelValue", "inc", "dec"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = Gr(), s = N(() => i("required", !0)), o = N(
      () => r.error ? "border-danger" : "border-line"
    );
    return (l, u) => (R(), K("div", null, [
      ue("div", LN, [
        l.label ? (R(), K("label", {
          key: 0,
          class: pe(["input__label", s.value && "input--required"])
        }, Ie(l.label), 3)) : fe("", !0),
        ue("div", {
          class: pe(["flex h-40 flex-row items-center justify-between rounded-sm border px-8", o.value])
        }, [
          ue("div", RN, [
            l.icon ? (R(), Le(gt, {
              key: 0,
              name: l.icon,
              class: "text-gray-400",
              size: 20
            }, null, 8, ["name"])) : fe("", !0),
            ue("span", {
              class: pe(["input__label mb-0 w-auto text-metadata-limited font-medium text-gray-500", s.value && "input--required"])
            }, [
              ke(l.$slots, "content", jr(oa({ value: U(n) })), () => [
                jt(Ie(U(n)), 1)
              ])
            ], 2)
          ]),
          Fe($N, {
            modelValue: U(n),
            "onUpdate:modelValue": u[0] || (u[0] = (d) => _a(n) ? n.value = d : null),
            min: l.min,
            max: l.max,
            step: l.step,
            isFixed: l.isFixed,
            iconSize: 18
          }, null, 8, ["modelValue", "min", "max", "step", "isFixed"])
        ], 2)
      ]),
      l.error ? (R(), K("span", jN, Ie(l.error), 1)) : !l.error && l.hint ? (R(), K("span", FN, Ie(l.hint), 1)) : fe("", !0)
    ]));
  }
});
var ve = {}, BS = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(BS);
var X = BS.exports, Vp = { exports: {} }, qS = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(qS);
var On = qS.exports, Up = { exports: {} }, zp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(zp, zp.exports);
var pt = zp.exports, Yp = { exports: {} }, Wp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n) {
    if (n.length < a)
      throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  e.exports = t.default;
})(Wp, Wp.exports);
var re = Wp.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(On), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = Object.prototype.toString.call(s);
    return s instanceof Date || (0, a.default)(s) === "object" && o === "[object Date]" ? new Date(s.getTime()) : typeof s == "number" || o === "[object Number]" ? new Date(s) : ((typeof s == "string" || o === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  e.exports = t.default;
})(Yp, Yp.exports);
var Ce = Yp.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return isNaN(d) ? /* @__PURE__ */ new Date(NaN) : (d && u.setDate(u.getDate() + d), u);
  }
  e.exports = t.default;
})(Up, Up.exports);
var $i = Up.exports, Gp = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    if (isNaN(d))
      return /* @__PURE__ */ new Date(NaN);
    if (!d)
      return u;
    var f = u.getDate(), c = new Date(u.getTime());
    c.setMonth(u.getMonth() + d + 1, 0);
    var p = c.getDate();
    return f >= p ? c : (u.setFullYear(c.getFullYear(), c.getMonth(), f), u);
  }
  e.exports = t.default;
})(Gp, Gp.exports);
var _u = Gp.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var a = r(On), n = r($i), i = r(_u), s = r(Ce), o = r(re), l = r(pt);
  function u(d, f) {
    if ((0, o.default)(2, arguments), !f || (0, a.default)(f) !== "object")
      return /* @__PURE__ */ new Date(NaN);
    var c = f.years ? (0, l.default)(f.years) : 0, p = f.months ? (0, l.default)(f.months) : 0, v = f.weeks ? (0, l.default)(f.weeks) : 0, h = f.days ? (0, l.default)(f.days) : 0, g = f.hours ? (0, l.default)(f.hours) : 0, m = f.minutes ? (0, l.default)(f.minutes) : 0, b = f.seconds ? (0, l.default)(f.seconds) : 0, y = (0, s.default)(d), _ = p || c ? (0, i.default)(y, p + c * 12) : y, x = h || v ? (0, n.default)(_, h + v * 7) : _, w = m + g * 60, k = b + w * 60, S = k * 1e3, P = new Date(x.getTime() + S);
    return P;
  }
  e.exports = t.default;
})(Vp, Vp.exports);
var HS = Vp.exports, Xp = { exports: {} }, Kp = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getDay();
    return l === 0 || l === 6;
  }
  e.exports = t.default;
})(Kp, Kp.exports);
var rc = Kp.exports, Jp = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 0;
  }
  e.exports = t.default;
})(Jp, Jp.exports);
var sb = Jp.exports, Qp = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 6;
  }
  e.exports = t.default;
})(Qp, Qp.exports);
var VS = Qp.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var a = r(rc), n = r(Ce), i = r(pt), s = r(re), o = r(sb), l = r(VS);
  function u(d, f) {
    (0, s.default)(2, arguments);
    var c = (0, n.default)(d), p = (0, a.default)(c), v = (0, i.default)(f);
    if (isNaN(v))
      return /* @__PURE__ */ new Date(NaN);
    var h = c.getHours(), g = v < 0 ? -1 : 1, m = (0, i.default)(v / 5);
    c.setDate(c.getDate() + m * 7);
    for (var b = Math.abs(v % 5); b > 0; )
      c.setDate(c.getDate() + g), (0, a.default)(c) || (b -= 1);
    return p && (0, a.default)(c) && v !== 0 && ((0, l.default)(c) && c.setDate(c.getDate() + (g < 0 ? 2 : -1)), (0, o.default)(c) && c.setDate(c.getDate() + (g < 0 ? 1 : -2))), c.setHours(h), c;
  }
  e.exports = t.default;
})(Xp, Xp.exports);
var US = Xp.exports, Zp = { exports: {} }, ev = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o).getTime(), d = (0, a.default)(l);
    return new Date(u + d);
  }
  e.exports = t.default;
})(ev, ev.exports);
var xu = ev.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(xu), i = r(re), s = 36e5;
  function o(l, u) {
    (0, i.default)(2, arguments);
    var d = (0, a.default)(u);
    return (0, n.default)(l, d * s);
  }
  e.exports = t.default;
})(Zp, Zp.exports);
var ob = Zp.exports, tv = { exports: {} }, rv = { exports: {} }, av = { exports: {} }, nv = { exports: {} }, Lr = {};
Object.defineProperty(Lr, "__esModule", {
  value: !0
});
Lr.getDefaultOptions = BN;
Lr.setDefaultOptions = qN;
var zS = {};
function BN() {
  return zS;
}
function qN(e) {
  zS = e;
}
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(pt), i = r(re), s = Lr;
  function o(l, u) {
    var d, f, c, p, v, h, g, m;
    (0, i.default)(1, arguments);
    var b = (0, s.getDefaultOptions)(), y = (0, n.default)((d = (f = (c = (p = u == null ? void 0 : u.weekStartsOn) !== null && p !== void 0 ? p : u == null || (v = u.locale) === null || v === void 0 || (h = v.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && c !== void 0 ? c : b.weekStartsOn) !== null && f !== void 0 ? f : (g = b.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(y >= 0 && y <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = (0, a.default)(l), x = _.getDay(), w = (x < y ? 7 : 0) + x - y;
    return _.setDate(_.getDate() - w), _.setHours(0, 0, 0, 0), _;
  }
  e.exports = t.default;
})(nv, nv.exports);
var as = nv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(as), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, {
      weekStartsOn: 1
    });
  }
  e.exports = t.default;
})(av, av.exports);
var Ls = av.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(Ls), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o), u = l.getFullYear(), d = /* @__PURE__ */ new Date(0);
    d.setFullYear(u + 1, 0, 4), d.setHours(0, 0, 0, 0);
    var f = (0, n.default)(d), c = /* @__PURE__ */ new Date(0);
    c.setFullYear(u, 0, 4), c.setHours(0, 0, 0, 0);
    var p = (0, n.default)(c);
    return l.getTime() >= f.getTime() ? u + 1 : l.getTime() >= p.getTime() ? u : u - 1;
  }
  e.exports = t.default;
})(rv, rv.exports);
var Mo = rv.exports, iv = { exports: {} }, sv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Mo), n = r(Ls), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o), u = /* @__PURE__ */ new Date(0);
    u.setFullYear(l, 0, 4), u.setHours(0, 0, 0, 0);
    var d = (0, n.default)(u);
    return d;
  }
  e.exports = t.default;
})(sv, sv.exports);
var wu = sv.exports, ov = { exports: {} }, lv = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
  }
  e.exports = t.default;
})(lv, lv.exports);
var Li = lv.exports, uv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(uv, uv.exports);
var ac = uv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Li), n = r(ac), i = r(re), s = 864e5;
  function o(l, u) {
    (0, i.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, n.default)(u), c = d.getTime() - (0, a.default)(d), p = f.getTime() - (0, a.default)(f);
    return Math.round((c - p) / s);
  }
  e.exports = t.default;
})(ov, ov.exports);
var ns = ov.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(pt), n = r(Ce), i = r(wu), s = r(ns), o = r(re);
  function l(u, d) {
    (0, o.default)(2, arguments);
    var f = (0, n.default)(u), c = (0, a.default)(d), p = (0, s.default)(f, (0, i.default)(f)), v = /* @__PURE__ */ new Date(0);
    return v.setFullYear(c, 0, 4), v.setHours(0, 0, 0, 0), f = (0, i.default)(v), f.setDate(f.getDate() + p), f;
  }
  e.exports = t.default;
})(iv, iv.exports);
var YS = iv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Mo), i = r(YS), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, a.default)(u);
    return (0, i.default)(l, (0, n.default)(l) + d);
  }
  e.exports = t.default;
})(tv, tv.exports);
var WS = tv.exports, dv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(xu), i = r(re), s = 6e4;
  function o(l, u) {
    (0, i.default)(2, arguments);
    var d = (0, a.default)(u);
    return (0, n.default)(l, d * s);
  }
  e.exports = t.default;
})(dv, dv.exports);
var lb = dv.exports, cv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(_u), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l), d = u * 3;
    return (0, n.default)(o, d);
  }
  e.exports = t.default;
})(cv, cv.exports);
var ub = cv.exports, fv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(xu), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, u * 1e3);
  }
  e.exports = t.default;
})(fv, fv.exports);
var GS = fv.exports, pv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r($i), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l), d = u * 7;
    return (0, n.default)(o, d);
  }
  e.exports = t.default;
})(pv, pv.exports);
var nc = pv.exports, vv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(_u), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, u * 12);
  }
  e.exports = t.default;
})(vv, vv.exports);
var XS = vv.exports, mv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o, l) {
    (0, n.default)(2, arguments);
    var u = (0, a.default)(s == null ? void 0 : s.start).getTime(), d = (0, a.default)(s == null ? void 0 : s.end).getTime(), f = (0, a.default)(o == null ? void 0 : o.start).getTime(), c = (0, a.default)(o == null ? void 0 : o.end).getTime();
    if (!(u <= d && f <= c))
      throw new RangeError("Invalid interval");
    return l != null && l.inclusive ? u <= c && f <= d : u < c && f < d;
  }
  e.exports = t.default;
})(mv, mv.exports);
var HN = mv.exports, hv = { exports: {} }, gv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(On), n = r(Ce), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l;
    if (o && typeof o.forEach == "function")
      l = o;
    else if ((0, a.default)(o) === "object" && o !== null)
      l = Array.prototype.slice.call(o);
    else
      return /* @__PURE__ */ new Date(NaN);
    var u;
    return l.forEach(function(d) {
      var f = (0, n.default)(d);
      (u === void 0 || u < f || isNaN(Number(f))) && (u = f);
    }), u || /* @__PURE__ */ new Date(NaN);
  }
  e.exports = t.default;
})(gv, gv.exports);
var KS = gv.exports, bv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(On), n = r(Ce), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l;
    if (o && typeof o.forEach == "function")
      l = o;
    else if ((0, a.default)(o) === "object" && o !== null)
      l = Array.prototype.slice.call(o);
    else
      return /* @__PURE__ */ new Date(NaN);
    var u;
    return l.forEach(function(d) {
      var f = (0, n.default)(d);
      (u === void 0 || u > f || isNaN(f.getDate())) && (u = f);
    }), u || /* @__PURE__ */ new Date(NaN);
  }
  e.exports = t.default;
})(bv, bv.exports);
var JS = bv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(KS), n = r(JS), i = r(re);
  function s(o, l) {
    var u = l.start, d = l.end;
    return (0, i.default)(2, arguments), (0, n.default)([(0, a.default)([o, u]), d]);
  }
  e.exports = t.default;
})(hv, hv.exports);
var VN = hv.exports, yv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s);
    if (isNaN(Number(l)))
      return NaN;
    var u = l.getTime(), d;
    o == null ? d = [] : typeof o.forEach == "function" ? d = o : d = Array.prototype.slice.call(o);
    var f, c;
    return d.forEach(function(p, v) {
      var h = (0, a.default)(p);
      if (isNaN(Number(h))) {
        f = NaN, c = NaN;
        return;
      }
      var g = Math.abs(u - h.getTime());
      (f == null || g < Number(c)) && (f = v, c = g);
    }), f;
  }
  e.exports = t.default;
})(yv, yv.exports);
var UN = yv.exports, _v = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s);
    if (isNaN(Number(l)))
      return /* @__PURE__ */ new Date(NaN);
    var u = l.getTime(), d;
    o == null ? d = [] : typeof o.forEach == "function" ? d = o : d = Array.prototype.slice.call(o);
    var f, c;
    return d.forEach(function(p) {
      var v = (0, a.default)(p);
      if (isNaN(Number(v))) {
        f = /* @__PURE__ */ new Date(NaN), c = NaN;
        return;
      }
      var h = Math.abs(u - v.getTime());
      (f == null || h < Number(c)) && (f = v, c = h);
    }), f;
  }
  e.exports = t.default;
})(_v, _v.exports);
var zN = _v.exports, xv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o), d = l.getTime() - u.getTime();
    return d < 0 ? -1 : d > 0 ? 1 : d;
  }
  e.exports = t.default;
})(xv, xv.exports);
var Rs = xv.exports, wv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o), d = l.getTime() - u.getTime();
    return d > 0 ? -1 : d < 0 ? 1 : d;
  }
  e.exports = t.default;
})(wv, wv.exports);
var YN = wv.exports, Tv = { exports: {} }, dt = {};
Object.defineProperty(dt, "__esModule", {
  value: !0
});
dt.secondsInYear = dt.secondsInWeek = dt.secondsInQuarter = dt.secondsInMonth = dt.secondsInMinute = dt.secondsInHour = dt.secondsInDay = dt.quartersInYear = dt.monthsInYear = dt.monthsInQuarter = dt.minutesInHour = dt.minTime = dt.millisecondsInSecond = dt.millisecondsInMinute = dt.millisecondsInHour = dt.maxTime = dt.daysInYear = dt.daysInWeek = void 0;
var WN = 7;
dt.daysInWeek = WN;
var QS = 365.2425;
dt.daysInYear = QS;
var ZS = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
dt.maxTime = ZS;
var GN = 6e4;
dt.millisecondsInMinute = GN;
var XN = 36e5;
dt.millisecondsInHour = XN;
var KN = 1e3;
dt.millisecondsInSecond = KN;
var JN = -ZS;
dt.minTime = JN;
var QN = 60;
dt.minutesInHour = QN;
var ZN = 3;
dt.monthsInQuarter = ZN;
var e$ = 12;
dt.monthsInYear = e$;
var t$ = 4;
dt.quartersInYear = t$;
var eE = 3600;
dt.secondsInHour = eE;
var r$ = 60;
dt.secondsInMinute = r$;
var db = eE * 24;
dt.secondsInDay = db;
var a$ = db * 7;
dt.secondsInWeek = a$;
var tE = db * QS;
dt.secondsInYear = tE;
var rE = tE / 12;
dt.secondsInMonth = rE;
var n$ = rE * 3;
dt.secondsInQuarter = n$;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.daysInWeek;
    return Math.floor(o);
  }
  e.exports = t.default;
})(Tv, Tv.exports);
var i$ = Tv.exports, Sv = { exports: {} }, Ev = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ac), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(Ev, Ev.exports);
var Tu = Ev.exports, Ov = { exports: {} }, Cv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(On), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), s instanceof Date || (0, a.default)(s) === "object" && Object.prototype.toString.call(s) === "[object Date]";
  }
  e.exports = t.default;
})(Cv, Cv.exports);
var aE = Cv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(aE), n = r(Ce), i = r(re);
  function s(o) {
    if ((0, i.default)(1, arguments), !(0, a.default)(o) && typeof o != "number")
      return !1;
    var l = (0, n.default)(o);
    return !isNaN(Number(l));
  }
  e.exports = t.default;
})(Ov, Ov.exports);
var is = Ov.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var a = r($i), n = r(ns), i = r(Tu), s = r(is), o = r(rc), l = r(Ce), u = r(re), d = r(pt);
  function f(c, p) {
    (0, u.default)(2, arguments);
    var v = (0, l.default)(c), h = (0, l.default)(p);
    if (!(0, s.default)(v) || !(0, s.default)(h))
      return NaN;
    var g = (0, n.default)(v, h), m = g < 0 ? -1 : 1, b = (0, d.default)(g / 7), y = b * 5;
    for (h = (0, a.default)(h, b * 7); !(0, i.default)(v, h); )
      y += (0, o.default)(h) ? 0 : m, h = (0, a.default)(h, m);
    return y === 0 ? 0 : y;
  }
  e.exports = t.default;
})(Sv, Sv.exports);
var s$ = Sv.exports, kv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Mo), n = r(re);
  function i(s, o) {
    return (0, n.default)(2, arguments), (0, a.default)(s) - (0, a.default)(o);
  }
  e.exports = t.default;
})(kv, kv.exports);
var nE = kv.exports, Pv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Li), n = r(Ls), i = r(re), s = 6048e5;
  function o(l, u) {
    (0, i.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, n.default)(u), c = d.getTime() - (0, a.default)(d), p = f.getTime() - (0, a.default)(f);
    return Math.round((c - p) / s);
  }
  e.exports = t.default;
})(Pv, Pv.exports);
var o$ = Pv.exports, Mv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o), d = l.getFullYear() - u.getFullYear(), f = l.getMonth() - u.getMonth();
    return d * 12 + f;
  }
  e.exports = t.default;
})(Mv, Mv.exports);
var cb = Mv.exports, Av = { exports: {} }, Dv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = Math.floor(o.getMonth() / 3) + 1;
    return l;
  }
  e.exports = t.default;
})(Dv, Dv.exports);
var iE = Dv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(iE), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, n.default)(l), f = u.getFullYear() - d.getFullYear(), c = (0, a.default)(u) - (0, a.default)(d);
    return f * 4 + c;
  }
  e.exports = t.default;
})(Av, Av.exports);
var sE = Av.exports, Iv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(as), n = r(Li), i = r(re), s = 6048e5;
  function o(l, u, d) {
    (0, i.default)(2, arguments);
    var f = (0, a.default)(l, d), c = (0, a.default)(u, d), p = f.getTime() - (0, n.default)(f), v = c.getTime() - (0, n.default)(c);
    return Math.round((p - v) / s);
  }
  e.exports = t.default;
})(Iv, Iv.exports);
var fb = Iv.exports, Nv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getFullYear() - u.getFullYear();
  }
  e.exports = t.default;
})(Nv, Nv.exports);
var pb = Nv.exports, $v = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(ns), i = r(re);
  function s(l, u) {
    var d = l.getFullYear() - u.getFullYear() || l.getMonth() - u.getMonth() || l.getDate() - u.getDate() || l.getHours() - u.getHours() || l.getMinutes() - u.getMinutes() || l.getSeconds() - u.getSeconds() || l.getMilliseconds() - u.getMilliseconds();
    return d < 0 ? -1 : d > 0 ? 1 : d;
  }
  function o(l, u) {
    (0, i.default)(2, arguments);
    var d = (0, a.default)(l), f = (0, a.default)(u), c = s(d, f), p = Math.abs((0, n.default)(d, f));
    d.setDate(d.getDate() - c * p);
    var v = +(s(d, f) === -c), h = c * (p - v);
    return h === 0 ? 0 : h;
  }
  e.exports = t.default;
})($v, $v.exports);
var vb = $v.exports, Lv = { exports: {} }, Rv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    return (0, n.default)(2, arguments), (0, a.default)(s).getTime() - (0, a.default)(o).getTime();
  }
  e.exports = t.default;
})(Rv, Rv.exports);
var ic = Rv.exports, ss = {};
Object.defineProperty(ss, "__esModule", {
  value: !0
});
ss.getRoundingMethod = u$;
var I_ = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, l$ = "trunc";
function u$(e) {
  return e ? I_[e] : I_[l$];
}
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = dt, n = r(ic), i = r(re), s = ss;
  function o(l, u, d) {
    (0, i.default)(2, arguments);
    var f = (0, n.default)(l, u) / a.millisecondsInHour;
    return (0, s.getRoundingMethod)(d == null ? void 0 : d.roundingMethod)(f);
  }
  e.exports = t.default;
})(Lv, Lv.exports);
var mb = Lv.exports, jv = { exports: {} }, Fv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(WS), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})(Fv, Fv.exports);
var oE = Fv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(nE), i = r(Rs), s = r(oE), o = r(re);
  function l(u, d) {
    (0, o.default)(2, arguments);
    var f = (0, a.default)(u), c = (0, a.default)(d), p = (0, i.default)(f, c), v = Math.abs((0, n.default)(f, c));
    f = (0, s.default)(f, p * v);
    var h = +((0, i.default)(f, c) === -p), g = p * (v - h);
    return g === 0 ? 0 : g;
  }
  e.exports = t.default;
})(jv, jv.exports);
var d$ = jv.exports, Bv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = dt, n = r(ic), i = r(re), s = ss;
  function o(l, u, d) {
    (0, i.default)(2, arguments);
    var f = (0, n.default)(l, u) / a.millisecondsInMinute;
    return (0, s.getRoundingMethod)(d == null ? void 0 : d.roundingMethod)(f);
  }
  e.exports = t.default;
})(Bv, Bv.exports);
var hb = Bv.exports, qv = { exports: {} }, Hv = { exports: {} }, Vv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(Vv, Vv.exports);
var gb = Vv.exports, Uv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth();
    return o.setFullYear(o.getFullYear(), l + 1, 0), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(Uv, Uv.exports);
var bb = Uv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(gb), i = r(bb), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(u).getTime() === (0, i.default)(u).getTime();
  }
  e.exports = t.default;
})(Hv, Hv.exports);
var lE = Hv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(cb), i = r(Rs), s = r(re), o = r(lE);
  function l(u, d) {
    (0, s.default)(2, arguments);
    var f = (0, a.default)(u), c = (0, a.default)(d), p = (0, i.default)(f, c), v = Math.abs((0, n.default)(f, c)), h;
    if (v < 1)
      h = 0;
    else {
      f.getMonth() === 1 && f.getDate() > 27 && f.setDate(30), f.setMonth(f.getMonth() - p * v);
      var g = (0, i.default)(f, c) === -p;
      (0, o.default)((0, a.default)(u)) && v === 1 && (0, i.default)(u, c) === 1 && (g = !1), h = p * (v - Number(g));
    }
    return h === 0 ? 0 : h;
  }
  e.exports = t.default;
})(qv, qv.exports);
var sc = qv.exports, zv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(sc), n = r(re), i = ss;
  function s(o, l, u) {
    (0, n.default)(2, arguments);
    var d = (0, a.default)(o, l) / 3;
    return (0, i.getRoundingMethod)(u == null ? void 0 : u.roundingMethod)(d);
  }
  e.exports = t.default;
})(zv, zv.exports);
var c$ = zv.exports, Yv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(ic), n = r(re), i = ss;
  function s(o, l, u) {
    (0, n.default)(2, arguments);
    var d = (0, a.default)(o, l) / 1e3;
    return (0, i.getRoundingMethod)(u == null ? void 0 : u.roundingMethod)(d);
  }
  e.exports = t.default;
})(Yv, Yv.exports);
var oc = Yv.exports, Wv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(vb), n = r(re), i = ss;
  function s(o, l, u) {
    (0, n.default)(2, arguments);
    var d = (0, a.default)(o, l) / 7;
    return (0, i.getRoundingMethod)(u == null ? void 0 : u.roundingMethod)(d);
  }
  e.exports = t.default;
})(Wv, Wv.exports);
var f$ = Wv.exports, Gv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(pb), i = r(Rs), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, a.default)(l), f = (0, a.default)(u), c = (0, i.default)(d, f), p = Math.abs((0, n.default)(d, f));
    d.setFullYear(1584), f.setFullYear(1584);
    var v = (0, i.default)(d, f) === -c, h = c * (p - Number(v));
    return h === 0 ? 0 : h;
  }
  e.exports = t.default;
})(Gv, Gv.exports);
var uE = Gv.exports, Xv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    var l;
    (0, n.default)(1, arguments);
    var u = s || {}, d = (0, a.default)(u.start), f = (0, a.default)(u.end), c = f.getTime();
    if (!(d.getTime() <= c))
      throw new RangeError("Invalid interval");
    var p = [], v = d;
    v.setHours(0, 0, 0, 0);
    var h = Number((l = o == null ? void 0 : o.step) !== null && l !== void 0 ? l : 1);
    if (h < 1 || isNaN(h))
      throw new RangeError("`options.step` must be a number greater than 1");
    for (; v.getTime() <= c; )
      p.push((0, a.default)(v)), v.setDate(v.getDate() + h), v.setHours(0, 0, 0, 0);
    return p;
  }
  e.exports = t.default;
})(Xv, Xv.exports);
var dE = Xv.exports, Kv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(ob), n = r(Ce), i = r(re);
  function s(o, l) {
    var u;
    (0, i.default)(1, arguments);
    var d = o || {}, f = (0, n.default)(d.start), c = (0, n.default)(d.end), p = f.getTime(), v = c.getTime();
    if (!(p <= v))
      throw new RangeError("Invalid interval");
    var h = [], g = f;
    g.setMinutes(0, 0, 0);
    var m = Number((u = l == null ? void 0 : l.step) !== null && u !== void 0 ? u : 1);
    if (m < 1 || isNaN(m))
      throw new RangeError("`options.step` must be a number greater than 1");
    for (; g.getTime() <= v; )
      h.push((0, n.default)(g)), g = (0, a.default)(g, m);
    return h;
  }
  e.exports = t.default;
})(Kv, Kv.exports);
var p$ = Kv.exports, Jv = { exports: {} }, Qv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setSeconds(0, 0), o;
  }
  e.exports = t.default;
})(Qv, Qv.exports);
var yb = Qv.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(lb), n = r(Ce), i = r(yb), s = r(re);
  function o(l, u) {
    var d;
    (0, s.default)(1, arguments);
    var f = (0, i.default)((0, n.default)(l.start)), c = (0, n.default)(l.end), p = f.getTime(), v = c.getTime();
    if (p >= v)
      throw new RangeError("Invalid interval");
    var h = [], g = f, m = Number((d = u == null ? void 0 : u.step) !== null && d !== void 0 ? d : 1);
    if (m < 1 || isNaN(m))
      throw new RangeError("`options.step` must be a number equal to or greater than 1");
    for (; g.getTime() <= v; )
      h.push((0, n.default)(g)), g = (0, a.default)(g, m);
    return h;
  }
  e.exports = t.default;
})(Jv, Jv.exports);
var v$ = Jv.exports, Zv = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = s || {}, l = (0, a.default)(o.start), u = (0, a.default)(o.end), d = u.getTime(), f = [];
    if (!(l.getTime() <= d))
      throw new RangeError("Invalid interval");
    var c = l;
    for (c.setHours(0, 0, 0, 0), c.setDate(1); c.getTime() <= d; )
      f.push((0, a.default)(c)), c.setMonth(c.getMonth() + 1);
    return f;
  }
  e.exports = t.default;
})(Zv, Zv.exports);
var m$ = Zv.exports, em = { exports: {} }, tm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth(), u = l - l % 3;
    return o.setMonth(u, 1), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(tm, tm.exports);
var _b = tm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(ub), n = r(_b), i = r(Ce), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    var u = l || {}, d = (0, i.default)(u.start), f = (0, i.default)(u.end), c = f.getTime();
    if (!(d.getTime() <= c))
      throw new RangeError("Invalid interval");
    var p = (0, n.default)(d), v = (0, n.default)(f);
    c = v.getTime();
    for (var h = [], g = p; g.getTime() <= c; )
      h.push((0, i.default)(g)), g = (0, a.default)(g, 1);
    return h;
  }
  e.exports = t.default;
})(em, em.exports);
var h$ = em.exports, rm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(nc), n = r(as), i = r(Ce), s = r(re);
  function o(l, u) {
    (0, s.default)(1, arguments);
    var d = l || {}, f = (0, i.default)(d.start), c = (0, i.default)(d.end), p = c.getTime();
    if (!(f.getTime() <= p))
      throw new RangeError("Invalid interval");
    var v = (0, n.default)(f, u), h = (0, n.default)(c, u);
    v.setHours(15), h.setHours(15), p = h.getTime();
    for (var g = [], m = v; m.getTime() <= p; )
      m.setHours(0), g.push((0, i.default)(m)), m = (0, a.default)(m, 1), m.setHours(15);
    return g;
  }
  e.exports = t.default;
})(rm, rm.exports);
var g$ = rm.exports, am = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(dE), n = r(sb), i = r(rc), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    for (var u = (0, a.default)(l), d = [], f = 0; f < u.length; ) {
      var c = u[f++];
      (0, i.default)(c) && (d.push(c), (0, n.default)(c) && (f = f + 5));
    }
    return d;
  }
  e.exports = t.default;
})(am, am.exports);
var xb = am.exports, nm = { exports: {} }, im = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setDate(1), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(im, im.exports);
var lc = im.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(xb), n = r(lc), i = r(bb), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    var u = (0, n.default)(l);
    if (isNaN(u.getTime()))
      throw new RangeError("The passed date is invalid");
    var d = (0, i.default)(l);
    return (0, a.default)({
      start: u,
      end: d
    });
  }
  e.exports = t.default;
})(nm, nm.exports);
var b$ = nm.exports, sm = { exports: {} }, om = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear();
    return o.setFullYear(l + 1, 0, 0), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(om, om.exports);
var cE = om.exports, lm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(o.getFullYear(), 0, 1), l.setHours(0, 0, 0, 0), l;
  }
  e.exports = t.default;
})(lm, lm.exports);
var wb = lm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(xb), n = r(cE), i = r(wb), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    var u = (0, i.default)(l), d = (0, n.default)(l);
    return (0, a.default)({
      start: u,
      end: d
    });
  }
  e.exports = t.default;
})(sm, sm.exports);
var y$ = sm.exports, um = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = s || {}, l = (0, a.default)(o.start), u = (0, a.default)(o.end), d = u.getTime();
    if (!(l.getTime() <= d))
      throw new RangeError("Invalid interval");
    var f = [], c = l;
    for (c.setHours(0, 0, 0, 0), c.setMonth(0, 1); c.getTime() <= d; )
      f.push((0, a.default)(c)), c.setFullYear(c.getFullYear() + 1);
    return f;
  }
  e.exports = t.default;
})(um, um.exports);
var _$ = um.exports, dm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear(), u = 9 + Math.floor(l / 10) * 10;
    return o.setFullYear(u, 11, 31), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(dm, dm.exports);
var x$ = dm.exports, cm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setMinutes(59, 59, 999), o;
  }
  e.exports = t.default;
})(cm, cm.exports);
var w$ = cm.exports, fm = { exports: {} }, pm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = Lr, n = r(Ce), i = r(pt), s = r(re);
  function o(l, u) {
    var d, f, c, p, v, h, g, m;
    (0, s.default)(1, arguments);
    var b = (0, a.getDefaultOptions)(), y = (0, i.default)((d = (f = (c = (p = u == null ? void 0 : u.weekStartsOn) !== null && p !== void 0 ? p : u == null || (v = u.locale) === null || v === void 0 || (h = v.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && c !== void 0 ? c : b.weekStartsOn) !== null && f !== void 0 ? f : (g = b.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(y >= 0 && y <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = (0, n.default)(l), x = _.getDay(), w = (x < y ? -7 : 0) + 6 - (x - y);
    return _.setDate(_.getDate() + w), _.setHours(23, 59, 59, 999), _;
  }
  e.exports = t.default;
})(pm, pm.exports);
var fE = pm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(fE), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, {
      weekStartsOn: 1
    });
  }
  e.exports = t.default;
})(fm, fm.exports);
var T$ = fm.exports, vm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Mo), n = r(Ls), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o), u = /* @__PURE__ */ new Date(0);
    u.setFullYear(l + 1, 0, 4), u.setHours(0, 0, 0, 0);
    var d = (0, n.default)(u);
    return d.setMilliseconds(d.getMilliseconds() - 1), d;
  }
  e.exports = t.default;
})(vm, vm.exports);
var S$ = vm.exports, mm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setSeconds(59, 999), o;
  }
  e.exports = t.default;
})(mm, mm.exports);
var E$ = mm.exports, hm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth(), u = l - l % 3 + 3;
    return o.setMonth(u, 0), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(hm, hm.exports);
var O$ = hm.exports, gm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setMilliseconds(999), o;
  }
  e.exports = t.default;
})(gm, gm.exports);
var C$ = gm.exports, bm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(gb);
  function n() {
    return (0, a.default)(Date.now());
  }
  e.exports = t.default;
})(bm, bm.exports);
var k$ = bm.exports, ym = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var a = /* @__PURE__ */ new Date(), n = a.getFullYear(), i = a.getMonth(), s = a.getDate(), o = /* @__PURE__ */ new Date(0);
    return o.setFullYear(n, i, s + 1), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(ym, ym.exports);
var P$ = ym.exports, _m = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var a = /* @__PURE__ */ new Date(), n = a.getFullYear(), i = a.getMonth(), s = a.getDate(), o = /* @__PURE__ */ new Date(0);
    return o.setFullYear(n, i, s - 1), o.setHours(23, 59, 59, 999), o;
  }
  e.exports = t.default;
})(_m, _m.exports);
var M$ = _m.exports, xm = { exports: {} }, wm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(xu), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})(wm, wm.exports);
var Su = wm.exports, Tm = { exports: {} }, Sm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(re), i = 864e5;
  function s(o) {
    (0, n.default)(1, arguments);
    var l = (0, a.default)(o), u = l.getTime();
    l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
    var d = l.getTime(), f = u - d;
    return Math.floor(f / i) + 1;
  }
  e.exports = t.default;
})(Sm, Sm.exports);
var A$ = Sm.exports, Em = { exports: {} }, Om = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = 1, l = (0, a.default)(s), u = l.getUTCDay(), d = (u < o ? 7 : 0) + u - o;
    return l.setUTCDate(l.getUTCDate() - d), l.setUTCHours(0, 0, 0, 0), l;
  }
  e.exports = t.default;
})(Om, Om.exports);
var Eu = Om.exports, Cm = { exports: {} }, km = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(re), i = r(Eu);
  function s(o) {
    (0, n.default)(1, arguments);
    var l = (0, a.default)(o), u = l.getUTCFullYear(), d = /* @__PURE__ */ new Date(0);
    d.setUTCFullYear(u + 1, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var f = (0, i.default)(d), c = /* @__PURE__ */ new Date(0);
    c.setUTCFullYear(u, 0, 4), c.setUTCHours(0, 0, 0, 0);
    var p = (0, i.default)(c);
    return l.getTime() >= f.getTime() ? u + 1 : l.getTime() >= p.getTime() ? u : u - 1;
  }
  e.exports = t.default;
})(km, km.exports);
var pE = km.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pE), n = r(Eu), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(l, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var d = (0, n.default)(u);
    return d;
  }
  e.exports = t.default;
})(Cm, Cm.exports);
var D$ = Cm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(Eu), i = r(D$), s = r(re), o = 6048e5;
  function l(u) {
    (0, s.default)(1, arguments);
    var d = (0, a.default)(u), f = (0, n.default)(d).getTime() - (0, i.default)(d).getTime();
    return Math.round(f / o) + 1;
  }
  e.exports = t.default;
})(Em, Em.exports);
var vE = Em.exports, Pm = { exports: {} }, Mm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(re), i = r(pt), s = Lr;
  function o(l, u) {
    var d, f, c, p, v, h, g, m;
    (0, n.default)(1, arguments);
    var b = (0, s.getDefaultOptions)(), y = (0, i.default)((d = (f = (c = (p = u == null ? void 0 : u.weekStartsOn) !== null && p !== void 0 ? p : u == null || (v = u.locale) === null || v === void 0 || (h = v.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && c !== void 0 ? c : b.weekStartsOn) !== null && f !== void 0 ? f : (g = b.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(y >= 0 && y <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = (0, a.default)(l), x = _.getUTCDay(), w = (x < y ? 7 : 0) + x - y;
    return _.setUTCDate(_.getUTCDate() - w), _.setUTCHours(0, 0, 0, 0), _;
  }
  e.exports = t.default;
})(Mm, Mm.exports);
var Ou = Mm.exports, Am = { exports: {} }, Dm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(re), i = r(Ou), s = r(pt), o = Lr;
  function l(u, d) {
    var f, c, p, v, h, g, m, b;
    (0, n.default)(1, arguments);
    var y = (0, a.default)(u), _ = y.getUTCFullYear(), x = (0, o.getDefaultOptions)(), w = (0, s.default)((f = (c = (p = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (h = d.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && p !== void 0 ? p : x.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = x.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && f !== void 0 ? f : 1);
    if (!(w >= 1 && w <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var k = /* @__PURE__ */ new Date(0);
    k.setUTCFullYear(_ + 1, 0, w), k.setUTCHours(0, 0, 0, 0);
    var S = (0, i.default)(k, d), P = /* @__PURE__ */ new Date(0);
    P.setUTCFullYear(_, 0, w), P.setUTCHours(0, 0, 0, 0);
    var A = (0, i.default)(P, d);
    return y.getTime() >= S.getTime() ? _ + 1 : y.getTime() >= A.getTime() ? _ : _ - 1;
  }
  e.exports = t.default;
})(Dm, Dm.exports);
var Tb = Dm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Tb), n = r(re), i = r(Ou), s = r(pt), o = Lr;
  function l(u, d) {
    var f, c, p, v, h, g, m, b;
    (0, n.default)(1, arguments);
    var y = (0, o.getDefaultOptions)(), _ = (0, s.default)((f = (c = (p = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (h = d.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && p !== void 0 ? p : y.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = y.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && f !== void 0 ? f : 1), x = (0, a.default)(u, d), w = /* @__PURE__ */ new Date(0);
    w.setUTCFullYear(x, 0, _), w.setUTCHours(0, 0, 0, 0);
    var k = (0, i.default)(w, d);
    return k;
  }
  e.exports = t.default;
})(Am, Am.exports);
var I$ = Am.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(Ou), i = r(I$), s = r(re), o = 6048e5;
  function l(u, d) {
    (0, s.default)(1, arguments);
    var f = (0, a.default)(u), c = (0, n.default)(f, d).getTime() - (0, i.default)(f, d).getTime();
    return Math.round(c / o) + 1;
  }
  e.exports = t.default;
})(Pm, Pm.exports);
var mE = Pm.exports, Im = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n) {
    for (var i = a < 0 ? "-" : "", s = Math.abs(a).toString(); s.length < n; )
      s = "0" + s;
    return i + s;
  }
  e.exports = t.default;
})(Im, Im.exports);
var Ao = Im.exports, Nm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(Ao), n = {
    // Year
    y: function(o, l) {
      var u = o.getUTCFullYear(), d = u > 0 ? u : 1 - u;
      return (0, a.default)(l === "yy" ? d % 100 : d, l.length);
    },
    // Month
    M: function(o, l) {
      var u = o.getUTCMonth();
      return l === "M" ? String(u + 1) : (0, a.default)(u + 1, 2);
    },
    // Day of the month
    d: function(o, l) {
      return (0, a.default)(o.getUTCDate(), l.length);
    },
    // AM or PM
    a: function(o, l) {
      var u = o.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (l) {
        case "a":
        case "aa":
          return u.toUpperCase();
        case "aaa":
          return u;
        case "aaaaa":
          return u[0];
        case "aaaa":
        default:
          return u === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(o, l) {
      return (0, a.default)(o.getUTCHours() % 12 || 12, l.length);
    },
    // Hour [0-23]
    H: function(o, l) {
      return (0, a.default)(o.getUTCHours(), l.length);
    },
    // Minute
    m: function(o, l) {
      return (0, a.default)(o.getUTCMinutes(), l.length);
    },
    // Second
    s: function(o, l) {
      return (0, a.default)(o.getUTCSeconds(), l.length);
    },
    // Fraction of second
    S: function(o, l) {
      var u = l.length, d = o.getUTCMilliseconds(), f = Math.floor(d * Math.pow(10, u - 3));
      return (0, a.default)(f, l.length);
    }
  }, i = n;
  t.default = i, e.exports = t.default;
})(Nm, Nm.exports);
var hE = Nm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(A$), n = r(vE), i = r(pE), s = r(mE), o = r(Tb), l = r(Ao), u = r(hE), d = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, f = {
    // Era
    G: function(m, b, y) {
      var _ = m.getUTCFullYear() > 0 ? 1 : 0;
      switch (b) {
        case "G":
        case "GG":
        case "GGG":
          return y.era(_, {
            width: "abbreviated"
          });
        case "GGGGG":
          return y.era(_, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return y.era(_, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(m, b, y) {
      if (b === "yo") {
        var _ = m.getUTCFullYear(), x = _ > 0 ? _ : 1 - _;
        return y.ordinalNumber(x, {
          unit: "year"
        });
      }
      return u.default.y(m, b);
    },
    // Local week-numbering year
    Y: function(m, b, y, _) {
      var x = (0, o.default)(m, _), w = x > 0 ? x : 1 - x;
      if (b === "YY") {
        var k = w % 100;
        return (0, l.default)(k, 2);
      }
      return b === "Yo" ? y.ordinalNumber(w, {
        unit: "year"
      }) : (0, l.default)(w, b.length);
    },
    // ISO week-numbering year
    R: function(m, b) {
      var y = (0, i.default)(m);
      return (0, l.default)(y, b.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(m, b) {
      var y = m.getUTCFullYear();
      return (0, l.default)(y, b.length);
    },
    // Quarter
    Q: function(m, b, y) {
      var _ = Math.ceil((m.getUTCMonth() + 1) / 3);
      switch (b) {
        case "Q":
          return String(_);
        case "QQ":
          return (0, l.default)(_, 2);
        case "Qo":
          return y.ordinalNumber(_, {
            unit: "quarter"
          });
        case "QQQ":
          return y.quarter(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return y.quarter(_, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return y.quarter(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(m, b, y) {
      var _ = Math.ceil((m.getUTCMonth() + 1) / 3);
      switch (b) {
        case "q":
          return String(_);
        case "qq":
          return (0, l.default)(_, 2);
        case "qo":
          return y.ordinalNumber(_, {
            unit: "quarter"
          });
        case "qqq":
          return y.quarter(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return y.quarter(_, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return y.quarter(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(m, b, y) {
      var _ = m.getUTCMonth();
      switch (b) {
        case "M":
        case "MM":
          return u.default.M(m, b);
        case "Mo":
          return y.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "MMM":
          return y.month(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return y.month(_, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return y.month(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(m, b, y) {
      var _ = m.getUTCMonth();
      switch (b) {
        case "L":
          return String(_ + 1);
        case "LL":
          return (0, l.default)(_ + 1, 2);
        case "Lo":
          return y.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "LLL":
          return y.month(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return y.month(_, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return y.month(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(m, b, y, _) {
      var x = (0, s.default)(m, _);
      return b === "wo" ? y.ordinalNumber(x, {
        unit: "week"
      }) : (0, l.default)(x, b.length);
    },
    // ISO week of year
    I: function(m, b, y) {
      var _ = (0, n.default)(m);
      return b === "Io" ? y.ordinalNumber(_, {
        unit: "week"
      }) : (0, l.default)(_, b.length);
    },
    // Day of the month
    d: function(m, b, y) {
      return b === "do" ? y.ordinalNumber(m.getUTCDate(), {
        unit: "date"
      }) : u.default.d(m, b);
    },
    // Day of year
    D: function(m, b, y) {
      var _ = (0, a.default)(m);
      return b === "Do" ? y.ordinalNumber(_, {
        unit: "dayOfYear"
      }) : (0, l.default)(_, b.length);
    },
    // Day of week
    E: function(m, b, y) {
      var _ = m.getUTCDay();
      switch (b) {
        case "E":
        case "EE":
        case "EEE":
          return y.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return y.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return y.day(_, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return y.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(m, b, y, _) {
      var x = m.getUTCDay(), w = (x - _.weekStartsOn + 8) % 7 || 7;
      switch (b) {
        case "e":
          return String(w);
        case "ee":
          return (0, l.default)(w, 2);
        case "eo":
          return y.ordinalNumber(w, {
            unit: "day"
          });
        case "eee":
          return y.day(x, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return y.day(x, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return y.day(x, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return y.day(x, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(m, b, y, _) {
      var x = m.getUTCDay(), w = (x - _.weekStartsOn + 8) % 7 || 7;
      switch (b) {
        case "c":
          return String(w);
        case "cc":
          return (0, l.default)(w, b.length);
        case "co":
          return y.ordinalNumber(w, {
            unit: "day"
          });
        case "ccc":
          return y.day(x, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return y.day(x, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return y.day(x, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return y.day(x, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(m, b, y) {
      var _ = m.getUTCDay(), x = _ === 0 ? 7 : _;
      switch (b) {
        case "i":
          return String(x);
        case "ii":
          return (0, l.default)(x, b.length);
        case "io":
          return y.ordinalNumber(x, {
            unit: "day"
          });
        case "iii":
          return y.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return y.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return y.day(_, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return y.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(m, b, y) {
      var _ = m.getUTCHours(), x = _ / 12 >= 1 ? "pm" : "am";
      switch (b) {
        case "a":
        case "aa":
          return y.dayPeriod(x, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return y.dayPeriod(x, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return y.dayPeriod(x, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return y.dayPeriod(x, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(m, b, y) {
      var _ = m.getUTCHours(), x;
      switch (_ === 12 ? x = d.noon : _ === 0 ? x = d.midnight : x = _ / 12 >= 1 ? "pm" : "am", b) {
        case "b":
        case "bb":
          return y.dayPeriod(x, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return y.dayPeriod(x, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return y.dayPeriod(x, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return y.dayPeriod(x, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(m, b, y) {
      var _ = m.getUTCHours(), x;
      switch (_ >= 17 ? x = d.evening : _ >= 12 ? x = d.afternoon : _ >= 4 ? x = d.morning : x = d.night, b) {
        case "B":
        case "BB":
        case "BBB":
          return y.dayPeriod(x, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return y.dayPeriod(x, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return y.dayPeriod(x, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(m, b, y) {
      if (b === "ho") {
        var _ = m.getUTCHours() % 12;
        return _ === 0 && (_ = 12), y.ordinalNumber(_, {
          unit: "hour"
        });
      }
      return u.default.h(m, b);
    },
    // Hour [0-23]
    H: function(m, b, y) {
      return b === "Ho" ? y.ordinalNumber(m.getUTCHours(), {
        unit: "hour"
      }) : u.default.H(m, b);
    },
    // Hour [0-11]
    K: function(m, b, y) {
      var _ = m.getUTCHours() % 12;
      return b === "Ko" ? y.ordinalNumber(_, {
        unit: "hour"
      }) : (0, l.default)(_, b.length);
    },
    // Hour [1-24]
    k: function(m, b, y) {
      var _ = m.getUTCHours();
      return _ === 0 && (_ = 24), b === "ko" ? y.ordinalNumber(_, {
        unit: "hour"
      }) : (0, l.default)(_, b.length);
    },
    // Minute
    m: function(m, b, y) {
      return b === "mo" ? y.ordinalNumber(m.getUTCMinutes(), {
        unit: "minute"
      }) : u.default.m(m, b);
    },
    // Second
    s: function(m, b, y) {
      return b === "so" ? y.ordinalNumber(m.getUTCSeconds(), {
        unit: "second"
      }) : u.default.s(m, b);
    },
    // Fraction of second
    S: function(m, b) {
      return u.default.S(m, b);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(m, b, y, _) {
      var x = _._originalDate || m, w = x.getTimezoneOffset();
      if (w === 0)
        return "Z";
      switch (b) {
        case "X":
          return p(w);
        case "XXXX":
        case "XX":
          return v(w);
        case "XXXXX":
        case "XXX":
        default:
          return v(w, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(m, b, y, _) {
      var x = _._originalDate || m, w = x.getTimezoneOffset();
      switch (b) {
        case "x":
          return p(w);
        case "xxxx":
        case "xx":
          return v(w);
        case "xxxxx":
        case "xxx":
        default:
          return v(w, ":");
      }
    },
    // Timezone (GMT)
    O: function(m, b, y, _) {
      var x = _._originalDate || m, w = x.getTimezoneOffset();
      switch (b) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + c(w, ":");
        case "OOOO":
        default:
          return "GMT" + v(w, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(m, b, y, _) {
      var x = _._originalDate || m, w = x.getTimezoneOffset();
      switch (b) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + c(w, ":");
        case "zzzz":
        default:
          return "GMT" + v(w, ":");
      }
    },
    // Seconds timestamp
    t: function(m, b, y, _) {
      var x = _._originalDate || m, w = Math.floor(x.getTime() / 1e3);
      return (0, l.default)(w, b.length);
    },
    // Milliseconds timestamp
    T: function(m, b, y, _) {
      var x = _._originalDate || m, w = x.getTime();
      return (0, l.default)(w, b.length);
    }
  };
  function c(g, m) {
    var b = g > 0 ? "-" : "+", y = Math.abs(g), _ = Math.floor(y / 60), x = y % 60;
    if (x === 0)
      return b + String(_);
    var w = m || "";
    return b + String(_) + w + (0, l.default)(x, 2);
  }
  function p(g, m) {
    if (g % 60 === 0) {
      var b = g > 0 ? "-" : "+";
      return b + (0, l.default)(Math.abs(g) / 60, 2);
    }
    return v(g, m);
  }
  function v(g, m) {
    var b = m || "", y = g > 0 ? "-" : "+", _ = Math.abs(g), x = (0, l.default)(Math.floor(_ / 60), 2), w = (0, l.default)(_ % 60, 2);
    return y + x + b + w;
  }
  var h = f;
  t.default = h, e.exports = t.default;
})(Tm, Tm.exports);
var N$ = Tm.exports, $m = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(l, u) {
    switch (l) {
      case "P":
        return u.date({
          width: "short"
        });
      case "PP":
        return u.date({
          width: "medium"
        });
      case "PPP":
        return u.date({
          width: "long"
        });
      case "PPPP":
      default:
        return u.date({
          width: "full"
        });
    }
  }, a = function(l, u) {
    switch (l) {
      case "p":
        return u.time({
          width: "short"
        });
      case "pp":
        return u.time({
          width: "medium"
        });
      case "ppp":
        return u.time({
          width: "long"
        });
      case "pppp":
      default:
        return u.time({
          width: "full"
        });
    }
  }, n = function(l, u) {
    var d = l.match(/(P+)(p+)?/) || [], f = d[1], c = d[2];
    if (!c)
      return r(l, u);
    var p;
    switch (f) {
      case "P":
        p = u.dateTime({
          width: "short"
        });
        break;
      case "PP":
        p = u.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        p = u.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        p = u.dateTime({
          width: "full"
        });
        break;
    }
    return p.replace("{{date}}", r(f, u)).replace("{{time}}", a(c, u));
  }, i = {
    p: a,
    P: n
  }, s = i;
  t.default = s, e.exports = t.default;
})($m, $m.exports);
var gE = $m.exports, Do = {};
Object.defineProperty(Do, "__esModule", {
  value: !0
});
Do.isProtectedDayOfYearToken = R$;
Do.isProtectedWeekYearToken = j$;
Do.throwProtectedError = F$;
var $$ = ["D", "DD"], L$ = ["YY", "YYYY"];
function R$(e) {
  return $$.indexOf(e) !== -1;
}
function j$(e) {
  return L$.indexOf(e) !== -1;
}
function F$(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Lm = { exports: {} }, Rm = { exports: {} }, jm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, a = function(s, o, l) {
    var u, d = r[s];
    return typeof d == "string" ? u = d : o === 1 ? u = d.one : u = d.other.replace("{{count}}", o.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + u : u + " ago" : u;
  }, n = a;
  t.default = n, e.exports = t.default;
})(jm, jm.exports);
var B$ = jm.exports, Fm = { exports: {} }, Bm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = n.width ? String(n.width) : a.defaultWidth, s = a.formats[i] || a.formats[a.defaultWidth];
      return s;
    };
  }
  e.exports = t.default;
})(Bm, Bm.exports);
var q$ = Bm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(q$), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, l = o;
  t.default = l, e.exports = t.default;
})(Fm, Fm.exports);
var H$ = Fm.exports, qm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, a = function(s, o, l, u) {
    return r[s];
  }, n = a;
  t.default = n, e.exports = t.default;
})(qm, qm.exports);
var V$ = qm.exports, Hm = { exports: {} }, Vm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    return function(n, i) {
      var s = i != null && i.context ? String(i.context) : "standalone", o;
      if (s === "formatting" && a.formattingValues) {
        var l = a.defaultFormattingWidth || a.defaultWidth, u = i != null && i.width ? String(i.width) : l;
        o = a.formattingValues[u] || a.formattingValues[l];
      } else {
        var d = a.defaultWidth, f = i != null && i.width ? String(i.width) : a.defaultWidth;
        o = a.values[f] || a.values[d];
      }
      var c = a.argumentCallback ? a.argumentCallback(n) : n;
      return o[c];
    };
  }
  e.exports = t.default;
})(Vm, Vm.exports);
var U$ = Vm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(U$), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, o = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, d = function(v, h) {
    var g = Number(v), m = g % 100;
    if (m > 20 || m < 10)
      switch (m % 10) {
        case 1:
          return g + "st";
        case 2:
          return g + "nd";
        case 3:
          return g + "rd";
      }
    return g + "th";
  }, f = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, c = f;
  t.default = c, e.exports = t.default;
})(Hm, Hm.exports);
var z$ = Hm.exports, Um = { exports: {} }, zm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(i) {
    return function(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = o.width, u = l && i.matchPatterns[l] || i.matchPatterns[i.defaultMatchWidth], d = s.match(u);
      if (!d)
        return null;
      var f = d[0], c = l && i.parsePatterns[l] || i.parsePatterns[i.defaultParseWidth], p = Array.isArray(c) ? n(c, function(g) {
        return g.test(f);
      }) : a(c, function(g) {
        return g.test(f);
      }), v;
      v = i.valueCallback ? i.valueCallback(p) : p, v = o.valueCallback ? o.valueCallback(v) : v;
      var h = s.slice(f.length);
      return {
        value: v,
        rest: h
      };
    };
  }
  function a(i, s) {
    for (var o in i)
      if (i.hasOwnProperty(o) && s(i[o]))
        return o;
  }
  function n(i, s) {
    for (var o = 0; o < i.length; o++)
      if (s(i[o]))
        return o;
  }
  e.exports = t.default;
})(zm, zm.exports);
var Y$ = zm.exports, Ym = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    return function(n) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(a.matchPattern);
      if (!s)
        return null;
      var o = s[0], l = n.match(a.parsePattern);
      if (!l)
        return null;
      var u = a.valueCallback ? a.valueCallback(l[0]) : l[0];
      u = i.valueCallback ? i.valueCallback(u) : u;
      var d = n.slice(o.length);
      return {
        value: u,
        rest: d
      };
    };
  }
  e.exports = t.default;
})(Ym, Ym.exports);
var W$ = Ym.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(Y$), n = r(W$), i = /^(\d+)(th|st|nd|rd)?/i, s = /\d+/i, o = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, l = {
    any: [/^b/i, /^(a|c)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, c = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, p = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, h = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, g = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, m = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(_) {
        return parseInt(_, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(_) {
        return _ + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: c,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: p,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: h,
      defaultMatchWidth: "any",
      parsePatterns: g,
      defaultParseWidth: "any"
    })
  }, b = m;
  t.default = b, e.exports = t.default;
})(Um, Um.exports);
var G$ = Um.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(B$), n = r(H$), i = r(V$), s = r(z$), o = r(G$), l = {
    code: "en-US",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, u = l;
  t.default = u, e.exports = t.default;
})(Rm, Rm.exports);
var X$ = Rm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = r(X$), n = a.default;
  t.default = n, e.exports = t.default;
})(Lm, Lm.exports);
var Io = Lm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var a = r(is), n = r(Su), i = r(Ce), s = r(N$), o = r(gE), l = r(Li), u = Do, d = r(pt), f = r(re), c = Lr, p = r(Io), v = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, h = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, g = /^'([^]*?)'?$/, m = /''/g, b = /[a-zA-Z]/;
  function y(x, w, k) {
    var S, P, A, E, O, T, D, $, I, F, j, M, q, le, Z, G, H, W;
    (0, f.default)(2, arguments);
    var ie = String(w), we = (0, c.getDefaultOptions)(), Be = (S = (P = k == null ? void 0 : k.locale) !== null && P !== void 0 ? P : we.locale) !== null && S !== void 0 ? S : p.default, Ve = (0, d.default)((A = (E = (O = (T = k == null ? void 0 : k.firstWeekContainsDate) !== null && T !== void 0 ? T : k == null || (D = k.locale) === null || D === void 0 || ($ = D.options) === null || $ === void 0 ? void 0 : $.firstWeekContainsDate) !== null && O !== void 0 ? O : we.firstWeekContainsDate) !== null && E !== void 0 ? E : (I = we.locale) === null || I === void 0 || (F = I.options) === null || F === void 0 ? void 0 : F.firstWeekContainsDate) !== null && A !== void 0 ? A : 1);
    if (!(Ve >= 1 && Ve <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var et = (0, d.default)((j = (M = (q = (le = k == null ? void 0 : k.weekStartsOn) !== null && le !== void 0 ? le : k == null || (Z = k.locale) === null || Z === void 0 || (G = Z.options) === null || G === void 0 ? void 0 : G.weekStartsOn) !== null && q !== void 0 ? q : we.weekStartsOn) !== null && M !== void 0 ? M : (H = we.locale) === null || H === void 0 || (W = H.options) === null || W === void 0 ? void 0 : W.weekStartsOn) !== null && j !== void 0 ? j : 0);
    if (!(et >= 0 && et <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!Be.localize)
      throw new RangeError("locale must contain localize property");
    if (!Be.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var nt = (0, i.default)(x);
    if (!(0, a.default)(nt))
      throw new RangeError("Invalid time value");
    var xe = (0, l.default)(nt), J = (0, n.default)(nt, xe), se = {
      firstWeekContainsDate: Ve,
      weekStartsOn: et,
      locale: Be,
      _originalDate: nt
    }, _e = ie.match(h).map(function(Se) {
      var Re = Se[0];
      if (Re === "p" || Re === "P") {
        var rt = o.default[Re];
        return rt(Se, Be.formatLong);
      }
      return Se;
    }).join("").match(v).map(function(Se) {
      if (Se === "''")
        return "'";
      var Re = Se[0];
      if (Re === "'")
        return _(Se);
      var rt = s.default[Re];
      if (rt)
        return !(k != null && k.useAdditionalWeekYearTokens) && (0, u.isProtectedWeekYearToken)(Se) && (0, u.throwProtectedError)(Se, w, String(x)), !(k != null && k.useAdditionalDayOfYearTokens) && (0, u.isProtectedDayOfYearToken)(Se) && (0, u.throwProtectedError)(Se, w, String(x)), rt(J, Se, Be.localize, se);
      if (Re.match(b))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + Re + "`");
      return Se;
    }).join("");
    return _e;
  }
  function _(x) {
    var w = x.match(g);
    return w ? w[1].replace(m, "'") : x;
  }
  e.exports = t.default;
})(xm, xm.exports);
var bE = xm.exports, Wm = { exports: {} }, Gm = { exports: {} }, Xm = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n) {
    if (a == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (a[i] = n[i]);
    return a;
  }
  e.exports = t.default;
})(Xm, Xm.exports);
var Cu = Xm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(Cu);
  function n(i) {
    return (0, a.default)({}, i);
  }
  e.exports = t.default;
})(Gm, Gm.exports);
var yE = Gm.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = m;
  var a = Lr, n = r(Rs), i = r(sc), s = r(oc), o = r(Io), l = r(Ce), u = r(yE), d = r(Cu), f = r(Li), c = r(re), p = 1440, v = 2520, h = 43200, g = 86400;
  function m(b, y, _) {
    var x, w;
    (0, c.default)(2, arguments);
    var k = (0, a.getDefaultOptions)(), S = (x = (w = _ == null ? void 0 : _.locale) !== null && w !== void 0 ? w : k.locale) !== null && x !== void 0 ? x : o.default;
    if (!S.formatDistance)
      throw new RangeError("locale must contain formatDistance property");
    var P = (0, n.default)(b, y);
    if (isNaN(P))
      throw new RangeError("Invalid time value");
    var A = (0, d.default)((0, u.default)(_), {
      addSuffix: !!(_ != null && _.addSuffix),
      comparison: P
    }), E, O;
    P > 0 ? (E = (0, l.default)(y), O = (0, l.default)(b)) : (E = (0, l.default)(b), O = (0, l.default)(y));
    var T = (0, s.default)(O, E), D = ((0, f.default)(O) - (0, f.default)(E)) / 1e3, $ = Math.round((T - D) / 60), I;
    if ($ < 2)
      return _ != null && _.includeSeconds ? T < 5 ? S.formatDistance("lessThanXSeconds", 5, A) : T < 10 ? S.formatDistance("lessThanXSeconds", 10, A) : T < 20 ? S.formatDistance("lessThanXSeconds", 20, A) : T < 40 ? S.formatDistance("halfAMinute", 0, A) : T < 60 ? S.formatDistance("lessThanXMinutes", 1, A) : S.formatDistance("xMinutes", 1, A) : $ === 0 ? S.formatDistance("lessThanXMinutes", 1, A) : S.formatDistance("xMinutes", $, A);
    if ($ < 45)
      return S.formatDistance("xMinutes", $, A);
    if ($ < 90)
      return S.formatDistance("aboutXHours", 1, A);
    if ($ < p) {
      var F = Math.round($ / 60);
      return S.formatDistance("aboutXHours", F, A);
    } else {
      if ($ < v)
        return S.formatDistance("xDays", 1, A);
      if ($ < h) {
        var j = Math.round($ / p);
        return S.formatDistance("xDays", j, A);
      } else if ($ < g)
        return I = Math.round($ / h), S.formatDistance("aboutXMonths", I, A);
    }
    if (I = (0, i.default)(O, E), I < 12) {
      var M = Math.round($ / h);
      return S.formatDistance("xMonths", M, A);
    } else {
      var q = I % 12, le = Math.floor(I / 12);
      return q < 3 ? S.formatDistance("aboutXYears", le, A) : q < 9 ? S.formatDistance("overXYears", le, A) : S.formatDistance("almostXYears", le + 1, A);
    }
  }
  e.exports = t.default;
})(Wm, Wm.exports);
var _E = Wm.exports, Km = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = h;
  var a = Lr, n = r(Li), i = r(Rs), s = r(Ce), o = r(yE), l = r(Cu), u = r(Io), d = r(re), f = 1e3 * 60, c = 60 * 24, p = c * 30, v = c * 365;
  function h(g, m, b) {
    var y, _, x;
    (0, d.default)(2, arguments);
    var w = (0, a.getDefaultOptions)(), k = (y = (_ = b == null ? void 0 : b.locale) !== null && _ !== void 0 ? _ : w.locale) !== null && y !== void 0 ? y : u.default;
    if (!k.formatDistance)
      throw new RangeError("locale must contain localize.formatDistance property");
    var S = (0, i.default)(g, m);
    if (isNaN(S))
      throw new RangeError("Invalid time value");
    var P = (0, l.default)((0, o.default)(b), {
      addSuffix: !!(b != null && b.addSuffix),
      comparison: S
    }), A, E;
    S > 0 ? (A = (0, s.default)(m), E = (0, s.default)(g)) : (A = (0, s.default)(g), E = (0, s.default)(m));
    var O = String((x = b == null ? void 0 : b.roundingMethod) !== null && x !== void 0 ? x : "round"), T;
    if (O === "floor")
      T = Math.floor;
    else if (O === "ceil")
      T = Math.ceil;
    else if (O === "round")
      T = Math.round;
    else
      throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var D = E.getTime() - A.getTime(), $ = D / f, I = (0, n.default)(E) - (0, n.default)(A), F = (D - I) / f, j = b == null ? void 0 : b.unit, M;
    if (j ? M = String(j) : $ < 1 ? M = "second" : $ < 60 ? M = "minute" : $ < c ? M = "hour" : F < p ? M = "day" : F < v ? M = "month" : M = "year", M === "second") {
      var q = T(D / 1e3);
      return k.formatDistance("xSeconds", q, P);
    } else if (M === "minute") {
      var le = T($);
      return k.formatDistance("xMinutes", le, P);
    } else if (M === "hour") {
      var Z = T($ / 60);
      return k.formatDistance("xHours", Z, P);
    } else if (M === "day") {
      var G = T(F / c);
      return k.formatDistance("xDays", G, P);
    } else if (M === "month") {
      var H = T(F / p);
      return H === 12 && j !== "month" ? k.formatDistance("xYears", 1, P) : k.formatDistance("xMonths", H, P);
    } else if (M === "year") {
      var W = T(F / v);
      return k.formatDistance("xYears", W, P);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
  }
  e.exports = t.default;
})(Km, Km.exports);
var xE = Km.exports, Jm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(_E), n = r(re);
  function i(s, o) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now(), o);
  }
  e.exports = t.default;
})(Jm, Jm.exports);
var K$ = Jm.exports, Qm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(xE), n = r(re);
  function i(s, o) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now(), o);
  }
  e.exports = t.default;
})(Qm, Qm.exports);
var J$ = Qm.exports, Zm = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = Lr, n = r(Io), i = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
  function s(o, l) {
    var u, d, f, c, p;
    if (arguments.length < 1)
      throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var v = (0, a.getDefaultOptions)(), h = (u = (d = l == null ? void 0 : l.locale) !== null && d !== void 0 ? d : v.locale) !== null && u !== void 0 ? u : n.default, g = (f = l == null ? void 0 : l.format) !== null && f !== void 0 ? f : i, m = (c = l == null ? void 0 : l.zero) !== null && c !== void 0 ? c : !1, b = (p = l == null ? void 0 : l.delimiter) !== null && p !== void 0 ? p : " ";
    if (!h.formatDistance)
      return "";
    var y = g.reduce(function(_, x) {
      var w = "x".concat(x.replace(/(^.)/, function(S) {
        return S.toUpperCase();
      })), k = o[x];
      return typeof k == "number" && (m || o[x]) ? _.concat(h.formatDistance(w, k)) : _;
    }, []).join(b);
    return y;
  }
  e.exports = t.default;
})(Zm, Zm.exports);
var Q$ = Zm.exports, eh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(Ao), i = r(re);
  function s(o, l) {
    var u, d;
    (0, i.default)(1, arguments);
    var f = (0, a.default)(o);
    if (isNaN(f.getTime()))
      throw new RangeError("Invalid time value");
    var c = String((u = l == null ? void 0 : l.format) !== null && u !== void 0 ? u : "extended"), p = String((d = l == null ? void 0 : l.representation) !== null && d !== void 0 ? d : "complete");
    if (c !== "extended" && c !== "basic")
      throw new RangeError("format must be 'extended' or 'basic'");
    if (p !== "date" && p !== "time" && p !== "complete")
      throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var v = "", h = "", g = c === "extended" ? "-" : "", m = c === "extended" ? ":" : "";
    if (p !== "time") {
      var b = (0, n.default)(f.getDate(), 2), y = (0, n.default)(f.getMonth() + 1, 2), _ = (0, n.default)(f.getFullYear(), 4);
      v = "".concat(_).concat(g).concat(y).concat(g).concat(b);
    }
    if (p !== "date") {
      var x = f.getTimezoneOffset();
      if (x !== 0) {
        var w = Math.abs(x), k = (0, n.default)(Math.floor(w / 60), 2), S = (0, n.default)(w % 60, 2), P = x < 0 ? "+" : "-";
        h = "".concat(P).concat(k, ":").concat(S);
      } else
        h = "Z";
      var A = (0, n.default)(f.getHours(), 2), E = (0, n.default)(f.getMinutes(), 2), O = (0, n.default)(f.getSeconds(), 2), T = v === "" ? "" : "T", D = [A, E, O].join(m);
      v = "".concat(v).concat(T).concat(D).concat(h);
    }
    return v;
  }
  e.exports = t.default;
})(eh, eh.exports);
var Z$ = eh.exports, th = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(is), i = r(Ao);
  function s(o, l) {
    var u, d;
    if (arguments.length < 1)
      throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var f = (0, a.default)(o);
    if (!(0, n.default)(f))
      throw new RangeError("Invalid time value");
    var c = String((u = l == null ? void 0 : l.format) !== null && u !== void 0 ? u : "extended"), p = String((d = l == null ? void 0 : l.representation) !== null && d !== void 0 ? d : "complete");
    if (c !== "extended" && c !== "basic")
      throw new RangeError("format must be 'extended' or 'basic'");
    if (p !== "date" && p !== "time" && p !== "complete")
      throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var v = "", h = c === "extended" ? "-" : "", g = c === "extended" ? ":" : "";
    if (p !== "time") {
      var m = (0, i.default)(f.getDate(), 2), b = (0, i.default)(f.getMonth() + 1, 2), y = (0, i.default)(f.getFullYear(), 4);
      v = "".concat(y).concat(h).concat(b).concat(h).concat(m);
    }
    if (p !== "date") {
      var _ = (0, i.default)(f.getHours(), 2), x = (0, i.default)(f.getMinutes(), 2), w = (0, i.default)(f.getSeconds(), 2), k = v === "" ? "" : " ";
      v = "".concat(v).concat(k).concat(_).concat(g).concat(x).concat(g).concat(w);
    }
    return v;
  }
  e.exports = t.default;
})(th, th.exports);
var e8 = th.exports, rh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(On), n = r(re);
  function i(s) {
    if ((0, n.default)(1, arguments), (0, a.default)(s) !== "object")
      throw new Error("Duration must be an object");
    var o = s.years, l = o === void 0 ? 0 : o, u = s.months, d = u === void 0 ? 0 : u, f = s.days, c = f === void 0 ? 0 : f, p = s.hours, v = p === void 0 ? 0 : p, h = s.minutes, g = h === void 0 ? 0 : h, m = s.seconds, b = m === void 0 ? 0 : m;
    return "P".concat(l, "Y").concat(d, "M").concat(c, "DT").concat(v, "H").concat(g, "M").concat(b, "S");
  }
  e.exports = t.default;
})(rh, rh.exports);
var t8 = rh.exports, ah = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(is), i = r(Ao), s = r(pt);
  function o(l, u) {
    var d;
    if (arguments.length < 1)
      throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
    var f = (0, a.default)(l);
    if (!(0, n.default)(f))
      throw new RangeError("Invalid time value");
    var c = Number((d = u == null ? void 0 : u.fractionDigits) !== null && d !== void 0 ? d : 0);
    if (!(c >= 0 && c <= 3))
      throw new RangeError("fractionDigits must be between 0 and 3 inclusively");
    var p = (0, i.default)(f.getDate(), 2), v = (0, i.default)(f.getMonth() + 1, 2), h = f.getFullYear(), g = (0, i.default)(f.getHours(), 2), m = (0, i.default)(f.getMinutes(), 2), b = (0, i.default)(f.getSeconds(), 2), y = "";
    if (c > 0) {
      var _ = f.getMilliseconds(), x = Math.floor(_ * Math.pow(10, c - 3));
      y = "." + (0, i.default)(x, c);
    }
    var w = "", k = f.getTimezoneOffset();
    if (k !== 0) {
      var S = Math.abs(k), P = (0, i.default)((0, s.default)(S / 60), 2), A = (0, i.default)(S % 60, 2), E = k < 0 ? "+" : "-";
      w = "".concat(E).concat(P, ":").concat(A);
    } else
      w = "Z";
    return "".concat(h, "-").concat(v, "-").concat(p, "T").concat(g, ":").concat(m, ":").concat(b).concat(y).concat(w);
  }
  e.exports = t.default;
})(ah, ah.exports);
var r8 = ah.exports, nh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(is), i = r(Ao), s = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], o = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function l(u) {
    if (arguments.length < 1)
      throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
    var d = (0, a.default)(u);
    if (!(0, n.default)(d))
      throw new RangeError("Invalid time value");
    var f = s[d.getUTCDay()], c = (0, i.default)(d.getUTCDate(), 2), p = o[d.getUTCMonth()], v = d.getUTCFullYear(), h = (0, i.default)(d.getUTCHours(), 2), g = (0, i.default)(d.getUTCMinutes(), 2), m = (0, i.default)(d.getUTCSeconds(), 2);
    return "".concat(f, ", ").concat(c, " ").concat(p, " ").concat(v, " ").concat(h, ":").concat(g, ":").concat(m, " GMT");
  }
  e.exports = t.default;
})(nh, nh.exports);
var a8 = nh.exports, ih = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var a = Lr, n = r(ns), i = r(bE), s = r(Io), o = r(Su), l = r(Ce), u = r(Li), d = r(re), f = r(pt);
  function c(p, v, h) {
    var g, m, b, y, _, x, w, k, S, P;
    (0, d.default)(2, arguments);
    var A = (0, l.default)(p), E = (0, l.default)(v), O = (0, a.getDefaultOptions)(), T = (g = (m = h == null ? void 0 : h.locale) !== null && m !== void 0 ? m : O.locale) !== null && g !== void 0 ? g : s.default, D = (0, f.default)((b = (y = (_ = (x = h == null ? void 0 : h.weekStartsOn) !== null && x !== void 0 ? x : h == null || (w = h.locale) === null || w === void 0 || (k = w.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && _ !== void 0 ? _ : O.weekStartsOn) !== null && y !== void 0 ? y : (S = O.locale) === null || S === void 0 || (P = S.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && b !== void 0 ? b : 0);
    if (!T.localize)
      throw new RangeError("locale must contain localize property");
    if (!T.formatLong)
      throw new RangeError("locale must contain formatLong property");
    if (!T.formatRelative)
      throw new RangeError("locale must contain formatRelative property");
    var $ = (0, n.default)(A, E);
    if (isNaN($))
      throw new RangeError("Invalid time value");
    var I;
    $ < -6 ? I = "other" : $ < -1 ? I = "lastWeek" : $ < 0 ? I = "yesterday" : $ < 1 ? I = "today" : $ < 2 ? I = "tomorrow" : $ < 7 ? I = "nextWeek" : I = "other";
    var F = (0, o.default)(A, (0, u.default)(A)), j = (0, o.default)(E, (0, u.default)(E)), M = T.formatRelative(I, F, j, {
      locale: T,
      weekStartsOn: D
    });
    return (0, i.default)(A, M, {
      locale: T,
      weekStartsOn: D
    });
  }
  e.exports = t.default;
})(ih, ih.exports);
var n8 = ih.exports, sh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(pt), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, n.default)(o);
    return (0, a.default)(l * 1e3);
  }
  e.exports = t.default;
})(sh, sh.exports);
var i8 = sh.exports, oh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getDate();
    return l;
  }
  e.exports = t.default;
})(oh, oh.exports);
var wE = oh.exports, lh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getDay();
    return l;
  }
  e.exports = t.default;
})(lh, lh.exports);
var uc = lh.exports, uh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(wb), i = r(ns), s = r(re);
  function o(l) {
    (0, s.default)(1, arguments);
    var u = (0, a.default)(l), d = (0, i.default)(u, (0, n.default)(u)), f = d + 1;
    return f;
  }
  e.exports = t.default;
})(uh, uh.exports);
var s8 = uh.exports, dh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear(), u = o.getMonth(), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(l, u + 1, 0), d.setHours(0, 0, 0, 0), d.getDate();
  }
  e.exports = t.default;
})(dh, dh.exports);
var TE = dh.exports, ch = { exports: {} }, fh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear();
    return l % 400 === 0 || l % 4 === 0 && l % 100 !== 0;
  }
  e.exports = t.default;
})(fh, fh.exports);
var SE = fh.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(SE), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o);
    return String(new Date(l)) === "Invalid Date" ? NaN : (0, n.default)(l) ? 366 : 365;
  }
  e.exports = t.default;
})(ch, ch.exports);
var o8 = ch.exports, ph = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear(), u = Math.floor(l / 10) * 10;
    return u;
  }
  e.exports = t.default;
})(ph, ph.exports);
var l8 = ph.exports, vh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = Lr, n = r(Cu);
  function i() {
    return (0, n.default)({}, (0, a.getDefaultOptions)());
  }
  e.exports = t.default;
})(vh, vh.exports);
var u8 = vh.exports, mh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getHours();
    return l;
  }
  e.exports = t.default;
})(mh, mh.exports);
var d8 = mh.exports, hh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getDay();
    return l === 0 && (l = 7), l;
  }
  e.exports = t.default;
})(hh, hh.exports);
var EE = hh.exports, gh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(Ce), n = r(Ls), i = r(wu), s = r(re), o = 6048e5;
  function l(u) {
    (0, s.default)(1, arguments);
    var d = (0, a.default)(u), f = (0, n.default)(d).getTime() - (0, i.default)(d).getTime();
    return Math.round(f / o) + 1;
  }
  e.exports = t.default;
})(gh, gh.exports);
var OE = gh.exports, bh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(wu), n = r(nc), i = r(re), s = 6048e5;
  function o(l) {
    (0, i.default)(1, arguments);
    var u = (0, a.default)(l), d = (0, a.default)((0, n.default)(u, 60)), f = d.valueOf() - u.valueOf();
    return Math.round(f / s);
  }
  e.exports = t.default;
})(bh, bh.exports);
var c8 = bh.exports, yh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMilliseconds();
    return l;
  }
  e.exports = t.default;
})(yh, yh.exports);
var f8 = yh.exports, _h = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMinutes();
    return l;
  }
  e.exports = t.default;
})(_h, _h.exports);
var p8 = _h.exports, xh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth();
    return l;
  }
  e.exports = t.default;
})(xh, xh.exports);
var v8 = xh.exports, wh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(re), i = 24 * 60 * 60 * 1e3;
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = o || {}, d = l || {}, f = (0, a.default)(u.start).getTime(), c = (0, a.default)(u.end).getTime(), p = (0, a.default)(d.start).getTime(), v = (0, a.default)(d.end).getTime();
    if (!(f <= c && p <= v))
      throw new RangeError("Invalid interval");
    var h = f < v && p < c;
    if (!h)
      return 0;
    var g = p < f ? f : p, m = v > c ? c : v, b = m - g;
    return Math.ceil(b / i);
  }
  e.exports = t.default;
})(wh, wh.exports);
var m8 = wh.exports, Th = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getSeconds();
    return l;
  }
  e.exports = t.default;
})(Th, Th.exports);
var h8 = Th.exports, Sh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getTime();
    return l;
  }
  e.exports = t.default;
})(Sh, Sh.exports);
var CE = Sh.exports, Eh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(CE), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), Math.floor((0, a.default)(s) / 1e3);
  }
  e.exports = t.default;
})(Eh, Eh.exports);
var g8 = Eh.exports, Oh = { exports: {} }, Ch = { exports: {} }, kh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(as), n = r(Ce), i = r(pt), s = r(re), o = Lr;
  function l(u, d) {
    var f, c, p, v, h, g, m, b;
    (0, s.default)(1, arguments);
    var y = (0, n.default)(u), _ = y.getFullYear(), x = (0, o.getDefaultOptions)(), w = (0, i.default)((f = (c = (p = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (h = d.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && p !== void 0 ? p : x.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = x.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && f !== void 0 ? f : 1);
    if (!(w >= 1 && w <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var k = /* @__PURE__ */ new Date(0);
    k.setFullYear(_ + 1, 0, w), k.setHours(0, 0, 0, 0);
    var S = (0, a.default)(k, d), P = /* @__PURE__ */ new Date(0);
    P.setFullYear(_, 0, w), P.setHours(0, 0, 0, 0);
    var A = (0, a.default)(P, d);
    return y.getTime() >= S.getTime() ? _ + 1 : y.getTime() >= A.getTime() ? _ : _ - 1;
  }
  e.exports = t.default;
})(kh, kh.exports);
var kE = kh.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(kE), n = r(as), i = r(pt), s = r(re), o = Lr;
  function l(u, d) {
    var f, c, p, v, h, g, m, b;
    (0, s.default)(1, arguments);
    var y = (0, o.getDefaultOptions)(), _ = (0, i.default)((f = (c = (p = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (h = d.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && p !== void 0 ? p : y.firstWeekContainsDate) !== null && c !== void 0 ? c : (m = y.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && f !== void 0 ? f : 1), x = (0, a.default)(u, d), w = /* @__PURE__ */ new Date(0);
    w.setFullYear(x, 0, _), w.setHours(0, 0, 0, 0);
    var k = (0, n.default)(w, d);
    return k;
  }
  e.exports = t.default;
})(Ch, Ch.exports);
var Sb = Ch.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(as), n = r(Sb), i = r(Ce), s = r(re), o = 6048e5;
  function l(u, d) {
    (0, s.default)(1, arguments);
    var f = (0, i.default)(u), c = (0, a.default)(f, d).getTime() - (0, n.default)(f, d).getTime();
    return Math.round(c / o) + 1;
  }
  e.exports = t.default;
})(Oh, Oh.exports);
var PE = Oh.exports, Ph = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var a = Lr, n = r(wE), i = r(uc), s = r(lc), o = r(re), l = r(pt);
  function u(d, f) {
    var c, p, v, h, g, m, b, y;
    (0, o.default)(1, arguments);
    var _ = (0, a.getDefaultOptions)(), x = (0, l.default)((c = (p = (v = (h = f == null ? void 0 : f.weekStartsOn) !== null && h !== void 0 ? h : f == null || (g = f.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && v !== void 0 ? v : _.weekStartsOn) !== null && p !== void 0 ? p : (b = _.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && c !== void 0 ? c : 0);
    if (!(x >= 0 && x <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var w = (0, n.default)(d);
    if (isNaN(w))
      return NaN;
    var k = (0, i.default)((0, s.default)(d)), S = x - k;
    S <= 0 && (S += 7);
    var P = w - S;
    return Math.ceil(P / 7) + 1;
  }
  e.exports = t.default;
})(Ph, Ph.exports);
var b8 = Ph.exports, Mh = { exports: {} }, Ah = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth();
    return o.setFullYear(o.getFullYear(), l + 1, 0), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(Ah, Ah.exports);
var ME = Ah.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(fb), n = r(ME), i = r(lc), s = r(re);
  function o(l, u) {
    return (0, s.default)(1, arguments), (0, a.default)((0, n.default)(l), (0, i.default)(l), u) + 1;
  }
  e.exports = t.default;
})(Mh, Mh.exports);
var y8 = Mh.exports, Dh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getFullYear();
  }
  e.exports = t.default;
})(Dh, Dh.exports);
var _8 = Dh.exports, Ih = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.millisecondsInHour);
  }
  e.exports = t.default;
})(Ih, Ih.exports);
var x8 = Ih.exports, Nh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.minutesInHour);
  }
  e.exports = t.default;
})(Nh, Nh.exports);
var w8 = Nh.exports, $h = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.secondsInHour);
  }
  e.exports = t.default;
})($h, $h.exports);
var T8 = $h.exports, Lh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var a = r(Rs), n = r(HS), i = r(vb), s = r(mb), o = r(hb), l = r(sc), u = r(oc), d = r(uE), f = r(Ce), c = r(re);
  function p(v) {
    (0, c.default)(1, arguments);
    var h = (0, f.default)(v.start), g = (0, f.default)(v.end);
    if (isNaN(h.getTime()))
      throw new RangeError("Start Date is invalid");
    if (isNaN(g.getTime()))
      throw new RangeError("End Date is invalid");
    var m = {};
    m.years = Math.abs((0, d.default)(g, h));
    var b = (0, a.default)(g, h), y = (0, n.default)(h, {
      years: b * m.years
    });
    m.months = Math.abs((0, l.default)(g, y));
    var _ = (0, n.default)(y, {
      months: b * m.months
    });
    m.days = Math.abs((0, i.default)(g, _));
    var x = (0, n.default)(_, {
      days: b * m.days
    });
    m.hours = Math.abs((0, s.default)(g, x));
    var w = (0, n.default)(x, {
      hours: b * m.hours
    });
    m.minutes = Math.abs((0, o.default)(g, w));
    var k = (0, n.default)(w, {
      minutes: b * m.minutes
    });
    return m.seconds = Math.abs((0, u.default)(g, k)), m;
  }
  e.exports = t.default;
})(Lh, Lh.exports);
var S8 = Lh.exports, Rh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(re);
  function n(s, o, l) {
    var u;
    (0, a.default)(1, arguments);
    var d;
    return i(o) ? d = o : l = o, new Intl.DateTimeFormat((u = l) === null || u === void 0 ? void 0 : u.locale, d).format(s);
  }
  function i(s) {
    return s !== void 0 && !("locale" in s);
  }
  e.exports = t.default;
})(Rh, Rh.exports);
var E8 = Rh.exports, jh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var a = dt, n = r(ns), i = r(cb), s = r(sE), o = r(fb), l = r(pb), u = r(mb), d = r(hb), f = r(oc), c = r(Ce), p = r(re);
  function v(h, g, m) {
    (0, p.default)(2, arguments);
    var b = 0, y, _ = (0, c.default)(h), x = (0, c.default)(g);
    if (m != null && m.unit)
      y = m == null ? void 0 : m.unit, y === "second" ? b = (0, f.default)(_, x) : y === "minute" ? b = (0, d.default)(_, x) : y === "hour" ? b = (0, u.default)(_, x) : y === "day" ? b = (0, n.default)(_, x) : y === "week" ? b = (0, o.default)(_, x) : y === "month" ? b = (0, i.default)(_, x) : y === "quarter" ? b = (0, s.default)(_, x) : y === "year" && (b = (0, l.default)(_, x));
    else {
      var w = (0, f.default)(_, x);
      Math.abs(w) < a.secondsInMinute ? (b = (0, f.default)(_, x), y = "second") : Math.abs(w) < a.secondsInHour ? (b = (0, d.default)(_, x), y = "minute") : Math.abs(w) < a.secondsInDay && Math.abs((0, n.default)(_, x)) < 1 ? (b = (0, u.default)(_, x), y = "hour") : Math.abs(w) < a.secondsInWeek && (b = (0, n.default)(_, x)) && Math.abs(b) < 7 ? y = "day" : Math.abs(w) < a.secondsInMonth ? (b = (0, o.default)(_, x), y = "week") : Math.abs(w) < a.secondsInQuarter ? (b = (0, i.default)(_, x), y = "month") : Math.abs(w) < a.secondsInYear && (0, s.default)(_, x) < 4 ? (b = (0, s.default)(_, x), y = "quarter") : (b = (0, l.default)(_, x), y = "year");
    }
    var k = new Intl.RelativeTimeFormat(m == null ? void 0 : m.locale, {
      localeMatcher: m == null ? void 0 : m.localeMatcher,
      numeric: (m == null ? void 0 : m.numeric) || "auto",
      style: m == null ? void 0 : m.style
    });
    return k.format(b, y);
  }
  e.exports = t.default;
})(jh, jh.exports);
var O8 = jh.exports, Fh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() > u.getTime();
  }
  e.exports = t.default;
})(Fh, Fh.exports);
var C8 = Fh.exports, Bh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() < u.getTime();
  }
  e.exports = t.default;
})(Bh, Bh.exports);
var k8 = Bh.exports, qh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(qh, qh.exports);
var P8 = qh.exports, Hh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n, i) {
    if (arguments.length < 3)
      throw new TypeError("3 argument required, but only " + arguments.length + " present");
    var s = new Date(a, n, i);
    return s.getFullYear() === a && s.getMonth() === n && s.getDate() === i;
  }
  e.exports = t.default;
})(Hh, Hh.exports);
var M8 = Hh.exports, Vh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDate() === 1;
  }
  e.exports = t.default;
})(Vh, Vh.exports);
var A8 = Vh.exports, Uh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 5;
  }
  e.exports = t.default;
})(Uh, Uh.exports);
var D8 = Uh.exports, zh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getTime() > Date.now();
  }
  e.exports = t.default;
})(zh, zh.exports);
var I8 = zh.exports, Yh = { exports: {} }, Wh = { exports: {} }, AE = { exports: {} }, DE = { exports: {} }, IE = { exports: {} };
(function(e) {
  function t(r, a) {
    (a == null || a > r.length) && (a = r.length);
    for (var n = 0, i = new Array(a); n < a; n++)
      i[n] = r[n];
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(IE);
var N8 = IE.exports;
(function(e) {
  var t = N8;
  function r(a, n) {
    if (a) {
      if (typeof a == "string")
        return t(a, n);
      var i = Object.prototype.toString.call(a).slice(8, -1);
      if (i === "Object" && a.constructor && (i = a.constructor.name), i === "Map" || i === "Set")
        return Array.from(a);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return t(a, n);
    }
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(DE);
var $8 = DE.exports;
(function(e) {
  var t = $8;
  function r(a, n) {
    var i = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
    if (!i) {
      if (Array.isArray(a) || (i = t(a)) || n && a && typeof a.length == "number") {
        i && (a = i);
        var s = 0, o = function() {
        };
        return {
          s: o,
          n: function() {
            return s >= a.length ? {
              done: !0
            } : {
              done: !1,
              value: a[s++]
            };
          },
          e: function(c) {
            throw c;
          },
          f: o
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var l = !0, u = !1, d;
    return {
      s: function() {
        i = i.call(a);
      },
      n: function() {
        var c = i.next();
        return l = c.done, c;
      },
      e: function(c) {
        u = !0, d = c;
      },
      f: function() {
        try {
          !l && i.return != null && i.return();
        } finally {
          if (u)
            throw d;
        }
      }
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(AE);
var L8 = AE.exports, Ti = {}, NE = { exports: {} };
(function(e) {
  function t(r) {
    if (r === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(NE);
var Ut = NE.exports, $E = { exports: {} }, LE = { exports: {} };
(function(e) {
  function t(r, a) {
    return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, s) {
      return i.__proto__ = s, i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, a);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(LE);
var R8 = LE.exports;
(function(e) {
  var t = R8;
  function r(a, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(n && n.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(a, "prototype", {
      writable: !1
    }), n && t(a, n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})($E);
var Qt = $E.exports, RE = { exports: {} }, jE = { exports: {} };
(function(e) {
  function t(r) {
    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
      return n.__proto__ || Object.getPrototypeOf(n);
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(jE);
var j8 = jE.exports, FE = { exports: {} };
(function(e) {
  function t() {
    try {
      var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (e.exports = t = function() {
      return !!r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports)();
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(FE);
var F8 = FE.exports, BE = { exports: {} };
(function(e) {
  var t = On.default, r = Ut;
  function a(n, i) {
    if (i && (t(i) === "object" || typeof i == "function"))
      return i;
    if (i !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return r(n);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(BE);
var B8 = BE.exports;
(function(e) {
  var t = j8, r = F8, a = B8;
  function n(i) {
    var s = r();
    return function() {
      var l = t(i), u;
      if (s) {
        var d = t(this).constructor;
        u = Reflect.construct(l, arguments, d);
      } else
        u = l.apply(this, arguments);
      return a(this, u);
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(RE);
var Zt = RE.exports, qE = { exports: {} };
(function(e) {
  function t(r, a) {
    if (!(r instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(qE);
var zt = qE.exports, HE = { exports: {} }, VE = { exports: {} }, UE = { exports: {} };
(function(e) {
  var t = On.default;
  function r(a, n) {
    if (t(a) != "object" || !a)
      return a;
    var i = a[Symbol.toPrimitive];
    if (i !== void 0) {
      var s = i.call(a, n || "default");
      if (t(s) != "object")
        return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(a);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(UE);
var q8 = UE.exports;
(function(e) {
  var t = On.default, r = q8;
  function a(n) {
    var i = r(n, "string");
    return t(i) == "symbol" ? i : String(i);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(VE);
var zE = VE.exports;
(function(e) {
  var t = zE;
  function r(n, i) {
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, t(o.key), o);
    }
  }
  function a(n, i, s) {
    return i && r(n.prototype, i), s && r(n, s), Object.defineProperty(n, "prototype", {
      writable: !1
    }), n;
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(HE);
var Yt = HE.exports, YE = { exports: {} };
(function(e) {
  var t = zE;
  function r(a, n, i) {
    return n = t(n), n in a ? Object.defineProperty(a, n, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[n] = i, a;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(YE);
var Wt = YE.exports, No = X.default;
Object.defineProperty(Ti, "__esModule", {
  value: !0
});
Ti.ValueSetter = Ti.Setter = Ti.DateToSystemTimezoneSetter = void 0;
var N_ = No(Ut), WE = No(Qt), GE = No(Zt), Eb = No(zt), Ob = No(Yt), Sd = No(Wt), H8 = 10, Cb = /* @__PURE__ */ function() {
  function e() {
    (0, Eb.default)(this, e), (0, Sd.default)(this, "priority", void 0), (0, Sd.default)(this, "subPriority", 0);
  }
  return (0, Ob.default)(e, [{
    key: "validate",
    value: function(r, a) {
      return !0;
    }
  }]), e;
}();
Ti.Setter = Cb;
var V8 = /* @__PURE__ */ function(e) {
  (0, WE.default)(r, e);
  var t = (0, GE.default)(r);
  function r(a, n, i, s, o) {
    var l;
    return (0, Eb.default)(this, r), l = t.call(this), l.value = a, l.validateValue = n, l.setValue = i, l.priority = s, o && (l.subPriority = o), l;
  }
  return (0, Ob.default)(r, [{
    key: "validate",
    value: function(n, i) {
      return this.validateValue(n, this.value, i);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return this.setValue(n, i, this.value, s);
    }
  }]), r;
}(Cb);
Ti.ValueSetter = V8;
var U8 = /* @__PURE__ */ function(e) {
  (0, WE.default)(r, e);
  var t = (0, GE.default)(r);
  function r() {
    var a;
    (0, Eb.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Sd.default)((0, N_.default)(a), "priority", H8), (0, Sd.default)((0, N_.default)(a), "subPriority", -1), a;
  }
  return (0, Ob.default)(r, [{
    key: "set",
    value: function(n, i) {
      if (i.timestampIsSet)
        return n;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), s.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), s;
    }
  }]), r;
}(Cb);
Ti.DateToSystemTimezoneSetter = U8;
var dc = {}, cc = {}, qt = {}, kb = X.default;
Object.defineProperty(qt, "__esModule", {
  value: !0
});
qt.Parser = void 0;
var z8 = kb(zt), Y8 = kb(Yt), Pf = kb(Wt), W8 = Ti, G8 = /* @__PURE__ */ function() {
  function e() {
    (0, z8.default)(this, e), (0, Pf.default)(this, "incompatibleTokens", void 0), (0, Pf.default)(this, "priority", void 0), (0, Pf.default)(this, "subPriority", void 0);
  }
  return (0, Y8.default)(e, [{
    key: "run",
    value: function(r, a, n, i) {
      var s = this.parse(r, a, n, i);
      return s ? {
        setter: new W8.ValueSetter(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, a, n) {
      return !0;
    }
  }]), e;
}();
qt.Parser = G8;
var $o = X.default;
Object.defineProperty(cc, "__esModule", {
  value: !0
});
cc.EraParser = void 0;
var X8 = $o(zt), K8 = $o(Yt), $_ = $o(Ut), J8 = $o(Qt), Q8 = $o(Zt), L_ = $o(Wt), Z8 = qt, eL = /* @__PURE__ */ function(e) {
  (0, J8.default)(r, e);
  var t = (0, Q8.default)(r);
  function r() {
    var a;
    (0, X8.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, L_.default)((0, $_.default)(a), "priority", 140), (0, L_.default)((0, $_.default)(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return (0, K8.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(n, {
            width: "abbreviated"
          }) || s.era(n, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(n, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(n, {
            width: "wide"
          }) || s.era(n, {
            width: "abbreviated"
          }) || s.era(n, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return i.era = s, n.setUTCFullYear(s, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Z8.Parser);
cc.EraParser = eL;
var fc = {}, At = {}, Wr = {};
Object.defineProperty(Wr, "__esModule", {
  value: !0
});
Wr.timezonePatterns = Wr.numericPatterns = void 0;
var tL = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
Wr.numericPatterns = tL;
var rL = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
Wr.timezonePatterns = rL;
Object.defineProperty(At, "__esModule", {
  value: !0
});
At.dayPeriodEnumToHours = lL;
At.isLeapYearIndex = dL;
At.mapValue = aL;
At.normalizeTwoDigitYear = uL;
At.parseAnyDigitsSigned = iL;
At.parseNDigits = sL;
At.parseNDigitsSigned = oL;
At.parseNumericPattern = mn;
At.parseTimezonePattern = nL;
var Mf = dt, wi = Wr;
function aL(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function mn(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function nL(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var a = r[1] === "+" ? 1 : -1, n = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, s = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: a * (n * Mf.millisecondsInHour + i * Mf.millisecondsInMinute + s * Mf.millisecondsInSecond),
    rest: t.slice(r[0].length)
  };
}
function iL(e) {
  return mn(wi.numericPatterns.anyDigitsSigned, e);
}
function sL(e, t) {
  switch (e) {
    case 1:
      return mn(wi.numericPatterns.singleDigit, t);
    case 2:
      return mn(wi.numericPatterns.twoDigits, t);
    case 3:
      return mn(wi.numericPatterns.threeDigits, t);
    case 4:
      return mn(wi.numericPatterns.fourDigits, t);
    default:
      return mn(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function oL(e, t) {
  switch (e) {
    case 1:
      return mn(wi.numericPatterns.singleDigitSigned, t);
    case 2:
      return mn(wi.numericPatterns.twoDigitsSigned, t);
    case 3:
      return mn(wi.numericPatterns.threeDigitsSigned, t);
    case 4:
      return mn(wi.numericPatterns.fourDigitsSigned, t);
    default:
      return mn(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function lL(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function uL(e, t) {
  var r = t > 0, a = r ? t : 1 - t, n;
  if (a <= 50)
    n = e || 100;
  else {
    var i = a + 50, s = Math.floor(i / 100) * 100, o = e >= i % 100;
    n = e + s - (o ? 100 : 0);
  }
  return r ? n : 1 - n;
}
function dL(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Lo = X.default;
Object.defineProperty(fc, "__esModule", {
  value: !0
});
fc.YearParser = void 0;
var cL = Lo(zt), fL = Lo(Yt), R_ = Lo(Ut), pL = Lo(Qt), vL = Lo(Zt), j_ = Lo(Wt), mL = qt, Zs = At, hL = /* @__PURE__ */ function(e) {
  (0, pL.default)(r, e);
  var t = (0, vL.default)(r);
  function r() {
    var a;
    (0, cL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, j_.default)((0, R_.default)(a), "priority", 130), (0, j_.default)((0, R_.default)(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return (0, fL.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      var o = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return (0, Zs.mapValue)((0, Zs.parseNDigits)(4, n), o);
        case "yo":
          return (0, Zs.mapValue)(s.ordinalNumber(n, {
            unit: "year"
          }), o);
        default:
          return (0, Zs.mapValue)((0, Zs.parseNDigits)(i.length, n), o);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      var o = n.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var l = (0, Zs.normalizeTwoDigitYear)(s.year, o);
        return n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
      }
      var u = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return n.setUTCFullYear(u, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(mL.Parser);
fc.YearParser = hL;
var pc = {}, os = X.default;
Object.defineProperty(pc, "__esModule", {
  value: !0
});
pc.LocalWeekYearParser = void 0;
var gL = os(zt), bL = os(Yt), F_ = os(Ut), yL = os(Qt), _L = os(Zt), B_ = os(Wt), xL = qt, eo = At, wL = os(Tb), q_ = os(Ou), TL = /* @__PURE__ */ function(e) {
  (0, yL.default)(r, e);
  var t = (0, _L.default)(r);
  function r() {
    var a;
    (0, gL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, B_.default)((0, F_.default)(a), "priority", 130), (0, B_.default)((0, F_.default)(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return (0, bL.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      var o = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return (0, eo.mapValue)((0, eo.parseNDigits)(4, n), o);
        case "Yo":
          return (0, eo.mapValue)(s.ordinalNumber(n, {
            unit: "year"
          }), o);
        default:
          return (0, eo.mapValue)((0, eo.parseNDigits)(i.length, n), o);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, s, o) {
      var l = (0, wL.default)(n, o);
      if (s.isTwoDigitYear) {
        var u = (0, eo.normalizeTwoDigitYear)(s.year, l);
        return n.setUTCFullYear(u, 0, o.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), (0, q_.default)(n, o);
      }
      var d = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return n.setUTCFullYear(d, 0, o.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), (0, q_.default)(n, o);
    }
  }]), r;
}(xL.Parser);
pc.LocalWeekYearParser = TL;
var vc = {}, js = X.default;
Object.defineProperty(vc, "__esModule", {
  value: !0
});
vc.ISOWeekYearParser = void 0;
var SL = js(zt), EL = js(Yt), H_ = js(Ut), OL = js(Qt), CL = js(Zt), V_ = js(Wt), kL = qt, U_ = At, PL = js(Eu), ML = /* @__PURE__ */ function(e) {
  (0, OL.default)(r, e);
  var t = (0, CL.default)(r);
  function r() {
    var a;
    (0, SL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, V_.default)((0, H_.default)(a), "priority", 130), (0, V_.default)((0, H_.default)(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return (0, EL.default)(r, [{
    key: "parse",
    value: function(n, i) {
      return i === "R" ? (0, U_.parseNDigitsSigned)(4, n) : (0, U_.parseNDigitsSigned)(i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(s, 0, 4), o.setUTCHours(0, 0, 0, 0), (0, PL.default)(o);
    }
  }]), r;
}(kL.Parser);
vc.ISOWeekYearParser = ML;
var mc = {}, Ro = X.default;
Object.defineProperty(mc, "__esModule", {
  value: !0
});
mc.ExtendedYearParser = void 0;
var AL = Ro(zt), DL = Ro(Yt), z_ = Ro(Ut), IL = Ro(Qt), NL = Ro(Zt), Y_ = Ro(Wt), $L = qt, W_ = At, LL = /* @__PURE__ */ function(e) {
  (0, IL.default)(r, e);
  var t = (0, NL.default)(r);
  function r() {
    var a;
    (0, AL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Y_.default)((0, z_.default)(a), "priority", 130), (0, Y_.default)((0, z_.default)(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return (0, DL.default)(r, [{
    key: "parse",
    value: function(n, i) {
      return i === "u" ? (0, W_.parseNDigitsSigned)(4, n) : (0, W_.parseNDigitsSigned)(i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCFullYear(s, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}($L.Parser);
mc.ExtendedYearParser = LL;
var hc = {}, jo = X.default;
Object.defineProperty(hc, "__esModule", {
  value: !0
});
hc.QuarterParser = void 0;
var RL = jo(zt), jL = jo(Yt), G_ = jo(Ut), FL = jo(Qt), BL = jo(Zt), X_ = jo(Wt), qL = qt, HL = At, VL = /* @__PURE__ */ function(e) {
  (0, FL.default)(r, e);
  var t = (0, BL.default)(r);
  function r() {
    var a;
    (0, RL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, X_.default)((0, G_.default)(a), "priority", 120), (0, X_.default)((0, G_.default)(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return (0, jL.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "Q":
        case "QQ":
          return (0, HL.parseNDigits)(i.length, n);
        case "Qo":
          return s.ordinalNumber(n, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(n, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMonth((s - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(qL.Parser);
hc.QuarterParser = VL;
var gc = {}, Fo = X.default;
Object.defineProperty(gc, "__esModule", {
  value: !0
});
gc.StandAloneQuarterParser = void 0;
var UL = Fo(zt), zL = Fo(Yt), K_ = Fo(Ut), YL = Fo(Qt), WL = Fo(Zt), J_ = Fo(Wt), GL = qt, XL = At, KL = /* @__PURE__ */ function(e) {
  (0, YL.default)(r, e);
  var t = (0, WL.default)(r);
  function r() {
    var a;
    (0, UL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, J_.default)((0, K_.default)(a), "priority", 120), (0, J_.default)((0, K_.default)(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return (0, zL.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "q":
        case "qq":
          return (0, XL.parseNDigits)(i.length, n);
        case "qo":
          return s.ordinalNumber(n, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(n, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMonth((s - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(GL.Parser);
gc.StandAloneQuarterParser = KL;
var bc = {}, Bo = X.default;
Object.defineProperty(bc, "__esModule", {
  value: !0
});
bc.MonthParser = void 0;
var JL = Bo(zt), QL = Bo(Yt), Q_ = Bo(Ut), ZL = Bo(Qt), e7 = Bo(Zt), Z_ = Bo(Wt), vl = At, t7 = qt, r7 = Wr, a7 = /* @__PURE__ */ function(e) {
  (0, ZL.default)(r, e);
  var t = (0, e7.default)(r);
  function r() {
    var a;
    (0, JL.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Z_.default)((0, Q_.default)(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), (0, Z_.default)((0, Q_.default)(a), "priority", 110), a;
  }
  return (0, QL.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      var o = function(u) {
        return u - 1;
      };
      switch (i) {
        case "M":
          return (0, vl.mapValue)((0, vl.parseNumericPattern)(r7.numericPatterns.month, n), o);
        case "MM":
          return (0, vl.mapValue)((0, vl.parseNDigits)(2, n), o);
        case "Mo":
          return (0, vl.mapValue)(s.ordinalNumber(n, {
            unit: "month"
          }), o);
        case "MMM":
          return s.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(n, {
            width: "wide",
            context: "formatting"
          }) || s.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMonth(s, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(t7.Parser);
bc.MonthParser = a7;
var yc = {}, qo = X.default;
Object.defineProperty(yc, "__esModule", {
  value: !0
});
yc.StandAloneMonthParser = void 0;
var n7 = qo(zt), i7 = qo(Yt), ex = qo(Ut), s7 = qo(Qt), o7 = qo(Zt), tx = qo(Wt), l7 = qt, u7 = Wr, ml = At, d7 = /* @__PURE__ */ function(e) {
  (0, s7.default)(r, e);
  var t = (0, o7.default)(r);
  function r() {
    var a;
    (0, n7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, tx.default)((0, ex.default)(a), "priority", 110), (0, tx.default)((0, ex.default)(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return (0, i7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      var o = function(u) {
        return u - 1;
      };
      switch (i) {
        case "L":
          return (0, ml.mapValue)((0, ml.parseNumericPattern)(u7.numericPatterns.month, n), o);
        case "LL":
          return (0, ml.mapValue)((0, ml.parseNDigits)(2, n), o);
        case "Lo":
          return (0, ml.mapValue)(s.ordinalNumber(n, {
            unit: "month"
          }), o);
        case "LLL":
          return s.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(n, {
            width: "wide",
            context: "standalone"
          }) || s.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMonth(s, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(l7.Parser);
yc.StandAloneMonthParser = d7;
var _c = {}, Gh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Ce), i = r(mE), s = r(re);
  function o(l, u, d) {
    (0, s.default)(2, arguments);
    var f = (0, n.default)(l), c = (0, a.default)(u), p = (0, i.default)(f, d) - c;
    return f.setUTCDate(f.getUTCDate() - p * 7), f;
  }
  e.exports = t.default;
})(Gh, Gh.exports);
var c7 = Gh.exports, ls = X.default;
Object.defineProperty(_c, "__esModule", {
  value: !0
});
_c.LocalWeekParser = void 0;
var f7 = ls(zt), p7 = ls(Yt), rx = ls(Ut), v7 = ls(Qt), m7 = ls(Zt), ax = ls(Wt), h7 = qt, g7 = Wr, nx = At, b7 = ls(c7), y7 = ls(Ou), _7 = /* @__PURE__ */ function(e) {
  (0, v7.default)(r, e);
  var t = (0, m7.default)(r);
  function r() {
    var a;
    (0, f7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, ax.default)((0, rx.default)(a), "priority", 100), (0, ax.default)((0, rx.default)(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return (0, p7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "w":
          return (0, nx.parseNumericPattern)(g7.numericPatterns.week, n);
        case "wo":
          return s.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return (0, nx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, s, o) {
      return (0, y7.default)((0, b7.default)(n, s, o), o);
    }
  }]), r;
}(h7.Parser);
_c.LocalWeekParser = _7;
var xc = {}, Xh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Ce), i = r(vE), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, a.default)(u), c = (0, i.default)(d) - f;
    return d.setUTCDate(d.getUTCDate() - c * 7), d;
  }
  e.exports = t.default;
})(Xh, Xh.exports);
var x7 = Xh.exports, us = X.default;
Object.defineProperty(xc, "__esModule", {
  value: !0
});
xc.ISOWeekParser = void 0;
var w7 = us(zt), T7 = us(Yt), ix = us(Ut), S7 = us(Qt), E7 = us(Zt), sx = us(Wt), O7 = qt, C7 = Wr, ox = At, k7 = us(x7), P7 = us(Eu), M7 = /* @__PURE__ */ function(e) {
  (0, S7.default)(r, e);
  var t = (0, E7.default)(r);
  function r() {
    var a;
    (0, w7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, sx.default)((0, ix.default)(a), "priority", 100), (0, sx.default)((0, ix.default)(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return (0, T7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "I":
          return (0, ox.parseNumericPattern)(C7.numericPatterns.week, n);
        case "Io":
          return s.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return (0, ox.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return (0, P7.default)((0, k7.default)(n, s));
    }
  }]), r;
}(O7.Parser);
xc.ISOWeekParser = M7;
var wc = {}, Ho = X.default;
Object.defineProperty(wc, "__esModule", {
  value: !0
});
wc.DateParser = void 0;
var A7 = Ho(zt), D7 = Ho(Yt), Af = Ho(Ut), I7 = Ho(Qt), N7 = Ho(Zt), Df = Ho(Wt), If = At, $7 = qt, L7 = Wr, R7 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], j7 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], F7 = /* @__PURE__ */ function(e) {
  (0, I7.default)(r, e);
  var t = (0, N7.default)(r);
  function r() {
    var a;
    (0, A7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Df.default)((0, Af.default)(a), "priority", 90), (0, Df.default)((0, Af.default)(a), "subPriority", 1), (0, Df.default)((0, Af.default)(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return (0, D7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "d":
          return (0, If.parseNumericPattern)(L7.numericPatterns.date, n);
        case "do":
          return s.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return (0, If.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var s = n.getUTCFullYear(), o = (0, If.isLeapYearIndex)(s), l = n.getUTCMonth();
      return o ? i >= 1 && i <= j7[l] : i >= 1 && i <= R7[l];
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCDate(s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}($7.Parser);
wc.DateParser = F7;
var Tc = {}, Vo = X.default;
Object.defineProperty(Tc, "__esModule", {
  value: !0
});
Tc.DayOfYearParser = void 0;
var B7 = Vo(zt), q7 = Vo(Yt), Nf = Vo(Ut), H7 = Vo(Qt), V7 = Vo(Zt), $f = Vo(Wt), U7 = qt, z7 = Wr, Lf = At, Y7 = /* @__PURE__ */ function(e) {
  (0, H7.default)(r, e);
  var t = (0, V7.default)(r);
  function r() {
    var a;
    (0, B7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, $f.default)((0, Nf.default)(a), "priority", 90), (0, $f.default)((0, Nf.default)(a), "subpriority", 1), (0, $f.default)((0, Nf.default)(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return (0, q7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "D":
        case "DD":
          return (0, Lf.parseNumericPattern)(z7.numericPatterns.dayOfYear, n);
        case "Do":
          return s.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return (0, Lf.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var s = n.getUTCFullYear(), o = (0, Lf.isLeapYearIndex)(s);
      return o ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMonth(0, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(U7.Parser);
Tc.DayOfYearParser = Y7;
var Sc = {}, Kh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(re), i = r(pt), s = Lr;
  function o(l, u, d) {
    var f, c, p, v, h, g, m, b;
    (0, n.default)(2, arguments);
    var y = (0, s.getDefaultOptions)(), _ = (0, i.default)((f = (c = (p = (v = d == null ? void 0 : d.weekStartsOn) !== null && v !== void 0 ? v : d == null || (h = d.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && p !== void 0 ? p : y.weekStartsOn) !== null && c !== void 0 ? c : (m = y.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && f !== void 0 ? f : 0);
    if (!(_ >= 0 && _ <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var x = (0, a.default)(l), w = (0, i.default)(u), k = x.getUTCDay(), S = w % 7, P = (S + 7) % 7, A = (P < _ ? 7 : 0) + w - k;
    return x.setUTCDate(x.getUTCDate() + A), x;
  }
  e.exports = t.default;
})(Kh, Kh.exports);
var Pb = Kh.exports, Fs = X.default;
Object.defineProperty(Sc, "__esModule", {
  value: !0
});
Sc.DayParser = void 0;
var W7 = Fs(zt), G7 = Fs(Yt), lx = Fs(Ut), X7 = Fs(Qt), K7 = Fs(Zt), ux = Fs(Wt), J7 = qt, Q7 = Fs(Pb), Z7 = /* @__PURE__ */ function(e) {
  (0, X7.default)(r, e);
  var t = (0, K7.default)(r);
  function r() {
    var a;
    (0, W7.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, ux.default)((0, lx.default)(a), "priority", 90), (0, ux.default)((0, lx.default)(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return (0, G7.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(n, {
            width: "wide",
            context: "formatting"
          }) || s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, s, o) {
      return n = (0, Q7.default)(n, s, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(J7.Parser);
Sc.DayParser = Z7;
var Ec = {}, Bs = X.default;
Object.defineProperty(Ec, "__esModule", {
  value: !0
});
Ec.LocalDayParser = void 0;
var e9 = Bs(zt), t9 = Bs(Yt), dx = Bs(Ut), r9 = Bs(Qt), a9 = Bs(Zt), cx = Bs(Wt), n9 = qt, Rf = At, i9 = Bs(Pb), s9 = /* @__PURE__ */ function(e) {
  (0, r9.default)(r, e);
  var t = (0, a9.default)(r);
  function r() {
    var a;
    (0, e9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, cx.default)((0, dx.default)(a), "priority", 90), (0, cx.default)((0, dx.default)(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return (0, t9.default)(r, [{
    key: "parse",
    value: function(n, i, s, o) {
      var l = function(d) {
        var f = Math.floor((d - 1) / 7) * 7;
        return (d + o.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "e":
        case "ee":
          return (0, Rf.mapValue)((0, Rf.parseNDigits)(i.length, n), l);
        case "eo":
          return (0, Rf.mapValue)(s.ordinalNumber(n, {
            unit: "day"
          }), l);
        case "eee":
          return s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(n, {
            width: "wide",
            context: "formatting"
          }) || s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, s, o) {
      return n = (0, i9.default)(n, s, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(n9.Parser);
Ec.LocalDayParser = s9;
var Oc = {}, qs = X.default;
Object.defineProperty(Oc, "__esModule", {
  value: !0
});
Oc.StandAloneLocalDayParser = void 0;
var o9 = qs(zt), l9 = qs(Yt), fx = qs(Ut), u9 = qs(Qt), d9 = qs(Zt), px = qs(Wt), c9 = qt, jf = At, f9 = qs(Pb), p9 = /* @__PURE__ */ function(e) {
  (0, u9.default)(r, e);
  var t = (0, d9.default)(r);
  function r() {
    var a;
    (0, o9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, px.default)((0, fx.default)(a), "priority", 90), (0, px.default)((0, fx.default)(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return (0, l9.default)(r, [{
    key: "parse",
    value: function(n, i, s, o) {
      var l = function(d) {
        var f = Math.floor((d - 1) / 7) * 7;
        return (d + o.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "c":
        case "cc":
          return (0, jf.mapValue)((0, jf.parseNDigits)(i.length, n), l);
        case "co":
          return (0, jf.mapValue)(s.ordinalNumber(n, {
            unit: "day"
          }), l);
        case "ccc":
          return s.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(n, {
            width: "short",
            context: "standalone"
          }) || s.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(n, {
            width: "short",
            context: "standalone"
          }) || s.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(n, {
            width: "wide",
            context: "standalone"
          }) || s.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(n, {
            width: "short",
            context: "standalone"
          }) || s.day(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, s, o) {
      return n = (0, f9.default)(n, s, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(c9.Parser);
Oc.StandAloneLocalDayParser = p9;
var Cc = {}, Jh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    u % 7 === 0 && (u = u - 7);
    var d = 1, f = (0, a.default)(o), c = f.getUTCDay(), p = u % 7, v = (p + 7) % 7, h = (v < d ? 7 : 0) + u - c;
    return f.setUTCDate(f.getUTCDate() + h), f;
  }
  e.exports = t.default;
})(Jh, Jh.exports);
var v9 = Jh.exports, Hs = X.default;
Object.defineProperty(Cc, "__esModule", {
  value: !0
});
Cc.ISODayParser = void 0;
var m9 = Hs(zt), h9 = Hs(Yt), vx = Hs(Ut), g9 = Hs(Qt), b9 = Hs(Zt), mx = Hs(Wt), y9 = qt, hl = At, _9 = Hs(v9), x9 = /* @__PURE__ */ function(e) {
  (0, g9.default)(r, e);
  var t = (0, b9.default)(r);
  function r() {
    var a;
    (0, m9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, mx.default)((0, vx.default)(a), "priority", 90), (0, mx.default)((0, vx.default)(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return (0, h9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      var o = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (i) {
        case "i":
        case "ii":
          return (0, hl.parseNDigits)(i.length, n);
        case "io":
          return s.ordinalNumber(n, {
            unit: "day"
          });
        case "iii":
          return (0, hl.mapValue)(s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiii":
          return (0, hl.mapValue)(s.day(n, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiiii":
          return (0, hl.mapValue)(s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiii":
        default:
          return (0, hl.mapValue)(s.day(n, {
            width: "wide",
            context: "formatting"
          }) || s.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(n, {
            width: "short",
            context: "formatting"
          }) || s.day(n, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n = (0, _9.default)(n, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(y9.Parser);
Cc.ISODayParser = x9;
var kc = {}, Uo = X.default;
Object.defineProperty(kc, "__esModule", {
  value: !0
});
kc.AMPMParser = void 0;
var w9 = Uo(zt), T9 = Uo(Yt), hx = Uo(Ut), S9 = Uo(Qt), E9 = Uo(Zt), gx = Uo(Wt), O9 = qt, C9 = At, k9 = /* @__PURE__ */ function(e) {
  (0, S9.default)(r, e);
  var t = (0, E9.default)(r);
  function r() {
    var a;
    (0, w9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, gx.default)((0, hx.default)(a), "priority", 80), (0, gx.default)((0, hx.default)(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return (0, T9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCHours((0, C9.dayPeriodEnumToHours)(s), 0, 0, 0), n;
    }
  }]), r;
}(O9.Parser);
kc.AMPMParser = k9;
var Pc = {}, zo = X.default;
Object.defineProperty(Pc, "__esModule", {
  value: !0
});
Pc.AMPMMidnightParser = void 0;
var P9 = zo(zt), M9 = zo(Yt), bx = zo(Ut), A9 = zo(Qt), D9 = zo(Zt), yx = zo(Wt), I9 = qt, N9 = At, $9 = /* @__PURE__ */ function(e) {
  (0, A9.default)(r, e);
  var t = (0, D9.default)(r);
  function r() {
    var a;
    (0, P9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, yx.default)((0, bx.default)(a), "priority", 80), (0, yx.default)((0, bx.default)(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return (0, M9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCHours((0, N9.dayPeriodEnumToHours)(s), 0, 0, 0), n;
    }
  }]), r;
}(I9.Parser);
Pc.AMPMMidnightParser = $9;
var Mc = {}, Yo = X.default;
Object.defineProperty(Mc, "__esModule", {
  value: !0
});
Mc.DayPeriodParser = void 0;
var L9 = Yo(zt), R9 = Yo(Yt), _x = Yo(Ut), j9 = Yo(Qt), F9 = Yo(Zt), xx = Yo(Wt), B9 = qt, q9 = At, H9 = /* @__PURE__ */ function(e) {
  (0, j9.default)(r, e);
  var t = (0, F9.default)(r);
  function r() {
    var a;
    (0, L9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, xx.default)((0, _x.default)(a), "priority", 80), (0, xx.default)((0, _x.default)(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return (0, R9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCHours((0, q9.dayPeriodEnumToHours)(s), 0, 0, 0), n;
    }
  }]), r;
}(B9.Parser);
Mc.DayPeriodParser = H9;
var Ac = {}, Wo = X.default;
Object.defineProperty(Ac, "__esModule", {
  value: !0
});
Ac.Hour1to12Parser = void 0;
var V9 = Wo(zt), U9 = Wo(Yt), wx = Wo(Ut), z9 = Wo(Qt), Y9 = Wo(Zt), Tx = Wo(Wt), W9 = qt, G9 = Wr, Sx = At, X9 = /* @__PURE__ */ function(e) {
  (0, z9.default)(r, e);
  var t = (0, Y9.default)(r);
  function r() {
    var a;
    (0, V9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Tx.default)((0, wx.default)(a), "priority", 70), (0, Tx.default)((0, wx.default)(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return (0, U9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "h":
          return (0, Sx.parseNumericPattern)(G9.numericPatterns.hour12h, n);
        case "ho":
          return s.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return (0, Sx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      var o = n.getUTCHours() >= 12;
      return o && s < 12 ? n.setUTCHours(s + 12, 0, 0, 0) : !o && s === 12 ? n.setUTCHours(0, 0, 0, 0) : n.setUTCHours(s, 0, 0, 0), n;
    }
  }]), r;
}(W9.Parser);
Ac.Hour1to12Parser = X9;
var Dc = {}, Go = X.default;
Object.defineProperty(Dc, "__esModule", {
  value: !0
});
Dc.Hour0to23Parser = void 0;
var K9 = Go(zt), J9 = Go(Yt), Ex = Go(Ut), Q9 = Go(Qt), Z9 = Go(Zt), Ox = Go(Wt), eR = qt, tR = Wr, Cx = At, rR = /* @__PURE__ */ function(e) {
  (0, Q9.default)(r, e);
  var t = (0, Z9.default)(r);
  function r() {
    var a;
    (0, K9.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Ox.default)((0, Ex.default)(a), "priority", 70), (0, Ox.default)((0, Ex.default)(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return (0, J9.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "H":
          return (0, Cx.parseNumericPattern)(tR.numericPatterns.hour23h, n);
        case "Ho":
          return s.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return (0, Cx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCHours(s, 0, 0, 0), n;
    }
  }]), r;
}(eR.Parser);
Dc.Hour0to23Parser = rR;
var Ic = {}, Xo = X.default;
Object.defineProperty(Ic, "__esModule", {
  value: !0
});
Ic.Hour0To11Parser = void 0;
var aR = Xo(zt), nR = Xo(Yt), kx = Xo(Ut), iR = Xo(Qt), sR = Xo(Zt), Px = Xo(Wt), oR = qt, lR = Wr, Mx = At, uR = /* @__PURE__ */ function(e) {
  (0, iR.default)(r, e);
  var t = (0, sR.default)(r);
  function r() {
    var a;
    (0, aR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Px.default)((0, kx.default)(a), "priority", 70), (0, Px.default)((0, kx.default)(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return (0, nR.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "K":
          return (0, Mx.parseNumericPattern)(lR.numericPatterns.hour11h, n);
        case "Ko":
          return s.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return (0, Mx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      var o = n.getUTCHours() >= 12;
      return o && s < 12 ? n.setUTCHours(s + 12, 0, 0, 0) : n.setUTCHours(s, 0, 0, 0), n;
    }
  }]), r;
}(oR.Parser);
Ic.Hour0To11Parser = uR;
var Nc = {}, Ko = X.default;
Object.defineProperty(Nc, "__esModule", {
  value: !0
});
Nc.Hour1To24Parser = void 0;
var dR = Ko(zt), cR = Ko(Yt), Ax = Ko(Ut), fR = Ko(Qt), pR = Ko(Zt), Dx = Ko(Wt), vR = qt, mR = Wr, Ix = At, hR = /* @__PURE__ */ function(e) {
  (0, fR.default)(r, e);
  var t = (0, pR.default)(r);
  function r() {
    var a;
    (0, dR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Dx.default)((0, Ax.default)(a), "priority", 70), (0, Dx.default)((0, Ax.default)(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return (0, cR.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "k":
          return (0, Ix.parseNumericPattern)(mR.numericPatterns.hour24h, n);
        case "ko":
          return s.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return (0, Ix.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      var o = s <= 24 ? s % 24 : s;
      return n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), r;
}(vR.Parser);
Nc.Hour1To24Parser = hR;
var $c = {}, Jo = X.default;
Object.defineProperty($c, "__esModule", {
  value: !0
});
$c.MinuteParser = void 0;
var gR = Jo(zt), bR = Jo(Yt), Nx = Jo(Ut), yR = Jo(Qt), _R = Jo(Zt), $x = Jo(Wt), xR = qt, wR = Wr, Lx = At, TR = /* @__PURE__ */ function(e) {
  (0, yR.default)(r, e);
  var t = (0, _R.default)(r);
  function r() {
    var a;
    (0, gR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, $x.default)((0, Nx.default)(a), "priority", 60), (0, $x.default)((0, Nx.default)(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return (0, bR.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "m":
          return (0, Lx.parseNumericPattern)(wR.numericPatterns.minute, n);
        case "mo":
          return s.ordinalNumber(n, {
            unit: "minute"
          });
        default:
          return (0, Lx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMinutes(s, 0, 0), n;
    }
  }]), r;
}(xR.Parser);
$c.MinuteParser = TR;
var Lc = {}, Qo = X.default;
Object.defineProperty(Lc, "__esModule", {
  value: !0
});
Lc.SecondParser = void 0;
var SR = Qo(zt), ER = Qo(Yt), Rx = Qo(Ut), OR = Qo(Qt), CR = Qo(Zt), jx = Qo(Wt), kR = qt, PR = Wr, Fx = At, MR = /* @__PURE__ */ function(e) {
  (0, OR.default)(r, e);
  var t = (0, CR.default)(r);
  function r() {
    var a;
    (0, SR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, jx.default)((0, Rx.default)(a), "priority", 50), (0, jx.default)((0, Rx.default)(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return (0, ER.default)(r, [{
    key: "parse",
    value: function(n, i, s) {
      switch (i) {
        case "s":
          return (0, Fx.parseNumericPattern)(PR.numericPatterns.second, n);
        case "so":
          return s.ordinalNumber(n, {
            unit: "second"
          });
        default:
          return (0, Fx.parseNDigits)(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCSeconds(s, 0), n;
    }
  }]), r;
}(kR.Parser);
Lc.SecondParser = MR;
var Rc = {}, Zo = X.default;
Object.defineProperty(Rc, "__esModule", {
  value: !0
});
Rc.FractionOfSecondParser = void 0;
var AR = Zo(zt), DR = Zo(Yt), Bx = Zo(Ut), IR = Zo(Qt), NR = Zo(Zt), qx = Zo(Wt), $R = qt, Hx = At, LR = /* @__PURE__ */ function(e) {
  (0, IR.default)(r, e);
  var t = (0, NR.default)(r);
  function r() {
    var a;
    (0, AR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, qx.default)((0, Bx.default)(a), "priority", 30), (0, qx.default)((0, Bx.default)(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return (0, DR.default)(r, [{
    key: "parse",
    value: function(n, i) {
      var s = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return (0, Hx.mapValue)((0, Hx.parseNDigits)(i.length, n), s);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return n.setUTCMilliseconds(s), n;
    }
  }]), r;
}($R.Parser);
Rc.FractionOfSecondParser = LR;
var jc = {}, el = X.default;
Object.defineProperty(jc, "__esModule", {
  value: !0
});
jc.ISOTimezoneWithZParser = void 0;
var RR = el(zt), jR = el(Yt), Vx = el(Ut), FR = el(Qt), BR = el(Zt), Ux = el(Wt), qR = qt, gl = Wr, bl = At, HR = /* @__PURE__ */ function(e) {
  (0, FR.default)(r, e);
  var t = (0, BR.default)(r);
  function r() {
    var a;
    (0, RR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Ux.default)((0, Vx.default)(a), "priority", 10), (0, Ux.default)((0, Vx.default)(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return (0, jR.default)(r, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "X":
          return (0, bl.parseTimezonePattern)(gl.timezonePatterns.basicOptionalMinutes, n);
        case "XX":
          return (0, bl.parseTimezonePattern)(gl.timezonePatterns.basic, n);
        case "XXXX":
          return (0, bl.parseTimezonePattern)(gl.timezonePatterns.basicOptionalSeconds, n);
        case "XXXXX":
          return (0, bl.parseTimezonePattern)(gl.timezonePatterns.extendedOptionalSeconds, n);
        case "XXX":
        default:
          return (0, bl.parseTimezonePattern)(gl.timezonePatterns.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return i.timestampIsSet ? n : new Date(n.getTime() - s);
    }
  }]), r;
}(qR.Parser);
jc.ISOTimezoneWithZParser = HR;
var Fc = {}, tl = X.default;
Object.defineProperty(Fc, "__esModule", {
  value: !0
});
Fc.ISOTimezoneParser = void 0;
var VR = tl(zt), UR = tl(Yt), zx = tl(Ut), zR = tl(Qt), YR = tl(Zt), Yx = tl(Wt), WR = qt, yl = Wr, _l = At, GR = /* @__PURE__ */ function(e) {
  (0, zR.default)(r, e);
  var t = (0, YR.default)(r);
  function r() {
    var a;
    (0, VR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Yx.default)((0, zx.default)(a), "priority", 10), (0, Yx.default)((0, zx.default)(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return (0, UR.default)(r, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "x":
          return (0, _l.parseTimezonePattern)(yl.timezonePatterns.basicOptionalMinutes, n);
        case "xx":
          return (0, _l.parseTimezonePattern)(yl.timezonePatterns.basic, n);
        case "xxxx":
          return (0, _l.parseTimezonePattern)(yl.timezonePatterns.basicOptionalSeconds, n);
        case "xxxxx":
          return (0, _l.parseTimezonePattern)(yl.timezonePatterns.extendedOptionalSeconds, n);
        case "xxx":
        default:
          return (0, _l.parseTimezonePattern)(yl.timezonePatterns.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return i.timestampIsSet ? n : new Date(n.getTime() - s);
    }
  }]), r;
}(WR.Parser);
Fc.ISOTimezoneParser = GR;
var Bc = {}, rl = X.default;
Object.defineProperty(Bc, "__esModule", {
  value: !0
});
Bc.TimestampSecondsParser = void 0;
var XR = rl(zt), KR = rl(Yt), Wx = rl(Ut), JR = rl(Qt), QR = rl(Zt), Gx = rl(Wt), ZR = qt, ej = At, tj = /* @__PURE__ */ function(e) {
  (0, JR.default)(r, e);
  var t = (0, QR.default)(r);
  function r() {
    var a;
    (0, XR.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Gx.default)((0, Wx.default)(a), "priority", 40), (0, Gx.default)((0, Wx.default)(a), "incompatibleTokens", "*"), a;
  }
  return (0, KR.default)(r, [{
    key: "parse",
    value: function(n) {
      return (0, ej.parseAnyDigitsSigned)(n);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(ZR.Parser);
Bc.TimestampSecondsParser = tj;
var qc = {}, al = X.default;
Object.defineProperty(qc, "__esModule", {
  value: !0
});
qc.TimestampMillisecondsParser = void 0;
var rj = al(zt), aj = al(Yt), Xx = al(Ut), nj = al(Qt), ij = al(Zt), Kx = al(Wt), sj = qt, oj = At, lj = /* @__PURE__ */ function(e) {
  (0, nj.default)(r, e);
  var t = (0, ij.default)(r);
  function r() {
    var a;
    (0, rj.default)(this, r);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(i)), (0, Kx.default)((0, Xx.default)(a), "priority", 20), (0, Kx.default)((0, Xx.default)(a), "incompatibleTokens", "*"), a;
  }
  return (0, aj.default)(r, [{
    key: "parse",
    value: function(n) {
      return (0, oj.parseAnyDigitsSigned)(n);
    }
  }, {
    key: "set",
    value: function(n, i, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(sj.Parser);
qc.TimestampMillisecondsParser = lj;
Object.defineProperty(dc, "__esModule", {
  value: !0
});
dc.parsers = void 0;
var uj = cc, dj = fc, cj = pc, fj = vc, pj = mc, vj = hc, mj = gc, hj = bc, gj = yc, bj = _c, yj = xc, _j = wc, xj = Tc, wj = Sc, Tj = Ec, Sj = Oc, Ej = Cc, Oj = kc, Cj = Pc, kj = Mc, Pj = Ac, Mj = Dc, Aj = Ic, Dj = Nc, Ij = $c, Nj = Lc, $j = Rc, Lj = jc, Rj = Fc, jj = Bc, Fj = qc, Bj = {
  G: new uj.EraParser(),
  y: new dj.YearParser(),
  Y: new cj.LocalWeekYearParser(),
  R: new fj.ISOWeekYearParser(),
  u: new pj.ExtendedYearParser(),
  Q: new vj.QuarterParser(),
  q: new mj.StandAloneQuarterParser(),
  M: new hj.MonthParser(),
  L: new gj.StandAloneMonthParser(),
  w: new bj.LocalWeekParser(),
  I: new yj.ISOWeekParser(),
  d: new _j.DateParser(),
  D: new xj.DayOfYearParser(),
  E: new wj.DayParser(),
  e: new Tj.LocalDayParser(),
  c: new Sj.StandAloneLocalDayParser(),
  i: new Ej.ISODayParser(),
  a: new Oj.AMPMParser(),
  b: new Cj.AMPMMidnightParser(),
  B: new kj.DayPeriodParser(),
  h: new Pj.Hour1to12Parser(),
  H: new Mj.Hour0to23Parser(),
  K: new Aj.Hour0To11Parser(),
  k: new Dj.Hour1To24Parser(),
  m: new Ij.MinuteParser(),
  s: new Nj.SecondParser(),
  S: new $j.FractionOfSecondParser(),
  X: new Lj.ISOTimezoneWithZParser(),
  x: new Rj.ISOTimezoneParser(),
  t: new jj.TimestampSecondsParser(),
  T: new Fj.TimestampMillisecondsParser()
};
dc.parsers = Bj;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = k;
  var a = r(On), n = r(L8), i = r(Io), s = r(Su), o = r(Ce), l = r(Cu), u = r(gE), d = r(Li), f = Do, c = r(pt), p = r(re), v = Ti, h = dc, g = Lr, m = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, b = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, y = /^'([^]*?)'?$/, _ = /''/g, x = /\S/, w = /[a-zA-Z]/;
  function k(P, A, E, O) {
    var T, D, $, I, F, j, M, q, le, Z, G, H, W, ie, we, Be, Ve, et;
    (0, p.default)(3, arguments);
    var nt = String(P), xe = String(A), J = (0, g.getDefaultOptions)(), se = (T = (D = O == null ? void 0 : O.locale) !== null && D !== void 0 ? D : J.locale) !== null && T !== void 0 ? T : i.default;
    if (!se.match)
      throw new RangeError("locale must contain match property");
    var _e = (0, c.default)(($ = (I = (F = (j = O == null ? void 0 : O.firstWeekContainsDate) !== null && j !== void 0 ? j : O == null || (M = O.locale) === null || M === void 0 || (q = M.options) === null || q === void 0 ? void 0 : q.firstWeekContainsDate) !== null && F !== void 0 ? F : J.firstWeekContainsDate) !== null && I !== void 0 ? I : (le = J.locale) === null || le === void 0 || (Z = le.options) === null || Z === void 0 ? void 0 : Z.firstWeekContainsDate) !== null && $ !== void 0 ? $ : 1);
    if (!(_e >= 1 && _e <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var Se = (0, c.default)((G = (H = (W = (ie = O == null ? void 0 : O.weekStartsOn) !== null && ie !== void 0 ? ie : O == null || (we = O.locale) === null || we === void 0 || (Be = we.options) === null || Be === void 0 ? void 0 : Be.weekStartsOn) !== null && W !== void 0 ? W : J.weekStartsOn) !== null && H !== void 0 ? H : (Ve = J.locale) === null || Ve === void 0 || (et = Ve.options) === null || et === void 0 ? void 0 : et.weekStartsOn) !== null && G !== void 0 ? G : 0);
    if (!(Se >= 0 && Se <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (xe === "")
      return nt === "" ? (0, o.default)(E) : /* @__PURE__ */ new Date(NaN);
    var Re = {
      firstWeekContainsDate: _e,
      weekStartsOn: Se,
      locale: se
    }, rt = [new v.DateToSystemTimezoneSetter()], Dt = xe.match(b).map(function(Y) {
      var de = Y[0];
      if (de in u.default) {
        var Ne = u.default[de];
        return Ne(Y, se.formatLong);
      }
      return Y;
    }).join("").match(m), It = [], Ye = (0, n.default)(Dt), at;
    try {
      var ut = function() {
        var de = at.value;
        !(O != null && O.useAdditionalWeekYearTokens) && (0, f.isProtectedWeekYearToken)(de) && (0, f.throwProtectedError)(de, xe, P), !(O != null && O.useAdditionalDayOfYearTokens) && (0, f.isProtectedDayOfYearToken)(de) && (0, f.throwProtectedError)(de, xe, P);
        var Ne = de[0], We = h.parsers[Ne];
        if (We) {
          var mt = We.incompatibleTokens;
          if (Array.isArray(mt)) {
            var Nt = It.find(function(me) {
              return mt.includes(me.token) || me.token === Ne;
            });
            if (Nt)
              throw new RangeError("The format string mustn't contain `".concat(Nt.fullToken, "` and `").concat(de, "` at the same time"));
          } else if (We.incompatibleTokens === "*" && It.length > 0)
            throw new RangeError("The format string mustn't contain `".concat(de, "` and any other token at the same time"));
          It.push({
            token: Ne,
            fullToken: de
          });
          var St = We.run(nt, de, se.match, Re);
          if (!St)
            return {
              v: /* @__PURE__ */ new Date(NaN)
            };
          rt.push(St.setter), nt = St.rest;
        } else {
          if (Ne.match(w))
            throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ne + "`");
          if (de === "''" ? de = "'" : Ne === "'" && (de = S(de)), nt.indexOf(de) === 0)
            nt = nt.slice(de.length);
          else
            return {
              v: /* @__PURE__ */ new Date(NaN)
            };
        }
      };
      for (Ye.s(); !(at = Ye.n()).done; ) {
        var Gt = ut();
        if ((0, a.default)(Gt) === "object")
          return Gt.v;
      }
    } catch (Y) {
      Ye.e(Y);
    } finally {
      Ye.f();
    }
    if (nt.length > 0 && x.test(nt))
      return /* @__PURE__ */ new Date(NaN);
    var Je = rt.map(function(Y) {
      return Y.priority;
    }).sort(function(Y, de) {
      return de - Y;
    }).filter(function(Y, de, Ne) {
      return Ne.indexOf(Y) === de;
    }).map(function(Y) {
      return rt.filter(function(de) {
        return de.priority === Y;
      }).sort(function(de, Ne) {
        return Ne.subPriority - de.subPriority;
      });
    }).map(function(Y) {
      return Y[0];
    }), he = (0, o.default)(E);
    if (isNaN(he.getTime()))
      return /* @__PURE__ */ new Date(NaN);
    var ye = (0, s.default)(he, (0, d.default)(he)), Ke = {}, Q = (0, n.default)(Je), L;
    try {
      for (Q.s(); !(L = Q.n()).done; ) {
        var Te = L.value;
        if (!Te.validate(ye, Re))
          return /* @__PURE__ */ new Date(NaN);
        var Oe = Te.set(ye, Ke, Re);
        Array.isArray(Oe) ? (ye = Oe[0], (0, l.default)(Ke, Oe[1])) : ye = Oe;
      }
    } catch (Y) {
      Q.e(Y);
    } finally {
      Q.f();
    }
    return ye;
  }
  function S(P) {
    return P.match(y)[1].replace(_, "'");
  }
  e.exports = t.default;
})(Wh, Wh.exports);
var XE = Wh.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(XE), n = r(is), i = r(re);
  function s(o, l, u) {
    return (0, i.default)(2, arguments), (0, n.default)((0, a.default)(o, l, /* @__PURE__ */ new Date(), u));
  }
  e.exports = t.default;
})(Yh, Yh.exports);
var qj = Yh.exports, Qh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 1;
  }
  e.exports = t.default;
})(Qh, Qh.exports);
var Hj = Qh.exports, Zh = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getTime() < Date.now();
  }
  e.exports = t.default;
})(Zh, Zh.exports);
var Vj = Zh.exports, eg = { exports: {} }, tg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setMinutes(0, 0, 0), o;
  }
  e.exports = t.default;
})(tg, tg.exports);
var KE = tg.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(KE), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(eg, eg.exports);
var JE = eg.exports, rg = { exports: {} }, ag = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(as), n = r(re);
  function i(s, o, l) {
    (0, n.default)(2, arguments);
    var u = (0, a.default)(s, l), d = (0, a.default)(o, l);
    return u.getTime() === d.getTime();
  }
  e.exports = t.default;
})(ag, ag.exports);
var Mb = ag.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Mb), n = r(re);
  function i(s, o) {
    return (0, n.default)(2, arguments), (0, a.default)(s, o, {
      weekStartsOn: 1
    });
  }
  e.exports = t.default;
})(rg, rg.exports);
var QE = rg.exports, ng = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(wu), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(ng, ng.exports);
var Uj = ng.exports, ig = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(yb), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(ig, ig.exports);
var ZE = ig.exports, sg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getFullYear() === u.getFullYear() && l.getMonth() === u.getMonth();
  }
  e.exports = t.default;
})(sg, sg.exports);
var eO = sg.exports, og = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(_b), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(og, og.exports);
var tO = og.exports, lg = { exports: {} }, ug = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s);
    return o.setMilliseconds(0), o;
  }
  e.exports = t.default;
})(ug, ug.exports);
var rO = ug.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(rO), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getTime() === u.getTime();
  }
  e.exports = t.default;
})(lg, lg.exports);
var aO = lg.exports, dg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s), u = (0, a.default)(o);
    return l.getFullYear() === u.getFullYear();
  }
  e.exports = t.default;
})(dg, dg.exports);
var nO = dg.exports, cg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(JE), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(Date.now(), s);
  }
  e.exports = t.default;
})(cg, cg.exports);
var zj = cg.exports, fg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(QE), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now());
  }
  e.exports = t.default;
})(fg, fg.exports);
var Yj = fg.exports, pg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ZE), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(Date.now(), s);
  }
  e.exports = t.default;
})(pg, pg.exports);
var Wj = pg.exports, vg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(eO), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(Date.now(), s);
  }
  e.exports = t.default;
})(vg, vg.exports);
var Gj = vg.exports, mg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(tO), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(Date.now(), s);
  }
  e.exports = t.default;
})(mg, mg.exports);
var Xj = mg.exports, hg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(aO), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(Date.now(), s);
  }
  e.exports = t.default;
})(hg, hg.exports);
var Kj = hg.exports, gg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Mb), n = r(re);
  function i(s, o) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now(), o);
  }
  e.exports = t.default;
})(gg, gg.exports);
var Jj = gg.exports, bg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(nO), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now());
  }
  e.exports = t.default;
})(bg, bg.exports);
var Qj = bg.exports, yg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 4;
  }
  e.exports = t.default;
})(yg, yg.exports);
var Zj = yg.exports, _g = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Tu), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, Date.now());
  }
  e.exports = t.default;
})(_g, _g.exports);
var eF = _g.exports, xg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r($i), n = r(Tu), i = r(re);
  function s(o) {
    return (0, i.default)(1, arguments), (0, n.default)(o, (0, a.default)(Date.now(), 1));
  }
  e.exports = t.default;
})(xg, xg.exports);
var tF = xg.exports, wg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 2;
  }
  e.exports = t.default;
})(wg, wg.exports);
var rF = wg.exports, Tg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s).getDay() === 3;
  }
  e.exports = t.default;
})(Tg, Tg.exports);
var aF = Tg.exports, Sg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s, o) {
    (0, n.default)(2, arguments);
    var l = (0, a.default)(s).getTime(), u = (0, a.default)(o.start).getTime(), d = (0, a.default)(o.end).getTime();
    if (!(u <= d))
      throw new RangeError("Invalid interval");
    return l >= u && l <= d;
  }
  e.exports = t.default;
})(Sg, Sg.exports);
var nF = Sg.exports, Eg = { exports: {} }, Og = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r($i), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})(Og, Og.exports);
var Hc = Og.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Tu), n = r(Hc), i = r(re);
  function s(o) {
    return (0, i.default)(1, arguments), (0, a.default)(o, (0, n.default)(Date.now(), 1));
  }
  e.exports = t.default;
})(Eg, Eg.exports);
var iF = Eg.exports, Cg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear(), u = 9 + Math.floor(l / 10) * 10;
    return o.setFullYear(u + 1, 0, 0), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(Cg, Cg.exports);
var sF = Cg.exports, kg = { exports: {} }, Pg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(Ce), n = r(pt), i = r(re), s = Lr;
  function o(l, u) {
    var d, f, c, p, v, h, g, m;
    (0, i.default)(1, arguments);
    var b = (0, s.getDefaultOptions)(), y = (0, n.default)((d = (f = (c = (p = u == null ? void 0 : u.weekStartsOn) !== null && p !== void 0 ? p : u == null || (v = u.locale) === null || v === void 0 || (h = v.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && c !== void 0 ? c : b.weekStartsOn) !== null && f !== void 0 ? f : (g = b.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(y >= 0 && y <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6");
    var _ = (0, a.default)(l), x = _.getDay(), w = (x < y ? -7 : 0) + 6 - (x - y);
    return _.setHours(0, 0, 0, 0), _.setDate(_.getDate() + w), _;
  }
  e.exports = t.default;
})(Pg, Pg.exports);
var iO = Pg.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(iO), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, {
      weekStartsOn: 1
    });
  }
  e.exports = t.default;
})(kg, kg.exports);
var oF = kg.exports, Mg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Mo), n = r(Ls), i = r(re);
  function s(o) {
    (0, i.default)(1, arguments);
    var l = (0, a.default)(o), u = /* @__PURE__ */ new Date(0);
    u.setFullYear(l + 1, 0, 4), u.setHours(0, 0, 0, 0);
    var d = (0, n.default)(u);
    return d.setDate(d.getDate() - 1), d;
  }
  e.exports = t.default;
})(Mg, Mg.exports);
var lF = Mg.exports, Ag = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getMonth(), u = l - l % 3 + 3;
    return o.setMonth(u, 0), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(Ag, Ag.exports);
var uF = Ag.exports, Dg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear();
    return o.setFullYear(l + 1, 0, 0), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(Dg, Dg.exports);
var dF = Dg.exports, Ig = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var a = r(Ce), n = r(hE), i = r(Li), s = r(is), o = r(Su), l = r(re), u = /(\w)\1*|''|'(''|[^'])+('|$)|./g, d = /^'([^]*?)'?$/, f = /''/g, c = /[a-zA-Z]/;
  function p(h, g) {
    (0, l.default)(2, arguments);
    var m = (0, a.default)(h);
    if (!(0, s.default)(m))
      throw new RangeError("Invalid time value");
    var b = (0, i.default)(m), y = (0, o.default)(m, b), _ = g.match(u);
    if (!_)
      return "";
    var x = _.map(function(w) {
      if (w === "''")
        return "'";
      var k = w[0];
      if (k === "'")
        return v(w);
      var S = n.default[k];
      if (S)
        return S(y, w);
      if (k.match(c))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + k + "`");
      return w;
    }).join("");
    return x;
  }
  function v(h) {
    var g = h.match(d);
    return g ? g[1].replace(f, "'") : h;
  }
  e.exports = t.default;
})(Ig, Ig.exports);
var cF = Ig.exports, Ng = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = 365.2425;
  function i(s) {
    var o = s.years, l = s.months, u = s.weeks, d = s.days, f = s.hours, c = s.minutes, p = s.seconds;
    (0, a.default)(1, arguments);
    var v = 0;
    o && (v += o * n), l && (v += l * (n / 12)), u && (v += u * 7), d && (v += d);
    var h = v * 24 * 60 * 60;
    return f && (h += f * 60 * 60), c && (h += c * 60), p && (h += p), Math.round(h * 1e3);
  }
  e.exports = t.default;
})(Ng, Ng.exports);
var fF = Ng.exports, $g = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.millisecondsInHour;
    return Math.floor(o);
  }
  e.exports = t.default;
})($g, $g.exports);
var pF = $g.exports, Lg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.millisecondsInMinute;
    return Math.floor(o);
  }
  e.exports = t.default;
})(Lg, Lg.exports);
var vF = Lg.exports, Rg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.millisecondsInSecond;
    return Math.floor(o);
  }
  e.exports = t.default;
})(Rg, Rg.exports);
var mF = Rg.exports, jg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.minutesInHour;
    return Math.floor(o);
  }
  e.exports = t.default;
})(jg, jg.exports);
var hF = jg.exports, Fg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.millisecondsInMinute);
  }
  e.exports = t.default;
})(Fg, Fg.exports);
var gF = Fg.exports, Bg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.secondsInMinute);
  }
  e.exports = t.default;
})(Bg, Bg.exports);
var bF = Bg.exports, qg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.monthsInQuarter;
    return Math.floor(o);
  }
  e.exports = t.default;
})(qg, qg.exports);
var yF = qg.exports, Hg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.monthsInYear;
    return Math.floor(o);
  }
  e.exports = t.default;
})(Hg, Hg.exports);
var _F = Hg.exports, Vg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r($i), n = r(uc), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = l - (0, n.default)(o);
    return u <= 0 && (u += 7), (0, a.default)(o, u);
  }
  e.exports = t.default;
})(Vg, Vg.exports);
var ds = Vg.exports, Ug = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 5);
  }
  e.exports = t.default;
})(Ug, Ug.exports);
var xF = Ug.exports, zg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 1);
  }
  e.exports = t.default;
})(zg, zg.exports);
var wF = zg.exports, Yg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 6);
  }
  e.exports = t.default;
})(Yg, Yg.exports);
var TF = Yg.exports, Wg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 0);
  }
  e.exports = t.default;
})(Wg, Wg.exports);
var SF = Wg.exports, Gg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 4);
  }
  e.exports = t.default;
})(Gg, Gg.exports);
var EF = Gg.exports, Xg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 2);
  }
  e.exports = t.default;
})(Xg, Xg.exports);
var OF = Xg.exports, Kg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(ds), n = r(re);
  function i(s) {
    return (0, n.default)(1, arguments), (0, a.default)(s, 3);
  }
  e.exports = t.default;
})(Kg, Kg.exports);
var CF = Kg.exports, Jg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = dt, n = r(re), i = r(pt);
  function s(A, E) {
    var O;
    (0, n.default)(1, arguments);
    var T = (0, i.default)((O = E == null ? void 0 : E.additionalDigits) !== null && O !== void 0 ? O : 2);
    if (T !== 2 && T !== 1 && T !== 0)
      throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof A == "string" || Object.prototype.toString.call(A) === "[object String]"))
      return /* @__PURE__ */ new Date(NaN);
    var D = f(A), $;
    if (D.date) {
      var I = c(D.date, T);
      $ = p(I.restDateString, I.year);
    }
    if (!$ || isNaN($.getTime()))
      return /* @__PURE__ */ new Date(NaN);
    var F = $.getTime(), j = 0, M;
    if (D.time && (j = h(D.time), isNaN(j)))
      return /* @__PURE__ */ new Date(NaN);
    if (D.timezone) {
      if (M = m(D.timezone), isNaN(M))
        return /* @__PURE__ */ new Date(NaN);
    } else {
      var q = new Date(F + j), le = /* @__PURE__ */ new Date(0);
      return le.setFullYear(q.getUTCFullYear(), q.getUTCMonth(), q.getUTCDate()), le.setHours(q.getUTCHours(), q.getUTCMinutes(), q.getUTCSeconds(), q.getUTCMilliseconds()), le;
    }
    return new Date(F + j + M);
  }
  var o = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  }, l = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, u = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, d = /^([+-])(\d{2})(?::?(\d{2}))?$/;
  function f(A) {
    var E = {}, O = A.split(o.dateTimeDelimiter), T;
    if (O.length > 2)
      return E;
    if (/:/.test(O[0]) ? T = O[0] : (E.date = O[0], T = O[1], o.timeZoneDelimiter.test(E.date) && (E.date = A.split(o.timeZoneDelimiter)[0], T = A.substr(E.date.length, A.length))), T) {
      var D = o.timezone.exec(T);
      D ? (E.time = T.replace(D[1], ""), E.timezone = D[1]) : E.time = T;
    }
    return E;
  }
  function c(A, E) {
    var O = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + E) + "})|(\\d{2}|[+-]\\d{" + (2 + E) + "})$)"), T = A.match(O);
    if (!T)
      return {
        year: NaN,
        restDateString: ""
      };
    var D = T[1] ? parseInt(T[1]) : null, $ = T[2] ? parseInt(T[2]) : null;
    return {
      year: $ === null ? D : $ * 100,
      restDateString: A.slice((T[1] || T[2]).length)
    };
  }
  function p(A, E) {
    if (E === null)
      return /* @__PURE__ */ new Date(NaN);
    var O = A.match(l);
    if (!O)
      return /* @__PURE__ */ new Date(NaN);
    var T = !!O[4], D = v(O[1]), $ = v(O[2]) - 1, I = v(O[3]), F = v(O[4]), j = v(O[5]) - 1;
    if (T)
      return k(E, F, j) ? b(E, F, j) : /* @__PURE__ */ new Date(NaN);
    var M = /* @__PURE__ */ new Date(0);
    return !x(E, $, I) || !w(E, D) ? /* @__PURE__ */ new Date(NaN) : (M.setUTCFullYear(E, $, Math.max(D, I)), M);
  }
  function v(A) {
    return A ? parseInt(A) : 1;
  }
  function h(A) {
    var E = A.match(u);
    if (!E)
      return NaN;
    var O = g(E[1]), T = g(E[2]), D = g(E[3]);
    return S(O, T, D) ? O * a.millisecondsInHour + T * a.millisecondsInMinute + D * 1e3 : NaN;
  }
  function g(A) {
    return A && parseFloat(A.replace(",", ".")) || 0;
  }
  function m(A) {
    if (A === "Z")
      return 0;
    var E = A.match(d);
    if (!E)
      return 0;
    var O = E[1] === "+" ? -1 : 1, T = parseInt(E[2]), D = E[3] && parseInt(E[3]) || 0;
    return P(T, D) ? O * (T * a.millisecondsInHour + D * a.millisecondsInMinute) : NaN;
  }
  function b(A, E, O) {
    var T = /* @__PURE__ */ new Date(0);
    T.setUTCFullYear(A, 0, 4);
    var D = T.getUTCDay() || 7, $ = (E - 1) * 7 + O + 1 - D;
    return T.setUTCDate(T.getUTCDate() + $), T;
  }
  var y = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function _(A) {
    return A % 400 === 0 || A % 4 === 0 && A % 100 !== 0;
  }
  function x(A, E, O) {
    return E >= 0 && E <= 11 && O >= 1 && O <= (y[E] || (_(A) ? 29 : 28));
  }
  function w(A, E) {
    return E >= 1 && E <= (_(A) ? 366 : 365);
  }
  function k(A, E, O) {
    return E >= 1 && E <= 53 && O >= 0 && O <= 6;
  }
  function S(A, E, O) {
    return A === 24 ? E === 0 && O === 0 : O >= 0 && O < 60 && E >= 0 && E < 60 && A >= 0 && A < 25;
  }
  function P(A, E) {
    return E >= 0 && E <= 59;
  }
  e.exports = t.default;
})(Jg, Jg.exports);
var kF = Jg.exports, Qg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    if ((0, n.default)(1, arguments), typeof s == "string") {
      var o = s.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
      return o ? new Date(Date.UTC(+o[1], +o[2] - 1, +o[3], +o[4] - (+o[9] || 0) * (o[8] == "-" ? -1 : 1), +o[5] - (+o[10] || 0) * (o[8] == "-" ? -1 : 1), +o[6], +((o[7] || "0") + "00").substring(0, 3))) : /* @__PURE__ */ new Date(NaN);
    }
    return (0, a.default)(s);
  }
  e.exports = t.default;
})(Qg, Qg.exports);
var PF = Qg.exports, Zg = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(re), n = r(uc), i = r(Hc);
  function s(o, l) {
    (0, a.default)(2, arguments);
    var u = (0, n.default)(o) - l;
    return u <= 0 && (u += 7), (0, i.default)(o, u);
  }
  e.exports = t.default;
})(Zg, Zg.exports);
var cs = Zg.exports, e0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 5);
  }
  e.exports = t.default;
})(e0, e0.exports);
var MF = e0.exports, t0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 1);
  }
  e.exports = t.default;
})(t0, t0.exports);
var AF = t0.exports, r0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 6);
  }
  e.exports = t.default;
})(r0, r0.exports);
var DF = r0.exports, a0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 0);
  }
  e.exports = t.default;
})(a0, a0.exports);
var IF = a0.exports, n0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 4);
  }
  e.exports = t.default;
})(n0, n0.exports);
var NF = n0.exports, i0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 2);
  }
  e.exports = t.default;
})(i0, i0.exports);
var $F = i0.exports, s0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = r(cs);
  function i(s) {
    return (0, a.default)(1, arguments), (0, n.default)(s, 3);
  }
  e.exports = t.default;
})(s0, s0.exports);
var LF = s0.exports, o0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.monthsInQuarter);
  }
  e.exports = t.default;
})(o0, o0.exports);
var RF = o0.exports, l0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.quartersInYear;
    return Math.floor(o);
  }
  e.exports = t.default;
})(l0, l0.exports);
var jF = l0.exports, u0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(Ce), n = ss, i = r(pt);
  function s(o, l) {
    var u;
    if (arguments.length < 1)
      throw new TypeError("1 argument required, but only none provided present");
    var d = (0, i.default)((u = l == null ? void 0 : l.nearestTo) !== null && u !== void 0 ? u : 1);
    if (d < 1 || d > 30)
      throw new RangeError("`options.nearestTo` must be between 1 and 30");
    var f = (0, a.default)(o), c = f.getSeconds(), p = f.getMinutes() + c / 60, v = (0, n.getRoundingMethod)(l == null ? void 0 : l.roundingMethod), h = v(p / d) * d, g = p % d, m = Math.round(g / d) * d;
    return new Date(f.getFullYear(), f.getMonth(), f.getDate(), f.getHours(), h + m);
  }
  e.exports = t.default;
})(u0, u0.exports);
var FF = u0.exports, d0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.secondsInHour;
    return Math.floor(o);
  }
  e.exports = t.default;
})(d0, d0.exports);
var BF = d0.exports, c0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), s * n.millisecondsInSecond;
  }
  e.exports = t.default;
})(c0, c0.exports);
var qF = c0.exports, f0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    (0, a.default)(1, arguments);
    var o = s / n.secondsInMinute;
    return Math.floor(o);
  }
  e.exports = t.default;
})(f0, f0.exports);
var HF = f0.exports, p0 = { exports: {} }, v0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Ce), i = r(TE), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, a.default)(u), c = d.getFullYear(), p = d.getDate(), v = /* @__PURE__ */ new Date(0);
    v.setFullYear(c, f, 15), v.setHours(0, 0, 0, 0);
    var h = (0, i.default)(v);
    return d.setMonth(f, Math.min(p, h)), d;
  }
  e.exports = t.default;
})(v0, v0.exports);
var Ab = v0.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(On), n = r(Ce), i = r(Ab), s = r(pt), o = r(re);
  function l(u, d) {
    if ((0, o.default)(2, arguments), (0, a.default)(d) !== "object" || d === null)
      throw new RangeError("values parameter must be an object");
    var f = (0, n.default)(u);
    return isNaN(f.getTime()) ? /* @__PURE__ */ new Date(NaN) : (d.year != null && f.setFullYear(d.year), d.month != null && (f = (0, i.default)(f, d.month)), d.date != null && f.setDate((0, s.default)(d.date)), d.hours != null && f.setHours((0, s.default)(d.hours)), d.minutes != null && f.setMinutes((0, s.default)(d.minutes)), d.seconds != null && f.setSeconds((0, s.default)(d.seconds)), d.milliseconds != null && f.setMilliseconds((0, s.default)(d.milliseconds)), f);
  }
  e.exports = t.default;
})(p0, p0.exports);
var VF = p0.exports, m0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setDate(d), u;
  }
  e.exports = t.default;
})(m0, m0.exports);
var UF = m0.exports, h0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r($i), n = r(Ce), i = r(pt), s = r(re), o = Lr;
  function l(u, d, f) {
    var c, p, v, h, g, m, b, y;
    (0, s.default)(2, arguments);
    var _ = (0, o.getDefaultOptions)(), x = (0, i.default)((c = (p = (v = (h = f == null ? void 0 : f.weekStartsOn) !== null && h !== void 0 ? h : f == null || (g = f.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && v !== void 0 ? v : _.weekStartsOn) !== null && p !== void 0 ? p : (b = _.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && c !== void 0 ? c : 0);
    if (!(x >= 0 && x <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var w = (0, n.default)(u), k = (0, i.default)(d), S = w.getDay(), P = k % 7, A = (P + 7) % 7, E = 7 - x, O = k < 0 || k > 6 ? k - (S + E) % 7 : (A + E) % 7 - (S + E) % 7;
    return (0, a.default)(w, O);
  }
  e.exports = t.default;
})(h0, h0.exports);
var zF = h0.exports, g0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setMonth(0), u.setDate(d), u;
  }
  e.exports = t.default;
})(g0, g0.exports);
var YF = g0.exports, b0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = Lr, n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = {}, l = (0, a.getDefaultOptions)();
    for (var u in l)
      Object.prototype.hasOwnProperty.call(l, u) && (o[u] = l[u]);
    for (var d in s)
      Object.prototype.hasOwnProperty.call(s, d) && (s[d] === void 0 ? delete o[d] : o[d] = s[d]);
    (0, a.setDefaultOptions)(o);
  }
  e.exports = t.default;
})(b0, b0.exports);
var WF = b0.exports, y0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setHours(d), u;
  }
  e.exports = t.default;
})(y0, y0.exports);
var GF = y0.exports, _0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(pt), n = r(Ce), i = r($i), s = r(EE), o = r(re);
  function l(u, d) {
    (0, o.default)(2, arguments);
    var f = (0, n.default)(u), c = (0, a.default)(d), p = (0, s.default)(f), v = c - p;
    return (0, i.default)(f, v);
  }
  e.exports = t.default;
})(_0, _0.exports);
var XF = _0.exports, x0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Ce), i = r(OE), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, a.default)(u), c = (0, i.default)(d) - f;
    return d.setDate(d.getDate() - c * 7), d;
  }
  e.exports = t.default;
})(x0, x0.exports);
var KF = x0.exports, w0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setMilliseconds(d), u;
  }
  e.exports = t.default;
})(w0, w0.exports);
var JF = w0.exports, T0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setMinutes(d), u;
  }
  e.exports = t.default;
})(T0, T0.exports);
var QF = T0.exports, S0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(pt), n = r(Ce), i = r(Ab), s = r(re);
  function o(l, u) {
    (0, s.default)(2, arguments);
    var d = (0, n.default)(l), f = (0, a.default)(u), c = Math.floor(d.getMonth() / 3) + 1, p = f - c;
    return (0, i.default)(d, d.getMonth() + p * 3);
  }
  e.exports = t.default;
})(S0, S0.exports);
var ZF = S0.exports, E0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return u.setSeconds(d), u;
  }
  e.exports = t.default;
})(E0, E0.exports);
var eB = E0.exports, O0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var a = r(PE), n = r(Ce), i = r(re), s = r(pt);
  function o(l, u, d) {
    (0, i.default)(2, arguments);
    var f = (0, n.default)(l), c = (0, s.default)(u), p = (0, a.default)(f, d) - c;
    return f.setDate(f.getDate() - p * 7), f;
  }
  e.exports = t.default;
})(O0, O0.exports);
var tB = O0.exports, C0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var a = r(ns), n = r(Sb), i = r(Ce), s = r(pt), o = r(re), l = Lr;
  function u(d, f, c) {
    var p, v, h, g, m, b, y, _;
    (0, o.default)(2, arguments);
    var x = (0, l.getDefaultOptions)(), w = (0, s.default)((p = (v = (h = (g = c == null ? void 0 : c.firstWeekContainsDate) !== null && g !== void 0 ? g : c == null || (m = c.locale) === null || m === void 0 || (b = m.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && h !== void 0 ? h : x.firstWeekContainsDate) !== null && v !== void 0 ? v : (y = x.locale) === null || y === void 0 || (_ = y.options) === null || _ === void 0 ? void 0 : _.firstWeekContainsDate) !== null && p !== void 0 ? p : 1), k = (0, i.default)(d), S = (0, s.default)(f), P = (0, a.default)(k, (0, n.default)(k, c)), A = /* @__PURE__ */ new Date(0);
    return A.setFullYear(S, 0, w), A.setHours(0, 0, 0, 0), k = (0, n.default)(A, c), k.setDate(k.getDate() + P), k;
  }
  e.exports = t.default;
})(C0, C0.exports);
var rB = C0.exports, k0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(Ce), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, n.default)(o), d = (0, a.default)(l);
    return isNaN(u.getTime()) ? /* @__PURE__ */ new Date(NaN) : (u.setFullYear(d), u);
  }
  e.exports = t.default;
})(k0, k0.exports);
var aB = k0.exports, P0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(Ce), n = r(re);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = (0, a.default)(s), l = o.getFullYear(), u = Math.floor(l / 10) * 10;
    return o.setFullYear(u, 0, 1), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(P0, P0.exports);
var nB = P0.exports, M0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(ac);
  function n() {
    return (0, a.default)(Date.now());
  }
  e.exports = t.default;
})(M0, M0.exports);
var iB = M0.exports, A0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var a = /* @__PURE__ */ new Date(), n = a.getFullYear(), i = a.getMonth(), s = a.getDate(), o = /* @__PURE__ */ new Date(0);
    return o.setFullYear(n, i, s + 1), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(A0, A0.exports);
var sB = A0.exports, D0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var a = /* @__PURE__ */ new Date(), n = a.getFullYear(), i = a.getMonth(), s = a.getDate(), o = /* @__PURE__ */ new Date(0);
    return o.setFullYear(n, i, s - 1), o.setHours(0, 0, 0, 0), o;
  }
  e.exports = t.default;
})(D0, D0.exports);
var oB = D0.exports, I0 = { exports: {} }, N0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(_u), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, -u);
  }
  e.exports = t.default;
})(N0, N0.exports);
var sO = N0.exports;
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var a = r(On), n = r(Hc), i = r(sO), s = r(re), o = r(pt);
  function l(u, d) {
    if ((0, s.default)(2, arguments), !d || (0, a.default)(d) !== "object")
      return /* @__PURE__ */ new Date(NaN);
    var f = d.years ? (0, o.default)(d.years) : 0, c = d.months ? (0, o.default)(d.months) : 0, p = d.weeks ? (0, o.default)(d.weeks) : 0, v = d.days ? (0, o.default)(d.days) : 0, h = d.hours ? (0, o.default)(d.hours) : 0, g = d.minutes ? (0, o.default)(d.minutes) : 0, m = d.seconds ? (0, o.default)(d.seconds) : 0, b = (0, i.default)(u, c + f * 12), y = (0, n.default)(b, v + p * 7), _ = g + h * 60, x = m + _ * 60, w = x * 1e3, k = new Date(y.getTime() - w);
    return k;
  }
  e.exports = t.default;
})(I0, I0.exports);
var lB = I0.exports, $0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(US), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})($0, $0.exports);
var uB = $0.exports, L0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(ob), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})(L0, L0.exports);
var dB = L0.exports, R0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(lb), n = r(re), i = r(pt);
  function s(o, l) {
    (0, n.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, a.default)(o, -u);
  }
  e.exports = t.default;
})(R0, R0.exports);
var cB = R0.exports, j0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(ub), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, -u);
  }
  e.exports = t.default;
})(j0, j0.exports);
var fB = j0.exports, F0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(GS), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, -u);
  }
  e.exports = t.default;
})(F0, F0.exports);
var pB = F0.exports, B0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(nc), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, -u);
  }
  e.exports = t.default;
})(B0, B0.exports);
var vB = B0.exports, q0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var a = r(pt), n = r(XS), i = r(re);
  function s(o, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(l);
    return (0, n.default)(o, -u);
  }
  e.exports = t.default;
})(q0, q0.exports);
var mB = q0.exports, H0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.daysInWeek);
  }
  e.exports = t.default;
})(H0, H0.exports);
var hB = H0.exports, V0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.monthsInYear);
  }
  e.exports = t.default;
})(V0, V0.exports);
var gB = V0.exports, U0 = { exports: {} };
(function(e, t) {
  var r = X.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var a = r(re), n = dt;
  function i(s) {
    return (0, a.default)(1, arguments), Math.floor(s * n.quartersInYear);
  }
  e.exports = t.default;
})(U0, U0.exports);
var bB = U0.exports;
(function(e) {
  var t = X.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = {
    add: !0,
    addBusinessDays: !0,
    addDays: !0,
    addHours: !0,
    addISOWeekYears: !0,
    addMilliseconds: !0,
    addMinutes: !0,
    addMonths: !0,
    addQuarters: !0,
    addSeconds: !0,
    addWeeks: !0,
    addYears: !0,
    areIntervalsOverlapping: !0,
    clamp: !0,
    closestIndexTo: !0,
    closestTo: !0,
    compareAsc: !0,
    compareDesc: !0,
    daysToWeeks: !0,
    differenceInBusinessDays: !0,
    differenceInCalendarDays: !0,
    differenceInCalendarISOWeekYears: !0,
    differenceInCalendarISOWeeks: !0,
    differenceInCalendarMonths: !0,
    differenceInCalendarQuarters: !0,
    differenceInCalendarWeeks: !0,
    differenceInCalendarYears: !0,
    differenceInDays: !0,
    differenceInHours: !0,
    differenceInISOWeekYears: !0,
    differenceInMilliseconds: !0,
    differenceInMinutes: !0,
    differenceInMonths: !0,
    differenceInQuarters: !0,
    differenceInSeconds: !0,
    differenceInWeeks: !0,
    differenceInYears: !0,
    eachDayOfInterval: !0,
    eachHourOfInterval: !0,
    eachMinuteOfInterval: !0,
    eachMonthOfInterval: !0,
    eachQuarterOfInterval: !0,
    eachWeekOfInterval: !0,
    eachWeekendOfInterval: !0,
    eachWeekendOfMonth: !0,
    eachWeekendOfYear: !0,
    eachYearOfInterval: !0,
    endOfDay: !0,
    endOfDecade: !0,
    endOfHour: !0,
    endOfISOWeek: !0,
    endOfISOWeekYear: !0,
    endOfMinute: !0,
    endOfMonth: !0,
    endOfQuarter: !0,
    endOfSecond: !0,
    endOfToday: !0,
    endOfTomorrow: !0,
    endOfWeek: !0,
    endOfYear: !0,
    endOfYesterday: !0,
    format: !0,
    formatDistance: !0,
    formatDistanceStrict: !0,
    formatDistanceToNow: !0,
    formatDistanceToNowStrict: !0,
    formatDuration: !0,
    formatISO: !0,
    formatISO9075: !0,
    formatISODuration: !0,
    formatRFC3339: !0,
    formatRFC7231: !0,
    formatRelative: !0,
    fromUnixTime: !0,
    getDate: !0,
    getDay: !0,
    getDayOfYear: !0,
    getDaysInMonth: !0,
    getDaysInYear: !0,
    getDecade: !0,
    getDefaultOptions: !0,
    getHours: !0,
    getISODay: !0,
    getISOWeek: !0,
    getISOWeekYear: !0,
    getISOWeeksInYear: !0,
    getMilliseconds: !0,
    getMinutes: !0,
    getMonth: !0,
    getOverlappingDaysInIntervals: !0,
    getQuarter: !0,
    getSeconds: !0,
    getTime: !0,
    getUnixTime: !0,
    getWeek: !0,
    getWeekOfMonth: !0,
    getWeekYear: !0,
    getWeeksInMonth: !0,
    getYear: !0,
    hoursToMilliseconds: !0,
    hoursToMinutes: !0,
    hoursToSeconds: !0,
    intervalToDuration: !0,
    intlFormat: !0,
    intlFormatDistance: !0,
    isAfter: !0,
    isBefore: !0,
    isDate: !0,
    isEqual: !0,
    isExists: !0,
    isFirstDayOfMonth: !0,
    isFriday: !0,
    isFuture: !0,
    isLastDayOfMonth: !0,
    isLeapYear: !0,
    isMatch: !0,
    isMonday: !0,
    isPast: !0,
    isSameDay: !0,
    isSameHour: !0,
    isSameISOWeek: !0,
    isSameISOWeekYear: !0,
    isSameMinute: !0,
    isSameMonth: !0,
    isSameQuarter: !0,
    isSameSecond: !0,
    isSameWeek: !0,
    isSameYear: !0,
    isSaturday: !0,
    isSunday: !0,
    isThisHour: !0,
    isThisISOWeek: !0,
    isThisMinute: !0,
    isThisMonth: !0,
    isThisQuarter: !0,
    isThisSecond: !0,
    isThisWeek: !0,
    isThisYear: !0,
    isThursday: !0,
    isToday: !0,
    isTomorrow: !0,
    isTuesday: !0,
    isValid: !0,
    isWednesday: !0,
    isWeekend: !0,
    isWithinInterval: !0,
    isYesterday: !0,
    lastDayOfDecade: !0,
    lastDayOfISOWeek: !0,
    lastDayOfISOWeekYear: !0,
    lastDayOfMonth: !0,
    lastDayOfQuarter: !0,
    lastDayOfWeek: !0,
    lastDayOfYear: !0,
    lightFormat: !0,
    max: !0,
    milliseconds: !0,
    millisecondsToHours: !0,
    millisecondsToMinutes: !0,
    millisecondsToSeconds: !0,
    min: !0,
    minutesToHours: !0,
    minutesToMilliseconds: !0,
    minutesToSeconds: !0,
    monthsToQuarters: !0,
    monthsToYears: !0,
    nextDay: !0,
    nextFriday: !0,
    nextMonday: !0,
    nextSaturday: !0,
    nextSunday: !0,
    nextThursday: !0,
    nextTuesday: !0,
    nextWednesday: !0,
    parse: !0,
    parseISO: !0,
    parseJSON: !0,
    previousDay: !0,
    previousFriday: !0,
    previousMonday: !0,
    previousSaturday: !0,
    previousSunday: !0,
    previousThursday: !0,
    previousTuesday: !0,
    previousWednesday: !0,
    quartersToMonths: !0,
    quartersToYears: !0,
    roundToNearestMinutes: !0,
    secondsToHours: !0,
    secondsToMilliseconds: !0,
    secondsToMinutes: !0,
    set: !0,
    setDate: !0,
    setDay: !0,
    setDayOfYear: !0,
    setDefaultOptions: !0,
    setHours: !0,
    setISODay: !0,
    setISOWeek: !0,
    setISOWeekYear: !0,
    setMilliseconds: !0,
    setMinutes: !0,
    setMonth: !0,
    setQuarter: !0,
    setSeconds: !0,
    setWeek: !0,
    setWeekYear: !0,
    setYear: !0,
    startOfDay: !0,
    startOfDecade: !0,
    startOfHour: !0,
    startOfISOWeek: !0,
    startOfISOWeekYear: !0,
    startOfMinute: !0,
    startOfMonth: !0,
    startOfQuarter: !0,
    startOfSecond: !0,
    startOfToday: !0,
    startOfTomorrow: !0,
    startOfWeek: !0,
    startOfWeekYear: !0,
    startOfYear: !0,
    startOfYesterday: !0,
    sub: !0,
    subBusinessDays: !0,
    subDays: !0,
    subHours: !0,
    subISOWeekYears: !0,
    subMilliseconds: !0,
    subMinutes: !0,
    subMonths: !0,
    subQuarters: !0,
    subSeconds: !0,
    subWeeks: !0,
    subYears: !0,
    toDate: !0,
    weeksToDays: !0,
    yearsToMonths: !0,
    yearsToQuarters: !0
  };
  Object.defineProperty(e, "add", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "addBusinessDays", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "addDays", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(e, "addHours", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(e, "addISOWeekYears", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(e, "addMilliseconds", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(e, "addMinutes", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), Object.defineProperty(e, "addMonths", {
    enumerable: !0,
    get: function() {
      return d.default;
    }
  }), Object.defineProperty(e, "addQuarters", {
    enumerable: !0,
    get: function() {
      return f.default;
    }
  }), Object.defineProperty(e, "addSeconds", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(e, "addWeeks", {
    enumerable: !0,
    get: function() {
      return p.default;
    }
  }), Object.defineProperty(e, "addYears", {
    enumerable: !0,
    get: function() {
      return v.default;
    }
  }), Object.defineProperty(e, "areIntervalsOverlapping", {
    enumerable: !0,
    get: function() {
      return h.default;
    }
  }), Object.defineProperty(e, "clamp", {
    enumerable: !0,
    get: function() {
      return g.default;
    }
  }), Object.defineProperty(e, "closestIndexTo", {
    enumerable: !0,
    get: function() {
      return m.default;
    }
  }), Object.defineProperty(e, "closestTo", {
    enumerable: !0,
    get: function() {
      return b.default;
    }
  }), Object.defineProperty(e, "compareAsc", {
    enumerable: !0,
    get: function() {
      return y.default;
    }
  }), Object.defineProperty(e, "compareDesc", {
    enumerable: !0,
    get: function() {
      return _.default;
    }
  }), Object.defineProperty(e, "daysToWeeks", {
    enumerable: !0,
    get: function() {
      return x.default;
    }
  }), Object.defineProperty(e, "differenceInBusinessDays", {
    enumerable: !0,
    get: function() {
      return w.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarDays", {
    enumerable: !0,
    get: function() {
      return k.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarISOWeekYears", {
    enumerable: !0,
    get: function() {
      return S.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarISOWeeks", {
    enumerable: !0,
    get: function() {
      return P.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarMonths", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarQuarters", {
    enumerable: !0,
    get: function() {
      return E.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarWeeks", {
    enumerable: !0,
    get: function() {
      return O.default;
    }
  }), Object.defineProperty(e, "differenceInCalendarYears", {
    enumerable: !0,
    get: function() {
      return T.default;
    }
  }), Object.defineProperty(e, "differenceInDays", {
    enumerable: !0,
    get: function() {
      return D.default;
    }
  }), Object.defineProperty(e, "differenceInHours", {
    enumerable: !0,
    get: function() {
      return $.default;
    }
  }), Object.defineProperty(e, "differenceInISOWeekYears", {
    enumerable: !0,
    get: function() {
      return I.default;
    }
  }), Object.defineProperty(e, "differenceInMilliseconds", {
    enumerable: !0,
    get: function() {
      return F.default;
    }
  }), Object.defineProperty(e, "differenceInMinutes", {
    enumerable: !0,
    get: function() {
      return j.default;
    }
  }), Object.defineProperty(e, "differenceInMonths", {
    enumerable: !0,
    get: function() {
      return M.default;
    }
  }), Object.defineProperty(e, "differenceInQuarters", {
    enumerable: !0,
    get: function() {
      return q.default;
    }
  }), Object.defineProperty(e, "differenceInSeconds", {
    enumerable: !0,
    get: function() {
      return le.default;
    }
  }), Object.defineProperty(e, "differenceInWeeks", {
    enumerable: !0,
    get: function() {
      return Z.default;
    }
  }), Object.defineProperty(e, "differenceInYears", {
    enumerable: !0,
    get: function() {
      return G.default;
    }
  }), Object.defineProperty(e, "eachDayOfInterval", {
    enumerable: !0,
    get: function() {
      return H.default;
    }
  }), Object.defineProperty(e, "eachHourOfInterval", {
    enumerable: !0,
    get: function() {
      return W.default;
    }
  }), Object.defineProperty(e, "eachMinuteOfInterval", {
    enumerable: !0,
    get: function() {
      return ie.default;
    }
  }), Object.defineProperty(e, "eachMonthOfInterval", {
    enumerable: !0,
    get: function() {
      return we.default;
    }
  }), Object.defineProperty(e, "eachQuarterOfInterval", {
    enumerable: !0,
    get: function() {
      return Be.default;
    }
  }), Object.defineProperty(e, "eachWeekOfInterval", {
    enumerable: !0,
    get: function() {
      return Ve.default;
    }
  }), Object.defineProperty(e, "eachWeekendOfInterval", {
    enumerable: !0,
    get: function() {
      return et.default;
    }
  }), Object.defineProperty(e, "eachWeekendOfMonth", {
    enumerable: !0,
    get: function() {
      return nt.default;
    }
  }), Object.defineProperty(e, "eachWeekendOfYear", {
    enumerable: !0,
    get: function() {
      return xe.default;
    }
  }), Object.defineProperty(e, "eachYearOfInterval", {
    enumerable: !0,
    get: function() {
      return J.default;
    }
  }), Object.defineProperty(e, "endOfDay", {
    enumerable: !0,
    get: function() {
      return se.default;
    }
  }), Object.defineProperty(e, "endOfDecade", {
    enumerable: !0,
    get: function() {
      return _e.default;
    }
  }), Object.defineProperty(e, "endOfHour", {
    enumerable: !0,
    get: function() {
      return Se.default;
    }
  }), Object.defineProperty(e, "endOfISOWeek", {
    enumerable: !0,
    get: function() {
      return Re.default;
    }
  }), Object.defineProperty(e, "endOfISOWeekYear", {
    enumerable: !0,
    get: function() {
      return rt.default;
    }
  }), Object.defineProperty(e, "endOfMinute", {
    enumerable: !0,
    get: function() {
      return Dt.default;
    }
  }), Object.defineProperty(e, "endOfMonth", {
    enumerable: !0,
    get: function() {
      return It.default;
    }
  }), Object.defineProperty(e, "endOfQuarter", {
    enumerable: !0,
    get: function() {
      return Ye.default;
    }
  }), Object.defineProperty(e, "endOfSecond", {
    enumerable: !0,
    get: function() {
      return at.default;
    }
  }), Object.defineProperty(e, "endOfToday", {
    enumerable: !0,
    get: function() {
      return ut.default;
    }
  }), Object.defineProperty(e, "endOfTomorrow", {
    enumerable: !0,
    get: function() {
      return Gt.default;
    }
  }), Object.defineProperty(e, "endOfWeek", {
    enumerable: !0,
    get: function() {
      return Je.default;
    }
  }), Object.defineProperty(e, "endOfYear", {
    enumerable: !0,
    get: function() {
      return he.default;
    }
  }), Object.defineProperty(e, "endOfYesterday", {
    enumerable: !0,
    get: function() {
      return ye.default;
    }
  }), Object.defineProperty(e, "format", {
    enumerable: !0,
    get: function() {
      return Ke.default;
    }
  }), Object.defineProperty(e, "formatDistance", {
    enumerable: !0,
    get: function() {
      return Q.default;
    }
  }), Object.defineProperty(e, "formatDistanceStrict", {
    enumerable: !0,
    get: function() {
      return L.default;
    }
  }), Object.defineProperty(e, "formatDistanceToNow", {
    enumerable: !0,
    get: function() {
      return Te.default;
    }
  }), Object.defineProperty(e, "formatDistanceToNowStrict", {
    enumerable: !0,
    get: function() {
      return Oe.default;
    }
  }), Object.defineProperty(e, "formatDuration", {
    enumerable: !0,
    get: function() {
      return Y.default;
    }
  }), Object.defineProperty(e, "formatISO", {
    enumerable: !0,
    get: function() {
      return de.default;
    }
  }), Object.defineProperty(e, "formatISO9075", {
    enumerable: !0,
    get: function() {
      return Ne.default;
    }
  }), Object.defineProperty(e, "formatISODuration", {
    enumerable: !0,
    get: function() {
      return We.default;
    }
  }), Object.defineProperty(e, "formatRFC3339", {
    enumerable: !0,
    get: function() {
      return mt.default;
    }
  }), Object.defineProperty(e, "formatRFC7231", {
    enumerable: !0,
    get: function() {
      return Nt.default;
    }
  }), Object.defineProperty(e, "formatRelative", {
    enumerable: !0,
    get: function() {
      return St.default;
    }
  }), Object.defineProperty(e, "fromUnixTime", {
    enumerable: !0,
    get: function() {
      return me.default;
    }
  }), Object.defineProperty(e, "getDate", {
    enumerable: !0,
    get: function() {
      return Ue.default;
    }
  }), Object.defineProperty(e, "getDay", {
    enumerable: !0,
    get: function() {
      return bt.default;
    }
  }), Object.defineProperty(e, "getDayOfYear", {
    enumerable: !0,
    get: function() {
      return _t.default;
    }
  }), Object.defineProperty(e, "getDaysInMonth", {
    enumerable: !0,
    get: function() {
      return pr.default;
    }
  }), Object.defineProperty(e, "getDaysInYear", {
    enumerable: !0,
    get: function() {
      return Ze.default;
    }
  }), Object.defineProperty(e, "getDecade", {
    enumerable: !0,
    get: function() {
      return vr.default;
    }
  }), Object.defineProperty(e, "getDefaultOptions", {
    enumerable: !0,
    get: function() {
      return yt.default;
    }
  }), Object.defineProperty(e, "getHours", {
    enumerable: !0,
    get: function() {
      return Xr.default;
    }
  }), Object.defineProperty(e, "getISODay", {
    enumerable: !0,
    get: function() {
      return La.default;
    }
  }), Object.defineProperty(e, "getISOWeek", {
    enumerable: !0,
    get: function() {
      return Ar.default;
    }
  }), Object.defineProperty(e, "getISOWeekYear", {
    enumerable: !0,
    get: function() {
      return rn.default;
    }
  }), Object.defineProperty(e, "getISOWeeksInYear", {
    enumerable: !0,
    get: function() {
      return Gn.default;
    }
  }), Object.defineProperty(e, "getMilliseconds", {
    enumerable: !0,
    get: function() {
      return pi.default;
    }
  }), Object.defineProperty(e, "getMinutes", {
    enumerable: !0,
    get: function() {
      return Cn.default;
    }
  }), Object.defineProperty(e, "getMonth", {
    enumerable: !0,
    get: function() {
      return Va.default;
    }
  }), Object.defineProperty(e, "getOverlappingDaysInIntervals", {
    enumerable: !0,
    get: function() {
      return Er.default;
    }
  }), Object.defineProperty(e, "getQuarter", {
    enumerable: !0,
    get: function() {
      return an.default;
    }
  }), Object.defineProperty(e, "getSeconds", {
    enumerable: !0,
    get: function() {
      return kn.default;
    }
  }), Object.defineProperty(e, "getTime", {
    enumerable: !0,
    get: function() {
      return Pn.default;
    }
  }), Object.defineProperty(e, "getUnixTime", {
    enumerable: !0,
    get: function() {
      return Xn.default;
    }
  }), Object.defineProperty(e, "getWeek", {
    enumerable: !0,
    get: function() {
      return Kn.default;
    }
  }), Object.defineProperty(e, "getWeekOfMonth", {
    enumerable: !0,
    get: function() {
      return Or.default;
    }
  }), Object.defineProperty(e, "getWeekYear", {
    enumerable: !0,
    get: function() {
      return Mn.default;
    }
  }), Object.defineProperty(e, "getWeeksInMonth", {
    enumerable: !0,
    get: function() {
      return xa.default;
    }
  }), Object.defineProperty(e, "getYear", {
    enumerable: !0,
    get: function() {
      return wa.default;
    }
  }), Object.defineProperty(e, "hoursToMilliseconds", {
    enumerable: !0,
    get: function() {
      return Ta.default;
    }
  }), Object.defineProperty(e, "hoursToMinutes", {
    enumerable: !0,
    get: function() {
      return Ua.default;
    }
  }), Object.defineProperty(e, "hoursToSeconds", {
    enumerable: !0,
    get: function() {
      return lr.default;
    }
  }), Object.defineProperty(e, "intervalToDuration", {
    enumerable: !0,
    get: function() {
      return vi.default;
    }
  }), Object.defineProperty(e, "intlFormat", {
    enumerable: !0,
    get: function() {
      return Jn.default;
    }
  }), Object.defineProperty(e, "intlFormatDistance", {
    enumerable: !0,
    get: function() {
      return nn.default;
    }
  }), Object.defineProperty(e, "isAfter", {
    enumerable: !0,
    get: function() {
      return Vr.default;
    }
  }), Object.defineProperty(e, "isBefore", {
    enumerable: !0,
    get: function() {
      return Ra.default;
    }
  }), Object.defineProperty(e, "isDate", {
    enumerable: !0,
    get: function() {
      return qr.default;
    }
  }), Object.defineProperty(e, "isEqual", {
    enumerable: !0,
    get: function() {
      return Ur.default;
    }
  }), Object.defineProperty(e, "isExists", {
    enumerable: !0,
    get: function() {
      return da.default;
    }
  }), Object.defineProperty(e, "isFirstDayOfMonth", {
    enumerable: !0,
    get: function() {
      return hr.default;
    }
  }), Object.defineProperty(e, "isFriday", {
    enumerable: !0,
    get: function() {
      return Kr.default;
    }
  }), Object.defineProperty(e, "isFuture", {
    enumerable: !0,
    get: function() {
      return Qn.default;
    }
  }), Object.defineProperty(e, "isLastDayOfMonth", {
    enumerable: !0,
    get: function() {
      return sn.default;
    }
  }), Object.defineProperty(e, "isLeapYear", {
    enumerable: !0,
    get: function() {
      return on.default;
    }
  }), Object.defineProperty(e, "isMatch", {
    enumerable: !0,
    get: function() {
      return Dr.default;
    }
  }), Object.defineProperty(e, "isMonday", {
    enumerable: !0,
    get: function() {
      return Xt.default;
    }
  }), Object.defineProperty(e, "isPast", {
    enumerable: !0,
    get: function() {
      return ia.default;
    }
  }), Object.defineProperty(e, "isSameDay", {
    enumerable: !0,
    get: function() {
      return Sa.default;
    }
  }), Object.defineProperty(e, "isSameHour", {
    enumerable: !0,
    get: function() {
      return ca.default;
    }
  }), Object.defineProperty(e, "isSameISOWeek", {
    enumerable: !0,
    get: function() {
      return za.default;
    }
  }), Object.defineProperty(e, "isSameISOWeekYear", {
    enumerable: !0,
    get: function() {
      return Ya.default;
    }
  }), Object.defineProperty(e, "isSameMinute", {
    enumerable: !0,
    get: function() {
      return Jr.default;
    }
  }), Object.defineProperty(e, "isSameMonth", {
    enumerable: !0,
    get: function() {
      return Ea.default;
    }
  }), Object.defineProperty(e, "isSameQuarter", {
    enumerable: !0,
    get: function() {
      return An.default;
    }
  }), Object.defineProperty(e, "isSameSecond", {
    enumerable: !0,
    get: function() {
      return ln.default;
    }
  }), Object.defineProperty(e, "isSameWeek", {
    enumerable: !0,
    get: function() {
      return Oa.default;
    }
  }), Object.defineProperty(e, "isSameYear", {
    enumerable: !0,
    get: function() {
      return mi.default;
    }
  }), Object.defineProperty(e, "isSaturday", {
    enumerable: !0,
    get: function() {
      return hi.default;
    }
  }), Object.defineProperty(e, "isSunday", {
    enumerable: !0,
    get: function() {
      return B.default;
    }
  }), Object.defineProperty(e, "isThisHour", {
    enumerable: !0,
    get: function() {
      return z.default;
    }
  }), Object.defineProperty(e, "isThisISOWeek", {
    enumerable: !0,
    get: function() {
      return ae.default;
    }
  }), Object.defineProperty(e, "isThisMinute", {
    enumerable: !0,
    get: function() {
      return be.default;
    }
  }), Object.defineProperty(e, "isThisMonth", {
    enumerable: !0,
    get: function() {
      return $e.default;
    }
  }), Object.defineProperty(e, "isThisQuarter", {
    enumerable: !0,
    get: function() {
      return Ge.default;
    }
  }), Object.defineProperty(e, "isThisSecond", {
    enumerable: !0,
    get: function() {
      return Et.default;
    }
  }), Object.defineProperty(e, "isThisWeek", {
    enumerable: !0,
    get: function() {
      return te.default;
    }
  }), Object.defineProperty(e, "isThisYear", {
    enumerable: !0,
    get: function() {
      return ce.default;
    }
  }), Object.defineProperty(e, "isThursday", {
    enumerable: !0,
    get: function() {
      return ge.default;
    }
  }), Object.defineProperty(e, "isToday", {
    enumerable: !0,
    get: function() {
      return Me.default;
    }
  }), Object.defineProperty(e, "isTomorrow", {
    enumerable: !0,
    get: function() {
      return ze.default;
    }
  }), Object.defineProperty(e, "isTuesday", {
    enumerable: !0,
    get: function() {
      return Xe.default;
    }
  }), Object.defineProperty(e, "isValid", {
    enumerable: !0,
    get: function() {
      return xt.default;
    }
  }), Object.defineProperty(e, "isWednesday", {
    enumerable: !0,
    get: function() {
      return tt.default;
    }
  }), Object.defineProperty(e, "isWeekend", {
    enumerable: !0,
    get: function() {
      return ar.default;
    }
  }), Object.defineProperty(e, "isWithinInterval", {
    enumerable: !0,
    get: function() {
      return er.default;
    }
  }), Object.defineProperty(e, "isYesterday", {
    enumerable: !0,
    get: function() {
      return Kt.default;
    }
  }), Object.defineProperty(e, "lastDayOfDecade", {
    enumerable: !0,
    get: function() {
      return tr.default;
    }
  }), Object.defineProperty(e, "lastDayOfISOWeek", {
    enumerable: !0,
    get: function() {
      return Lt.default;
    }
  }), Object.defineProperty(e, "lastDayOfISOWeekYear", {
    enumerable: !0,
    get: function() {
      return gr.default;
    }
  }), Object.defineProperty(e, "lastDayOfMonth", {
    enumerable: !0,
    get: function() {
      return ur.default;
    }
  }), Object.defineProperty(e, "lastDayOfQuarter", {
    enumerable: !0,
    get: function() {
      return dr.default;
    }
  }), Object.defineProperty(e, "lastDayOfWeek", {
    enumerable: !0,
    get: function() {
      return Zn.default;
    }
  }), Object.defineProperty(e, "lastDayOfYear", {
    enumerable: !0,
    get: function() {
      return gi.default;
    }
  }), Object.defineProperty(e, "lightFormat", {
    enumerable: !0,
    get: function() {
      return Bi.default;
    }
  }), Object.defineProperty(e, "max", {
    enumerable: !0,
    get: function() {
      return C.default;
    }
  }), Object.defineProperty(e, "milliseconds", {
    enumerable: !0,
    get: function() {
      return V.default;
    }
  }), Object.defineProperty(e, "millisecondsToHours", {
    enumerable: !0,
    get: function() {
      return oe.default;
    }
  }), Object.defineProperty(e, "millisecondsToMinutes", {
    enumerable: !0,
    get: function() {
      return Ee.default;
    }
  }), Object.defineProperty(e, "millisecondsToSeconds", {
    enumerable: !0,
    get: function() {
      return wt.default;
    }
  }), Object.defineProperty(e, "min", {
    enumerable: !0,
    get: function() {
      return ht.default;
    }
  }), Object.defineProperty(e, "minutesToHours", {
    enumerable: !0,
    get: function() {
      return Rt.default;
    }
  }), Object.defineProperty(e, "minutesToMilliseconds", {
    enumerable: !0,
    get: function() {
      return Ft.default;
    }
  }), Object.defineProperty(e, "minutesToSeconds", {
    enumerable: !0,
    get: function() {
      return Rr.default;
    }
  }), Object.defineProperty(e, "monthsToQuarters", {
    enumerable: !0,
    get: function() {
      return Jt.default;
    }
  }), Object.defineProperty(e, "monthsToYears", {
    enumerable: !0,
    get: function() {
      return ta.default;
    }
  }), Object.defineProperty(e, "nextDay", {
    enumerable: !0,
    get: function() {
      return fa.default;
    }
  }), Object.defineProperty(e, "nextFriday", {
    enumerable: !0,
    get: function() {
      return Hr.default;
    }
  }), Object.defineProperty(e, "nextMonday", {
    enumerable: !0,
    get: function() {
      return ra.default;
    }
  }), Object.defineProperty(e, "nextSaturday", {
    enumerable: !0,
    get: function() {
      return Qr.default;
    }
  }), Object.defineProperty(e, "nextSunday", {
    enumerable: !0,
    get: function() {
      return ei.default;
    }
  }), Object.defineProperty(e, "nextThursday", {
    enumerable: !0,
    get: function() {
      return Dn.default;
    }
  }), Object.defineProperty(e, "nextTuesday", {
    enumerable: !0,
    get: function() {
      return bi.default;
    }
  }), Object.defineProperty(e, "nextWednesday", {
    enumerable: !0,
    get: function() {
      return Ru.default;
    }
  }), Object.defineProperty(e, "parse", {
    enumerable: !0,
    get: function() {
      return Xs.default;
    }
  }), Object.defineProperty(e, "parseISO", {
    enumerable: !0,
    get: function() {
      return Ks.default;
    }
  }), Object.defineProperty(e, "parseJSON", {
    enumerable: !0,
    get: function() {
      return TC.default;
    }
  }), Object.defineProperty(e, "previousDay", {
    enumerable: !0,
    get: function() {
      return SC.default;
    }
  }), Object.defineProperty(e, "previousFriday", {
    enumerable: !0,
    get: function() {
      return EC.default;
    }
  }), Object.defineProperty(e, "previousMonday", {
    enumerable: !0,
    get: function() {
      return OC.default;
    }
  }), Object.defineProperty(e, "previousSaturday", {
    enumerable: !0,
    get: function() {
      return CC.default;
    }
  }), Object.defineProperty(e, "previousSunday", {
    enumerable: !0,
    get: function() {
      return kC.default;
    }
  }), Object.defineProperty(e, "previousThursday", {
    enumerable: !0,
    get: function() {
      return PC.default;
    }
  }), Object.defineProperty(e, "previousTuesday", {
    enumerable: !0,
    get: function() {
      return MC.default;
    }
  }), Object.defineProperty(e, "previousWednesday", {
    enumerable: !0,
    get: function() {
      return AC.default;
    }
  }), Object.defineProperty(e, "quartersToMonths", {
    enumerable: !0,
    get: function() {
      return DC.default;
    }
  }), Object.defineProperty(e, "quartersToYears", {
    enumerable: !0,
    get: function() {
      return IC.default;
    }
  }), Object.defineProperty(e, "roundToNearestMinutes", {
    enumerable: !0,
    get: function() {
      return NC.default;
    }
  }), Object.defineProperty(e, "secondsToHours", {
    enumerable: !0,
    get: function() {
      return $C.default;
    }
  }), Object.defineProperty(e, "secondsToMilliseconds", {
    enumerable: !0,
    get: function() {
      return LC.default;
    }
  }), Object.defineProperty(e, "secondsToMinutes", {
    enumerable: !0,
    get: function() {
      return RC.default;
    }
  }), Object.defineProperty(e, "set", {
    enumerable: !0,
    get: function() {
      return jC.default;
    }
  }), Object.defineProperty(e, "setDate", {
    enumerable: !0,
    get: function() {
      return FC.default;
    }
  }), Object.defineProperty(e, "setDay", {
    enumerable: !0,
    get: function() {
      return BC.default;
    }
  }), Object.defineProperty(e, "setDayOfYear", {
    enumerable: !0,
    get: function() {
      return qC.default;
    }
  }), Object.defineProperty(e, "setDefaultOptions", {
    enumerable: !0,
    get: function() {
      return HC.default;
    }
  }), Object.defineProperty(e, "setHours", {
    enumerable: !0,
    get: function() {
      return VC.default;
    }
  }), Object.defineProperty(e, "setISODay", {
    enumerable: !0,
    get: function() {
      return UC.default;
    }
  }), Object.defineProperty(e, "setISOWeek", {
    enumerable: !0,
    get: function() {
      return zC.default;
    }
  }), Object.defineProperty(e, "setISOWeekYear", {
    enumerable: !0,
    get: function() {
      return YC.default;
    }
  }), Object.defineProperty(e, "setMilliseconds", {
    enumerable: !0,
    get: function() {
      return WC.default;
    }
  }), Object.defineProperty(e, "setMinutes", {
    enumerable: !0,
    get: function() {
      return GC.default;
    }
  }), Object.defineProperty(e, "setMonth", {
    enumerable: !0,
    get: function() {
      return XC.default;
    }
  }), Object.defineProperty(e, "setQuarter", {
    enumerable: !0,
    get: function() {
      return KC.default;
    }
  }), Object.defineProperty(e, "setSeconds", {
    enumerable: !0,
    get: function() {
      return JC.default;
    }
  }), Object.defineProperty(e, "setWeek", {
    enumerable: !0,
    get: function() {
      return QC.default;
    }
  }), Object.defineProperty(e, "setWeekYear", {
    enumerable: !0,
    get: function() {
      return ZC.default;
    }
  }), Object.defineProperty(e, "setYear", {
    enumerable: !0,
    get: function() {
      return e4.default;
    }
  }), Object.defineProperty(e, "startOfDay", {
    enumerable: !0,
    get: function() {
      return t4.default;
    }
  }), Object.defineProperty(e, "startOfDecade", {
    enumerable: !0,
    get: function() {
      return r4.default;
    }
  }), Object.defineProperty(e, "startOfHour", {
    enumerable: !0,
    get: function() {
      return a4.default;
    }
  }), Object.defineProperty(e, "startOfISOWeek", {
    enumerable: !0,
    get: function() {
      return n4.default;
    }
  }), Object.defineProperty(e, "startOfISOWeekYear", {
    enumerable: !0,
    get: function() {
      return i4.default;
    }
  }), Object.defineProperty(e, "startOfMinute", {
    enumerable: !0,
    get: function() {
      return s4.default;
    }
  }), Object.defineProperty(e, "startOfMonth", {
    enumerable: !0,
    get: function() {
      return o4.default;
    }
  }), Object.defineProperty(e, "startOfQuarter", {
    enumerable: !0,
    get: function() {
      return l4.default;
    }
  }), Object.defineProperty(e, "startOfSecond", {
    enumerable: !0,
    get: function() {
      return u4.default;
    }
  }), Object.defineProperty(e, "startOfToday", {
    enumerable: !0,
    get: function() {
      return d4.default;
    }
  }), Object.defineProperty(e, "startOfTomorrow", {
    enumerable: !0,
    get: function() {
      return c4.default;
    }
  }), Object.defineProperty(e, "startOfWeek", {
    enumerable: !0,
    get: function() {
      return f4.default;
    }
  }), Object.defineProperty(e, "startOfWeekYear", {
    enumerable: !0,
    get: function() {
      return p4.default;
    }
  }), Object.defineProperty(e, "startOfYear", {
    enumerable: !0,
    get: function() {
      return v4.default;
    }
  }), Object.defineProperty(e, "startOfYesterday", {
    enumerable: !0,
    get: function() {
      return m4.default;
    }
  }), Object.defineProperty(e, "sub", {
    enumerable: !0,
    get: function() {
      return h4.default;
    }
  }), Object.defineProperty(e, "subBusinessDays", {
    enumerable: !0,
    get: function() {
      return g4.default;
    }
  }), Object.defineProperty(e, "subDays", {
    enumerable: !0,
    get: function() {
      return b4.default;
    }
  }), Object.defineProperty(e, "subHours", {
    enumerable: !0,
    get: function() {
      return y4.default;
    }
  }), Object.defineProperty(e, "subISOWeekYears", {
    enumerable: !0,
    get: function() {
      return _4.default;
    }
  }), Object.defineProperty(e, "subMilliseconds", {
    enumerable: !0,
    get: function() {
      return x4.default;
    }
  }), Object.defineProperty(e, "subMinutes", {
    enumerable: !0,
    get: function() {
      return w4.default;
    }
  }), Object.defineProperty(e, "subMonths", {
    enumerable: !0,
    get: function() {
      return T4.default;
    }
  }), Object.defineProperty(e, "subQuarters", {
    enumerable: !0,
    get: function() {
      return S4.default;
    }
  }), Object.defineProperty(e, "subSeconds", {
    enumerable: !0,
    get: function() {
      return E4.default;
    }
  }), Object.defineProperty(e, "subWeeks", {
    enumerable: !0,
    get: function() {
      return O4.default;
    }
  }), Object.defineProperty(e, "subYears", {
    enumerable: !0,
    get: function() {
      return C4.default;
    }
  }), Object.defineProperty(e, "toDate", {
    enumerable: !0,
    get: function() {
      return k4.default;
    }
  }), Object.defineProperty(e, "weeksToDays", {
    enumerable: !0,
    get: function() {
      return P4.default;
    }
  }), Object.defineProperty(e, "yearsToMonths", {
    enumerable: !0,
    get: function() {
      return M4.default;
    }
  }), Object.defineProperty(e, "yearsToQuarters", {
    enumerable: !0,
    get: function() {
      return A4.default;
    }
  });
  var a = t(HS), n = t(US), i = t($i), s = t(ob), o = t(WS), l = t(xu), u = t(lb), d = t(_u), f = t(ub), c = t(GS), p = t(nc), v = t(XS), h = t(HN), g = t(VN), m = t(UN), b = t(zN), y = t(Rs), _ = t(YN), x = t(i$), w = t(s$), k = t(ns), S = t(nE), P = t(o$), A = t(cb), E = t(sE), O = t(fb), T = t(pb), D = t(vb), $ = t(mb), I = t(d$), F = t(ic), j = t(hb), M = t(sc), q = t(c$), le = t(oc), Z = t(f$), G = t(uE), H = t(dE), W = t(p$), ie = t(v$), we = t(m$), Be = t(h$), Ve = t(g$), et = t(xb), nt = t(b$), xe = t(y$), J = t(_$), se = t(gb), _e = t(x$), Se = t(w$), Re = t(T$), rt = t(S$), Dt = t(E$), It = t(bb), Ye = t(O$), at = t(C$), ut = t(k$), Gt = t(P$), Je = t(fE), he = t(cE), ye = t(M$), Ke = t(bE), Q = t(_E), L = t(xE), Te = t(K$), Oe = t(J$), Y = t(Q$), de = t(Z$), Ne = t(e8), We = t(t8), mt = t(r8), Nt = t(a8), St = t(n8), me = t(i8), Ue = t(wE), bt = t(uc), _t = t(s8), pr = t(TE), Ze = t(o8), vr = t(l8), yt = t(u8), Xr = t(d8), La = t(EE), Ar = t(OE), rn = t(Mo), Gn = t(c8), pi = t(f8), Cn = t(p8), Va = t(v8), Er = t(m8), an = t(iE), kn = t(h8), Pn = t(CE), Xn = t(g8), Kn = t(PE), Or = t(b8), Mn = t(kE), xa = t(y8), wa = t(_8), Ta = t(x8), Ua = t(w8), lr = t(T8), vi = t(S8), Jn = t(E8), nn = t(O8), Vr = t(C8), Ra = t(k8), qr = t(aE), Ur = t(P8), da = t(M8), hr = t(A8), Kr = t(D8), Qn = t(I8), sn = t(lE), on = t(SE), Dr = t(qj), Xt = t(Hj), ia = t(Vj), Sa = t(Tu), ca = t(JE), za = t(QE), Ya = t(Uj), Jr = t(ZE), Ea = t(eO), An = t(tO), ln = t(aO), Oa = t(Mb), mi = t(nO), hi = t(VS), B = t(sb), z = t(zj), ae = t(Yj), be = t(Wj), $e = t(Gj), Ge = t(Xj), Et = t(Kj), te = t(Jj), ce = t(Qj), ge = t(Zj), Me = t(eF), ze = t(tF), Xe = t(rF), xt = t(is), tt = t(aF), ar = t(rc), er = t(nF), Kt = t(iF), tr = t(sF), Lt = t(oF), gr = t(lF), ur = t(ME), dr = t(uF), Zn = t(iO), gi = t(dF), Bi = t(cF), C = t(KS), V = t(fF), oe = t(pF), Ee = t(vF), wt = t(mF), ht = t(JS), Rt = t(hF), Ft = t(gF), Rr = t(bF), Jt = t(yF), ta = t(_F), fa = t(ds), Hr = t(xF), ra = t(wF), Qr = t(TF), ei = t(SF), Dn = t(EF), bi = t(OF), Ru = t(CF), Xs = t(XE), Ks = t(kF), TC = t(PF), SC = t(cs), EC = t(MF), OC = t(AF), CC = t(DF), kC = t(IF), PC = t(NF), MC = t($F), AC = t(LF), DC = t(RF), IC = t(jF), NC = t(FF), $C = t(BF), LC = t(qF), RC = t(HF), jC = t(VF), FC = t(UF), BC = t(zF), qC = t(YF), HC = t(WF), VC = t(GF), UC = t(XF), zC = t(KF), YC = t(YS), WC = t(JF), GC = t(QF), XC = t(Ab), KC = t(ZF), JC = t(eB), QC = t(tB), ZC = t(rB), e4 = t(aB), t4 = t(ac), r4 = t(nB), a4 = t(KE), n4 = t(Ls), i4 = t(wu), s4 = t(yb), o4 = t(lc), l4 = t(_b), u4 = t(rO), d4 = t(iB), c4 = t(sB), f4 = t(as), p4 = t(Sb), v4 = t(wb), m4 = t(oB), h4 = t(lB), g4 = t(uB), b4 = t(Hc), y4 = t(dB), _4 = t(oE), x4 = t(Su), w4 = t(cB), T4 = t(sO), S4 = t(fB), E4 = t(pB), O4 = t(vB), C4 = t(mB), k4 = t(Ce), P4 = t(hB), M4 = t(gB), A4 = t(bB), pf = dt;
  Object.keys(pf).forEach(function(ee) {
    ee === "default" || ee === "__esModule" || Object.prototype.hasOwnProperty.call(r, ee) || ee in e && e[ee] === pf[ee] || Object.defineProperty(e, ee, {
      enumerable: !0,
      get: function() {
        return pf[ee];
      }
    });
  });
})(ve);
function Vc() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ue("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ue("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ue("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function yB() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ue("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function Jx() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Qx() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function oO() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ue("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function lO() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function uO() {
  return R(), K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ue("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Zx = (e, t, r, a, n) => {
  const i = ve.parse(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return ve.isValid(i) && ve.isDate(i) ? a || n ? i : ve.set(i, {
    hours: +r.hours,
    minutes: +(r == null ? void 0 : r.minutes),
    seconds: +(r == null ? void 0 : r.seconds),
    milliseconds: 0
  }) : null;
}, _B = (e, t, r, a, n) => {
  const i = Array.isArray(r) ? r[0] : r;
  if (typeof t == "string")
    return Zx(e, t, i, a, n);
  if (Array.isArray(t)) {
    let s = null;
    for (const o of t)
      if (s = Zx(e, o, i, a, n), s)
        break;
    return s;
  }
  return typeof t == "function" ? t(e) : null;
}, qe = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), xB = (e, t, r) => {
  if (t) {
    const n = (e.getMonth() + 1).toString().padStart(2, "0"), i = e.getDate().toString().padStart(2, "0"), s = e.getHours().toString().padStart(2, "0"), o = e.getMinutes().toString().padStart(2, "0"), l = r ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${n}-${i}T${s}:${o}:${l}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, _n = (e) => {
  let t = qe(JSON.parse(JSON.stringify(e)));
  return t = ve.setHours(t, 0), t = ve.setMinutes(t, 0), t = ve.setSeconds(t, 0), t = ve.setMilliseconds(t, 0), t;
}, dn = (e, t, r, a) => {
  let n = e ? qe(e) : qe();
  return (t || t === 0) && (n = ve.setHours(n, +t)), (r || r === 0) && (n = ve.setMinutes(n, +r)), (a || a === 0) && (n = ve.setSeconds(n, +a)), ve.setMilliseconds(n, 0);
}, va = (e, t) => !e || !t ? !1 : ve.isBefore(_n(e), _n(t)), nr = (e, t) => !e || !t ? !1 : ve.isEqual(_n(e), _n(t)), Ia = (e, t) => !e || !t ? !1 : ve.isAfter(_n(e), _n(t)), dO = (e, t, r) => e && e[0] && e[1] ? Ia(r, e[0]) && va(r, e[1]) : e && e[0] && t ? Ia(r, e[0]) && va(r, t) || va(r, e[0]) && Ia(r, t) : !1, xl = (e) => {
  const t = ve.set(new Date(e), { date: 1 });
  return _n(t);
}, Ff = (e, t, r) => t && (r || r === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, r] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Uu = (e) => ({
  hours: ve.getHours(e),
  minutes: ve.getMinutes(e),
  seconds: ve.getSeconds(e)
}), wl = Sn({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), cO = () => {
  const e = (r) => {
    wl.menuFocused = r;
  }, t = (r) => {
    wl.shiftKeyInMenu !== r && (wl.shiftKeyInMenu = r);
  };
  return {
    control: N(() => ({ shiftKeyInMenu: wl.shiftKeyInMenu, menuFocused: wl.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
};
function Db(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fO = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fO);
var wB = fO.exports, z0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(z0, z0.exports);
var TB = z0.exports;
const SB = /* @__PURE__ */ Db(TB);
var Y0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
  }
  e.exports = t.default;
})(Y0, Y0.exports);
var EB = Y0.exports;
const e2 = /* @__PURE__ */ Db(EB);
function OB(e, t) {
  var r = MB(t);
  return r.formatToParts ? kB(r, e) : PB(r, e);
}
var CB = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function kB(e, t) {
  try {
    for (var r = e.formatToParts(t), a = [], n = 0; n < r.length; n++) {
      var i = CB[r[n].type];
      i >= 0 && (a[i] = parseInt(r[n].value, 10));
    }
    return a;
  } catch (s) {
    if (s instanceof RangeError)
      return [NaN];
    throw s;
  }
}
function PB(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [a[3], a[1], a[2], a[4], a[5], a[6]];
}
var Bf = {};
function MB(e) {
  if (!Bf[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Bf[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Bf[e];
}
function Ib(e, t, r, a, n, i, s) {
  var o = /* @__PURE__ */ new Date(0);
  return o.setUTCFullYear(e, t, r), o.setUTCHours(a, n, i, s), o;
}
var t2 = 36e5, AB = 6e4, qf = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Nb(e, t, r) {
  var a, n;
  if (!e || (a = qf.timezoneZ.exec(e), a))
    return 0;
  var i;
  if (a = qf.timezoneHH.exec(e), a)
    return i = parseInt(a[1], 10), r2(i) ? -(i * t2) : NaN;
  if (a = qf.timezoneHHMM.exec(e), a) {
    i = parseInt(a[1], 10);
    var s = parseInt(a[2], 10);
    return r2(i, s) ? (n = Math.abs(i) * t2 + s * AB, i > 0 ? -n : n) : NaN;
  }
  if (NB(e)) {
    t = new Date(t || Date.now());
    var o = r ? t : DB(t), l = W0(o, e), u = r ? l : IB(t, l, e);
    return -u;
  }
  return NaN;
}
function DB(e) {
  return Ib(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function W0(e, t) {
  var r = OB(e, t), a = Ib(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), n = e.getTime(), i = n % 1e3;
  return n -= i >= 0 ? i : 1e3 + i, a - n;
}
function IB(e, t, r) {
  var a = e.getTime(), n = a - t, i = W0(new Date(n), r);
  if (t === i)
    return t;
  n -= i - t;
  var s = W0(new Date(n), r);
  return i === s ? i : Math.max(i, s);
}
function r2(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var a2 = {};
function NB(e) {
  if (a2[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), a2[e] = !0, !0;
  } catch {
    return !1;
  }
}
var $B = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const pO = $B;
var Hf = 36e5, n2 = 6e4, LB = 2, Aa = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: pO
};
function G0(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, a = r.additionalDigits == null ? LB : SB(r.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = RB(e), i = jB(n.date, a), s = i.year, o = i.restDateString, l = FB(o, s);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var u = l.getTime(), d = 0, f;
    if (n.time && (d = BB(n.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || r.timeZone) {
      if (f = Nb(n.timeZone || r.timeZone, new Date(u + d)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = e2(new Date(u + d)), f = e2(new Date(u + d + f));
    return new Date(u + d + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function RB(e) {
  var t = {}, r = Aa.dateTimePattern.exec(e), a;
  if (r ? (t.date = r[1], a = r[3]) : (r = Aa.datePattern.exec(e), r ? (t.date = r[1], a = r[2]) : (t.date = null, a = e)), a) {
    var n = Aa.timeZone.exec(a);
    n ? (t.time = a.replace(n[1], ""), t.timeZone = n[1].trim()) : t.time = a;
  }
  return t;
}
function jB(e, t) {
  var r = Aa.YYY[t], a = Aa.YYYYY[t], n;
  if (n = Aa.YYYY.exec(e) || a.exec(e), n) {
    var i = n[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (n = Aa.YY.exec(e) || r.exec(e), n) {
    var s = n[1];
    return {
      year: parseInt(s, 10) * 100,
      restDateString: e.slice(s.length)
    };
  }
  return {
    year: null
  };
}
function FB(e, t) {
  if (t === null)
    return null;
  var r, a, n, i;
  if (e.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(t), a;
  if (r = Aa.MM.exec(e), r)
    return a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1, s2(t, n) ? (a.setUTCFullYear(t, n), a) : /* @__PURE__ */ new Date(NaN);
  if (r = Aa.DDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0);
    var s = parseInt(r[1], 10);
    return VB(t, s) ? (a.setUTCFullYear(t, 0, s), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Aa.MMDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1;
    var o = parseInt(r[2], 10);
    return s2(t, n, o) ? (a.setUTCFullYear(t, n, o), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Aa.Www.exec(e), r)
    return i = parseInt(r[1], 10) - 1, o2(t, i) ? i2(t, i) : /* @__PURE__ */ new Date(NaN);
  if (r = Aa.WwwD.exec(e), r) {
    i = parseInt(r[1], 10) - 1;
    var l = parseInt(r[2], 10) - 1;
    return o2(t, i, l) ? i2(t, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function BB(e) {
  var t, r, a;
  if (t = Aa.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), Vf(r) ? r % 24 * Hf : NaN;
  if (t = Aa.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), a = parseFloat(t[2].replace(",", ".")), Vf(r, a) ? r % 24 * Hf + a * n2 : NaN;
  if (t = Aa.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), a = parseInt(t[2], 10);
    var n = parseFloat(t[3].replace(",", "."));
    return Vf(r, a, n) ? r % 24 * Hf + a * n2 + n * 1e3 : NaN;
  }
  return null;
}
function i2(e, t, r) {
  t = t || 0, r = r || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var n = a.getUTCDay() || 7, i = t * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + i), a;
}
var qB = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HB = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function vO(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function s2(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var a = vO(e);
    if (a && r > HB[t] || !a && r > qB[t])
      return !1;
  }
  return !0;
}
function VB(e, t) {
  if (t < 1)
    return !1;
  var r = vO(e);
  return !(r && t > 366 || !r && t > 365);
}
function o2(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function Vf(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
var X0 = { exports: {} }, K0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n) {
    if (a == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (a[i] = n[i]);
    return a;
  }
  e.exports = t.default;
})(K0, K0.exports);
var UB = K0.exports;
(function(e, t) {
  var r = wB.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(UB);
  function n(i) {
    return (0, a.default)({}, i);
  }
  e.exports = t.default;
})(X0, X0.exports);
var zB = X0.exports;
const YB = /* @__PURE__ */ Db(zB);
function WB(e, t, r) {
  var a = G0(e, r), n = Nb(t, a, !0), i = new Date(a.getTime() - n), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), s.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), s;
}
function GB(e, t, r) {
  if (typeof e == "string" && !e.match(pO)) {
    var a = YB(r);
    return a.timeZone = t, G0(e, a);
  }
  var n = G0(e, r), i = Ib(
    n.getFullYear(),
    n.getMonth(),
    n.getDate(),
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ).getTime(), s = Nb(t, new Date(i));
  return new Date(i + s);
}
const XB = (e, t = 3) => {
  const r = [];
  for (let a = 0; a < e.length; a += t)
    r.push([e[a], e[a + 1], e[a + 2]]);
  return r;
};
function l2(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function KB(e) {
  return (t) => ve.format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "EEEEEE", { locale: e });
}
const JB = (e, t, r) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let n;
  if (e !== null)
    try {
      n = a.map(KB(e));
    } catch {
      n = a.map(l2(t));
    }
  else
    n = a.map(l2(t));
  const i = n.slice(0, r), s = n.slice(r + 1, n.length);
  return [n[r]].concat(...s).concat(...i);
}, QB = (e, t) => {
  const r = [];
  for (let a = +e[0]; a <= +e[1]; a++)
    r.push({ value: +a, text: `${a}` });
  return t ? r.reverse() : r;
}, ZB = (e, t, r) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => {
    const s = i < 10 ? `0${i}` : i;
    return /* @__PURE__ */ new Date(`2017-${s}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const i = r === "long" ? "MMMM" : "MMM";
      return a.map((s, o) => {
        const l = ve.format(s, i, { locale: e });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const n = new Intl.DateTimeFormat(t, { month: r, timeZone: "UTC" });
  return a.map((i, s) => {
    const o = n.format(i);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: s
    };
  });
}, eq = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Fr = (e) => {
  const t = U(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, tq = (e) => Object.assign({ type: "dot" }, e), mO = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Ed = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, pa = (e) => e, u2 = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, rq = (e) => e === 0 ? !0 : !!e, d2 = (e) => e === null, aq = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, c2 = (e) => Object.assign(
  {
    menuAppear: "",
    open: "dp-slide-down",
    close: "dp-slide-up",
    next: "calendar-next",
    previous: "calendar-prev",
    vNext: "dp-slide-up",
    vPrevious: "dp-slide-down"
  },
  e
), nq = (e) => Object.assign(
  {
    toggleOverlay: "Toggle overlay",
    menu: "Datepicker menu",
    input: "Datepicker input",
    calendarWrap: "Calendar wrapper",
    calendarDays: "Calendar days",
    openTimePicker: "Open time picker",
    closeTimePicker: "Close time Picker",
    incrementValue: (t) => `Increment ${t}`,
    decrementValue: (t) => `Decrement ${t}`,
    openTpOverlay: (t) => `Open ${t} overlay`,
    amPmButton: "Switch AM/PM mode",
    openYearsOverlay: "Open years overlay",
    openMonthsOverlay: "Open months overlay",
    nextMonth: "Next month",
    prevMonth: "Previous month",
    day: () => ""
  },
  e
), iq = (e) => e === null ? 0 : typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2, sq = (e, t, r) => e || (typeof r == "string" ? r : t), oq = (e) => typeof e == "boolean" ? e ? c2({}) : !1 : c2(e), lq = () => ({
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: !0,
  rangeSeparator: " - "
}), uq = (e) => Object.assign({ months: [], years: [], times: { hours: [], minutes: [], seconds: [] } }, e), dq = (e) => Object.assign({ showSelect: !0, showCancel: !0, showNow: !1, showPreview: !0 }, e), en = (e) => {
  const t = () => {
    if (e.partialRange)
      return null;
    throw new Error(Ed.prop("partial-range"));
  }, r = N(() => ({
    ariaLabels: nq(e.ariaLabels),
    textInputOptions: Object.assign(lq(), e.textInputOptions),
    multiCalendars: iq(e.multiCalendars),
    previewFormat: sq(e.previewFormat, e.format, i()),
    filters: uq(e.filters),
    transitions: oq(e.transitions),
    startTime: p(),
    actionRow: dq(e.actionRow)
  })), a = (G) => {
    if (e.range)
      return G();
    throw new Error(Ed.prop("range"));
  }, n = () => {
    const G = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${G}` : `hh:mm${G} aa`;
  }, i = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? n() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${n()}` : "MM/dd/yyyy", s = (G, H) => {
    if (typeof e.format == "function")
      return e.format(G);
    const W = H || i(), ie = e.formatLocale ? { locale: e.formatLocale } : void 0;
    return Array.isArray(G) ? `${ve.format(G[0], W, ie)}${e.modelAuto && !G[1] ? "" : r.value.textInputOptions.rangeSeparator || "-"}${G[1] ? ve.format(G[1], W, ie) : ""}` : ve.format(G, W, ie);
  }, o = (G) => e.timezone ? WB(G, e.timezone) : G, l = (G) => e.timezone ? GB(G, e.timezone) : G, u = N(() => (G) => {
    var H;
    return (H = e.hideNavigation) == null ? void 0 : H.includes(G);
  }), d = (G) => {
    var H, W, ie, we;
    return Array.isArray(e.allowedDates) && !((H = e.allowedDates) != null && H.length) ? !0 : (W = e.arrMapValues) != null && W.allowedDates ? !b(G, e.arrMapValues.allowedDates) : (ie = e.allowedDates) != null && ie.length ? !((we = e.allowedDates) != null && we.some(
      (Be) => nr(o(qe(Be)), o(G))
    )) : !1;
  }, f = (G) => {
    var H;
    const W = e.maxDate ? Ia(o(G), o(qe(e.maxDate))) : !1, ie = e.minDate ? va(o(G), o(qe(e.minDate))) : !1, we = b(
      G,
      (H = e.arrMapValues) != null && H.disabledDates ? e.arrMapValues.disabledDates : e.disabledDates
    ), Be = r.value.filters.months.map((J) => +J).includes(ve.getMonth(G)), Ve = e.disabledWeekDays.length ? e.disabledWeekDays.some((J) => +J === ve.getDay(G)) : !1, et = d(G), nt = ve.getYear(G), xe = nt < +e.yearRange[0] || nt > +e.yearRange[1];
    return !(W || ie || we || Be || xe || Ve || et);
  }, c = (G) => {
    const H = {
      hours: ve.getHours(qe()),
      minutes: ve.getMinutes(qe()),
      seconds: e.enableSeconds ? ve.getSeconds(qe()) : 0
    };
    return Object.assign(H, G);
  }, p = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [c(e.startTime[0]), c(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? c(e.startTime) : null, v = (G) => !f(G), h = (G) => Array.isArray(G) ? ve.isValid(G[0]) && (G[1] ? ve.isValid(G[1]) : !0) : G ? ve.isValid(G) : !1, g = (G) => G instanceof Date ? G : ve.parseISO(G), m = (G) => {
    const H = ve.startOfWeek(o(G), { weekStartsOn: +e.weekStart }), W = ve.endOfWeek(o(G), { weekStartsOn: +e.weekStart });
    return [H, W];
  }, b = (G, H) => G ? H instanceof Map ? !!H.get(q(G)) : Array.isArray(H) ? H.some((W) => nr(o(qe(W)), o(G))) : H(qe(JSON.parse(JSON.stringify(G)))) : !0, y = (G, H, W) => {
    let ie = G ? qe(G) : qe();
    return (H || H === 0) && (ie = ve.setMonth(ie, H)), W && (ie = ve.setYear(ie, W)), ie;
  }, _ = (G) => ve.set(qe(), Uu(G)), x = (G) => ve.set(qe(), {
    hours: +G.hours || 0,
    minutes: +G.minutes || 0,
    seconds: +G.seconds || 0
  }), w = (G, H, W, ie) => {
    if (!G)
      return !0;
    if (ie) {
      const we = W === "max" ? ve.isBefore(G, H) : ve.isAfter(G, H), Be = { seconds: 0, milliseconds: 0 };
      return we || ve.isEqual(ve.set(G, Be), ve.set(H, Be));
    }
    return W === "max" ? G.getTime() <= H.getTime() : G.getTime() >= H.getTime();
  }, k = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, S = (G) => Array.isArray(G) ? [G[0] ? _(G[0]) : null, G[1] ? _(G[1]) : null] : _(G), P = (G) => {
    const H = e.maxTime ? x(e.maxTime) : qe(e.maxDate);
    return Array.isArray(G) ? w(G[0], H, "max", !!e.maxDate) && w(G[1], H, "max", !!e.maxDate) : w(G, H, "max", !!e.maxDate);
  }, A = (G, H) => {
    const W = e.minTime ? x(e.minTime) : qe(e.minDate);
    return Array.isArray(G) ? w(G[0], W, "min", !!e.minDate) && w(G[1], W, "min", !!e.minDate) && H : w(G, W, "min", !!e.minDate) && H;
  }, E = (G) => {
    let H = !0;
    if (!G || k())
      return !0;
    const W = !e.minDate && !e.maxDate ? S(G) : G;
    if ((e.maxTime || e.maxDate) && (H = P(pa(W))), (e.minTime || e.minDate) && (H = A(pa(W), H)), e.disabledTimes) {
      const ie = Array.isArray(G) ? [Uu(G[0]), G[1] ? Uu(G[1]) : void 0] : Uu(G);
      H = !e.disabledTimes(ie);
    }
    return H;
  }, O = (G, H) => {
    const W = qe(JSON.parse(JSON.stringify(G))), ie = [];
    for (let we = 0; we < 7; we++) {
      const Be = ve.addDays(W, we), Ve = ve.getMonth(Be) !== H;
      ie.push({
        text: e.hideOffsetDates && Ve ? "" : Be.getDate(),
        value: Be,
        current: !Ve,
        classData: {}
      });
    }
    return ie;
  }, T = (G, H) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [G == 0, !0];
      case "fair":
        return [G == 0 || H > G, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, D = (G, H) => {
    const W = [], ie = qe(o(new Date(H, G))), we = qe(o(new Date(H, G + 1, 0))), Be = e.weekStart, Ve = ve.startOfWeek(ie, { weekStartsOn: Be }), et = (nt) => {
      const xe = O(nt, G);
      if (W.push({ days: xe }), !W[W.length - 1].days.some(
        (J) => nr(_n(J.value), _n(we))
      )) {
        const J = ve.addDays(nt, 7);
        et(J);
      }
    };
    if (et(Ve), e.sixWeeks && W.length < 6) {
      const nt = 6 - W.length, xe = (ie.getDay() + 7 - Be) % 7, J = 6 - (we.getDay() + 7 - Be) % 7, [se, _e] = T(xe, J);
      for (let Se = 1; Se <= nt; Se++)
        if (_e ? !!(Se % 2) == se : se) {
          const Re = W[0].days[0], rt = O(ve.addDays(Re.value, -7), ve.getMonth(ie));
          W.unshift({ days: rt });
        } else {
          const Re = W[W.length - 1], rt = Re.days[Re.days.length - 1], Dt = O(ve.addDays(rt.value, 1), ve.getMonth(ie));
          W.push({ days: Dt });
        }
    }
    return W;
  }, $ = (G, H, W) => [ve.set(qe(G), { date: 1 }), ve.set(qe(), { month: H, year: W, date: 1 })], I = (G, H) => va(...$(e.minDate, G, H)) || nr(...$(e.minDate, G, H)), F = (G, H) => Ia(...$(e.maxDate, G, H)) || nr(...$(e.maxDate, G, H)), j = (G, H, W) => {
    let ie = !1;
    return e.maxDate && W && F(G, H) && (ie = !0), e.minDate && !W && I(G, H) && (ie = !0), ie;
  }, M = (G, H, W, ie) => {
    let we = !1;
    return ie ? e.minDate && e.maxDate ? we = j(G, H, W) : (e.minDate && I(G, H) || e.maxDate && F(G, H)) && (we = !0) : we = !0, we;
  }, q = (G) => {
    const H = _n(o(qe(G))).toISOString(), [W] = H.split("T");
    return W;
  }, le = (G) => new Map(G.map((H) => [q(H), !0])), Z = (G) => Array.isArray(G) && G.length > 0;
  return {
    checkPartialRangeValue: t,
    checkRangeEnabled: a,
    getZonedDate: o,
    getZonedToUtc: l,
    formatDate: s,
    getDefaultPattern: i,
    validateDate: f,
    getDefaultStartTime: p,
    isDisabled: v,
    isValidDate: h,
    sanitizeDate: g,
    getWeekFromDate: m,
    matchDate: b,
    setDateMonthOrYear: y,
    isValidTime: E,
    getCalendarDays: D,
    validateMonthYearInRange: M,
    validateMaxDate: F,
    validateMinDate: I,
    assignDefaultTime: c,
    mapDatesArrToMap: (G) => {
      Z(e.allowedDates) && (G.allowedDates = le(e.allowedDates)), Z(e.highlight) && (G.highlightedDates = le(e.highlight)), Z(e.disabledDates) && (G.disabledDates = le(e.disabledDates));
    },
    defaults: r,
    hideNavigationButtons: u
  };
}, br = Sn({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Uf = ne(null), zu = ne(!1), zf = ne(!1), Yf = ne(!1), Wf = ne(!1), Ca = ne(0), sa = ne(0), fs = () => {
  const e = N(() => zu.value ? [...br.selectionGrid, br.actionRow].filter((f) => f.length) : zf.value ? [
    ...br.timePicker[0],
    ...br.timePicker[1],
    Wf.value ? [] : [Uf.value],
    br.actionRow
  ].filter((f) => f.length) : Yf.value ? [...br.monthPicker, br.actionRow] : [br.monthYear, ...br.calendar, br.time, br.actionRow].filter((f) => f.length)), t = (f) => {
    Ca.value = f ? Ca.value + 1 : Ca.value - 1;
    let c = null;
    e.value[sa.value] && (c = e.value[sa.value][Ca.value]), c || (Ca.value = f ? Ca.value - 1 : Ca.value + 1);
  }, r = (f) => {
    sa.value === 0 && !f || sa.value === e.value.length && f || (sa.value = f ? sa.value + 1 : sa.value - 1, e.value[sa.value] ? e.value[sa.value] && !e.value[sa.value][Ca.value] && Ca.value !== 0 && (Ca.value = e.value[sa.value].length - 1) : sa.value = f ? sa.value - 1 : sa.value + 1);
  }, a = (f) => {
    let c = null;
    e.value[sa.value] && (c = e.value[sa.value][Ca.value]), c ? c.focus({ preventScroll: !zu.value }) : Ca.value = f ? Ca.value - 1 : Ca.value + 1;
  }, n = () => {
    t(!0), a(!0);
  }, i = () => {
    t(!1), a(!1);
  }, s = () => {
    r(!1), a(!0);
  }, o = () => {
    r(!0), a(!0);
  }, l = (f, c) => {
    br[c] = f;
  }, u = (f, c) => {
    br[c] = f;
  }, d = () => {
    Ca.value = 0, sa.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (f) => {
      Uf.value = f;
    },
    setSelectionGrid: (f) => {
      zu.value = f, d(), f || (br.selectionGrid = []);
    },
    setTimePicker: (f, c = !1) => {
      zf.value = f, Wf.value = c, d(), f || (br.timePicker[0] = [], br.timePicker[1] = []);
    },
    setTimePickerElements: (f, c = 0) => {
      br.timePicker[c] = f;
    },
    arrowRight: n,
    arrowLeft: i,
    arrowUp: s,
    arrowDown: o,
    clearArrowNav: () => {
      br.monthYear = [], br.calendar = [], br.time = [], br.actionRow = [], br.selectionGrid = [], br.timePicker[0] = [], br.timePicker[1] = [], zu.value = !1, zf.value = !1, Wf.value = !1, Yf.value = !1, d(), Uf.value = null;
    },
    setMonthPicker: (f) => {
      Yf.value = f, d();
    },
    refSets: br
    // exposed for testing
  };
}, f2 = (e) => Array.isArray(e), _s = (e) => Array.isArray(e), p2 = (e) => Array.isArray(e) && e.length === 2, cq = (e, t, r, a, n) => {
  const {
    getDefaultStartTime: i,
    isDisabled: s,
    sanitizeDate: o,
    getWeekFromDate: l,
    setDateMonthOrYear: u,
    validateMonthYearInRange: d,
    defaults: f
  } = en(e), c = N({
    get: () => e.internalModelValue,
    set: (Y) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", Y);
    }
  }), p = ne([]);
  He(c, (Y, de) => {
    e.range ? k() : ve.isEqual(Y, de) || k();
  });
  const v = ql(e, "multiCalendars");
  He(v, () => {
    Ye(0);
  });
  const h = ne([{ month: ve.getMonth(qe()), year: ve.getYear(qe()) }]);
  He(
    h,
    () => {
      h.value.forEach((Y, de) => {
        t("update-month-year", { instance: de, month: Y.month, year: Y.year });
      });
    },
    { deep: !0 }
  );
  const g = Sn({
    hours: e.range ? [ve.getHours(qe()), ve.getHours(qe())] : ve.getHours(qe()),
    minutes: e.range ? [ve.getMinutes(qe()), ve.getMinutes(qe())] : ve.getMinutes(qe()),
    seconds: e.range ? [0, 0] : 0
  }), m = N(
    () => (Y) => h.value[Y] ? h.value[Y].month : 0
  ), b = N(
    () => (Y) => h.value[Y] ? h.value[Y].year : 0
  ), y = N(() => {
    var Y;
    return (Y = e.flow) != null && Y.length && !e.partialFlow ? n.value === e.flow.length : !0;
  }), _ = (Y, de, Ne) => {
    var We, mt;
    h.value[Y] || (h.value[Y] = { month: 0, year: 0 }), h.value[Y].month = d2(de) ? (We = h.value[Y]) == null ? void 0 : We.month : de, h.value[Y].year = d2(Ne) ? (mt = h.value[Y]) == null ? void 0 : mt.year : Ne;
  }, x = (Y, de) => {
    g[Y] = de;
  }, w = () => {
    e.startDate && (_(0, ve.getMonth(qe(e.startDate)), ve.getYear(qe(e.startDate))), f.value.multiCalendars && Ye(0));
  };
  ct(() => {
    c.value || (w(), f.value.startTime && F()), k(!0), e.focusStartDate && e.startDate && w();
  });
  const k = (Y = !1) => {
    if (c.value)
      return Array.isArray(c.value) ? (p.value = c.value, O(Y)) : P(c.value, Y);
    if (e.timePicker)
      return T();
    if (e.monthPicker && !e.range)
      return D();
    if (e.yearPicker && !e.range)
      return $();
    if (f.value.multiCalendars && Y && !e.startDate)
      return S(qe(), Y);
  }, S = (Y, de = !1) => {
    if ((!f.value.multiCalendars || !e.multiStatic || de) && _(0, ve.getMonth(Y), ve.getYear(Y)), f.value.multiCalendars)
      for (let Ne = 1; Ne < f.value.multiCalendars; Ne++) {
        const We = ve.set(qe(), { month: m.value(Ne - 1), year: b.value(Ne - 1) }), mt = ve.add(We, { months: 1 });
        h.value[Ne] = { month: ve.getMonth(mt), year: ve.getYear(mt) };
      }
  }, P = (Y, de) => {
    S(Y), x("hours", ve.getHours(Y)), x("minutes", ve.getMinutes(Y)), x("seconds", ve.getSeconds(Y)), f.value.multiCalendars && de && M();
  }, A = (Y, de) => {
    Y[1] && e.showLastInRange ? S(Y[1], de) : S(Y[0], de);
    const Ne = (We, mt) => [
      We(Y[0]),
      Y[1] ? We(Y[1]) : g[mt][1]
    ];
    x("hours", Ne(ve.getHours, "hours")), x("minutes", Ne(ve.getMinutes, "minutes")), x("seconds", Ne(ve.getSeconds, "seconds"));
  }, E = (Y, de) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return A(Y, de);
    if (e.multiDates) {
      const Ne = Y[Y.length - 1];
      return P(Ne, de);
    }
  }, O = (Y) => {
    const de = c.value;
    E(de, Y), f.value.multiCalendars && e.multiCalendarsSolo && M();
  }, T = () => {
    if (F(), !e.range)
      c.value = dn(qe(), g.hours, g.minutes, I());
    else {
      const Y = g.hours, de = g.minutes;
      c.value = [
        dn(qe(), Y[0], de[0], I()),
        dn(qe(), Y[1], de[1], I(!1))
      ];
    }
  }, D = () => {
    e.multiDates ? c.value = [u(qe(), m.value(0), b.value(0))] : c.value = u(qe(), m.value(0), b.value(0));
  }, $ = () => {
    c.value = qe();
  }, I = (Y = !0) => e.enableSeconds ? Array.isArray(g.seconds) ? Y ? g.seconds[0] : g.seconds[1] : g.seconds : 0, F = () => {
    const Y = i();
    if (Y) {
      const de = Array.isArray(Y), Ne = de ? [+Y[0].hours, +Y[1].hours] : +Y.hours, We = de ? [+Y[0].minutes, +Y[1].minutes] : +Y.minutes, mt = de ? [+Y[0].seconds, +Y[1].seconds] : +Y.seconds;
      x("hours", Ne), x("minutes", We), e.enableSeconds && x("seconds", mt);
    }
  }, j = () => Array.isArray(c.value) && c.value.length ? c.value[c.value.length - 1] : null, M = () => {
    if (Array.isArray(c.value) && c.value.length === 2) {
      const Y = qe(
        qe(c.value[1] ? c.value[1] : ve.addMonths(c.value[0], 1))
      ), [de, Ne] = [ve.getMonth(c.value[0]), ve.getYear(c.value[0])], [We, mt] = [ve.getMonth(c.value[1]), ve.getYear(c.value[1])];
      (de !== We || de === We && Ne !== mt) && e.multiCalendarsSolo && _(1, ve.getMonth(Y), ve.getYear(Y));
    } else
      c.value && !Array.isArray(c.value) && _(0, ve.getMonth(c.value), ve.getYear(c.value));
  }, q = (Y) => {
    const de = ve.addMonths(Y, 1);
    return { month: ve.getMonth(de), year: ve.getYear(de) };
  }, le = (Y) => {
    const de = ve.getMonth(qe(Y)), Ne = ve.getYear(qe(Y));
    if (_(0, de, Ne), f.value.multiCalendars > 0)
      for (let We = 1; We < f.value.multiCalendars; We++) {
        const mt = q(
          ve.set(qe(Y), { year: m.value(We - 1), month: b.value(We - 1) })
        );
        _(We, mt.month, mt.year);
      }
  }, Z = (Y) => {
    if (c.value && Array.isArray(c.value))
      if (c.value.some((de) => nr(Y, de))) {
        const de = c.value.filter((Ne) => !nr(Ne, Y));
        c.value = de.length ? de : null;
      } else
        (e.multiDatesLimit && +e.multiDatesLimit > c.value.length || !e.multiDatesLimit) && c.value.push(Y);
    else
      c.value = [Y];
  }, G = (Y, de) => {
    const Ne = Ia(Y, de) ? de : Y, We = Ia(de, Y) ? de : Y;
    return ve.eachDayOfInterval({ start: Ne, end: We });
  }, H = (Y, de = 0) => {
    if (Array.isArray(c.value) && c.value[de]) {
      const Ne = ve.differenceInCalendarDays(Y, c.value[de]), We = G(c.value[de], Y), mt = We.length === 1 ? 0 : We.filter((St) => s(St)).length, Nt = Math.abs(Ne) - mt;
      if (e.minRange && e.maxRange)
        return Nt >= +e.minRange && Nt <= +e.maxRange;
      if (e.minRange)
        return Nt >= +e.minRange;
      if (e.maxRange)
        return Nt <= +e.maxRange;
    }
    return !0;
  }, W = (Y) => Array.isArray(c.value) && c.value.length === 2 ? e.fixedStart && (Ia(Y, c.value[0]) || nr(Y, c.value[0])) ? [c.value[0], Y] : e.fixedEnd && (va(Y, c.value[1]) || nr(Y, c.value[1])) ? [Y, c.value[1]] : (t("invalid-fixed-range", Y), c.value) : [], ie = () => {
    e.autoApply && y.value && t("auto-apply", e.partialFlow);
  }, we = () => {
    e.autoApply && t("select-date");
  }, Be = (Y) => !ve.eachDayOfInterval({ start: Y[0], end: Y[1] }).some((de) => s(de)), Ve = (Y) => (c.value = l(qe(Y.value)), ie()), et = (Y) => {
    const de = dn(qe(Y.value), g.hours, g.minutes, I());
    e.multiDates ? Z(de) : c.value = de, r(), ie();
  }, nt = () => {
    p.value = c.value ? c.value.slice() : [], p.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (p.value = []);
  }, xe = (Y, de) => {
    const Ne = [qe(Y.value), ve.addDays(qe(Y.value), +e.autoRange)];
    Be(Ne) && (de && le(Y.value), p.value = Ne);
  }, J = (Y) => {
    se(Y.value) || !H(Y.value, e.fixedStart ? 0 : 1) || (p.value = W(qe(Y.value)));
  }, se = (Y) => e.noDisabledRange ? G(p.value[0], Y).some((de) => s(de)) : !1, _e = (Y, de) => {
    if (nt(), e.autoRange)
      return xe(Y, de);
    if (e.fixedStart || e.fixedEnd)
      return J(Y);
    p.value[0] ? H(qe(Y.value)) && !se(Y.value) && (va(qe(Y.value), qe(p.value[0])) ? (p.value.unshift(qe(Y.value)), t("range-end", p.value[0])) : (p.value[1] = qe(Y.value), t("range-end", p.value[1]))) : (p.value[0] = qe(Y.value), t("range-start", p.value[0]));
  }, Se = (Y) => {
    p.value[Y] = dn(
      p.value[Y],
      g.hours[Y],
      g.minutes[Y],
      I(Y !== 1)
    );
  }, Re = () => {
    var Y, de;
    p.value[0] && p.value[1] && +((Y = p.value) == null ? void 0 : Y[0]) > +((de = p.value) == null ? void 0 : de[1]) && (p.value.reverse(), t("range-start", p.value[0]), t("range-end", p.value[1]));
  }, rt = () => {
    p.value.length && (p.value[0] && !p.value[1] ? Se(0) : (Se(0), Se(1), r()), Re(), c.value = p.value.slice(), p.value[0] && p.value[1] && e.autoApply && t("auto-apply"), p.value[0] && !p.value[1] && e.modelAuto && e.autoApply && t("auto-apply"));
  }, Dt = (Y, de = !1) => {
    if (!(s(Y.value) || !Y.current && e.hideOffsetDates)) {
      if (e.weekPicker)
        return Ve(Y);
      if (!e.range)
        return et(Y);
      _s(g.hours) && _s(g.minutes) && !e.multiDates && (_e(Y, de), rt());
    }
  }, It = (Y) => {
    const de = Y[0];
    return e.weekNumbers === "local" ? ve.getWeek(de.value, { weekStartsOn: +e.weekStart }) : e.weekNumbers === "iso" ? ve.getISOWeek(de.value) : typeof e.weekNumbers == "function" ? e.weekNumbers(de.value) : "";
  }, Ye = (Y) => {
    for (let de = Y - 1; de >= 0; de--) {
      const Ne = ve.subMonths(ve.set(qe(), { month: m.value(de + 1), year: b.value(de + 1) }), 1);
      _(de, ve.getMonth(Ne), ve.getYear(Ne));
    }
    for (let de = Y + 1; de <= f.value.multiCalendars - 1; de++) {
      const Ne = ve.addMonths(ve.set(qe(), { month: m.value(de - 1), year: b.value(de - 1) }), 1);
      _(de, ve.getMonth(Ne), ve.getYear(Ne));
    }
  }, at = (Y) => u(qe(), m.value(Y), b.value(Y)), ut = (Y) => dn(Y, g.hours, g.minutes, I()), Gt = (Y) => {
    Z(at(Y));
  }, Je = (Y, de) => {
    const Ne = e.monthPicker ? m.value(Y) !== de.month || !de.fromNav : b.value(Y) !== de.year || !de.fromNav;
    if (_(Y, de.month, de.year), f.value.multiCalendars && !e.multiCalendarsSolo && Ye(Y), e.monthPicker || e.yearPicker)
      if (e.multiDates)
        Ne && Gt(Y);
      else if (e.range) {
        if (Ne && H(at(Y))) {
          let We = c.value ? c.value.slice() : [];
          We.length === 2 && We[1] !== null && (We = []), We.length ? va(at(Y), We[0]) ? We.unshift(at(Y)) : We[1] = at(Y) : We = [at(Y)], c.value = We;
        }
      } else
        (e.autoApplyMonth || Ne) && (c.value = at(Y));
    a(e.multiCalendarsSolo ? Y : void 0);
  }, he = async (Y = !1) => {
    if (e.autoApply && (e.monthPicker || e.yearPicker)) {
      await Pt();
      const de = e.monthPicker ? Y : !1;
      e.range ? t("auto-apply", de || !c.value || c.value.length === 1) : t("auto-apply", de);
    }
    r();
  }, ye = (Y, de) => {
    const Ne = ve.set(qe(), { month: m.value(de), year: b.value(de) }), We = Y < 0 ? ve.addMonths(Ne, 1) : ve.subMonths(Ne, 1);
    d(ve.getMonth(We), ve.getYear(We), Y < 0, e.preventMinMaxNavigation) && (_(de, ve.getMonth(We), ve.getYear(We)), f.value.multiCalendars && !e.multiCalendarsSolo && Ye(de), a());
  }, Ke = (Y) => {
    f2(Y) && f2(c.value) && _s(g.hours) && _s(g.minutes) ? (Y[0] && c.value[0] && (c.value[0] = dn(Y[0], g.hours[0], g.minutes[0], I())), Y[1] && c.value[1] && (c.value[1] = dn(Y[1], g.hours[1], g.minutes[1], I(!1)))) : e.multiDates && Array.isArray(c.value) ? c.value[c.value.length - 1] = ut(Y) : !e.range && !p2(Y) && (c.value = ut(Y)), t("time-update");
  }, Q = (Y, de = !0, Ne = !1) => {
    const We = de ? Y : g.hours, mt = !de && !Ne ? Y : g.minutes, Nt = Ne ? Y : g.seconds;
    if (e.range && p2(c.value) && _s(We) && _s(mt) && _s(Nt) && !e.disableTimeRangeValidation) {
      const St = (Ue) => dn(c.value[Ue], We[Ue], mt[Ue], Nt[Ue]), me = (Ue) => ve.setMilliseconds(c.value[Ue], 0);
      if (nr(c.value[0], c.value[1]) && (ve.isAfter(St(0), me(1)) || ve.isBefore(St(1), me(0))))
        return;
    }
    if (x("hours", We), x("minutes", mt), x("seconds", Nt), c.value)
      if (e.multiDates) {
        const St = j();
        St && Ke(St);
      } else
        Ke(c.value);
    else
      e.timePicker && Ke(e.range ? [qe(), qe()] : qe());
    r();
  }, L = (Y, de) => {
    e.monthChangeOnScroll && ye(e.monthChangeOnScroll !== "inverse" ? -Y.deltaY : Y.deltaY, de);
  }, Te = (Y, de, Ne = !1) => {
    e.monthChangeOnArrows && e.vertical === Ne && Oe(Y, de);
  }, Oe = (Y, de) => {
    ye(Y === "right" ? -1 : 1, de);
  };
  return {
    time: g,
    month: m,
    year: b,
    modelValue: c,
    calendars: h,
    monthYearSelect: he,
    isDisabled: s,
    updateTime: Q,
    getWeekNum: It,
    selectDate: Dt,
    updateMonthYear: Je,
    handleScroll: L,
    getMarker: (Y) => e.markers.find((de) => nr(o(Y.value), o(de.date))),
    handleArrow: Te,
    handleSwipe: Oe,
    selectCurrentDate: () => {
      e.range ? c.value && Array.isArray(c.value) && c.value[0] ? c.value = va(qe(), c.value[0]) ? [qe(), c.value[0]] : [c.value[0], qe()] : c.value = [qe()] : c.value = qe(), we();
    },
    presetDateRange: (Y, de) => {
      de || Y.length && Y.length <= 2 && e.range && (c.value = Y.map((Ne) => qe(Ne)), we(), e.multiCalendars && Pt().then(() => k(!0)));
    }
  };
}, fq = (e, t, r) => {
  const a = ne(), {
    getZonedToUtc: n,
    getZonedDate: i,
    formatDate: s,
    getDefaultPattern: o,
    checkRangeEnabled: l,
    checkPartialRangeValue: u,
    isValidDate: d,
    setDateMonthOrYear: f,
    defaults: c
  } = en(t), p = ne(""), v = ql(t, "format");
  He(a, () => {
    e("internal-model-change", a.value);
  }), He(v, () => {
    j();
  });
  const h = (H) => {
    const W = H || qe();
    return t.modelType ? q(W) : {
      hours: ve.getHours(W),
      minutes: ve.getMinutes(W),
      seconds: t.enableSeconds ? ve.getSeconds(W) : 0
    };
  }, g = (H) => t.modelType ? q(H) : { month: ve.getMonth(H), year: ve.getYear(H) }, m = (H) => Array.isArray(H) ? l(() => [
    ve.setYear(qe(), H[0]),
    H[1] ? ve.setYear(qe(), H[1]) : u()
  ]) : ve.setYear(qe(), +H), b = (H, W) => (typeof H == "string" || typeof H == "number") && t.modelType ? M(H) : W, y = (H) => Array.isArray(H) ? [
    b(
      H[0],
      dn(null, +H[0].hours, +H[0].minutes, H[0].seconds)
    ),
    b(
      H[1],
      dn(null, +H[1].hours, +H[1].minutes, H[1].seconds)
    )
  ] : b(H, dn(null, H.hours, H.minutes, H.seconds)), _ = (H) => Array.isArray(H) ? t.multiDates ? H.map((W) => b(W, f(null, +W.month, +W.year))) : l(() => [
    b(H[0], f(null, +H[0].month, +H[0].year)),
    b(
      H[1],
      H[1] ? f(null, +H[1].month, +H[1].year) : u()
    )
  ]) : b(H, f(null, +H.month, +H.year)), x = (H) => {
    if (Array.isArray(H))
      return H.map((W) => M(W));
    throw new Error(Ed.dateArr("multi-dates"));
  }, w = (H) => {
    if (Array.isArray(H))
      return [qe(H[0]), qe(H[1])];
    throw new Error(Ed.dateArr("week-picker"));
  }, k = (H) => t.modelAuto ? Array.isArray(H) ? [M(H[0]), M(H[1])] : t.autoApply ? [M(H)] : [M(H), null] : Array.isArray(H) ? l(() => [
    M(H[0]),
    H[1] ? M(H[1]) : u()
  ]) : M(H), S = () => {
    Array.isArray(a.value) && t.range && a.value.length === 1 && a.value.push(u());
  }, P = () => {
    const H = a.value;
    return [
      q(H[0]),
      H[1] ? q(H[1]) : u()
    ];
  }, A = () => a.value[1] ? P() : q(pa(a.value[0])), E = () => (a.value || []).map((H) => q(H)), O = () => (S(), t.modelAuto ? A() : t.multiDates ? E() : Array.isArray(a.value) ? l(() => P()) : q(pa(a.value))), T = (H) => H ? t.timePicker ? y(pa(H)) : t.monthPicker ? _(pa(H)) : t.yearPicker ? m(pa(H)) : t.multiDates ? x(pa(H)) : t.weekPicker ? w(pa(H)) : k(pa(H)) : null, D = (H) => {
    const W = T(H);
    d(pa(W)) ? (a.value = pa(W), j()) : (a.value = null, p.value = "");
  }, $ = () => {
    var H;
    const W = (ie) => {
      var we;
      return ve.format(ie, (we = c.value.textInputOptions) == null ? void 0 : we.format);
    };
    return `${W(a.value[0])} ${(H = c.value.textInputOptions) == null ? void 0 : H.rangeSeparator} ${a.value[1] ? W(a.value[1]) : ""}`;
  }, I = () => {
    var H;
    return r.value && a.value ? Array.isArray(a.value) ? $() : ve.format(a.value, (H = c.value.textInputOptions) == null ? void 0 : H.format) : s(a.value);
  }, F = () => {
    var H;
    return a.value ? t.multiDates ? a.value.map((W) => s(W)).join("; ") : t.textInput && typeof ((H = c.value.textInputOptions) == null ? void 0 : H.format) == "string" ? I() : s(a.value) : "";
  }, j = () => {
    !t.format || typeof t.format == "string" || t.textInput && typeof t.textInputOptions.format == "string" ? p.value = F() : p.value = t.format(a.value);
  }, M = (H) => {
    if (t.utc) {
      const W = new Date(H);
      return t.utc === "preserve" ? new Date(W.getTime() + W.getTimezoneOffset() * 6e4) : W;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? i(new Date(H)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? ve.parse(H, o(), /* @__PURE__ */ new Date()) : i(ve.parse(H, t.modelType, /* @__PURE__ */ new Date())) : i(new Date(H));
  }, q = (H) => H ? t.utc ? xB(H, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +n(H) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? s(n(H)) : s(n(H), t.modelType) : n(H) : "", le = (H) => {
    e("update:model-value", H);
  }, Z = (H) => Array.isArray(a.value) ? t.multiDates ? a.value.map((W) => H(W)) : [
    H(a.value[0]),
    a.value[1] ? H(a.value[1]) : u()
  ] : H(pa(a.value)), G = (H) => le(pa(Z(H)));
  return {
    inputValue: p,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? t.range ? t.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: D,
    formatInputValue: j,
    emitModelValue: () => (j(), t.monthPicker ? G(g) : t.timePicker ? G(h) : t.yearPicker ? G(ve.getYear) : t.weekPicker ? le(a.value) : le(O()))
  };
}, pq = (e, t) => {
  const { validateMonthYearInRange: r, validateMaxDate: a, validateMinDate: n, defaults: i } = en(e), s = (f, c) => {
    let p = f;
    return i.value.filters.months.includes(ve.getMonth(p)) ? (p = c ? ve.addMonths(f, 1) : ve.subMonths(f, 1), s(p, c)) : p;
  }, o = (f, c) => {
    let p = f;
    return i.value.filters.years.includes(ve.getYear(p)) ? (p = c ? ve.addYears(f, 1) : ve.subYears(f, 1), o(p, c)) : p;
  }, l = (f) => {
    const c = ve.set(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let p = f ? ve.addMonths(c, 1) : ve.subMonths(c, 1);
    e.disableYearSelect && (p = ve.setYear(p, e.year));
    let v = ve.getMonth(p), h = ve.getYear(p);
    i.value.filters.months.includes(v) && (p = s(p, f), v = ve.getMonth(p), h = ve.getYear(p)), i.value.filters.years.includes(h) && (p = o(p, f), h = ve.getYear(p)), r(v, h, f, e.preventMinMaxNavigation) && u(v, h);
  }, u = (f, c) => {
    t("update-month-year", { month: f, year: c });
  }, d = N(() => (f) => {
    if (!e.preventMinMaxNavigation || f && !e.maxDate || !f && !e.minDate)
      return !1;
    const c = ve.set(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }), p = f ? ve.addMonths(c, 1) : ve.subMonths(c, 1), v = [ve.getMonth(p), ve.getYear(p)];
    return f ? !a(...v) : !n(...v);
  });
  return { handleMonthYearChange: l, isDisabled: d, updateMonthYear: u };
};
var od = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(od || {});
const vq = (e, t, r, a) => {
  const n = ne({
    top: "0",
    left: "0",
    transform: "none",
    opacity: "0"
  }), i = ne(!1), s = ql(a, "teleportCenter"), o = N(() => i.value ? "-100%" : "0"), l = () => {
    u(), n.value.opacity = "0";
  };
  He(s, () => {
    b();
  }), ct(() => {
    u();
  });
  const u = () => {
    const O = Fr(t);
    if (O) {
      const { top: T, left: D, width: $, height: I } = v(O);
      n.value.top = `${T + I / 2}px`, p(D, $, 50);
    }
  }, d = (O) => {
    if (a.teleport) {
      const T = O.getBoundingClientRect();
      return {
        left: T.left + window.scrollX,
        top: T.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, f = (O, T) => {
    n.value.left = `${O + T}px`, n.value.transform = `translate(-100%, ${o.value})`;
  }, c = (O) => {
    n.value.left = `${O}px`, n.value.transform = `translate(0, ${o.value})`;
  }, p = (O, T, D) => {
    a.position === od.left && c(O), a.position === od.right && f(O, T), a.position === od.center && (n.value.left = `${O + T / 2}px`, n.value.transform = D ? `translate(-50%, -${D}%)` : `translate(-50%, ${o.value})`);
  }, v = (O) => {
    const { width: T, height: D } = O.getBoundingClientRect(), { top: $, left: I } = a.altPosition ? a.altPosition(O) : d(O);
    return { top: +$, left: +I, width: T, height: D };
  }, h = () => {
    const O = Fr(t);
    if (O) {
      const { top: T, left: D, width: $, height: I } = v(O), F = k();
      n.value.top = `${T + I / 2}px`, p(D, $, F === "top" ? 100 : 0);
    }
  }, g = () => {
    n.value.left = "50%", n.value.top = "50%", n.value.transform = "translate(-50%, -50%)", n.value.position = "fixed", delete n.value.opacity;
  }, m = () => {
    const O = Fr(t), { top: T, left: D, transform: $ } = a.altPosition(O);
    n.value = { top: `${T}px`, left: `${D}px`, transform: $ || "" };
  }, b = (O = !0) => {
    if (!a.inline)
      return s.value ? g() : a.altPosition !== null ? m() : (O && r("recalculate-position"), P());
  }, y = ({
    inputEl: O,
    menuEl: T,
    left: D,
    width: $
  }) => {
    window.screen.width > 768 && p(D, $), w(O, T);
  }, _ = (O, T) => {
    const { top: D, left: $, height: I, width: F } = v(O);
    n.value.top = `${I + D + +a.offset}px`, i.value = !1, y({ inputEl: O, menuEl: T, left: $, width: F });
  }, x = (O, T) => {
    const { top: D, left: $, width: I } = v(O);
    n.value.top = `${D - +a.offset}px`, i.value = !0, y({ inputEl: O, menuEl: T, left: $, width: I });
  }, w = (O, T) => {
    if (a.autoPosition) {
      const { left: D, width: $ } = v(O), { left: I, right: F } = T.getBoundingClientRect();
      return I <= 0 ? c(D) : F >= document.documentElement.clientWidth ? f(D, $) : p(D, $);
    }
  }, k = () => {
    const O = Fr(e), T = Fr(t);
    if (O && T) {
      const { height: D } = O.getBoundingClientRect(), { top: $, height: I } = T.getBoundingClientRect(), F = window.innerHeight - $ - I, j = $;
      return D <= F ? "bottom" : D > F && D <= j ? "top" : F >= j ? "bottom" : "top";
    }
    return "bottom";
  }, S = (O, T) => k() === "bottom" ? _(O, T) : x(O, T), P = () => {
    const O = Fr(t), T = Fr(e);
    if (O && T)
      return a.autoPosition ? S(O, T) : _(O, T);
  }, A = function(O) {
    if (O) {
      const T = O.scrollHeight > O.clientHeight, D = window.getComputedStyle(O).overflowY.indexOf("hidden") !== -1;
      return T && !D;
    }
    return !0;
  }, E = function(O) {
    return !O || O === document.body || O.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : A(O) ? O : E(O.parentNode);
  };
  return { openOnTop: i, menuStyle: n, resetPosition: l, setMenuPosition: b, setInitialPosition: h, getScrollableParent: E };
}, to = [
  { name: "clock-icon", use: ["time", "calendar"] },
  { name: "arrow-left", use: ["month-year", "calendar"] },
  { name: "arrow-right", use: ["month-year", "calendar"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar"] },
  { name: "day", use: ["calendar"] },
  { name: "month-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay", use: ["month-year"] },
  { name: "month-overlay", use: ["month-year"] },
  { name: "month-overlay-header", use: ["month-year"] },
  { name: "year-overlay-header", use: ["month-year"] },
  { name: "hours-overlay-value", use: ["calendar", "time"] },
  { name: "minutes-overlay-value", use: ["calendar", "time"] },
  { name: "seconds-overlay-value", use: ["calendar", "time"] },
  { name: "hours", use: ["calendar", "time"] },
  { name: "minutes", use: ["calendar", "time"] },
  { name: "month", use: ["calendar", "month-year"] },
  { name: "year", use: ["calendar", "month-year"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar"] },
  { name: "marker-tooltip", use: ["calendar"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time"] },
  { name: "am-pm-button", use: ["calendar", "time"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year"] },
  { name: "time-picker", use: ["menu"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar"] }
], mq = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], hq = {
  all: () => to,
  monthYear: () => to.filter((e) => e.use.includes("month-year")),
  input: () => mq,
  timePicker: () => to.filter((e) => e.use.includes("time")),
  action: () => to.filter((e) => e.use.includes("action")),
  calendar: () => to.filter((e) => e.use.includes("calendar")),
  menu: () => to.filter((e) => e.use.includes("menu"))
}, Ss = (e, t, r) => {
  const a = [];
  return hq[t]().forEach((n) => {
    e[n.name] && a.push(n.name);
  }), r && r.length && r.forEach((n) => {
    n.slot && a.push(n.slot);
  }), a;
}, Uc = (e) => ({ transitionName: N(() => (t) => e && typeof e != "boolean" ? t ? e.open : e.close : ""), showTransition: !!e }), ps = {
  multiCalendars: { type: [Boolean, Number, String], default: null },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  multiCalendarsSolo: { type: Boolean, default: !1 },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  showNowButton: { type: Boolean, default: !1 },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetRanges: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  multiStatic: { type: Boolean, default: !0 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function],
    default: null
  },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  inlineWithInput: { type: Boolean, default: !1 },
  textInputOptions: { type: Object, default: () => null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: Boolean, default: !1 },
  textInput: { type: Boolean, default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  allowPreventDefault: { type: Boolean, default: !1 },
  closeOnClearValue: { type: Boolean, default: !0 },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: Function, default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  autoApplyMonth: { type: Boolean, default: !0 }
}, gq = {
  key: 1,
  class: "dp__input_wrap"
}, bq = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "onKeydown"], yq = {
  key: 2,
  class: "dp__clear_icon"
}, _q = /* @__PURE__ */ Ae({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...ps
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, { getDefaultPattern: n, isValidDate: i, defaults: s, getDefaultStartTime: o, assignDefaultTime: l } = en(a), u = ne(), d = ne(null), f = ne(!1), c = ne(!1), p = N(
      () => ({
        dp__pointer: !a.disabled && !a.readonly && !a.textInput,
        dp__disabled: a.disabled,
        dp__input_readonly: !a.textInput,
        dp__input: !0,
        dp__input_icon_pad: !a.hideInputIcon,
        dp__input_valid: a.state,
        dp__input_invalid: a.state === !1,
        dp__input_focus: f.value || a.isMenuOpen,
        dp__input_reg: !a.textInput,
        [a.inputClassName]: !!a.inputClassName
      })
    ), v = () => {
      r("set-input-date", null), a.autoApply && (r("set-empty-date"), u.value = null);
    }, h = (E) => {
      var O;
      const T = o();
      return _B(
        E,
        ((O = s.value.textInputOptions) == null ? void 0 : O.format) || n(),
        T || l({}),
        a.inputValue,
        c.value
      );
    }, g = (E) => {
      const { rangeSeparator: O } = s.value.textInputOptions, [T, D] = E.split(`${O}`);
      if (T) {
        const $ = h(T.trim()), I = D ? h(D.trim()) : null, F = $ && I ? [$, I] : [$];
        u.value = $ ? F : null;
      }
    }, m = () => {
      c.value = !0;
    }, b = (E) => {
      if (a.range)
        g(E);
      else if (a.multiDates) {
        const O = E.split(";");
        u.value = O.map((T) => h(T.trim())).filter((T) => T);
      } else
        u.value = h(E);
    }, y = (E) => {
      var O, T;
      const D = typeof E == "string" ? E : (O = E.target) == null ? void 0 : O.value;
      D !== "" ? ((T = s.value.textInputOptions) != null && T.openMenu && !a.isMenuOpen && r("open"), b(D), r("set-input-date", u.value)) : v(), c.value = !1, r("update:input-value", D);
    }, _ = (E) => {
      var O, T;
      a.textInput ? (b(E.target.value), (O = s.value.textInputOptions) != null && O.enterSubmit && i(u.value) && a.inputValue !== "" ? (r("set-input-date", u.value, !0), u.value = null) : (T = s.value.textInputOptions) != null && T.enterSubmit && a.inputValue === "" && (u.value = null, r("clear"))) : k(E);
    }, x = (E) => {
      var O, T, D;
      a.textInput && (O = s.value.textInputOptions) != null && O.tabSubmit && b(E.target.value), (T = s.value.textInputOptions) != null && T.tabSubmit && i(u.value) && a.inputValue !== "" ? (r("set-input-date", u.value, !0), u.value = null) : (D = s.value.textInputOptions) != null && D.tabSubmit && a.inputValue === "" && (u.value = null, r("clear"));
    }, w = () => {
      f.value = !0, r("focus");
    }, k = (E) => {
      var O;
      E.preventDefault(), E.stopImmediatePropagation(), E.stopPropagation(), a.textInput && (O = s.value.textInputOptions) != null && O.openMenu && !a.inlineWithInput ? (r("toggle"), s.value.textInputOptions.enterSubmit && r("select-date")) : a.textInput || r("toggle");
    }, S = () => {
      r("real-blur"), f.value = !1, (!a.isMenuOpen || a.inline && a.inlineWithInput) && r("blur"), a.autoApply && a.textInput && u.value && !a.isMenuOpen && (r("set-input-date", u.value), r("select-date"), u.value = null);
    }, P = () => {
      r("clear");
    }, A = (E) => {
      if (!a.textInput) {
        if (E.code === "Tab")
          return;
        E.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var E;
        (E = d.value) == null || E.focus({ preventScroll: !0 });
      },
      setParsedDate: (E) => {
        u.value = E;
      }
    }), (E, O) => {
      var T;
      return R(), K("div", { onClick: k }, [
        E.$slots.trigger && !E.$slots["dp-input"] && !E.inline ? ke(E.$slots, "trigger", { key: 0 }) : fe("", !0),
        !E.$slots.trigger && (!E.inline || E.inlineWithInput) ? (R(), K("div", gq, [
          E.$slots["dp-input"] && !E.$slots.trigger && !E.inline ? ke(E.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: y,
            onEnter: _,
            onTab: x,
            onClear: P,
            onBlur: S,
            onKeypress: A,
            onPaste: m
          }) : fe("", !0),
          E.$slots["dp-input"] ? fe("", !0) : (R(), K("input", {
            key: 1,
            ref_key: "inputRef",
            ref: d,
            id: E.uid ? `dp-input-${E.uid}` : void 0,
            name: E.name,
            class: pe(p.value),
            inputmode: E.textInput ? "text" : "none",
            placeholder: E.placeholder,
            disabled: E.disabled,
            readonly: E.readonly,
            required: E.required,
            value: e.inputValue,
            autocomplete: E.autocomplete,
            "aria-label": (T = U(s).ariaLabels) == null ? void 0 : T.input,
            onInput: y,
            onKeydown: [
              Ot(_, ["enter"]),
              Ot(x, ["tab"]),
              A
            ],
            onBlur: S,
            onFocus: w,
            onKeypress: A,
            onPaste: m
          }, null, 42, bq)),
          ue("div", {
            onClick: O[2] || (O[2] = (D) => r("toggle"))
          }, [
            E.$slots["input-icon"] && !E.hideInputIcon ? (R(), K("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: O[0] || (O[0] = (D) => r("toggle"))
            }, [
              ke(E.$slots, "input-icon")
            ])) : fe("", !0),
            !E.$slots["input-icon"] && !E.hideInputIcon && !E.$slots["dp-input"] ? (R(), Le(U(Vc), {
              key: 1,
              onClick: O[1] || (O[1] = (D) => r("toggle")),
              class: "dp__input_icon dp__input_icons"
            })) : fe("", !0)
          ]),
          E.$slots["clear-icon"] && e.inputValue && E.clearable && !E.disabled && !E.readonly ? (R(), K("span", yq, [
            ke(E.$slots, "clear-icon", { clear: P })
          ])) : fe("", !0),
          E.clearable && !E.$slots["clear-icon"] && e.inputValue && !E.disabled && !E.readonly ? (R(), Le(U(yB), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: zr(P, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : fe("", !0)
        ])) : fe("", !0)
      ]);
    };
  }
}), xq = ["title"], wq = { class: "dp__action_buttons" }, Tq = ["onKeydown", "disabled"], Sq = /* @__PURE__ */ Ae({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    calendarWidth: { type: Number, default: 0 },
    ...ps
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const r = e, { formatDate: a, isValidTime: n, defaults: i } = en(r), { buildMatrix: s } = fs(), o = ne(null), l = ne(null);
    ct(() => {
      r.arrowNavigation && s([Fr(o), Fr(l)], "actionRow");
    });
    const u = N(() => r.range && !r.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), d = N(() => !f.value || !c.value || !u.value), f = N(() => !r.enableTimePicker || r.ignoreTimeValidation ? !0 : n(r.internalModelValue)), c = N(() => r.monthPicker ? r.range && Array.isArray(r.internalModelValue) ? !r.internalModelValue.filter((x) => !y(x)).length : y(r.internalModelValue) : !0), p = () => {
      const x = i.value.previewFormat;
      return r.timePicker || r.monthPicker, x(pa(r.internalModelValue));
    }, v = () => {
      const x = r.internalModelValue;
      return i.value.multiCalendars > 0 ? `${h(x[0])} - ${h(x[1])}` : [h(x[0]), h(x[1])];
    }, h = (x) => a(x, i.value.previewFormat), g = N(() => !r.internalModelValue || !r.menuMount ? "" : typeof i.value.previewFormat == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? v() : r.multiDates ? r.internalModelValue.map((x) => `${h(x)}`) : r.modelAuto ? `${h(r.internalModelValue[0])}` : `${h(r.internalModelValue[0])} -` : h(r.internalModelValue) : p()), m = () => r.multiDates ? "; " : " - ", b = N(
      () => Array.isArray(g.value) ? g.value.join(m()) : g.value
    ), y = (x) => {
      if (!r.monthPicker)
        return !0;
      let w = !0;
      const k = qe(xl(x));
      if (r.minDate && r.maxDate) {
        const S = qe(xl(r.minDate)), P = qe(xl(r.maxDate));
        return Ia(k, S) && va(k, P) || nr(k, S) || nr(k, P);
      }
      if (r.minDate) {
        const S = qe(xl(r.minDate));
        w = Ia(k, S) || nr(k, S);
      }
      if (r.maxDate) {
        const S = qe(xl(r.maxDate));
        w = va(k, S) || nr(k, S);
      }
      return w;
    }, _ = () => {
      f.value && c.value && u.value ? t("select-date") : t("invalid-select");
    };
    return (x, w) => (R(), K("div", {
      class: "dp__action_row",
      style: Ir(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      x.$slots["action-row"] ? ke(x.$slots, "action-row", jr(Mt({ key: 0 }, {
        internalModelValue: e.internalModelValue,
        disabled: d.value,
        selectDate: () => x.$emit("select-date"),
        closePicker: () => x.$emit("close-picker")
      }))) : (R(), K(Qe, { key: 1 }, [
        U(i).actionRow.showPreview ? (R(), K("div", {
          key: 0,
          class: "dp__selection_preview",
          title: b.value
        }, [
          x.$slots["action-preview"] ? ke(x.$slots, "action-preview", {
            key: 0,
            value: e.internalModelValue
          }) : fe("", !0),
          x.$slots["action-preview"] ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
            jt(Ie(b.value), 1)
          ], 64))
        ], 8, xq)) : fe("", !0),
        ue("div", wq, [
          x.$slots["action-buttons"] ? ke(x.$slots, "action-buttons", {
            key: 0,
            value: e.internalModelValue
          }) : fe("", !0),
          x.$slots["action-buttons"] ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
            !x.inline && U(i).actionRow.showCancel ? (R(), K("button", {
              key: 0,
              type: "button",
              ref_key: "cancelButtonRef",
              ref: o,
              class: "dp__action_button dp__action_cancel",
              onClick: w[0] || (w[0] = (k) => x.$emit("close-picker")),
              onKeydown: [
                w[1] || (w[1] = Ot((k) => x.$emit("close-picker"), ["enter"])),
                w[2] || (w[2] = Ot((k) => x.$emit("close-picker"), ["space"]))
              ]
            }, Ie(x.cancelText), 545)) : fe("", !0),
            x.showNowButton || U(i).actionRow.showNow ? (R(), K("button", {
              key: 1,
              type: "button",
              ref_key: "cancelButtonRef",
              ref: o,
              class: "dp__action_button dp__action_cancel",
              onClick: w[3] || (w[3] = (k) => x.$emit("select-now")),
              onKeydown: [
                w[4] || (w[4] = Ot((k) => x.$emit("select-now"), ["enter"])),
                w[5] || (w[5] = Ot((k) => x.$emit("select-now"), ["space"]))
              ]
            }, Ie(x.nowButtonLabel), 545)) : fe("", !0),
            U(i).actionRow.showSelect ? (R(), K("button", {
              key: 2,
              type: "button",
              class: "dp__action_button dp__action_select",
              onKeydown: [
                Ot(_, ["enter"]),
                Ot(_, ["space"])
              ],
              onClick: _,
              disabled: d.value,
              ref_key: "selectButtonRef",
              ref: l
            }, Ie(x.selectText), 41, Tq)) : fe("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), Eq = ["aria-label"], Oq = {
  class: "dp__calendar_header",
  role: "row"
}, Cq = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, kq = /* @__PURE__ */ ue("div", { class: "dp__calendar_header_separator" }, null, -1), Pq = ["aria-label"], Mq = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, Aq = { class: "dp__cell_inner" }, Dq = ["aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], Iq = /* @__PURE__ */ Ae({
  __name: "Calendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    getWeekNum: {
      type: Function,
      default: () => ""
    },
    specificMode: { type: Boolean, default: !1 },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...ps
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, { buildMultiLevelMatrix: n } = fs(), { setDateMonthOrYear: i, defaults: s } = en(a), o = ne(null), l = ne({
      bottom: "",
      left: "",
      transform: ""
    }), u = ne([]), d = ne(null), f = ne(!0), c = ne(""), p = ne({ startX: 0, endX: 0, startY: 0, endY: 0 }), v = ne([]), h = ne({ left: "50%" }), g = N(() => a.calendar ? a.calendar(a.mappedDates) : a.mappedDates), m = N(() => a.dayNames ? Array.isArray(a.dayNames) ? a.dayNames : a.dayNames(a.locale, +a.weekStart) : JB(a.formatLocale, a.locale, +a.weekStart));
    ct(() => {
      r("mount", { cmp: "calendar", refs: u }), a.noSwipe || d.value && (d.value.addEventListener("touchstart", O, { passive: !1 }), d.value.addEventListener("touchend", T, { passive: !1 }), d.value.addEventListener("touchmove", D, { passive: !1 })), a.monthChangeOnScroll && d.value && d.value.addEventListener("wheel", F, { passive: !1 });
    });
    const b = (j) => j ? a.vertical ? "vNext" : "next" : a.vertical ? "vPrevious" : "previous", y = (j, M) => {
      if (a.transitions) {
        const q = _n(i(qe(), a.month, a.year));
        c.value = Ia(_n(i(qe(), j, M)), q) ? s.value.transitions[b(!0)] : s.value.transitions[b(!1)], f.value = !1, Pt(() => {
          f.value = !0;
        });
      }
    }, _ = N(
      () => ({
        [a.calendarClassName]: !!a.calendarClassName
      })
    ), x = N(() => (j) => {
      const M = tq(j);
      return {
        dp__marker_dot: M.type === "dot",
        dp__marker_line: M.type === "line"
      };
    }), w = N(() => (j) => nr(j, o.value)), k = N(() => ({
      dp__calendar: !0,
      dp__calendar_next: s.value.multiCalendars > 0 && a.instance !== 0
    })), S = N(() => (j) => a.hideOffsetDates ? j.current : !0), P = N(() => a.specificMode ? { height: `${a.modeHeight}px` } : void 0), A = async (j, M, q) => {
      var le, Z;
      if (r("set-hover-date", j), (Z = (le = j.marker) == null ? void 0 : le.tooltip) != null && Z.length) {
        const G = Fr(u.value[M][q]);
        if (G) {
          const { width: H, height: W } = G.getBoundingClientRect();
          o.value = j.value;
          let ie = { left: `${H / 2}px` }, we = -50;
          if (await Pt(), v.value[0]) {
            const { left: Be, width: Ve } = v.value[0].getBoundingClientRect();
            Be < 0 && (ie = { left: "0" }, we = 0, h.value.left = `${H / 2}px`), window.innerWidth < Be + Ve && (ie = { right: "0" }, we = 0, h.value.left = `${Ve - H / 2}px`);
          }
          l.value = {
            bottom: `${W}px`,
            ...ie,
            transform: `translateX(${we}%)`
          }, r("tooltip-open", j.marker);
        }
      }
    }, E = (j) => {
      o.value && (o.value = null, l.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", j.marker));
    }, O = (j) => {
      p.value.startX = j.changedTouches[0].screenX, p.value.startY = j.changedTouches[0].screenY;
    }, T = (j) => {
      p.value.endX = j.changedTouches[0].screenX, p.value.endY = j.changedTouches[0].screenY, $();
    }, D = (j) => {
      a.vertical && !a.inline && j.preventDefault();
    }, $ = () => {
      const j = a.vertical ? "Y" : "X";
      Math.abs(p.value[`start${j}`] - p.value[`end${j}`]) > 10 && r("handle-swipe", p.value[`start${j}`] > p.value[`end${j}`] ? "right" : "left");
    }, I = (j, M, q) => {
      j && (Array.isArray(u.value[M]) ? u.value[M][q] = j : u.value[M] = [j]), a.arrowNavigation && n(u.value, "calendar");
    }, F = (j) => {
      a.monthChangeOnScroll && (j.preventDefault(), r("handle-scroll", j));
    };
    return t({ triggerTransition: y }), (j, M) => {
      var q;
      return R(), K("div", {
        class: pe(k.value)
      }, [
        ue("div", {
          style: Ir(P.value),
          ref_key: "calendarWrapRef",
          ref: d,
          role: "grid",
          class: pe(_.value),
          "aria-label": (q = U(s).ariaLabels) == null ? void 0 : q.calendarWrap
        }, [
          e.specificMode ? fe("", !0) : (R(), K(Qe, { key: 0 }, [
            ue("div", Oq, [
              j.weekNumbers ? (R(), K("div", Cq, Ie(j.weekNumName), 1)) : fe("", !0),
              (R(!0), K(Qe, null, kt(m.value, (le, Z) => (R(), K("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: Z
              }, [
                j.$slots["calendar-header"] ? ke(j.$slots, "calendar-header", {
                  key: 0,
                  day: le,
                  index: Z
                }) : fe("", !0),
                j.$slots["calendar-header"] ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                  jt(Ie(le), 1)
                ], 64))
              ]))), 128))
            ]),
            kq,
            Fe(Hn, {
              name: c.value,
              css: !!j.transitions
            }, {
              default: Pe(() => {
                var le;
                return [
                  f.value ? (R(), K("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": (le = U(s).ariaLabels) == null ? void 0 : le.calendarDays
                  }, [
                    (R(!0), K(Qe, null, kt(g.value, (Z, G) => (R(), K("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: G
                    }, [
                      j.weekNumbers ? (R(), K("div", Mq, [
                        ue("div", Aq, Ie(e.getWeekNum(Z.days)), 1)
                      ])) : fe("", !0),
                      (R(!0), K(Qe, null, kt(Z.days, (H, W) => {
                        var ie, we, Be;
                        return R(), K("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (Ve) => I(Ve, G, W),
                          key: W + G,
                          "aria-selected": H.classData.dp__active_date || H.classData.dp__range_start || H.classData.dp__range_start,
                          "aria-disabled": H.classData.dp__cell_disabled,
                          "aria-label": (we = (ie = U(s).ariaLabels) == null ? void 0 : ie.day) == null ? void 0 : we.call(ie, H),
                          tabindex: "0",
                          onClick: zr((Ve) => j.$emit("select-date", H), ["stop", "prevent"]),
                          onKeydown: [
                            Ot((Ve) => j.$emit("select-date", H), ["enter"]),
                            Ot((Ve) => j.$emit("handle-space", H), ["space"])
                          ],
                          onMouseenter: (Ve) => A(H, G, W),
                          onMouseleave: (Ve) => E(H)
                        }, [
                          ue("div", {
                            class: pe(["dp__cell_inner", H.classData])
                          }, [
                            j.$slots.day && S.value(H) ? ke(j.$slots, "day", {
                              key: 0,
                              day: +H.text,
                              date: H.value
                            }) : fe("", !0),
                            j.$slots.day ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                              jt(Ie(H.text), 1)
                            ], 64)),
                            H.marker && S.value(H) ? (R(), K(Qe, { key: 2 }, [
                              j.$slots.marker ? ke(j.$slots, "marker", {
                                key: 0,
                                marker: H.marker,
                                day: +H.text,
                                date: H.value
                              }) : (R(), K("div", {
                                key: 1,
                                class: pe(x.value(H.marker)),
                                style: Ir(H.marker.color ? { backgroundColor: H.marker.color } : {})
                              }, null, 6))
                            ], 64)) : fe("", !0),
                            w.value(H.value) ? (R(), K("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: v,
                              style: Ir(l.value)
                            }, [
                              (Be = H.marker) != null && Be.tooltip ? (R(), K("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: M[0] || (M[0] = zr(() => {
                                }, ["stop"]))
                              }, [
                                (R(!0), K(Qe, null, kt(H.marker.tooltip, (Ve, et) => (R(), K("div", {
                                  key: et,
                                  class: "dp__tooltip_text"
                                }, [
                                  j.$slots["marker-tooltip"] ? ke(j.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: Ve,
                                    day: H.value
                                  }) : fe("", !0),
                                  j.$slots["marker-tooltip"] ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                                    ue("div", {
                                      class: "dp__tooltip_mark",
                                      style: Ir(Ve.color ? { backgroundColor: Ve.color } : {})
                                    }, null, 4),
                                    ue("div", null, Ie(Ve.text), 1)
                                  ], 64))
                                ]))), 128)),
                                ue("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: Ir(h.value)
                                }, null, 4)
                              ])) : fe("", !0)
                            ], 4)) : fe("", !0)
                          ], 2)
                        ], 40, Dq);
                      }), 128))
                    ]))), 128))
                  ], 8, Pq)) : fe("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 14, Eq)
      ], 2);
    };
  }
}), Nq = ["aria-label", "aria-disabled"], Gf = /* @__PURE__ */ Ae({
  __name: "ActionIcon",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const r = ne(null);
    return ct(() => t("set-ref", r)), (a, n) => (R(), K("button", {
      type: "button",
      class: "dp__btn dp__month_year_col_nav",
      onClick: n[0] || (n[0] = (i) => a.$emit("activate")),
      onKeydown: [
        n[1] || (n[1] = Ot(zr((i) => a.$emit("activate"), ["prevent"]), ["enter"])),
        n[2] || (n[2] = Ot(zr((i) => a.$emit("activate"), ["prevent"]), ["space"]))
      ],
      tabindex: "0",
      "aria-label": a.ariaLabel,
      "aria-disabled": a.disabled,
      ref_key: "elRef",
      ref: r
    }, [
      ue("span", {
        class: pe(["dp__inner_nav", { dp__inner_nav_disabled: a.disabled }])
      }, [
        ke(a.$slots, "default")
      ], 2)
    ], 40, Nq));
  }
}), $q = ["onKeydown"], Lq = { class: "dp__selection_grid_header" }, Rq = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], jq = ["aria-label", "onKeydown"], $l = /* @__PURE__ */ Ae({
  __name: "SelectionGrid",
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    multiModelValue: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: [Number, String], default: null },
    maxValue: { type: [Number, String], default: null },
    year: { type: Number, default: 0 },
    skipActive: { type: Boolean, default: !1 },
    headerRefs: { type: Array, default: () => [] },
    skipButtonRef: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    autoApplyMonth: { type: Boolean, default: !1 }
  },
  emits: ["update:model-value", "selected", "toggle", "reset-flow"],
  setup(e, { expose: t, emit: r }) {
    const a = e, { setSelectionGrid: n, buildMultiLevelMatrix: i, setMonthPicker: s } = fs(), { hideNavigationButtons: o } = en(a), l = ne(!1), u = ne(null), d = ne(null), f = ne([]), c = ne(), p = ne(null), v = ne(0), h = ne(null);
    j4(() => {
      u.value = null;
    }), ct(() => {
      var F;
      Pt().then(() => P()), m(), g(!0), (F = u.value) == null || F.focus({ preventScroll: !0 });
    }), Tr(() => g(!1));
    const g = (F) => {
      var j;
      a.arrowNavigation && ((j = a.headerRefs) != null && j.length ? s(F) : n(F));
    }, m = () => {
      const F = Fr(d);
      F && (a.textInput || F.focus({ preventScroll: !0 }), l.value = F.clientHeight < F.scrollHeight);
    }, b = N(
      () => ({
        dp__overlay: !0
      })
    ), y = N(() => ({
      dp__overlay_col: !0
    })), _ = (F) => a.monthPicker && !a.autoApplyMonth ? nr(
      a.internalModelValue,
      ve.setYear(ve.setMonth(/* @__PURE__ */ new Date(), F.value), a.year)
    ) : a.skipActive ? !1 : F.value === a.modelValue, x = N(() => a.items.map((F) => F.filter((j) => j).map((j) => {
      var M, q, le;
      const Z = a.disabledValues.some((H) => H === j.value) || S(j.value), G = (M = a.multiModelValue) != null && M.length ? (q = a.multiModelValue) == null ? void 0 : q.some(
        (H) => nr(
          H,
          ve.setYear(
            a.monthPicker ? ve.setMonth(/* @__PURE__ */ new Date(), j.value) : /* @__PURE__ */ new Date(),
            a.monthPicker ? a.year : j.value
          )
        )
      ) : _(j);
      return {
        ...j,
        className: {
          dp__overlay_cell_active: G,
          dp__overlay_cell: !G,
          dp__overlay_cell_disabled: Z,
          dp__overlay_cell_active_disabled: Z && G,
          dp__overlay_cell_pad: !0,
          dp__cell_in_between: (le = a.multiModelValue) != null && le.length && a.skipActive ? E(j.value) : !1
        }
      };
    }))), w = N(
      () => ({
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: l.value,
        dp__button_bottom: a.autoApply
      })
    ), k = N(() => {
      var F, j;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((F = a.items) == null ? void 0 : F.length) <= 6,
        dp__container_block: ((j = a.items) == null ? void 0 : j.length) > 6
      };
    }), S = (F) => {
      const j = a.maxValue || a.maxValue === 0, M = a.minValue || a.minValue === 0;
      return !j && !M ? !1 : j && M ? +F > +a.maxValue || +F < +a.minValue : j ? +F > +a.maxValue : M ? +F < +a.minValue : !1;
    }, P = () => {
      const F = Fr(u), j = Fr(d), M = Fr(p), q = Fr(h), le = M ? M.getBoundingClientRect().height : 0;
      j && (v.value = j.getBoundingClientRect().height - le), F && q && (q.scrollTop = F.offsetTop - q.offsetTop - (v.value / 2 - F.getBoundingClientRect().height) - le);
    }, A = (F) => {
      !a.disabledValues.some((j) => j === F) && !S(F) && (r("update:model-value", F), r("selected"));
    }, E = (F) => {
      const j = a.monthPicker ? a.year : F;
      return dO(
        a.multiModelValue,
        ve.setYear(
          a.monthPicker ? ve.setMonth(/* @__PURE__ */ new Date(), c.value || 0) : /* @__PURE__ */ new Date(),
          a.monthPicker ? j : c.value || j
        ),
        ve.setYear(a.monthPicker ? ve.setMonth(/* @__PURE__ */ new Date(), F) : /* @__PURE__ */ new Date(), j)
      );
    }, O = () => {
      r("toggle"), r("reset-flow");
    }, T = () => {
      a.escClose && O();
    }, D = (F, j, M, q) => {
      F && (j.value === +a.modelValue && !a.disabledValues.includes(j.value) && (u.value = F), a.arrowNavigation && (Array.isArray(f.value[M]) ? f.value[M][q] = F : f.value[M] = [F], $()));
    }, $ = () => {
      var F, j;
      const M = (F = a.headerRefs) != null && F.length ? [a.headerRefs].concat(f.value) : f.value.concat([a.skipButtonRef ? [] : [p.value]]);
      i(pa(M), (j = a.headerRefs) != null && j.length ? "monthPicker" : "selectionGrid");
    }, I = (F) => {
      a.arrowNavigation || F.stopImmediatePropagation();
    };
    return t({ focusGrid: m }), (F, j) => {
      var M;
      return R(), K("div", {
        ref_key: "gridWrapRef",
        ref: d,
        class: pe(b.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          Ot(T, ["esc"]),
          j[0] || (j[0] = Ot((q) => I(q), ["left"])),
          j[1] || (j[1] = Ot((q) => I(q), ["up"])),
          j[2] || (j[2] = Ot((q) => I(q), ["down"])),
          j[3] || (j[3] = Ot((q) => I(q), ["right"]))
        ]
      }, [
        ue("div", {
          class: pe(k.value),
          ref_key: "containerRef",
          ref: h,
          role: "grid",
          style: Ir({ height: `${v.value}px` })
        }, [
          ue("div", Lq, [
            ke(F.$slots, "header")
          ]),
          F.$slots.overlay ? ke(F.$slots, "overlay", { key: 0 }) : (R(!0), K(Qe, { key: 1 }, kt(x.value, (q, le) => (R(), K("div", {
            class: pe(["dp__overlay_row", { dp__flex_row: x.value.length >= 3 }]),
            key: le,
            role: "row"
          }, [
            (R(!0), K(Qe, null, kt(q, (Z, G) => (R(), K("div", {
              role: "gridcell",
              class: pe(y.value),
              key: Z.value,
              "aria-selected": Z.value === e.modelValue && !e.disabledValues.includes(Z.value),
              "aria-disabled": Z.className.dp__overlay_cell_disabled,
              ref_for: !0,
              ref: (H) => D(H, Z, le, G),
              tabindex: "0",
              onClick: (H) => A(Z.value),
              onKeydown: [
                Ot((H) => A(Z.value), ["enter"]),
                Ot((H) => A(Z.value), ["space"])
              ],
              onMouseover: (H) => c.value = Z.value
            }, [
              ue("div", {
                class: pe(Z.className)
              }, [
                F.$slots.item ? ke(F.$slots, "item", {
                  key: 0,
                  item: Z
                }) : fe("", !0),
                F.$slots.item ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                  jt(Ie(Z.text), 1)
                ], 64))
              ], 2)
            ], 42, Rq))), 128))
          ], 2))), 128))
        ], 6),
        F.$slots["button-icon"] ? ea((R(), K("div", {
          key: 0,
          role: "button",
          "aria-label": (M = e.ariaLabels) == null ? void 0 : M.toggleOverlay,
          class: pe(w.value),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: p,
          onClick: O,
          onKeydown: [
            Ot(O, ["enter"]),
            Ot(O, ["tab"])
          ]
        }, [
          ke(F.$slots, "button-icon")
        ], 42, jq)), [
          [$a, !U(o)(e.type)]
        ]) : fe("", !0)
      ], 42, $q);
    };
  }
}), Fq = ["aria-label"], v2 = /* @__PURE__ */ Ae({
  __name: "RegularPicker",
  props: {
    ariaLabel: { type: String, default: "" },
    showSelectionGrid: { type: Boolean, default: !1 },
    modelValue: { type: Number, default: null },
    items: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    slotName: { type: String, default: "" },
    overlaySlot: { type: String, default: "" },
    headerRefs: { type: Array, default: () => [] },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    transitions: { type: [Object, Boolean], default: !1 },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "toggle", "set-ref"],
  setup(e, { emit: t }) {
    const r = e, { transitionName: a, showTransition: n } = Uc(r.transitions), i = ne(null);
    return ct(() => t("set-ref", i)), (s, o) => (R(), K(Qe, null, [
      ue("button", {
        type: "button",
        class: "dp__btn dp__month_year_select",
        onClick: o[0] || (o[0] = (l) => s.$emit("toggle")),
        onKeydown: [
          o[1] || (o[1] = Ot(zr((l) => s.$emit("toggle"), ["prevent"]), ["enter"])),
          o[2] || (o[2] = Ot(zr((l) => s.$emit("toggle"), ["prevent"]), ["space"]))
        ],
        "aria-label": e.ariaLabel,
        tabindex: "0",
        ref_key: "elRef",
        ref: i
      }, [
        ke(s.$slots, "default")
      ], 40, Fq),
      Fe(Hn, {
        name: U(a)(e.showSelectionGrid),
        css: U(n)
      }, {
        default: Pe(() => [
          e.showSelectionGrid ? (R(), Le($l, Mt({ key: 0 }, {
            modelValue: e.modelValue,
            items: e.items,
            disabledValues: e.disabledValues,
            minValue: e.minValue,
            maxValue: e.maxValue,
            escClose: e.escClose,
            type: e.type,
            arrowNavigation: e.arrowNavigation,
            textInput: e.textInput,
            autoApply: e.autoApply,
            ariaLabels: e.ariaLabels,
            hideNavigation: e.hideNavigation
          }, {
            "header-refs": [],
            "onUpdate:modelValue": o[3] || (o[3] = (l) => s.$emit("update:model-value", l)),
            onToggle: o[4] || (o[4] = (l) => s.$emit("toggle"))
          }), Ma({
            "button-icon": Pe(() => [
              s.$slots["calendar-icon"] ? ke(s.$slots, "calendar-icon", { key: 0 }) : fe("", !0),
              s.$slots["calendar-icon"] ? fe("", !0) : (R(), Le(U(Vc), { key: 1 }))
            ]),
            _: 2
          }, [
            s.$slots[e.slotName] ? {
              name: "item",
              fn: Pe(({ item: l }) => [
                ke(s.$slots, e.slotName, { item: l })
              ]),
              key: "0"
            } : void 0,
            s.$slots[e.overlaySlot] ? {
              name: "overlay",
              fn: Pe(() => [
                ke(s.$slots, e.overlaySlot)
              ]),
              key: "1"
            } : void 0,
            s.$slots[`${e.overlaySlot}-header`] ? {
              name: "header",
              fn: Pe(() => [
                ke(s.$slots, `${e.overlaySlot}-header`)
              ]),
              key: "2"
            } : void 0
          ]), 1040)) : fe("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), Bq = { class: "dp__month_year_row" }, qq = { class: "dp__month_picker_header" }, Hq = ["aria-label"], Vq = ["aria-label"], Uq = ["aria-label"], zq = /* @__PURE__ */ Ae({
  __name: "MonthYearPicker",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    ...ps
  },
  emits: ["update-month-year", "month-year-select", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: r }) {
    const a = e, { defaults: n } = en(a), { transitionName: i, showTransition: s } = Uc(n.value.transitions), { buildMatrix: o } = fs(), { handleMonthYearChange: l, isDisabled: u, updateMonthYear: d } = pq(a, r), f = ne(!1), c = ne(!1), p = ne([null, null, null, null]), v = ne(null), h = ne(null), g = ne(null);
    ct(() => {
      r("mount");
    });
    const m = (W) => ({
      get: () => a[W],
      set: (ie) => {
        const we = W === "month" ? "year" : "month";
        r("update-month-year", { [W]: ie, [we]: a[we] }), r("month-year-select", W === "year"), W === "month" ? q(!0) : le(!0);
      }
    }), b = N(m("month")), y = N(m("year")), _ = (W) => {
      const ie = ve.getYear(qe(W));
      return a.year === ie;
    }, x = N(() => a.monthPicker ? Array.isArray(a.disabledDates) ? a.disabledDates.map((W) => qe(W)).filter((W) => _(W)).map((W) => ve.getMonth(W)) : [] : []), w = N(() => (W) => {
      const ie = W === "month";
      return {
        showSelectionGrid: (ie ? f : c).value,
        items: (ie ? $ : I).value,
        disabledValues: n.value.filters[ie ? "months" : "years"].concat(x.value),
        minValue: (ie ? A : S).value,
        maxValue: (ie ? E : P).value,
        headerRefs: ie && a.monthPicker ? [v.value, h.value, g.value] : [],
        escClose: a.escClose,
        transitions: n.value.transitions,
        ariaLabels: n.value.ariaLabels,
        textInput: a.textInput,
        autoApply: a.autoApply,
        arrowNavigation: a.arrowNavigation,
        hideNavigation: a.hideNavigation
      };
    }), k = N(() => (W) => ({
      month: a.month,
      year: a.year,
      items: W === "month" ? a.months : a.years,
      instance: a.instance,
      updateMonthYear: d,
      toggle: W === "month" ? q : le
    })), S = N(() => a.minDate ? ve.getYear(qe(a.minDate)) : null), P = N(() => a.maxDate ? ve.getYear(qe(a.maxDate)) : null), A = N(() => {
      if (a.minDate && S.value) {
        if (S.value > a.year)
          return 12;
        if (S.value === a.year)
          return ve.getMonth(qe(a.minDate));
      }
      return null;
    }), E = N(() => a.maxDate && P.value ? P.value < a.year ? -1 : P.value === a.year ? ve.getMonth(qe(a.maxDate)) : null : null), O = N(() => (a.range || a.multiDates) && a.internalModelValue && (a.monthPicker || a.yearPicker) ? a.internalModelValue : []), T = (W) => {
      const ie = [], we = (Be) => Be;
      for (let Be = 0; Be < W.length; Be += 3) {
        const Ve = [W[Be], W[Be + 1], W[Be + 2]];
        ie.push(we(Ve));
      }
      return ie;
    }, D = N(() => a.months.find((ie) => ie.value === a.month) || { text: "", value: 0 }), $ = N(() => T(a.months)), I = N(() => T(a.years)), F = N(() => n.value.multiCalendars ? a.multiCalendarsSolo ? !0 : a.instance === 0 : !0), j = N(() => n.value.multiCalendars ? a.multiCalendarsSolo ? !0 : a.instance === n.value.multiCalendars - 1 : !0), M = (W, ie) => {
      ie !== void 0 ? W.value = ie : W.value = !W.value;
    }, q = (W = !1, ie) => {
      Z(W), M(f, ie), f.value || r("overlay-closed");
    }, le = (W = !1, ie) => {
      Z(W), M(c, ie), c.value || r("overlay-closed");
    }, Z = (W) => {
      W || r("reset-flow");
    }, G = (W = !1) => {
      u.value(W) || r("update-month-year", {
        year: W ? a.year + 1 : a.year - 1,
        month: a.month,
        fromNav: !0
      });
    }, H = (W, ie) => {
      a.arrowNavigation && (p.value[ie] = Fr(W), o(p.value, "monthYear"));
    };
    return t({
      toggleMonthPicker: q,
      toggleYearPicker: le,
      handleMonthYearChange: l
    }), (W, ie) => {
      var we, Be, Ve, et, nt;
      return R(), K("div", Bq, [
        W.$slots["month-year"] ? ke(W.$slots, "month-year", jr(Mt({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: U(d), handleMonthYearChange: U(l), instance: e.instance }))) : (R(), K(Qe, { key: 1 }, [
          !W.monthPicker && !W.yearPicker ? (R(), K(Qe, { key: 0 }, [
            F.value && !W.vertical ? (R(), Le(Gf, {
              key: 0,
              "aria-label": (we = U(n).ariaLabels) == null ? void 0 : we.prevMonth,
              disabled: U(u)(!1),
              onActivate: ie[0] || (ie[0] = (xe) => U(l)(!1)),
              onSetRef: ie[1] || (ie[1] = (xe) => H(xe, 0))
            }, {
              default: Pe(() => [
                W.$slots["arrow-left"] ? ke(W.$slots, "arrow-left", { key: 0 }) : fe("", !0),
                W.$slots["arrow-left"] ? fe("", !0) : (R(), Le(U(Jx), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : fe("", !0),
            ue("div", {
              class: pe(["dp__month_year_wrap", {
                dp__year_disable_select: a.disableYearSelect
              }])
            }, [
              Fe(v2, Mt({
                type: "month",
                "slot-name": "month-overlay-val",
                "overlay-slot": "overlay-month",
                "aria-label": (Be = U(n).ariaLabels) == null ? void 0 : Be.openMonthsOverlay,
                modelValue: b.value,
                "onUpdate:modelValue": ie[2] || (ie[2] = (xe) => b.value = xe)
              }, w.value("month"), {
                onToggle: q,
                onSetRef: ie[3] || (ie[3] = (xe) => H(xe, 1))
              }), Ma({
                default: Pe(() => [
                  W.$slots.month ? ke(W.$slots, "month", jr(Mt({ key: 0 }, D.value))) : fe("", !0),
                  W.$slots.month ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                    jt(Ie(D.value.text), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                W.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: Pe(() => [
                    ke(W.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                W.$slots["month-overlay-value"] ? {
                  name: "month-overlay-val",
                  fn: Pe(({ item: xe }) => [
                    ke(W.$slots, "month-overlay-value", {
                      text: xe.text,
                      value: xe.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                W.$slots["month-overlay"] ? {
                  name: "overlay-month",
                  fn: Pe(() => [
                    ke(W.$slots, "month-overlay", jr(oa(k.value("month"))))
                  ]),
                  key: "2"
                } : void 0,
                W.$slots["month-overlay-header"] ? {
                  name: "overlay-month-header",
                  fn: Pe(() => [
                    ke(W.$slots, "month-overlay-header", { toggle: q })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]),
              a.disableYearSelect ? fe("", !0) : (R(), Le(v2, Mt({
                key: 0,
                type: "year",
                "slot-name": "year-overlay-val",
                "overlay-slot": "overlay-year",
                "aria-label": (Ve = U(n).ariaLabels) == null ? void 0 : Ve.openYearsOverlay,
                modelValue: y.value,
                "onUpdate:modelValue": ie[4] || (ie[4] = (xe) => y.value = xe)
              }, w.value("year"), {
                onToggle: le,
                onSetRef: ie[5] || (ie[5] = (xe) => H(xe, 2))
              }), Ma({
                default: Pe(() => [
                  W.$slots.year ? ke(W.$slots, "year", {
                    key: 0,
                    year: e.year
                  }) : fe("", !0),
                  W.$slots.year ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                    jt(Ie(e.year), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                W.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: Pe(() => [
                    ke(W.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                W.$slots["year-overlay-value"] ? {
                  name: "year-overlay-val",
                  fn: Pe(({ item: xe }) => [
                    ke(W.$slots, "year-overlay-value", {
                      text: xe.text,
                      value: xe.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                W.$slots["year-overlay"] ? {
                  name: "overlay-year",
                  fn: Pe(() => [
                    ke(W.$slots, "year-overlay", jr(oa(k.value("year"))))
                  ]),
                  key: "2"
                } : void 0,
                W.$slots["year-overlay-header"] ? {
                  name: "overlay-year-header",
                  fn: Pe(() => [
                    ke(W.$slots, "year-overlay-header", { toggle: le })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]))
            ], 2),
            F.value && W.vertical ? (R(), Le(Gf, {
              key: 1,
              "aria-label": (et = U(n).ariaLabels) == null ? void 0 : et.prevMonth,
              disabled: U(u)(!1),
              onActivate: ie[6] || (ie[6] = (xe) => U(l)(!1))
            }, {
              default: Pe(() => [
                W.$slots["arrow-up"] ? ke(W.$slots, "arrow-up", { key: 0 }) : fe("", !0),
                W.$slots["arrow-up"] ? fe("", !0) : (R(), Le(U(lO), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : fe("", !0),
            j.value ? (R(), Le(Gf, {
              key: 2,
              ref: "rightIcon",
              disabled: U(u)(!0),
              "aria-label": (nt = U(n).ariaLabels) == null ? void 0 : nt.nextMonth,
              onActivate: ie[7] || (ie[7] = (xe) => U(l)(!0)),
              onSetRef: ie[8] || (ie[8] = (xe) => H(xe, 3))
            }, {
              default: Pe(() => [
                W.$slots[W.vertical ? "arrow-down" : "arrow-right"] ? ke(W.$slots, W.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : fe("", !0),
                W.$slots[W.vertical ? "arrow-down" : "arrow-right"] ? fe("", !0) : (R(), Le(Za(W.vertical ? U(uO) : U(Qx)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : fe("", !0)
          ], 64)) : fe("", !0),
          W.monthPicker ? (R(), Le($l, Mt({ key: 1 }, w.value("month"), {
            "skip-active": W.range,
            "internal-model-value": e.internalModelValue,
            year: e.year,
            "auto-apply-month": W.autoApplyMonth,
            "multi-model-value": O.value,
            "month-picker": "",
            modelValue: b.value,
            "onUpdate:modelValue": ie[17] || (ie[17] = (xe) => b.value = xe),
            onToggle: q,
            onSelected: ie[18] || (ie[18] = (xe) => W.$emit("overlay-closed"))
          }), Ma({
            header: Pe(() => {
              var xe, J, se;
              return [
                ue("div", qq, [
                  ue("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpPrevIconRef",
                    ref: v,
                    onClick: ie[9] || (ie[9] = (_e) => G(!1)),
                    onKeydown: ie[10] || (ie[10] = Ot((_e) => G(!1), ["enter"]))
                  }, [
                    ue("div", {
                      class: pe(["dp__inner_nav", { dp__inner_nav_disabled: U(u)(!1) }]),
                      role: "button",
                      "aria-label": (xe = U(n).ariaLabels) == null ? void 0 : xe.prevMonth
                    }, [
                      W.$slots["arrow-left"] ? ke(W.$slots, "arrow-left", { key: 0 }) : fe("", !0),
                      W.$slots["arrow-left"] ? fe("", !0) : (R(), Le(U(Jx), { key: 1 }))
                    ], 10, Hq)
                  ], 544),
                  ue("div", {
                    class: "dp__pointer",
                    role: "button",
                    ref_key: "mpYearButtonRef",
                    ref: h,
                    "aria-label": (J = U(n).ariaLabels) == null ? void 0 : J.openYearsOverlay,
                    tabindex: "0",
                    onClick: ie[11] || (ie[11] = () => le(!1)),
                    onKeydown: ie[12] || (ie[12] = Ot(() => le(!1), ["enter"]))
                  }, [
                    W.$slots.year ? ke(W.$slots, "year", {
                      key: 0,
                      year: e.year
                    }) : fe("", !0),
                    W.$slots.year ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                      jt(Ie(e.year), 1)
                    ], 64))
                  ], 40, Vq),
                  ue("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpNextIconRef",
                    ref: g,
                    onClick: ie[13] || (ie[13] = (_e) => G(!0)),
                    onKeydown: ie[14] || (ie[14] = Ot((_e) => G(!0), ["enter"]))
                  }, [
                    ue("div", {
                      class: pe(["dp__inner_nav", { dp__inner_nav_disabled: U(u)(!0) }]),
                      role: "button",
                      "aria-label": (se = U(n).ariaLabels) == null ? void 0 : se.nextMonth
                    }, [
                      W.$slots["arrow-right"] ? ke(W.$slots, "arrow-right", { key: 0 }) : fe("", !0),
                      W.$slots["arrow-right"] ? fe("", !0) : (R(), Le(U(Qx), { key: 1 }))
                    ], 10, Uq)
                  ], 544)
                ]),
                Fe(Hn, {
                  name: U(i)(c.value),
                  css: U(s)
                }, {
                  default: Pe(() => [
                    c.value ? (R(), Le($l, Mt({ key: 0 }, w.value("year"), {
                      modelValue: y.value,
                      "onUpdate:modelValue": ie[15] || (ie[15] = (_e) => y.value = _e),
                      onToggle: le,
                      onSelected: ie[16] || (ie[16] = (_e) => W.$emit("overlay-closed"))
                    }), Ma({
                      "button-icon": Pe(() => [
                        W.$slots["calendar-icon"] ? ke(W.$slots, "calendar-icon", { key: 0 }) : fe("", !0),
                        W.$slots["calendar-icon"] ? fe("", !0) : (R(), Le(U(Vc), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      W.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: Pe(({ item: _e }) => [
                          ke(W.$slots, "year-overlay-value", {
                            text: _e.text,
                            value: _e.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1040, ["modelValue"])) : fe("", !0)
                  ]),
                  _: 3
                }, 8, ["name", "css"])
              ];
            }),
            _: 2
          }, [
            W.$slots["month-overlay-value"] ? {
              name: "item",
              fn: Pe(({ item: xe }) => [
                ke(W.$slots, "month-overlay-value", {
                  text: xe.text,
                  value: xe.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["skip-active", "internal-model-value", "year", "auto-apply-month", "multi-model-value", "modelValue"])) : fe("", !0),
          W.yearPicker ? (R(), Le($l, Mt({ key: 2 }, w.value("year"), {
            modelValue: y.value,
            "onUpdate:modelValue": ie[19] || (ie[19] = (xe) => y.value = xe),
            "multi-model-value": O.value,
            "skip-active": W.range,
            "skip-button-ref": "",
            "year-picker": "",
            onToggle: le,
            onSelected: ie[20] || (ie[20] = (xe) => W.$emit("overlay-closed"))
          }), Ma({ _: 2 }, [
            W.$slots["year-overlay-value"] ? {
              name: "item",
              fn: Pe(({ item: xe }) => [
                ke(W.$slots, "year-overlay-value", {
                  text: xe.text,
                  value: xe.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "multi-model-value", "skip-active"])) : fe("", !0)
        ], 64))
      ]);
    };
  }
}), Yq = {
  key: 0,
  class: "dp__time_input"
}, Wq = ["aria-label", "onKeydown", "onClick"], Gq = /* @__PURE__ */ ue("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), Xq = /* @__PURE__ */ ue("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), Kq = ["aria-label", "onKeydown", "onClick"], Jq = ["aria-label", "onKeydown", "onClick"], Qq = /* @__PURE__ */ ue("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), Zq = /* @__PURE__ */ ue("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), eH = { key: 0 }, tH = ["aria-label", "onKeydown"], rH = /* @__PURE__ */ Ae({
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    ...ps
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, { setTimePickerElements: n, setTimePickerBackRef: i } = fs(), { defaults: s } = en(a), { transitionName: o, showTransition: l } = Uc(s.value.transitions), u = Sn({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), d = ne("AM"), f = ne(null), c = ne([]);
    ct(() => {
      r("mounted");
    });
    const p = (M) => ve.set(/* @__PURE__ */ new Date(), {
      hours: M.hours,
      minutes: M.minutes,
      seconds: a.enableSeconds ? M.seconds : 0,
      milliseconds: 0
    }), v = N(() => ({ hours: a.hours, minutes: a.minutes, seconds: a.seconds })), h = N(() => (M) => !S(+a[M] + +a[`${M}Increment`], M)), g = N(() => (M) => !S(+a[M] - +a[`${M}Increment`], M)), m = (M, q) => ve.add(ve.set(qe(), M), q), b = (M, q) => ve.sub(ve.set(qe(), M), q), y = N(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !a.timePickerInline,
        dp__time_col_reg_block: !a.enableSeconds && a.is24 && !a.timePickerInline,
        dp__time_col_reg_inline: !a.enableSeconds && a.is24 && a.timePickerInline,
        dp__time_col_reg_with_button: !a.enableSeconds && !a.is24,
        dp__time_col_sec: a.enableSeconds && a.is24,
        dp__time_col_sec_with_button: a.enableSeconds && !a.is24
      })
    ), _ = N(() => {
      const M = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return a.enableSeconds ? M.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : M;
    }), x = N(() => _.value.filter((M) => !M.separator)), w = N(() => (M) => {
      if (M === "hours") {
        const q = D(+a.hours);
        return { text: q < 10 ? `0${q}` : `${q}`, value: q };
      }
      return { text: a[M] < 10 ? `0${a[M]}` : `${a[M]}`, value: a[M] };
    }), k = (M) => {
      const q = a.is24 ? 24 : 12, le = M === "hours" ? q : 60, Z = +a[`${M}GridIncrement`], G = M === "hours" && !a.is24 ? Z : 0, H = [];
      for (let W = G; W < le; W += Z)
        H.push({ value: W, text: W < 10 ? `0${W}` : `${W}` });
      return M === "hours" && !a.is24 && H.push({ value: 0, text: "12" }), XB(H);
    }, S = (M, q) => {
      const le = a.minTime ? p(Ff(a.minTime)) : null, Z = a.maxTime ? p(Ff(a.maxTime)) : null, G = p(Ff(v.value, q, M));
      return le && Z ? (ve.isBefore(G, Z) || ve.isEqual(G, Z)) && (ve.isAfter(G, le) || ve.isEqual(G, le)) : le ? ve.isAfter(G, le) || ve.isEqual(G, le) : Z ? ve.isBefore(G, Z) || ve.isEqual(G, Z) : !0;
    }, P = N(() => (M) => k(M).flat().filter((q) => rq(q.value)).map((q) => q.value).filter((q) => !S(q, M))), A = (M) => a[`no${M[0].toUpperCase() + M.slice(1)}Overlay`], E = (M) => {
      A(M) || (u[M] = !u[M], u[M] || r("overlay-closed"));
    }, O = (M) => M === "hours" ? ve.getHours : M === "minutes" ? ve.getMinutes : ve.getSeconds, T = (M, q = !0) => {
      const le = q ? m : b, Z = q ? +a[`${M}Increment`] : -+a[`${M}Increment`];
      S(+a[M] + Z, M) && r(
        `update:${M}`,
        O(M)(le({ [M]: +a[M] }, { [M]: +a[`${M}Increment`] }))
      );
    }, D = (M) => a.is24 ? M : (M >= 12 ? d.value = "PM" : d.value = "AM", eq(M)), $ = () => {
      d.value === "PM" ? (d.value = "AM", r("update:hours", a.hours - 12)) : (d.value = "PM", r("update:hours", a.hours + 12)), r("am-pm-change", d.value);
    }, I = (M) => {
      u[M] = !0;
    }, F = (M, q, le) => {
      if (M && a.arrowNavigation) {
        Array.isArray(c.value[q]) ? c.value[q][le] = M : c.value[q] = [M];
        const Z = c.value.reduce(
          (G, H) => H.map((W, ie) => [...G[ie] || [], H[ie]]),
          []
        );
        i(a.closeTimePickerBtn), f.value && (Z[1] = Z[1].concat(f.value)), n(Z, a.order);
      }
    }, j = (M, q) => M === "hours" && !a.is24 ? r(`update:${M}`, d.value === "PM" ? q + 12 : q) : r(`update:${M}`, q);
    return t({ openChildCmp: I }), (M, q) => {
      var le;
      return M.disabled ? fe("", !0) : (R(), K("div", Yq, [
        (R(!0), K(Qe, null, kt(_.value, (Z, G) => {
          var H, W, ie;
          return R(), K("div", {
            key: G,
            class: pe(y.value)
          }, [
            Z.separator ? (R(), K(Qe, { key: 0 }, [
              jt(" : ")
            ], 64)) : (R(), K(Qe, { key: 1 }, [
              ue("button", {
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !a.timePickerInline,
                  dp__inc_dec_button_inline: a.timePickerInline,
                  dp__tp_inline_btn_top: a.timePickerInline,
                  dp__inc_dec_button_disabled: h.value(Z.type)
                }),
                "aria-label": (H = U(s).ariaLabels) == null ? void 0 : H.incrementValue(Z.type),
                tabindex: "0",
                onKeydown: [
                  Ot((we) => T(Z.type), ["enter"]),
                  Ot((we) => T(Z.type), ["space"])
                ],
                onClick: (we) => T(Z.type),
                ref_for: !0,
                ref: (we) => F(we, G, 0)
              }, [
                a.timePickerInline ? (R(), K(Qe, { key: 1 }, [
                  Gq,
                  Xq
                ], 64)) : (R(), K(Qe, { key: 0 }, [
                  M.$slots["arrow-up"] ? ke(M.$slots, "arrow-up", { key: 0 }) : fe("", !0),
                  M.$slots["arrow-up"] ? fe("", !0) : (R(), Le(U(lO), { key: 1 }))
                ], 64))
              ], 42, Wq),
              ue("button", {
                type: "button",
                "aria-label": (W = U(s).ariaLabels) == null ? void 0 : W.openTpOverlay(Z.type),
                class: pe([
                  "dp__btn",
                  A(Z.type) ? void 0 : {
                    dp__time_display: !0,
                    dp__time_display_block: !a.timePickerInline,
                    dp__time_display_inline: a.timePickerInline
                  }
                ]),
                tabindex: "0",
                onKeydown: [
                  Ot((we) => E(Z.type), ["enter"]),
                  Ot((we) => E(Z.type), ["space"])
                ],
                onClick: (we) => E(Z.type),
                ref_for: !0,
                ref: (we) => F(we, G, 1)
              }, [
                M.$slots[Z.type] ? ke(M.$slots, Z.type, {
                  key: 0,
                  text: w.value(Z.type).text,
                  value: w.value(Z.type).value
                }) : fe("", !0),
                M.$slots[Z.type] ? fe("", !0) : (R(), K(Qe, { key: 1 }, [
                  jt(Ie(w.value(Z.type).text), 1)
                ], 64))
              ], 42, Kq),
              ue("button", {
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !a.timePickerInline,
                  dp__inc_dec_button_inline: a.timePickerInline,
                  dp__tp_inline_btn_bottom: a.timePickerInline,
                  dp__inc_dec_button_disabled: g.value(Z.type)
                }),
                "aria-label": (ie = U(s).ariaLabels) == null ? void 0 : ie.decrementValue(Z.type),
                tabindex: "0",
                onKeydown: [
                  Ot((we) => T(Z.type, !1), ["enter"]),
                  Ot((we) => T(Z.type, !1), ["space"])
                ],
                onClick: (we) => T(Z.type, !1),
                ref_for: !0,
                ref: (we) => F(we, G, 2)
              }, [
                a.timePickerInline ? (R(), K(Qe, { key: 1 }, [
                  Qq,
                  Zq
                ], 64)) : (R(), K(Qe, { key: 0 }, [
                  M.$slots["arrow-down"] ? ke(M.$slots, "arrow-down", { key: 0 }) : fe("", !0),
                  M.$slots["arrow-down"] ? fe("", !0) : (R(), Le(U(uO), { key: 1 }))
                ], 64))
              ], 42, Jq)
            ], 64))
          ], 2);
        }), 128)),
        M.is24 ? fe("", !0) : (R(), K("div", eH, [
          M.$slots["am-pm-button"] ? ke(M.$slots, "am-pm-button", {
            key: 0,
            toggle: $,
            value: d.value
          }) : fe("", !0),
          M.$slots["am-pm-button"] ? fe("", !0) : (R(), K("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: f,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (le = U(s).ariaLabels) == null ? void 0 : le.amPmButton,
            tabindex: "0",
            onClick: $,
            onKeydown: [
              Ot(zr($, ["prevent"]), ["enter"]),
              Ot(zr($, ["prevent"]), ["space"])
            ]
          }, Ie(d.value), 41, tH))
        ])),
        (R(!0), K(Qe, null, kt(x.value, (Z, G) => (R(), Le(Hn, {
          key: G,
          name: U(o)(u[Z.type]),
          css: U(l)
        }, {
          default: Pe(() => [
            u[Z.type] ? (R(), Le($l, {
              key: 0,
              items: k(Z.type),
              "disabled-values": U(s).filters.times[Z.type].concat(P.value(Z.type)),
              "esc-close": M.escClose,
              "aria-labels": U(s).ariaLabels,
              "hide-navigation": M.hideNavigation,
              "onUpdate:modelValue": (H) => j(Z.type, H),
              onSelected: (H) => E(Z.type),
              onToggle: (H) => E(Z.type),
              onResetFlow: q[0] || (q[0] = (H) => M.$emit("reset-flow")),
              type: Z.type
            }, Ma({
              "button-icon": Pe(() => [
                M.$slots["clock-icon"] ? ke(M.$slots, "clock-icon", { key: 0 }) : fe("", !0),
                M.$slots["clock-icon"] ? fe("", !0) : (R(), Le(U(oO), { key: 1 }))
              ]),
              _: 2
            }, [
              M.$slots[`${Z.type}-overlay-value`] ? {
                name: "item",
                fn: Pe(({ item: H }) => [
                  ke(M.$slots, `${Z.type}-overlay-value`, {
                    text: H.text,
                    value: H.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "disabled-values", "esc-close", "aria-labels", "hide-navigation", "onUpdate:modelValue", "onSelected", "onToggle", "type"])) : fe("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), aH = ["aria-label"], nH = ["tabindex"], iH = ["aria-label"], sH = /* @__PURE__ */ Ae({
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...ps
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, { buildMatrix: n, setTimePicker: i } = fs(), s = lu(), { hideNavigationButtons: o, defaults: l } = en(a), { transitionName: u, showTransition: d } = Uc(l.value.transitions), f = ne(null), c = ne(null), p = ne([]), v = ne(null);
    ct(() => {
      r("mount"), !a.timePicker && a.arrowNavigation ? n([Fr(f.value)], "time") : i(!0, a.timePicker);
    });
    const h = N(() => a.range && a.modelAuto ? mO(a.internalModelValue) : !0), g = ne(!1), m = (E) => ({
      hours: Array.isArray(a.hours) ? a.hours[E] : a.hours,
      minutes: Array.isArray(a.minutes) ? a.minutes[E] : a.minutes,
      seconds: Array.isArray(a.seconds) ? a.seconds[E] : a.seconds
    }), b = N(() => {
      const E = [];
      if (a.range)
        for (let O = 0; O < 2; O++)
          E.push(m(O));
      else
        E.push(m(0));
      return E;
    }), y = (E, O = !1, T = "") => {
      O || r("reset-flow"), g.value = E, r(E ? "overlay-opened" : "overlay-closed"), a.arrowNavigation && i(E), Pt(() => {
        T !== "" && p.value[0] && p.value[0].openChildCmp(T);
      });
    }, _ = N(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: a.autoApply && !a.keepActionRow
    })), x = Ss(s, "timePicker"), w = (E, O, T) => a.range ? O === 0 ? [E, b.value[1][T]] : [b.value[0][T], E] : E, k = (E) => {
      r("update:hours", E);
    }, S = (E) => {
      r("update:minutes", E);
    }, P = (E) => {
      r("update:seconds", E);
    }, A = () => {
      if (v.value) {
        const E = aq(v.value);
        E && E.focus({ preventScroll: !0 });
      }
    };
    return t({ toggleTimePicker: y }), (E, O) => {
      var T;
      return R(), K("div", null, [
        !E.timePicker && !E.timePickerInline ? ea((R(), K("button", {
          key: 0,
          type: "button",
          class: pe(_.value),
          "aria-label": (T = U(l).ariaLabels) == null ? void 0 : T.openTimePicker,
          tabindex: "0",
          ref_key: "openTimePickerBtn",
          ref: f,
          onKeydown: [
            O[0] || (O[0] = Ot((D) => y(!0), ["enter"])),
            O[1] || (O[1] = Ot((D) => y(!0), ["space"]))
          ],
          onClick: O[2] || (O[2] = (D) => y(!0))
        }, [
          E.$slots["clock-icon"] ? ke(E.$slots, "clock-icon", { key: 0 }) : fe("", !0),
          E.$slots["clock-icon"] ? fe("", !0) : (R(), Le(U(oO), { key: 1 }))
        ], 42, aH)), [
          [$a, !U(o)("time")]
        ]) : fe("", !0),
        Fe(Hn, {
          name: U(u)(g.value),
          css: U(d) && !E.timePickerInline
        }, {
          default: Pe(() => {
            var D;
            return [
              g.value || E.timePicker || E.timePickerInline ? (R(), K("div", {
                key: 0,
                class: pe({ dp__overlay: !E.timePickerInline }),
                ref_key: "overlayRef",
                ref: v,
                tabindex: E.timePickerInline ? void 0 : 0
              }, [
                ue("div", {
                  class: pe(
                    E.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  E.$slots["time-picker-overlay"] ? ke(E.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: k,
                    setMinutes: S,
                    setSeconds: P
                  }) : fe("", !0),
                  E.$slots["time-picker-overlay"] ? fe("", !0) : (R(), K("div", {
                    key: 1,
                    class: pe(E.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (R(!0), K(Qe, null, kt(b.value, ($, I) => ea((R(), Le(rH, Mt({ key: I }, {
                      ...E.$props,
                      order: I,
                      hours: $.hours,
                      minutes: $.minutes,
                      seconds: $.seconds,
                      closeTimePickerBtn: c.value,
                      disabled: I === 0 ? E.fixedStart : E.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: p,
                      "onUpdate:hours": (F) => k(w(F, I, "hours")),
                      "onUpdate:minutes": (F) => S(w(F, I, "minutes")),
                      "onUpdate:seconds": (F) => P(w(F, I, "seconds")),
                      onMounted: A,
                      onOverlayClosed: A,
                      onAmPmChange: O[3] || (O[3] = (F) => E.$emit("am-pm-change", F))
                    }), Ma({ _: 2 }, [
                      kt(U(x), (F, j) => ({
                        name: F,
                        fn: Pe((M) => [
                          ke(E.$slots, F, jr(oa(M)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [$a, I === 0 ? !0 : h.value]
                    ])), 128))
                  ], 2)),
                  !E.timePicker && !E.timePickerInline ? ea((R(), K("button", {
                    key: 2,
                    type: "button",
                    ref_key: "closeTimePickerBtn",
                    ref: c,
                    class: pe(_.value),
                    "aria-label": (D = U(l).ariaLabels) == null ? void 0 : D.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      O[4] || (O[4] = Ot(($) => y(!1), ["enter"])),
                      O[5] || (O[5] = Ot(($) => y(!1), ["space"]))
                    ],
                    onClick: O[6] || (O[6] = ($) => y(!1))
                  }, [
                    E.$slots["calendar-icon"] ? ke(E.$slots, "calendar-icon", { key: 0 }) : fe("", !0),
                    E.$slots["calendar-icon"] ? fe("", !0) : (R(), Le(U(Vc), { key: 1 }))
                  ], 42, iH)), [
                    [$a, !U(o)("time")]
                  ]) : fe("", !0)
                ], 2)
              ], 10, nH)) : fe("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), oH = (e, t) => {
  const { isDisabled: r, matchDate: a, getWeekFromDate: n, defaults: i } = en(t), s = ne(null), o = ne(qe()), l = (M) => {
    !M.current && t.hideOffsetDates || (s.value = M.value);
  }, u = () => {
    s.value = null;
  }, d = (M) => Array.isArray(e.value) && t.range && e.value[0] && s.value ? M ? Ia(s.value, e.value[0]) : va(s.value, e.value[0]) : !0, f = (M, q) => {
    const le = () => e.value ? q ? e.value[0] || null : e.value[1] : null, Z = e.value && Array.isArray(e.value) ? le() : null;
    return nr(qe(M.value), Z);
  }, c = (M) => {
    const q = Array.isArray(e.value) ? e.value[0] : null;
    return M ? !va(s.value || null, q) : !0;
  }, p = (M, q = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !M.current ? !1 : nr(qe(M.value), e.value[q ? 0 : 1]) : t.range ? f(M, q) && c(q) || nr(M.value, Array.isArray(e.value) ? e.value[0] : null) && d(q) : !1, v = (M, q, le) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? M ? !1 : le ? Ia(e.value[0], q.value) : va(e.value[0], q.value) : !1, h = (M) => !e.value || t.hideOffsetDates && !M.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? nr(M.value, e.value[0] ? e.value[0] : o.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((q) => nr(q, M.value)) : nr(M.value, e.value ? e.value : o.value), g = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (s.value) {
        if (t.hideOffsetDates && !M.current)
          return !1;
        const q = ve.addDays(s.value, +t.autoRange), le = n(qe(s.value));
        return t.weekPicker ? nr(le[1], qe(M.value)) : nr(q, qe(M.value));
      }
      return !1;
    }
    return !1;
  }, m = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (s.value) {
        const q = ve.addDays(s.value, +t.autoRange);
        if (t.hideOffsetDates && !M.current)
          return !1;
        const le = n(qe(s.value));
        return t.weekPicker ? Ia(M.value, le[0]) && va(M.value, le[1]) : Ia(M.value, s.value) && va(M.value, q);
      }
      return !1;
    }
    return !1;
  }, b = (M) => {
    if (t.autoRange || t.weekPicker) {
      if (s.value) {
        if (t.hideOffsetDates && !M.current)
          return !1;
        const q = n(qe(s.value));
        return t.weekPicker ? nr(q[0], M.value) : nr(s.value, M.value);
      }
      return !1;
    }
    return !1;
  }, y = (M) => dO(e.value, s.value, M.value), _ = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, x = () => t.modelAuto ? mO(t.internalModelValue) : !0, w = (M) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const q = t.range ? !p(M) && !p(M, !1) : !0;
    return !r(M.value) && !h(M) && !(!M.current && t.hideOffsetDates) && q;
  }, k = (M) => t.range ? t.modelAuto ? _() && h(M) : !1 : h(M), S = (M) => {
    var q;
    return t.highlight ? a(
      M.value,
      (q = t.arrMapValues) != null && q.highlightedDates ? t.arrMapValues.highlightedDates : t.highlight
    ) : !1;
  }, P = (M) => r(M.value) && t.highlightDisabledDays === !1, A = (M) => t.highlightWeekDays && t.highlightWeekDays.includes(M.value.getDay()), E = (M) => (t.range || t.weekPicker) && (!(i.value.multiCalendars > 0) || M.current) && x() && !(!M.current && t.hideOffsetDates) && !h(M) ? y(M) : !1, O = (M) => {
    const { isRangeStart: q, isRangeEnd: le } = $(M), Z = t.range ? q || le : !1;
    return {
      dp__cell_offset: !M.current,
      dp__pointer: !t.disabled && !(!M.current && t.hideOffsetDates) && !r(M.value),
      dp__cell_disabled: r(M.value),
      dp__cell_highlight: !P(M) && (S(M) || A(M)) && !k(M) && !Z,
      dp__cell_highlight_active: !P(M) && (S(M) || A(M)) && k(M),
      dp__today: !t.noToday && nr(M.value, o.value) && M.current
    };
  }, T = (M) => ({
    dp__active_date: k(M),
    dp__date_hover: w(M)
  }), D = (M) => ({
    ...I(M),
    ...F(M),
    dp__range_between_week: E(M) && t.weekPicker
  }), $ = (M) => {
    const q = i.value.multiCalendars > 0 ? M.current && p(M) && x() : p(M) && x(), le = i.value.multiCalendars > 0 ? M.current && p(M, !1) && x() : p(M, !1) && x();
    return { isRangeStart: q, isRangeEnd: le };
  }, I = (M) => {
    const { isRangeStart: q, isRangeEnd: le } = $(M);
    return {
      dp__range_start: q,
      dp__range_end: le,
      dp__range_between: E(M) && !t.weekPicker,
      dp__date_hover_start: v(w(M), M, !0),
      dp__date_hover_end: v(w(M), M, !1)
    };
  }, F = (M) => ({
    ...I(M),
    dp__cell_auto_range: m(M),
    dp__cell_auto_range_start: b(M),
    dp__cell_auto_range_end: g(M)
  }), j = (M) => t.range ? t.autoRange ? F(M) : t.modelAuto ? { ...T(M), ...I(M) } : I(M) : t.weekPicker ? D(M) : T(M);
  return {
    setHoverDate: l,
    clearHoverDate: u,
    getDayClassData: (M) => t.hideOffsetDates && !M.current ? {} : {
      ...O(M),
      ...j(M),
      [t.dayClass ? t.dayClass(M.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    }
  };
}, lH = ["id", "onKeydown"], uH = {
  key: 0,
  class: "dp__sidebar_left"
}, dH = {
  key: 1,
  class: "dp__preset_ranges"
}, cH = ["onClick"], fH = {
  key: 2,
  class: "dp__sidebar_right"
}, pH = {
  key: 3,
  class: "dp__action_extra"
}, vH = /* @__PURE__ */ Ae({
  __name: "DatepickerMenu",
  props: {
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) },
    ...ps
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = N(() => {
      const { openOnTop: me, internalModelValue: Ue, arrMapValues: bt, ..._t } = a;
      return _t;
    }), { setMenuFocused: i, setShiftKey: s, control: o } = cO(), { getCalendarDays: l, defaults: u } = en(a), d = lu(), f = ne(null), c = Sn({
      timePicker: !!(!a.enableTimePicker || a.timePicker || a.monthPicker),
      monthYearInput: !!a.timePicker,
      calendar: !1
    }), p = ne([]), v = ne([]), h = ne(null), g = ne(null), m = ne(0), b = ne(!1), y = ne(0);
    ct(() => {
      var me;
      b.value = !0, !((me = a.presetRanges) != null && me.length) && !d["left-sidebar"] && !d["right-sidebar"] && (Dt(), window.addEventListener("resize", Dt));
      const Ue = Fr(g);
      if (Ue && !a.textInput && !a.inline && (i(!0), P()), Ue) {
        const bt = (_t) => {
          a.allowPreventDefault && _t.preventDefault(), _t.stopImmediatePropagation(), _t.stopPropagation();
        };
        Ue.addEventListener("pointerdown", bt), Ue.addEventListener("mousedown", bt);
      }
    }), Tr(() => {
      window.removeEventListener("resize", Dt);
    });
    const { arrowRight: _, arrowLeft: x, arrowDown: w, arrowUp: k } = fs(), S = (me) => {
      me || me === 0 ? v.value[me].triggerTransition(
        D.value(me),
        $.value(me)
      ) : v.value.forEach(
        (Ue, bt) => Ue.triggerTransition(D.value(bt), $.value(bt))
      );
    }, P = () => {
      const me = Fr(g);
      me && me.focus({ preventScroll: !0 });
    }, A = () => {
      var me;
      (me = a.flow) != null && me.length && y.value !== -1 && (y.value += 1, r("flow-step", y.value), Ne());
    }, E = () => {
      y.value = -1;
    }, {
      calendars: O,
      modelValue: T,
      month: D,
      year: $,
      time: I,
      updateTime: F,
      updateMonthYear: j,
      selectDate: M,
      getWeekNum: q,
      monthYearSelect: le,
      handleScroll: Z,
      handleArrow: G,
      handleSwipe: H,
      getMarker: W,
      selectCurrentDate: ie,
      presetDateRange: we
    } = cq(a, r, A, S, y), { setHoverDate: Be, clearHoverDate: Ve, getDayClassData: et } = oH(T, a), nt = {
      modelValue: T,
      month: D,
      year: $,
      time: I,
      updateTime: F,
      updateMonthYear: j,
      selectDate: M,
      presetDateRange: we,
      handleMonthYearChange: (me) => {
        p.value[0] && p.value[0].handleMonthYearChange(me);
      }
    };
    He(
      O,
      () => {
        a.openOnTop && setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const xe = Ss(d, "calendar"), J = Ss(d, "action"), se = Ss(d, "timePicker"), _e = Ss(d, "monthYear"), Se = N(() => a.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), Re = N(() => QB(a.yearRange, a.reverseYears)), rt = N(() => ZB(a.formatLocale, a.locale, a.monthNameFormat)), Dt = () => {
      const me = Fr(f);
      me && (m.value = me.getBoundingClientRect().width);
    }, It = N(() => (me) => l(D.value(me), $.value(me))), Ye = N(
      () => u.value.multiCalendars > 0 ? [...Array(u.value.multiCalendars).keys()] : [0]
    ), at = N(
      () => (me) => me === 1
    ), ut = N(() => a.monthPicker || a.timePicker || a.yearPicker), Gt = N(
      () => ({
        dp__menu_inner: !0,
        dp__flex_display: u.value.multiCalendars > 0
      })
    ), Je = N(() => ({
      dp__instance_calendar: u.value.multiCalendars > 0
    })), he = N(() => ({
      dp__menu_disabled: a.disabled,
      dp__menu_readonly: a.readonly
    })), ye = N(
      () => (me) => Q(It, me)
    ), Ke = N(
      () => ({
        dp__menu: !0,
        dp__menu_index: !a.inline,
        dp__relative: a.inline,
        [a.menuClassName]: !!a.menuClassName
      })
    ), Q = (me, Ue) => me.value(Ue).map((bt) => ({
      ...bt,
      days: bt.days.map((_t) => (_t.marker = W(_t), _t.classData = et(_t), _t))
    })), L = (me) => {
      me.stopPropagation(), me.stopImmediatePropagation();
    }, Te = () => {
      a.escClose && r("close-picker");
    }, Oe = (me, Ue = !1) => {
      M(me, Ue), a.spaceConfirm && r("select-date");
    }, Y = (me) => {
      var Ue;
      (Ue = a.flow) != null && Ue.length && (c[me] = !0, Object.keys(c).filter((bt) => !c[bt]).length || Ne());
    }, de = (me, Ue, bt, _t, ...pr) => {
      if (a.flow[y.value] === me) {
        const Ze = _t ? Ue.value[0] : Ue.value;
        Ze && Ze[bt](...pr);
      }
    }, Ne = () => {
      de("month", p, "toggleMonthPicker", !0, !0), de("year", p, "toggleYearPicker", !0, !0), de("calendar", h, "toggleTimePicker", !1, !1, !0), de("time", h, "toggleTimePicker", !1, !0, !0);
      const me = a.flow[y.value];
      (me === "hours" || me === "minutes" || me === "seconds") && de(me, h, "toggleTimePicker", !1, !0, !0, me);
    }, We = (me) => {
      if (a.arrowNavigation) {
        if (me === "up")
          return k();
        if (me === "down")
          return w();
        if (me === "left")
          return x();
        if (me === "right")
          return _();
      } else
        me === "left" || me === "up" ? G("left", 0, me === "up") : G("right", 0, me === "down");
    }, mt = (me) => {
      s(me.shiftKey), !a.disableMonthYearSelect && me.code === "Tab" && me.target.classList.contains("dp__menu") && o.value.shiftKeyInMenu && (me.preventDefault(), me.stopImmediatePropagation(), r("close-picker"));
    }, Nt = () => {
      P(), r("time-picker-close");
    }, St = (me) => {
      var Ue, bt, _t, pr, Ze;
      (Ue = h.value) == null || Ue.toggleTimePicker(!1, !1), (_t = (bt = p.value) == null ? void 0 : bt[me]) == null || _t.toggleMonthPicker(!1, !1), (Ze = (pr = p.value) == null ? void 0 : pr[me]) == null || Ze.toggleYearPicker(!1, !1);
    };
    return t({
      updateMonthYear: j,
      switchView: (me, Ue = 0) => {
        var bt, _t, pr, Ze, vr;
        return me === "month" ? (_t = (bt = p.value) == null ? void 0 : bt[Ue]) == null ? void 0 : _t.toggleMonthPicker(!1, !0) : me === "year" ? (Ze = (pr = p.value) == null ? void 0 : pr[Ue]) == null ? void 0 : Ze.toggleYearPicker(!1, !0) : me === "time" ? (vr = h.value) == null ? void 0 : vr.toggleTimePicker(!0, !1) : St(Ue);
      }
    }), (me, Ue) => {
      var bt;
      return R(), Le(Hn, {
        appear: "",
        name: (bt = U(u).transitions) == null ? void 0 : bt.menuAppear,
        css: !!me.transitions
      }, {
        default: Pe(() => {
          var _t, pr;
          return [
            ue("div", {
              id: me.uid ? `dp-menu-${me.uid}` : void 0,
              tabindex: "0",
              ref_key: "dpMenuRef",
              ref: g,
              role: "dialog",
              class: pe(Ke.value),
              onMouseleave: Ue[14] || (Ue[14] = //@ts-ignore
              (...Ze) => U(Ve) && U(Ve)(...Ze)),
              onClick: L,
              onKeydown: [
                Ot(Te, ["esc"]),
                Ue[15] || (Ue[15] = Ot(zr((Ze) => We("left"), ["prevent"]), ["left"])),
                Ue[16] || (Ue[16] = Ot(zr((Ze) => We("up"), ["prevent"]), ["up"])),
                Ue[17] || (Ue[17] = Ot(zr((Ze) => We("down"), ["prevent"]), ["down"])),
                Ue[18] || (Ue[18] = Ot(zr((Ze) => We("right"), ["prevent"]), ["right"])),
                mt
              ]
            }, [
              (me.disabled || me.readonly) && me.inline ? (R(), K("div", {
                key: 0,
                class: pe(he.value)
              }, null, 2)) : fe("", !0),
              !me.inline && !me.teleportCenter ? (R(), K("div", {
                key: 1,
                class: pe(Se.value)
              }, null, 2)) : fe("", !0),
              ue("div", {
                class: pe({
                  dp__menu_content_wrapper: ((_t = me.presetRanges) == null ? void 0 : _t.length) || !!me.$slots["left-sidebar"] || !!me.$slots["right-sidebar"]
                })
              }, [
                me.$slots["left-sidebar"] ? (R(), K("div", uH, [
                  ke(me.$slots, "left-sidebar", jr(oa(nt)))
                ])) : fe("", !0),
                (pr = me.presetRanges) != null && pr.length ? (R(), K("div", dH, [
                  (R(!0), K(Qe, null, kt(me.presetRanges, (Ze, vr) => (R(), K("div", {
                    key: vr,
                    style: Ir(Ze.style || {}),
                    class: "dp__preset_range",
                    onClick: (yt) => U(we)(Ze.range, !!Ze.slot)
                  }, [
                    Ze.slot ? ke(me.$slots, Ze.slot, {
                      key: 0,
                      presetDateRange: U(we),
                      label: Ze.label,
                      range: Ze.range
                    }) : (R(), K(Qe, { key: 1 }, [
                      jt(Ie(Ze.label), 1)
                    ], 64))
                  ], 12, cH))), 128))
                ])) : fe("", !0),
                ue("div", {
                  class: "dp__instance_calendar",
                  ref_key: "calendarWrapperRef",
                  ref: f,
                  role: "document"
                }, [
                  ue("div", {
                    class: pe(Gt.value)
                  }, [
                    (R(!0), K(Qe, null, kt(Ye.value, (Ze, vr) => (R(), K("div", {
                      key: Ze,
                      class: pe(Je.value)
                    }, [
                      !me.disableMonthYearSelect && !me.timePicker ? (R(), Le(zq, Mt({
                        key: 0,
                        ref_for: !0,
                        ref: (yt) => {
                          yt && (p.value[vr] = yt);
                        },
                        months: rt.value,
                        years: Re.value,
                        month: U(D)(Ze),
                        year: U($)(Ze),
                        instance: Ze,
                        "internal-model-value": e.internalModelValue
                      }, n.value, {
                        onMount: Ue[0] || (Ue[0] = (yt) => Y("monthYearInput")),
                        onResetFlow: E,
                        onUpdateMonthYear: (yt) => U(j)(Ze, yt),
                        onMonthYearSelect: U(le),
                        onOverlayClosed: P
                      }), Ma({ _: 2 }, [
                        kt(U(_e), (yt, Xr) => ({
                          name: yt,
                          fn: Pe((La) => [
                            ke(me.$slots, yt, jr(oa(La)))
                          ])
                        }))
                      ]), 1040, ["months", "years", "month", "year", "instance", "internal-model-value", "onUpdateMonthYear", "onMonthYearSelect"])) : fe("", !0),
                      Fe(Iq, Mt({
                        ref_for: !0,
                        ref: (yt) => {
                          yt && (v.value[vr] = yt);
                        },
                        "specific-mode": ut.value,
                        "get-week-num": U(q),
                        instance: Ze,
                        "mapped-dates": ye.value(Ze),
                        month: U(D)(Ze),
                        year: U($)(Ze)
                      }, n.value, {
                        onSelectDate: (yt) => U(M)(yt, !at.value(Ze)),
                        onHandleSpace: (yt) => Oe(yt, !at.value(Ze)),
                        onSetHoverDate: Ue[1] || (Ue[1] = (yt) => U(Be)(yt)),
                        onHandleScroll: (yt) => U(Z)(yt, Ze),
                        onHandleSwipe: (yt) => U(H)(yt, Ze),
                        onMount: Ue[2] || (Ue[2] = (yt) => Y("calendar")),
                        onResetFlow: E,
                        onTooltipOpen: Ue[3] || (Ue[3] = (yt) => me.$emit("tooltip-open", yt)),
                        onTooltipClose: Ue[4] || (Ue[4] = (yt) => me.$emit("tooltip-close", yt))
                      }), Ma({ _: 2 }, [
                        kt(U(xe), (yt, Xr) => ({
                          name: yt,
                          fn: Pe((La) => [
                            ke(me.$slots, yt, jr(oa({ ...La })))
                          ])
                        }))
                      ]), 1040, ["specific-mode", "get-week-num", "instance", "mapped-dates", "month", "year", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
                    ], 2))), 128))
                  ], 2),
                  ue("div", null, [
                    me.$slots["time-picker"] ? ke(me.$slots, "time-picker", jr(Mt({ key: 0 }, { time: U(I), updateTime: U(F) }))) : (R(), K(Qe, { key: 1 }, [
                      me.enableTimePicker && !me.monthPicker && !me.weekPicker ? (R(), Le(sH, Mt({
                        key: 0,
                        ref_key: "timePickerRef",
                        ref: h,
                        hours: U(I).hours,
                        minutes: U(I).minutes,
                        seconds: U(I).seconds,
                        "internal-model-value": e.internalModelValue
                      }, n.value, {
                        onMount: Ue[5] || (Ue[5] = (Ze) => Y("timePicker")),
                        "onUpdate:hours": Ue[6] || (Ue[6] = (Ze) => U(F)(Ze)),
                        "onUpdate:minutes": Ue[7] || (Ue[7] = (Ze) => U(F)(Ze, !1)),
                        "onUpdate:seconds": Ue[8] || (Ue[8] = (Ze) => U(F)(Ze, !1, !0)),
                        onResetFlow: E,
                        onOverlayClosed: Nt,
                        onOverlayOpened: Ue[9] || (Ue[9] = (Ze) => me.$emit("time-picker-open", Ze)),
                        onAmPmChange: Ue[10] || (Ue[10] = (Ze) => me.$emit("am-pm-change", Ze))
                      }), Ma({ _: 2 }, [
                        kt(U(se), (Ze, vr) => ({
                          name: Ze,
                          fn: Pe((yt) => [
                            ke(me.$slots, Ze, jr(oa(yt)))
                          ])
                        }))
                      ]), 1040, ["hours", "minutes", "seconds", "internal-model-value"])) : fe("", !0)
                    ], 64))
                  ])
                ], 512),
                me.$slots["right-sidebar"] ? (R(), K("div", fH, [
                  ke(me.$slots, "right-sidebar", jr(oa(nt)))
                ])) : fe("", !0),
                me.$slots["action-extra"] ? (R(), K("div", pH, [
                  me.$slots["action-extra"] ? ke(me.$slots, "action-extra", {
                    key: 0,
                    selectCurrentDate: U(ie)
                  }) : fe("", !0)
                ])) : fe("", !0)
              ], 2),
              !me.autoApply || me.keepActionRow ? (R(), Le(Sq, Mt({
                key: 2,
                "menu-mount": b.value,
                "calendar-width": m.value,
                "internal-model-value": e.internalModelValue
              }, n.value, {
                onClosePicker: Ue[11] || (Ue[11] = (Ze) => me.$emit("close-picker")),
                onSelectDate: Ue[12] || (Ue[12] = (Ze) => me.$emit("select-date")),
                onInvalidSelect: Ue[13] || (Ue[13] = (Ze) => me.$emit("invalid-select")),
                onSelectNow: U(ie)
              }), Ma({ _: 2 }, [
                kt(U(J), (Ze, vr) => ({
                  name: Ze,
                  fn: Pe((yt) => [
                    ke(me.$slots, Ze, jr(oa({ ...yt })))
                  ])
                }))
              ]), 1040, ["menu-mount", "calendar-width", "internal-model-value", "onSelectNow"])) : fe("", !0)
            ], 42, lH)
          ];
        }),
        _: 3
      }, 8, ["name", "css"]);
    };
  }
}), mH = typeof window < "u" ? window : void 0, Xf = () => {
}, hH = (e) => eT() ? (D1(e), !0) : !1, gH = (e, t, r, a) => {
  if (!e)
    return Xf;
  let n = Xf;
  const i = He(
    () => U(e),
    (o) => {
      n(), o && (o.addEventListener(t, r, a), n = () => {
        o.removeEventListener(t, r, a), n = Xf;
      });
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    i(), n();
  };
  return hH(s), s;
}, bH = (e, t, r, a = {}) => {
  const { window: n = mH, event: i = "pointerdown" } = a;
  return n ? gH(n, i, (s) => {
    const o = Fr(e), l = Fr(t);
    !o || !l || o === s.target || s.composedPath().includes(o) || s.composedPath().includes(l) || r(s);
  }, { passive: !0 }) : void 0;
}, yH = /* @__PURE__ */ Ae({
  __name: "VueDatePicker",
  props: {
    ...ps
  },
  emits: [
    "update:model-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = lu(), i = ne(!1), s = ql(a, "modelValue"), o = ql(a, "timezone"), l = ne(null), u = ne(null), d = ne(!1), f = ne(null), c = Sn({
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    }), { setMenuFocused: p, setShiftKey: v } = cO(), { clearArrowNav: h } = fs(), { validateDate: g, isValidTime: m, defaults: b, mapDatesArrToMap: y } = en(a);
    ct(() => {
      D(a.modelValue), a.inline || (E(f.value).addEventListener("scroll", le), window.addEventListener("resize", Z)), a.inline && (i.value = !0), y(c);
    }), Tr(() => {
      if (!a.inline) {
        const Ye = E(f.value);
        Ye && Ye.removeEventListener("scroll", le), window.removeEventListener("resize", Z);
      }
    });
    const _ = Ss(n, "all", a.presetRanges), x = Ss(n, "input");
    He(
      [s, o],
      () => {
        D(s.value);
      },
      { deep: !0 }
    );
    const { openOnTop: w, menuStyle: k, resetPosition: S, setMenuPosition: P, setInitialPosition: A, getScrollableParent: E } = vq(l, u, r, a), {
      inputValue: O,
      internalModelValue: T,
      parseExternalModelValue: D,
      emitModelValue: $,
      formatInputValue: I,
      checkBeforeEmit: F
    } = fq(r, a, d), j = N(
      () => ({
        dp__main: !0,
        dp__theme_dark: a.dark,
        dp__theme_light: !a.dark,
        dp__flex_display: a.inline,
        dp__flex_display_with_input: a.inlineWithInput
      })
    ), M = N(() => a.dark ? "dp__theme_dark" : "dp__theme_light"), q = N(() => a.teleport ? {
      to: typeof a.teleport == "boolean" ? "body" : a.teleport,
      disabled: a.inline
    } : { class: "dp__outer_menu_wrap" }), le = () => {
      i.value && (a.closeOnScroll ? nt() : P());
    }, Z = () => {
      i.value && P();
    }, G = async () => {
      var Ye, at, ut;
      !a.disabled && !a.readonly && (S(), await Pt(), i.value = !0, await Pt(), A(), await Pt(), P(), delete k.value.opacity, !((Ye = b.value.transitions) != null && Ye.menuAppear) && a.transitions && ((ut = (at = l.value) == null ? void 0 : at.$el) == null || ut.classList.add("dp__menu_transitioned")), i.value && r("open"), i.value || et(), D(a.modelValue));
    }, H = () => {
      O.value = "", et(), r("update:model-value", null), r("cleared"), a.closeOnClearValue && nt();
    }, W = () => {
      const Ye = T.value;
      return !Ye || !Array.isArray(Ye) && g(Ye) ? !0 : Array.isArray(Ye) ? Ye.length === 2 && g(Ye[0]) && g(Ye[1]) ? !0 : g(Ye[0]) : !1;
    }, ie = () => {
      F() && W() ? ($(), nt()) : r("invalid-select", T.value);
    }, we = (Ye) => {
      Be(), $(), a.closeOnAutoApply && !Ye && nt();
    }, Be = () => {
      u.value && a.textInput && u.value.setParsedDate(T.value);
    }, Ve = (Ye = !1) => {
      a.autoApply && m(T.value) && W() && (a.range && Array.isArray(T.value) ? (a.partialRange || T.value.length === 2) && we(Ye) : we(Ye));
    }, et = () => {
      a.textInput || (T.value = null);
    }, nt = () => {
      a.inline || (i.value && (i.value = !1, p(!1), v(!1), h(), r("closed"), A(), O.value && D(s.value)), et());
    }, xe = (Ye, at) => {
      if (!Ye) {
        T.value = null;
        return;
      }
      T.value = Ye, at && (ie(), r("text-submit"));
    }, J = () => {
      a.autoApply && m(T.value) && $(), Be();
    }, se = () => i.value ? nt() : G(), _e = (Ye) => {
      T.value = Ye;
    }, Se = () => {
      a.textInput && (d.value = !0, I()), r("focus");
    }, Re = () => {
      a.textInput && (d.value = !1, D(a.modelValue)), r("blur");
    }, rt = (Ye) => {
      l.value && l.value.updateMonthYear(0, {
        month: u2(Ye.month),
        year: u2(Ye.year)
      });
    }, Dt = (Ye) => {
      D(Ye || a.modelValue);
    }, It = (Ye, at) => {
      var ut;
      (ut = l.value) == null || ut.switchView(Ye, at);
    };
    return bH(
      l,
      u,
      a.onClickOutside ? () => a.onClickOutside(W) : nt
    ), t({
      closeMenu: nt,
      selectDate: ie,
      clearValue: H,
      openMenu: G,
      onScroll: le,
      formatInputValue: I,
      // exposed for testing purposes
      updateInternalModelValue: _e,
      // modify internal modelValue
      setMonthYear: rt,
      parseModel: Dt,
      switchView: It
    }), (Ye, at) => (R(), K("div", {
      class: pe(j.value),
      ref_key: "pickerWrapperRef",
      ref: f
    }, [
      Fe(_q, Mt({
        ref_key: "inputRef",
        ref: u,
        "is-menu-open": i.value,
        "input-value": U(O),
        "onUpdate:inputValue": at[0] || (at[0] = (ut) => _a(O) ? O.value = ut : null)
      }, Ye.$props, {
        onClear: H,
        onOpen: G,
        onSetInputDate: xe,
        onSetEmptyDate: U($),
        onSelectDate: ie,
        onToggle: se,
        onClose: nt,
        onFocus: Se,
        onBlur: Re,
        onRealBlur: at[1] || (at[1] = (ut) => d.value = !1)
      }), Ma({ _: 2 }, [
        kt(U(x), (ut, Gt) => ({
          name: ut,
          fn: Pe((Je) => [
            ke(Ye.$slots, ut, jr(oa(Je)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      i.value ? (R(), Le(Za(Ye.teleport ? Oo : "div"), jr(Mt({ key: 0 }, q.value)), {
        default: Pe(() => [
          i.value ? (R(), Le(vH, Mt({
            key: 0,
            ref_key: "dpMenuRef",
            ref: l,
            class: M.value,
            style: Ye.inline ? void 0 : U(k),
            "open-on-top": U(w),
            "arr-map-values": c
          }, Ye.$props, {
            "internal-model-value": U(T),
            "onUpdate:internalModelValue": at[2] || (at[2] = (ut) => _a(T) ? T.value = ut : null),
            onClosePicker: nt,
            onSelectDate: ie,
            onAutoApply: Ve,
            onTimeUpdate: J,
            onFlowStep: at[3] || (at[3] = (ut) => Ye.$emit("flow-step", ut)),
            onUpdateMonthYear: at[4] || (at[4] = (ut) => Ye.$emit("update-month-year", ut)),
            onInvalidSelect: at[5] || (at[5] = (ut) => Ye.$emit("invalid-select", U(T))),
            onInvalidFixedRange: at[6] || (at[6] = (ut) => Ye.$emit("invalid-fixed-range", ut)),
            onRecalculatePosition: U(P),
            onTooltipOpen: at[7] || (at[7] = (ut) => Ye.$emit("tooltip-open", ut)),
            onTooltipClose: at[8] || (at[8] = (ut) => Ye.$emit("tooltip-close", ut)),
            onTimePickerOpen: at[9] || (at[9] = (ut) => Ye.$emit("time-picker-open", ut)),
            onTimePickerClose: at[10] || (at[10] = (ut) => Ye.$emit("time-picker-close", ut)),
            onAmPmChange: at[11] || (at[11] = (ut) => Ye.$emit("am-pm-change", ut)),
            onRangeStart: at[12] || (at[12] = (ut) => Ye.$emit("range-start", ut)),
            onRangeEnd: at[13] || (at[13] = (ut) => Ye.$emit("range-end", ut))
          }), Ma({ _: 2 }, [
            kt(U(_), (ut, Gt) => ({
              name: ut,
              fn: Pe((Je) => [
                ke(Ye.$slots, ut, jr(oa({ ...Je })))
              ])
            }))
          ]), 1040, ["class", "style", "open-on-top", "arr-map-values", "internal-model-value", "onRecalculatePosition"])) : fe("", !0)
        ]),
        _: 3
      }, 16)) : fe("", !0)
    ], 2));
  }
}), $b = /* @__PURE__ */ (() => {
  const e = yH;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), _H = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $b
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(_H).forEach(([e, t]) => {
  e !== "default" && ($b[e] = t);
});
function Ml(e, t) {
  return String(e).padStart(t, "0");
}
function xH(e) {
  return e.replace(/[٠-٩۰-۹]/g, (t) => (t.charCodeAt(0) & 15).toString());
}
const wH = ["for"], TH = {
  key: 0,
  class: "action-row"
}, SH = ["aria-disabled"], EH = ["id", "placeholder", "value", "required", "disabled", "aria-required", "aria-disabled"], OH = ["disabled"], CH = {
  key: 0,
  class: "input__error"
}, kH = {
  key: 1,
  class: "input__hint mb-4"
}, koe = /* @__PURE__ */ Ae({
  __name: "JDateTimePicker",
  props: {
    modelValue: {},
    error: {},
    label: {},
    placeholder: { default: "Select Date" },
    calenderLeft: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !0 },
    hint: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, i = $d(), s = Gr(), o = N(() => s("timePicker", !0)), l = N(() => s("flow", !0)), u = N(
      () => l.value ? i.flow : ["year", "month", "calendar", "time"]
    ), { currentLocaleItem: d } = Ii();
    function f(k) {
      if (!k)
        return null;
      const S = k.split("/");
      if (S.length === 3) {
        const P = Number.parseInt(S[0]), A = Number.parseInt(S[1]) - 1, E = Number.parseInt(S[2]);
        return new Date(E, A, P);
      }
      return null;
    }
    const c = N({
      get() {
        return o.value ? p(a.modelValue) : f(a.modelValue);
      },
      set(k) {
        n("update:modelValue", k ? h(k) : null);
      }
    });
    function p(k) {
      if (!k)
        return null;
      const [S, P] = k.split(":").map(Number);
      return {
        hours: S,
        minutes: P
      };
    }
    const v = () => c.value = null;
    function h(k) {
      if (k)
        if (o.value) {
          const S = Ml(k.hours, 2), P = Ml(k.minutes, 2);
          return `${S}:${P}:00`;
        } else {
          let S = /* @__PURE__ */ new Date();
          typeof k == "string" ? S = new Date(Date.parse(k)) : typeof k == "object" && (S = k);
          const P = Ml(S.getDate().toString(), 2), A = Ml((S.getMonth() + 1).toString(), 2), E = S.getFullYear();
          return `${P}/${A}/${E}`;
        }
    }
    const g = N(() => cu().toString()), m = N(() => s("required", !0)), b = N(
      () => m.value && "after:px-4 after:content-['*'] "
    ), y = N(() => s("disabled", !0)), _ = ne();
    function x() {
      var k;
      (k = _.value) == null || k.openMenu();
    }
    function w(k) {
      var S;
      o.value || !k || ((S = c.value) == null ? void 0 : S.toString()) === k.toString() || _.value && _.value.selectDate();
    }
    return t({
      openDatePicker: x
    }), (k, S) => (R(), K("div", null, [
      k.label ? (R(), K("div", {
        key: 0,
        class: pe([b.value, "mb-8 text-base after:text-danger md:text-subject"])
      }, [
        ue("label", {
          for: g.value,
          class: "input__label"
        }, Ie(k.label), 9, wH)
      ], 2)) : fe("", !0),
      Fe(U($b), Mt({
        ref_key: "datePickerRef",
        ref: _
      }, k.$attrs, {
        modelValue: c.value,
        "onUpdate:modelValue": S[0] || (S[0] = (P) => c.value = P),
        format: o.value ? "HH:mm" : "dd/MM/yyyy",
        enableTimePicker: o.value,
        position: "left",
        flow: u.value,
        preventMinMaxNavigation: "",
        onInternalModelChange: w
      }), {
        "clear-icon": Pe(() => []),
        "arrow-left": Pe(() => [
          Fe(U(gt), {
            name: "alt-arrow-left-line",
            class: pe({ "rotate-180": U(d).rtl })
          }, null, 8, ["class"])
        ]),
        "arrow-right": Pe(() => [
          Fe(U(gt), {
            name: "arrow-right-outline",
            class: pe({ "rotate-180": U(d).rtl })
          }, null, 8, ["class"])
        ]),
        "action-preview": Pe(() => []),
        "action-row": Pe(({ selectDate: P, closePicker: A }) => [
          o.value ? (R(), K("div", TH, [
            Fe(U(Wl), {
              size: "md",
              type: "button",
              class: "select-button m-2 rounded-sm",
              onClick: P
            }, {
              default: Pe(() => [
                jt(Ie(k.$t("words.select")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            Fe(U(Wl), {
              size: "md",
              type: "button",
              variant: "outlined",
              color: "dark",
              class: "cancel-button rounded-sm",
              onClick: A
            }, {
              default: Pe(() => [
                jt(Ie(k.$t("words.cancel")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])) : fe("", !0)
        ]),
        "dp-input": Pe(({ value: P }) => [
          ue("div", {
            "aria-disabled": y.value,
            class: pe(["flex h-40 w-full cursor-pointer overflow-hidden rounded-sm border px-12 py-[0.65rem] text-left focus-within:border", {
              "bg-disabled": y.value,
              "bg-white focus-within:border-primary": !y.value,
              "mb-4 border-danger": k.error,
              "border-gray-300": !k.error
            }])
          }, [
            ea(Fe(U(gt), {
              class: "me-4 inline-block text-gray-400",
              "aria-disabled": y.value,
              name: o.value ? "clock-circle-outline" : "calendar-outline",
              "aria-hidden": "true"
            }, null, 8, ["aria-disabled", "name"]), [
              [$a, k.calenderLeft]
            ]),
            ue("input", {
              id: g.value,
              placeholder: k.placeholder,
              value: o.value ? P : h(c.value ?? ""),
              required: m.value,
              disabled: y.value,
              "aria-required": m.value,
              "aria-disabled": y.value,
              readonly: "",
              autocomplete: "off",
              class: pe(["inline-block w-full cursor-pointer placeholder:text-metadata-limited placeholder:text-placeholder focus:outline-none focus:ring-0", [y.value ? "bg-disabled" : "bg-white"]])
            }, null, 10, EH),
            ea(Fe(U(gt), {
              class: "inline-block text-gray-400",
              "aria-disabled": y.value,
              name: o.value ? "clock-circle-outline" : "calendar-outline",
              "aria-hidden": "true"
            }, null, 8, ["aria-disabled", "name"]), [
              [$a, !c.value && !k.calenderLeft]
            ]),
            ue("button", {
              disabled: y.value,
              onClick: v
            }, [
              ea(Fe(U(gt), {
                class: "inline-block text-danger",
                "aria-disabled": y.value,
                name: "close",
                "aria-hidden": "true"
              }, null, 8, ["aria-disabled"]), [
                [$a, c.value && k.clearable]
              ])
            ], 8, OH)
          ], 10, SH),
          k.error ? (R(), K("span", CH, Ie(k.error), 1)) : !k.error && k.hint ? (R(), K("span", kH, Ie(k.hint), 1)) : fe("", !0)
        ]),
        _: 1
      }, 16, ["modelValue", "format", "enableTimePicker", "flow"])
    ]));
  }
});
const PH = {
  sm: "w-full md:w-1/3",
  md: "w-full md:w-2/3 xl:w-1/2",
  lg: "w-9/10 md:w-3/4",
  full: "w-full"
}, m2 = {
  left: {
    enter: "duration-150 ease-out",
    enterFrom: "opacity-90 rtl:translate-x-full ltr:-translate-x-full",
    enterTo: "opacity-100 rtl:translate-x-0 ltr:-translate-x-0",
    leave: "duration-100 ease-in",
    leaveFrom: "opacity-100 rtl:translate-x-0 ltr:-translate-x-0",
    leaveTo: "opacity-90 rtl:translate-x-full ltr:-translate-x-full"
  },
  right: {
    enter: "duration-150 ease-out",
    enterFrom: "opacity-90 rtl:-translate-x-full ltr:translate-x-full",
    enterTo: "opacity-100 rtl:-translate-x-0 ltr:translate-x-0",
    leave: "duration-100 ease-in",
    leaveFrom: "opacity-100 rtl:-translate-x-0 ltr:translate-x-0",
    leaveTo: "opacity-90 rtl:-translate-x-full ltr:translate-x-full"
  }
}, MH = /* @__PURE__ */ ue("span", { class: "sr-only" }, "Close SideBar", -1), AH = { class: "h-full w-full overflow-y-auto scroll-smooth" }, Poe = /* @__PURE__ */ Ae({
  __name: "JDrawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    outsideClose: { type: Boolean, default: !0 },
    hasClose: { type: Boolean, default: !0 },
    floatClose: { type: Boolean, default: !1 },
    closeSize: { default: 40 },
    contentClass: { default: "" },
    overlayClass: { default: "" },
    align: { default: "right" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), { isOnTop: i, zIndex: s } = G1({
      type: "drawer",
      isOpen: n
    });
    function o() {
      i.value && (n.value = !1);
    }
    const l = ne(null), u = N(() => PH[r.size]), d = N(() => r.floatClose ? "md:top-50 top-10 ltr:left-10 ltr:md:-left-60 rtl:md:-right-60 rtl:right-10 bg-white" : "top-4 ltr:right-4 rtl:left-4"), f = N(() => r.align === "left" ? "ltr:left-0 rtl:right-0" : "ltr:right-0 rtl:left-0"), c = N(() => r.align === "left" ? m2.left : m2.right);
    return (p, v) => (R(), Le(U(ab), {
      appear: "",
      show: U(n),
      as: "template"
    }, {
      default: Pe(() => [
        Fe(U(J1), { onClose: o }, {
          default: Pe(() => [
            Fe(U(zl), {
              as: "template",
              enter: "duration-75 ease-in",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "duration-75 ease-out",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0"
            }, {
              default: Pe(() => [
                ea(Fe(Qd, {
                  style: Ir({ zIndex: U(s) }),
                  class: pe([p.overlayClass])
                }, null, 8, ["style", "class"]), [
                  [$a, U(n)]
                ])
              ]),
              _: 1
            }),
            Fe(U(zl), Mt({ as: "template" }, c.value), {
              default: Pe(() => [
                ue("div", {
                  class: pe(["fixed top-0 min-h-screen bg-white", [u.value, f.value, p.contentClass]]),
                  style: Ir({ zIndex: U(s) })
                }, [
                  Fe(U(Q1), { class: "h-screen max-h-screen overflow-y-auto scroll-smooth" }, {
                    default: Pe(() => [
                      ue("div", {
                        ref_key: "drawerContent",
                        ref: l,
                        class: "h-full w-full"
                      }, [
                        ue("div", null, [
                          ke(p.$slots, "header")
                        ]),
                        p.hasClose ? (R(), K("button", {
                          key: 0,
                          class: pe(["absolute z-1 inline-flex items-center justify-center rounded-full", [d.value]]),
                          onClick: o
                        }, [
                          Fe(gt, {
                            name: "close",
                            size: p.closeSize
                          }, null, 8, ["size"]),
                          MH
                        ], 2)) : fe("", !0),
                        ue("div", AH, [
                          ke(p.$slots, "default")
                        ])
                      ], 512)
                    ]),
                    _: 3
                  })
                ], 6)
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Moe = /* @__PURE__ */ Ae({
  __name: "JErrorBoundary",
  setup(e) {
    const t = Sn({
      hasError: !1,
      error: null
    });
    return F4((r) => {
      t.hasError = !0, t.error = r;
    }), (r, a) => t.hasError ? ke(r.$slots, "fallback", {
      key: 1,
      error: t.error
    }) : ke(r.$slots, "default", { key: 0 });
  }
}), Aoe = /* @__PURE__ */ Ae({
  __name: "JFlag",
  props: {
    name: {},
    size: { default: 24 }
  },
  setup(e) {
    const t = e, r = ne();
    return He(
      () => t.name,
      (a) => {
        r.value = rT(
          Dl(() => R1(/* @__PURE__ */ Object.assign({ "../../assets/svg/flags/arabia.svg": () => import("./arabia-61b2924a.mjs"), "../../assets/svg/flags/bangladesh.svg": () => import("./bangladesh-c32f9318.mjs"), "../../assets/svg/flags/england.svg": () => import("./england-ee7bc50a.mjs"), "../../assets/svg/flags/france.svg": () => import("./france-413e670f.mjs"), "../../assets/svg/flags/germany.svg": () => import("./germany-080f3513.mjs"), "../../assets/svg/flags/greece.svg": () => import("./greece-13c98286.mjs"), "../../assets/svg/flags/italy.svg": () => import("./italy-ef2b1198.mjs"), "../../assets/svg/flags/portugal.svg": () => import("./portugal-0fcec40f.mjs"), "../../assets/svg/flags/serbia.svg": () => import("./serbia-5321989b.mjs"), "../../assets/svg/flags/spain.svg": () => import("./spain-164c703d.mjs") }), `../../assets/svg/flags/${a}.svg`))
        );
      },
      {
        immediate: !0
      }
    ), (a, n) => (R(), Le(Za(r.value), {
      width: a.size,
      height: a.size
    }, null, 8, ["width", "height"]));
  }
}), DH = {
  1: "w-1/12",
  2: "w-2/12",
  3: "w-3/12",
  4: "w-4/12",
  5: "w-5/12",
  6: "w-6/12",
  7: "w-7/12",
  8: "w-8/12",
  9: "w-9/12",
  10: "w-10/12",
  11: "w-11/12",
  12: "w-full"
}, IH = {
  1: "md:w-1/12",
  2: "md:w-2/12",
  3: "md:w-3/12",
  4: "md:w-4/12",
  5: "md:w-5/12",
  6: "md:w-6/12",
  7: "md:w-7/12",
  8: "md:w-8/12",
  9: "md:w-9/12",
  10: "md:w-10/12",
  11: "md:w-11/12",
  12: "md:w-full"
}, NH = {
  1: "lg:w-1/12",
  2: "lg:w-2/12",
  3: "lg:w-3/12",
  4: "lg:w-4/12",
  5: "lg:w-5/12",
  6: "lg:w-6/12",
  7: "lg:w-7/12",
  8: "lg:w-8/12",
  9: "lg:w-9/12",
  10: "lg:w-10/12",
  11: "lg:w-11/12",
  12: "lg:w-full"
}, $H = {
  1: "xl:w-1/12",
  2: "xl:w-2/12",
  3: "xl:w-3/12",
  4: "xl:w-4/12",
  5: "xl:w-5/12",
  6: "xl:w-6/12",
  7: "xl:w-7/12",
  8: "xl:w-8/12",
  9: "xl:w-9/12",
  10: "xl:w-10/12",
  11: "xl:w-11/12",
  12: "xl:w-full"
}, h2 = /* @__PURE__ */ Ae({
  __name: "JCol",
  props: {
    sm: { default: "12" },
    md: { default: "12" },
    lg: { default: "12" },
    xl: { default: "12" }
  },
  setup(e) {
    const t = e, r = N(() => DH[t.sm]), a = N(() => IH[t.md]), n = N(() => NH[t.lg]), i = N(() => $H[t.xl]), s = sr("paddingSm"), o = sr("paddingMd"), l = sr("paddingLg"), u = sr("paddingXl");
    return (d, f) => (R(), K("div", {
      class: pe(["container__col", [
        r.value,
        a.value,
        n.value,
        i.value,
        U(s),
        U(o),
        U(l),
        U(u)
      ]])
    }, [
      ke(d.$slots, "default")
    ], 2));
  }
}), LH = { class: "flex flex-row justify-center" }, Doe = /* @__PURE__ */ Ae({
  __name: "JContainer",
  props: {
    fluid: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = N(() => t.fluid ? "w-full" : "container");
    return (a, n) => (R(), K("div", LH, [
      ue("div", {
        class: pe([r.value, "h-full"])
      }, [
        ke(a.$slots, "default")
      ], 2)
    ]));
  }
}), RH = /* @__PURE__ */ Ae({
  __name: "JRow",
  props: {
    noWrap: { type: Boolean, default: !1 },
    spaceSm: { default: "0" },
    spaceMd: { default: "0" },
    spaceLg: { default: "0" },
    spaceXl: { default: "0" }
  },
  setup(e) {
    const t = e, r = N(() => t.noWrap ? "flex-nowrap" : "flex-wrap"), a = N(() => t.spaceSm && kD[t.spaceSm]), n = N(() => t.spaceMd && PD[t.spaceMd]), i = N(() => t.spaceLg && MD[t.spaceLg]), s = N(() => t.spaceXl && AD[t.spaceXl]);
    return Mr("paddingSm", SD[t.spaceSm]), Mr("paddingMd", ED[t.spaceMd]), Mr("paddingLg", OD[t.spaceLg]), Mr("paddingXl", CD[t.spaceXl]), (o, l) => (R(), K("div", {
      class: pe(["flex flex-row justify-start", [r.value, a.value, n.value, i.value, s.value]])
    }, [
      ke(o.$slots, "default")
    ], 2));
  }
});
var J0 = /* @__PURE__ */ ((e) => (e.LOADED = "loaded", e.LOADING = "loading", e))(J0 || {});
const jH = ["data-src", "lazy"], FH = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JImage",
  props: {
    src: {},
    overlay: { type: Boolean },
    containerClass: {},
    overlayClass: { default: "" }
  },
  setup(e) {
    const t = e, r = ne(null), a = ne(null), n = ne(!1), i = ne([]), s = N(() => t.overlay || !1), o = N(() => t.containerClass || ""), { isReady: l, isLoading: u, error: d } = h5({ src: t.src }), f = N(
      () => n.value ? J0.LOADED : J0.LOADING
    ), { stop: c } = p5(
      r,
      ([{ isIntersecting: p }]) => {
        if (p && l) {
          if (!a.value)
            return;
          a.value.src = t.src, i.value.push("opacity-100 !blur-none"), n.value = p, a.value.removeAttribute("data-src"), c();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );
    return (p, v) => (R(), K("figure", {
      ref_key: "containerRef",
      ref: r,
      class: pe([[o.value, (U(u) || U(d)) && "image__cover"], "relative overflow-hidden"])
    }, [
      U(d) ? fe("", !0) : (R(), K("img", Mt({
        key: 0,
        ref_key: "imageRef",
        ref: a,
        "data-src": p.src,
        class: ["relative h-full w-full opacity-0 blur-sm transition-opacity duration-500", i.value]
      }, p.$attrs, { lazy: f.value }), null, 16, jH)),
      s.value ? (R(), K("div", {
        key: 1,
        class: pe(["absolute inset-0 h-full w-full", [p.overlayClass]])
      }, [
        ke(p.$slots, "overlay", {}, void 0, !0)
      ], 2)) : fe("", !0)
    ], 2));
  }
});
const BH = /* @__PURE__ */ rs(FH, [["__scopeId", "data-v-f76e0927"]]), qH = {
  width: "500",
  height: "200",
  viewBox: "0 0 500 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HH = /* @__PURE__ */ B4('<g clip-path="url(#clip0_10_16)"><path d="M201.29 115.49V191.43H188.93V130.02L188.65 130.36C187.99 131.18 187.35 132.1 186.74 133.12C186.04 134.27 185.41 135.34 184.84 136.32C184.27 137.32 183.64 138.44 182.95 139.68L178.74 147.93C178.04 149.32 177.28 150.64 176.49 151.89C175.7 153.14 174.86 154.32 173.99 155.42C173.1 156.54 172.14 157.55 171.12 158.46C170.1 159.36 169.01 160.16 167.87 160.85C166.69 161.56 165.38 162.09 163.96 162.44C162.55 162.79 161.03 162.97 159.41 162.97C157.79 162.97 156.28 162.8 154.88 162.46C153.46 162.12 152.17 161.6 151.01 160.91C149.89 160.25 148.82 159.46 147.83 158.57C146.84 157.69 145.91 156.69 145.06 155.59C144.22 154.51 143.43 153.35 142.69 152.15C141.95 150.94 141.25 149.66 140.6 148.32L138.67 144.37L136.69 140.38C136.01 139.09 135.34 137.88 134.7 136.73C134.02 135.53 133.36 134.4 132.73 133.35C132.11 132.31 131.44 131.35 130.75 130.48L130.36 130.01V191.43H118V114.42H129.24L129.41 114.48C130.6 114.89 131.75 115.4 132.83 116.01C133.91 116.6 134.92 117.29 135.86 118.06C136.79 118.83 137.67 119.64 138.5 120.5C139.33 121.36 140.12 122.27 140.85 123.24C141.58 124.18 142.27 125.17 142.94 126.19C143.59 127.2 144.22 128.25 144.81 129.32C145.89 131.3 147.3 133.61 148.22 135.6C149.42 138 150.46 140.18 151.33 142.13C151.75 143.07 152.18 143.94 152.61 144.74C153.01 145.5 153.43 146.2 153.87 146.85C154.67 148.06 155.51 148.98 156.4 149.62C156.79 149.9 157.24 150.12 157.73 150.26C158.23 150.41 158.79 150.49 159.41 150.49C160.7 150.49 161.77 150.19 162.61 149.61C163.07 149.29 163.52 148.9 163.96 148.45C164.4 147.99 164.83 147.45 165.26 146.84C165.69 146.23 166.13 145.52 166.58 144.72C167.03 143.91 167.48 143.04 167.91 142.12L169.39 139.02L171.07 135.6C171.59 134.58 172.13 133.53 172.7 132.47C173.28 131.38 173.86 130.33 174.43 129.31C175.65 127.15 176.99 125.13 178.44 123.24C179.18 122.27 179.97 121.35 180.8 120.5C181.62 119.64 182.5 118.82 183.43 118.06C184.37 117.29 185.38 116.6 186.46 116.01C187.55 115.4 188.69 114.89 189.89 114.48L190.06 114.42H201.29V115.49ZM270.59 184.9C269.17 185.91 267.62 186.88 265.96 187.78C264.3 188.68 262.52 189.53 260.62 190.32C258.68 191.12 256.62 191.72 254.42 192.12C252.22 192.52 249.91 192.72 247.48 192.72C243.48 192.72 239.77 192.12 236.36 190.93C234.65 190.34 233.05 189.61 231.57 188.75C230.08 187.89 228.7 186.9 227.44 185.79C224.9 183.54 222.87 180.77 221.34 177.46C220.58 175.81 219.99 174.04 219.56 172.16C219.18 170.46 218.93 168.66 218.83 166.78L218.03 166.85C217.4 166.89 216.74 166.93 216.03 166.95C215.45 166.97 214.86 167.04 214.26 167.16C213.66 167.27 213.07 167.44 212.5 167.66L211.07 168.2V155.04L211.83 154.82C212.53 154.61 213.24 154.44 213.94 154.32C214.64 154.19 215.33 154.1 215.99 154.06L217.9 153.92L218.99 153.81C219.14 152.16 219.41 150.57 219.79 149.04C220.24 147.22 220.86 145.48 221.64 143.84C222.42 142.19 223.35 140.65 224.4 139.22C225.45 137.8 226.64 136.49 227.96 135.29C229.29 134.09 230.74 133.02 232.3 132.1C233.86 131.18 235.55 130.38 237.36 129.72C239.16 129.07 241.06 128.58 243.05 128.25C245.04 127.92 247.12 127.75 249.26 127.75C251.6 127.75 253.83 128.01 255.97 128.53C258.1 129.05 260.12 129.83 262.03 130.86L262.05 130.87C263.5 131.7 264.84 132.7 266.06 133.85C267.27 134.99 268.35 136.3 269.31 137.76C270.28 139.24 271.01 140.81 271.49 142.48C271.98 144.15 272.22 145.9 272.22 147.74C272.22 151.63 270.92 155.26 268.31 158.62C266.98 160.37 265.51 161.82 263.91 162.96C262.29 164.11 260.54 164.96 258.65 165.48C256.85 165.99 254.96 166.37 252.98 166.63C251.01 166.88 248.97 167.01 246.88 167.01C246.01 167.01 245.01 166.99 243.89 166.95C242.78 166.91 241.63 166.85 240.45 166.77C239.21 166.69 238.07 166.63 237.01 166.59C235.98 166.56 234.94 166.54 233.91 166.54C233.39 166.54 232.9 166.56 232.45 166.59L232.12 166.62C232.15 168.68 232.51 170.5 233.2 172.05C233.91 173.67 234.98 175.02 236.4 176.12C237.87 177.25 239.52 178.1 241.35 178.67C243.19 179.24 245.24 179.52 247.48 179.52C248.67 179.52 249.79 179.48 250.82 179.38C251.86 179.29 252.88 179.14 253.88 178.95C254.88 178.75 255.83 178.52 256.73 178.26C257.64 178 258.53 177.69 259.4 177.34C260.28 176.99 261.14 176.61 261.97 176.21C262.78 175.82 263.61 175.38 264.44 174.91C265.31 174.41 266.14 173.92 266.91 173.44C267.71 172.95 268.54 172.41 269.39 171.85L271.04 170.75V184.58L270.59 184.9ZM250.69 140.24C248.33 140.24 246.06 140.54 243.9 141.15C242.82 141.45 241.8 141.83 240.85 142.27C239.89 142.72 238.99 143.25 238.16 143.85C237.33 144.43 236.57 145.1 235.89 145.85C235.2 146.6 234.59 147.43 234.05 148.34C233.52 149.24 233.09 150.23 232.77 151.3C232.55 152.04 232.38 152.83 232.26 153.66C233.66 153.61 236.36 153.34 237.61 153.47C238.27 153.55 239 153.61 239.79 153.66C240.63 153.71 241.51 153.74 242.44 153.76L245.3 153.81L248.07 153.82C249.62 153.82 251.16 153.72 252.7 153.53C253.43 153.44 254.13 153.3 254.79 153.12C255.44 152.93 256.05 152.71 256.6 152.44C257.14 152.18 257.62 151.87 258.05 151.52C258.47 151.17 258.85 150.77 259.18 150.33C259.48 149.92 259.7 149.45 259.86 148.91C260.02 148.35 260.1 147.72 260.1 147.03C260.1 144.59 259.21 142.87 257.44 141.88C256.45 141.33 255.39 140.92 254.28 140.65C253.16 140.37 251.96 140.24 250.69 140.24ZM293.71 134.37C294.11 133.87 294.55 133.4 295.03 132.97C295.85 132.23 296.7 131.58 297.57 131.02C298.45 130.46 299.37 129.97 300.32 129.57C301.25 129.18 302.18 128.84 303.1 128.57C304.02 128.3 304.95 128.09 305.86 127.95C306.77 127.81 307.56 127.7 308.24 127.63C308.98 127.56 309.59 127.52 310.08 127.52C312.38 127.52 314.54 127.66 316.55 127.95C318.56 128.23 320.43 128.66 322.14 129.24C323.87 129.82 325.45 130.58 326.87 131.5C328.3 132.42 329.57 133.52 330.69 134.78C331.8 136.04 332.77 137.49 333.59 139.13C334.41 140.76 335.09 142.57 335.62 144.55C336.15 146.52 336.55 148.71 336.81 151.09C337.07 153.47 337.21 156.05 337.21 158.81V191.41H324.37V158.45C324.37 157.25 324.32 156.08 324.22 154.94C324.12 153.8 323.98 152.69 323.79 151.61C323.61 150.58 323.33 149.59 322.98 148.66C322.63 147.73 322.19 146.86 321.68 146.05C321.18 145.25 320.58 144.53 319.89 143.89C319.21 143.25 318.42 142.68 317.53 142.18C316.66 141.69 315.64 141.29 314.48 140.99C313.31 140.68 311.99 140.47 310.52 140.35C308.52 140.36 306.5 140.73 304.49 141.48C303.49 141.85 302.54 142.31 301.65 142.86C300.76 143.41 299.92 144.04 299.14 144.77C298.36 145.49 297.64 146.3 297 147.19C296.35 148.08 295.77 149.06 295.26 150.11C294.77 151.14 294.39 152.25 294.14 153.43C293.89 154.62 293.77 155.9 293.77 157.26V191.41H280.81V129.66H293.78L293.71 134.37ZM382.2 191.65C380.5 191.65 378.87 191.49 377.32 191.18C375.76 190.87 374.27 190.4 372.84 189.77C371.44 189.15 370.12 188.43 368.89 187.62C367.66 186.8 366.51 185.88 365.46 184.86C364.39 183.84 363.45 182.74 362.63 181.55C361.8 180.36 361.09 179.08 360.51 177.74C359.93 176.39 359.5 175.01 359.2 173.59C358.91 172.17 358.76 170.73 358.76 169.28V141.78H348.17V129.66H358.88V110.86H371.36V129.66H383.38V141.78H371.36V171.13C371.54 172.21 371.92 173.2 372.48 174.1C373.08 175.04 373.88 175.89 374.9 176.64C375.92 177.4 377.03 177.97 378.25 178.35C379.46 178.74 380.78 178.93 382.2 178.93H383.26V191.65H382.2ZM499.31 140.35H493.59C491.25 140.35 488.96 140.73 486.73 141.49C485.62 141.86 484.58 142.33 483.62 142.88C482.64 143.43 481.74 144.07 480.9 144.79C480.07 145.51 479.32 146.32 478.64 147.21C477.97 148.08 477.38 149.06 476.87 150.11C476.38 151.14 476 152.25 475.75 153.43C475.5 154.62 475.38 155.9 475.38 157.26V191.41H462.42V129.66H475.26V133.36C475.79 132.78 476.37 132.24 477.02 131.77C477.81 131.19 478.65 130.67 479.54 130.21C480.43 129.76 481.36 129.37 482.32 129.06C483.26 128.75 484.22 128.49 485.18 128.29C486.13 128.08 487.09 127.92 488.07 127.82C489.98 127.62 491.67 127.52 493.12 127.52H500.24L500.38 140.35H499.31Z" fill="#130044"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M413.35 161.11L431.26 150.73L422.3 169.39L419.04 163.33L413.35 161.11Z" fill="#130044"></path><path d="M422.42 192.6C417.92 192.6 413.67 191.74 409.69 190.01C405.71 188.29 402.23 185.96 399.25 183.01C397.75 181.53 396.41 179.93 395.23 178.21C394.06 176.5 393.04 174.65 392.18 172.68C391.31 170.71 390.66 168.67 390.23 166.58C389.8 164.47 389.59 162.32 389.59 160.12C389.59 157.88 389.8 155.69 390.23 153.57C390.66 151.45 391.31 149.41 392.18 147.44C393.04 145.47 394.06 143.62 395.23 141.91C396.41 140.19 397.75 138.58 399.25 137.11C402.23 134.16 405.71 131.83 409.69 130.11C411.68 129.25 413.74 128.6 415.86 128.17C418 127.73 420.19 127.52 422.42 127.52C424.63 127.52 426.79 127.73 428.9 128.17C431 128.6 433.05 129.24 435.04 130.11C437.04 130.97 438.9 131.99 440.62 133.14C442.36 134.32 443.96 135.64 445.43 137.11C446.89 138.57 448.22 140.17 449.4 141.91C450.56 143.63 451.58 145.48 452.44 147.44C454.16 151.38 455.03 155.61 455.03 160.12C455.03 164.54 454.16 168.73 452.44 172.68C451.58 174.64 450.56 176.49 449.4 178.21C448.22 179.94 446.89 181.55 445.43 183.01C443.96 184.48 442.35 185.8 440.62 186.97C438.9 188.13 437.04 189.15 435.04 190.01C433.05 190.87 431 191.52 428.9 191.95C426.79 192.38 424.62 192.6 422.42 192.6ZM422.42 140.83C419.71 140.83 417.15 141.34 414.74 142.35C413.53 142.86 412.4 143.46 411.36 144.15C410.32 144.83 409.36 145.61 408.47 146.47C407.59 147.34 406.79 148.28 406.08 149.3C405.38 150.31 404.76 151.41 404.23 152.58C403.71 153.74 403.31 154.95 403.05 156.2C402.79 157.44 402.66 158.75 402.66 160.12C402.66 161.48 402.79 162.79 403.05 164.04C403.31 165.28 403.71 166.49 404.23 167.65C404.76 168.83 405.38 169.93 406.09 170.96C406.79 171.98 407.59 172.93 408.48 173.83C409.37 174.71 410.33 175.51 411.36 176.19C412.41 176.89 413.54 177.5 414.74 178C415.94 178.51 417.18 178.89 418.46 179.14C419.74 179.4 421.06 179.52 422.42 179.52C425.14 179.52 427.68 179.02 430.04 178C431.23 177.49 432.35 176.89 433.38 176.2C434.4 175.51 435.36 174.72 436.25 173.83C438.02 172.05 439.42 170 440.43 167.67C440.94 166.5 441.32 165.3 441.57 164.05C441.82 162.8 441.95 161.49 441.95 160.12C441.95 158.75 441.82 157.43 441.57 156.19C441.32 154.94 440.94 153.73 440.43 152.57C439.93 151.4 439.32 150.31 438.63 149.29C437.93 148.28 437.14 147.34 436.26 146.47C435.38 145.61 434.42 144.83 433.38 144.15C432.35 143.46 431.23 142.86 430.04 142.35C428.87 141.85 427.64 141.46 426.37 141.21C425.1 140.96 423.78 140.83 422.42 140.83Z" fill="#30C680"></path><path d="M82.19 8.89C82.1 11.78 81.64 14.48 80.8 16.99C80.38 18.25 79.87 19.44 79.26 20.54C78.65 21.65 77.94 22.69 77.14 23.64C76.34 24.61 75.42 25.47 74.4 26.23C73.39 26.99 72.27 27.65 71.04 28.2C68.59 29.32 65.78 29.87 62.59 29.87C58.11 29.87 53.44 29.04 48.58 27.36V90.17H36.2V22.34C35.43 22.07 34.63 21.83 33.82 21.6C32.85 21.34 31.83 21.09 30.76 20.88C29.72 20.67 28.69 20.51 27.66 20.41C26.65 20.31 25.63 20.25 24.62 20.25C23.55 20.25 22.53 20.35 21.56 20.53C20.6 20.71 19.68 20.98 18.81 21.35C18.05 21.67 17.47 22.18 17.07 22.89C16.65 23.64 16.41 24.62 16.38 25.82L16.35 26.54H4V25.8C4 22.87 4.56 20.27 5.68 18.03C6.24 16.91 6.89 15.89 7.64 14.96C8.39 14.03 9.24 13.19 10.18 12.45C11.11 11.72 12.14 11.07 13.24 10.52C14.34 9.96 15.52 9.5 16.78 9.12C19.28 8.37 21.98 8 24.88 8C29.22 8 33.11 8.5 36.56 9.51C38.26 10 39.9 10.52 41.47 11.07C43.06 11.63 44.57 12.2 46.01 12.8C47.44 13.4 48.84 13.97 50.21 14.51C51.61 15.06 52.98 15.58 54.31 16.06C55.61 16.54 56.95 16.9 58.31 17.14C59.67 17.37 61.05 17.49 62.47 17.49C63.26 17.49 63.97 17.45 64.59 17.37C65.2 17.29 65.74 17.17 66.21 17.02C66.65 16.87 67.05 16.68 67.39 16.45C67.72 16.23 68 15.97 68.23 15.67C68.47 15.36 68.67 14.99 68.84 14.57C69.01 14.14 69.15 13.64 69.25 13.1C69.35 12.52 69.44 11.88 69.51 11.16C69.58 10.45 69.64 9.67 69.68 8.83L69.72 8.13H82.21L82.19 8.89ZM193.06 22.27C195.58 22.27 197.99 22.48 200.28 22.91C202.58 23.34 204.76 23.98 206.82 24.83C208.87 25.68 210.78 26.71 212.53 27.9C214.28 29.1 215.88 30.46 217.33 32C218.78 33.53 220.05 35.2 221.16 37.01C222.27 38.82 223.2 40.76 223.97 42.83C224.73 44.9 225.3 47.08 225.68 49.36C226.07 51.65 226.26 54.02 226.26 56.49C226.26 60.68 225.54 64.82 224.1 68.92C223.38 70.98 222.48 72.92 221.43 74.76C220.37 76.59 219.14 78.32 217.74 79.94C216.34 81.56 214.77 83.03 213.06 84.34C211.34 85.65 209.47 86.81 207.44 87.81C205.39 88.83 203.19 89.58 200.83 90.09C198.92 90.5 196.91 90.74 194.8 90.82H194.77H194.55H194.53L194.43 90.83H194.18L194.06 90.84H194.05H193.94H193.81H193.32H192.71H192.67H192.62H192.61H192.57H192.52H192.51H192.47H192.41H192.36L192.31 90.83H192.21H192.2H192.16H192.11H192.1H192.05H192H191.95H191.9H191.89H191.85L191.79 90.82H191.74H191.69H191.64H191.58H191.53H191.48H191.43L191.37 90.81H191.32H191.27H191.22H191.17H191.16H191.11L191.06 90.8H191H190.96H190.95H190.89H190.85H190.84H190.79L190.74 90.79H190.73H190.68H190.64H190.62H190.57L190.53 90.78H190.52H190.46H190.43H190.41H190.35H190.32H190.3L190.24 90.77H190.21H190.19H190.13H190.11H190.08L190.02 90.76H189.97L189.8 90.75H189.78H189.74L189.52 90.74H189.47L189.46 90.73H189.41H189.35H189.3C188.33 90.67 187.36 90.61 186.39 90.52C185.18 90.41 184.07 90.29 183.07 90.15C182.45 90.06 181.88 89.96 181.36 89.86V111.63H180.62H168.69H167.95V29.01L168.3 28.79C169.31 28.18 170.34 27.62 171.4 27.11C172.45 26.6 173.54 26.13 174.65 25.72C175.77 25.3 176.87 24.93 177.95 24.6C179.03 24.27 180.12 23.97 181.22 23.7C182.33 23.44 183.4 23.21 184.42 23.04C185.46 22.85 186.5 22.71 187.53 22.6C188.56 22.49 189.52 22.41 190.44 22.35C191.37 22.3 192.25 22.27 193.06 22.27ZM213.75 54.57C213.75 51.27 213.07 48.42 211.73 46.01C211.05 44.8 210.27 43.7 209.4 42.71C208.53 41.73 207.56 40.86 206.49 40.1C205.42 39.33 204.26 38.66 203.03 38.1C201.8 37.53 200.49 37.05 199.09 36.68C197.69 36.3 196.28 36.02 194.88 35.83C194.24 35.75 193.6 35.68 192.96 35.63H192.94H192.89L192.69 35.62L192.67 35.61H192.63H192.56H192.53L192.5 35.6H192.39H192.36L192.16 35.59L192.12 35.58H192.1H192.03H191.99H191.96L191.9 35.57H191.85H191.83H191.76H191.71H191.7H191.63L191.58 35.56H191.56H191.5H191.44H191.43H191.36H191.31H191.3H191.23L191.17 35.55H191.16H191.09H191.03H190.96H190.9H190.89H190.83H190.76H190.69H190.62H190.55H190.48H190.47H190.4H190.33H190.32H190.25H190.18H190.17H190.1L190.03 35.56H190.01H189.95H189.88H189.86H189.8L189.73 35.57H189.71H189.65H189.58H189.56H189.5L189.43 35.58H189.4H189.35H189.28L189.25 35.59H189.2H189.13H189.09L189.05 35.6H188.98H188.94C187.9 35.67 186.86 35.8 185.82 35.99C184.35 36.25 182.86 36.63 181.36 37.13V76.3C181.9 76.41 182.47 76.51 183.06 76.59C183.87 76.71 184.74 76.8 185.67 76.86C186.63 76.92 187.51 76.97 188.31 77C189.1 77.03 189.87 77.05 190.62 77.05C194.24 77.05 197.48 76.61 200.35 75.74C201.78 75.3 203.1 74.75 204.3 74.08C205.5 73.42 206.59 72.63 207.58 71.73C208.55 70.83 209.42 69.81 210.18 68.66C210.94 67.51 211.59 66.23 212.13 64.82C212.67 63.41 213.07 61.86 213.34 60.16C213.61 58.46 213.75 56.59 213.75 54.57ZM152.65 90.17H140.62V24.68H153.39V90.17H152.65ZM146.94 16.53C145.02 16.53 143.35 15.89 141.97 14.6C141.27 13.95 140.74 13.22 140.38 12.42C140.03 11.6 139.85 10.72 139.85 9.76C139.85 8.81 140.03 7.93 140.38 7.11C140.74 6.3 141.27 5.57 141.97 4.93C142.66 4.29 143.42 3.8 144.26 3.48C145.09 3.16 145.99 3 146.94 3C148.95 3 150.66 3.64 152.04 4.93C152.75 5.57 153.28 6.3 153.63 7.11C153.98 7.93 154.16 8.81 154.16 9.76C154.16 10.72 153.98 11.6 153.63 12.42C153.28 13.22 152.75 13.95 152.04 14.6C151.35 15.24 150.58 15.73 149.72 16.05C148.87 16.37 147.94 16.53 146.94 16.53ZM130.33 35.26H124.17C122.88 35.26 121.61 35.37 120.36 35.57C119.11 35.78 117.88 36.09 116.65 36.51C115.43 36.92 114.28 37.43 113.21 38.04C112.14 38.64 111.14 39.35 110.22 40.15C109.29 40.95 108.46 41.84 107.73 42.81C106.99 43.78 106.34 44.85 105.78 46C105.23 47.15 104.82 48.37 104.54 49.68C104.27 51 104.13 52.4 104.13 53.9V90.3H90.98V24.55H104V29.26L104.26 28.93C104.92 28.11 105.68 27.38 106.55 26.74C107.38 26.13 108.27 25.58 109.21 25.1C110.15 24.62 111.13 24.21 112.14 23.88C113.15 23.55 114.16 23.28 115.18 23.06C116.2 22.84 117.22 22.67 118.26 22.57C119.28 22.46 120.24 22.37 121.13 22.32C122.04 22.27 122.89 22.24 123.66 22.24H130.93L131.07 35.26H130.33Z" fill="#130044"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.02 118.18L38.87 125.34V193.41L4 186.77L4.02 118.18ZM82.87 170.94L101.11 160.36L91.98 179.37L88.67 173.19L82.87 170.94ZM41.31 125.34L70.83 113L71.03 113.04V181.26L41.31 193.47V125.34ZM73.46 113.06L108.08 120.73L108.16 189.15L73.46 181.24V113.06Z" fill="#30C680"></path></g><defs><clipPath id="clip0_10_16"><rect width="500" height="200" fill="white"></rect></clipPath></defs>', 2), VH = [
  HH
];
function UH(e, t) {
  return R(), K("svg", qH, [...VH]);
}
const zH = { render: UH }, YH = { class: "sr-only" }, WH = ["src", "alt"], GH = {
  key: 2,
  class: "sr-only"
}, Ioe = /* @__PURE__ */ Ae({
  __name: "JLogo",
  props: {
    title: { default: "TripMentor" },
    src: {}
  },
  setup(e) {
    return (t, r) => (R(), Le(U(uu), {
      to: "/",
      class: "flex items-center gap-x-10 no-underline md:gap-x-12"
    }, {
      default: Pe(() => [
        ue("span", YH, Ie(t.title), 1),
        t.src ? (R(), K("img", {
          key: 0,
          src: t.src,
          alt: t.title,
          class: "h-32 w-auto md:h-55"
        }, null, 8, WH)) : (R(), Le(U(zH), {
          key: 1,
          class: "h-32 w-auto md:h-55"
        })),
        t.title ? (R(), K("h1", GH, Ie(t.title), 1)) : fe("", !0)
      ]),
      _: 1
    }));
  }
});
var Q0 = { exports: {} };
(function(e, t) {
  (function(r, a) {
    a(t);
  })(Ba, function(r) {
    function a(u, d, f, c) {
      return new (f || (f = Promise))(function(p, v) {
        function h(b) {
          try {
            m(c.next(b));
          } catch (y) {
            v(y);
          }
        }
        function g(b) {
          try {
            m(c.throw(b));
          } catch (y) {
            v(y);
          }
        }
        function m(b) {
          var y;
          b.done ? p(b.value) : (y = b.value, y instanceof f ? y : new f(function(_) {
            _(y);
          })).then(h, g);
        }
        m((c = c.apply(u, d || [])).next());
      });
    }
    function n(u) {
      return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
    }
    typeof SuppressedError == "function" && SuppressedError;
    var i = n(function u(d, f) {
      if (d === f)
        return !0;
      if (d && f && typeof d == "object" && typeof f == "object") {
        if (d.constructor !== f.constructor)
          return !1;
        var c, p, v;
        if (Array.isArray(d)) {
          if ((c = d.length) != f.length)
            return !1;
          for (p = c; p-- != 0; )
            if (!u(d[p], f[p]))
              return !1;
          return !0;
        }
        if (d.constructor === RegExp)
          return d.source === f.source && d.flags === f.flags;
        if (d.valueOf !== Object.prototype.valueOf)
          return d.valueOf() === f.valueOf();
        if (d.toString !== Object.prototype.toString)
          return d.toString() === f.toString();
        if ((c = (v = Object.keys(d)).length) !== Object.keys(f).length)
          return !1;
        for (p = c; p-- != 0; )
          if (!Object.prototype.hasOwnProperty.call(f, v[p]))
            return !1;
        for (p = c; p-- != 0; ) {
          var h = v[p];
          if (!u(d[h], f[h]))
            return !1;
        }
        return !0;
      }
      return d != d && f != f;
    });
    const s = "__googleMapsScriptId";
    var o;
    r.LoaderStatus = void 0, (o = r.LoaderStatus || (r.LoaderStatus = {}))[o.INITIALIZED = 0] = "INITIALIZED", o[o.LOADING = 1] = "LOADING", o[o.SUCCESS = 2] = "SUCCESS", o[o.FAILURE = 3] = "FAILURE";
    class l {
      constructor(d) {
        let { apiKey: f, authReferrerPolicy: c, channel: p, client: v, id: h = s, language: g, libraries: m = [], mapIds: b, nonce: y, region: _, retries: x = 3, url: w = "https://maps.googleapis.com/maps/api/js", version: k } = d;
        if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = f, this.authReferrerPolicy = c, this.channel = p, this.client = v, this.id = h || s, this.language = g, this.libraries = m, this.mapIds = b, this.nonce = y, this.region = _, this.retries = x, this.url = w, this.version = k, l.instance) {
          if (!i(this.options, l.instance.options))
            throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(l.instance.options)}`);
          return l.instance;
        }
        l.instance = this;
      }
      get options() {
        return { version: this.version, apiKey: this.apiKey, channel: this.channel, client: this.client, id: this.id, libraries: this.libraries, language: this.language, region: this.region, mapIds: this.mapIds, nonce: this.nonce, url: this.url, authReferrerPolicy: this.authReferrerPolicy };
      }
      get status() {
        return this.errors.length ? r.LoaderStatus.FAILURE : this.done ? r.LoaderStatus.SUCCESS : this.loading ? r.LoaderStatus.LOADING : r.LoaderStatus.INITIALIZED;
      }
      get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
      }
      createUrl() {
        let d = this.url;
        return d += "?callback=__googleMapsCallback&loading=async", this.apiKey && (d += `&key=${this.apiKey}`), this.channel && (d += `&channel=${this.channel}`), this.client && (d += `&client=${this.client}`), this.libraries.length > 0 && (d += `&libraries=${this.libraries.join(",")}`), this.language && (d += `&language=${this.language}`), this.region && (d += `&region=${this.region}`), this.version && (d += `&v=${this.version}`), this.mapIds && (d += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (d += `&auth_referrer_policy=${this.authReferrerPolicy}`), d;
      }
      deleteScript() {
        const d = document.getElementById(this.id);
        d && d.remove();
      }
      load() {
        return this.loadPromise();
      }
      loadPromise() {
        return new Promise((d, f) => {
          this.loadCallback((c) => {
            c ? f(c.error) : d(window.google);
          });
        });
      }
      importLibrary(d) {
        return this.execute(), google.maps.importLibrary(d);
      }
      loadCallback(d) {
        this.callbacks.push(d), this.execute();
      }
      setScript() {
        var d, f;
        if (document.getElementById(this.id))
          return void this.callback();
        const c = { key: this.apiKey, channel: this.channel, client: this.client, libraries: this.libraries.length && this.libraries, v: this.version, mapIds: this.mapIds, language: this.language, region: this.region, authReferrerPolicy: this.authReferrerPolicy };
        Object.keys(c).forEach((v) => !c[v] && delete c[v]), !((f = (d = window == null ? void 0 : window.google) === null || d === void 0 ? void 0 : d.maps) === null || f === void 0) && f.importLibrary || ((v) => {
          let h, g, m, b = "The Google Maps JavaScript API", y = "google", _ = "importLibrary", x = "__ib__", w = document, k = window;
          k = k[y] || (k[y] = {});
          const S = k.maps || (k.maps = {}), P = /* @__PURE__ */ new Set(), A = new URLSearchParams(), E = () => h || (h = new Promise((O, T) => a(this, void 0, void 0, function* () {
            var D;
            for (m in yield g = w.createElement("script"), g.id = this.id, A.set("libraries", [...P] + ""), v)
              A.set(m.replace(/[A-Z]/g, ($) => "_" + $[0].toLowerCase()), v[m]);
            A.set("callback", y + ".maps." + x), g.src = this.url + "?" + A, S[x] = O, g.onerror = () => h = T(Error(b + " could not load.")), g.nonce = this.nonce || ((D = w.querySelector("script[nonce]")) === null || D === void 0 ? void 0 : D.nonce) || "", w.head.append(g);
          })));
          S[_] ? console.warn(b + " only loads once. Ignoring:", v) : S[_] = function(O) {
            for (var T = arguments.length, D = new Array(T > 1 ? T - 1 : 0), $ = 1; $ < T; $++)
              D[$ - 1] = arguments[$];
            return P.add(O) && E().then(() => S[_](O, ...D));
          };
        })(c);
        const p = this.libraries.map((v) => this.importLibrary(v));
        p.length || p.push(this.importLibrary("core")), Promise.all(p).then(() => this.callback(), (v) => {
          const h = new ErrorEvent("error", { error: v });
          this.loadErrorCallback(h);
        });
      }
      reset() {
        this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
      }
      resetIfRetryingFailed() {
        this.failed && this.reset();
      }
      loadErrorCallback(d) {
        if (this.errors.push(d), this.errors.length <= this.retries) {
          const f = this.errors.length * Math.pow(2, this.errors.length);
          console.error(`Failed to load Google Maps script, retrying in ${f} ms.`), setTimeout(() => {
            this.deleteScript(), this.setScript();
          }, f);
        } else
          this.onerrorEvent = d, this.callback();
      }
      callback() {
        this.done = !0, this.loading = !1, this.callbacks.forEach((d) => {
          d(this.onerrorEvent);
        }), this.callbacks = [];
      }
      execute() {
        if (this.resetIfRetryingFailed(), this.done)
          this.callback();
        else {
          if (window.google && window.google.maps && window.google.maps.version)
            return console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), void this.callback();
          this.loading || (this.loading = !0, this.setScript());
        }
      }
    }
    r.DEFAULT_ID = s, r.Loader = l;
  });
})(Q0, Q0.exports);
var XH = Q0.exports;
let KH = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", JH = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += KH[Math.random() * 64 | 0];
  return t;
};
const Noe = /* @__PURE__ */ Ae({
  __name: "JMap",
  props: {
    apiKey: {},
    zoom: { default: 15 },
    markers: { default: () => [] },
    height: { default: 500 }
  },
  setup(e) {
    const t = e, r = ir(), a = ne(), n = N(() => ({
      mapId: JH(),
      center: t.markers.length ? t.markers[0].position : void 0,
      zoom: t.zoom,
      mapTypeControl: !1,
      streetViewControl: !1,
      zoomControl: !1,
      fullscreenControl: !1,
      gestureHandling: "greedy",
      styles: [
        {
          featureType: "poi.business",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "landscape",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }]
        }
      ]
    })), i = new XH.Loader({
      apiKey: t.apiKey
    });
    async function s() {
      if (!a.value)
        return;
      const { Map: l } = await i.importLibrary("maps");
      r.value = new l(a.value, n.value), await o();
    }
    async function o() {
      var f;
      const { AdvancedMarkerElement: l } = await i.importLibrary("marker"), u = new google.maps.InfoWindow(), d = new google.maps.LatLngBounds();
      t.markers.forEach(
        ({
          position: c,
          onClick: p,
          customInfoWindow: v,
          onInfoWindowClick: h,
          icon: g,
          ...m
        }) => {
          let b = null;
          g && (b = document.createElement("img"), b.setAttribute("src", g), b.setAttribute("alt", "marker"));
          const y = new l({
            map: r.value,
            position: c,
            ...g && b ? { content: b } : {},
            ...m
          });
          if (p && y.addListener("click", p), !(c != null && c.lat) || !(c != null && c.lng))
            return;
          const _ = typeof c.lat == "function" ? c.lat() : c.lat, x = typeof c.lng == "function" ? c.lng() : c.lng, w = new google.maps.LatLng(_, x);
          d.extend(w), v && y.content && (y.content.addEventListener("mouseover", () => {
            const k = "custom-info-window";
            u.setContent(
              `<div class="${k}">${v}</div>`
            ), u.open(r.value, y), google.maps.event.addListenerOnce(u, "domready", () => {
              const S = document.querySelector(`.${k}`);
              S && h && S.addEventListener("click", () => {
                h();
              });
            });
          }), y.content.addEventListener("mouseout", () => {
            u.close();
          })), y.map = r.value;
        }
      ), (f = r.value) == null || f.fitBounds(d);
    }
    return q4(() => {
      !t.markers || !t.markers.length || s();
    }), ct(() => {
      window.addEventListener("resize", async () => {
        r.value ? google.maps.event.trigger(r.value, "resize") : await s();
      });
    }), (l, u) => (R(), K("div", null, [
      ue("div", {
        ref_key: "mapRef",
        ref: a,
        class: "w-full",
        style: Ir({ height: `${l.height}px` })
      }, null, 4)
    ]));
  }
});
const QH = {
  key: 0,
  class: "border-b border-gray-300"
}, ZH = { class: "flex items-center justify-between px-12 py-8" }, eV = { class: "whitespace-nowrap font-semi-bold text-secondary" }, tV = { class: "whitespace-nowrap text-gray-500" }, rV = {
  key: 0,
  class: "flex items-center justify-between whitespace-nowrap border-b border-disabled px-16 pb-8 font-semi-bold text-secondary"
}, aV = "right", $oe = /* @__PURE__ */ Ae({
  __name: "JMenu",
  props: {
    modelValue: {},
    options: {},
    title: {},
    icon: {},
    fullScreen: { type: Boolean, default: !1 },
    position: {},
    preventClose: { type: Boolean, default: !1 },
    isSortMenu: { type: Boolean, default: !1 },
    sortOrder: { default: "ascending" },
    disableBottomSheet: { type: Boolean, default: !1 },
    optionClass: {},
    excludeClickOutside: { default: () => [] },
    hasPopstate: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "update:sortOrder"],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, i = ne(null), s = ne(!1), { isMobile: o } = pT(), { getNewZIndex: l } = pu();
    function u() {
      s.value = !s.value;
    }
    function d() {
      a.preventClose || u();
    }
    function f(h) {
      s.value = !1, h.stopPropagation();
    }
    const c = $r(a, "modelValue", n), p = $r(a, "sortOrder", n);
    function v() {
      p.value = p.value === "ascending" ? "descending" : "ascending", d();
    }
    return du(i, f, {
      ignore: a.excludeClickOutside
    }), t({
      toggleMenu: u
    }), (h, g) => (R(), Le(U(LA), Mt({
      modelValue: U(c),
      "onUpdate:modelValue": g[1] || (g[1] = (m) => _a(c) ? c.value = m : null)
    }, h.$attrs, {
      as: "div",
      class: "relative h-full"
    }), {
      default: Pe(() => [
        Fe(U(Hu), {
          class: "h-full w-full",
          onClick: u
        }, {
          default: Pe(() => [
            h.icon ? (R(), Le(gt, {
              key: 0,
              name: h.icon
            }, null, 8, ["name"])) : ke(h.$slots, "menuButton", {
              key: 1,
              isOpen: s.value
            })
          ]),
          _: 3
        }),
        Fe(Hn, {
          enterActiveClass: "transition duration-100 ease-out",
          enterFromClass: "transform scale-95 opacity-0",
          enterToClass: "transform scale-100 opacity-100",
          leaveActiveClass: "transition duration-75 ease-in",
          leaveFromClass: "transform scale-100 opacity-100",
          leaveToClass: "transform scale-95 opacity-0"
        }, {
          default: Pe(() => {
            var m;
            return [
              (!U(o) || h.disableBottomSheet) && s.value ? (R(), K("div", {
                key: 0,
                ref_key: "optionsRef",
                ref: i,
                class: pe([
                  "absolute divide-gray-100 rounded-md bg-white object-fill shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                  h.position === aV ? "ltr:left-0 rtl:right-0" : "ltr:right-0 rtl:left-0"
                ]),
                style: Ir({ zIndex: U(l)() })
              }, [
                h.title ? (R(), K("div", QH, [
                  ue("div", ZH, [
                    h.isSortMenu ? (R(), K(Qe, { key: 0 }, [
                      ue("div", eV, Ie((m = h.modelValue) == null ? void 0 : m.text), 1),
                      Fe(U(Hu), {
                        class: "inline-flex",
                        onClick: v
                      }, {
                        default: Pe(() => [
                          Fe(gt, {
                            name: "alt-arrow-down-filled",
                            size: "12",
                            class: pe([
                              "cursor-pointer text-secondary",
                              U(p) === "ascending" ? "rotate-0" : "rotate-180"
                            ])
                          }, null, 8, ["class"])
                        ]),
                        _: 1
                      })
                    ], 64)) : (R(), K(Qe, { key: 1 }, [
                      ue("div", tV, Ie(h.title), 1),
                      Fe(U(Hu), {
                        class: "inline-flex",
                        onClick: u
                      }, {
                        default: Pe(() => [
                          Fe(gt, {
                            name: "close",
                            class: "cursor-pointer text-danger"
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  ])
                ])) : fe("", !0),
                ke(h.$slots, "description"),
                Fe(U(__), { static: "" }, {
                  default: Pe(() => [
                    (R(!0), K(Qe, null, kt(h.options, (b, y) => (R(), Le(U(x_), {
                      key: b.id,
                      value: b,
                      as: "li",
                      class: pe([[
                        h.optionClass,
                        { "hover:rounded-b-md": y === h.options.length - 1 },
                        { "hover:rounded-t-md": y === 0 && !h.title }
                      ], "cursor-pointer px-12 hover:bg-gray-200"]),
                      onClick: d
                    }, {
                      default: Pe(({ selected: _ }) => [
                        ke(h.$slots, "listItem", {
                          selectedItem: _,
                          menuItem: b,
                          changeOpenState: u
                        })
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))), 128))
                  ]),
                  _: 3
                })
              ], 6)) : fe("", !0)
            ];
          }),
          _: 3
        }),
        U(o) && !h.disableBottomSheet ? (R(), Le(GD, {
          key: 0,
          modelValue: s.value,
          "onUpdate:modelValue": g[0] || (g[0] = (m) => s.value = m),
          fullScreen: h.fullScreen,
          hasPopstate: h.hasPopstate,
          backgroundColor: h.fullScreen ? "gray-100" : "white"
        }, {
          header: Pe(() => [
            ke(h.$slots, "mobileHeader", { changeOpenState: u })
          ]),
          default: Pe(() => {
            var m;
            return [
              h.isSortMenu ? (R(), K("div", rV, [
                jt(Ie((m = h.modelValue) == null ? void 0 : m.text) + " ", 1),
                Fe(U(Hu), {
                  class: "inline-flex",
                  onClick: v
                }, {
                  default: Pe(() => [
                    Fe(gt, {
                      name: "alt-arrow-down-filled",
                      size: "12",
                      class: pe([
                        "cursor-pointer text-secondary",
                        U(p) === "ascending" ? "rotate-0" : "rotate-180"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                })
              ])) : fe("", !0),
              Fe(U(__), { static: "" }, {
                default: Pe(() => [
                  (R(!0), K(Qe, null, kt(h.options, (b) => (R(), Le(U(x_), {
                    key: b.id,
                    value: b,
                    as: "li",
                    class: "cursor-pointer",
                    onClick: d
                  }, {
                    default: Pe(({ selected: y }) => [
                      ke(h.$slots, "listItem", {
                        selectedItem: y,
                        menuItem: b,
                        changeOpenState: u
                      })
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 3
              })
            ];
          }),
          _: 3
        }, 8, ["modelValue", "fullScreen", "hasPopstate", "backgroundColor"])) : fe("", !0)
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), nV = { class: "flex select-none items-stretch justify-between px-16 py-8 lg:px-0" }, iV = {
  key: 0,
  class: "flex items-center justify-start whitespace-nowrap pt-2 ltr:mr-40 rtl:ml-40"
}, sV = { class: "ltr:mr-8 rtl:ml-8" }, oV = {
  key: 1,
  class: "flex px-4 ltr:ml-12 rtl:mr-12"
}, Loe = /* @__PURE__ */ Ae({
  __name: "JMenuItem",
  props: {
    option: {},
    title: {},
    selectedItem: { type: Boolean }
  },
  setup(e) {
    const t = Vn(), r = t("title"), a = t("item");
    return (n, i) => (R(), K("div", nV, [
      U(a) ? fe("", !0) : (R(), K("div", iV, [
        ue("div", sV, [
          ke(n.$slots, "prependItem")
        ]),
        U(r) ? fe("", !0) : (R(), K("span", {
          key: 0,
          class: pe({ "font-bold text-secondary": n.selectedItem })
        }, Ie(n.title), 3)),
        ke(n.$slots, "title")
      ])),
      U(a) ? fe("", !0) : (R(), K("div", oV, [
        ke(n.$slots, "appendItem")
      ])),
      ke(n.$slots, "item")
    ]));
  }
}), lV = {
  xs: "w-full sm:w-1/3 md:w-1/4",
  sm: "w-full sm:w-1/2 md:w-1/3",
  md: "w-full sm:w-3/4 md:w-1/2 ",
  lg: "w-full sm:w-4/5 md:w-3/4 ",
  xl: "w-full sm:w-11/12"
}, uV = {
  key: 0,
  class: "-mx-32"
}, dV = {
  key: 1,
  class: "relative"
}, cV = {
  key: 0,
  class: "text-subject font-bold text-primary"
}, fV = { class: "absolute end-2 top-0 inline-flex gap-10" }, pV = /* @__PURE__ */ ue("span", {
  tabindex: "0",
  "data-initital-focus": ""
}, null, -1), vV = /* @__PURE__ */ Ae({
  __name: "JModal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: {},
    noBody: { type: Boolean, default: !1 },
    size: { default: "md" },
    persistent: { type: Boolean, default: !1 },
    center: { type: Boolean, default: !1 },
    contentClass: { default: "" },
    overlayClass: { default: "" },
    overflowVisible: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = ne(), i = ne(), s = $r(r, "modelValue", a), { isOnTop: o, zIndex: l } = G1({
      type: "modal",
      isOpen: s
    });
    He(o, async () => {
      var c, p, v, h;
      if (o.value) {
        await Pt(), (p = (c = document.activeElement) == null ? void 0 : c.blur) == null || p.call(c);
        const g = (v = i.value) == null ? void 0 : v.querySelector(
          "span[data-initital-focus]"
        );
        (h = g == null ? void 0 : g.focus) == null || h.call(g);
      }
    });
    const u = N(() => lV[r.size]), d = () => s.value = !1;
    function f() {
      !o.value || r.persistent || d();
    }
    return (c, p) => (R(), Le(U(ab), {
      appear: "",
      show: U(s),
      as: "template",
      initialFocus: n.value
    }, {
      default: Pe(() => [
        Fe(U(J1), {
          ref_key: "dialog",
          ref: n,
          onClose: f
        }, {
          default: Pe(() => [
            Fe(U(zl), {
              as: "template",
              enter: "duration-300 ease-out",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "duration-200 ease-in",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0"
            }, {
              default: Pe(() => [
                Fe(Qd, {
                  class: pe([c.overlayClass]),
                  style: Ir({ zIndex: U(l) })
                }, null, 8, ["class", "style"])
              ]),
              _: 1
            }),
            ue("div", {
              ref_key: "content",
              ref: i,
              class: pe(["popup-right-0 fixed inset-0 left-0 right-0 overflow-y-auto", [c.contentClass, c.center && "flex items-center justify-center"]]),
              style: Ir({ zIndex: U(l) })
            }, [
              ue("div", {
                class: pe(["flex min-w-[36rem] max-w-[95%] items-center justify-center px-24 sm:px-0", [
                  u.value,
                  !c.center && "absolute left-1/2 top-0 mt-60 -translate-x-1/2 "
                ]])
              }, [
                Fe(U(zl), {
                  as: "template",
                  enter: "duration-300 ease-out",
                  enterFrom: "opacity-0 scale-95",
                  enterTo: "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  leaveFrom: "opacity-100 scale-100",
                  leaveTo: "opacity-0 scale-95"
                }, {
                  default: Pe(() => [
                    Fe(U(Q1), {
                      class: pe(["max-h-[90vh] w-full rounded-md bg-white pt-16", [
                        c.overflowVisible ? "overflow-y-visible" : "overflow-y-auto"
                      ]])
                    }, {
                      default: Pe(() => [
                        Fe(U(hS), { class: "mb-16 px-32 text-center" }, {
                          default: Pe(() => [
                            c.$slots.header ? (R(), K("div", uV, [
                              ke(c.$slots, "header")
                            ])) : (R(), K("div", dV, [
                              c.title ? (R(), K("div", cV, Ie(c.title), 1)) : fe("", !0),
                              ue("div", fV, [
                                ke(c.$slots, "navigation"),
                                c.showClose ? (R(), K("button", {
                                  key: 0,
                                  class: "cursor-pointer text-gray-600",
                                  onClick: d
                                }, [
                                  Fe(gt, { name: "close" })
                                ])) : fe("", !0)
                              ])
                            ]))
                          ]),
                          _: 3
                        }),
                        ue("div", {
                          class: pe([!c.noBody && "px-32"])
                        }, [
                          ke(c.$slots, "description"),
                          ke(c.$slots, "default")
                        ], 2),
                        pV
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ], 2)
            ], 6)
          ]),
          _: 3
        }, 512)
      ]),
      _: 3
    }, 8, ["show", "initialFocus"]));
  }
});
function mV() {
  this.__data__ = [], this.size = 0;
}
var hV = mV;
function gV(e, t) {
  return e === t || e !== e && t !== t;
}
var hO = gV, bV = hO;
function yV(e, t) {
  for (var r = e.length; r--; )
    if (bV(e[r][0], t))
      return r;
  return -1;
}
var zc = yV, _V = zc, xV = Array.prototype, wV = xV.splice;
function TV(e) {
  var t = this.__data__, r = _V(t, e);
  if (r < 0)
    return !1;
  var a = t.length - 1;
  return r == a ? t.pop() : wV.call(t, r, 1), --this.size, !0;
}
var SV = TV, EV = zc;
function OV(e) {
  var t = this.__data__, r = EV(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var CV = OV, kV = zc;
function PV(e) {
  return kV(this.__data__, e) > -1;
}
var MV = PV, AV = zc;
function DV(e, t) {
  var r = this.__data__, a = AV(r, e);
  return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
}
var IV = DV, NV = hV, $V = SV, LV = CV, RV = MV, jV = IV;
function nl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
nl.prototype.clear = NV;
nl.prototype.delete = $V;
nl.prototype.get = LV;
nl.prototype.has = RV;
nl.prototype.set = jV;
var Yc = nl, FV = Yc;
function BV() {
  this.__data__ = new FV(), this.size = 0;
}
var qV = BV;
function HV(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var VV = HV;
function UV(e) {
  return this.__data__.get(e);
}
var zV = UV;
function YV(e) {
  return this.__data__.has(e);
}
var WV = YV, GV = typeof Ba == "object" && Ba && Ba.Object === Object && Ba, gO = GV, XV = gO, KV = typeof self == "object" && self && self.Object === Object && self, JV = XV || KV || Function("return this")(), Ri = JV, QV = Ri, ZV = QV.Symbol, Lb = ZV, g2 = Lb, bO = Object.prototype, eU = bO.hasOwnProperty, tU = bO.toString, Tl = g2 ? g2.toStringTag : void 0;
function rU(e) {
  var t = eU.call(e, Tl), r = e[Tl];
  try {
    e[Tl] = void 0;
    var a = !0;
  } catch {
  }
  var n = tU.call(e);
  return a && (t ? e[Tl] = r : delete e[Tl]), n;
}
var aU = rU, nU = Object.prototype, iU = nU.toString;
function sU(e) {
  return iU.call(e);
}
var oU = sU, b2 = Lb, lU = aU, uU = oU, dU = "[object Null]", cU = "[object Undefined]", y2 = b2 ? b2.toStringTag : void 0;
function fU(e) {
  return e == null ? e === void 0 ? cU : dU : y2 && y2 in Object(e) ? lU(e) : uU(e);
}
var Wc = fU;
function pU(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var yO = pU, vU = Wc, mU = yO, hU = "[object AsyncFunction]", gU = "[object Function]", bU = "[object GeneratorFunction]", yU = "[object Proxy]";
function _U(e) {
  if (!mU(e))
    return !1;
  var t = vU(e);
  return t == gU || t == bU || t == hU || t == yU;
}
var _O = _U, xU = Ri, wU = xU["__core-js_shared__"], TU = wU, Kf = TU, _2 = function() {
  var e = /[^.]+$/.exec(Kf && Kf.keys && Kf.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function SU(e) {
  return !!_2 && _2 in e;
}
var EU = SU, OU = Function.prototype, CU = OU.toString;
function kU(e) {
  if (e != null) {
    try {
      return CU.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var xO = kU, PU = _O, MU = EU, AU = yO, DU = xO, IU = /[\\^$.*+?()[\]{}|]/g, NU = /^\[object .+?Constructor\]$/, $U = Function.prototype, LU = Object.prototype, RU = $U.toString, jU = LU.hasOwnProperty, FU = RegExp(
  "^" + RU.call(jU).replace(IU, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BU(e) {
  if (!AU(e) || MU(e))
    return !1;
  var t = PU(e) ? FU : NU;
  return t.test(DU(e));
}
var qU = BU;
function HU(e, t) {
  return e == null ? void 0 : e[t];
}
var VU = HU, UU = qU, zU = VU;
function YU(e, t) {
  var r = zU(e, t);
  return UU(r) ? r : void 0;
}
var il = YU, WU = il, GU = Ri, XU = WU(GU, "Map"), Rb = XU, KU = il, JU = KU(Object, "create"), Gc = JU, x2 = Gc;
function QU() {
  this.__data__ = x2 ? x2(null) : {}, this.size = 0;
}
var ZU = QU;
function ez(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var tz = ez, rz = Gc, az = "__lodash_hash_undefined__", nz = Object.prototype, iz = nz.hasOwnProperty;
function sz(e) {
  var t = this.__data__;
  if (rz) {
    var r = t[e];
    return r === az ? void 0 : r;
  }
  return iz.call(t, e) ? t[e] : void 0;
}
var oz = sz, lz = Gc, uz = Object.prototype, dz = uz.hasOwnProperty;
function cz(e) {
  var t = this.__data__;
  return lz ? t[e] !== void 0 : dz.call(t, e);
}
var fz = cz, pz = Gc, vz = "__lodash_hash_undefined__";
function mz(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = pz && t === void 0 ? vz : t, this;
}
var hz = mz, gz = ZU, bz = tz, yz = oz, _z = fz, xz = hz;
function sl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
sl.prototype.clear = gz;
sl.prototype.delete = bz;
sl.prototype.get = yz;
sl.prototype.has = _z;
sl.prototype.set = xz;
var wz = sl, w2 = wz, Tz = Yc, Sz = Rb;
function Ez() {
  this.size = 0, this.__data__ = {
    hash: new w2(),
    map: new (Sz || Tz)(),
    string: new w2()
  };
}
var Oz = Ez;
function Cz(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var kz = Cz, Pz = kz;
function Mz(e, t) {
  var r = e.__data__;
  return Pz(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Xc = Mz, Az = Xc;
function Dz(e) {
  var t = Az(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Iz = Dz, Nz = Xc;
function $z(e) {
  return Nz(this, e).get(e);
}
var Lz = $z, Rz = Xc;
function jz(e) {
  return Rz(this, e).has(e);
}
var Fz = jz, Bz = Xc;
function qz(e, t) {
  var r = Bz(this, e), a = r.size;
  return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
}
var Hz = qz, Vz = Oz, Uz = Iz, zz = Lz, Yz = Fz, Wz = Hz;
function ol(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
ol.prototype.clear = Vz;
ol.prototype.delete = Uz;
ol.prototype.get = zz;
ol.prototype.has = Yz;
ol.prototype.set = Wz;
var wO = ol, Gz = Yc, Xz = Rb, Kz = wO, Jz = 200;
function Qz(e, t) {
  var r = this.__data__;
  if (r instanceof Gz) {
    var a = r.__data__;
    if (!Xz || a.length < Jz - 1)
      return a.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Kz(a);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Zz = Qz, eY = Yc, tY = qV, rY = VV, aY = zV, nY = WV, iY = Zz;
function ll(e) {
  var t = this.__data__ = new eY(e);
  this.size = t.size;
}
ll.prototype.clear = tY;
ll.prototype.delete = rY;
ll.prototype.get = aY;
ll.prototype.has = nY;
ll.prototype.set = iY;
var sY = ll, oY = "__lodash_hash_undefined__";
function lY(e) {
  return this.__data__.set(e, oY), this;
}
var uY = lY;
function dY(e) {
  return this.__data__.has(e);
}
var cY = dY, fY = wO, pY = uY, vY = cY;
function Od(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new fY(); ++t < r; )
    this.add(e[t]);
}
Od.prototype.add = Od.prototype.push = pY;
Od.prototype.has = vY;
var mY = Od;
function hY(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length; ++r < a; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var gY = hY;
function bY(e, t) {
  return e.has(t);
}
var yY = bY, _Y = mY, xY = gY, wY = yY, TY = 1, SY = 2;
function EY(e, t, r, a, n, i) {
  var s = r & TY, o = e.length, l = t.length;
  if (o != l && !(s && l > o))
    return !1;
  var u = i.get(e), d = i.get(t);
  if (u && d)
    return u == t && d == e;
  var f = -1, c = !0, p = r & SY ? new _Y() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < o; ) {
    var v = e[f], h = t[f];
    if (a)
      var g = s ? a(h, v, f, t, e, i) : a(v, h, f, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      c = !1;
      break;
    }
    if (p) {
      if (!xY(t, function(m, b) {
        if (!wY(p, b) && (v === m || n(v, m, r, a, i)))
          return p.push(b);
      })) {
        c = !1;
        break;
      }
    } else if (!(v === h || n(v, h, r, a, i))) {
      c = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), c;
}
var TO = EY, OY = Ri, CY = OY.Uint8Array, kY = CY;
function PY(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a, n) {
    r[++t] = [n, a];
  }), r;
}
var MY = PY;
function AY(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a) {
    r[++t] = a;
  }), r;
}
var DY = AY, T2 = Lb, S2 = kY, IY = hO, NY = TO, $Y = MY, LY = DY, RY = 1, jY = 2, FY = "[object Boolean]", BY = "[object Date]", qY = "[object Error]", HY = "[object Map]", VY = "[object Number]", UY = "[object RegExp]", zY = "[object Set]", YY = "[object String]", WY = "[object Symbol]", GY = "[object ArrayBuffer]", XY = "[object DataView]", E2 = T2 ? T2.prototype : void 0, Jf = E2 ? E2.valueOf : void 0;
function KY(e, t, r, a, n, i, s) {
  switch (r) {
    case XY:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case GY:
      return !(e.byteLength != t.byteLength || !i(new S2(e), new S2(t)));
    case FY:
    case BY:
    case VY:
      return IY(+e, +t);
    case qY:
      return e.name == t.name && e.message == t.message;
    case UY:
    case YY:
      return e == t + "";
    case HY:
      var o = $Y;
    case zY:
      var l = a & RY;
      if (o || (o = LY), e.size != t.size && !l)
        return !1;
      var u = s.get(e);
      if (u)
        return u == t;
      a |= jY, s.set(e, t);
      var d = NY(o(e), o(t), a, n, i, s);
      return s.delete(e), d;
    case WY:
      if (Jf)
        return Jf.call(e) == Jf.call(t);
  }
  return !1;
}
var JY = KY;
function QY(e, t) {
  for (var r = -1, a = t.length, n = e.length; ++r < a; )
    e[n + r] = t[r];
  return e;
}
var ZY = QY, eW = Array.isArray, jb = eW, tW = ZY, rW = jb;
function aW(e, t, r) {
  var a = t(e);
  return rW(e) ? a : tW(a, r(e));
}
var nW = aW;
function iW(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length, n = 0, i = []; ++r < a; ) {
    var s = e[r];
    t(s, r, e) && (i[n++] = s);
  }
  return i;
}
var sW = iW;
function oW() {
  return [];
}
var lW = oW, uW = sW, dW = lW, cW = Object.prototype, fW = cW.propertyIsEnumerable, O2 = Object.getOwnPropertySymbols, pW = O2 ? function(e) {
  return e == null ? [] : (e = Object(e), uW(O2(e), function(t) {
    return fW.call(e, t);
  }));
} : dW, vW = pW;
function mW(e, t) {
  for (var r = -1, a = Array(e); ++r < e; )
    a[r] = t(r);
  return a;
}
var hW = mW;
function gW(e) {
  return e != null && typeof e == "object";
}
var Kc = gW, bW = Wc, yW = Kc, _W = "[object Arguments]";
function xW(e) {
  return yW(e) && bW(e) == _W;
}
var wW = xW, C2 = wW, TW = Kc, SO = Object.prototype, SW = SO.hasOwnProperty, EW = SO.propertyIsEnumerable, OW = C2(function() {
  return arguments;
}()) ? C2 : function(e) {
  return TW(e) && SW.call(e, "callee") && !EW.call(e, "callee");
}, CW = OW, Cd = { exports: {} };
function kW() {
  return !1;
}
var PW = kW;
Cd.exports;
(function(e, t) {
  var r = Ri, a = PW, n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, s = i && i.exports === n, o = s ? r.Buffer : void 0, l = o ? o.isBuffer : void 0, u = l || a;
  e.exports = u;
})(Cd, Cd.exports);
var EO = Cd.exports, MW = 9007199254740991, AW = /^(?:0|[1-9]\d*)$/;
function DW(e, t) {
  var r = typeof e;
  return t = t ?? MW, !!t && (r == "number" || r != "symbol" && AW.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var IW = DW, NW = 9007199254740991;
function $W(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= NW;
}
var OO = $W, LW = Wc, RW = OO, jW = Kc, FW = "[object Arguments]", BW = "[object Array]", qW = "[object Boolean]", HW = "[object Date]", VW = "[object Error]", UW = "[object Function]", zW = "[object Map]", YW = "[object Number]", WW = "[object Object]", GW = "[object RegExp]", XW = "[object Set]", KW = "[object String]", JW = "[object WeakMap]", QW = "[object ArrayBuffer]", ZW = "[object DataView]", eG = "[object Float32Array]", tG = "[object Float64Array]", rG = "[object Int8Array]", aG = "[object Int16Array]", nG = "[object Int32Array]", iG = "[object Uint8Array]", sG = "[object Uint8ClampedArray]", oG = "[object Uint16Array]", lG = "[object Uint32Array]", _r = {};
_r[eG] = _r[tG] = _r[rG] = _r[aG] = _r[nG] = _r[iG] = _r[sG] = _r[oG] = _r[lG] = !0;
_r[FW] = _r[BW] = _r[QW] = _r[qW] = _r[ZW] = _r[HW] = _r[VW] = _r[UW] = _r[zW] = _r[YW] = _r[WW] = _r[GW] = _r[XW] = _r[KW] = _r[JW] = !1;
function uG(e) {
  return jW(e) && RW(e.length) && !!_r[LW(e)];
}
var dG = uG;
function cG(e) {
  return function(t) {
    return e(t);
  };
}
var fG = cG, kd = { exports: {} };
kd.exports;
(function(e, t) {
  var r = gO, a = t && !t.nodeType && t, n = a && !0 && e && !e.nodeType && e, i = n && n.exports === a, s = i && r.process, o = function() {
    try {
      var l = n && n.require && n.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(kd, kd.exports);
var pG = kd.exports, vG = dG, mG = fG, k2 = pG, P2 = k2 && k2.isTypedArray, hG = P2 ? mG(P2) : vG, CO = hG, gG = hW, bG = CW, yG = jb, _G = EO, xG = IW, wG = CO, TG = Object.prototype, SG = TG.hasOwnProperty;
function EG(e, t) {
  var r = yG(e), a = !r && bG(e), n = !r && !a && _G(e), i = !r && !a && !n && wG(e), s = r || a || n || i, o = s ? gG(e.length, String) : [], l = o.length;
  for (var u in e)
    (t || SG.call(e, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    xG(u, l))) && o.push(u);
  return o;
}
var OG = EG, CG = Object.prototype;
function kG(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || CG;
  return e === r;
}
var PG = kG;
function MG(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var AG = MG, DG = AG, IG = DG(Object.keys, Object), NG = IG, $G = PG, LG = NG, RG = Object.prototype, jG = RG.hasOwnProperty;
function FG(e) {
  if (!$G(e))
    return LG(e);
  var t = [];
  for (var r in Object(e))
    jG.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var BG = FG, qG = _O, HG = OO;
function VG(e) {
  return e != null && HG(e.length) && !qG(e);
}
var UG = VG, zG = OG, YG = BG, WG = UG;
function GG(e) {
  return WG(e) ? zG(e) : YG(e);
}
var XG = GG, KG = nW, JG = vW, QG = XG;
function ZG(e) {
  return KG(e, QG, JG);
}
var eX = ZG, M2 = eX, tX = 1, rX = Object.prototype, aX = rX.hasOwnProperty;
function nX(e, t, r, a, n, i) {
  var s = r & tX, o = M2(e), l = o.length, u = M2(t), d = u.length;
  if (l != d && !s)
    return !1;
  for (var f = l; f--; ) {
    var c = o[f];
    if (!(s ? c in t : aX.call(t, c)))
      return !1;
  }
  var p = i.get(e), v = i.get(t);
  if (p && v)
    return p == t && v == e;
  var h = !0;
  i.set(e, t), i.set(t, e);
  for (var g = s; ++f < l; ) {
    c = o[f];
    var m = e[c], b = t[c];
    if (a)
      var y = s ? a(b, m, c, t, e, i) : a(m, b, c, e, t, i);
    if (!(y === void 0 ? m === b || n(m, b, r, a, i) : y)) {
      h = !1;
      break;
    }
    g || (g = c == "constructor");
  }
  if (h && !g) {
    var _ = e.constructor, x = t.constructor;
    _ != x && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof x == "function" && x instanceof x) && (h = !1);
  }
  return i.delete(e), i.delete(t), h;
}
var iX = nX, sX = il, oX = Ri, lX = sX(oX, "DataView"), uX = lX, dX = il, cX = Ri, fX = dX(cX, "Promise"), pX = fX, vX = il, mX = Ri, hX = vX(mX, "Set"), gX = hX, bX = il, yX = Ri, _X = bX(yX, "WeakMap"), xX = _X, Z0 = uX, e1 = Rb, t1 = pX, r1 = gX, a1 = xX, kO = Wc, ul = xO, A2 = "[object Map]", wX = "[object Object]", D2 = "[object Promise]", I2 = "[object Set]", N2 = "[object WeakMap]", $2 = "[object DataView]", TX = ul(Z0), SX = ul(e1), EX = ul(t1), OX = ul(r1), CX = ul(a1), xs = kO;
(Z0 && xs(new Z0(new ArrayBuffer(1))) != $2 || e1 && xs(new e1()) != A2 || t1 && xs(t1.resolve()) != D2 || r1 && xs(new r1()) != I2 || a1 && xs(new a1()) != N2) && (xs = function(e) {
  var t = kO(e), r = t == wX ? e.constructor : void 0, a = r ? ul(r) : "";
  if (a)
    switch (a) {
      case TX:
        return $2;
      case SX:
        return A2;
      case EX:
        return D2;
      case OX:
        return I2;
      case CX:
        return N2;
    }
  return t;
});
var kX = xs, Qf = sY, PX = TO, MX = JY, AX = iX, L2 = kX, R2 = jb, j2 = EO, DX = CO, IX = 1, F2 = "[object Arguments]", B2 = "[object Array]", Yu = "[object Object]", NX = Object.prototype, q2 = NX.hasOwnProperty;
function $X(e, t, r, a, n, i) {
  var s = R2(e), o = R2(t), l = s ? B2 : L2(e), u = o ? B2 : L2(t);
  l = l == F2 ? Yu : l, u = u == F2 ? Yu : u;
  var d = l == Yu, f = u == Yu, c = l == u;
  if (c && j2(e)) {
    if (!j2(t))
      return !1;
    s = !0, d = !1;
  }
  if (c && !d)
    return i || (i = new Qf()), s || DX(e) ? PX(e, t, r, a, n, i) : MX(e, t, l, r, a, n, i);
  if (!(r & IX)) {
    var p = d && q2.call(e, "__wrapped__"), v = f && q2.call(t, "__wrapped__");
    if (p || v) {
      var h = p ? e.value() : e, g = v ? t.value() : t;
      return i || (i = new Qf()), n(h, g, r, a, i);
    }
  }
  return c ? (i || (i = new Qf()), AX(e, t, r, a, n, i)) : !1;
}
var LX = $X, RX = LX, H2 = Kc;
function PO(e, t, r, a, n) {
  return e === t ? !0 : e == null || t == null || !H2(e) && !H2(t) ? e !== e && t !== t : RX(e, t, r, a, PO, n);
}
var jX = PO, FX = jX;
function BX(e, t) {
  return FX(e, t);
}
var qX = BX;
const HX = /* @__PURE__ */ Rd(qX), VX = 3, UX = 100, zX = ["aria-disabled"], YX = {
  key: 0,
  class: "flex items-center gap-8 truncate"
}, WX = ["index"], GX = { class: "font-medium text-gray-500" }, XX = ["onClick"], KX = {
  key: 3,
  class: "rounded-sm bg-gray-200 px-4 py-3 font-medium text-gray-500"
}, JX = {
  key: 1,
  class: "text-metadata-limited text-placeholder"
}, QX = ["placeholder", "value"], ZX = {
  key: 0,
  class: "flex items-center justify-center"
}, eK = { class: "font-medium text-gray-500" }, tK = {
  key: 1,
  class: "text-center"
}, rK = { class: "font-medium text-gray-500" }, aK = { key: 2 }, nK = {
  key: 0,
  class: "my-8 px-12"
}, iK = /* @__PURE__ */ ue("span", { class: "block border border-gray-200" }, null, -1), sK = [
  iK
], oK = ["onClick"], lK = { key: 0 }, uK = { class: "font-medium text-gray-500" }, Roe = /* @__PURE__ */ Ae({
  __name: "JMultiSelect",
  props: {
    options: { default: () => [] },
    emitValue: { default: void 0 },
    modelValue: {},
    placeholder: {},
    label: {},
    error: {},
    isLoading: { type: Boolean, default: !1 },
    isLoadingMore: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: {},
    disableFilter: { type: Boolean, default: !1 },
    notFoundText: { default: "No items found!" },
    loadingText: { default: "Searching ..." },
    loadingMoreText: { default: "Loading more ..." },
    teleport: { type: Boolean, default: !0 },
    maxVisibleItems: { default: VX },
    compareFn: {},
    chunkSize: { default: UX },
    optionClass: {}
  },
  emits: ["update:modelValue", "select", "remove", "search", "loadMore"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a), i = Vn(), s = i("option"), o = i("selected"), l = i("remaining-items"), u = Gr(), { getNewZIndex: d } = pu(), f = N(() => u("required", !0)), c = N(() => u("disabled", !0));
    function p(q) {
      return typeof q == "string" ? q : typeof q == "object" && r.emitValue ? q[r.emitValue] : q;
    }
    function v(q) {
      return r.emitValue ? r.options.find(
        (le) => le[r.emitValue] === q
      ) : q;
    }
    function h(q, le) {
      return r.compareFn ? r.compareFn(q, le) : typeof q == "string" && typeof le == "string" ? q === le : HX(q, le);
    }
    function g(q) {
      const le = n.value.splice(q, 1);
      a("remove", le[0]);
    }
    const [m, b] = L1(!1), y = ne(null);
    du(y, () => {
      b(!1);
    }), UT(y, (q) => {
      b(!1), q.preventDefault(), q.stopPropagation();
    });
    const _ = ne(""), x = N(() => r.disableFilter ? r.options : typeof r.options[0] == "string" ? r.options.filter(
      (q) => q.toLowerCase().includes(_.value.toLowerCase())
    ) : r.options.filter(
      (q) => Object.values(q).filter((le) => le !== null).some(
        (le) => le.toString().toLowerCase().includes(_.value.toLowerCase())
      )
    )), w = ne(1), k = N(() => x.value.slice(0, r.chunkSize * w.value));
    function S(q) {
      setTimeout(() => {
        w.value = q;
      }, 0);
    }
    He(m, () => S(1)), He(
      () => x.value.length,
      () => S(1)
    );
    function P(q) {
      const le = q.target, Z = le.scrollTop + le.clientHeight;
      le.scrollHeight - Z < 50 && k.value.length < x.value.length && S(w.value + 1);
    }
    function A(q) {
      if (!r.searchable)
        return;
      const { value: le } = q.target;
      _.value = le, a("search", le);
    }
    const E = N(
      () => n.value.slice(0, r.maxVisibleItems)
    ), O = N(
      () => n.value.length - r.maxVisibleItems
    ), T = ne(null), {
      comboOptionsTop: D,
      comboOptionsTransform: $,
      elementBounding: { left: I, width: F }
    } = W1(T, y, r.teleport), j = N(() => r.teleport ? Oo : "div"), { arrivedState: M } = dT(y);
    return He(
      () => M.bottom,
      (q) => {
        q && a("loadMore");
      }
    ), (q, le) => (R(), K("div", {
      ref_key: "selectRef",
      ref: T,
      class: pe(["relative", { "cursor-not-allowed": c.value }])
    }, [
      Fe(U(iS), {
        modelValue: U(n),
        "onUpdate:modelValue": le[2] || (le[2] = (Z) => _a(n) ? n.value = Z : null),
        multiple: "",
        by: h
      }, {
        default: Pe(() => [
          q.label ? (R(), Le(U(iA), {
            key: 0,
            class: pe(["input__label", {
              "cursor-not-allowed": c.value,
              "input--required": f.value,
              "mb-8 block": !!q.label
            }]),
            onClick: le[0] || (le[0] = (Z) => !c.value && U(b)(!U(m)))
          }, {
            default: Pe(() => [
              jt(Ie(q.label), 1)
            ]),
            _: 1
          }, 8, ["class"])) : fe("", !0),
          ue("div", {
            class: pe(["flex h-40 w-full cursor-pointer items-center rounded-md border px-12 py-8 text-start focus:ring-0", [
              c.value ? "bg-disabled" : "bg-white",
              q.error ? "border-danger" : "border-gray-300",
              { "cursor-not-allowed": c.value }
            ]]),
            "aria-disabled": c.value,
            onClick: le[1] || (le[1] = (Z) => !c.value && U(b)(!U(m)))
          }, [
            U(n).length ? (R(), K("span", YX, [
              U(o) ? (R(!0), K(Qe, { key: 0 }, kt(E.value, (Z, G) => ke(q.$slots, "selected", {
                key: G,
                index: G,
                item: Z
              })), 128)) : (R(!0), K(Qe, { key: 1 }, kt(E.value, (Z, G) => (R(), K("div", {
                key: G,
                index: G,
                class: pe(["group relative flex items-center gap-4 rounded-sm bg-gray-200 px-4 py-3", [c.value ? "cursor-not-allowed" : "cursor-default"]])
              }, [
                ue("span", GX, Ie(v(Z)), 1),
                c.value ? fe("", !0) : (R(), K("button", {
                  key: 0,
                  class: "absolute bottom-0 right-0 top-0 hidden bg-gray-200 group-hover:inline-block",
                  title: "Remove",
                  type: "button",
                  onClick: zr((H) => g(G), ["stop"])
                }, [
                  Fe(U(gt), {
                    name: "close",
                    size: "16"
                  })
                ], 8, XX))
              ], 10, WX))), 128)),
              U(l) && E.value.length === q.maxVisibleItems && O.value > 0 ? ke(q.$slots, "remaining-items", {
                key: 2,
                count: O.value
              }) : E.value.length === q.maxVisibleItems && O.value > 0 ? (R(), K("span", KX, " + " + Ie(O.value), 1)) : fe("", !0)
            ])) : (R(), K("span", JX, Ie(q.placeholder), 1)),
            ue("div", {
              class: pe(["mr-10 flex-1 self-stretch pl-10", {
                "border-r border-gray-300": E.value.length === q.maxVisibleItems
              }])
            }, null, 2),
            q.isLoading ? (R(), Le(U(gt), {
              key: 2,
              class: "text-gray-400",
              "aria-hidden": !q.isLoading,
              name: "spinner"
            }, null, 8, ["aria-hidden"])) : (R(), Le(U(gt), {
              key: 3,
              name: "alt-arrow-down",
              class: pe(["text-gray-400 transition-all", U(m) && "rotate-180"]),
              size: "24"
            }, null, 8, ["class"]))
          ], 10, zX),
          (R(), Le(Za(j.value), jr(oa(q.teleport && { to: "body" })), {
            default: Pe(() => [
              U(m) ? (R(), K("div", {
                key: 0,
                ref_key: "dropdownRef",
                ref: y,
                class: pe(["visible absolute mt-4 max-h-[200px] overflow-y-auto rounded-md border border-gray-300 bg-white text-base transition-transform delay-75 focus:outline-none", !q.teleport && "w-full"]),
                tabindex: "0",
                role: "dialog",
                style: Ir({
                  top: U(D),
                  left: q.teleport ? `${U(I)}px` : 0,
                  width: `${U(F)}px`,
                  transform: U($),
                  zIndex: U(d)()
                }),
                onScroll: P
              }, [
                Fe(U(sS), { static: "" }, {
                  default: Pe(() => [
                    ue("li", {
                      class: pe(["flex items-center gap-8 px-12 py-4", { "h-0": !q.searchable }])
                    }, [
                      Fe(U(gt), {
                        name: "magnifier-outline",
                        class: pe(["text-gray-400", { "h-0": !q.searchable }]),
                        size: "18"
                      }, null, 8, ["class"]),
                      ue("input", {
                        type: "text",
                        placeholder: q.searchPlaceholder,
                        class: pe(["w-full focus:outline-none focus-visible:outline-none", { "h-0": !q.searchable }]),
                        value: _.value,
                        onInput: A
                      }, null, 42, QX)
                    ], 2),
                    q.isLoading ? (R(), K("li", ZX, [
                      Fe(U(gt), {
                        name: "spinner",
                        size: "24"
                      }),
                      ue("span", eK, Ie(q.loadingText), 1)
                    ])) : !x.value.length && !q.isLoadingMore ? (R(), K("li", tK, [
                      ue("span", rK, Ie(q.notFoundText), 1)
                    ])) : (R(), K("ul", aK, [
                      q.searchable ? (R(), K("li", nK, sK)) : fe("", !0),
                      (R(!0), K(Qe, null, kt(k.value, (Z, G) => (R(), Le(U(yd), {
                        key: G,
                        value: p(Z)
                      }, {
                        default: Pe(({ selected: H, active: W }) => [
                          ue("li", {
                            class: pe(["flex items-center justify-between px-16 py-8", [
                              c.value ? "cursor-not-allowed" : "cursor-pointer",
                              {
                                "bg-gray-100": W
                              },
                              q.optionClass
                            ]]),
                            onClick: (ie) => q.$emit("select", Z)
                          }, [
                            ke(q.$slots, "option", {
                              option: Z,
                              selected: H,
                              active: W
                            }, () => [
                              U(s) ? fe("", !0) : (R(), K("span", lK, Ie(Z), 1))
                            ]),
                            Fe(U(TN), {
                              modelValue: H,
                              value: H,
                              name: "MultiSelect",
                              color: H ? "primary" : "gray-600"
                            }, null, 8, ["modelValue", "value", "color"])
                          ], 10, oK)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128)),
                      q.isLoadingMore ? (R(), Le(U(yd), {
                        key: 1,
                        class: "text-gray-700 relative flex cursor-default select-none items-center justify-center px-16 py-8 text-gray-500 hover:bg-gray-200"
                      }, {
                        default: Pe(() => [
                          Fe(U(gt), {
                            class: "flex",
                            name: "spinner"
                          }),
                          ue("span", uK, Ie(q.loadingMoreText), 1)
                        ]),
                        _: 1
                      })) : fe("", !0)
                    ]))
                  ]),
                  _: 3
                })
              ], 38)) : fe("", !0)
            ]),
            _: 3
          }, 16)),
          ea(ue("div", { class: "text-metadata-limited text-danger" }, Ie(q.error), 513), [
            [$a, !U(m)]
          ])
        ]),
        _: 3
      }, 8, ["modelValue"])
    ], 2));
  }
});
var MO = Ae({
  name: "SingleOtpInput",
  props: {
    inputType: {
      type: String,
      validator: (e) => ["number", "tel", "letter-numeric", "password"].includes(e),
      default: "tel"
    },
    inputmode: {
      type: String,
      default: "numeric"
    },
    value: {
      type: [String, Number]
    },
    separator: {
      type: String
    },
    focus: {
      type: Boolean
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: String
    },
    shouldAutoFocus: {
      type: Boolean
    },
    isLastChild: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    isDisabled: {
      type: Boolean
    }
  },
  emits: ["on-change", "on-keydown", "on-paste", "on-focus", "on-blur"],
  setup(e, t) {
    let {
      emit: r
    } = t;
    const a = ne(e.value || ""), n = ne(null), i = () => (a.value = a.value.toString(), a.value.length > 1 && (a.value = a.value.slice(0, 1)), r("on-change", a.value)), s = (c) => c >= 65 && c <= 90, o = (c) => c >= 48 && c <= 57 || c >= 96 && c <= 105, l = (c) => {
      e.isDisabled && c.preventDefault();
      const p = c || window.event, v = p.which ? p.which : p.keyCode;
      o(v) || e.inputType === "letter-numeric" && s(v) || [8, 9, 13, 37, 39, 46, 86].includes(v) ? r("on-keydown", c) : p.preventDefault();
    }, u = (c) => r("on-paste", c), d = () => (n.value.select(), r("on-focus")), f = () => r("on-blur");
    return He(() => e.value, (c, p) => {
      c !== p && (a.value = c);
    }), He(() => e.focus, (c, p) => {
      p !== c && n.value && e.focus && (n.value.focus(), n.value.select());
    }), ct(() => {
      n.value && e.focus && e.shouldAutoFocus && (n.value.focus(), n.value.select());
    }), {
      handleOnChange: i,
      handleOnKeyDown: l,
      handleOnPaste: u,
      handleOnFocus: d,
      handleOnBlur: f,
      input: n,
      model: a,
      inputTypeValue: e.inputType === "letter-numeric" ? "text" : e.inputType
    };
  }
});
const dK = {
  style: {
    display: "flex",
    "align-items": "center"
  }
}, cK = ["type", "inputmode", "placeholder", "disabled"], fK = {
  key: 0
}, pK = ["innerHTML"];
function vK(e, t, r, a, n, i) {
  return R(), K("div", dK, [ea(ue("input", {
    "data-test": "single-input",
    type: e.inputTypeValue,
    inputmode: e.inputmode,
    placeholder: e.placeholder,
    disabled: e.isDisabled,
    ref: "input",
    min: "0",
    max: "9",
    maxlength: "1",
    pattern: "[0-9]",
    "onUpdate:modelValue": t[0] || (t[0] = (s) => e.model = s),
    class: pe([e.inputClasses, e.conditionalClass, {
      "is-complete": e.model
    }]),
    onInput: t[1] || (t[1] = function() {
      return e.handleOnChange && e.handleOnChange(...arguments);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return e.handleOnKeyDown && e.handleOnKeyDown(...arguments);
    }),
    onPaste: t[3] || (t[3] = function() {
      return e.handleOnPaste && e.handleOnPaste(...arguments);
    }),
    onFocus: t[4] || (t[4] = function() {
      return e.handleOnFocus && e.handleOnFocus(...arguments);
    }),
    onBlur: t[5] || (t[5] = function() {
      return e.handleOnBlur && e.handleOnBlur(...arguments);
    })
  }, null, 42, cK), [[sT, e.model]]), !e.isLastChild && e.separator ? (R(), K("span", fK, [ue("span", {
    innerHTML: e.separator
  }, null, 8, pK)])) : fe("", !0)]);
}
MO.render = vK;
const mK = 8, hK = 37, gK = 39, bK = 46;
var AO = /* @__PURE__ */ Ae({
  name: "Vue3OtpInput",
  components: {
    SingleOtpInput: MO
  },
  props: {
    value: {
      type: String,
      default: "",
      required: !0
    },
    numInputs: {
      default: 4
    },
    separator: {
      type: String,
      default: "**"
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: Array,
      default: []
    },
    inputType: {
      type: String,
      validator: (e) => ["number", "tel", "letter-numeric", "password"].includes(e)
    },
    inputmode: {
      type: String,
      validator: (e) => ["numeric", "text", "tel", "none"].includes(e),
      default: "numeric"
    },
    shouldAutoFocus: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: Array,
      default: []
    },
    isDisabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    let {
      emit: r
    } = t;
    const a = ne(0), n = ne([]), i = ne([]);
    He(() => e.value, (b) => {
      const y = U(b).split("");
      n.value = y;
    }, {
      immediate: !0
    });
    const s = (b) => {
      a.value = b;
    }, o = () => {
      a.value = -1;
    }, l = () => n.value.join("").length === e.numInputs ? (r("update:value", n.value.join("")), r("on-complete", n.value.join(""))) : "Wait until the user enters the required number of characters", u = (b) => {
      a.value = Math.max(Math.min(e.numInputs - 1, b), 0);
    }, d = () => {
      u(a.value + 1);
    }, f = () => {
      u(a.value - 1);
    }, c = (b) => {
      i.value = Object.assign([], n.value), n.value[a.value] = b, i.value.join("") !== n.value.join("") && (r("update:value", n.value.join("")), r("on-change", n.value.join("")), l());
    };
    return {
      activeInput: a,
      otp: n,
      oldOtp: i,
      clearInput: () => {
        n.value.length > 0 && (r("update:value", ""), r("on-change", "")), n.value = [], a.value = 0;
      },
      handleOnPaste: (b) => {
        b.preventDefault();
        const y = b.clipboardData.getData("text/plain").slice(0, e.numInputs - a.value).split("");
        if (e.inputType === "number" && !y.join("").match(/^\d+$/) || e.inputType === "letter-numeric" && !y.join("").match(/^\w+$/))
          return "Invalid pasted data";
        const x = n.value.slice(0, a.value).concat(y);
        return x.slice(0, e.numInputs).forEach(function(w, k) {
          n.value[k] = w;
        }), u(x.slice(0, e.numInputs).length), l();
      },
      handleOnKeyDown: (b) => {
        switch (b.keyCode) {
          case mK:
            b.preventDefault(), c(""), f();
            break;
          case bK:
            b.preventDefault(), c("");
            break;
          case hK:
            b.preventDefault(), f();
            break;
          case gK:
            b.preventDefault(), d();
            break;
        }
      },
      handleOnBlur: o,
      changeCodeAtFocus: c,
      focusInput: u,
      focusNextInput: d,
      focusPrevInput: f,
      handleOnFocus: s,
      checkFilledAllInputs: l,
      handleOnChange: (b) => {
        c(b), d();
      },
      fillInput: (b) => {
        const y = b.split("");
        y.length === e.numInputs && (n.value = y, r("update:value", n.value.join("")), r("on-complete", n.value.join("")));
      }
    };
  }
});
const yK = {
  style: {
    display: "flex"
  }
}, _K = {
  key: 0,
  autocomplete: "off",
  name: "hidden",
  type: "text",
  style: {
    display: "none"
  }
};
function xK(e, t, r, a, n, i) {
  const s = H4("SingleOtpInput");
  return R(), K("div", yK, [e.inputType === "password" ? (R(), K("input", _K)) : fe("", !0), (R(!0), K(Qe, null, kt(e.numInputs, (o, l) => (R(), Le(s, {
    key: l,
    focus: e.activeInput === l,
    value: e.otp[l],
    separator: e.separator,
    "input-type": e.inputType,
    inputmode: e.inputmode,
    "input-classes": e.inputClasses,
    conditionalClass: e.conditionalClass[l],
    "is-last-child": l === e.numInputs - 1,
    "should-auto-focus": e.shouldAutoFocus,
    placeholder: e.placeholder[l],
    "is-disabled": e.isDisabled,
    onOnChange: e.handleOnChange,
    onOnKeydown: e.handleOnKeyDown,
    onOnPaste: e.handleOnPaste,
    onOnFocus: (u) => e.handleOnFocus(l),
    onOnBlur: e.handleOnBlur
  }, null, 8, ["focus", "value", "separator", "input-type", "inputmode", "input-classes", "conditionalClass", "is-last-child", "should-auto-focus", "placeholder", "is-disabled", "onOnChange", "onOnKeydown", "onOnPaste", "onOnFocus", "onOnBlur"]))), 128))]);
}
AO.render = xK;
var wK = /* @__PURE__ */ (() => {
  const e = AO;
  return e.install = (t) => {
    t.component("Vue3OtpInput", e);
  }, e;
})();
const joe = /* @__PURE__ */ Ae({
  __name: "JOTP",
  props: {
    modelValue: {},
    hasError: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = N({
      get() {
        return r.modelValue;
      },
      set(o) {
        a("update:modelValue", xH(o));
      }
    }), i = Gr(), { currentLocaleItem: s } = Ii();
    return (o, l) => (R(), Le(U(wK), Mt({
      value: n.value,
      "onUpdate:value": l[0] || (l[0] = (u) => n.value = u),
      class: ["flex w-full justify-between", U(s).rtl ? "flex-row-reverse" : "flex-row"],
      isDisabled: U(i)("disabled", !0),
      inputClasses: [
        "border rounded-sm mx-4 w-40 h-40 text-center focus-visible:ring-0 outline-1",
        o.hasError ? "outline-danger border-danger text-danger" : "outline-primary text-secondary-hover border-disabled"
      ],
      inputType: "tel"
    }, o.$attrs, { separator: "" }), null, 16, ["value", "class", "isDisabled", "inputClasses"]));
  }
}), TK = { class: "flex" }, SK = ["disabled", "aria-disabled"], EK = { class: "inline-flex items-center gap-4" }, OK = ["disabled", "onClick"], CK = { class: "flex" }, kK = ["disabled", "aria-disabled"], Zf = 1, Foe = /* @__PURE__ */ Ae({
  __name: "JPagination",
  props: {
    modelValue: { default: 1 },
    totalPages: { default: 10 },
    pageSize: {},
    showNext: { type: Boolean, default: !0 },
    showPrev: { type: Boolean, default: !0 },
    maxVisibleButtons: { default: 3 },
    justify: { default: "between" },
    color: { default: "primary" },
    buttonClass: {},
    arrowButtonClass: {},
    showElipsis: { type: Boolean, default: !0 },
    showArrowButtons: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    showSelectedAsFirstPage: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a);
    function i(g) {
      n.value !== g && (n.value = g, a("update:modelValue", g));
    }
    const s = N(() => {
      const g = [], m = n.value, {
        maxVisibleButtons: b,
        totalPages: y,
        showSelectedAsFirstPage: _,
        showElipsis: x
      } = r;
      let w = Math.max(_ ? m : m - Math.floor(b / 2), 1);
      const k = Math.min(w + b - 1, y);
      k - w + 1 < b && (w = Math.max(k - b + 1, 1));
      for (let S = w; S <= k; S++)
        g.push({
          name: S,
          selected: m === S,
          isDisabled: S === k && S !== y || S === w && S !== Zf
        });
      return {
        range: g,
        showStartEllipsis: x && w > 1,
        showEndEllipsis: x && k < y
      };
    }), o = N(() => n.value === Zf);
    function l() {
      n.value !== Zf && (n.value--, i(n.value));
    }
    const u = N(
      () => n.value === r.totalPages
    ), d = N(() => r.showArrowButtons ? r.showPrev : !o.value), f = N(() => r.showArrowButtons ? r.showNext : !u.value);
    function c() {
      n.value++, i(n.value);
    }
    const p = N(() => `justify-${r.justify}`), v = N(() => ({
      text: gn[r.color],
      bg: qa[r.color],
      border: Yl[r.color],
      hoverBg: DD[r.color]
    })), h = N(() => `${v.value.bg} text-white`);
    return (g, m) => (R(), K("ul", {
      "aria-label": "Pagination",
      class: pe(["list-style-none inline-flex w-full items-center gap-4 text-gray-600", [p.value]])
    }, [
      ue("li", TK, [
        d.value ? (R(), K("button", {
          key: 0,
          class: pe(["flex items-center justify-center rounded-full p-2 disabled:cursor-not-allowed disabled:text-gray-400", [v.value.text, g.arrowButtonClass]]),
          disabled: o.value || g.disabled,
          "aria-disabled": o.value,
          onClick: l
        }, [
          Fe(gt, { name: "alt-arrow-left-line" })
        ], 10, SK)) : fe("", !0)
      ]),
      ue("li", null, [
        ue("div", EK, [
          s.value.showStartEllipsis ? (R(), K("button", {
            key: 0,
            class: pe(["disabled flex h-32 w-32 items-center justify-center rounded-full border hover:text-white disabled:cursor-not-allowed", [v.value.text, v.value.border, v.value.hoverBg, g.buttonClass]]),
            disabled: ""
          }, [
            Fe(gt, {
              name: "dots",
              size: 14
            })
          ], 2)) : fe("", !0),
          (R(!0), K(Qe, null, kt(s.value.range, (b) => (R(), K("button", {
            key: `page-${b.name}`,
            class: pe([[
              b.selected && h.value,
              v.value.text,
              v.value.border,
              v.value.hoverBg,
              g.buttonClass
            ], "flex h-32 w-32 items-center justify-center rounded-full border hover:text-white disabled:cursor-not-allowed"]),
            disabled: b.selected || g.disabled,
            onClick: (y) => i(b.name)
          }, [
            ue("span", null, Ie(b.name), 1)
          ], 10, OK))), 128)),
          s.value.showEndEllipsis ? (R(), K("button", {
            key: 1,
            class: pe(["disabled flex h-32 w-32 items-center justify-center rounded-full border hover:text-white disabled:cursor-not-allowed", [v.value.text, v.value.border, v.value.hoverBg, g.buttonClass]]),
            disabled: ""
          }, [
            Fe(gt, {
              name: "dots",
              size: 14
            })
          ], 2)) : fe("", !0)
        ])
      ]),
      ue("li", CK, [
        f.value ? (R(), K("button", {
          key: 0,
          class: pe(["flex items-center justify-center rounded-full p-2 disabled:cursor-not-allowed disabled:text-gray-400", [v.value.text, g.arrowButtonClass]]),
          disabled: u.value || g.disabled,
          "aria-disabled": u.value,
          onClick: c
        }, [
          Fe(gt, { name: "alt-arrow-right-line" })
        ], 10, kK)) : fe("", !0)
      ])
    ], 2));
  }
}), PK = { class: "radio" }, MK = ["required", "aria-required", "disabled", "aria-disabled"], AK = ["aria-disabled"], DK = ["aria-disabled"], IK = /* @__PURE__ */ Ae({
  __name: "JRadio",
  props: {
    title: {},
    value: { type: [String, Boolean, Number] },
    name: { default: "" },
    checked: { type: Boolean, default: !1 },
    color: { default: "primary" }
  },
  setup(e) {
    const t = e, r = Gr(), a = N(() => r("disabled", !0)), n = N(() => r("required", !0)), i = N(() => t.checked ? a.value ? qa.disabled : qa[t.color] : qa.white), s = N(
      () => a.value ? Yl.disabled : Yl[t.color]
    );
    return (o, l) => (R(), K("label", PK, [
      ue("input", Mt({
        type: "radio",
        class: ["radio__input", !a.value && "cursor-pointer"]
      }, t, {
        required: n.value,
        "aria-required": n.value,
        disabled: a.value,
        "aria-disabled": a.value
      }), null, 16, MK),
      ue("span", {
        class: pe(a.value ? "text-gray-500" : "text-black")
      }, [
        o.$slots.title ? ke(o.$slots, "title", { key: 1 }) : (R(), K(Qe, { key: 0 }, [
          jt(Ie(o.title), 1)
        ], 64))
      ], 2),
      ue("span", {
        class: pe(["radio__checkmark", [s.value, !a.value && "cursor-pointer"]]),
        "aria-disabled": a.value
      }, [
        ue("span", {
          class: pe(["radio__checkmark--type", i.value]),
          "aria-disabled": a.value
        }, null, 10, DK)
      ], 10, AK)
    ]));
  }
}), NK = { class: "flex flex-row gap-4 md:gap-16" }, Boe = /* @__PURE__ */ Ae({
  __name: "JRadioGroup",
  props: {
    options: {},
    label: { default: "" },
    color: { default: "primary" },
    name: { default: "" },
    modelValue: { default: "" },
    as: { default: "div" },
    by: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = $r(e, "modelValue", t), i = Gr(), s = N(() => i("disabled", !0)), o = N(() => i("required", !0));
    return (l, u) => (R(), Le(U(ES), {
      modelValue: U(n),
      "onUpdate:modelValue": u[0] || (u[0] = (d) => _a(n) ? n.value = d : null),
      class: "flex flex-wrap items-center gap-8",
      disabled: s.value,
      as: l.as,
      by: l.by
    }, {
      default: Pe(() => [
        l.label ? (R(), Le(U(CS), {
          key: 0,
          class: pe(["text-metadata-limited", o.value && "radio--required"])
        }, {
          default: Pe(() => [
            jt(Ie(l.label), 1)
          ]),
          _: 1
        }, 8, ["class"])) : fe("", !0),
        ue("div", NK, [
          (R(!0), K(Qe, null, kt(l.options, (d) => (R(), Le(U(OS), {
            key: d.title,
            value: d.value,
            disabled: d.disabled || !1
          }, {
            default: Pe(({ checked: f }) => [
              Fe(IK, {
                title: d.title,
                value: d.value,
                disabled: s.value || d.disabled,
                checked: f || d.checked,
                name: l.name,
                color: s.value ? "disabled" : l.color,
                required: o.value,
                class: "text-metadata-limited md:text-base"
              }, null, 8, ["title", "value", "disabled", "checked", "name", "color", "required"])
            ]),
            _: 2
          }, 1032, ["value", "disabled"]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "as", "by"]));
  }
}), $K = ["onClick"], qoe = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JRating",
  props: {
    modelValue: { default: 0 },
    max: { default: 5 },
    color: { default: "warning" },
    size: { default: 24 },
    clearable: { type: Boolean, default: !1 },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = Gr(), s = N(() => i("disabled", !0)), o = N(() => i("required", !0));
    function l(c) {
      n.value = c;
    }
    function u(c) {
      if (!s.value) {
        if (r.clearable && n.value === c) {
          l(0);
          return;
        }
        l(c);
      }
    }
    function d(c) {
      return c <= n.value ? "star" : c - 0.5 === n.value ? "star-half" : "star-outline";
    }
    const f = N(() => s.value ? gn.disabled : gn[r.color]);
    return (c, p) => (R(), K(Qe, null, [
      c.label ? (R(), K("label", {
        key: 0,
        class: pe(["input__label block", { "input--required": o.value }])
      }, Ie(c.label), 3)) : fe("", !0),
      ue("div", Mt(c.$attrs, { class: "row-wrap inline-flex gap-x-8" }), [
        (R(!0), K(Qe, null, kt(c.max, (v) => (R(), K("button", {
          key: v,
          type: "button",
          class: pe([f.value, s.value ? "cursor-not-allowed" : "cursor-pointer"]),
          onClick: (h) => u(v)
        }, [
          Fe(gt, {
            name: d(v),
            size: c.size
          }, null, 8, ["name", "size"])
        ], 10, $K))), 128))
      ], 16)
    ], 64));
  }
}), LK = 100, RK = ["aria-disabled"], jK = { class: "flex w-full rounded-sm focus:outline-none focus:ring-0" }, FK = {
  key: 0,
  class: "text-gray-700 relative flex cursor-default select-none items-center justify-center px-16 py-8 text-gray-500 hover:bg-gray-200"
}, BK = {
  key: 1,
  class: "text-gray-700 relative cursor-default select-none px-16 py-8 hover:bg-gray-200"
}, qK = { key: 2 }, HK = { key: 0 }, Hoe = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JSelect",
  props: {
    modelValue: { default: "" },
    optionKey: { default: "" },
    optionValue: { default: "" },
    options: {},
    label: { default: "" },
    placeholder: {},
    error: { default: "" },
    loading: { type: Boolean, default: !1 },
    loadMoreLoading: { type: Boolean, default: !1 },
    disableFilter: { type: Boolean, default: !1 },
    optionClass: {},
    clearable: { type: Boolean, default: !0 },
    propagateOnClose: { type: Boolean, default: !1 },
    teleport: { type: Boolean, default: !0 },
    prependIcon: {},
    optionsWrapperClass: { default: "" },
    chunkSize: { default: LK }
  },
  emits: ["update:modelValue", "loadMore", "search"],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, i = $r(a, "modelValue", n), { getNewZIndex: s } = pu();
    function o(xe) {
      return i.value === null || i.value === void 0 ? !1 : a.optionKey === "" ? a.optionValue ? JSON.stringify(i.value) === JSON.stringify(xe) : i.value.toString() === xe.toString() : i.value.toString() === xe[a.optionKey].toString();
    }
    const [l, u] = L1(!1), d = ne(null);
    He(
      () => l.value,
      (xe) => {
        var J;
        xe && d.value && ((J = d.value) == null || J.$el.focus()), xe && setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        });
      }
    );
    const c = Vn()("option"), p = Gr(), v = N(() => p("required", !0)), h = N(() => p("readonly", !0)), g = N(() => !!a.label), m = N(
      () => v.value && !g.value ? `${a.placeholder} *` : a.placeholder
    ), b = N(() => p("disabled", !0));
    function y() {
      b.value || u(!0);
    }
    const _ = N(() => a.optionKey ? a.options.find(
      (xe) => String(xe[a.optionKey]) === String(i.value)
    ) : i.value), x = N(() => i.value === null || i.value === void 0 ? "" : a.optionValue ? _.value ? String(_.value[a.optionValue]) : "" : String(i.value)), w = ne(""), k = N(() => a.disableFilter ? a.options : a.optionKey === "" ? w.value === "" ? a.options : a.options.filter(
      (xe) => xe.toString().toLowerCase().replace(/\s+/g, "").includes(w.value.toLowerCase().replace(/\s+/g, ""))
    ) : w.value === "" ? a.options : a.options.filter(
      (xe) => xe[a.optionValue].toString().toLowerCase().replace(/\s+/g, "").includes(w.value.toLowerCase().replace(/\s+/g, ""))
    )), S = ne(1), P = N(() => k.value.slice(0, a.chunkSize * S.value));
    function A(xe) {
      setTimeout(() => {
        S.value = xe;
      }, 0);
    }
    He(l, () => A(1)), He(
      () => k.value.length,
      () => A(1)
    );
    function E(xe) {
      const J = xe.target, se = J.scrollTop + J.clientHeight;
      J.scrollHeight - se < 50 && P.value.length < k.value.length && A(S.value + 1);
    }
    function O(xe) {
      n("search", xe);
    }
    He(w, O);
    function T() {
      if (!(a.loading || b.value)) {
        if (i.value = null, w.value === "") {
          O(w.value);
          return;
        }
        w.value = "";
      }
    }
    const D = N(
      () => k.value.length === 0 && w.value !== ""
    );
    function $(xe) {
      return a.optionKey ? xe[a.optionKey] : xe;
    }
    function I(xe) {
      return a.optionKey ? xe[a.optionValue] : xe;
    }
    function F() {
      _.value || (w.value = "");
    }
    He(i, F);
    const j = ne(null), { arrivedState: M } = dT(j);
    He(
      () => M.bottom,
      (xe) => {
        xe && n("loadMore");
      }
    );
    const q = ne(null);
    du(j, Z), UT(j, (xe) => {
      u(!1), F(), !a.propagateOnClose && (xe.preventDefault(), xe.stopPropagation());
    });
    const le = ne(null);
    function Z(xe) {
      u(!1), F(), !a.propagateOnClose && xe.stopPropagation();
    }
    function G(xe, J) {
      et(J) || Z(xe);
    }
    const {
      comboOptionsTop: H,
      comboOptionsTransform: W,
      elementBounding: { left: ie, width: we }
    } = W1(q, j, a.teleport);
    function Be(xe) {
      w.value = xe.target.value;
    }
    function Ve() {
      u(!0), i.value = null;
    }
    function et(xe) {
      return typeof xe == "object" && xe.disabled;
    }
    t({
      toggle: u
    });
    const nt = N(() => a.teleport ? Oo : "div");
    return (xe, J) => (R(), K("div", {
      class: pe(["relative", { "cursor-not-allowed": b.value }])
    }, [
      Fe(U(iS), {
        ref_key: "comboParentRef",
        ref: le,
        modelValue: U(i),
        "onUpdate:modelValue": J[3] || (J[3] = (se) => _a(i) ? i.value = se : null),
        disabled: b.value,
        nullable: ""
      }, {
        default: Pe(() => [
          ue("label", {
            ref_key: "selectRef",
            ref: q,
            onClick: y
          }, [
            xe.label ? (R(), K("span", {
              key: 0,
              class: pe([v.value && "input--required", "input__label w-full text-base after:text-danger md:text-subject"])
            }, Ie(xe.label), 3)) : fe("", !0),
            ue("span", {
              id: "myInputId",
              "aria-disabled": b.value,
              class: pe([{
                "cursor-not-allowed bg-disabled": b.value,
                "bg-white focus-within:border focus-within:border-primary": !b.value,
                "mb-4 border-danger": xe.error,
                "border-gray-300": !xe.error,
                "mt-8": !!xe.label
              }, "flex h-40 w-full cursor-default overflow-hidden rounded-sm border px-12 pb-6 pt-4 text-left focus:border-primary"])
            }, [
              ue("span", jK, [
                Fe(U(h_), {
                  class: pe(["items-left inline-block", b.value ? "cursor-not-allowed" : "cursor-pointer"]),
                  onClickCapture: J[0] || (J[0] = zr(() => {
                  }, ["prevent"]))
                }, {
                  default: Pe(() => [
                    xe.prependIcon ? (R(), Le(gt, {
                      key: 0,
                      class: "me-2 inline-block text-gray-400",
                      name: xe.prependIcon,
                      size: "20"
                    }, null, 8, ["name"])) : fe("", !0)
                  ]),
                  _: 1
                }, 8, ["class"]),
                Fe(U(sA), {
                  ref_key: "comboInput",
                  ref: d,
                  class: pe(["inline-block w-full truncate rounded-sm placeholder:text-metadata-limited placeholder:text-placeholder focus:outline-none focus:ring-0", [
                    b.value ? "bg-disabled" : "bg-white",
                    h.value && "cursor-pointer select-none"
                  ]]),
                  autocomplete: "off",
                  "aria-disabled": b.value,
                  placeholder: m.value,
                  displayValue: () => x.value,
                  disabled: b.value,
                  readonly: h.value,
                  onChange: Be,
                  onInput: Ve,
                  onClick: J[1] || (J[1] = zr((se) => U(u)(!0), ["stop"]))
                }, null, 8, ["class", "aria-disabled", "placeholder", "displayValue", "disabled", "readonly"])
              ]),
              Fe(U(h_), {
                class: pe(["items-left inline-block", b.value ? "cursor-not-allowed" : "cursor-pointer"]),
                onClickCapture: J[2] || (J[2] = zr(() => {
                }, ["prevent"]))
              }, {
                default: Pe(() => [
                  xe.clearable && U(i) != null && U(i) !== "" && !xe.loading && !b.value ? (R(), Le(gt, {
                    key: 0,
                    class: pe([{ "rotate-180": U(l) }, "inline-block text-danger"]),
                    size: "24",
                    name: "close",
                    "aria-hidden": !U(i),
                    onClick: T
                  }, null, 8, ["class", "aria-hidden"])) : xe.loading ? (R(), Le(gt, {
                    key: 1,
                    class: "inline-block text-gray-400",
                    "aria-hidden": !xe.loading,
                    name: "spinner"
                  }, null, 8, ["aria-hidden"])) : (R(), Le(gt, {
                    key: 2,
                    class: pe([{ "rotate-180": U(l) }, "inline-block text-gray-400"]),
                    name: "alt-arrow-down",
                    "aria-hidden": U(i)
                  }, null, 8, ["class", "aria-hidden"]))
                ]),
                _: 1
              }, 8, ["class"])
            ], 10, RK)
          ], 512),
          (R(), Le(Za(nt.value), jr(oa(xe.teleport && { to: "body" })), {
            default: Pe(() => [
              U(l) ? (R(), K("div", {
                key: 0,
                ref_key: "el",
                ref: j,
                class: pe(["visible absolute mt-4 max-h-[200px] overflow-y-auto rounded-md border border-gray-300 bg-white text-base transition-transform delay-75 focus:outline-none", [!xe.teleport && "w-full", xe.optionsWrapperClass]]),
                tabindex: "0",
                role: "dialog",
                style: Ir({
                  top: U(H),
                  left: xe.teleport ? `${U(ie)}px` : 0,
                  width: `${U(we)}px`,
                  transform: U(W),
                  zIndex: U(s)()
                }),
                onScroll: E
              }, [
                Fe(U(sS), { static: "" }, {
                  default: Pe(() => [
                    xe.loading ? (R(), K("div", FK, [
                      Fe(gt, {
                        class: "flex",
                        name: "spinner"
                      }),
                      jt(" " + Ie(xe.$t("loading")), 1)
                    ])) : D.value && !xe.loadMoreLoading ? (R(), K("div", BK, Ie(xe.$t("notFound")), 1)) : (R(), K("div", qK, [
                      (R(!0), K(Qe, null, kt(P.value, (se, _e) => (R(), Le(U(yd), {
                        key: _e,
                        as: "template",
                        disabled: et(se),
                        value: $(se),
                        onClick: (Se) => G(Se, se)
                      }, {
                        default: Pe(({ active: Se }) => [
                          ue("li", {
                            class: pe(["relative w-full cursor-pointer select-none px-16 py-8", [
                              {
                                "text-gray-900 bg-white": !Se && !o(se) && !et(se),
                                "bg-primary-lighter text-dark": o(se) && !et(se),
                                "bg-gray-200": Se && !o(se) && !et(se),
                                "rounded-t-md": _e === 0,
                                "rounded-b-md border-none": _e === P.value.length - 1,
                                "!cursor-not-allowed bg-gray-300": et(se)
                              },
                              xe.optionClass
                            ]])
                          }, [
                            ke(xe.$slots, "option", {
                              selectedOption: U(i),
                              option: se
                            }),
                            U(c) ? fe("", !0) : (R(), K("span", HK, Ie(I(se)), 1))
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "value", "onClick"]))), 128)),
                      xe.loadMoreLoading ? (R(), Le(U(yd), {
                        key: 0,
                        class: "text-gray-700 relative flex cursor-default select-none items-center justify-center px-16 py-8 text-gray-500 hover:bg-gray-200"
                      }, {
                        default: Pe(() => [
                          Fe(gt, {
                            class: "flex",
                            name: "spinner"
                          }),
                          jt(" " + Ie(xe.$t("loading")), 1)
                        ]),
                        _: 1
                      })) : fe("", !0)
                    ]))
                  ]),
                  _: 3
                })
              ], 38)) : fe("", !0)
            ]),
            _: 3
          }, 16)),
          ea(ue("div", { class: "text-metadata-limited text-danger" }, Ie(xe.error), 513), [
            [$a, !U(l)]
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"])
    ], 2));
  }
}), VK = {
  center: "mx-auto",
  right: "ml-auto",
  left: "mr-auto"
}, Voe = /* @__PURE__ */ Ae({
  __name: "JSkeleton",
  props: {
    options: { default: () => ({
      type: "rectangle",
      height: 100,
      width: 100,
      color: "primary",
      borderRadius: 4,
      align: "center"
    }) }
  },
  setup(e) {
    const t = e, r = Dl(
      async () => await import("./TextSkeleton-4f25e88c.mjs")
    ), a = Dl(
      async () => await import("./CircleSkeleton-bf5d238b.mjs")
    ), n = Dl(
      async () => await import("./RectangleSkeleton-cd181b48.mjs")
    ), i = N(
      () => t.options.align ? VK[t.options.align] : void 0
    );
    return Mr("marginClass", i), (s, o) => (R(), K("div", null, [
      s.options.type === "circle" ? (R(), Le(U(a), {
        key: 0,
        class: pe([i.value, "skeleton"]),
        color: s.options.color,
        height: s.options.height,
        width: s.options.width
      }, null, 8, ["class", "color", "height", "width"])) : fe("", !0),
      s.options.type === "text" ? (R(), Le(U(r), {
        key: 1,
        class: "skeleton",
        color: s.options.color,
        textLinesCount: s.options.textLinesCount,
        textLinesWidth: s.options.textLinesWidth,
        borderRadius: s.options.borderRadius,
        textSmall: s.options.textSmall
      }, null, 8, ["color", "textLinesCount", "textLinesWidth", "borderRadius", "textSmall"])) : s.options.type === "rectangle" ? (R(), Le(U(n), {
        key: 2,
        class: pe([i.value, "skeleton"]),
        color: s.options.color,
        height: s.options.height,
        borderRadius: s.options.borderRadius,
        width: s.options.width
      }, null, 8, ["class", "color", "height", "borderRadius", "width"])) : fe("", !0)
    ]));
  }
});
function Wu(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function UK(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function DO(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var V2 = DO(function(e, t) {
  e.exports = function() {
    var r = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function a(v) {
      return v.split("").reverse().join("");
    }
    function n(v, h) {
      return v.substring(0, h.length) === h;
    }
    function i(v, h) {
      return v.slice(-1 * h.length) === h;
    }
    function s(v, h, g) {
      if ((v[h] || v[g]) && v[h] === v[g])
        throw new Error(h);
    }
    function o(v) {
      return typeof v == "number" && isFinite(v);
    }
    function l(v, h) {
      return v = v.toString().split("e"), (+((v = (v = Math.round(+(v[0] + "e" + (v[1] ? +v[1] + h : h)))).toString().split("e"))[0] + "e" + (v[1] ? +v[1] - h : -h))).toFixed(h);
    }
    function u(v, h, g, m, b, y, _, x, w, k, S, P) {
      var A, E, O, T = P, D = "", $ = "";
      return y && (P = y(P)), !!o(P) && (v !== !1 && parseFloat(P.toFixed(v)) === 0 && (P = 0), P < 0 && (A = !0, P = Math.abs(P)), v !== !1 && (P = l(P, v)), (P = P.toString()).indexOf(".") !== -1 ? (O = (E = P.split("."))[0], g && (D = g + E[1])) : O = P, h && (O = a(O).match(/.{1,3}/g), O = a(O.join(a(h)))), A && x && ($ += x), m && ($ += m), A && w && ($ += w), $ += O, $ += D, b && ($ += b), k && ($ = k($, T)), $);
    }
    function d(v, h, g, m, b, y, _, x, w, k, S, P) {
      var A, E = "";
      return S && (P = S(P)), !(!P || typeof P != "string") && (x && n(P, x) && (P = P.replace(x, ""), A = !0), m && n(P, m) && (P = P.replace(m, "")), w && n(P, w) && (P = P.replace(w, ""), A = !0), b && i(P, b) && (P = P.slice(0, -1 * b.length)), h && (P = P.split(h).join("")), g && (P = P.replace(g, ".")), A && (E += "-"), (E = (E += P).replace(/[^0-9\.\-.]/g, "")) !== "" && (E = Number(E), _ && (E = _(E)), !!o(E) && E));
    }
    function f(v) {
      var h, g, m, b = {};
      for (v.suffix === void 0 && (v.suffix = v.postfix), h = 0; h < r.length; h += 1)
        if ((m = v[g = r[h]]) === void 0)
          g !== "negative" || b.negativeBefore ? g === "mark" && b.thousand !== "." ? b[g] = "." : b[g] = !1 : b[g] = "-";
        else if (g === "decimals") {
          if (!(m >= 0 && m < 8))
            throw new Error(g);
          b[g] = m;
        } else if (g === "encoder" || g === "decoder" || g === "edit" || g === "undo") {
          if (typeof m != "function")
            throw new Error(g);
          b[g] = m;
        } else {
          if (typeof m != "string")
            throw new Error(g);
          b[g] = m;
        }
      return s(b, "mark", "thousand"), s(b, "prefix", "negative"), s(b, "prefix", "negativeBefore"), b;
    }
    function c(v, h, g) {
      var m, b = [];
      for (m = 0; m < r.length; m += 1)
        b.push(v[r[m]]);
      return b.push(g), h.apply("", b);
    }
    function p(v) {
      if (!(this instanceof p))
        return new p(v);
      typeof v == "object" && (v = f(v), this.to = function(h) {
        return c(v, u, h);
      }, this.from = function(h) {
        return c(v, d, h);
      });
    }
    return p;
  }();
}), zK = UK(DO(function(e, t) {
  (function(r) {
    function a(Q) {
      return n(Q) && typeof Q.from == "function";
    }
    function n(Q) {
      return typeof Q == "object" && typeof Q.to == "function";
    }
    function i(Q) {
      Q.parentElement.removeChild(Q);
    }
    function s(Q) {
      return Q != null;
    }
    function o(Q) {
      Q.preventDefault();
    }
    function l(Q) {
      return Q.filter(function(L) {
        return !this[L] && (this[L] = !0);
      }, {});
    }
    function u(Q, L) {
      return Math.round(Q / L) * L;
    }
    function d(Q, L) {
      var Te = Q.getBoundingClientRect(), Oe = Q.ownerDocument, Y = Oe.documentElement, de = y(Oe);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (de.x = 0), L ? Te.top + de.y - Y.clientTop : Te.left + de.x - Y.clientLeft;
    }
    function f(Q) {
      return typeof Q == "number" && !isNaN(Q) && isFinite(Q);
    }
    function c(Q, L, Te) {
      Te > 0 && (g(Q, L), setTimeout(function() {
        m(Q, L);
      }, Te));
    }
    function p(Q) {
      return Math.max(Math.min(Q, 100), 0);
    }
    function v(Q) {
      return Array.isArray(Q) ? Q : [Q];
    }
    function h(Q) {
      var L = (Q = String(Q)).split(".");
      return L.length > 1 ? L[1].length : 0;
    }
    function g(Q, L) {
      Q.classList && !/\s/.test(L) ? Q.classList.add(L) : Q.className += " " + L;
    }
    function m(Q, L) {
      Q.classList && !/\s/.test(L) ? Q.classList.remove(L) : Q.className = Q.className.replace(new RegExp("(^|\\b)" + L.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(Q, L) {
      return Q.classList ? Q.classList.contains(L) : new RegExp("\\b" + L + "\\b").test(Q.className);
    }
    function y(Q) {
      var L = window.pageXOffset !== void 0, Te = (Q.compatMode || "") === "CSS1Compat";
      return { x: L ? window.pageXOffset : Te ? Q.documentElement.scrollLeft : Q.body.scrollLeft, y: L ? window.pageYOffset : Te ? Q.documentElement.scrollTop : Q.body.scrollTop };
    }
    function _() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function x() {
      var Q = !1;
      try {
        var L = Object.defineProperty({}, "passive", { get: function() {
          Q = !0;
        } });
        window.addEventListener("test", null, L);
      } catch {
      }
      return Q;
    }
    function w() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function k(Q, L) {
      return 100 / (L - Q);
    }
    function S(Q, L, Te) {
      return 100 * L / (Q[Te + 1] - Q[Te]);
    }
    function P(Q, L) {
      return S(Q, Q[0] < 0 ? L + Math.abs(Q[0]) : L - Q[0], 0);
    }
    function A(Q, L) {
      return L * (Q[1] - Q[0]) / 100 + Q[0];
    }
    function E(Q, L) {
      for (var Te = 1; Q >= L[Te]; )
        Te += 1;
      return Te;
    }
    function O(Q, L, Te) {
      if (Te >= Q.slice(-1)[0])
        return 100;
      var Oe = E(Te, Q), Y = Q[Oe - 1], de = Q[Oe], Ne = L[Oe - 1], We = L[Oe];
      return Ne + P([Y, de], Te) / k(Ne, We);
    }
    function T(Q, L, Te) {
      if (Te >= 100)
        return Q.slice(-1)[0];
      var Oe = E(Te, L), Y = Q[Oe - 1], de = Q[Oe], Ne = L[Oe - 1];
      return A([Y, de], (Te - Ne) * k(Ne, L[Oe]));
    }
    function D(Q, L, Te, Oe) {
      if (Oe === 100)
        return Oe;
      var Y = E(Oe, Q), de = Q[Y - 1], Ne = Q[Y];
      return Te ? Oe - de > (Ne - de) / 2 ? Ne : de : L[Y - 1] ? Q[Y - 1] + u(Oe - Q[Y - 1], L[Y - 1]) : Oe;
    }
    var $, I;
    r.PipsMode = void 0, (I = r.PipsMode || (r.PipsMode = {})).Range = "range", I.Steps = "steps", I.Positions = "positions", I.Count = "count", I.Values = "values", r.PipsType = void 0, ($ = r.PipsType || (r.PipsType = {}))[$.None = -1] = "None", $[$.NoValue = 0] = "NoValue", $[$.LargeValue = 1] = "LargeValue", $[$.SmallValue = 2] = "SmallValue";
    var F = function() {
      function Q(L, Te, Oe) {
        var Y;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [Oe || !1], this.xNumSteps = [!1], this.snap = Te;
        var de = [];
        for (Object.keys(L).forEach(function(Ne) {
          de.push([v(L[Ne]), Ne]);
        }), de.sort(function(Ne, We) {
          return Ne[0][0] - We[0][0];
        }), Y = 0; Y < de.length; Y++)
          this.handleEntryPoint(de[Y][1], de[Y][0]);
        for (this.xNumSteps = this.xSteps.slice(0), Y = 0; Y < this.xNumSteps.length; Y++)
          this.handleStepPoint(Y, this.xNumSteps[Y]);
      }
      return Q.prototype.getDistance = function(L) {
        for (var Te = [], Oe = 0; Oe < this.xNumSteps.length - 1; Oe++)
          Te[Oe] = S(this.xVal, L, Oe);
        return Te;
      }, Q.prototype.getAbsoluteDistance = function(L, Te, Oe) {
        var Y, de = 0;
        if (L < this.xPct[this.xPct.length - 1])
          for (; L > this.xPct[de + 1]; )
            de++;
        else
          L === this.xPct[this.xPct.length - 1] && (de = this.xPct.length - 2);
        Oe || L !== this.xPct[de + 1] || de++, Te === null && (Te = []);
        var Ne = 1, We = Te[de], mt = 0, Nt = 0, St = 0, me = 0;
        for (Y = Oe ? (L - this.xPct[de]) / (this.xPct[de + 1] - this.xPct[de]) : (this.xPct[de + 1] - L) / (this.xPct[de + 1] - this.xPct[de]); We > 0; )
          mt = this.xPct[de + 1 + me] - this.xPct[de + me], Te[de + me] * Ne + 100 - 100 * Y > 100 ? (Nt = mt * Y, Ne = (We - 100 * Y) / Te[de + me], Y = 1) : (Nt = Te[de + me] * mt / 100 * Ne, Ne = 0), Oe ? (St -= Nt, this.xPct.length + me >= 1 && me--) : (St += Nt, this.xPct.length - me >= 1 && me++), We = Te[de + me] * Ne;
        return L + St;
      }, Q.prototype.toStepping = function(L) {
        return L = O(this.xVal, this.xPct, L);
      }, Q.prototype.fromStepping = function(L) {
        return T(this.xVal, this.xPct, L);
      }, Q.prototype.getStep = function(L) {
        return L = D(this.xPct, this.xSteps, this.snap, L);
      }, Q.prototype.getDefaultStep = function(L, Te, Oe) {
        var Y = E(L, this.xPct);
        return (L === 100 || Te && L === this.xPct[Y - 1]) && (Y = Math.max(Y - 1, 1)), (this.xVal[Y] - this.xVal[Y - 1]) / Oe;
      }, Q.prototype.getNearbySteps = function(L) {
        var Te = E(L, this.xPct);
        return { stepBefore: { startValue: this.xVal[Te - 2], step: this.xNumSteps[Te - 2], highestStep: this.xHighestCompleteStep[Te - 2] }, thisStep: { startValue: this.xVal[Te - 1], step: this.xNumSteps[Te - 1], highestStep: this.xHighestCompleteStep[Te - 1] }, stepAfter: { startValue: this.xVal[Te], step: this.xNumSteps[Te], highestStep: this.xHighestCompleteStep[Te] } };
      }, Q.prototype.countStepDecimals = function() {
        var L = this.xNumSteps.map(h);
        return Math.max.apply(null, L);
      }, Q.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, Q.prototype.convert = function(L) {
        return this.getStep(this.toStepping(L));
      }, Q.prototype.handleEntryPoint = function(L, Te) {
        var Oe;
        if (!f(Oe = L === "min" ? 0 : L === "max" ? 100 : parseFloat(L)) || !f(Te[0]))
          throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(Oe), this.xVal.push(Te[0]);
        var Y = Number(Te[1]);
        Oe ? this.xSteps.push(!isNaN(Y) && Y) : isNaN(Y) || (this.xSteps[0] = Y), this.xHighestCompleteStep.push(0);
      }, Q.prototype.handleStepPoint = function(L, Te) {
        if (Te)
          if (this.xVal[L] !== this.xVal[L + 1]) {
            this.xSteps[L] = S([this.xVal[L], this.xVal[L + 1]], Te, 0) / k(this.xPct[L], this.xPct[L + 1]);
            var Oe = (this.xVal[L + 1] - this.xVal[L]) / this.xNumSteps[L], Y = Math.ceil(Number(Oe.toFixed(3)) - 1), de = this.xVal[L] + this.xNumSteps[L] * Y;
            this.xHighestCompleteStep[L] = de;
          } else
            this.xSteps[L] = this.xHighestCompleteStep[L] = this.xVal[L];
      }, Q;
    }(), j = { to: function(Q) {
      return Q === void 0 ? "" : Q.toFixed(2);
    }, from: Number }, M = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, q = { tooltips: ".__tooltips", aria: ".__aria" };
    function le(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'step' is not numeric.");
      Q.singleStep = L;
    }
    function Z(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      Q.keyboardPageMultiplier = L;
    }
    function G(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      Q.keyboardMultiplier = L;
    }
    function H(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      Q.keyboardDefaultStep = L;
    }
    function W(Q, L) {
      if (typeof L != "object" || Array.isArray(L))
        throw new Error("noUiSlider: 'range' is not an object.");
      if (L.min === void 0 || L.max === void 0)
        throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      Q.spectrum = new F(L, Q.snap || !1, Q.singleStep);
    }
    function ie(Q, L) {
      if (L = v(L), !Array.isArray(L) || !L.length)
        throw new Error("noUiSlider: 'start' option is incorrect.");
      Q.handles = L.length, Q.start = L;
    }
    function we(Q, L) {
      if (typeof L != "boolean")
        throw new Error("noUiSlider: 'snap' option must be a boolean.");
      Q.snap = L;
    }
    function Be(Q, L) {
      if (typeof L != "boolean")
        throw new Error("noUiSlider: 'animate' option must be a boolean.");
      Q.animate = L;
    }
    function Ve(Q, L) {
      if (typeof L != "number")
        throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      Q.animationDuration = L;
    }
    function et(Q, L) {
      var Te, Oe = [!1];
      if (L === "lower" ? L = [!0, !1] : L === "upper" && (L = [!1, !0]), L === !0 || L === !1) {
        for (Te = 1; Te < Q.handles; Te++)
          Oe.push(L);
        Oe.push(!1);
      } else {
        if (!Array.isArray(L) || !L.length || L.length !== Q.handles + 1)
          throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        Oe = L;
      }
      Q.connect = Oe;
    }
    function nt(Q, L) {
      switch (L) {
        case "horizontal":
          Q.ort = 0;
          break;
        case "vertical":
          Q.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function xe(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'margin' option must be numeric.");
      L !== 0 && (Q.margin = Q.spectrum.getDistance(L));
    }
    function J(Q, L) {
      if (!f(L))
        throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (Q.limit = Q.spectrum.getDistance(L), !Q.limit || Q.handles < 2)
        throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function se(Q, L) {
      var Te;
      if (!f(L) && !Array.isArray(L))
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(L) && L.length !== 2 && !f(L[0]) && !f(L[1]))
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (L !== 0) {
        for (Array.isArray(L) || (L = [L, L]), Q.padding = [Q.spectrum.getDistance(L[0]), Q.spectrum.getDistance(L[1])], Te = 0; Te < Q.spectrum.xNumSteps.length - 1; Te++)
          if (Q.padding[0][Te] < 0 || Q.padding[1][Te] < 0)
            throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var Oe = L[0] + L[1], Y = Q.spectrum.xVal[0];
        if (Oe / (Q.spectrum.xVal[Q.spectrum.xVal.length - 1] - Y) > 1)
          throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function _e(Q, L) {
      switch (L) {
        case "ltr":
          Q.dir = 0;
          break;
        case "rtl":
          Q.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function Se(Q, L) {
      if (typeof L != "string")
        throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var Te = L.indexOf("tap") >= 0, Oe = L.indexOf("drag") >= 0, Y = L.indexOf("fixed") >= 0, de = L.indexOf("snap") >= 0, Ne = L.indexOf("hover") >= 0, We = L.indexOf("unconstrained") >= 0, mt = L.indexOf("drag-all") >= 0, Nt = L.indexOf("smooth-steps") >= 0;
      if (Y) {
        if (Q.handles !== 2)
          throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        xe(Q, Q.start[1] - Q.start[0]);
      }
      if (We && (Q.margin || Q.limit))
        throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      Q.events = { tap: Te || de, drag: Oe, dragAll: mt, smoothSteps: Nt, fixed: Y, snap: de, hover: Ne, unconstrained: We };
    }
    function Re(Q, L) {
      if (L !== !1)
        if (L === !0 || n(L)) {
          Q.tooltips = [];
          for (var Te = 0; Te < Q.handles; Te++)
            Q.tooltips.push(L);
        } else {
          if ((L = v(L)).length !== Q.handles)
            throw new Error("noUiSlider: must pass a formatter for all handles.");
          L.forEach(function(Oe) {
            if (typeof Oe != "boolean" && !n(Oe))
              throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
          }), Q.tooltips = L;
        }
    }
    function rt(Q, L) {
      if (L.length !== Q.handles)
        throw new Error("noUiSlider: must pass a attributes for all handles.");
      Q.handleAttributes = L;
    }
    function Dt(Q, L) {
      if (!n(L))
        throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      Q.ariaFormat = L;
    }
    function It(Q, L) {
      if (!a(L))
        throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      Q.format = L;
    }
    function Ye(Q, L) {
      if (typeof L != "boolean")
        throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      Q.keyboardSupport = L;
    }
    function at(Q, L) {
      Q.documentElement = L;
    }
    function ut(Q, L) {
      if (typeof L != "string" && L !== !1)
        throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      Q.cssPrefix = L;
    }
    function Gt(Q, L) {
      if (typeof L != "object")
        throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof Q.cssPrefix == "string" ? (Q.cssClasses = {}, Object.keys(L).forEach(function(Te) {
        Q.cssClasses[Te] = Q.cssPrefix + L[Te];
      })) : Q.cssClasses = L;
    }
    function Je(Q) {
      var L = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: j, format: j }, Te = { step: { r: !1, t: le }, keyboardPageMultiplier: { r: !1, t: Z }, keyboardMultiplier: { r: !1, t: G }, keyboardDefaultStep: { r: !1, t: H }, start: { r: !0, t: ie }, connect: { r: !0, t: et }, direction: { r: !0, t: _e }, snap: { r: !1, t: we }, animate: { r: !1, t: Be }, animationDuration: { r: !1, t: Ve }, range: { r: !0, t: W }, orientation: { r: !1, t: nt }, margin: { r: !1, t: xe }, limit: { r: !1, t: J }, padding: { r: !1, t: se }, behaviour: { r: !0, t: Se }, ariaFormat: { r: !1, t: Dt }, format: { r: !1, t: It }, tooltips: { r: !1, t: Re }, keyboardSupport: { r: !0, t: Ye }, documentElement: { r: !1, t: at }, cssPrefix: { r: !0, t: ut }, cssClasses: { r: !0, t: Gt }, handleAttributes: { r: !1, t: rt } }, Oe = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: M, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      Q.format && !Q.ariaFormat && (Q.ariaFormat = Q.format), Object.keys(Te).forEach(function(mt) {
        if (s(Q[mt]) || Oe[mt] !== void 0)
          Te[mt].t(L, s(Q[mt]) ? Q[mt] : Oe[mt]);
        else if (Te[mt].r)
          throw new Error("noUiSlider: '" + mt + "' is required.");
      }), L.pips = Q.pips;
      var Y = document.createElement("div"), de = Y.style.msTransform !== void 0, Ne = Y.style.transform !== void 0;
      L.transformRule = Ne ? "transform" : de ? "msTransform" : "webkitTransform";
      var We = [["left", "top"], ["right", "bottom"]];
      return L.style = We[L.dir][L.ort], L;
    }
    function he(Q, L, Te) {
      var Oe, Y, de, Ne, We, mt = _(), Nt = w() && x(), St = Q, me = L.spectrum, Ue = [], bt = [], _t = [], pr = 0, Ze = {}, vr = Q.ownerDocument, yt = L.documentElement || vr.documentElement, Xr = vr.body, La = vr.dir === "rtl" || L.ort === 1 ? 0 : 100;
      function Ar(te, ce) {
        var ge = vr.createElement("div");
        return ce && g(ge, ce), te.appendChild(ge), ge;
      }
      function rn(te, ce) {
        var ge = Ar(te, L.cssClasses.origin), Me = Ar(ge, L.cssClasses.handle);
        if (Ar(Me, L.cssClasses.touchArea), Me.setAttribute("data-handle", String(ce)), L.keyboardSupport && (Me.setAttribute("tabindex", "0"), Me.addEventListener("keydown", function(Xe) {
          return Kr(Xe, ce);
        })), L.handleAttributes !== void 0) {
          var ze = L.handleAttributes[ce];
          Object.keys(ze).forEach(function(Xe) {
            Me.setAttribute(Xe, ze[Xe]);
          });
        }
        return Me.setAttribute("role", "slider"), Me.setAttribute("aria-orientation", L.ort ? "vertical" : "horizontal"), ce === 0 ? g(Me, L.cssClasses.handleLower) : ce === L.handles - 1 && g(Me, L.cssClasses.handleUpper), ge;
      }
      function Gn(te, ce) {
        return !!ce && Ar(te, L.cssClasses.connect);
      }
      function pi(te, ce) {
        var ge = Ar(ce, L.cssClasses.connects);
        Y = [], (de = []).push(Gn(ge, te[0]));
        for (var Me = 0; Me < L.handles; Me++)
          Y.push(rn(ce, Me)), _t[Me] = Me, de.push(Gn(ge, te[Me + 1]));
      }
      function Cn(te) {
        return g(te, L.cssClasses.target), L.dir === 0 ? g(te, L.cssClasses.ltr) : g(te, L.cssClasses.rtl), L.ort === 0 ? g(te, L.cssClasses.horizontal) : g(te, L.cssClasses.vertical), g(te, getComputedStyle(te).direction === "rtl" ? L.cssClasses.textDirectionRtl : L.cssClasses.textDirectionLtr), Ar(te, L.cssClasses.base);
      }
      function Va(te, ce) {
        return !(!L.tooltips || !L.tooltips[ce]) && Ar(te.firstChild, L.cssClasses.tooltip);
      }
      function Er() {
        return St.hasAttribute("disabled");
      }
      function an(te) {
        return Y[te].hasAttribute("disabled");
      }
      function kn() {
        We && (Dr("update" + q.tooltips), We.forEach(function(te) {
          te && i(te);
        }), We = null);
      }
      function Pn() {
        kn(), We = Y.map(Va), sn("update" + q.tooltips, function(te, ce, ge) {
          if (We && L.tooltips && We[ce] !== !1) {
            var Me = te[ce];
            L.tooltips[ce] !== !0 && (Me = L.tooltips[ce].to(ge[ce])), We[ce].innerHTML = Me;
          }
        });
      }
      function Xn() {
        Dr("update" + q.aria), sn("update" + q.aria, function(te, ce, ge, Me, ze) {
          _t.forEach(function(Xe) {
            var xt = Y[Xe], tt = ia(bt, Xe, 0, !0, !0, !0), ar = ia(bt, Xe, 100, !0, !0, !0), er = ze[Xe], Kt = String(L.ariaFormat.to(ge[Xe]));
            tt = me.fromStepping(tt).toFixed(1), ar = me.fromStepping(ar).toFixed(1), er = me.fromStepping(er).toFixed(1), xt.children[0].setAttribute("aria-valuemin", tt), xt.children[0].setAttribute("aria-valuemax", ar), xt.children[0].setAttribute("aria-valuenow", er), xt.children[0].setAttribute("aria-valuetext", Kt);
          });
        });
      }
      function Kn(te) {
        if (te.mode === r.PipsMode.Range || te.mode === r.PipsMode.Steps)
          return me.xVal;
        if (te.mode === r.PipsMode.Count) {
          if (te.values < 2)
            throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var ce = te.values - 1, ge = 100 / ce, Me = []; ce--; )
            Me[ce] = ce * ge;
          return Me.push(100), Or(Me, te.stepped);
        }
        return te.mode === r.PipsMode.Positions ? Or(te.values, te.stepped) : te.mode === r.PipsMode.Values ? te.stepped ? te.values.map(function(ze) {
          return me.fromStepping(me.getStep(me.toStepping(ze)));
        }) : te.values : [];
      }
      function Or(te, ce) {
        return te.map(function(ge) {
          return me.fromStepping(ce ? me.getStep(ge) : ge);
        });
      }
      function Mn(te) {
        function ce(er, Kt) {
          return Number((er + Kt).toFixed(7));
        }
        var ge = Kn(te), Me = {}, ze = me.xVal[0], Xe = me.xVal[me.xVal.length - 1], xt = !1, tt = !1, ar = 0;
        return (ge = l(ge.slice().sort(function(er, Kt) {
          return er - Kt;
        })))[0] !== ze && (ge.unshift(ze), xt = !0), ge[ge.length - 1] !== Xe && (ge.push(Xe), tt = !0), ge.forEach(function(er, Kt) {
          var tr, Lt, gr, ur, dr, Zn, gi, Bi, C, V, oe = er, Ee = ge[Kt + 1], wt = te.mode === r.PipsMode.Steps;
          for (wt && (tr = me.xNumSteps[Kt]), tr || (tr = Ee - oe), Ee === void 0 && (Ee = oe), tr = Math.max(tr, 1e-7), Lt = oe; Lt <= Ee; Lt = ce(Lt, tr)) {
            for (Bi = (dr = (ur = me.toStepping(Lt)) - ar) / (te.density || 1), V = dr / (C = Math.round(Bi)), gr = 1; gr <= C; gr += 1)
              Me[(Zn = ar + gr * V).toFixed(5)] = [me.fromStepping(Zn), 0];
            gi = ge.indexOf(Lt) > -1 ? r.PipsType.LargeValue : wt ? r.PipsType.SmallValue : r.PipsType.NoValue, !Kt && xt && Lt !== Ee && (gi = 0), Lt === Ee && tt || (Me[ur.toFixed(5)] = [Lt, gi]), ar = ur;
          }
        }), Me;
      }
      function xa(te, ce, ge) {
        var Me, ze, Xe = vr.createElement("div"), xt = ((Me = {})[r.PipsType.None] = "", Me[r.PipsType.NoValue] = L.cssClasses.valueNormal, Me[r.PipsType.LargeValue] = L.cssClasses.valueLarge, Me[r.PipsType.SmallValue] = L.cssClasses.valueSub, Me), tt = ((ze = {})[r.PipsType.None] = "", ze[r.PipsType.NoValue] = L.cssClasses.markerNormal, ze[r.PipsType.LargeValue] = L.cssClasses.markerLarge, ze[r.PipsType.SmallValue] = L.cssClasses.markerSub, ze), ar = [L.cssClasses.valueHorizontal, L.cssClasses.valueVertical], er = [L.cssClasses.markerHorizontal, L.cssClasses.markerVertical];
        function Kt(Lt, gr) {
          var ur = gr === L.cssClasses.value, dr = ur ? xt : tt;
          return gr + " " + (ur ? ar : er)[L.ort] + " " + dr[Lt];
        }
        function tr(Lt, gr, ur) {
          if ((ur = ce ? ce(gr, ur) : ur) !== r.PipsType.None) {
            var dr = Ar(Xe, !1);
            dr.className = Kt(ur, L.cssClasses.marker), dr.style[L.style] = Lt + "%", ur > r.PipsType.NoValue && ((dr = Ar(Xe, !1)).className = Kt(ur, L.cssClasses.value), dr.setAttribute("data-value", String(gr)), dr.style[L.style] = Lt + "%", dr.innerHTML = String(ge.to(gr)));
          }
        }
        return g(Xe, L.cssClasses.pips), g(Xe, L.ort === 0 ? L.cssClasses.pipsHorizontal : L.cssClasses.pipsVertical), Object.keys(te).forEach(function(Lt) {
          tr(Lt, te[Lt][0], te[Lt][1]);
        }), Xe;
      }
      function wa() {
        Ne && (i(Ne), Ne = null);
      }
      function Ta(te) {
        wa();
        var ce = Mn(te), ge = te.filter, Me = te.format || { to: function(ze) {
          return String(Math.round(ze));
        } };
        return Ne = St.appendChild(xa(ce, ge, Me));
      }
      function Ua() {
        var te = Oe.getBoundingClientRect(), ce = "offset" + ["Width", "Height"][L.ort];
        return L.ort === 0 ? te.width || Oe[ce] : te.height || Oe[ce];
      }
      function lr(te, ce, ge, Me) {
        var ze = function(xt) {
          var tt = vi(xt, Me.pageOffset, Me.target || ce);
          return !!tt && !(Er() && !Me.doNotReject) && !(b(St, L.cssClasses.tap) && !Me.doNotReject) && !(te === mt.start && tt.buttons !== void 0 && tt.buttons > 1) && (!Me.hover || !tt.buttons) && (Nt || tt.preventDefault(), tt.calcPoint = tt.points[L.ort], void ge(tt, Me));
        }, Xe = [];
        return te.split(" ").forEach(function(xt) {
          ce.addEventListener(xt, ze, !!Nt && { passive: !0 }), Xe.push([xt, ze]);
        }), Xe;
      }
      function vi(te, ce, ge) {
        var Me = te.type.indexOf("touch") === 0, ze = te.type.indexOf("mouse") === 0, Xe = te.type.indexOf("pointer") === 0, xt = 0, tt = 0;
        if (te.type.indexOf("MSPointer") === 0 && (Xe = !0), te.type === "mousedown" && !te.buttons && !te.touches)
          return !1;
        if (Me) {
          var ar = function(tr) {
            var Lt = tr.target;
            return Lt === ge || ge.contains(Lt) || te.composed && te.composedPath().shift() === ge;
          };
          if (te.type === "touchstart") {
            var er = Array.prototype.filter.call(te.touches, ar);
            if (er.length > 1)
              return !1;
            xt = er[0].pageX, tt = er[0].pageY;
          } else {
            var Kt = Array.prototype.find.call(te.changedTouches, ar);
            if (!Kt)
              return !1;
            xt = Kt.pageX, tt = Kt.pageY;
          }
        }
        return ce = ce || y(vr), (ze || Xe) && (xt = te.clientX + ce.x, tt = te.clientY + ce.y), te.pageOffset = ce, te.points = [xt, tt], te.cursor = ze || Xe, te;
      }
      function Jn(te) {
        var ce = 100 * (te - d(Oe, L.ort)) / Ua();
        return ce = p(ce), L.dir ? 100 - ce : ce;
      }
      function nn(te) {
        var ce = 100, ge = !1;
        return Y.forEach(function(Me, ze) {
          if (!an(ze)) {
            var Xe = bt[ze], xt = Math.abs(Xe - te);
            (xt < ce || xt <= ce && te > Xe || xt === 100 && ce === 100) && (ge = ze, ce = xt);
          }
        }), ge;
      }
      function Vr(te, ce) {
        te.type === "mouseout" && te.target.nodeName === "HTML" && te.relatedTarget === null && qr(te, ce);
      }
      function Ra(te, ce) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && te.buttons === 0 && ce.buttonsProperty !== 0)
          return qr(te, ce);
        var ge = (L.dir ? -1 : 1) * (te.calcPoint - ce.startCalcPoint);
        ca(ge > 0, 100 * ge / ce.baseSize, ce.locations, ce.handleNumbers, ce.connect);
      }
      function qr(te, ce) {
        ce.handle && (m(ce.handle, L.cssClasses.active), pr -= 1), ce.listeners.forEach(function(ge) {
          yt.removeEventListener(ge[0], ge[1]);
        }), pr === 0 && (m(St, L.cssClasses.drag), Jr(), te.cursor && (Xr.style.cursor = "", Xr.removeEventListener("selectstart", o))), L.events.smoothSteps && (ce.handleNumbers.forEach(function(ge) {
          Ea(ge, bt[ge], !0, !0, !1, !1);
        }), ce.handleNumbers.forEach(function(ge) {
          Xt("update", ge);
        })), ce.handleNumbers.forEach(function(ge) {
          Xt("change", ge), Xt("set", ge), Xt("end", ge);
        });
      }
      function Ur(te, ce) {
        if (!ce.handleNumbers.some(an)) {
          var ge;
          ce.handleNumbers.length === 1 && (ge = Y[ce.handleNumbers[0]].children[0], pr += 1, g(ge, L.cssClasses.active)), te.stopPropagation();
          var Me = [], ze = lr(mt.move, yt, Ra, { target: te.target, handle: ge, connect: ce.connect, listeners: Me, startCalcPoint: te.calcPoint, baseSize: Ua(), pageOffset: te.pageOffset, handleNumbers: ce.handleNumbers, buttonsProperty: te.buttons, locations: bt.slice() }), Xe = lr(mt.end, yt, qr, { target: te.target, handle: ge, listeners: Me, doNotReject: !0, handleNumbers: ce.handleNumbers }), xt = lr("mouseout", yt, Vr, { target: te.target, handle: ge, listeners: Me, doNotReject: !0, handleNumbers: ce.handleNumbers });
          Me.push.apply(Me, ze.concat(Xe, xt)), te.cursor && (Xr.style.cursor = getComputedStyle(te.target).cursor, Y.length > 1 && g(St, L.cssClasses.drag), Xr.addEventListener("selectstart", o, !1)), ce.handleNumbers.forEach(function(tt) {
            Xt("start", tt);
          });
        }
      }
      function da(te) {
        te.stopPropagation();
        var ce = Jn(te.calcPoint), ge = nn(ce);
        ge !== !1 && (L.events.snap || c(St, L.cssClasses.tap, L.animationDuration), Ea(ge, ce, !0, !0), Jr(), Xt("slide", ge, !0), Xt("update", ge, !0), L.events.snap ? Ur(te, { handleNumbers: [ge] }) : (Xt("change", ge, !0), Xt("set", ge, !0)));
      }
      function hr(te) {
        var ce = Jn(te.calcPoint), ge = me.getStep(ce), Me = me.fromStepping(ge);
        Object.keys(Ze).forEach(function(ze) {
          ze.split(".")[0] === "hover" && Ze[ze].forEach(function(Xe) {
            Xe.call(Et, Me);
          });
        });
      }
      function Kr(te, ce) {
        if (Er() || an(ce))
          return !1;
        var ge = ["Left", "Right"], Me = ["Down", "Up"], ze = ["PageDown", "PageUp"], Xe = ["Home", "End"];
        L.dir && !L.ort ? ge.reverse() : L.ort && !L.dir && (Me.reverse(), ze.reverse());
        var xt, tt = te.key.replace("Arrow", ""), ar = tt === ze[0], er = tt === ze[1], Kt = tt === Me[0] || tt === ge[0] || ar, tr = tt === Me[1] || tt === ge[1] || er, Lt = tt === Xe[0], gr = tt === Xe[1];
        if (!(Kt || tr || Lt || gr))
          return !0;
        if (te.preventDefault(), tr || Kt) {
          var ur = Kt ? 0 : 1, dr = ae(ce)[ur];
          if (dr === null)
            return !1;
          dr === !1 && (dr = me.getDefaultStep(bt[ce], Kt, L.keyboardDefaultStep)), dr *= er || ar ? L.keyboardPageMultiplier : L.keyboardMultiplier, dr = Math.max(dr, 1e-7), dr *= Kt ? -1 : 1, xt = Ue[ce] + dr;
        } else
          xt = gr ? L.spectrum.xVal[L.spectrum.xVal.length - 1] : L.spectrum.xVal[0];
        return Ea(ce, me.toStepping(xt), !0, !0), Xt("slide", ce), Xt("update", ce), Xt("change", ce), Xt("set", ce), !1;
      }
      function Qn(te) {
        te.fixed || Y.forEach(function(ce, ge) {
          lr(mt.start, ce.children[0], Ur, { handleNumbers: [ge] });
        }), te.tap && lr(mt.start, Oe, da, {}), te.hover && lr(mt.move, Oe, hr, { hover: !0 }), te.drag && de.forEach(function(ce, ge) {
          if (ce !== !1 && ge !== 0 && ge !== de.length - 1) {
            var Me = Y[ge - 1], ze = Y[ge], Xe = [ce], xt = [Me, ze], tt = [ge - 1, ge];
            g(ce, L.cssClasses.draggable), te.fixed && (Xe.push(Me.children[0]), Xe.push(ze.children[0])), te.dragAll && (xt = Y, tt = _t), Xe.forEach(function(ar) {
              lr(mt.start, ar, Ur, { handles: xt, handleNumbers: tt, connect: ce });
            });
          }
        });
      }
      function sn(te, ce) {
        Ze[te] = Ze[te] || [], Ze[te].push(ce), te.split(".")[0] === "update" && Y.forEach(function(ge, Me) {
          Xt("update", Me);
        });
      }
      function on(te) {
        return te === q.aria || te === q.tooltips;
      }
      function Dr(te) {
        var ce = te && te.split(".")[0], ge = ce ? te.substring(ce.length) : te;
        Object.keys(Ze).forEach(function(Me) {
          var ze = Me.split(".")[0], Xe = Me.substring(ze.length);
          ce && ce !== ze || ge && ge !== Xe || on(Xe) && ge !== Xe || delete Ze[Me];
        });
      }
      function Xt(te, ce, ge) {
        Object.keys(Ze).forEach(function(Me) {
          var ze = Me.split(".")[0];
          te === ze && Ze[Me].forEach(function(Xe) {
            Xe.call(Et, Ue.map(L.format.to), ce, Ue.slice(), ge || !1, bt.slice(), Et);
          });
        });
      }
      function ia(te, ce, ge, Me, ze, Xe, xt) {
        var tt;
        return Y.length > 1 && !L.events.unconstrained && (Me && ce > 0 && (tt = me.getAbsoluteDistance(te[ce - 1], L.margin, !1), ge = Math.max(ge, tt)), ze && ce < Y.length - 1 && (tt = me.getAbsoluteDistance(te[ce + 1], L.margin, !0), ge = Math.min(ge, tt))), Y.length > 1 && L.limit && (Me && ce > 0 && (tt = me.getAbsoluteDistance(te[ce - 1], L.limit, !1), ge = Math.min(ge, tt)), ze && ce < Y.length - 1 && (tt = me.getAbsoluteDistance(te[ce + 1], L.limit, !0), ge = Math.max(ge, tt))), L.padding && (ce === 0 && (tt = me.getAbsoluteDistance(0, L.padding[0], !1), ge = Math.max(ge, tt)), ce === Y.length - 1 && (tt = me.getAbsoluteDistance(100, L.padding[1], !0), ge = Math.min(ge, tt))), xt || (ge = me.getStep(ge)), !((ge = p(ge)) === te[ce] && !Xe) && ge;
      }
      function Sa(te, ce) {
        var ge = L.ort;
        return (ge ? ce : te) + ", " + (ge ? te : ce);
      }
      function ca(te, ce, ge, Me, ze) {
        var Xe = ge.slice(), xt = Me[0], tt = L.events.smoothSteps, ar = [!te, te], er = [te, !te];
        Me = Me.slice(), te && Me.reverse(), Me.length > 1 ? Me.forEach(function(tr, Lt) {
          var gr = ia(Xe, tr, Xe[tr] + ce, ar[Lt], er[Lt], !1, tt);
          gr === !1 ? ce = 0 : (ce = gr - Xe[tr], Xe[tr] = gr);
        }) : ar = er = [!0];
        var Kt = !1;
        Me.forEach(function(tr, Lt) {
          Kt = Ea(tr, ge[tr] + ce, ar[Lt], er[Lt], !1, tt) || Kt;
        }), Kt && (Me.forEach(function(tr) {
          Xt("update", tr), Xt("slide", tr);
        }), ze != null && Xt("drag", xt));
      }
      function za(te, ce) {
        return L.dir ? 100 - te - ce : te;
      }
      function Ya(te, ce) {
        bt[te] = ce, Ue[te] = me.fromStepping(ce);
        var ge = "translate(" + Sa(za(ce, 0) - La + "%", "0") + ")";
        Y[te].style[L.transformRule] = ge, An(te), An(te + 1);
      }
      function Jr() {
        _t.forEach(function(te) {
          var ce = bt[te] > 50 ? -1 : 1, ge = 3 + (Y.length + ce * te);
          Y[te].style.zIndex = String(ge);
        });
      }
      function Ea(te, ce, ge, Me, ze, Xe) {
        return ze || (ce = ia(bt, te, ce, ge, Me, !1, Xe)), ce !== !1 && (Ya(te, ce), !0);
      }
      function An(te) {
        if (de[te]) {
          var ce = 0, ge = 100;
          te !== 0 && (ce = bt[te - 1]), te !== de.length - 1 && (ge = bt[te]);
          var Me = ge - ce, ze = "translate(" + Sa(za(ce, Me) + "%", "0") + ")", Xe = "scale(" + Sa(Me / 100, "1") + ")";
          de[te].style[L.transformRule] = ze + " " + Xe;
        }
      }
      function ln(te, ce) {
        return te === null || te === !1 || te === void 0 ? bt[ce] : (typeof te == "number" && (te = String(te)), (te = L.format.from(te)) !== !1 && (te = me.toStepping(te)), te === !1 || isNaN(te) ? bt[ce] : te);
      }
      function Oa(te, ce, ge) {
        var Me = v(te), ze = bt[0] === void 0;
        ce = ce === void 0 || ce, L.animate && !ze && c(St, L.cssClasses.tap, L.animationDuration), _t.forEach(function(tt) {
          Ea(tt, ln(Me[tt], tt), !0, !1, ge);
        });
        var Xe = _t.length === 1 ? 0 : 1;
        if (ze && me.hasNoSize() && (ge = !0, bt[0] = 0, _t.length > 1)) {
          var xt = 100 / (_t.length - 1);
          _t.forEach(function(tt) {
            bt[tt] = tt * xt;
          });
        }
        for (; Xe < _t.length; ++Xe)
          _t.forEach(function(tt) {
            Ea(tt, bt[tt], !0, !0, ge);
          });
        Jr(), _t.forEach(function(tt) {
          Xt("update", tt), Me[tt] !== null && ce && Xt("set", tt);
        });
      }
      function mi(te) {
        Oa(L.start, te);
      }
      function hi(te, ce, ge, Me) {
        if (!((te = Number(te)) >= 0 && te < _t.length))
          throw new Error("noUiSlider: invalid handle number, got: " + te);
        Ea(te, ln(ce, te), !0, !0, Me), Xt("update", te), ge && Xt("set", te);
      }
      function B(te) {
        if (te === void 0 && (te = !1), te)
          return Ue.length === 1 ? Ue[0] : Ue.slice(0);
        var ce = Ue.map(L.format.to);
        return ce.length === 1 ? ce[0] : ce;
      }
      function z() {
        for (Dr(q.aria), Dr(q.tooltips), Object.keys(L.cssClasses).forEach(function(te) {
          m(St, L.cssClasses[te]);
        }); St.firstChild; )
          St.removeChild(St.firstChild);
        delete St.noUiSlider;
      }
      function ae(te) {
        var ce = bt[te], ge = me.getNearbySteps(ce), Me = Ue[te], ze = ge.thisStep.step, Xe = null;
        if (L.snap)
          return [Me - ge.stepBefore.startValue || null, ge.stepAfter.startValue - Me || null];
        ze !== !1 && Me + ze > ge.stepAfter.startValue && (ze = ge.stepAfter.startValue - Me), Xe = Me > ge.thisStep.startValue ? ge.thisStep.step : ge.stepBefore.step !== !1 && Me - ge.stepBefore.highestStep, ce === 100 ? ze = null : ce === 0 && (Xe = null);
        var xt = me.countStepDecimals();
        return ze !== null && ze !== !1 && (ze = Number(ze.toFixed(xt))), Xe !== null && Xe !== !1 && (Xe = Number(Xe.toFixed(xt))), [Xe, ze];
      }
      function be() {
        return _t.map(ae);
      }
      function $e(te, ce) {
        var ge = B(), Me = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        Me.forEach(function(Xe) {
          te[Xe] !== void 0 && (Te[Xe] = te[Xe]);
        });
        var ze = Je(Te);
        Me.forEach(function(Xe) {
          te[Xe] !== void 0 && (L[Xe] = ze[Xe]);
        }), me = ze.spectrum, L.margin = ze.margin, L.limit = ze.limit, L.padding = ze.padding, L.pips ? Ta(L.pips) : wa(), L.tooltips ? Pn() : kn(), bt = [], Oa(s(te.start) ? te.start : ge, ce);
      }
      function Ge() {
        Oe = Cn(St), pi(L.connect, Oe), Qn(L.events), Oa(L.start), L.pips && Ta(L.pips), L.tooltips && Pn(), Xn();
      }
      Ge();
      var Et = { destroy: z, steps: be, on: sn, off: Dr, get: B, set: Oa, setHandle: hi, reset: mi, __moveHandles: function(te, ce, ge) {
        ca(te, ce, bt, ge);
      }, options: Te, updateOptions: $e, target: St, removePips: wa, removeTooltips: kn, getPositions: function() {
        return bt.slice();
      }, getTooltips: function() {
        return We;
      }, getOrigins: function() {
        return Y;
      }, pips: Ta };
      return Et;
    }
    function ye(Q, L) {
      if (!Q || !Q.nodeName)
        throw new Error("noUiSlider: create requires a single element, got: " + Q);
      if (Q.noUiSlider)
        throw new Error("noUiSlider: Slider was already initialized.");
      var Te = he(Q, Je(L), L);
      return Q.noUiSlider = Te, Te;
    }
    var Ke = { __spectrum: F, cssClasses: M, create: ye };
    r.create = ye, r.cssClasses = M, r.default = Ke, Object.defineProperty(r, "__esModule", { value: !0 });
  })(t);
}));
function U2(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t))
    return !1;
  const r = t.slice().sort();
  return e.length === t.length && e.slice().sort().every(function(a, n) {
    return a === r[n];
  });
}
var n1 = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const r = function(s, o, l) {
    const { value: u, modelValue: d, min: f } = uo(s);
    let c = d && d.value !== void 0 ? d : u;
    const p = ne(c.value);
    if (Wu(c.value) && (c = ne(f.value)), Array.isArray(c.value) && c.value.length == 0)
      throw new Error("Slider v-model must not be an empty array");
    return { value: c, initialValue: p };
  }(e), a = function(s, o, l) {
    const { classes: u, showTooltip: d, tooltipPosition: f, orientation: c } = uo(s), p = N(() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...u.value }));
    return { classList: N(() => {
      const v = { ...p.value };
      return Object.keys(v).forEach((h) => {
        v[h] = Array.isArray(v[h]) ? v[h].filter((g) => g !== null).join(" ") : v[h];
      }), d.value !== "always" && (v.target += ` ${d.value === "drag" ? v.tooltipDrag : v.tooltipFocus}`), c.value === "horizontal" && (v.tooltip += f.value === "bottom" ? ` ${v.tooltipBottom}` : ` ${v.tooltipTop}`), c.value === "vertical" && (v.tooltip += f.value === "right" ? ` ${v.tooltipRight}` : ` ${v.tooltipLeft}`), v;
    }) };
  }(e), n = function(s, o, l) {
    const { format: u, step: d } = uo(s), f = l.value, c = l.classList, p = N(() => u && u.value ? typeof u.value == "function" ? { to: u.value } : V2({ ...u.value }) : V2({ decimals: d.value >= 0 ? 0 : 2 })), v = N(() => Array.isArray(f.value) ? f.value.map((h) => p.value) : p.value);
    return { tooltipFormat: p, tooltipsFormat: v, tooltipsMerge: (h, g, m) => {
      var b = getComputedStyle(h).direction === "rtl", y = h.noUiSlider.options.direction === "rtl", _ = h.noUiSlider.options.orientation === "vertical", x = h.noUiSlider.getTooltips(), w = h.noUiSlider.getOrigins();
      x.forEach(function(k, S) {
        k && w[S].appendChild(k);
      }), h.noUiSlider.on("update", function(k, S, P, A, E) {
        var O = [[]], T = [[]], D = [[]], $ = 0;
        x[0] && (O[0][0] = 0, T[0][0] = E[0], D[0][0] = p.value.to(parseFloat(k[0])));
        for (var I = 1; I < k.length; I++)
          (!x[I] || k[I] - k[I - 1] > g) && (O[++$] = [], D[$] = [], T[$] = []), x[I] && (O[$].push(I), D[$].push(p.value.to(parseFloat(k[I]))), T[$].push(E[I]));
        O.forEach(function(F, j) {
          for (var M = F.length, q = 0; q < M; q++) {
            var le = F[q];
            if (q === M - 1) {
              var Z = 0;
              T[j].forEach(function(ie) {
                Z += 1e3 - ie;
              });
              var G = _ ? "bottom" : "right", H = y ? 0 : M - 1, W = 1e3 - T[j][H];
              Z = (b && !_ ? 100 : 0) + Z / M - W, x[le].innerHTML = D[j].join(m), x[le].style.display = "block", x[le].style[G] = Z + "%", c.value.tooltipHidden.split(" ").forEach((ie) => {
                x[le].classList.contains(ie) && x[le].classList.remove(ie);
              });
            } else
              x[le].style.display = "none", c.value.tooltipHidden.split(" ").forEach((ie) => {
                x[le].classList.add(ie);
              });
          }
        });
      });
    } };
  }(e, 0, { value: r.value, classList: a.classList }), i = function(s, o, l) {
    const { orientation: u, direction: d, tooltips: f, step: c, min: p, max: v, merge: h, id: g, disabled: m, options: b, classes: y, format: _, lazy: x, ariaLabelledby: w, aria: k } = uo(s), S = l.value, P = l.initialValue, A = l.tooltipsFormat, E = l.tooltipsMerge, O = l.tooltipFormat, T = l.classList, D = ne(null), $ = ne(null), I = ne(!1), F = N(() => {
      let ie = { cssPrefix: "", cssClasses: T.value, orientation: u.value, direction: d.value, tooltips: !!f.value && A.value, connect: "lower", start: Wu(S.value) ? p.value : S.value, range: { min: p.value, max: v.value } };
      if (c.value > 0 && (ie.step = c.value), Array.isArray(S.value) && (ie.connect = !0), w && w.value || k && Object.keys(k.value).length) {
        let we = Array.isArray(S.value) ? S.value : [S.value];
        ie.handleAttributes = we.map((Be) => Object.assign({}, k.value, w && w.value ? { "aria-labelledby": w.value } : {}));
      }
      return _.value && (ie.ariaFormat = O.value), ie;
    }), j = N(() => {
      let ie = { id: g && g.value ? g.value : void 0 };
      return m.value && (ie.disabled = !0), ie;
    }), M = N(() => Array.isArray(S.value)), q = () => {
      let ie = $.value.get();
      return Array.isArray(ie) ? ie.map((we) => parseFloat(we)) : parseFloat(ie);
    }, le = function(ie) {
      let we = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      $.value.set(ie, we);
    }, Z = (ie) => {
      o.emit("input", ie), o.emit("update:modelValue", ie), o.emit("update", ie);
    }, G = () => {
      $.value = zK.create(D.value, Object.assign({}, F.value, b.value)), f.value && M.value && h.value >= 0 && E(D.value, h.value, " - "), $.value.on("set", () => {
        const ie = q();
        o.emit("change", ie), o.emit("set", ie), x.value && Z(ie);
      }), $.value.on("update", () => {
        if (!I.value)
          return;
        const ie = q();
        M.value && U2(S.value, ie) || !M.value && S.value == ie ? o.emit("update", ie) : x.value || Z(ie);
      }), $.value.on("start", () => {
        o.emit("start", q());
      }), $.value.on("end", () => {
        o.emit("end", q());
      }), $.value.on("slide", () => {
        o.emit("slide", q());
      }), $.value.on("drag", () => {
        o.emit("drag", q());
      }), D.value.querySelectorAll("[data-handle]").forEach((ie) => {
        ie.onblur = () => {
          D.value && T.value.focused.split(" ").forEach((we) => {
            D.value.classList.remove(we);
          });
        }, ie.onfocus = () => {
          T.value.focused.split(" ").forEach((we) => {
            D.value.classList.add(we);
          });
        };
      }), I.value = !0;
    }, H = () => {
      $.value.off(), $.value.destroy(), $.value = null;
    }, W = (ie, we) => {
      I.value = !1, H(), G();
    };
    return ct(G), Tr(H), He(M, W, { immediate: !1 }), He(p, W, { immediate: !1 }), He(v, W, { immediate: !1 }), He(c, W, { immediate: !1 }), He(u, W, { immediate: !1 }), He(d, W, { immediate: !1 }), He(f, W, { immediate: !1 }), He(h, W, { immediate: !1 }), He(_, W, { immediate: !1, deep: !0 }), He(b, W, { immediate: !1, deep: !0 }), He(y, W, { immediate: !1, deep: !0 }), He(S, (ie, we) => {
      we && (typeof we == "object" && typeof ie == "object" && ie && Object.keys(we) > Object.keys(ie) || typeof we == "object" && typeof ie != "object" || Wu(ie)) && W();
    }, { immediate: !1 }), He(S, (ie) => {
      if (Wu(ie))
        return void le(p.value, !1);
      let we = q();
      M.value && !Array.isArray(we) && (we = [we]), (M.value && !U2(ie, we) || !M.value && ie != we) && le(ie, !1);
    }, { deep: !0 }), { slider: D, slider$: $, isRange: M, sliderProps: j, init: G, destroy: H, refresh: W, update: le, reset: () => {
      Z(P.value);
    } };
  }(e, t, { value: r.value, initialValue: r.initialValue, tooltipFormat: n.tooltipFormat, tooltipsFormat: n.tooltipsFormat, tooltipsMerge: n.tooltipsMerge, classList: a.classList });
  return { ...a, ...n, ...i };
} };
n1.render = function(e, t, r, a, n, i) {
  return R(), K("div", Mt(e.sliderProps, { ref: "slider" }), null, 16);
}, n1.__file = "src/Slider.vue";
const YK = { class: "relative border-solid border-danger" }, WK = /* @__PURE__ */ ue("div", { class: "absolute -top-3 left-0 aspect-square w-8 rounded-full bg-gray-600" }, null, -1), GK = { class: "absolute left-0 top-8 text-metadata-limited font-medium text-gray-600" }, XK = /* @__PURE__ */ ue("div", { class: "absolute -top-3 right-0 aspect-square w-8 rounded-full bg-gray-600" }, null, -1), KK = { class: "absolute right-0 top-8 text-metadata-limited font-medium text-gray-600" }, JK = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JSlider",
  setup(e) {
    const t = $d(), { currentLocaleItem: r } = Ii(), a = N(() => {
      const n = String(t.min), i = String(t.max);
      return {
        min: Number.parseInt(n),
        max: Number.parseInt(i)
      };
    });
    return (n, i) => (R(), K("div", YK, [
      Fe(U(n1), Mt(n.$attrs, {
        min: a.value.min,
        max: a.value.max,
        direction: U(r).rtl ? "rtl" : "ltr",
        classes: {
          base: "h-2 bg-gray-600",
          handle: `slider-handle focus:shadow-none ${n.$attrs.classes.handle}`,
          connect: `slider-connect h-2 ${n.$attrs.classes.connect}`,
          tooltipBottom: `bg-transparent border-none text-base p-0 ${n.$attrs.classes.tooltipBottom}`,
          tooltip: "mt-6 font-medium absolute left-1/2 w-fit -translate-x-1/2"
        },
        tooltipPosition: "bottom"
      }), null, 16, ["min", "max", "direction", "classes"]),
      WK,
      ue("div", GK, Ie(n.$attrs.min), 1),
      XK,
      ue("div", KK, Ie(n.$attrs.max), 1)
    ]));
  }
});
const QK = ["aria-disabled", "disabled", "data-editable"], ZK = /* @__PURE__ */ Ae({
  __name: "JStepperItem",
  props: {
    isActive: { type: Boolean, default: !1 },
    stepperItemClass: { default: "" },
    stepperItemDirection: { default: "horizontal" },
    stepperType: { default: "icon" },
    index: {},
    displayTitleOnMobile: { type: Boolean, default: !1 },
    variant: { default: "contained" },
    activeColor: { default: "primary" },
    deActiveColor: { default: "gray-400" },
    icon: {},
    label: {},
    iconClass: {},
    editable: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = N(() => t.variant === "contained" ? [qa[t.activeColor], "text-white"] : [
      "border",
      gn[t.activeColor],
      Yl[t.activeColor]
    ]), a = N(() => t.variant === "contained" ? [qa[t.deActiveColor], "text-white"] : [
      "border",
      gn[t.deActiveColor],
      Yl[t.deActiveColor]
    ]), n = N(() => gn[t.activeColor]), i = N(() => gn[t.deActiveColor]);
    return (s, o) => (R(), K("button", {
      "aria-disabled": !s.editable,
      disabled: !s.editable,
      "data-editable": !s.editable,
      type: "button",
      class: pe(["flex items-center gap-x-8", [
        s.stepperItemDirection === "vertical" && "flex-col",
        s.stepperItemClass
      ]])
    }, [
      s.stepperType === "icon" && s.icon ? (R(), K("span", {
        key: 0,
        class: pe(["flex h-32 w-32 items-center justify-center rounded-full md:h-40 md:w-40", [s.isActive ? r.value : a.value]])
      }, [
        Fe(gt, {
          name: s.icon,
          class: pe(s.iconClass)
        }, null, 8, ["name", "class"])
      ], 2)) : (R(), K("span", {
        key: 1,
        class: pe(["flex h-32 w-32 items-center justify-center rounded-full font-bold md:h-40 md:w-40", [s.isActive ? r.value : a.value]])
      }, Ie(s.index + 1), 3)),
      ue("span", {
        class: pe(["font-semi-bold", [
          s.isActive ? n.value : i.value,
          s.displayTitleOnMobile ? "block" : "hidden text-subject md:block"
        ]])
      }, Ie(s.label), 3)
    ], 10, QK));
  }
}), eJ = { class: "w-full" }, tJ = { class: "mb-32 flex items-center justify-between gap-x-8 md:gap-x-20" }, Uoe = /* @__PURE__ */ Ae({
  __name: "JStepper",
  props: {
    steps: {},
    modelValue: { default: 0 },
    separatorColor: { default: "line" },
    separatorActiveColorColor: { default: "dark" },
    isActive: { type: Boolean },
    stepperItemClass: { default: "" },
    stepperItemDirection: { default: "horizontal" },
    stepperType: { default: "icon" },
    index: {},
    displayTitleOnMobile: { type: Boolean, default: !1 },
    variant: {},
    activeColor: {},
    deActiveColor: {},
    icon: {},
    label: {},
    iconClass: {},
    editable: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a);
    function i(l) {
      n.value = l, a("change", l);
    }
    const s = N(() => gn[r.separatorColor]), o = N(
      () => gn[r.separatorActiveColorColor]
    );
    return (l, u) => (R(), K("div", eJ, [
      ue("div", tJ, [
        (R(!0), K(Qe, null, kt(l.steps, ({ icon: d, label: f, iconClass: c, editable: p }, v) => (R(), K("div", {
          key: v,
          class: "group flex flex-1 items-center gap-x-8 last-of-type:flex-none last-of-type:justify-end md:gap-x-20"
        }, [
          Fe(ZK, {
            isActive: v <= U(n),
            icon: d,
            label: f,
            iconClass: c,
            editable: v === 0 ? !0 : !!p,
            stepperItemClass: l.stepperItemClass,
            stepperItemDirection: l.stepperItemDirection,
            stepperType: l.stepperType,
            displayTitleOnMobile: l.displayTitleOnMobile,
            activeColor: l.activeColor,
            variant: l.variant,
            deActiveColor: l.deActiveColor,
            index: v,
            onClick: (h) => i(v)
          }, null, 8, ["isActive", "icon", "label", "iconClass", "editable", "stepperItemClass", "stepperItemDirection", "stepperType", "displayTitleOnMobile", "activeColor", "variant", "deActiveColor", "index", "onClick"]),
          ue("hr", {
            role: "separator",
            class: pe(["block flex-1 group-last:hidden", [v < U(n) ? o.value : s.value]])
          }, null, 2)
        ]))), 128))
      ]),
      ue("div", null, [
        (R(!0), K(Qe, null, kt(l.steps, (d, f) => (R(), K(Qe, null, [
          f === U(n) ? ke(l.$slots, `step(${f})`, { key: 0 }) : fe("", !0)
        ], 64))), 256))
      ])
    ]));
  }
}), rJ = { class: "flex flex-row flex-wrap items-center justify-between gap-8" }, aJ = {
  key: 0,
  class: "sr-only"
}, zoe = /* @__PURE__ */ Ae({
  __name: "JSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    color: { default: "primary" },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = N(
      () => n.value ? "rtl:translate-x-0 ltr:translate-x-20" : "rtl:-translate-x-20 ltr:translate-x-0"
    ), s = Gr(), o = N(() => s("disabled", !0)), l = N(() => r.modelValue ? qa[r.color] : qa.disabled);
    return (u, d) => (R(), Le(U(YA), null, {
      default: Pe(() => [
        ue("div", rJ, [
          u.label ? (R(), Le(U(GA), {
            key: 0,
            "aria-disabled": o.value,
            class: "text-black"
          }, {
            default: Pe(() => [
              jt(Ie(u.label), 1)
            ]),
            _: 1
          }, 8, ["aria-disabled"])) : fe("", !0),
          Fe(U(WA), {
            modelValue: U(n),
            "onUpdate:modelValue": d[0] || (d[0] = (f) => _a(n) ? n.value = f : null),
            class: pe([l.value, "inline-flex h-20 w-40 shrink-0 rounded-3xl border border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 disabled:bg-disabled"]),
            disabled: o.value,
            "aria-disabled": o.value
          }, {
            default: Pe(() => [
              u.label ? (R(), K("span", aJ, Ie(u.label), 1)) : fe("", !0),
              ue("span", {
                class: pe(["pointer-events-none inline-block aspect-square h-full transform rounded-full bg-white ring-0 transition duration-200 ease-in-out", i.value]),
                role: "switch-toggle",
                "aria-hidden": "true"
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "class", "disabled", "aria-disabled"])
        ])
      ]),
      _: 1
    }));
  }
}), nJ = { class: "overflow-x-auto" }, iJ = {
  key: 0,
  class: "mb-12 cursor-default text-center text-gray-500"
}, sJ = { class: "flex" }, oJ = {
  key: 0,
  class: "text-vertical mx-4 cursor-default text-center text-gray-500"
}, lJ = { class: "table flex-1" }, uJ = { key: 1 }, dJ = { key: 0 }, cJ = { key: 1 }, fJ = ["colspan"], pJ = {
  key: 1,
  class: "text-center text-metadata-limited text-gray-500"
}, Yoe = /* @__PURE__ */ Ae({
  __name: "JTable",
  props: {
    fields: {},
    items: {},
    columnTitle: {},
    rowTitle: {},
    noDataText: { default: "No data!" }
  },
  setup(e) {
    const t = e, r = N(
      () => Object.entries(t.fields).map(([i, s]) => s.key)
    ), a = Vn(), n = a("noData");
    return (i, s) => (R(), K("div", nJ, [
      i.columnTitle ? (R(), K("h6", iJ, Ie(i.columnTitle), 1)) : fe("", !0),
      ue("div", sJ, [
        i.rowTitle ? (R(), K("div", oJ, Ie(i.rowTitle), 1)) : fe("", !0),
        ue("table", lJ, [
          ue("thead", null, [
            ue("tr", null, [
              (R(!0), K(Qe, null, kt(i.fields, (o, l) => (R(), K("th", {
                key: l,
                class: pe(["table__th", [
                  l === 0 && "ltr:text-left rtl:text-right",
                  l === i.fields.length - 1 && "ltr:text-right rtl:text-left",
                  l !== 0 && l !== i.fields.length - 1 && "text-center"
                ]])
              }, [
                U(a)(`header(${o.key})`) ? ke(i.$slots, `header(${o.key})`, {
                  key: 0,
                  item: { field: o }
                }) : (R(), K("span", uJ, Ie(o.label), 1))
              ], 2))), 128))
            ])
          ]),
          i.items.length ? (R(), K("tbody", dJ, [
            (R(!0), K(Qe, null, kt(i.items, (o, l) => (R(), K("tr", { key: l }, [
              (R(!0), K(Qe, null, kt(r.value, (u, d) => (R(), K("td", {
                key: d,
                class: pe(["table__td", [
                  d === 0 && "ltr:text-left rtl:text-right",
                  d === i.fields.length - 1 && "ltr:text-right rtl:text-left",
                  d !== 0 && d !== i.fields.length - 1 && "text-center"
                ]])
              }, [
                ke(i.$slots, `cell(${u})`, {
                  value: o[u],
                  item: { item: o, index: l, key: u }
                }, () => [
                  jt(Ie(o[u]), 1)
                ])
              ], 2))), 128))
            ]))), 128))
          ])) : (R(), K("tbody", cJ, [
            ue("tr", null, [
              ue("td", {
                colspan: i.fields.length,
                class: "table__td"
              }, [
                U(n) ? ke(i.$slots, "noData", { key: 0 }) : (R(), K("div", pJ, Ie(i.noDataText), 1))
              ], 8, fJ)
            ])
          ]))
        ])
      ])
    ]));
  }
}), Woe = /* @__PURE__ */ Ae({
  __name: "JTabs",
  props: {
    modelValue: {},
    modelOptions: { type: Boolean },
    vertical: { type: Boolean },
    manual: { type: Boolean, default: !0 },
    defaultIndex: {},
    tabItems: {},
    tabListClass: {},
    tabClass: {},
    buttonClass: {},
    panelsClass: {},
    panelClass: {},
    selectedClass: {},
    tabOnly: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = $r(r, "modelValue", a), i = ne(r.defaultIndex), s = N(() => r.defaultIndex || i.value), o = N(() => !r.vertical && "flex-col"), l = N(() => `${r.vertical && "flex-col"} ${r.tabListClass}`);
    function u(c) {
      return typeof c == "string" ? c : r.modelOptions ? c.label : c;
    }
    function d(c) {
      return typeof c == "string" ? c : r.modelOptions ? c.value : c;
    }
    function f(c) {
      i.value = c, r.modelOptions ? n.value = r.tabItems[c] : n.value = c, a("change", n.value);
    }
    return (c, p) => (R(), Le(U(QA), {
      manual: c.manual,
      defaultIndex: s.value,
      selectedIndex: i.value,
      as: "section",
      class: pe(["flex space-x-1", [o.value]]),
      vertical: c.vertical,
      onChange: f
    }, {
      default: Pe(() => [
        Fe(U(ZA), {
          class: pe(["flex space-x-1", [l.value]])
        }, {
          default: Pe(() => [
            (R(!0), K(Qe, null, kt(c.tabItems, (v, h) => (R(), Le(U(eD), {
              key: `tab-${h}`,
              class: pe([c.tabClass]),
              as: "template"
            }, {
              default: Pe(({ selected: g }) => [
                ue("button", {
                  class: pe([
                    "focus:outline-none",
                    g ? `font-black ${c.buttonClass} ${c.selectedClass}` : `text-sm font-medium leading-5 ${c.buttonClass}`
                  ])
                }, Ie(u(v)), 3)
              ]),
              _: 2
            }, 1032, ["class"]))), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        c.tabOnly ? fe("", !0) : (R(), Le(U(tD), {
          key: 0,
          class: pe(["!-ml-[0.5px] mt-2 w-full", [c.panelsClass]])
        }, {
          default: Pe(() => [
            (R(!0), K(Qe, null, kt(c.tabItems, (v, h) => (R(), Le(U(rD), {
              key: h,
              class: pe([c.panelClass])
            }, {
              default: Pe(() => [
                ke(c.$slots, d(v), {
                  index: h,
                  item: d(v)
                })
              ]),
              _: 2
            }, 1032, ["class"]))), 128))
          ]),
          _: 3
        }, 8, ["class"]))
      ]),
      _: 3
    }, 8, ["manual", "defaultIndex", "selectedIndex", "class", "vertical"]));
  }
}), vJ = [
  {
    name: "Afghanistan",
    flag: "🇦🇫",
    code: "AF",
    dial_code: "+93"
  },
  {
    name: "Åland Islands",
    flag: "🇦🇽",
    code: "AX",
    dial_code: "+358"
  },
  {
    name: "Albania",
    flag: "🇦🇱",
    code: "AL",
    dial_code: "+355"
  },
  {
    name: "Algeria",
    flag: "🇩🇿",
    code: "DZ",
    dial_code: "+213"
  },
  {
    name: "American Samoa",
    flag: "🇦🇸",
    code: "AS",
    dial_code: "+1684"
  },
  {
    name: "Andorra",
    flag: "🇦🇩",
    code: "AD",
    dial_code: "+376"
  },
  {
    name: "Angola",
    flag: "🇦🇴",
    code: "AO",
    dial_code: "+244"
  },
  {
    name: "Anguilla",
    flag: "🇦🇮",
    code: "AI",
    dial_code: "+1264"
  },
  {
    name: "Antarctica",
    flag: "🇦🇶",
    code: "AQ",
    dial_code: "+672"
  },
  {
    name: "Antigua and Barbuda",
    flag: "🇦🇬",
    code: "AG",
    dial_code: "+1268"
  },
  {
    name: "Argentina",
    flag: "🇦🇷",
    code: "AR",
    dial_code: "+54"
  },
  {
    name: "Armenia",
    flag: "🇦🇲",
    code: "AM",
    dial_code: "+374"
  },
  {
    name: "Aruba",
    flag: "🇦🇼",
    code: "AW",
    dial_code: "+297"
  },
  {
    name: "Australia",
    flag: "🇦🇺",
    code: "AU",
    dial_code: "+61"
  },
  {
    name: "Austria",
    flag: "🇦🇹",
    code: "AT",
    dial_code: "+43"
  },
  {
    name: "Azerbaijan",
    flag: "🇦🇿",
    code: "AZ",
    dial_code: "+994"
  },
  {
    name: "Bahamas",
    flag: "🇧🇸",
    code: "BS",
    dial_code: "+1242"
  },
  {
    name: "Bahrain",
    flag: "🇧🇭",
    code: "BH",
    dial_code: "+973"
  },
  {
    name: "Bangladesh",
    flag: "🇧🇩",
    code: "BD",
    dial_code: "+880"
  },
  {
    name: "Barbados",
    flag: "🇧🇧",
    code: "BB",
    dial_code: "+1246"
  },
  {
    name: "Belarus",
    flag: "🇧🇾",
    code: "BY",
    dial_code: "+375"
  },
  {
    name: "Belgium",
    flag: "🇧🇪",
    code: "BE",
    dial_code: "+32"
  },
  {
    name: "Belize",
    flag: "🇧🇿",
    code: "BZ",
    dial_code: "+501"
  },
  {
    name: "Benin",
    flag: "🇧🇯",
    code: "BJ",
    dial_code: "+229"
  },
  {
    name: "Bermuda",
    flag: "🇧🇲",
    code: "BM",
    dial_code: "+1441"
  },
  {
    name: "Bhutan",
    flag: "🇧🇹",
    code: "BT",
    dial_code: "+975"
  },
  {
    name: "Bolivia, Plurinational State of bolivia",
    flag: "🇧🇴",
    code: "BO",
    dial_code: "+591"
  },
  {
    name: "Bosnia and Herzegovina",
    flag: "🇧🇦",
    code: "BA",
    dial_code: "+387"
  },
  {
    name: "Botswana",
    flag: "🇧🇼",
    code: "BW",
    dial_code: "+267"
  },
  {
    name: "Bouvet Island",
    flag: "🇧🇻",
    code: "BV",
    dial_code: "+47"
  },
  {
    name: "Brazil",
    flag: "🇧🇷",
    code: "BR",
    dial_code: "+55"
  },
  {
    name: "British Indian Ocean Territory",
    flag: "🇮🇴",
    code: "IO",
    dial_code: "+246"
  },
  {
    name: "Brunei Darussalam",
    flag: "🇧🇳",
    code: "BN",
    dial_code: "+673"
  },
  {
    name: "Bulgaria",
    flag: "🇧🇬",
    code: "BG",
    dial_code: "+359"
  },
  {
    name: "Burkina Faso",
    flag: "🇧🇫",
    code: "BF",
    dial_code: "+226"
  },
  {
    name: "Burundi",
    flag: "🇧🇮",
    code: "BI",
    dial_code: "+257"
  },
  {
    name: "Cambodia",
    flag: "🇰🇭",
    code: "KH",
    dial_code: "+855"
  },
  {
    name: "Cameroon",
    flag: "🇨🇲",
    code: "CM",
    dial_code: "+237"
  },
  {
    name: "Canada",
    flag: "🇨🇦",
    code: "CA",
    dial_code: "+1"
  },
  {
    name: "Cape Verde",
    flag: "🇨🇻",
    code: "CV",
    dial_code: "+238"
  },
  {
    name: "Cayman Islands",
    flag: "🇰🇾",
    code: "KY",
    dial_code: "+345"
  },
  {
    name: "Central African Republic",
    flag: "🇨🇫",
    code: "CF",
    dial_code: "+236"
  },
  {
    name: "Chad",
    flag: "🇹🇩",
    code: "TD",
    dial_code: "+235"
  },
  {
    name: "Chile",
    flag: "🇨🇱",
    code: "CL",
    dial_code: "+56"
  },
  {
    name: "China",
    flag: "🇨🇳",
    code: "CN",
    dial_code: "+86"
  },
  {
    name: "Christmas Island",
    flag: "🇨🇽",
    code: "CX",
    dial_code: "+61"
  },
  {
    name: "Cocos (Keeling) Islands",
    flag: "🇨🇨",
    code: "CC",
    dial_code: "+61"
  },
  {
    name: "Colombia",
    flag: "🇨🇴",
    code: "CO",
    dial_code: "+57"
  },
  {
    name: "Comoros",
    flag: "🇰🇲",
    code: "KM",
    dial_code: "+269"
  },
  {
    name: "Congo",
    flag: "🇨🇬",
    code: "CG",
    dial_code: "+242"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    flag: "🇨🇩",
    code: "CD",
    dial_code: "+243"
  },
  {
    name: "Cook Islands",
    flag: "🇨🇰",
    code: "CK",
    dial_code: "+682"
  },
  {
    name: "Costa Rica",
    flag: "🇨🇷",
    code: "CR",
    dial_code: "+506"
  },
  {
    name: "Cote d'Ivoire",
    flag: "🇨🇮",
    code: "CI",
    dial_code: "+225"
  },
  {
    name: "Croatia",
    flag: "🇭🇷",
    code: "HR",
    dial_code: "+385"
  },
  {
    name: "Cuba",
    flag: "🇨🇺",
    code: "CU",
    dial_code: "+53"
  },
  {
    name: "Cyprus",
    flag: "🇨🇾",
    code: "CY",
    dial_code: "+357"
  },
  {
    name: "Czech Republic",
    flag: "🇨🇿",
    code: "CZ",
    dial_code: "+420"
  },
  {
    name: "Denmark",
    flag: "🇩🇰",
    code: "DK",
    dial_code: "+45"
  },
  {
    name: "Djibouti",
    flag: "🇩🇯",
    code: "DJ",
    dial_code: "+253"
  },
  {
    name: "Dominica",
    flag: "🇩🇲",
    code: "DM",
    dial_code: "+1767"
  },
  {
    name: "Dominican Republic",
    flag: "🇩🇴",
    code: "DO",
    dial_code: "+1849"
  },
  {
    name: "Ecuador",
    flag: "🇪🇨",
    code: "EC",
    dial_code: "+593"
  },
  {
    name: "Egypt",
    flag: "🇪🇬",
    code: "EG",
    dial_code: "+20"
  },
  {
    name: "El Salvador",
    flag: "🇸🇻",
    code: "SV",
    dial_code: "+503"
  },
  {
    name: "Equatorial Guinea",
    flag: "🇬🇶",
    code: "GQ",
    dial_code: "+240"
  },
  {
    name: "Eritrea",
    flag: "🇪🇷",
    code: "ER",
    dial_code: "+291"
  },
  {
    name: "Estonia",
    flag: "🇪🇪",
    code: "EE",
    dial_code: "+372"
  },
  {
    name: "Ethiopia",
    flag: "🇪🇹",
    code: "ET",
    dial_code: "+251"
  },
  {
    name: "Falkland Islands (Malvinas)",
    flag: "🇫🇰",
    code: "FK",
    dial_code: "+500"
  },
  {
    name: "Faroe Islands",
    flag: "🇫🇴",
    code: "FO",
    dial_code: "+298"
  },
  {
    name: "Fiji",
    flag: "🇫🇯",
    code: "FJ",
    dial_code: "+679"
  },
  {
    name: "Finland",
    flag: "🇫🇮",
    code: "FI",
    dial_code: "+358"
  },
  {
    name: "France",
    flag: "🇫🇷",
    code: "FR",
    dial_code: "+33"
  },
  {
    name: "French Guiana",
    flag: "🇬🇫",
    code: "GF",
    dial_code: "+594"
  },
  {
    name: "French Polynesia",
    flag: "🇵🇫",
    code: "PF",
    dial_code: "+689"
  },
  {
    name: "French Southern Territories",
    flag: "🇹🇫",
    code: "TF",
    dial_code: "+262"
  },
  {
    name: "Gabon",
    flag: "🇬🇦",
    code: "GA",
    dial_code: "+241"
  },
  {
    name: "Gambia",
    flag: "🇬🇲",
    code: "GM",
    dial_code: "+220"
  },
  {
    name: "Georgia",
    flag: "🇬🇪",
    code: "GE",
    dial_code: "+995"
  },
  {
    name: "Germany",
    flag: "🇩🇪",
    code: "DE",
    dial_code: "+49"
  },
  {
    name: "Ghana",
    flag: "🇬🇭",
    code: "GH",
    dial_code: "+233"
  },
  {
    name: "Gibraltar",
    flag: "🇬🇮",
    code: "GI",
    dial_code: "+350"
  },
  {
    name: "Greece",
    flag: "🇬🇷",
    code: "GR",
    dial_code: "+30"
  },
  {
    name: "Greenland",
    flag: "🇬🇱",
    code: "GL",
    dial_code: "+299"
  },
  {
    name: "Grenada",
    flag: "🇬🇩",
    code: "GD",
    dial_code: "+1473"
  },
  {
    name: "Guadeloupe",
    flag: "🇬🇵",
    code: "GP",
    dial_code: "+590"
  },
  {
    name: "Guam",
    flag: "🇬🇺",
    code: "GU",
    dial_code: "+1671"
  },
  {
    name: "Guatemala",
    flag: "🇬🇹",
    code: "GT",
    dial_code: "+502"
  },
  {
    name: "Guernsey",
    flag: "🇬🇬",
    code: "GG",
    dial_code: "+44"
  },
  {
    name: "Guinea",
    flag: "🇬🇳",
    code: "GN",
    dial_code: "+224"
  },
  {
    name: "Guinea-Bissau",
    flag: "🇬🇼",
    code: "GW",
    dial_code: "+245"
  },
  {
    name: "Guyana",
    flag: "🇬🇾",
    code: "GY",
    dial_code: "+592"
  },
  {
    name: "Haiti",
    flag: "🇭🇹",
    code: "HT",
    dial_code: "+509"
  },
  {
    name: "Heard Island and Mcdonald Islands",
    flag: "🇭🇲",
    code: "HM",
    dial_code: "+672"
  },
  {
    name: "Holy See (Vatican City State)",
    flag: "🇻🇦",
    code: "VA",
    dial_code: "+379"
  },
  {
    name: "Honduras",
    flag: "🇭🇳",
    code: "HN",
    dial_code: "+504"
  },
  {
    name: "Hong Kong",
    flag: "🇭🇰",
    code: "HK",
    dial_code: "+852"
  },
  {
    name: "Hungary",
    flag: "🇭🇺",
    code: "HU",
    dial_code: "+36"
  },
  {
    name: "Iceland",
    flag: "🇮🇸",
    code: "IS",
    dial_code: "+354"
  },
  {
    name: "India",
    flag: "🇮🇳",
    code: "IN",
    dial_code: "+91"
  },
  {
    name: "Indonesia",
    flag: "🇮🇩",
    code: "ID",
    dial_code: "+62"
  },
  {
    name: "Iran, Islamic Republic of",
    flag: "🇮🇷",
    code: "IR",
    dial_code: "+98"
  },
  {
    name: "Iraq",
    flag: "🇮🇶",
    code: "IQ",
    dial_code: "+964"
  },
  {
    name: "Ireland",
    flag: "🇮🇪",
    code: "IE",
    dial_code: "+353"
  },
  {
    name: "Isle of Man",
    flag: "🇮🇲",
    code: "IM",
    dial_code: "+44"
  },
  {
    name: "Israel",
    flag: "🇮🇱",
    code: "IL",
    dial_code: "+972"
  },
  {
    name: "Italy",
    flag: "🇮🇹",
    code: "IT",
    dial_code: "+39"
  },
  {
    name: "Jamaica",
    flag: "🇯🇲",
    code: "JM",
    dial_code: "+1876"
  },
  {
    name: "Japan",
    flag: "🇯🇵",
    code: "JP",
    dial_code: "+81"
  },
  {
    name: "Jersey",
    flag: "🇯🇪",
    code: "JE",
    dial_code: "+44"
  },
  {
    name: "Jordan",
    flag: "🇯🇴",
    code: "JO",
    dial_code: "+962"
  },
  {
    name: "Kazakhstan",
    flag: "🇰🇿",
    code: "KZ",
    dial_code: "+7"
  },
  {
    name: "Kenya",
    flag: "🇰🇪",
    code: "KE",
    dial_code: "+254"
  },
  {
    name: "Kiribati",
    flag: "🇰🇮",
    code: "KI",
    dial_code: "+686"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    flag: "🇰🇵",
    code: "KP",
    dial_code: "+850"
  },
  {
    name: "Korea, Republic of South Korea",
    flag: "🇰🇷",
    code: "KR",
    dial_code: "+82"
  },
  {
    name: "Kosovo",
    flag: "🇽🇰",
    code: "XK",
    dial_code: "+383"
  },
  {
    name: "Kuwait",
    flag: "🇰🇼",
    code: "KW",
    dial_code: "+965"
  },
  {
    name: "Kyrgyzstan",
    flag: "🇰🇬",
    code: "KG",
    dial_code: "+996"
  },
  {
    name: "Laos",
    flag: "🇱🇦",
    code: "LA",
    dial_code: "+856"
  },
  {
    name: "Latvia",
    flag: "🇱🇻",
    code: "LV",
    dial_code: "+371"
  },
  {
    name: "Lebanon",
    flag: "🇱🇧",
    code: "LB",
    dial_code: "+961"
  },
  {
    name: "Lesotho",
    flag: "🇱🇸",
    code: "LS",
    dial_code: "+266"
  },
  {
    name: "Liberia",
    flag: "🇱🇷",
    code: "LR",
    dial_code: "+231"
  },
  {
    name: "Libyan Arab Jamahiriya",
    flag: "🇱🇾",
    code: "LY",
    dial_code: "+218"
  },
  {
    name: "Liechtenstein",
    flag: "🇱🇮",
    code: "LI",
    dial_code: "+423"
  },
  {
    name: "Lithuania",
    flag: "🇱🇹",
    code: "LT",
    dial_code: "+370"
  },
  {
    name: "Luxembourg",
    flag: "🇱🇺",
    code: "LU",
    dial_code: "+352"
  },
  {
    name: "Macao",
    flag: "🇲🇴",
    code: "MO",
    dial_code: "+853"
  },
  {
    name: "Macedonia",
    flag: "🇲🇰",
    code: "MK",
    dial_code: "+389"
  },
  {
    name: "Madagascar",
    flag: "🇲🇬",
    code: "MG",
    dial_code: "+261"
  },
  {
    name: "Malawi",
    flag: "🇲🇼",
    code: "MW",
    dial_code: "+265"
  },
  {
    name: "Malaysia",
    flag: "🇲🇾",
    code: "MY",
    dial_code: "+60"
  },
  {
    name: "Maldives",
    flag: "🇲🇻",
    code: "MV",
    dial_code: "+960"
  },
  {
    name: "Mali",
    flag: "🇲🇱",
    code: "ML",
    dial_code: "+223"
  },
  {
    name: "Malta",
    flag: "🇲🇹",
    code: "MT",
    dial_code: "+356"
  },
  {
    name: "Marshall Islands",
    flag: "🇲🇭",
    code: "MH",
    dial_code: "+692"
  },
  {
    name: "Martinique",
    flag: "🇲🇶",
    code: "MQ",
    dial_code: "+596"
  },
  {
    name: "Mauritania",
    flag: "🇲🇷",
    code: "MR",
    dial_code: "+222"
  },
  {
    name: "Mauritius",
    flag: "🇲🇺",
    code: "MU",
    dial_code: "+230"
  },
  {
    name: "Mayotte",
    flag: "🇾🇹",
    code: "YT",
    dial_code: "+262"
  },
  {
    name: "Mexico",
    flag: "🇲🇽",
    code: "MX",
    dial_code: "+52"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    flag: "🇫🇲",
    code: "FM",
    dial_code: "+691"
  },
  {
    name: "Moldova",
    flag: "🇲🇩",
    code: "MD",
    dial_code: "+373"
  },
  {
    name: "Monaco",
    flag: "🇲🇨",
    code: "MC",
    dial_code: "+377"
  },
  {
    name: "Mongolia",
    flag: "🇲🇳",
    code: "MN",
    dial_code: "+976"
  },
  {
    name: "Montenegro",
    flag: "🇲🇪",
    code: "ME",
    dial_code: "+382"
  },
  {
    name: "Montserrat",
    flag: "🇲🇸",
    code: "MS",
    dial_code: "+1664"
  },
  {
    name: "Morocco",
    flag: "🇲🇦",
    code: "MA",
    dial_code: "+212"
  },
  {
    name: "Mozambique",
    flag: "🇲🇿",
    code: "MZ",
    dial_code: "+258"
  },
  {
    name: "Myanmar",
    flag: "🇲🇲",
    code: "MM",
    dial_code: "+95"
  },
  {
    name: "Namibia",
    flag: "🇳🇦",
    code: "NA",
    dial_code: "+264"
  },
  {
    name: "Nauru",
    flag: "🇳🇷",
    code: "NR",
    dial_code: "+674"
  },
  {
    name: "Nepal",
    flag: "🇳🇵",
    code: "NP",
    dial_code: "+977"
  },
  {
    name: "Netherlands",
    flag: "🇳🇱",
    code: "NL",
    dial_code: "+31"
  },
  {
    name: "Netherlands Antilles",
    flag: "",
    code: "AN",
    dial_code: "+599"
  },
  {
    name: "New Caledonia",
    flag: "🇳🇨",
    code: "NC",
    dial_code: "+687"
  },
  {
    name: "New Zealand",
    flag: "🇳🇿",
    code: "NZ",
    dial_code: "+64"
  },
  {
    name: "Nicaragua",
    flag: "🇳🇮",
    code: "NI",
    dial_code: "+505"
  },
  {
    name: "Niger",
    flag: "🇳🇪",
    code: "NE",
    dial_code: "+227"
  },
  {
    name: "Nigeria",
    flag: "🇳🇬",
    code: "NG",
    dial_code: "+234"
  },
  {
    name: "Niue",
    flag: "🇳🇺",
    code: "NU",
    dial_code: "+683"
  },
  {
    name: "Norfolk Island",
    flag: "🇳🇫",
    code: "NF",
    dial_code: "+672"
  },
  {
    name: "Northern Mariana Islands",
    flag: "🇲🇵",
    code: "MP",
    dial_code: "+1670"
  },
  {
    name: "Norway",
    flag: "🇳🇴",
    code: "NO",
    dial_code: "+47"
  },
  {
    name: "Oman",
    flag: "🇴🇲",
    code: "OM",
    dial_code: "+968"
  },
  {
    name: "Pakistan",
    flag: "🇵🇰",
    code: "PK",
    dial_code: "+92"
  },
  {
    name: "Palau",
    flag: "🇵🇼",
    code: "PW",
    dial_code: "+680"
  },
  {
    name: "Palestinian Territory, Occupied",
    flag: "🇵🇸",
    code: "PS",
    dial_code: "+970"
  },
  {
    name: "Panama",
    flag: "🇵🇦",
    code: "PA",
    dial_code: "+507"
  },
  {
    name: "Papua New Guinea",
    flag: "🇵🇬",
    code: "PG",
    dial_code: "+675"
  },
  {
    name: "Paraguay",
    flag: "🇵🇾",
    code: "PY",
    dial_code: "+595"
  },
  {
    name: "Peru",
    flag: "🇵🇪",
    code: "PE",
    dial_code: "+51"
  },
  {
    name: "Philippines",
    flag: "🇵🇭",
    code: "PH",
    dial_code: "+63"
  },
  {
    name: "Pitcairn",
    flag: "🇵🇳",
    code: "PN",
    dial_code: "+64"
  },
  {
    name: "Poland",
    flag: "🇵🇱",
    code: "PL",
    dial_code: "+48"
  },
  {
    name: "Portugal",
    flag: "🇵🇹",
    code: "PT",
    dial_code: "+351"
  },
  {
    name: "Puerto Rico",
    flag: "🇵🇷",
    code: "PR",
    dial_code: "+1939"
  },
  {
    name: "Qatar",
    flag: "🇶🇦",
    code: "QA",
    dial_code: "+974"
  },
  {
    name: "Romania",
    flag: "🇷🇴",
    code: "RO",
    dial_code: "+40"
  },
  {
    name: "Rwanda",
    flag: "🇷🇼",
    code: "RW",
    dial_code: "+250"
  },
  {
    name: "Reunion",
    flag: "🇷🇪",
    code: "RE",
    dial_code: "+262"
  },
  {
    name: "Saint Barthelemy",
    flag: "🇧🇱",
    code: "BL",
    dial_code: "+590"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    flag: "🇸🇭",
    code: "SH",
    dial_code: "+290"
  },
  {
    name: "Saint Kitts and Nevis",
    flag: "🇰🇳",
    code: "KN",
    dial_code: "+1869"
  },
  {
    name: "Saint Lucia",
    flag: "🇱🇨",
    code: "LC",
    dial_code: "+1758"
  },
  {
    name: "Saint Martin",
    flag: "🇲🇫",
    code: "MF",
    dial_code: "+590"
  },
  {
    name: "Saint Pierre and Miquelon",
    flag: "🇵🇲",
    code: "PM",
    dial_code: "+508"
  },
  {
    name: "Saint Vincent and the Grenadines",
    flag: "🇻🇨",
    code: "VC",
    dial_code: "+1784"
  },
  {
    name: "Samoa",
    flag: "🇼🇸",
    code: "WS",
    dial_code: "+685"
  },
  {
    name: "San Marino",
    flag: "🇸🇲",
    code: "SM",
    dial_code: "+378"
  },
  {
    name: "Sao Tome and Principe",
    flag: "🇸🇹",
    code: "ST",
    dial_code: "+239"
  },
  {
    name: "Saudi Arabia",
    flag: "🇸🇦",
    code: "SA",
    dial_code: "+966"
  },
  {
    name: "Senegal",
    flag: "🇸🇳",
    code: "SN",
    dial_code: "+221"
  },
  {
    name: "Serbia",
    flag: "🇷🇸",
    code: "RS",
    dial_code: "+381"
  },
  {
    name: "Seychelles",
    flag: "🇸🇨",
    code: "SC",
    dial_code: "+248"
  },
  {
    name: "Sierra Leone",
    flag: "🇸🇱",
    code: "SL",
    dial_code: "+232"
  },
  {
    name: "Singapore",
    flag: "🇸🇬",
    code: "SG",
    dial_code: "+65"
  },
  {
    name: "Slovakia",
    flag: "🇸🇰",
    code: "SK",
    dial_code: "+421"
  },
  {
    name: "Slovenia",
    flag: "🇸🇮",
    code: "SI",
    dial_code: "+386"
  },
  {
    name: "Solomon Islands",
    flag: "🇸🇧",
    code: "SB",
    dial_code: "+677"
  },
  {
    name: "Somalia",
    flag: "🇸🇴",
    code: "SO",
    dial_code: "+252"
  },
  {
    name: "South Africa",
    flag: "🇿🇦",
    code: "ZA",
    dial_code: "+27"
  },
  {
    name: "South Sudan",
    flag: "🇸🇸",
    code: "SS",
    dial_code: "+211"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    flag: "🇬🇸",
    code: "GS",
    dial_code: "+500"
  },
  {
    name: "Spain",
    flag: "🇪🇸",
    code: "ES",
    dial_code: "+34"
  },
  {
    name: "Sri Lanka",
    flag: "🇱🇰",
    code: "LK",
    dial_code: "+94"
  },
  {
    name: "Sudan",
    flag: "🇸🇩",
    code: "SD",
    dial_code: "+249"
  },
  {
    name: "Suriname",
    flag: "🇸🇷",
    code: "SR",
    dial_code: "+597"
  },
  {
    name: "Svalbard and Jan Mayen",
    flag: "🇸🇯",
    code: "SJ",
    dial_code: "+47"
  },
  {
    name: "Eswatini",
    flag: "🇸🇿",
    code: "SZ",
    dial_code: "+268"
  },
  {
    name: "Sweden",
    flag: "🇸🇪",
    code: "SE",
    dial_code: "+46"
  },
  {
    name: "Switzerland",
    flag: "🇨🇭",
    code: "CH",
    dial_code: "+41"
  },
  {
    name: "Syrian Arab Republic",
    flag: "🇸🇾",
    code: "SY",
    dial_code: "+963"
  },
  {
    name: "Taiwan",
    flag: "🇹🇼",
    code: "TW",
    dial_code: "+886"
  },
  {
    name: "Tajikistan",
    flag: "🇹🇯",
    code: "TJ",
    dial_code: "+992"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    flag: "🇹🇿",
    code: "TZ",
    dial_code: "+255"
  },
  {
    name: "Thailand",
    flag: "🇹🇭",
    code: "TH",
    dial_code: "+66"
  },
  {
    name: "Timor-Leste",
    flag: "🇹🇱",
    code: "TL",
    dial_code: "+670"
  },
  {
    name: "Togo",
    flag: "🇹🇬",
    code: "TG",
    dial_code: "+228"
  },
  {
    name: "Tokelau",
    flag: "🇹🇰",
    code: "TK",
    dial_code: "+690"
  },
  {
    name: "Tonga",
    flag: "🇹🇴",
    code: "TO",
    dial_code: "+676"
  },
  {
    name: "Trinidad and Tobago",
    flag: "🇹🇹",
    code: "TT",
    dial_code: "+1868"
  },
  {
    name: "Tunisia",
    flag: "🇹🇳",
    code: "TN",
    dial_code: "+216"
  },
  {
    name: "Turkey",
    flag: "🇹🇷",
    code: "TR",
    dial_code: "+90"
  },
  {
    name: "Turkmenistan",
    flag: "🇹🇲",
    code: "TM",
    dial_code: "+993"
  },
  {
    name: "Turks and Caicos Islands",
    flag: "🇹🇨",
    code: "TC",
    dial_code: "+1649"
  },
  {
    name: "Tuvalu",
    flag: "🇹🇻",
    code: "TV",
    dial_code: "+688"
  },
  {
    name: "Uganda",
    flag: "🇺🇬",
    code: "UG",
    dial_code: "+256"
  },
  {
    name: "Ukraine",
    flag: "🇺🇦",
    code: "UA",
    dial_code: "+380"
  },
  {
    name: "United Arab Emirates",
    flag: "🇦🇪",
    code: "AE",
    dial_code: "+971"
  },
  {
    name: "United Kingdom",
    flag: "🇬🇧",
    code: "GB",
    dial_code: "+44"
  },
  {
    name: "United States",
    flag: "🇺🇸",
    code: "US",
    dial_code: "+1"
  },
  {
    name: "Uruguay",
    flag: "🇺🇾",
    code: "UY",
    dial_code: "+598"
  },
  {
    name: "Uzbekistan",
    flag: "🇺🇿",
    code: "UZ",
    dial_code: "+998"
  },
  {
    name: "Vanuatu",
    flag: "🇻🇺",
    code: "VU",
    dial_code: "+678"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    flag: "🇻🇪",
    code: "VE",
    dial_code: "+58"
  },
  {
    name: "Vietnam",
    flag: "🇻🇳",
    code: "VN",
    dial_code: "+84"
  },
  {
    name: "Virgin Islands, British",
    flag: "🇻🇬",
    code: "VG",
    dial_code: "+1284"
  },
  {
    name: "Virgin Islands, U.S.",
    flag: "🇻🇮",
    code: "VI",
    dial_code: "+1340"
  },
  {
    name: "Wallis and Futuna",
    flag: "🇼🇫",
    code: "WF",
    dial_code: "+681"
  },
  {
    name: "Yemen",
    flag: "🇾🇪",
    code: "YE",
    dial_code: "+967"
  },
  {
    name: "Zambia",
    flag: "🇿🇲",
    code: "ZM",
    dial_code: "+260"
  },
  {
    name: "Zimbabwe",
    flag: "🇿🇼",
    code: "ZW",
    dial_code: "+263"
  }
], mJ = { class: "input relative" }, hJ = { class: "relative" }, gJ = { class: "relative flex w-full items-stretch" }, bJ = ["value", "disabled"], yJ = ["value", "disabled"], _J = ["onClick"], Goe = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JTelInput",
  props: {
    modelValue: { default: () => ({
      code: "",
      number: ""
    }) },
    label: {},
    error: { default: "" },
    color: { default: "gray-400" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = Gr(), i = n("required", !0), s = n("disabled", !0), o = ne(null), l = ne(null), u = ne(null), { focused: d } = v5(u), f = ne(
      r.modelValue || { code: "", number: "" }
    );
    function c() {
      a("update:modelValue", {
        code: f.value.code,
        number: f.value.number
      });
    }
    function p(S) {
      const P = S.target, { name: A, value: E } = P;
      f.value[A] = E, c();
    }
    He(
      () => r.modelValue,
      (S) => {
        f.value = {
          code: S == null ? void 0 : S.code,
          number: S == null ? void 0 : S.number
        };
      }
    );
    const v = ne(), h = ne(!1);
    function g() {
      h.value || (h.value = !0);
    }
    const m = N(() => {
      var A;
      const S = /(?:\+(\d+))|\b(\d+)\b/, P = (A = f.value.code) == null ? void 0 : A.match(S);
      return P ? `+${P[1] || P[2]}` : "";
    }), b = N(() => {
      function S(P, A) {
        const E = P.name.toLowerCase(), O = A.name.toLowerCase();
        return E < O ? -1 : E > O ? 1 : 0;
      }
      return vJ.slice().sort(S);
    }), y = N(() => {
      var P;
      const S = (P = f.value.code) == null ? void 0 : P.toLowerCase().trim();
      if (S === "" || !S)
        return b.value;
      {
        const A = b.value.filter((O) => m.value.length ? O.dial_code.includes(m.value) : O.name.toLowerCase().includes(S)), E = b.value.filter(
          (O) => !A.includes(O)
        );
        return [...A, ...E];
      }
    });
    async function _(S) {
      v.value = S, f.value.code = S.dial_code, h.value = !1, setTimeout(() => {
        d.value = !d.value;
      }, 5), c();
    }
    He(
      () => f.value.code,
      (S) => {
        var A;
        const P = b.value.find(
          (E) => E.dial_code === S || E.dial_code === `+${S}`
        );
        !((A = f.value.code) != null && A.startsWith("+")) && P && _(P), v.value = P || void 0, v.value && (h.value = !1);
      },
      {
        immediate: !0
      }
    ), du(o, (S) => {
      S.target !== l.value && (h.value = !1);
    });
    const x = N(() => Zd[r.color]), w = N(
      () => r.error.length ? "border-danger" : "border-gray-300"
    );
    function k(S) {
      const P = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter"
      ];
      !S.key.match(/^[0-9]+$/) && !P.includes(S.key) && S.preventDefault();
    }
    return (S, P) => (R(), K("label", mJ, [
      S.label ? (R(), K("span", {
        key: 0,
        class: pe(["input__label", [U(i) && "input--required"]])
      }, Ie(S.label), 3)) : fe("", !0),
      ue("div", hJ, [
        ue("div", gJ, [
          v.value ? (R(), K("span", {
            key: 0,
            class: pe(["fi !absolute left-10 top-1/2 -translate-y-1/2", [`fi-${v.value.code.toLocaleLowerCase()}`]])
          }, null, 2)) : fe("", !0),
          ue("input", {
            ref_key: "codeInputRef",
            ref: l,
            value: f.value.code,
            type: "text",
            class: pe(["input__field w-[80px] rounded-r-none border-r-0 pl-32", [x.value, w.value]]),
            placeholder: "+1",
            name: "code",
            autocomplete: "off",
            disabled: U(s),
            onInput: p,
            onMouseup: P[0] || (P[0] = (A) => h.value = !0),
            onKeydown: [
              P[1] || (P[1] = Ot((A) => h.value = !1, ["tab"])),
              Ot(g, ["delete"])
            ]
          }, null, 42, bJ),
          ue("input", {
            ref_key: "numberInputRef",
            ref: u,
            value: f.value.number,
            type: "text",
            class: pe(["input__field flex-1 rounded-l-none", [x.value, w.value]]),
            placeholder: "XXX XXX XX",
            name: "number",
            autocomplete: "off",
            disabled: U(s),
            onInput: p,
            onKeydown: k
          }, null, 42, yJ)
        ]),
        ea(ue("ul", {
          ref_key: "optionsRef",
          ref: o,
          class: "text-sm absolute top-full z-30 mt-4 max-h-[200px] w-full overflow-y-auto rounded-md border border-gray-300 bg-white text-base focus:outline-none"
        }, [
          (R(!0), K(Qe, null, kt(y.value, (A, E) => (R(), K("li", {
            key: E,
            class: pe(["cursor-pointer px-4 hover:bg-gray-200", [
              JSON.stringify(A) === JSON.stringify(v.value) && "bg-primary-light"
            ]]),
            onClick: (O) => _(A)
          }, [
            ue("span", {
              class: pe(["fi", [`fi-${A.code.toLocaleLowerCase()}`]])
            }, null, 2),
            jt(" " + Ie(A.name) + " ", 1),
            ue("strong", null, Ie(A.dial_code), 1)
          ], 10, _J))), 128))
        ], 512), [
          [$a, h.value]
        ])
      ]),
      ue("span", {
        class: pe(["input__error", [S.error && "mt-4"]])
      }, Ie(S.error), 3)
    ]));
  }
});
const xJ = { class: "input" }, wJ = { class: "input__wrapper" }, TJ = ["id", "disabled", "aria-disabled", "name", "placeholder"], SJ = { class: "input__error" }, Xoe = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JTextArea",
  props: {
    modelValue: {},
    label: { default: "" },
    color: { default: "gray-400" },
    id: {},
    name: { default: "" },
    error: { default: "" },
    placeholder: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = Gr(), i = N(() => r.id || `text-area-${cu()}`), s = $r(r, "modelValue", a), o = N(() => Zd[r.color]), l = N(() => n("required", !0)), u = N(() => n("disabled", !0)), d = N(() => !!r.label), f = N(
      () => l.value && !d.value ? `${r.placeholder} *` : r.placeholder
    ), c = N(
      () => r.error.length ? "border-danger" : "border-gray-300"
    );
    return (p, v) => (R(), K("label", xJ, [
      p.label ? (R(), K("span", {
        key: 0,
        class: pe(["input__label", l.value && "input--required"])
      }, Ie(p.label), 3)) : fe("", !0),
      ue("span", wJ, [
        ea(ue("textarea", Mt({
          id: i.value,
          "onUpdate:modelValue": v[0] || (v[0] = (h) => _a(s) ? s.value = h : null),
          disabled: u.value,
          "aria-disabled": u.value,
          name: p.name,
          class: [o.value, c.value, p.error && "mb-4"],
          placeholder: f.value
        }, p.$attrs, { class: "input__field" }), null, 16, TJ), [
          [V4, U(s)]
        ]),
        ue("span", SJ, Ie(p.error), 1)
      ])
    ]));
  }
}), EJ = "border-gray-300", OJ = "border-danger", CJ = { class: "input" }, kJ = { class: "input__wrapper" }, PJ = ["disabled", "aria-disabled", "type", "placeholder", "aria-placeholder", "required"], MJ = {
  key: 4,
  class: "input__error"
}, AJ = {
  key: 5,
  class: "input__hint mb-4"
}, DJ = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JTextInput",
  props: {
    color: { default: "gray-400" },
    type: { default: "text" },
    label: { default: "" },
    error: { default: "" },
    modelValue: { default: "" },
    appendIcon: { default: void 0 },
    prependIcon: { default: void 0 },
    placeholder: { default: "" },
    modelModifiers: {},
    hint: {},
    iconClass: {}
  },
  emits: ["update:modelValue", "click:prepend", "click:append"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = Gr(), i = $d(), s = ne(r.modelValue), o = N(() => {
      var F;
      return !!((F = r.modelModifiers) != null && F.debounce);
    });
    n5(
      s,
      (F) => a("update:modelValue", F),
      {
        debounce: o.value ? 1e3 : void 0,
        maxWait: o.value ? 5e3 : void 0
      }
    ), He(
      () => r.modelValue,
      (F) => {
        s.value = F;
      }
    );
    const l = N(() => Zd[r.color]), u = N(() => gn[r.color]), d = N(
      () => r.iconClass ? `${u.value} ${r.iconClass}` : u.value
    ), f = N(
      () => r.error.length ? OJ : EJ
    ), c = N(() => r.type === "search"), p = N(() => r.type === "password"), v = ne("password"), h = N(() => v.value === "text");
    function g() {
      v.value = "password";
    }
    function m() {
      v.value = "text";
    }
    function b() {
      h.value ? g() : m();
    }
    const y = N(
      () => r.appendIcon || r.type === "search"
    ), _ = N(() => y.value && "pe-40"), x = () => a("click:append"), w = N(() => r.prependIcon), k = N(() => w.value && "ps-40"), S = () => a("click:prepend"), P = N(() => n("required", !0)), A = N(() => !!r.label), E = N(
      () => P.value && !A.value ? `${r.placeholder} *` : r.placeholder
    ), O = N(() => n("disabled", !0)), { currentLocaleItem: T } = Ii(), D = N(
      () => r.type === "email" || r.type === "password" || r.type === "number" || r.type === "tel"
    ), $ = N(
      () => D.value ? "ltr" : T.value.rtl ? "rtl" : "ltr"
    );
    function I(F) {
      if (r.type !== "number")
        return;
      const j = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter"
      ];
      !F.key.match(/^[0-9.]$/) && !j.includes(F.key) && F.preventDefault();
    }
    return (F, j) => (R(), K("label", CJ, [
      F.label ? (R(), K("span", {
        key: 0,
        class: pe(["input__label", P.value && "input--required"])
      }, Ie(F.label), 3)) : fe("", !0),
      ue("span", kJ, [
        ea(ue("input", Mt({
          "onUpdate:modelValue": j[0] || (j[0] = (M) => s.value = M),
          disabled: O.value,
          "aria-disabled": O.value,
          type: p.value ? v.value : F.type
        }, U(i), {
          placeholder: E.value,
          "aria-placeholder": E.value,
          required: P.value,
          class: ["input__field", [
            l.value,
            f.value,
            _.value,
            k.value,
            F.error && "mb-4"
          ]],
          style: {
            direction: $.value
          },
          onKeydown: I
        }), null, 16, PJ), [
          [sT, s.value]
        ]),
        c.value && F.appendIcon !== null ? (R(), Le(gt, {
          key: 0,
          name: "magnifier-outline",
          class: pe(["input__icon__append", d.value]),
          size: 20,
          onClick: x
        }, null, 8, ["class"])) : fe("", !0),
        p.value ? (R(), Le(gt, {
          key: 1,
          name: h.value ? "eye-hide" : "eye",
          class: pe(["input__icon__append", d.value]),
          size: 20,
          onClick: b
        }, null, 8, ["name", "class"])) : F.appendIcon ? (R(), Le(gt, {
          key: 2,
          name: F.appendIcon,
          class: pe(["input__icon__append", d.value]),
          size: 20,
          onClick: x
        }, null, 8, ["name", "class"])) : fe("", !0),
        F.prependIcon ? (R(), Le(gt, {
          key: 3,
          name: F.prependIcon,
          class: pe(["input__icon__prepend", d.value]),
          size: 20,
          onClick: S
        }, null, 8, ["name", "class"])) : fe("", !0),
        F.error ? (R(), K("span", MJ, Ie(F.error), 1)) : !F.error && F.hint ? (R(), K("span", AJ, Ie(F.hint), 1)) : fe("", !0)
      ])
    ]));
  }
});
const Koe = /* @__PURE__ */ rs(DJ, [["__scopeId", "data-v-8592b1a5"]]);
var IO = {}, NO = {}, Fb = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    if (r = `${r}`, r === "0")
      return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(r))
      return r.replace(/^[+-]?/, (n) => n === "-" ? "" : "-");
    let a = [
      "var",
      "calc",
      "min",
      "max",
      "clamp"
    ];
    for (const n of a)
      if (r.includes(`${n}(`))
        return `calc(${r} * -1)`;
  }
})(Fb);
var $O = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "content",
    "forcedColorAdjust"
  ];
})($O);
var LO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r, a) {
    return r === void 0 ? a : Array.isArray(r) ? r : [
      ...new Set(a.filter((i) => r !== !1 && r[i] !== !1).concat(Object.keys(r).filter((i) => r[i] !== !1)))
    ];
  }
})(LO);
var RO = {}, Jc = {}, Bb = { exports: {} }, yr = String, jO = function() {
  return { isColorSupported: !1, reset: yr, bold: yr, dim: yr, italic: yr, underline: yr, inverse: yr, hidden: yr, strikethrough: yr, black: yr, red: yr, green: yr, yellow: yr, blue: yr, magenta: yr, cyan: yr, white: yr, gray: yr, bgBlack: yr, bgRed: yr, bgGreen: yr, bgYellow: yr, bgBlue: yr, bgMagenta: yr, bgCyan: yr, bgWhite: yr };
};
Bb.exports = jO();
Bb.exports.createColors = jO;
var FO = Bb.exports;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, u) {
    for (var d in u)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
  }
  t(e, {
    dim: function() {
      return s;
    },
    default: function() {
      return o;
    }
  });
  const r = /* @__PURE__ */ a(FO);
  function a(l) {
    return l && l.__esModule ? l : {
      default: l
    };
  }
  let n = /* @__PURE__ */ new Set();
  function i(l, u, d) {
    typeof process < "u" && process.env.JEST_WORKER_ID || d && n.has(d) || (d && n.add(d), console.warn(""), u.forEach((f) => console.warn(l, "-", f)));
  }
  function s(l) {
    return r.default.dim(l);
  }
  const o = {
    info(l, u) {
      i(r.default.bold(r.default.cyan("info")), ...Array.isArray(l) ? [
        l
      ] : [
        u,
        l
      ]);
    },
    warn(l, u) {
      i(r.default.bold(r.default.yellow("warn")), ...Array.isArray(l) ? [
        l
      ] : [
        u,
        l
      ]);
    },
    risk(l, u) {
      i(r.default.bold(r.default.magenta("risk")), ...Array.isArray(l) ? [
        l
      ] : [
        u,
        l
      ]);
    }
  };
})(Jc);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ r(Jc);
  function r(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function a({ version: i, from: s, to: o }) {
    t.default.warn(`${s}-color-renamed`, [
      `As of Tailwind CSS ${i}, \`${s}\` has been renamed to \`${o}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const n = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return a({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return a({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return a({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return a({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return a({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(RO);
var BO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "defaults", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r, ...a) {
    for (let s of a) {
      for (let o in s) {
        var n;
        !(r == null || (n = r.hasOwnProperty) === null || n === void 0) && n.call(r, o) || (r[o] = s[o]);
      }
      for (let o of Object.getOwnPropertySymbols(s)) {
        var i;
        !(r == null || (i = r.hasOwnProperty) === null || i === void 0) && i.call(r, o) || (r[o] = s[o]);
      }
    }
    return r;
  }
})(BO);
var qO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "toPath", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    if (Array.isArray(r))
      return r;
    let a = r.split("[").length - 1, n = r.split("]").length - 1;
    if (a !== n)
      throw new Error(`Path is invalid. Has unbalanced brackets: ${r}`);
    return r.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(qO);
var HO = {}, Qc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(f, c) {
    for (var p in c)
      Object.defineProperty(f, p, {
        enumerable: !0,
        get: c[p]
      });
  }
  t(e, {
    flagEnabled: function() {
      return o;
    },
    issueFlagNotices: function() {
      return u;
    },
    default: function() {
      return d;
    }
  });
  const r = /* @__PURE__ */ n(FO), a = /* @__PURE__ */ n(Jc);
  function n(f) {
    return f && f.__esModule ? f : {
      default: f
    };
  }
  let i = {
    optimizeUniversalDefaults: !1,
    generalizedModifiers: !0,
    get disableColorOpacityUtilitiesByDefault() {
      return !1;
    },
    get relativeContentPathsByDefault() {
      return !1;
    }
  }, s = {
    future: [
      "hoverOnlyWhenSupported",
      "respectDefaultRingColorOpacity",
      "disableColorOpacityUtilitiesByDefault",
      "relativeContentPathsByDefault"
    ],
    experimental: [
      "optimizeUniversalDefaults",
      "generalizedModifiers"
    ]
  };
  function o(f, c) {
    if (s.future.includes(c)) {
      var p, v, h;
      return f.future === "all" || ((h = (v = f == null || (p = f.future) === null || p === void 0 ? void 0 : p[c]) !== null && v !== void 0 ? v : i[c]) !== null && h !== void 0 ? h : !1);
    }
    if (s.experimental.includes(c)) {
      var g, m, b;
      return f.experimental === "all" || ((b = (m = f == null || (g = f.experimental) === null || g === void 0 ? void 0 : g[c]) !== null && m !== void 0 ? m : i[c]) !== null && b !== void 0 ? b : !1);
    }
    return !1;
  }
  function l(f) {
    if (f.experimental === "all")
      return s.experimental;
    var c;
    return Object.keys((c = f == null ? void 0 : f.experimental) !== null && c !== void 0 ? c : {}).filter((p) => s.experimental.includes(p) && f.experimental[p]);
  }
  function u(f) {
    if (process.env.JEST_WORKER_ID === void 0 && l(f).length > 0) {
      let c = l(f).map((p) => r.default.yellow(p)).join(", ");
      a.default.warn("experimental-flags-enabled", [
        `You have enabled experimental features: ${c}`,
        "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
      ]);
    }
  }
  const d = s;
})(Qc);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "normalizeConfig", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const t = Qc, r = /* @__PURE__ */ n(Jc);
  function a(s) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (a = function(u) {
      return u ? l : o;
    })(s);
  }
  function n(s, o) {
    if (!o && s && s.__esModule)
      return s;
    if (s === null || typeof s != "object" && typeof s != "function")
      return {
        default: s
      };
    var l = a(o);
    if (l && l.has(s))
      return l.get(s);
    var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in s)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(s, f)) {
        var c = d ? Object.getOwnPropertyDescriptor(s, f) : null;
        c && (c.get || c.set) ? Object.defineProperty(u, f, c) : u[f] = s[f];
      }
    return u.default = s, l && l.set(s, u), u;
  }
  function i(s) {
    if ((() => {
      if (s.purge || !s.content || !Array.isArray(s.content) && !(typeof s.content == "object" && s.content !== null))
        return !1;
      if (Array.isArray(s.content))
        return s.content.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string"));
      if (typeof s.content == "object" && s.content !== null) {
        if (Object.keys(s.content).some((u) => ![
          "files",
          "relative",
          "extract",
          "transform"
        ].includes(u)))
          return !1;
        if (Array.isArray(s.content.files)) {
          if (!s.content.files.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string")))
            return !1;
          if (typeof s.content.extract == "object") {
            for (let u of Object.values(s.content.extract))
              if (typeof u != "function")
                return !1;
          } else if (!(s.content.extract === void 0 || typeof s.content.extract == "function"))
            return !1;
          if (typeof s.content.transform == "object") {
            for (let u of Object.values(s.content.transform))
              if (typeof u != "function")
                return !1;
          } else if (!(s.content.transform === void 0 || typeof s.content.transform == "function"))
            return !1;
          if (typeof s.content.relative != "boolean" && typeof s.content.relative < "u")
            return !1;
        }
        return !0;
      }
      return !1;
    })() || r.default.warn("purge-deprecation", [
      "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
      "Update your configuration file to eliminate this warning.",
      "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]), s.safelist = (() => {
      var u;
      let { content: d, purge: f, safelist: c } = s;
      return Array.isArray(c) ? c : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(f == null ? void 0 : f.safelist) ? f.safelist : Array.isArray(f == null || (u = f.options) === null || u === void 0 ? void 0 : u.safelist) ? f.options.safelist : [];
    })(), s.blocklist = (() => {
      let { blocklist: u } = s;
      if (Array.isArray(u)) {
        if (u.every((d) => typeof d == "string"))
          return u;
        r.default.warn("blocklist-invalid", [
          "The `blocklist` option must be an array of strings.",
          "https://tailwindcss.com/docs/content-configuration#discarding-classes"
        ]);
      }
      return [];
    })(), typeof s.prefix == "function")
      r.default.warn("prefix-function", [
        "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
        "Update `prefix` in your configuration to be a string to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
      ]), s.prefix = "";
    else {
      var l;
      s.prefix = (l = s.prefix) !== null && l !== void 0 ? l : "";
    }
    s.content = {
      relative: (() => {
        let { content: u } = s;
        return u != null && u.relative ? u.relative : (0, t.flagEnabled)(s, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let { content: u, purge: d } = s;
        return Array.isArray(d) ? d : Array.isArray(d == null ? void 0 : d.content) ? d.content : Array.isArray(u) ? u : Array.isArray(u == null ? void 0 : u.content) ? u.content : Array.isArray(u == null ? void 0 : u.files) ? u.files : [];
      })(),
      extract: (() => {
        let u = (() => {
          var c, p, v, h, g, m, b, y, _, x;
          return !((c = s.purge) === null || c === void 0) && c.extract ? s.purge.extract : !((p = s.content) === null || p === void 0) && p.extract ? s.content.extract : !((v = s.purge) === null || v === void 0 || (h = v.extract) === null || h === void 0) && h.DEFAULT ? s.purge.extract.DEFAULT : !((g = s.content) === null || g === void 0 || (m = g.extract) === null || m === void 0) && m.DEFAULT ? s.content.extract.DEFAULT : !((b = s.purge) === null || b === void 0 || (y = b.options) === null || y === void 0) && y.extractors ? s.purge.options.extractors : !((_ = s.content) === null || _ === void 0 || (x = _.options) === null || x === void 0) && x.extractors ? s.content.options.extractors : {};
        })(), d = {}, f = (() => {
          var c, p, v, h;
          if (!((c = s.purge) === null || c === void 0 || (p = c.options) === null || p === void 0) && p.defaultExtractor)
            return s.purge.options.defaultExtractor;
          if (!((v = s.content) === null || v === void 0 || (h = v.options) === null || h === void 0) && h.defaultExtractor)
            return s.content.options.defaultExtractor;
        })();
        if (f !== void 0 && (d.DEFAULT = f), typeof u == "function")
          d.DEFAULT = u;
        else if (Array.isArray(u))
          for (let { extensions: c, extractor: p } of u ?? [])
            for (let v of c)
              d[v] = p;
        else
          typeof u == "object" && u !== null && Object.assign(d, u);
        return d;
      })(),
      transform: (() => {
        let u = (() => {
          var f, c, p, v, h, g;
          return !((f = s.purge) === null || f === void 0) && f.transform ? s.purge.transform : !((c = s.content) === null || c === void 0) && c.transform ? s.content.transform : !((p = s.purge) === null || p === void 0 || (v = p.transform) === null || v === void 0) && v.DEFAULT ? s.purge.transform.DEFAULT : !((h = s.content) === null || h === void 0 || (g = h.transform) === null || g === void 0) && g.DEFAULT ? s.content.transform.DEFAULT : {};
        })(), d = {};
        return typeof u == "function" && (d.DEFAULT = u), typeof u == "object" && u !== null && Object.assign(d, u), d;
      })()
    };
    for (let u of s.content.files)
      if (typeof u == "string" && /{([^,]*?)}/g.test(u)) {
        r.default.warn("invalid-glob-braces", [
          `The glob pattern ${(0, r.dim)(u)} in your Tailwind CSS configuration is invalid.`,
          `Update it to ${(0, r.dim)(u.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
      }
    return s;
  }
})(HO);
var VO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    if (Object.prototype.toString.call(r) !== "[object Object]")
      return !1;
    const a = Object.getPrototypeOf(r);
    return a === null || Object.getPrototypeOf(a) === null;
  }
})(VO);
var UO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    return Array.isArray(r) ? r.map((a) => t(a)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([a, n]) => [
      a,
      t(n)
    ])) : r;
  }
})(UO);
var zO = {}, YO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    return r.replace(/\\,/g, "\\2c ");
  }
})(YO);
var qb = {}, Hb = {}, WO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = {
    aliceblue: [
      240,
      248,
      255
    ],
    antiquewhite: [
      250,
      235,
      215
    ],
    aqua: [
      0,
      255,
      255
    ],
    aquamarine: [
      127,
      255,
      212
    ],
    azure: [
      240,
      255,
      255
    ],
    beige: [
      245,
      245,
      220
    ],
    bisque: [
      255,
      228,
      196
    ],
    black: [
      0,
      0,
      0
    ],
    blanchedalmond: [
      255,
      235,
      205
    ],
    blue: [
      0,
      0,
      255
    ],
    blueviolet: [
      138,
      43,
      226
    ],
    brown: [
      165,
      42,
      42
    ],
    burlywood: [
      222,
      184,
      135
    ],
    cadetblue: [
      95,
      158,
      160
    ],
    chartreuse: [
      127,
      255,
      0
    ],
    chocolate: [
      210,
      105,
      30
    ],
    coral: [
      255,
      127,
      80
    ],
    cornflowerblue: [
      100,
      149,
      237
    ],
    cornsilk: [
      255,
      248,
      220
    ],
    crimson: [
      220,
      20,
      60
    ],
    cyan: [
      0,
      255,
      255
    ],
    darkblue: [
      0,
      0,
      139
    ],
    darkcyan: [
      0,
      139,
      139
    ],
    darkgoldenrod: [
      184,
      134,
      11
    ],
    darkgray: [
      169,
      169,
      169
    ],
    darkgreen: [
      0,
      100,
      0
    ],
    darkgrey: [
      169,
      169,
      169
    ],
    darkkhaki: [
      189,
      183,
      107
    ],
    darkmagenta: [
      139,
      0,
      139
    ],
    darkolivegreen: [
      85,
      107,
      47
    ],
    darkorange: [
      255,
      140,
      0
    ],
    darkorchid: [
      153,
      50,
      204
    ],
    darkred: [
      139,
      0,
      0
    ],
    darksalmon: [
      233,
      150,
      122
    ],
    darkseagreen: [
      143,
      188,
      143
    ],
    darkslateblue: [
      72,
      61,
      139
    ],
    darkslategray: [
      47,
      79,
      79
    ],
    darkslategrey: [
      47,
      79,
      79
    ],
    darkturquoise: [
      0,
      206,
      209
    ],
    darkviolet: [
      148,
      0,
      211
    ],
    deeppink: [
      255,
      20,
      147
    ],
    deepskyblue: [
      0,
      191,
      255
    ],
    dimgray: [
      105,
      105,
      105
    ],
    dimgrey: [
      105,
      105,
      105
    ],
    dodgerblue: [
      30,
      144,
      255
    ],
    firebrick: [
      178,
      34,
      34
    ],
    floralwhite: [
      255,
      250,
      240
    ],
    forestgreen: [
      34,
      139,
      34
    ],
    fuchsia: [
      255,
      0,
      255
    ],
    gainsboro: [
      220,
      220,
      220
    ],
    ghostwhite: [
      248,
      248,
      255
    ],
    gold: [
      255,
      215,
      0
    ],
    goldenrod: [
      218,
      165,
      32
    ],
    gray: [
      128,
      128,
      128
    ],
    green: [
      0,
      128,
      0
    ],
    greenyellow: [
      173,
      255,
      47
    ],
    grey: [
      128,
      128,
      128
    ],
    honeydew: [
      240,
      255,
      240
    ],
    hotpink: [
      255,
      105,
      180
    ],
    indianred: [
      205,
      92,
      92
    ],
    indigo: [
      75,
      0,
      130
    ],
    ivory: [
      255,
      255,
      240
    ],
    khaki: [
      240,
      230,
      140
    ],
    lavender: [
      230,
      230,
      250
    ],
    lavenderblush: [
      255,
      240,
      245
    ],
    lawngreen: [
      124,
      252,
      0
    ],
    lemonchiffon: [
      255,
      250,
      205
    ],
    lightblue: [
      173,
      216,
      230
    ],
    lightcoral: [
      240,
      128,
      128
    ],
    lightcyan: [
      224,
      255,
      255
    ],
    lightgoldenrodyellow: [
      250,
      250,
      210
    ],
    lightgray: [
      211,
      211,
      211
    ],
    lightgreen: [
      144,
      238,
      144
    ],
    lightgrey: [
      211,
      211,
      211
    ],
    lightpink: [
      255,
      182,
      193
    ],
    lightsalmon: [
      255,
      160,
      122
    ],
    lightseagreen: [
      32,
      178,
      170
    ],
    lightskyblue: [
      135,
      206,
      250
    ],
    lightslategray: [
      119,
      136,
      153
    ],
    lightslategrey: [
      119,
      136,
      153
    ],
    lightsteelblue: [
      176,
      196,
      222
    ],
    lightyellow: [
      255,
      255,
      224
    ],
    lime: [
      0,
      255,
      0
    ],
    limegreen: [
      50,
      205,
      50
    ],
    linen: [
      250,
      240,
      230
    ],
    magenta: [
      255,
      0,
      255
    ],
    maroon: [
      128,
      0,
      0
    ],
    mediumaquamarine: [
      102,
      205,
      170
    ],
    mediumblue: [
      0,
      0,
      205
    ],
    mediumorchid: [
      186,
      85,
      211
    ],
    mediumpurple: [
      147,
      112,
      219
    ],
    mediumseagreen: [
      60,
      179,
      113
    ],
    mediumslateblue: [
      123,
      104,
      238
    ],
    mediumspringgreen: [
      0,
      250,
      154
    ],
    mediumturquoise: [
      72,
      209,
      204
    ],
    mediumvioletred: [
      199,
      21,
      133
    ],
    midnightblue: [
      25,
      25,
      112
    ],
    mintcream: [
      245,
      255,
      250
    ],
    mistyrose: [
      255,
      228,
      225
    ],
    moccasin: [
      255,
      228,
      181
    ],
    navajowhite: [
      255,
      222,
      173
    ],
    navy: [
      0,
      0,
      128
    ],
    oldlace: [
      253,
      245,
      230
    ],
    olive: [
      128,
      128,
      0
    ],
    olivedrab: [
      107,
      142,
      35
    ],
    orange: [
      255,
      165,
      0
    ],
    orangered: [
      255,
      69,
      0
    ],
    orchid: [
      218,
      112,
      214
    ],
    palegoldenrod: [
      238,
      232,
      170
    ],
    palegreen: [
      152,
      251,
      152
    ],
    paleturquoise: [
      175,
      238,
      238
    ],
    palevioletred: [
      219,
      112,
      147
    ],
    papayawhip: [
      255,
      239,
      213
    ],
    peachpuff: [
      255,
      218,
      185
    ],
    peru: [
      205,
      133,
      63
    ],
    pink: [
      255,
      192,
      203
    ],
    plum: [
      221,
      160,
      221
    ],
    powderblue: [
      176,
      224,
      230
    ],
    purple: [
      128,
      0,
      128
    ],
    rebeccapurple: [
      102,
      51,
      153
    ],
    red: [
      255,
      0,
      0
    ],
    rosybrown: [
      188,
      143,
      143
    ],
    royalblue: [
      65,
      105,
      225
    ],
    saddlebrown: [
      139,
      69,
      19
    ],
    salmon: [
      250,
      128,
      114
    ],
    sandybrown: [
      244,
      164,
      96
    ],
    seagreen: [
      46,
      139,
      87
    ],
    seashell: [
      255,
      245,
      238
    ],
    sienna: [
      160,
      82,
      45
    ],
    silver: [
      192,
      192,
      192
    ],
    skyblue: [
      135,
      206,
      235
    ],
    slateblue: [
      106,
      90,
      205
    ],
    slategray: [
      112,
      128,
      144
    ],
    slategrey: [
      112,
      128,
      144
    ],
    snow: [
      255,
      250,
      250
    ],
    springgreen: [
      0,
      255,
      127
    ],
    steelblue: [
      70,
      130,
      180
    ],
    tan: [
      210,
      180,
      140
    ],
    teal: [
      0,
      128,
      128
    ],
    thistle: [
      216,
      191,
      216
    ],
    tomato: [
      255,
      99,
      71
    ],
    turquoise: [
      64,
      224,
      208
    ],
    violet: [
      238,
      130,
      238
    ],
    wheat: [
      245,
      222,
      179
    ],
    white: [
      255,
      255,
      255
    ],
    whitesmoke: [
      245,
      245,
      245
    ],
    yellow: [
      255,
      255,
      0
    ],
    yellowgreen: [
      154,
      205,
      50
    ]
  };
})(WO);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(v, h) {
    for (var g in h)
      Object.defineProperty(v, g, {
        enumerable: !0,
        get: h[g]
      });
  }
  t(e, {
    parseColor: function() {
      return c;
    },
    formatColor: function() {
      return p;
    }
  });
  const r = /* @__PURE__ */ a(WO);
  function a(v) {
    return v && v.__esModule ? v : {
      default: v
    };
  }
  let n = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, i = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, s = /(?:\d+|\d*\.\d+)%?/, o = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, u = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, d = new RegExp(`^(rgba?)\\(\\s*(${s.source}|${u.source})(?:${o.source}(${s.source}|${u.source}))?(?:${o.source}(${s.source}|${u.source}))?(?:${l.source}(${s.source}|${u.source}))?\\s*\\)$`), f = new RegExp(`^(hsla?)\\(\\s*((?:${s.source})(?:deg|rad|grad|turn)?|${u.source})(?:${o.source}(${s.source}|${u.source}))?(?:${o.source}(${s.source}|${u.source}))?(?:${l.source}(${s.source}|${u.source}))?\\s*\\)$`);
  function c(v, { loose: h = !1 } = {}) {
    var g, m;
    if (typeof v != "string")
      return null;
    if (v = v.trim(), v === "transparent")
      return {
        mode: "rgb",
        color: [
          "0",
          "0",
          "0"
        ],
        alpha: "0"
      };
    if (v in r.default)
      return {
        mode: "rgb",
        color: r.default[v].map((w) => w.toString())
      };
    let b = v.replace(i, (w, k, S, P, A) => [
      "#",
      k,
      k,
      S,
      S,
      P,
      P,
      A ? A + A : ""
    ].join("")).match(n);
    if (b !== null)
      return {
        mode: "rgb",
        color: [
          parseInt(b[1], 16),
          parseInt(b[2], 16),
          parseInt(b[3], 16)
        ].map((w) => w.toString()),
        alpha: b[4] ? (parseInt(b[4], 16) / 255).toString() : void 0
      };
    var y;
    let _ = (y = v.match(d)) !== null && y !== void 0 ? y : v.match(f);
    if (_ === null)
      return null;
    let x = [
      _[2],
      _[3],
      _[4]
    ].filter(Boolean).map((w) => w.toString());
    return x.length === 2 && x[0].startsWith("var(") ? {
      mode: _[1],
      color: [
        x[0]
      ],
      alpha: x[1]
    } : !h && x.length !== 3 || x.length < 3 && !x.some((w) => /^var\(.*?\)$/.test(w)) ? null : {
      mode: _[1],
      color: x,
      alpha: (g = _[5]) === null || g === void 0 || (m = g.toString) === null || m === void 0 ? void 0 : m.call(g)
    };
  }
  function p({ mode: v, color: h, alpha: g }) {
    let m = g !== void 0;
    return v === "rgba" || v === "hsla" ? `${v}(${h.join(", ")}${m ? `, ${g}` : ""})` : `${v}(${h.join(" ")}${m ? ` / ${g}` : ""})`;
  }
})(Hb);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(i, s) {
    for (var o in s)
      Object.defineProperty(i, o, {
        enumerable: !0,
        get: s[o]
      });
  }
  t(e, {
    withAlphaValue: function() {
      return a;
    },
    default: function() {
      return n;
    }
  });
  const r = Hb;
  function a(i, s, o) {
    if (typeof i == "function")
      return i({
        opacityValue: s
      });
    let l = (0, r.parseColor)(i, {
      loose: !0
    });
    return l === null ? o : (0, r.formatColor)({
      ...l,
      alpha: s
    });
  }
  function n({ color: i, property: s, variable: o }) {
    let l = [].concat(s);
    if (typeof i == "function")
      return {
        [o]: "1",
        ...Object.fromEntries(l.map((d) => [
          d,
          i({
            opacityVariable: o,
            opacityValue: `var(${o})`
          })
        ]))
      };
    const u = (0, r.parseColor)(i);
    return u === null ? Object.fromEntries(l.map((d) => [
      d,
      i
    ])) : u.alpha !== void 0 ? Object.fromEntries(l.map((d) => [
      d,
      i
    ])) : {
      [o]: "1",
      ...Object.fromEntries(l.map((d) => [
        d,
        (0, r.formatColor)({
          ...u,
          alpha: `var(${o})`
        })
      ]))
    };
  }
})(qb);
var Vb = {}, GO = {}, Zc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r, a) {
    let n = [], i = [], s = 0, o = !1;
    for (let l = 0; l < r.length; l++) {
      let u = r[l];
      n.length === 0 && u === a[0] && !o && (a.length === 1 || r.slice(l, l + a.length) === a) && (i.push(r.slice(s, l)), s = l + a.length), o ? o = !1 : u === "\\" && (o = !0), u === "(" || u === "[" || u === "{" ? n.push(u) : (u === ")" && n[n.length - 1] === "(" || u === "]" && n[n.length - 1] === "[" || u === "}" && n[n.length - 1] === "{") && n.pop();
    }
    return i.push(r.slice(s)), i;
  }
})(Zc);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, u) {
    for (var d in u)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
  }
  t(e, {
    parseBoxShadowValue: function() {
      return s;
    },
    formatBoxShadowValue: function() {
      return o;
    }
  });
  const r = Zc;
  let a = /* @__PURE__ */ new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]), n = /\ +(?![^(]*\))/g, i = /^-?(\d+|\.\d+)(.*?)$/g;
  function s(l) {
    return (0, r.splitAtTopLevelOnly)(l, ",").map((d) => {
      let f = d.trim(), c = {
        raw: f
      }, p = f.split(n), v = /* @__PURE__ */ new Set();
      for (let h of p)
        i.lastIndex = 0, !v.has("KEYWORD") && a.has(h) ? (c.keyword = h, v.add("KEYWORD")) : i.test(h) ? v.has("X") ? v.has("Y") ? v.has("BLUR") ? v.has("SPREAD") || (c.spread = h, v.add("SPREAD")) : (c.blur = h, v.add("BLUR")) : (c.y = h, v.add("Y")) : (c.x = h, v.add("X")) : c.color ? (c.unknown || (c.unknown = []), c.unknown.push(h)) : c.color = h;
      return c.valid = c.x !== void 0 && c.y !== void 0, c;
    });
  }
  function o(l) {
    return l.map((u) => u.valid ? [
      u.keyword,
      u.x,
      u.y,
      u.blur,
      u.spread,
      u.color
    ].filter(Boolean).join(" ") : u.raw).join(", ");
  }
})(GO);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(I, F) {
    for (var j in F)
      Object.defineProperty(I, j, {
        enumerable: !0,
        get: F[j]
      });
  }
  t(e, {
    normalize: function() {
      return l;
    },
    url: function() {
      return d;
    },
    number: function() {
      return f;
    },
    percentage: function() {
      return c;
    },
    length: function() {
      return h;
    },
    lineWidth: function() {
      return m;
    },
    shadow: function() {
      return b;
    },
    color: function() {
      return y;
    },
    image: function() {
      return _;
    },
    gradient: function() {
      return w;
    },
    position: function() {
      return S;
    },
    familyName: function() {
      return P;
    },
    genericName: function() {
      return E;
    },
    absoluteSize: function() {
      return T;
    },
    relativeSize: function() {
      return $;
    }
  });
  const r = Hb, a = GO, n = Zc;
  let i = [
    "min",
    "max",
    "clamp",
    "calc"
  ];
  function s(I) {
    return i.some((F) => new RegExp(`^${F}\\(.*\\)`).test(I));
  }
  const o = /* @__PURE__ */ new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline"
  ]);
  function l(I, F = null, j = !0) {
    let M = F && o.has(F.property);
    return I.startsWith("--") && !M ? `var(${I})` : I.includes("url(") ? I.split(/(url\(.*?\))/g).filter(Boolean).map((q) => /^url\(.*?\)$/.test(q) ? q : l(q, F, !1)).join("") : (I = I.replace(/([^\\])_+/g, (q, le) => le + " ".repeat(q.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), j && (I = I.trim()), I = u(I), I);
  }
  function u(I) {
    let F = [
      "theme"
    ], j = [
      "min-content",
      "max-content",
      "fit-content",
      // Env
      "safe-area-inset-top",
      "safe-area-inset-right",
      "safe-area-inset-bottom",
      "safe-area-inset-left",
      "titlebar-area-x",
      "titlebar-area-y",
      "titlebar-area-width",
      "titlebar-area-height",
      "keyboard-inset-top",
      "keyboard-inset-right",
      "keyboard-inset-bottom",
      "keyboard-inset-left",
      "keyboard-inset-width",
      "keyboard-inset-height",
      "radial-gradient",
      "linear-gradient",
      "conic-gradient",
      "repeating-radial-gradient",
      "repeating-linear-gradient",
      "repeating-conic-gradient"
    ];
    return I.replace(/(calc|min|max|clamp)\(.+\)/g, (M) => {
      let q = "";
      function le() {
        let Z = q.trimEnd();
        return Z[Z.length - 1];
      }
      for (let Z = 0; Z < M.length; Z++) {
        let G = function(ie) {
          return ie.split("").every((we, Be) => M[Z + Be] === we);
        }, H = function(ie) {
          let we = 1 / 0;
          for (let Ve of ie) {
            let et = M.indexOf(Ve, Z);
            et !== -1 && et < we && (we = et);
          }
          let Be = M.slice(Z, we);
          return Z += Be.length - 1, Be;
        }, W = M[Z];
        if (G("var"))
          q += H([
            ")",
            ","
          ]);
        else if (j.some((ie) => G(ie))) {
          let ie = j.find((we) => G(we));
          q += ie, Z += ie.length - 1;
        } else
          F.some((ie) => G(ie)) ? q += H([
            ")"
          ]) : G("[") ? q += H([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(W) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(le()) ? q += ` ${W} ` : q += W;
      }
      return q.replace(/\s+/g, " ");
    });
  }
  function d(I) {
    return I.startsWith("url(");
  }
  function f(I) {
    return !isNaN(Number(I)) || s(I);
  }
  function c(I) {
    return I.endsWith("%") && f(I.slice(0, -1)) || s(I);
  }
  let v = `(?:${[
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
  ].join("|")})`;
  function h(I) {
    return I === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${v}$`).test(I) || s(I);
  }
  let g = /* @__PURE__ */ new Set([
    "thin",
    "medium",
    "thick"
  ]);
  function m(I) {
    return g.has(I);
  }
  function b(I) {
    let F = (0, a.parseBoxShadowValue)(l(I));
    for (let j of F)
      if (!j.valid)
        return !1;
    return !0;
  }
  function y(I) {
    let F = 0;
    return (0, n.splitAtTopLevelOnly)(I, "_").every((M) => (M = l(M), M.startsWith("var(") ? !0 : (0, r.parseColor)(M, {
      loose: !0
    }) !== null ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  function _(I) {
    let F = 0;
    return (0, n.splitAtTopLevelOnly)(I, ",").every((M) => (M = l(M), M.startsWith("var(") ? !0 : d(M) || w(M) || [
      "element(",
      "image(",
      "cross-fade(",
      "image-set("
    ].some((q) => M.startsWith(q)) ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  let x = /* @__PURE__ */ new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
  ]);
  function w(I) {
    I = l(I);
    for (let F of x)
      if (I.startsWith(`${F}(`))
        return !0;
    return !1;
  }
  let k = /* @__PURE__ */ new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
  ]);
  function S(I) {
    let F = 0;
    return (0, n.splitAtTopLevelOnly)(I, "_").every((M) => (M = l(M), M.startsWith("var(") ? !0 : k.has(M) || h(M) || c(M) ? (F++, !0) : !1)) ? F > 0 : !1;
  }
  function P(I) {
    let F = 0;
    return (0, n.splitAtTopLevelOnly)(I, ",").every((M) => (M = l(M), M.startsWith("var(") ? !0 : M.includes(" ") && !/(['"])([^"']+)\1/g.test(M) || /^\d/g.test(M) ? !1 : (F++, !0))) ? F > 0 : !1;
  }
  let A = /* @__PURE__ */ new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
  ]);
  function E(I) {
    return A.has(I);
  }
  let O = /* @__PURE__ */ new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "x-large",
    "xxx-large"
  ]);
  function T(I) {
    return O.has(I);
  }
  let D = /* @__PURE__ */ new Set([
    "larger",
    "smaller"
  ]);
  function $(I) {
    return D.has(I);
  }
})(Vb);
var XO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "backgroundSize", {
    enumerable: !0,
    get: function() {
      return a;
    }
  });
  const t = Vb, r = Zc;
  function a(n) {
    let i = [
      "cover",
      "contain"
    ];
    return (0, r.splitAtTopLevelOnly)(n, ",").every((s) => {
      let o = (0, r.splitAtTopLevelOnly)(s, "_").filter(Boolean);
      return o.length === 1 && i.includes(o[0]) ? !0 : o.length !== 1 && o.length !== 2 ? !1 : o.every((l) => (0, t.length)(l) || (0, t.percentage)(l) || l === "auto");
    });
  }
})(XO);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(P, A) {
    for (var E in A)
      Object.defineProperty(P, E, {
        enumerable: !0,
        get: A[E]
      });
  }
  t(e, {
    updateAllClasses: function() {
      return u;
    },
    asValue: function() {
      return c;
    },
    parseColorFormat: function() {
      return h;
    },
    asColor: function() {
      return m;
    },
    asLookupValue: function() {
      return b;
    },
    typeMap: function() {
      return _;
    },
    coerceValue: function() {
      return k;
    },
    getMatchingTypes: function() {
      return S;
    }
  });
  const r = /* @__PURE__ */ l(YO), a = qb, n = Vb, i = /* @__PURE__ */ l(Fb), s = XO, o = Qc;
  function l(P) {
    return P && P.__esModule ? P : {
      default: P
    };
  }
  function u(P, A) {
    P.walkClasses((E) => {
      E.value = A(E.value), E.raws && E.raws.value && (E.raws.value = (0, r.default)(E.raws.value));
    });
  }
  function d(P, A) {
    if (!p(P))
      return;
    let E = P.slice(1, -1);
    if (A(E))
      return (0, n.normalize)(E);
  }
  function f(P, A = {}, E) {
    let O = A[P];
    if (O !== void 0)
      return (0, i.default)(O);
    if (p(P)) {
      let T = d(P, E);
      return T === void 0 ? void 0 : (0, i.default)(T);
    }
  }
  function c(P, A = {}, { validate: E = () => !0 } = {}) {
    var O;
    let T = (O = A.values) === null || O === void 0 ? void 0 : O[P];
    return T !== void 0 ? T : A.supportsNegativeValues && P.startsWith("-") ? f(P.slice(1), A.values, E) : d(P, E);
  }
  function p(P) {
    return P.startsWith("[") && P.endsWith("]");
  }
  function v(P) {
    let A = P.lastIndexOf("/"), E = P.lastIndexOf("[", A), O = P.indexOf("]", A);
    return P[A - 1] === "]" || P[A + 1] === "[" || E !== -1 && O !== -1 && E < A && A < O && (A = P.lastIndexOf("/", E)), A === -1 || A === P.length - 1 ? [
      P,
      void 0
    ] : p(P) && !P.includes("]/[") ? [
      P,
      void 0
    ] : [
      P.slice(0, A),
      P.slice(A + 1)
    ];
  }
  function h(P) {
    if (typeof P == "string" && P.includes("<alpha-value>")) {
      let A = P;
      return ({ opacityValue: E = 1 }) => A.replace("<alpha-value>", E);
    }
    return P;
  }
  function g(P) {
    return (0, n.normalize)(P.slice(1, -1));
  }
  function m(P, A = {}, { tailwindConfig: E = {} } = {}) {
    var O;
    if (((O = A.values) === null || O === void 0 ? void 0 : O[P]) !== void 0) {
      var T;
      return h((T = A.values) === null || T === void 0 ? void 0 : T[P]);
    }
    let [D, $] = v(P);
    if ($ !== void 0) {
      var I, F, j, M;
      let q = (M = (I = A.values) === null || I === void 0 ? void 0 : I[D]) !== null && M !== void 0 ? M : p(D) ? D.slice(1, -1) : void 0;
      return q === void 0 ? void 0 : (q = h(q), p($) ? (0, a.withAlphaValue)(q, g($)) : ((F = E.theme) === null || F === void 0 || (j = F.opacity) === null || j === void 0 ? void 0 : j[$]) === void 0 ? void 0 : (0, a.withAlphaValue)(q, E.theme.opacity[$]));
    }
    return c(P, A, {
      validate: n.color
    });
  }
  function b(P, A = {}) {
    var E;
    return (E = A.values) === null || E === void 0 ? void 0 : E[P];
  }
  function y(P) {
    return (A, E) => c(A, E, {
      validate: P
    });
  }
  let _ = {
    any: c,
    color: m,
    url: y(n.url),
    image: y(n.image),
    length: y(n.length),
    percentage: y(n.percentage),
    position: y(n.position),
    lookup: b,
    "generic-name": y(n.genericName),
    "family-name": y(n.familyName),
    number: y(n.number),
    "line-width": y(n.lineWidth),
    "absolute-size": y(n.absoluteSize),
    "relative-size": y(n.relativeSize),
    shadow: y(n.shadow),
    size: y(s.backgroundSize)
  }, x = Object.keys(_);
  function w(P, A) {
    let E = P.indexOf(A);
    return E === -1 ? [
      void 0,
      P
    ] : [
      P.slice(0, E),
      P.slice(E + 1)
    ];
  }
  function k(P, A, E, O) {
    if (E.values && A in E.values)
      for (let { type: D } of P ?? []) {
        let $ = _[D](A, E, {
          tailwindConfig: O
        });
        if ($ !== void 0)
          return [
            $,
            D,
            null
          ];
      }
    if (p(A)) {
      let D = A.slice(1, -1), [$, I] = w(D, ":");
      if (!/^[\w-_]+$/g.test($))
        I = D;
      else if ($ !== void 0 && !x.includes($))
        return [];
      if (I.length > 0 && x.includes($))
        return [
          c(`[${I}]`, E),
          $,
          null
        ];
    }
    let T = S(P, A, E, O);
    for (let D of T)
      return D;
    return [];
  }
  function* S(P, A, E, O) {
    let T = (0, o.flagEnabled)(O, "generalizedModifiers"), [D, $] = v(A);
    if (T && E.modifiers != null && (E.modifiers === "any" || typeof E.modifiers == "object" && ($ && p($) || $ in E.modifiers)) || (D = A, $ = void 0), $ !== void 0 && D === "" && (D = "DEFAULT"), $ !== void 0 && typeof E.modifiers == "object") {
      var F, j;
      let M = (j = (F = E.modifiers) === null || F === void 0 ? void 0 : F[$]) !== null && j !== void 0 ? j : null;
      M !== null ? $ = M : p($) && ($ = g($));
    }
    for (let { type: M } of P ?? []) {
      let q = _[M](D, E, {
        tailwindConfig: O
      });
      q !== void 0 && (yield [
        q,
        M,
        $ ?? null
      ]);
    }
  }
})(zO);
var KO = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(r) {
    return typeof r == "function" ? r({}) : r;
  }
})(KO);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return E;
    }
  });
  const t = /* @__PURE__ */ p(Fb), r = /* @__PURE__ */ p($O), a = /* @__PURE__ */ p(LO), n = /* @__PURE__ */ p(RO), i = BO, s = qO, o = HO, l = /* @__PURE__ */ p(VO), u = UO, d = zO, f = qb, c = /* @__PURE__ */ p(KO);
  function p(O) {
    return O && O.__esModule ? O : {
      default: O
    };
  }
  function v(O) {
    return typeof O == "function";
  }
  function h(O, ...T) {
    let D = T.pop();
    for (let $ of T)
      for (let I in $) {
        let F = D(O[I], $[I]);
        F === void 0 ? (0, l.default)(O[I]) && (0, l.default)($[I]) ? O[I] = h({}, O[I], $[I], D) : O[I] = $[I] : O[I] = F;
      }
    return O;
  }
  const g = {
    colors: n.default,
    negative(O) {
      return Object.keys(O).filter((T) => O[T] !== "0").reduce((T, D) => {
        let $ = (0, t.default)(O[D]);
        return $ !== void 0 && (T[`-${D}`] = $), T;
      }, {});
    },
    breakpoints(O) {
      return Object.keys(O).filter((T) => typeof O[T] == "string").reduce((T, D) => ({
        ...T,
        [`screen-${D}`]: O[D]
      }), {});
    }
  };
  function m(O, ...T) {
    return v(O) ? O(...T) : O;
  }
  function b(O) {
    return O.reduce((T, { extend: D }) => h(T, D, ($, I) => $ === void 0 ? [
      I
    ] : Array.isArray($) ? [
      I,
      ...$
    ] : [
      I,
      $
    ]), {});
  }
  function y(O) {
    return {
      ...O.reduce((T, D) => (0, i.defaults)(T, D), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: b(O)
    };
  }
  function _(O, T) {
    if (Array.isArray(O) && (0, l.default)(O[0]))
      return O.concat(T);
    if (Array.isArray(T) && (0, l.default)(T[0]) && (0, l.default)(O))
      return [
        O,
        ...T
      ];
    if (Array.isArray(T))
      return T;
  }
  function x({ extend: O, ...T }) {
    return h(T, O, (D, $) => !v(D) && !$.some(v) ? h({}, D, ...$, _) : (I, F) => h({}, ...[
      D,
      ...$
    ].map((j) => m(j, I, F)), _));
  }
  function* w(O) {
    let T = (0, s.toPath)(O);
    if (T.length === 0 || (yield T, Array.isArray(O)))
      return;
    let D = /^(.*?)\s*\/\s*([^/]+)$/, $ = O.match(D);
    if ($ !== null) {
      let [, I, F] = $, j = (0, s.toPath)(I);
      j.alpha = F, yield j;
    }
  }
  function k(O) {
    const T = (D, $) => {
      for (const I of w(D)) {
        let F = 0, j = O;
        for (; j != null && F < I.length; )
          j = j[I[F++]], j = v(j) && (I.alpha === void 0 || F <= I.length - 1) ? j(T, g) : j;
        if (j !== void 0) {
          if (I.alpha !== void 0) {
            let M = (0, d.parseColorFormat)(j);
            return (0, f.withAlphaValue)(M, I.alpha, (0, c.default)(M));
          }
          return (0, l.default)(j) ? (0, u.cloneDeep)(j) : j;
        }
      }
      return $;
    };
    return Object.assign(T, {
      theme: T,
      ...g
    }), Object.keys(O).reduce((D, $) => (D[$] = v(O[$]) ? O[$](T, g) : O[$], D), {});
  }
  function S(O) {
    let T = [];
    return O.forEach((D) => {
      T = [
        ...T,
        D
      ];
      var $;
      const I = ($ = D == null ? void 0 : D.plugins) !== null && $ !== void 0 ? $ : [];
      I.length !== 0 && I.forEach((F) => {
        F.__isOptionsFunction && (F = F());
        var j;
        T = [
          ...T,
          ...S([
            (j = F == null ? void 0 : F.config) !== null && j !== void 0 ? j : {}
          ])
        ];
      });
    }), T;
  }
  function P(O) {
    return [
      ...O
    ].reduceRight((D, $) => v($) ? $({
      corePlugins: D
    }) : (0, a.default)($, D), r.default);
  }
  function A(O) {
    return [
      ...O
    ].reduceRight((D, $) => [
      ...D,
      ...$
    ], []);
  }
  function E(O) {
    let T = [
      ...S(O),
      {
        prefix: "",
        important: !1,
        separator: ":"
      }
    ];
    var D, $;
    return (0, o.normalizeConfig)((0, i.defaults)({
      theme: k(x(y(T.map((I) => (D = I == null ? void 0 : I.theme) !== null && D !== void 0 ? D : {})))),
      corePlugins: P(T.map((I) => I.corePlugins)),
      plugins: A(O.map((I) => ($ = I == null ? void 0 : I.plugins) !== null && $ !== void 0 ? $ : []))
    }, ...T));
  }
})(NO);
var JO = {}, IJ = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "0",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      ...e("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ a(IJ), r = Qc;
  function a(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function n(i) {
    var s;
    const o = ((s = i == null ? void 0 : i.presets) !== null && s !== void 0 ? s : [
      t.default
    ]).slice().reverse().flatMap((d) => n(d instanceof Function ? d() : d)), l = {
      // Add experimental configs here...
      respectDefaultRingColorOpacity: {
        theme: {
          ringColor: ({ theme: d }) => ({
            DEFAULT: "#3b82f67f",
            ...d("colors")
          })
        }
      },
      disableColorOpacityUtilitiesByDefault: {
        corePlugins: {
          backgroundOpacity: !1,
          borderOpacity: !1,
          divideOpacity: !1,
          placeholderOpacity: !1,
          ringOpacity: !1,
          textOpacity: !1
        }
      }
    }, u = Object.keys(l).filter((d) => (0, r.flagEnabled)(i, d)).map((d) => l[d]);
    return [
      i,
      ...u,
      ...o
    ];
  }
})(JO);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ a(NO), r = /* @__PURE__ */ a(JO);
  function a(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function n(...i) {
    let [, ...s] = (0, r.default)(i[0]);
    return (0, t.default)([
      ...i,
      ...s
    ]);
  }
})(IO);
let ep = IO;
var NJ = (ep.__esModule ? ep : { default: ep }).default;
const $J = /* @__PURE__ */ Rd(NJ), LJ = {
  content: ["./src/**/*.{html,ts,vue}"],
  theme: {
    colors: {
      primary: "hsla(152, 61%, 48%, 1)",
      "primary-hover": "hsla(150, 68%, 67%, 1)",
      "primary-light": "hsla(147, 72%, 80%, 1)",
      "primary-lighter": "hsla(144, 100%, 97%, 1)",
      secondary: "hsla(259, 96%, 10%, 1)",
      "secondary-hover": "hsla(262, 99%, 34%, 1)",
      "secondary-light": "hsla(248, 96%, 90%, 1)",
      "secondary-lighter": "hsla(240, 100%, 98%, 1)",
      success: "#22B44B",
      "success-hover": "#19943C",
      danger: "#E47259",
      "danger-hover": "#E46044",
      white: "#FFFFFF",
      warning: "#E1CC0F",
      "gray-100": "#F9F9F9",
      "gray-150": "#F7F7F7",
      "gray-200": "#F3F3F3",
      "gray-250": "#F5F5F5",
      "gray-300": "#E1E1E1",
      "gray-400": "#BDBDBD",
      "gray-500": "#7A7A7A",
      "gray-600": "#5F5F5F",
      dark: "#2C2C2C",
      disabled: "#E1E1E1",
      black: "#000000",
      placeholder: "#B2B7BC",
      line: "#E6E6E6",
      transparent: "transparent"
    },
    container: {
      screens: {
        sm: "100%",
        md: "100%",
        lg: "1024px",
        xl: "1280px"
      }
    },
    fontWeight: {
      thin: "100",
      light: "300",
      regular: "400",
      medium: "500",
      "semi-bold": "600",
      bold: "700",
      black: "900"
    },
    borderRadius: {
      none: "0",
      xs: "2px",
      sm: "4px",
      md: "8px",
      lg: "12px",
      xl: "16px",
      "2xl": "20px",
      "3xl": "24px",
      full: "50%"
    },
    boxShadow: {
      DEFAULT: "0px 4px 8px rgba(0, 0, 0, 0.08)",
      none: "0 0 0 0 rgba(0, 0, 0, 1)",
      xs: "0px 0px 4px rgba(0, 0, 0, 0.08)",
      sm: "0px 0px 8px rgba(0, 0, 0, 0.08)",
      md: "0px 0px 16px rgba(0, 0, 0, 0.08)",
      lg: "0px 0px 8px rgba(0, 0, 0, 0.16)",
      xl: "0px 0px 16px rgba(0, 0, 0, 0.16)",
      "2xl": "0px 0px 8px 4px rgba(0, 0, 0, 0.16)",
      "3xl": "0px 0px 16px 4px rgba(0, 0, 0, 0.16)",
      "4xl": "0px 4px 8px 0px rgba(0, 0, 0, 0.3)"
    },
    fontSize: {
      metadata: "1rem",
      "metadata-limited": "1.2rem",
      base: "1.4rem",
      subject: "1.6rem",
      header: "1.8rem",
      "pane-header": "2rem",
      title: "2.4rem",
      greeting: "3.2rem",
      hero: "4rem",
      "xl-numeric": "6.4rem"
    },
    fontFamily: {
      primary: ["VazirMatn", "Afacad", "Helvetica", "Arial", "sans-serif"]
    },
    spacing: {
      0: "0",
      1: "0.1rem",
      2: "0.2rem",
      3: "0.3rem",
      4: "0.4rem",
      5: "0.5rem",
      6: "0.6rem",
      8: "0.8rem",
      10: "1rem",
      12: "1.2rem",
      16: "1.6rem",
      20: "2rem",
      24: "2.4rem",
      28: "2.8rem",
      32: "3.2rem",
      40: "4rem",
      50: "5rem",
      55: "5.5rem",
      60: "6rem",
      65: "6.5rem",
      auto: "auto",
      full: "100%"
    },
    animation: {
      wave: "wave 1.5s linear 0.5s infinite"
    },
    keyframes: {
      wave: {
        "0%": { transform: "translateX(-100%)" },
        "100%": { transform: "translateX(100%)" }
      }
    },
    extend: {
      zIndex: {
        1: "1"
      }
    }
  },
  plugins: []
}, RJ = $J(LJ), jJ = { key: 1 }, Joe = /* @__PURE__ */ Ae({
  __name: "JTimeline",
  props: {
    items: {},
    icon: {},
    direction: { default: "horizontal" },
    iconClass: {},
    labelClass: {},
    itemClass: {},
    color: { default: "primary-hover" },
    iconSize: { default: 20 }
  },
  setup(e) {
    const t = e, { isMobile: r } = pT(), a = N(() => t.direction === "vertical"), n = N(() => {
      var o;
      return (o = Object.entries(RJ.theme.colors).map(
        ([l, u]) => ({ key: l, value: u })
      ).find((l) => l.key === t.color)) == null ? void 0 : o.value;
    }), i = Vn();
    return (s, o) => (R(), K("div", {
      class: pe(["flex items-stretch gap-6", [a.value ? "flex-col justify-between" : "flex-row"]])
    }, [
      (R(!0), K(Qe, null, kt(s.items, (l, u) => (R(), K("div", {
        key: u,
        class: pe(["flex flex-1 select-none gap-6 last-of-type:flex-none", [
          a.value ? "flex-col items-stretch" : "flex-row items-center",
          s.itemClass
        ]])
      }, [
        ue("span", {
          class: pe(["text-subject font-medium text-gray-600", [a.value && "text-center", s.labelClass]])
        }, [
          U(i)(`label#${u}`) ? ke(s.$slots, `label#${u}`, {
            key: 0,
            value: l,
            item: { item: l, index: u }
          }) : (R(), K("span", jJ, Ie(typeof l == "string" ? l : l.label), 1))
        ], 2),
        u !== s.items.length - 1 ? (R(), K("div", {
          key: 0,
          style: Ir({ color: n.value }),
          class: pe(["relative z-0 flex flex-1 items-center justify-center after:absolute after:transform after:border after:border-line after:content-['']", [
            a.value ? "after:bottom-5 after:left-1/2 after:top-5  after:w-1 after:-translate-x-1/2 after:border-l" : "after:left-10 after:right-10 after:top-1/2 after:h-1 after:-translate-y-1/2 after:border-t",
            !a.value && "after:!left-16 after:!right-16"
          ]])
        }, [
          ue("span", {
            class: pe([a.value ? "py-4" : "px-4", "z-1 bg-white"])
          }, [
            Fe(gt, {
              name: s.icon,
              size: s.iconSize,
              class: pe([s.iconClass])
            }, null, 8, ["name", "size", "class"])
          ], 2),
          typeof l != "string" ? (R(), K(Qe, { key: 0 }, [
            ue("span", {
              class: pe(["absolute left-1/2 w-65 -translate-x-1/2 transform text-center text-metadata-limited text-gray-500", U(r) ? "-top-1/3 mt-16" : "-top-3/4"])
            }, [
              ue("span", null, Ie(l.title), 1)
            ], 2),
            l.caption ? (R(), K("span", {
              key: 0,
              class: pe(["absolute left-1/2 w-65 -translate-x-1/2 transform text-center text-metadata-limited text-gray-500", U(r) ? "-bottom-1/3 mt-16" : "-bottom-3/4"])
            }, Ie(l.caption), 3)) : fe("", !0)
          ], 64)) : fe("", !0),
          typeof l != "string" ? (R(), K("span", {
            key: 1,
            class: pe([
              "absolute",
              U(r) ? "-bottom-48 left-1/2 ms-16" : "-bottom-16 left-1/2 -translate-x-1/2 transform"
            ])
          }, [
            ke(s.$slots, "caption", {
              item: { index: u }
            })
          ], 2)) : fe("", !0),
          ue("span", {
            class: pe(["absolute h-6 w-6 rounded-full border border-line bg-white", a.value ? "-top-6" : "left-0"])
          }, null, 2),
          ue("span", {
            class: pe(["absolute h-6 w-6 rounded-full border border-line bg-white", a.value ? "-bottom-6" : "right-6"])
          }, null, 2)
        ], 6)) : fe("", !0)
      ], 2))), 128))
    ], 2));
  }
}), Qoe = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JTimeSlider",
  props: {
    modelValue: { default: "0" },
    min: { default: 0 },
    max: { default: 24 },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = N({
      get() {
        function u(f) {
          const [c, p] = f.split(":");
          return c === "24" && p === "0" ? "24" : c;
        }
        function d(f) {
          return typeof f == "string" ? u(f) : f.map(u);
        }
        return d(r.modelValue);
      },
      set(u) {
        function d(c) {
          let p = c;
          return p.length === 1 && (p = Ml(p, 2)), `${p}:00`;
        }
        function f(c) {
          return typeof c == "string" ? d(c) : typeof c == "number" ? d(c.toString()) : c.map(d);
        }
        a("update:modelValue", f(u));
      }
    }), i = Gr(), s = N(() => i("required", !0)), o = N(() => ({
      min: `${r.min}:00`,
      max: `${r.max}:00`
    }));
    function l(u) {
      return u === r.min || u === r.max ? "" : `${u.toFixed(0)}:00`;
    }
    return (u, d) => (R(), K("div", null, [
      u.label ? (R(), K("label", {
        key: 0,
        class: pe(["input__label mb-16 block", s.value && "input--required"])
      }, Ie(u.label), 3)) : fe("", !0),
      Fe(U(JK), Mt(u.$attrs, {
        modelValue: n.value,
        "onUpdate:modelValue": d[0] || (d[0] = (f) => n.value = f),
        classes: {
          handle: "!shadow-none !bg-primary",
          connect: "bg-primary !bg-gray-600-hover",
          tooltipBottom: "text-gray-600-hover"
        },
        tooltipPosition: "bottom",
        min: o.value.min,
        max: o.value.max,
        format: l
      }), null, 16, ["modelValue", "min", "max"])
    ]));
  }
}), Zoe = /* @__PURE__ */ Ae({
  __name: "JToggle",
  props: {
    modelValue: {},
    options: {},
    label: {},
    containerClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = N({
      get() {
        return r.options.find((s) => s.value === r.modelValue);
      },
      set(s) {
        a("update:modelValue", s == null ? void 0 : s.value);
      }
    }), { currentLocaleItem: i } = Ii();
    return (s, o) => (R(), Le(U(ES), {
      modelValue: n.value,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => n.value = l),
      class: "flex items-center gap-x-4 md:gap-x-8",
      dir: U(i).rtl ? "rtl" : "ltr"
    }, {
      default: Pe(() => [
        s.label ? (R(), Le(U(CS), {
          key: 0,
          class: "text-base font-medium text-gray-500"
        }, {
          default: Pe(() => [
            jt(Ie(s.label), 1)
          ]),
          _: 1
        })) : fe("", !0),
        ue("div", {
          class: pe(["flex w-full items-center gap-4 rounded-md bg-gray-200 p-4 md:w-max", s.containerClass])
        }, [
          (R(!0), K(Qe, null, kt(s.options, (l, u) => (R(), Le(U(OS), {
            key: u,
            value: l,
            as: "template"
          }, {
            default: Pe(({ checked: d }) => [
              ue("button", {
                type: "button",
                class: pe([
                  d ? "bg-blue-200 bg-white text-dark shadow-md" : "text-gray-500",
                  "rounded-sm p-8 text-base font-medium md:p-4"
                ])
              }, Ie(l.title), 3)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "dir"]));
  }
}), QO = {};
Object.keys(qa).forEach((e) => {
  QO[e] = {
    border: `border-${e}`,
    text: `text-${e}`
  };
});
const FJ = {
  success: "check-circle-bold",
  danger: "close-circle-bold",
  warning: "warning-triangle"
}, BJ = { class: "flex items-center gap-8" }, qJ = { class: "text-base font-regular" }, ele = /* @__PURE__ */ Ae({
  __name: "JToast",
  props: {
    color: { default: "primary" },
    title: {},
    description: {}
  },
  emits: ["close"],
  setup(e) {
    const t = e, { getNewZIndex: r } = pu(), a = N(() => QO[t.color]), n = N(() => FJ[t.color]);
    return (i, s) => (R(), K("div", {
      class: pe([[a.value.border], "relative w-fit select-none rounded-xl bg-white px-16 py-6 shadow-4xl"]),
      style: Ir({ zIndex: U(r)() })
    }, [
      ue("div", BJ, [
        ue("div", null, [
          n.value ? (R(), Le(gt, {
            key: 0,
            name: n.value,
            class: pe([a.value.text, "inline-block"]),
            size: "20"
          }, null, 8, ["name", "class"])) : fe("", !0)
        ]),
        ue("div", qJ, Ie(i.title), 1),
        ue("button", {
          type: "button",
          onClick: s[0] || (s[0] = (o) => i.$emit("close"))
        }, [
          Fe(gt, {
            name: "close",
            class: "text-danger",
            size: "20"
          })
        ])
      ])
    ], 6));
  }
});
function i1(e, t, r) {
  var a, n, i, s, o;
  t == null && (t = 100);
  function l() {
    var d = Date.now() - s;
    d < t && d >= 0 ? a = setTimeout(l, t - d) : (a = null, r || (o = e.apply(i, n), i = n = null));
  }
  var u = function() {
    i = this, n = arguments, s = Date.now();
    var d = r && !a;
    return a || (a = setTimeout(l, t)), d && (o = e.apply(i, n), i = n = null), o;
  };
  return u.clear = function() {
    a && (clearTimeout(a), a = null);
  }, u.flush = function() {
    a && (o = e.apply(i, n), i = n = null, clearTimeout(a), a = null);
  }, u;
}
i1.debounce = i1;
var tp = i1;
function HJ(e, t, r) {
  _a(e) ? He(e, (a, n) => {
    n == null || n.removeEventListener(t, r), a == null || a.addEventListener(t, r);
  }) : ct(() => {
    e.addEventListener(t, r);
  }), Ai(() => {
    var a;
    (a = U(e)) === null || a === void 0 || a.removeEventListener(t, r);
  });
}
function VJ(e, t) {
  const r = "pointerdown";
  return typeof window > "u" || !window ? void 0 : HJ(window, r, (n) => {
    const i = U(e);
    i && (i === n.target || n.composedPath().includes(i) || t(n));
  });
}
function UJ(e, t, r) {
  let a = null;
  const n = ne(!1);
  ct(() => {
    (e.content !== void 0 || r.value) && (n.value = !0), a = new MutationObserver(i), a.observe(t.value, {
      childList: !0,
      subtree: !0
    });
  }), Ai(() => a.disconnect()), He(r, (s) => {
    s ? n.value = !0 : n.value = !1;
  });
  const i = () => {
    e.content ? n.value = !0 : n.value = !1;
  };
  return {
    hasContent: n
  };
}
function bo(e, t) {
  var r = e.getBoundingClientRect(), a = 1, n = 1;
  return {
    width: r.width / a,
    height: r.height / n,
    top: r.top / n,
    right: r.right / a,
    bottom: r.bottom / n,
    left: r.left / a,
    x: r.left / a,
    y: r.top / n
  };
}
function Un(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ub(e) {
  var t = Un(e), r = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Xl(e) {
  var t = Un(e).Element;
  return e instanceof t || e instanceof Element;
}
function xn(e) {
  var t = Un(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ZO(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Un(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function zJ(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function YJ(e) {
  return e === Un(e) || !xn(e) ? Ub(e) : zJ(e);
}
function li(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function vs(e) {
  return ((Xl(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function zb(e) {
  return bo(vs(e)).left + Ub(e).scrollLeft;
}
function Oi(e) {
  return Un(e).getComputedStyle(e);
}
function Yb(e) {
  var t = Oi(e), r = t.overflow, a = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function WJ(e) {
  var t = e.getBoundingClientRect(), r = t.width / e.offsetWidth || 1, a = t.height / e.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function GJ(e, t, r) {
  r === void 0 && (r = !1);
  var a = xn(t);
  xn(t) && WJ(t);
  var n = vs(t), i = bo(e), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((li(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Yb(n)) && (s = YJ(t)), xn(t) ? (o = bo(t), o.x += t.clientLeft, o.y += t.clientTop) : n && (o.x = zb(n))), {
    x: i.left + s.scrollLeft - o.x,
    y: i.top + s.scrollTop - o.y,
    width: i.width,
    height: i.height
  };
}
function Wb(e) {
  var t = bo(e), r = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: a
  };
}
function ef(e) {
  return li(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ZO(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    vs(e)
  );
}
function e3(e) {
  return ["html", "body", "#document"].indexOf(li(e)) >= 0 ? e.ownerDocument.body : xn(e) && Yb(e) ? e : e3(ef(e));
}
function Ll(e, t) {
  var r;
  t === void 0 && (t = []);
  var a = e3(e), n = a === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Un(a), s = n ? [i].concat(i.visualViewport || [], Yb(a) ? a : []) : a, o = t.concat(s);
  return n ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(Ll(ef(s)))
  );
}
function XJ(e) {
  return ["table", "td", "th"].indexOf(li(e)) >= 0;
}
function z2(e) {
  return !xn(e) || // https://github.com/popperjs/popper-core/issues/837
  Oi(e).position === "fixed" ? null : e.offsetParent;
}
function KJ(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && xn(e)) {
    var a = Oi(e);
    if (a.position === "fixed")
      return null;
  }
  for (var n = ef(e); xn(n) && ["html", "body"].indexOf(li(n)) < 0; ) {
    var i = Oi(n);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function ku(e) {
  for (var t = Un(e), r = z2(e); r && XJ(r) && Oi(r).position === "static"; )
    r = z2(r);
  return r && (li(r) === "html" || li(r) === "body" && Oi(r).position === "static") ? t : r || KJ(e) || t;
}
var wn = "top", Fn = "bottom", Bn = "right", Tn = "left", Gb = "auto", Pu = [wn, Fn, Bn, Tn], yo = "start", Kl = "end", JJ = "clippingParents", t3 = "viewport", Sl = "popper", QJ = "reference", Y2 = /* @__PURE__ */ Pu.reduce(function(e, t) {
  return e.concat([t + "-" + yo, t + "-" + Kl]);
}, []), r3 = /* @__PURE__ */ [].concat(Pu, [Gb]).reduce(function(e, t) {
  return e.concat([t, t + "-" + yo, t + "-" + Kl]);
}, []), ZJ = "beforeRead", eQ = "read", tQ = "afterRead", rQ = "beforeMain", aQ = "main", nQ = "afterMain", iQ = "beforeWrite", sQ = "write", oQ = "afterWrite", lQ = [ZJ, eQ, tQ, rQ, aQ, nQ, iQ, sQ, oQ];
function uQ(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function n(i) {
    r.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(o) {
      if (!r.has(o)) {
        var l = t.get(o);
        l && n(l);
      }
    }), a.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || n(i);
  }), a;
}
function dQ(e) {
  var t = uQ(e);
  return lQ.reduce(function(r, a) {
    return r.concat(t.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function cQ(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function ii(e) {
  return e.split("-")[0];
}
function fQ(e) {
  var t = e.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
function pQ(e) {
  var t = Un(e), r = vs(e), a = t.visualViewport, n = r.clientWidth, i = r.clientHeight, s = 0, o = 0;
  return a && (n = a.width, i = a.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (s = a.offsetLeft, o = a.offsetTop)), {
    width: n,
    height: i,
    x: s + zb(e),
    y: o
  };
}
var Ji = Math.max, Jl = Math.min, Gu = Math.round;
function vQ(e) {
  var t, r = vs(e), a = Ub(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ji(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), s = Ji(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), o = -a.scrollLeft + zb(e), l = -a.scrollTop;
  return Oi(n || r).direction === "rtl" && (o += Ji(r.clientWidth, n ? n.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: o,
    y: l
  };
}
function a3(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && ZO(r)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function s1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function mQ(e) {
  var t = bo(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function W2(e, t) {
  return t === t3 ? s1(pQ(e)) : xn(t) ? mQ(t) : s1(vQ(vs(e)));
}
function hQ(e) {
  var t = Ll(ef(e)), r = ["absolute", "fixed"].indexOf(Oi(e).position) >= 0, a = r && xn(e) ? ku(e) : e;
  return Xl(a) ? t.filter(function(n) {
    return Xl(n) && a3(n, a) && li(n) !== "body";
  }) : [];
}
function gQ(e, t, r) {
  var a = t === "clippingParents" ? hQ(e) : [].concat(t), n = [].concat(a, [r]), i = n[0], s = n.reduce(function(o, l) {
    var u = W2(e, l);
    return o.top = Ji(u.top, o.top), o.right = Jl(u.right, o.right), o.bottom = Jl(u.bottom, o.bottom), o.left = Ji(u.left, o.left), o;
  }, W2(e, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function _o(e) {
  return e.split("-")[1];
}
function Xb(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function n3(e) {
  var t = e.reference, r = e.element, a = e.placement, n = a ? ii(a) : null, i = a ? _o(a) : null, s = t.x + t.width / 2 - r.width / 2, o = t.y + t.height / 2 - r.height / 2, l;
  switch (n) {
    case wn:
      l = {
        x: s,
        y: t.y - r.height
      };
      break;
    case Fn:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case Bn:
      l = {
        x: t.x + t.width,
        y: o
      };
      break;
    case Tn:
      l = {
        x: t.x - r.width,
        y: o
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = n ? Xb(n) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (i) {
      case yo:
        l[u] = l[u] - (t[d] / 2 - r[d] / 2);
        break;
      case Kl:
        l[u] = l[u] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return l;
}
function i3() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function s3(e) {
  return Object.assign({}, i3(), e);
}
function o3(e, t) {
  return t.reduce(function(r, a) {
    return r[a] = e, r;
  }, {});
}
function Kb(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = a === void 0 ? e.placement : a, i = r.boundary, s = i === void 0 ? JJ : i, o = r.rootBoundary, l = o === void 0 ? t3 : o, u = r.elementContext, d = u === void 0 ? Sl : u, f = r.altBoundary, c = f === void 0 ? !1 : f, p = r.padding, v = p === void 0 ? 0 : p, h = s3(typeof v != "number" ? v : o3(v, Pu)), g = d === Sl ? QJ : Sl, m = e.rects.popper, b = e.elements[c ? g : d], y = gQ(Xl(b) ? b : b.contextElement || vs(e.elements.popper), s, l), _ = bo(e.elements.reference), x = n3({
    reference: _,
    element: m,
    strategy: "absolute",
    placement: n
  }), w = s1(Object.assign({}, m, x)), k = d === Sl ? w : _, S = {
    top: y.top - k.top + h.top,
    bottom: k.bottom - y.bottom + h.bottom,
    left: y.left - k.left + h.left,
    right: k.right - y.right + h.right
  }, P = e.modifiersData.offset;
  if (d === Sl && P) {
    var A = P[n];
    Object.keys(S).forEach(function(E) {
      var O = [Bn, Fn].indexOf(E) >= 0 ? 1 : -1, T = [wn, Fn].indexOf(E) >= 0 ? "y" : "x";
      S[E] += A[T] * O;
    });
  }
  return S;
}
var G2 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function X2() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function bQ(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, a = r === void 0 ? [] : r, n = t.defaultOptions, i = n === void 0 ? G2 : n;
  return function(o, l, u) {
    u === void 0 && (u = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, G2, i),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], c = !1, p = {
      state: d,
      setOptions: function(m) {
        var b = typeof m == "function" ? m(d.options) : m;
        h(), d.options = Object.assign({}, i, d.options, b), d.scrollParents = {
          reference: Xl(o) ? Ll(o) : o.contextElement ? Ll(o.contextElement) : [],
          popper: Ll(l)
        };
        var y = dQ(fQ([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = y.filter(function(_) {
          return _.enabled;
        }), v(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!c) {
          var m = d.elements, b = m.reference, y = m.popper;
          if (X2(b, y)) {
            d.rects = {
              reference: GJ(b, ku(y), d.options.strategy === "fixed"),
              popper: Wb(y)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(A) {
              return d.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var _ = 0; _ < d.orderedModifiers.length; _++) {
              if (d.reset === !0) {
                d.reset = !1, _ = -1;
                continue;
              }
              var x = d.orderedModifiers[_], w = x.fn, k = x.options, S = k === void 0 ? {} : k, P = x.name;
              typeof w == "function" && (d = w({
                state: d,
                options: S,
                name: P,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: cQ(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        h(), c = !0;
      }
    };
    if (!X2(o, l))
      return p;
    p.setOptions(u).then(function(g) {
      !c && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function v() {
      d.orderedModifiers.forEach(function(g) {
        var m = g.name, b = g.options, y = b === void 0 ? {} : b, _ = g.effect;
        if (typeof _ == "function") {
          var x = _({
            state: d,
            name: m,
            instance: p,
            options: y
          }), w = function() {
          };
          f.push(x || w);
        }
      });
    }
    function h() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return p;
  };
}
var Xu = {
  passive: !0
};
function yQ(e) {
  var t = e.state, r = e.instance, a = e.options, n = a.scroll, i = n === void 0 ? !0 : n, s = a.resize, o = s === void 0 ? !0 : s, l = Un(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(d) {
    d.addEventListener("scroll", r.update, Xu);
  }), o && l.addEventListener("resize", r.update, Xu), function() {
    i && u.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Xu);
    }), o && l.removeEventListener("resize", r.update, Xu);
  };
}
var _Q = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: yQ,
  data: {}
};
function xQ(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = n3({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
var wQ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: xQ,
  data: {}
}, TQ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function SQ(e) {
  var t = e.x, r = e.y, a = window, n = a.devicePixelRatio || 1;
  return {
    x: Gu(Gu(t * n) / n) || 0,
    y: Gu(Gu(r * n) / n) || 0
  };
}
function K2(e) {
  var t, r = e.popper, a = e.popperRect, n = e.placement, i = e.variation, s = e.offsets, o = e.position, l = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = d === !0 ? SQ(s) : typeof d == "function" ? d(s) : s, c = f.x, p = c === void 0 ? 0 : c, v = f.y, h = v === void 0 ? 0 : v, g = s.hasOwnProperty("x"), m = s.hasOwnProperty("y"), b = Tn, y = wn, _ = window;
  if (u) {
    var x = ku(r), w = "clientHeight", k = "clientWidth";
    x === Un(r) && (x = vs(r), Oi(x).position !== "static" && o === "absolute" && (w = "scrollHeight", k = "scrollWidth")), x = x, (n === wn || (n === Tn || n === Bn) && i === Kl) && (y = Fn, h -= x[w] - a.height, h *= l ? 1 : -1), (n === Tn || (n === wn || n === Fn) && i === Kl) && (b = Bn, p -= x[k] - a.width, p *= l ? 1 : -1);
  }
  var S = Object.assign({
    position: o
  }, u && TQ);
  if (l) {
    var P;
    return Object.assign({}, S, (P = {}, P[y] = m ? "0" : "", P[b] = g ? "0" : "", P.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + h + "px)" : "translate3d(" + p + "px, " + h + "px, 0)", P));
  }
  return Object.assign({}, S, (t = {}, t[y] = m ? h + "px" : "", t[b] = g ? p + "px" : "", t.transform = "", t));
}
function EQ(e) {
  var t = e.state, r = e.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, i = r.adaptive, s = i === void 0 ? !0 : i, o = r.roundOffsets, l = o === void 0 ? !0 : o, u = {
    placement: ii(t.placement),
    variation: _o(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, K2(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, K2(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var OQ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: EQ,
  data: {}
};
function CQ(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var a = t.styles[r] || {}, n = t.attributes[r] || {}, i = t.elements[r];
    !xn(i) || !li(i) || (Object.assign(i.style, a), Object.keys(n).forEach(function(s) {
      var o = n[s];
      o === !1 ? i.removeAttribute(s) : i.setAttribute(s, o === !0 ? "" : o);
    }));
  });
}
function kQ(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var n = t.elements[a], i = t.attributes[a] || {}, s = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : r[a]), o = s.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !xn(n) || !li(n) || (Object.assign(n.style, o), Object.keys(i).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
var PQ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: CQ,
  effect: kQ,
  requires: ["computeStyles"]
}, MQ = [_Q, wQ, OQ, PQ], AQ = /* @__PURE__ */ bQ({
  defaultModifiers: MQ
});
function DQ(e) {
  return e === "x" ? "y" : "x";
}
function ld(e, t, r) {
  return Ji(e, Jl(t, r));
}
function IQ(e) {
  var t = e.state, r = e.options, a = e.name, n = r.mainAxis, i = n === void 0 ? !0 : n, s = r.altAxis, o = s === void 0 ? !1 : s, l = r.boundary, u = r.rootBoundary, d = r.altBoundary, f = r.padding, c = r.tether, p = c === void 0 ? !0 : c, v = r.tetherOffset, h = v === void 0 ? 0 : v, g = Kb(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), m = ii(t.placement), b = _o(t.placement), y = !b, _ = Xb(m), x = DQ(_), w = t.modifiersData.popperOffsets, k = t.rects.reference, S = t.rects.popper, P = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, A = {
    x: 0,
    y: 0
  };
  if (w) {
    if (i || o) {
      var E = _ === "y" ? wn : Tn, O = _ === "y" ? Fn : Bn, T = _ === "y" ? "height" : "width", D = w[_], $ = w[_] + g[E], I = w[_] - g[O], F = p ? -S[T] / 2 : 0, j = b === yo ? k[T] : S[T], M = b === yo ? -S[T] : -k[T], q = t.elements.arrow, le = p && q ? Wb(q) : {
        width: 0,
        height: 0
      }, Z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : i3(), G = Z[E], H = Z[O], W = ld(0, k[T], le[T]), ie = y ? k[T] / 2 - F - W - G - P : j - W - G - P, we = y ? -k[T] / 2 + F + W + H + P : M + W + H + P, Be = t.elements.arrow && ku(t.elements.arrow), Ve = Be ? _ === "y" ? Be.clientTop || 0 : Be.clientLeft || 0 : 0, et = t.modifiersData.offset ? t.modifiersData.offset[t.placement][_] : 0, nt = w[_] + ie - et - Ve, xe = w[_] + we - et;
      if (i) {
        var J = ld(p ? Jl($, nt) : $, D, p ? Ji(I, xe) : I);
        w[_] = J, A[_] = J - D;
      }
      if (o) {
        var se = _ === "x" ? wn : Tn, _e = _ === "x" ? Fn : Bn, Se = w[x], Re = Se + g[se], rt = Se - g[_e], Dt = ld(p ? Jl(Re, nt) : Re, Se, p ? Ji(rt, xe) : rt);
        w[x] = Dt, A[x] = Dt - Se;
      }
    }
    t.modifiersData[a] = A;
  }
}
var NQ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: IQ,
  requiresIfExists: ["offset"]
}, $Q = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ud(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return $Q[t];
  });
}
var LQ = {
  start: "end",
  end: "start"
};
function J2(e) {
  return e.replace(/start|end/g, function(t) {
    return LQ[t];
  });
}
function RQ(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = r.boundary, i = r.rootBoundary, s = r.padding, o = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? r3 : l, d = _o(a), f = d ? o ? Y2 : Y2.filter(function(v) {
    return _o(v) === d;
  }) : Pu, c = f.filter(function(v) {
    return u.indexOf(v) >= 0;
  });
  c.length === 0 && (c = f);
  var p = c.reduce(function(v, h) {
    return v[h] = Kb(e, {
      placement: h,
      boundary: n,
      rootBoundary: i,
      padding: s
    })[ii(h)], v;
  }, {});
  return Object.keys(p).sort(function(v, h) {
    return p[v] - p[h];
  });
}
function jQ(e) {
  if (ii(e) === Gb)
    return [];
  var t = ud(e);
  return [J2(e), t, J2(t)];
}
function FQ(e) {
  var t = e.state, r = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var n = r.mainAxis, i = n === void 0 ? !0 : n, s = r.altAxis, o = s === void 0 ? !0 : s, l = r.fallbackPlacements, u = r.padding, d = r.boundary, f = r.rootBoundary, c = r.altBoundary, p = r.flipVariations, v = p === void 0 ? !0 : p, h = r.allowedAutoPlacements, g = t.options.placement, m = ii(g), b = m === g, y = l || (b || !v ? [ud(g)] : jQ(g)), _ = [g].concat(y).reduce(function(H, W) {
      return H.concat(ii(W) === Gb ? RQ(t, {
        placement: W,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: v,
        allowedAutoPlacements: h
      }) : W);
    }, []), x = t.rects.reference, w = t.rects.popper, k = /* @__PURE__ */ new Map(), S = !0, P = _[0], A = 0; A < _.length; A++) {
      var E = _[A], O = ii(E), T = _o(E) === yo, D = [wn, Fn].indexOf(O) >= 0, $ = D ? "width" : "height", I = Kb(t, {
        placement: E,
        boundary: d,
        rootBoundary: f,
        altBoundary: c,
        padding: u
      }), F = D ? T ? Bn : Tn : T ? Fn : wn;
      x[$] > w[$] && (F = ud(F));
      var j = ud(F), M = [];
      if (i && M.push(I[O] <= 0), o && M.push(I[F] <= 0, I[j] <= 0), M.every(function(H) {
        return H;
      })) {
        P = E, S = !1;
        break;
      }
      k.set(E, M);
    }
    if (S)
      for (var q = v ? 3 : 1, le = function(W) {
        var ie = _.find(function(we) {
          var Be = k.get(we);
          if (Be)
            return Be.slice(0, W).every(function(Ve) {
              return Ve;
            });
        });
        if (ie)
          return P = ie, "break";
      }, Z = q; Z > 0; Z--) {
        var G = le(Z);
        if (G === "break")
          break;
      }
    t.placement !== P && (t.modifiersData[a]._skip = !0, t.placement = P, t.reset = !0);
  }
}
var BQ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: FQ,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function qQ(e, t, r) {
  var a = ii(e), n = [Tn, wn].indexOf(a) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, s = i[0], o = i[1];
  return s = s || 0, o = (o || 0) * n, [Tn, Bn].indexOf(a) >= 0 ? {
    x: o,
    y: s
  } : {
    x: s,
    y: o
  };
}
function HQ(e) {
  var t = e.state, r = e.options, a = e.name, n = r.offset, i = n === void 0 ? [0, 0] : n, s = r3.reduce(function(d, f) {
    return d[f] = qQ(f, t.rects, i), d;
  }, {}), o = s[t.placement], l = o.x, u = o.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[a] = s;
}
var VQ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: HQ
}, UQ = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, s3(typeof t != "number" ? t : o3(t, Pu));
};
function zQ(e) {
  var t, r = e.state, a = e.name, n = e.options, i = r.elements.arrow, s = r.modifiersData.popperOffsets, o = ii(r.placement), l = Xb(o), u = [Tn, Bn].indexOf(o) >= 0, d = u ? "height" : "width";
  if (!(!i || !s)) {
    var f = UQ(n.padding, r), c = Wb(i), p = l === "y" ? wn : Tn, v = l === "y" ? Fn : Bn, h = r.rects.reference[d] + r.rects.reference[l] - s[l] - r.rects.popper[d], g = s[l] - r.rects.reference[l], m = ku(i), b = m ? l === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, y = h / 2 - g / 2, _ = f[p], x = b - c[d] - f[v], w = b / 2 - c[d] / 2 + y, k = ld(_, w, x), S = l;
    r.modifiersData[a] = (t = {}, t[S] = k, t.centerOffset = k - w, t);
  }
}
function YQ(e) {
  var t = e.state, r = e.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || a3(t.elements.popper, n) && (t.elements.arrow = n));
}
var WQ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: zQ,
  effect: YQ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const rp = (e) => parseInt(e, 10);
function GQ({
  arrowPadding: e,
  emit: t,
  locked: r,
  offsetDistance: a,
  offsetSkid: n,
  placement: i,
  popperNode: s,
  triggerNode: o
}) {
  const l = Sn({
    isOpen: !1,
    popperInstance: null
  }), u = (h) => {
    var g;
    (g = l.popperInstance) === null || g === void 0 || g.setOptions((m) => ({
      ...m,
      modifiers: [...m.modifiers, {
        name: "eventListeners",
        enabled: h
      }]
    }));
  }, d = () => u(!0), f = () => u(!1), c = () => {
    l.isOpen && (l.isOpen = !1, t("close:popper"));
  }, p = () => {
    l.isOpen || (l.isOpen = !0, t("open:popper"));
  };
  He([() => l.isOpen, i], async ([h]) => {
    h ? (await v(), d()) : f();
  });
  const v = async () => {
    await Pt(), l.popperInstance = AQ(o.value, s.value, {
      placement: i.value,
      modifiers: [NQ, BQ, {
        name: "flip",
        enabled: !r.value
      }, WQ, {
        name: "arrow",
        options: {
          padding: rp(e.value)
        }
      }, VQ, {
        name: "offset",
        options: {
          offset: [rp(n.value), rp(a.value)]
        }
      }]
    }), l.popperInstance.update();
  };
  return Ai(() => {
    var h;
    (h = l.popperInstance) === null || h === void 0 || h.destroy();
  }), {
    ...uo(l),
    open: p,
    close: c
  };
}
const XQ = {
  id: "arrow",
  "data-popper-arrow": ""
};
function KQ(e, t) {
  return R(), K("div", XQ);
}
function l3(e, t) {
  t === void 0 && (t = {});
  var r = t.insertAt;
  if (!(!e || typeof document > "u")) {
    var a = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.type = "text/css", r === "top" && a.firstChild ? a.insertBefore(n, a.firstChild) : a.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
  }
}
var JQ = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
l3(JQ);
const Jb = {};
Jb.render = KQ;
Jb.__scopeId = "data-v-20b7fd4a";
var QQ = Jb;
const ZQ = ["onKeyup"];
var u3 = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(e) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(e);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(e, {
    emit: t
  }) {
    const r = e;
    I1((j) => ({
      c81fc0a4: e.zIndex
    }));
    const a = lu(), n = ne(null), i = ne(null), s = ne(null), o = ne(!1);
    ct(() => {
      const j = a.default();
      if (j && j.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${j.length} child nodes.`);
    });
    const {
      arrowPadding: l,
      closeDelay: u,
      content: d,
      disableClickAway: f,
      disabled: c,
      interactive: p,
      locked: v,
      offsetDistance: h,
      offsetSkid: g,
      openDelay: m,
      placement: b,
      show: y
    } = uo(r), {
      isOpen: _,
      open: x,
      close: w
    } = GQ({
      arrowPadding: l,
      emit: t,
      locked: v,
      offsetDistance: h,
      offsetSkid: g,
      placement: b,
      popperNode: i,
      triggerNode: s
    }), {
      hasContent: k
    } = UJ(a, i, d), S = N(() => y.value !== null), P = N(() => c.value || !k.value), A = N(() => _.value && !P.value), E = N(() => !f.value && !S.value), O = N(() => p.value ? `border: ${h.value}px solid transparent; margin: -${h.value}px;` : null), T = tp.debounce(x, m.value), D = tp.debounce(w, u.value), $ = async () => {
      P.value || S.value || (D.clear(), T());
    }, I = async () => {
      S.value || (T.clear(), D());
    }, F = () => {
      _.value ? I() : $();
    };
    return He([k, c], ([j, M]) => {
      _.value && (!j || M) && w();
    }), He(_, (j) => {
      j ? o.value = !0 : tp.debounce(() => {
        o.value = !1;
      }, 200);
    }), Nr(() => {
      S.value && (y.value ? T() : D());
    }), Nr(() => {
      E.value && VJ(n, I);
    }), (j, M) => (R(), K("div", {
      class: "inline-block",
      style: Ir(U(O)),
      onMouseleave: M[2] || (M[2] = (q) => e.hover && I()),
      ref: (q, le) => {
        le.popperContainerNode = q, n.value = q;
      }
    }, [ue("div", {
      ref: (q, le) => {
        le.triggerNode = q, s.value = q;
      },
      onMouseover: M[0] || (M[0] = (q) => e.hover && $()),
      onClick: F,
      onFocus: $,
      onKeyup: Ot(I, ["esc"])
    }, [ke(j.$slots, "default")], 40, ZQ), Fe(Hn, {
      name: "fade"
    }, {
      default: Pe(() => [ea(ue("div", {
        onClick: M[1] || (M[1] = (q) => !U(p) && I()),
        class: "popper",
        ref: (q, le) => {
          le.popperNode = q, i.value = q;
        }
      }, [ke(j.$slots, "content", {
        close: U(w),
        isOpen: o.value
      }, () => [jt(Ie(U(d)), 1)]), e.arrow ? (R(), Le(QQ, {
        key: 0
      })) : fe("", !0)], 512), [[$a, U(A)]])]),
      _: 3
    })], 36));
  }
}, eZ = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
l3(eZ);
u3.__scopeId = "data-v-5784ed69";
var tZ = /* @__PURE__ */ (() => {
  const e = u3;
  return e.install = (t) => {
    t.component("Popper", e);
  }, e;
})();
const rZ = { class: "cursor-pointer" }, tle = /* @__PURE__ */ Ae({
  __name: "JTooltip",
  setup(e) {
    return (t, r) => (R(), Le(U(tZ), Mt(t.$attrs, {
      openDelay: "200",
      closeDelay: "100"
    }), {
      content: Pe((a) => [
        ke(t.$slots, "content", jr(oa(a)))
      ]),
      default: Pe(() => [
        ue("div", rZ, [
          ke(t.$slots, "activator")
        ])
      ]),
      _: 3
    }, 16));
  }
});
function Ql(e) {
  if (e === 0)
    return "0 Bytes";
  const t = 1024, r = 2, a = ["Bytes", "KB", "MB", "GB"], n = Math.floor(Math.log(e) / Math.log(t));
  return `${Number.parseFloat((e / t ** n).toFixed(r))} ${a[n]}`;
}
const aZ = { class: "input" }, nZ = ["for"], iZ = { class: "input__wrapper relative" }, sZ = { class: "flex items-center gap-8" }, oZ = {
  key: 0,
  class: "text-metadata-limited font-medium text-gray-600"
}, lZ = ["id", "disabled", "accept"], uZ = /* @__PURE__ */ ue("span", { class: "sr-only" }, "Delete", -1), dZ = {
  key: 1,
  class: "input__error"
}, rle = /* @__PURE__ */ Ae({
  __name: "JFileInput",
  props: {
    modelValue: {},
    placeholder: { default: "Upload your file" },
    maxSize: { default: 1 },
    acceptedFileTypes: {},
    id: {},
    label: {},
    color: { default: "gray-400" },
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = Gr(), s = N(() => i("required", !0)), o = N(() => i("disabled", !0)), l = N(() => Zd[r.color]), u = N(
      () => {
        var g;
        return (g = r.error) != null && g.length ? "border-danger" : "border-gray-300";
      }
    ), d = N(
      () => r.id || `file-input-${Math.random().toString(36).substring(2, 15)}`
    ), f = ne(null), c = ne(r.error);
    ct(() => {
      n.value && (f.value = n.value);
    }), He(
      () => n.value,
      (g) => {
        g && (f.value = g);
      }
    ), He(f, (g) => {
      n.value = g;
    });
    function p(g) {
      c.value = null;
      const m = g.target.files;
      if (!m || m.length === 0) {
        f.value = null;
        return;
      }
      const b = m[0], y = r.maxSize * 1024 * 1024;
      if (r.maxSize && b.size > y) {
        c.value = `File size exceeds the maximum allowed size (${Ql(
          y
        )})`, f.value = null;
        return;
      }
      f.value = b;
    }
    const v = ne(null);
    function h() {
      f.value = null;
      const g = v.value;
      g && (g.value = "");
    }
    return (g, m) => (R(), K("label", aZ, [
      g.label ? (R(), K("span", {
        key: 0,
        class: pe(["input__label", s.value && "input--required"]),
        for: d.value
      }, Ie(g.label), 11, nZ)) : fe("", !0),
      ue("div", iZ, [
        ue("div", {
          class: pe(["input__field flex h-40 items-center gap-8 text-subject transition-colors duration-200", [
            l.value,
            u.value,
            {
              "cursor-not-allowed": o.value,
              "mb-4": !!c.value,
              "justify-between bg-gray-100 pe-40 font-medium": !!f.value,
              "pe-4": !f.value
            }
          ]])
        }, [
          ue("div", sZ, [
            Fe(gt, {
              name: f.value ? "document-text-filled" : "document-text",
              class: pe({
                "text-primary": !!f.value,
                "text-dark": !f.value
              })
            }, null, 8, ["name", "class"]),
            f.value ? (R(), K(Qe, { key: 0 }, [
              jt(Ie(f.value.name), 1)
            ], 64)) : fe("", !0)
          ]),
          ue("span", {
            class: pe({
              "flex-1 text-gray-600": !f.value
            })
          }, [
            f.value ? (R(), K("span", oZ, Ie(U(Ql)(f.value.size)), 1)) : (R(), K(Qe, { key: 1 }, [
              jt(Ie(g.placeholder), 1)
            ], 64))
          ], 2),
          f.value ? fe("", !0) : (R(), K("button", {
            key: 0,
            type: "button",
            class: "flex h-32 items-center gap-4 rounded-sm bg-primary p-8 text-base font-medium text-white",
            onClick: m[0] || (m[0] = (b) => {
              var y;
              return (y = v.value) == null ? void 0 : y.click();
            })
          }, [
            Fe(gt, {
              name: "upload-outline",
              size: "16"
            }),
            jt(" Select ")
          ]))
        ], 2),
        ue("input", {
          id: d.value,
          ref_key: "inputRef",
          ref: v,
          type: "file",
          class: "hidden",
          disabled: o.value,
          accept: g.acceptedFileTypes,
          onChange: p
        }, null, 40, lZ),
        f.value ? (R(), K("button", {
          key: 0,
          type: "button",
          class: "absolute end-12 top-1/2 -translate-y-1/2",
          onClick: zr(h, ["prevent"])
        }, [
          Fe(gt, {
            name: "trash",
            size: "16"
          }),
          uZ
        ])) : fe("", !0)
      ]),
      c.value ? (R(), K("span", dZ, Ie(c.value), 1)) : fe("", !0)
    ]));
  }
}), cZ = { class: "flex items-center gap-x-8 font-medium text-gray-600" }, ale = /* @__PURE__ */ Ae({
  __name: "JBreadcrumb",
  props: {
    items: {}
  },
  setup(e) {
    const t = e, { currentLocaleItem: r } = Ii(), a = N(
      () => t.items.map((n) => ({
        component: n.url ? uu : "span",
        attrs: {
          to: n.url,
          class: n.url ? "text-gray-600 no-underline" : "cursor-default"
        },
        label: n.label
      }))
    );
    return (n, i) => (R(), K("div", cZ, [
      (R(!0), K(Qe, null, kt(a.value, (s, o) => (R(), K(Qe, {
        key: `crumb-${o}`
      }, [
        (R(), Le(Za(s.component), jr(oa(s.attrs)), {
          default: Pe(() => [
            jt(Ie(s.label), 1)
          ]),
          _: 2
        }, 1040)),
        o < n.items.length - 1 ? (R(), Le(gt, {
          key: `crumb-${o}`,
          name: U(r).rtl ? "alt-arrow-left-line" : "arrow-right-outline",
          size: "16"
        }, null, 8, ["name"])) : fe("", !0)
      ], 64))), 128))
    ]));
  }
}), fZ = ["image/jpeg", "image/png", "image/jpg"], Q2 = 1024 * 1024, pZ = { class: "group relative rounded-sm border border-line p-4" }, vZ = { class: "absolute inset-4 z-1 flex flex-col justify-between gap-4 bg-black/[.34] p-4 opacity-0 transition-opacity duration-200 ease-in-out group-hover:opacity-100" }, mZ = /* @__PURE__ */ ue("span", { class: "sr-only" }, "Delete", -1), hZ = { class: "flex flex-col gap-1 font-medium text-white" }, gZ = /* @__PURE__ */ Ae({
  __name: "JImageUploaderPreview",
  props: {
    file: {}
  },
  emits: ["delete"],
  setup(e) {
    const t = e, r = N(() => URL.createObjectURL(t.file)), a = ne(""), n = N(() => Ql(t.file.size));
    function i() {
      return new Promise((s) => {
        const o = new Image();
        o.onload = () => {
          s({
            height: o.height,
            width: o.width
          });
        }, o.src = r.value;
      });
    }
    return ct(async () => {
      a.value = await i().then(
        ({ height: s, width: o }) => `${s}x${o}`
      );
    }), (s, o) => (R(), K("div", pZ, [
      Fe(BH, {
        src: r.value,
        alt: s.file.name,
        class: "aspect-square w-full rounded-sm object-cover",
        draggable: "false"
      }, null, 8, ["src", "alt"]),
      ue("div", vZ, [
        ue("button", {
          type: "button",
          class: "self-end text-white",
          onClick: o[0] || (o[0] = (l) => s.$emit("delete"))
        }, [
          Fe(gt, { name: "trash" }),
          mZ
        ]),
        ue("div", hZ, [
          ue("span", null, Ie(a.value), 1),
          ue("span", null, Ie(n.value), 1)
        ])
      ])
    ]));
  }
}), bZ = { class: "input" }, yZ = { class: "rounded-md border border-line p-8" }, _Z = {
  key: 0,
  class: "mb-8 flex items-center text-gray-600"
}, xZ = { class: "text-base font-medium" }, wZ = /* @__PURE__ */ ue("span", { class: "font-medium" }, "Add Photos", -1), TZ = ["accept"], SZ = {
  key: 1,
  class: "mt-8 font-medium text-danger"
}, EZ = {
  key: 2,
  class: "mt-8 font-medium text-gray-600"
}, nle = /* @__PURE__ */ Ae({
  __name: "JImageUploader",
  props: {
    modelValue: { default: () => [] },
    label: {},
    maxCount: {},
    maxSize: { default: 10 },
    maxTotalSize: {},
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t, {
      passive: !0,
      deep: !0
    }), i = ne(r.error);
    function s(p) {
      const v = p.target.files;
      if (!v || v.length === 0)
        return;
      const h = v[0], g = r.maxSize * Q2;
      if (r.maxSize && h.size > g) {
        i.value = `File size exceeds the maximum allowed size (${Ql(
          g
        )})`;
        return;
      }
      n.value = [...n.value, h], i.value = null;
    }
    const o = ne(null), l = Gr(), u = N(() => l("required", !0)), d = N(
      () => {
        var p;
        return (p = n.value) == null ? void 0 : p.reduce((v, h) => v + h.size, 0);
      }
    ), f = N(() => {
      const p = n.value ? n.value.length : 1, v = d.value || 0, h = r.maxCount ? p < r.maxCount : !0, g = r.maxTotalSize ? v < r.maxTotalSize * Q2 : !0;
      return h && g;
    });
    function c(p) {
      n.value = [
        ...n.value.slice(0, p),
        ...n.value.slice(p + 1)
      ];
    }
    return (p, v) => (R(), K("div", bZ, [
      p.label ? (R(), K("label", {
        key: 0,
        class: pe(["input__label", u.value && "input--required"])
      }, Ie(p.label), 3)) : fe("", !0),
      ue("div", yZ, [
        p.maxCount && p.maxTotalSize ? (R(), K("div", _Z, [
          Fe(U(gt), {
            name: "info-outline",
            class: "me-4",
            size: "18"
          }),
          ue("span", xZ, " Attach up " + Ie(p.maxCount) + " images. Total file size may not exceed " + Ie(p.maxTotalSize) + "MB ", 1)
        ])) : fe("", !0),
        Fe(U(RH), {
          spaceLg: "8",
          spaceMd: "8",
          spaceXl: "8",
          spaceSm: "8",
          class: "gap-y-16"
        }, {
          default: Pe(() => [
            (R(!0), K(Qe, null, kt(U(n), (h, g) => (R(), Le(U(h2), {
              key: h.name,
              sm: "6",
              md: "3",
              lg: "2",
              xl: "2"
            }, {
              default: Pe(() => [
                (R(), Le(gZ, {
                  key: g,
                  file: h,
                  onDelete: (m) => c(g)
                }, null, 8, ["file", "onDelete"]))
              ]),
              _: 2
            }, 1024))), 128)),
            f.value ? (R(), Le(U(h2), {
              key: 0,
              sm: "6",
              md: "3",
              lg: "2",
              xl: "2"
            }, {
              default: Pe(() => [
                ue("button", {
                  type: "button",
                  class: "flex aspect-square w-full flex-col items-center justify-center gap-8 rounded-sm border border-dashed border-line bg-gray-100 text-primary",
                  onClick: v[0] || (v[0] = (h) => {
                    var g;
                    return (g = o.value) == null ? void 0 : g.click();
                  })
                }, [
                  Fe(U(gt), {
                    name: "gallery-add",
                    class: "me-4",
                    size: "20"
                  }),
                  wZ
                ]),
                ue("input", {
                  ref_key: "inputRef",
                  ref: o,
                  type: "file",
                  class: "hidden",
                  accept: U(fZ).join(","),
                  onChange: s
                }, null, 40, TZ)
              ]),
              _: 1
            })) : fe("", !0)
          ]),
          _: 1
        }),
        i.value ? (R(), K("div", SZ, Ie(i.value), 1)) : !i.value && d.value && d.value > 0 ? (R(), K("div", EZ, Ie(U(Ql)(d.value || 0)), 1)) : fe("", !0)
      ])
    ]));
  }
});
var OZ = typeof global == "object" && global && global.Object === Object && global;
const d3 = OZ;
var CZ = typeof self == "object" && self && self.Object === Object && self, kZ = d3 || CZ || Function("return this")();
const fi = kZ;
var PZ = fi.Symbol;
const Zi = PZ;
var c3 = Object.prototype, MZ = c3.hasOwnProperty, AZ = c3.toString, El = Zi ? Zi.toStringTag : void 0;
function DZ(e) {
  var t = MZ.call(e, El), r = e[El];
  try {
    e[El] = void 0;
    var a = !0;
  } catch {
  }
  var n = AZ.call(e);
  return a && (t ? e[El] = r : delete e[El]), n;
}
var IZ = Object.prototype, NZ = IZ.toString;
function $Z(e) {
  return NZ.call(e);
}
var LZ = "[object Null]", RZ = "[object Undefined]", Z2 = Zi ? Zi.toStringTag : void 0;
function dl(e) {
  return e == null ? e === void 0 ? RZ : LZ : Z2 && Z2 in Object(e) ? DZ(e) : $Z(e);
}
function Ci(e) {
  return e != null && typeof e == "object";
}
var jZ = Array.isArray;
const As = jZ;
function ms(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function f3(e) {
  return e;
}
var FZ = "[object AsyncFunction]", BZ = "[object Function]", qZ = "[object GeneratorFunction]", HZ = "[object Proxy]";
function Qb(e) {
  if (!ms(e))
    return !1;
  var t = dl(e);
  return t == BZ || t == qZ || t == FZ || t == HZ;
}
var VZ = fi["__core-js_shared__"];
const ap = VZ;
var ew = function() {
  var e = /[^.]+$/.exec(ap && ap.keys && ap.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function UZ(e) {
  return !!ew && ew in e;
}
var zZ = Function.prototype, YZ = zZ.toString;
function Vs(e) {
  if (e != null) {
    try {
      return YZ.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var WZ = /[\\^$.*+?()[\]{}|]/g, GZ = /^\[object .+?Constructor\]$/, XZ = Function.prototype, KZ = Object.prototype, JZ = XZ.toString, QZ = KZ.hasOwnProperty, ZZ = RegExp(
  "^" + JZ.call(QZ).replace(WZ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function eee(e) {
  if (!ms(e) || UZ(e))
    return !1;
  var t = Qb(e) ? ZZ : GZ;
  return t.test(Vs(e));
}
function tee(e, t) {
  return e == null ? void 0 : e[t];
}
function Us(e, t) {
  var r = tee(e, t);
  return eee(r) ? r : void 0;
}
var ree = Us(fi, "WeakMap");
const o1 = ree;
var tw = Object.create, aee = function() {
  function e() {
  }
  return function(t) {
    if (!ms(t))
      return {};
    if (tw)
      return tw(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const nee = aee;
function iee(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function p3(e, t) {
  var r = -1, a = e.length;
  for (t || (t = Array(a)); ++r < a; )
    t[r] = e[r];
  return t;
}
var see = 800, oee = 16, lee = Date.now;
function uee(e) {
  var t = 0, r = 0;
  return function() {
    var a = lee(), n = oee - (a - r);
    if (r = a, n > 0) {
      if (++t >= see)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function dee(e) {
  return function() {
    return e;
  };
}
var cee = function() {
  try {
    var e = Us(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Pd = cee;
var fee = Pd ? function(e, t) {
  return Pd(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: dee(t),
    writable: !0
  });
} : f3;
const pee = fee;
var vee = uee(pee);
const mee = vee;
function hee(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length; ++r < a && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var gee = 9007199254740991, bee = /^(?:0|[1-9]\d*)$/;
function v3(e, t) {
  var r = typeof e;
  return t = t ?? gee, !!t && (r == "number" || r != "symbol" && bee.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Zb(e, t, r) {
  t == "__proto__" && Pd ? Pd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function Mu(e, t) {
  return e === t || e !== e && t !== t;
}
var yee = Object.prototype, _ee = yee.hasOwnProperty;
function m3(e, t, r) {
  var a = e[t];
  (!(_ee.call(e, t) && Mu(a, r)) || r === void 0 && !(t in e)) && Zb(e, t, r);
}
function Au(e, t, r, a) {
  var n = !r;
  r || (r = {});
  for (var i = -1, s = t.length; ++i < s; ) {
    var o = t[i], l = a ? a(r[o], e[o], o, r, e) : void 0;
    l === void 0 && (l = e[o]), n ? Zb(r, o, l) : m3(r, o, l);
  }
  return r;
}
var rw = Math.max;
function xee(e, t, r) {
  return t = rw(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var a = arguments, n = -1, i = rw(a.length - t, 0), s = Array(i); ++n < i; )
      s[n] = a[t + n];
    n = -1;
    for (var o = Array(t + 1); ++n < t; )
      o[n] = a[n];
    return o[t] = r(s), iee(e, this, o);
  };
}
function wee(e, t) {
  return mee(xee(e, t, f3), e + "");
}
var Tee = 9007199254740991;
function h3(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Tee;
}
function tf(e) {
  return e != null && h3(e.length) && !Qb(e);
}
function See(e, t, r) {
  if (!ms(r))
    return !1;
  var a = typeof t;
  return (a == "number" ? tf(r) && v3(t, r.length) : a == "string" && t in r) ? Mu(r[t], e) : !1;
}
function Eee(e) {
  return wee(function(t, r) {
    var a = -1, n = r.length, i = n > 1 ? r[n - 1] : void 0, s = n > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (n--, i) : void 0, s && See(r[0], r[1], s) && (i = n < 3 ? void 0 : i, n = 1), t = Object(t); ++a < n; ) {
      var o = r[a];
      o && e(t, o, a, i);
    }
    return t;
  });
}
var Oee = Object.prototype;
function ey(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Oee;
  return e === r;
}
function Cee(e, t) {
  for (var r = -1, a = Array(e); ++r < e; )
    a[r] = t(r);
  return a;
}
var kee = "[object Arguments]";
function aw(e) {
  return Ci(e) && dl(e) == kee;
}
var g3 = Object.prototype, Pee = g3.hasOwnProperty, Mee = g3.propertyIsEnumerable, Aee = aw(function() {
  return arguments;
}()) ? aw : function(e) {
  return Ci(e) && Pee.call(e, "callee") && !Mee.call(e, "callee");
};
const l1 = Aee;
function Dee() {
  return !1;
}
var b3 = typeof exports == "object" && exports && !exports.nodeType && exports, nw = b3 && typeof module == "object" && module && !module.nodeType && module, Iee = nw && nw.exports === b3, iw = Iee ? fi.Buffer : void 0, Nee = iw ? iw.isBuffer : void 0, $ee = Nee || Dee;
const Zl = $ee;
var Lee = "[object Arguments]", Ree = "[object Array]", jee = "[object Boolean]", Fee = "[object Date]", Bee = "[object Error]", qee = "[object Function]", Hee = "[object Map]", Vee = "[object Number]", Uee = "[object Object]", zee = "[object RegExp]", Yee = "[object Set]", Wee = "[object String]", Gee = "[object WeakMap]", Xee = "[object ArrayBuffer]", Kee = "[object DataView]", Jee = "[object Float32Array]", Qee = "[object Float64Array]", Zee = "[object Int8Array]", ete = "[object Int16Array]", tte = "[object Int32Array]", rte = "[object Uint8Array]", ate = "[object Uint8ClampedArray]", nte = "[object Uint16Array]", ite = "[object Uint32Array]", xr = {};
xr[Jee] = xr[Qee] = xr[Zee] = xr[ete] = xr[tte] = xr[rte] = xr[ate] = xr[nte] = xr[ite] = !0;
xr[Lee] = xr[Ree] = xr[Xee] = xr[jee] = xr[Kee] = xr[Fee] = xr[Bee] = xr[qee] = xr[Hee] = xr[Vee] = xr[Uee] = xr[zee] = xr[Yee] = xr[Wee] = xr[Gee] = !1;
function ste(e) {
  return Ci(e) && h3(e.length) && !!xr[dl(e)];
}
function ty(e) {
  return function(t) {
    return e(t);
  };
}
var y3 = typeof exports == "object" && exports && !exports.nodeType && exports, Rl = y3 && typeof module == "object" && module && !module.nodeType && module, ote = Rl && Rl.exports === y3, np = ote && d3.process, lte = function() {
  try {
    var e = Rl && Rl.require && Rl.require("util").types;
    return e || np && np.binding && np.binding("util");
  } catch {
  }
}();
const xo = lte;
var sw = xo && xo.isTypedArray, ute = sw ? ty(sw) : ste;
const ry = ute;
var dte = Object.prototype, cte = dte.hasOwnProperty;
function _3(e, t) {
  var r = As(e), a = !r && l1(e), n = !r && !a && Zl(e), i = !r && !a && !n && ry(e), s = r || a || n || i, o = s ? Cee(e.length, String) : [], l = o.length;
  for (var u in e)
    (t || cte.call(e, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    v3(u, l))) && o.push(u);
  return o;
}
function x3(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var fte = x3(Object.keys, Object);
const pte = fte;
var vte = Object.prototype, mte = vte.hasOwnProperty;
function hte(e) {
  if (!ey(e))
    return pte(e);
  var t = [];
  for (var r in Object(e))
    mte.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function ay(e) {
  return tf(e) ? _3(e) : hte(e);
}
function gte(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var bte = Object.prototype, yte = bte.hasOwnProperty;
function _te(e) {
  if (!ms(e))
    return gte(e);
  var t = ey(e), r = [];
  for (var a in e)
    a == "constructor" && (t || !yte.call(e, a)) || r.push(a);
  return r;
}
function Du(e) {
  return tf(e) ? _3(e, !0) : _te(e);
}
var xte = Us(Object, "create");
const eu = xte;
function wte() {
  this.__data__ = eu ? eu(null) : {}, this.size = 0;
}
function Tte(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ste = "__lodash_hash_undefined__", Ete = Object.prototype, Ote = Ete.hasOwnProperty;
function Cte(e) {
  var t = this.__data__;
  if (eu) {
    var r = t[e];
    return r === Ste ? void 0 : r;
  }
  return Ote.call(t, e) ? t[e] : void 0;
}
var kte = Object.prototype, Pte = kte.hasOwnProperty;
function Mte(e) {
  var t = this.__data__;
  return eu ? t[e] !== void 0 : Pte.call(t, e);
}
var Ate = "__lodash_hash_undefined__";
function Dte(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = eu && t === void 0 ? Ate : t, this;
}
function Ds(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Ds.prototype.clear = wte;
Ds.prototype.delete = Tte;
Ds.prototype.get = Cte;
Ds.prototype.has = Mte;
Ds.prototype.set = Dte;
function Ite() {
  this.__data__ = [], this.size = 0;
}
function rf(e, t) {
  for (var r = e.length; r--; )
    if (Mu(e[r][0], t))
      return r;
  return -1;
}
var Nte = Array.prototype, $te = Nte.splice;
function Lte(e) {
  var t = this.__data__, r = rf(t, e);
  if (r < 0)
    return !1;
  var a = t.length - 1;
  return r == a ? t.pop() : $te.call(t, r, 1), --this.size, !0;
}
function Rte(e) {
  var t = this.__data__, r = rf(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function jte(e) {
  return rf(this.__data__, e) > -1;
}
function Fte(e, t) {
  var r = this.__data__, a = rf(r, e);
  return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
}
function ji(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
ji.prototype.clear = Ite;
ji.prototype.delete = Lte;
ji.prototype.get = Rte;
ji.prototype.has = jte;
ji.prototype.set = Fte;
var Bte = Us(fi, "Map");
const tu = Bte;
function qte() {
  this.size = 0, this.__data__ = {
    hash: new Ds(),
    map: new (tu || ji)(),
    string: new Ds()
  };
}
function Hte(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function af(e, t) {
  var r = e.__data__;
  return Hte(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Vte(e) {
  var t = af(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Ute(e) {
  return af(this, e).get(e);
}
function zte(e) {
  return af(this, e).has(e);
}
function Yte(e, t) {
  var r = af(this, e), a = r.size;
  return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
}
function zs(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
zs.prototype.clear = qte;
zs.prototype.delete = Vte;
zs.prototype.get = Ute;
zs.prototype.has = zte;
zs.prototype.set = Yte;
function w3(e, t) {
  for (var r = -1, a = t.length, n = e.length; ++r < a; )
    e[n + r] = t[r];
  return e;
}
var Wte = x3(Object.getPrototypeOf, Object);
const ny = Wte;
var Gte = "[object Object]", Xte = Function.prototype, Kte = Object.prototype, T3 = Xte.toString, Jte = Kte.hasOwnProperty, Qte = T3.call(Object);
function Zte(e) {
  if (!Ci(e) || dl(e) != Gte)
    return !1;
  var t = ny(e);
  if (t === null)
    return !0;
  var r = Jte.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && T3.call(r) == Qte;
}
function ere() {
  this.__data__ = new ji(), this.size = 0;
}
function tre(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function rre(e) {
  return this.__data__.get(e);
}
function are(e) {
  return this.__data__.has(e);
}
var nre = 200;
function ire(e, t) {
  var r = this.__data__;
  if (r instanceof ji) {
    var a = r.__data__;
    if (!tu || a.length < nre - 1)
      return a.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new zs(a);
  }
  return r.set(e, t), this.size = r.size, this;
}
function si(e) {
  var t = this.__data__ = new ji(e);
  this.size = t.size;
}
si.prototype.clear = ere;
si.prototype.delete = tre;
si.prototype.get = rre;
si.prototype.has = are;
si.prototype.set = ire;
function sre(e, t) {
  return e && Au(t, ay(t), e);
}
function ore(e, t) {
  return e && Au(t, Du(t), e);
}
var S3 = typeof exports == "object" && exports && !exports.nodeType && exports, ow = S3 && typeof module == "object" && module && !module.nodeType && module, lre = ow && ow.exports === S3, lw = lre ? fi.Buffer : void 0, uw = lw ? lw.allocUnsafe : void 0;
function E3(e, t) {
  if (t)
    return e.slice();
  var r = e.length, a = uw ? uw(r) : new e.constructor(r);
  return e.copy(a), a;
}
function ure(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length, n = 0, i = []; ++r < a; ) {
    var s = e[r];
    t(s, r, e) && (i[n++] = s);
  }
  return i;
}
function O3() {
  return [];
}
var dre = Object.prototype, cre = dre.propertyIsEnumerable, dw = Object.getOwnPropertySymbols, fre = dw ? function(e) {
  return e == null ? [] : (e = Object(e), ure(dw(e), function(t) {
    return cre.call(e, t);
  }));
} : O3;
const iy = fre;
function pre(e, t) {
  return Au(e, iy(e), t);
}
var vre = Object.getOwnPropertySymbols, mre = vre ? function(e) {
  for (var t = []; e; )
    w3(t, iy(e)), e = ny(e);
  return t;
} : O3;
const C3 = mre;
function hre(e, t) {
  return Au(e, C3(e), t);
}
function k3(e, t, r) {
  var a = t(e);
  return As(e) ? a : w3(a, r(e));
}
function u1(e) {
  return k3(e, ay, iy);
}
function gre(e) {
  return k3(e, Du, C3);
}
var bre = Us(fi, "DataView");
const d1 = bre;
var yre = Us(fi, "Promise");
const c1 = yre;
var _re = Us(fi, "Set");
const f1 = _re;
var cw = "[object Map]", xre = "[object Object]", fw = "[object Promise]", pw = "[object Set]", vw = "[object WeakMap]", mw = "[object DataView]", wre = Vs(d1), Tre = Vs(tu), Sre = Vs(c1), Ere = Vs(f1), Ore = Vs(o1), ws = dl;
(d1 && ws(new d1(new ArrayBuffer(1))) != mw || tu && ws(new tu()) != cw || c1 && ws(c1.resolve()) != fw || f1 && ws(new f1()) != pw || o1 && ws(new o1()) != vw) && (ws = function(e) {
  var t = dl(e), r = t == xre ? e.constructor : void 0, a = r ? Vs(r) : "";
  if (a)
    switch (a) {
      case wre:
        return mw;
      case Tre:
        return cw;
      case Sre:
        return fw;
      case Ere:
        return pw;
      case Ore:
        return vw;
    }
  return t;
});
const ru = ws;
var Cre = Object.prototype, kre = Cre.hasOwnProperty;
function Pre(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && kre.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Mre = fi.Uint8Array;
const Md = Mre;
function sy(e) {
  var t = new e.constructor(e.byteLength);
  return new Md(t).set(new Md(e)), t;
}
function Are(e, t) {
  var r = t ? sy(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Dre = /\w*$/;
function Ire(e) {
  var t = new e.constructor(e.source, Dre.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var hw = Zi ? Zi.prototype : void 0, gw = hw ? hw.valueOf : void 0;
function Nre(e) {
  return gw ? Object(gw.call(e)) : {};
}
function P3(e, t) {
  var r = t ? sy(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var $re = "[object Boolean]", Lre = "[object Date]", Rre = "[object Map]", jre = "[object Number]", Fre = "[object RegExp]", Bre = "[object Set]", qre = "[object String]", Hre = "[object Symbol]", Vre = "[object ArrayBuffer]", Ure = "[object DataView]", zre = "[object Float32Array]", Yre = "[object Float64Array]", Wre = "[object Int8Array]", Gre = "[object Int16Array]", Xre = "[object Int32Array]", Kre = "[object Uint8Array]", Jre = "[object Uint8ClampedArray]", Qre = "[object Uint16Array]", Zre = "[object Uint32Array]";
function eae(e, t, r) {
  var a = e.constructor;
  switch (t) {
    case Vre:
      return sy(e);
    case $re:
    case Lre:
      return new a(+e);
    case Ure:
      return Are(e, r);
    case zre:
    case Yre:
    case Wre:
    case Gre:
    case Xre:
    case Kre:
    case Jre:
    case Qre:
    case Zre:
      return P3(e, r);
    case Rre:
      return new a();
    case jre:
    case qre:
      return new a(e);
    case Fre:
      return Ire(e);
    case Bre:
      return new a();
    case Hre:
      return Nre(e);
  }
}
function M3(e) {
  return typeof e.constructor == "function" && !ey(e) ? nee(ny(e)) : {};
}
var tae = "[object Map]";
function rae(e) {
  return Ci(e) && ru(e) == tae;
}
var bw = xo && xo.isMap, aae = bw ? ty(bw) : rae;
const nae = aae;
var iae = "[object Set]";
function sae(e) {
  return Ci(e) && ru(e) == iae;
}
var yw = xo && xo.isSet, oae = yw ? ty(yw) : sae;
const lae = oae;
var uae = 1, dae = 2, cae = 4, A3 = "[object Arguments]", fae = "[object Array]", pae = "[object Boolean]", vae = "[object Date]", mae = "[object Error]", D3 = "[object Function]", hae = "[object GeneratorFunction]", gae = "[object Map]", bae = "[object Number]", I3 = "[object Object]", yae = "[object RegExp]", _ae = "[object Set]", xae = "[object String]", wae = "[object Symbol]", Tae = "[object WeakMap]", Sae = "[object ArrayBuffer]", Eae = "[object DataView]", Oae = "[object Float32Array]", Cae = "[object Float64Array]", kae = "[object Int8Array]", Pae = "[object Int16Array]", Mae = "[object Int32Array]", Aae = "[object Uint8Array]", Dae = "[object Uint8ClampedArray]", Iae = "[object Uint16Array]", Nae = "[object Uint32Array]", mr = {};
mr[A3] = mr[fae] = mr[Sae] = mr[Eae] = mr[pae] = mr[vae] = mr[Oae] = mr[Cae] = mr[kae] = mr[Pae] = mr[Mae] = mr[gae] = mr[bae] = mr[I3] = mr[yae] = mr[_ae] = mr[xae] = mr[wae] = mr[Aae] = mr[Dae] = mr[Iae] = mr[Nae] = !0;
mr[mae] = mr[D3] = mr[Tae] = !1;
function dd(e, t, r, a, n, i) {
  var s, o = t & uae, l = t & dae, u = t & cae;
  if (r && (s = n ? r(e, a, n, i) : r(e)), s !== void 0)
    return s;
  if (!ms(e))
    return e;
  var d = As(e);
  if (d) {
    if (s = Pre(e), !o)
      return p3(e, s);
  } else {
    var f = ru(e), c = f == D3 || f == hae;
    if (Zl(e))
      return E3(e, o);
    if (f == I3 || f == A3 || c && !n) {
      if (s = l || c ? {} : M3(e), !o)
        return l ? hre(e, ore(s, e)) : pre(e, sre(s, e));
    } else {
      if (!mr[f])
        return n ? e : {};
      s = eae(e, f, o);
    }
  }
  i || (i = new si());
  var p = i.get(e);
  if (p)
    return p;
  i.set(e, s), lae(e) ? e.forEach(function(g) {
    s.add(dd(g, t, r, g, e, i));
  }) : nae(e) && e.forEach(function(g, m) {
    s.set(m, dd(g, t, r, m, e, i));
  });
  var v = u ? l ? gre : u1 : l ? Du : ay, h = d ? void 0 : v(e);
  return hee(h || e, function(g, m) {
    h && (m = g, g = e[m]), m3(s, m, dd(g, t, r, m, e, i));
  }), s;
}
var $ae = 1, Lae = 4;
function fo(e) {
  return dd(e, $ae | Lae);
}
var Rae = "__lodash_hash_undefined__";
function jae(e) {
  return this.__data__.set(e, Rae), this;
}
function Fae(e) {
  return this.__data__.has(e);
}
function Ad(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new zs(); ++t < r; )
    this.add(e[t]);
}
Ad.prototype.add = Ad.prototype.push = jae;
Ad.prototype.has = Fae;
function Bae(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length; ++r < a; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function qae(e, t) {
  return e.has(t);
}
var Hae = 1, Vae = 2;
function N3(e, t, r, a, n, i) {
  var s = r & Hae, o = e.length, l = t.length;
  if (o != l && !(s && l > o))
    return !1;
  var u = i.get(e), d = i.get(t);
  if (u && d)
    return u == t && d == e;
  var f = -1, c = !0, p = r & Vae ? new Ad() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < o; ) {
    var v = e[f], h = t[f];
    if (a)
      var g = s ? a(h, v, f, t, e, i) : a(v, h, f, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      c = !1;
      break;
    }
    if (p) {
      if (!Bae(t, function(m, b) {
        if (!qae(p, b) && (v === m || n(v, m, r, a, i)))
          return p.push(b);
      })) {
        c = !1;
        break;
      }
    } else if (!(v === h || n(v, h, r, a, i))) {
      c = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), c;
}
function Uae(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a, n) {
    r[++t] = [n, a];
  }), r;
}
function zae(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a) {
    r[++t] = a;
  }), r;
}
var Yae = 1, Wae = 2, Gae = "[object Boolean]", Xae = "[object Date]", Kae = "[object Error]", Jae = "[object Map]", Qae = "[object Number]", Zae = "[object RegExp]", ene = "[object Set]", tne = "[object String]", rne = "[object Symbol]", ane = "[object ArrayBuffer]", nne = "[object DataView]", _w = Zi ? Zi.prototype : void 0, ip = _w ? _w.valueOf : void 0;
function ine(e, t, r, a, n, i, s) {
  switch (r) {
    case nne:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ane:
      return !(e.byteLength != t.byteLength || !i(new Md(e), new Md(t)));
    case Gae:
    case Xae:
    case Qae:
      return Mu(+e, +t);
    case Kae:
      return e.name == t.name && e.message == t.message;
    case Zae:
    case tne:
      return e == t + "";
    case Jae:
      var o = Uae;
    case ene:
      var l = a & Yae;
      if (o || (o = zae), e.size != t.size && !l)
        return !1;
      var u = s.get(e);
      if (u)
        return u == t;
      a |= Wae, s.set(e, t);
      var d = N3(o(e), o(t), a, n, i, s);
      return s.delete(e), d;
    case rne:
      if (ip)
        return ip.call(e) == ip.call(t);
  }
  return !1;
}
var sne = 1, one = Object.prototype, lne = one.hasOwnProperty;
function une(e, t, r, a, n, i) {
  var s = r & sne, o = u1(e), l = o.length, u = u1(t), d = u.length;
  if (l != d && !s)
    return !1;
  for (var f = l; f--; ) {
    var c = o[f];
    if (!(s ? c in t : lne.call(t, c)))
      return !1;
  }
  var p = i.get(e), v = i.get(t);
  if (p && v)
    return p == t && v == e;
  var h = !0;
  i.set(e, t), i.set(t, e);
  for (var g = s; ++f < l; ) {
    c = o[f];
    var m = e[c], b = t[c];
    if (a)
      var y = s ? a(b, m, c, t, e, i) : a(m, b, c, e, t, i);
    if (!(y === void 0 ? m === b || n(m, b, r, a, i) : y)) {
      h = !1;
      break;
    }
    g || (g = c == "constructor");
  }
  if (h && !g) {
    var _ = e.constructor, x = t.constructor;
    _ != x && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof x == "function" && x instanceof x) && (h = !1);
  }
  return i.delete(e), i.delete(t), h;
}
var dne = 1, xw = "[object Arguments]", ww = "[object Array]", Ku = "[object Object]", cne = Object.prototype, Tw = cne.hasOwnProperty;
function fne(e, t, r, a, n, i) {
  var s = As(e), o = As(t), l = s ? ww : ru(e), u = o ? ww : ru(t);
  l = l == xw ? Ku : l, u = u == xw ? Ku : u;
  var d = l == Ku, f = u == Ku, c = l == u;
  if (c && Zl(e)) {
    if (!Zl(t))
      return !1;
    s = !0, d = !1;
  }
  if (c && !d)
    return i || (i = new si()), s || ry(e) ? N3(e, t, r, a, n, i) : ine(e, t, l, r, a, n, i);
  if (!(r & dne)) {
    var p = d && Tw.call(e, "__wrapped__"), v = f && Tw.call(t, "__wrapped__");
    if (p || v) {
      var h = p ? e.value() : e, g = v ? t.value() : t;
      return i || (i = new si()), n(h, g, r, a, i);
    }
  }
  return c ? (i || (i = new si()), une(e, t, r, a, n, i)) : !1;
}
function $3(e, t, r, a, n) {
  return e === t ? !0 : e == null || t == null || !Ci(e) && !Ci(t) ? e !== e && t !== t : fne(e, t, r, a, $3, n);
}
function pne(e) {
  return function(t, r, a) {
    for (var n = -1, i = Object(t), s = a(t), o = s.length; o--; ) {
      var l = s[e ? o : ++n];
      if (r(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var vne = pne();
const mne = vne;
function p1(e, t, r) {
  (r !== void 0 && !Mu(e[t], r) || r === void 0 && !(t in e)) && Zb(e, t, r);
}
function hne(e) {
  return Ci(e) && tf(e);
}
function v1(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function gne(e) {
  return Au(e, Du(e));
}
function bne(e, t, r, a, n, i, s) {
  var o = v1(e, r), l = v1(t, r), u = s.get(l);
  if (u) {
    p1(e, r, u);
    return;
  }
  var d = i ? i(o, l, r + "", e, t, s) : void 0, f = d === void 0;
  if (f) {
    var c = As(l), p = !c && Zl(l), v = !c && !p && ry(l);
    d = l, c || p || v ? As(o) ? d = o : hne(o) ? d = p3(o) : p ? (f = !1, d = E3(l, !0)) : v ? (f = !1, d = P3(l, !0)) : d = [] : Zte(l) || l1(l) ? (d = o, l1(o) ? d = gne(o) : (!ms(o) || Qb(o)) && (d = M3(l))) : f = !1;
  }
  f && (s.set(l, d), n(d, l, a, i, s), s.delete(l)), p1(e, r, d);
}
function L3(e, t, r, a, n) {
  e !== t && mne(t, function(i, s) {
    if (n || (n = new si()), ms(i))
      bne(e, t, s, r, L3, a, n);
    else {
      var o = a ? a(v1(e, s), i, s + "", e, t, n) : void 0;
      o === void 0 && (o = i), p1(e, s, o);
    }
  }, Du);
}
function oy(e, t) {
  return $3(e, t);
}
var yne = Eee(function(e, t, r) {
  L3(e, t, r);
});
const Qi = yne;
var vt = /* @__PURE__ */ ((e) => (e[e.TYPE = 3] = "TYPE", e[e.LEVEL = 12] = "LEVEL", e[e.ATTRIBUTE = 13] = "ATTRIBUTE", e[e.BLOT = 14] = "BLOT", e[e.INLINE = 7] = "INLINE", e[e.BLOCK = 11] = "BLOCK", e[e.BLOCK_BLOT = 10] = "BLOCK_BLOT", e[e.INLINE_BLOT = 6] = "INLINE_BLOT", e[e.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", e[e.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", e[e.ANY = 15] = "ANY", e))(vt || {});
class ui {
  constructor(t, r, a = {}) {
    this.attrName = t, this.keyName = r;
    const n = vt.TYPE & vt.ATTRIBUTE;
    this.scope = a.scope != null ? (
      // Ignore type bits, force attribute bit
      a.scope & vt.LEVEL | n
    ) : vt.ATTRIBUTE, a.whitelist != null && (this.whitelist = a.whitelist);
  }
  static keys(t) {
    return Array.from(t.attributes).map((r) => r.name);
  }
  add(t, r) {
    return this.canAdd(t, r) ? (t.setAttribute(this.keyName, r), !0) : !1;
  }
  canAdd(t, r) {
    return this.whitelist == null ? !0 : typeof r == "string" ? this.whitelist.indexOf(r.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(r) > -1;
  }
  remove(t) {
    t.removeAttribute(this.keyName);
  }
  value(t) {
    const r = t.getAttribute(this.keyName);
    return this.canAdd(t, r) && r ? r : "";
  }
}
class po extends Error {
  constructor(t) {
    t = "[Parchment] " + t, super(t), this.message = t, this.name = this.constructor.name;
  }
}
const R3 = class m1 {
  constructor() {
    this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
  }
  static find(t, r = !1) {
    if (t == null)
      return null;
    if (this.blots.has(t))
      return this.blots.get(t) || null;
    if (r) {
      let a = null;
      try {
        a = t.parentNode;
      } catch {
        return null;
      }
      return this.find(a, r);
    }
    return null;
  }
  create(t, r, a) {
    const n = this.query(r);
    if (n == null)
      throw new po(`Unable to create ${r} blot`);
    const i = n, s = (
      // @ts-expect-error Fix me later
      r instanceof Node || r.nodeType === Node.TEXT_NODE ? r : i.create(a)
    ), o = new i(t, s, a);
    return m1.blots.set(o.domNode, o), o;
  }
  find(t, r = !1) {
    return m1.find(t, r);
  }
  query(t, r = vt.ANY) {
    let a;
    return typeof t == "string" ? a = this.types[t] || this.attributes[t] : t instanceof Text || t.nodeType === Node.TEXT_NODE ? a = this.types.text : typeof t == "number" ? t & vt.LEVEL & vt.BLOCK ? a = this.types.block : t & vt.LEVEL & vt.INLINE && (a = this.types.inline) : t instanceof Element && ((t.getAttribute("class") || "").split(/\s+/).some((n) => (a = this.classes[n], !!a)), a = a || this.tags[t.tagName]), a == null ? null : "scope" in a && r & vt.LEVEL & a.scope && r & vt.TYPE & a.scope ? a : null;
  }
  register(...t) {
    return t.map((r) => {
      const a = "blotName" in r, n = "attrName" in r;
      if (!a && !n)
        throw new po("Invalid definition");
      if (a && r.blotName === "abstract")
        throw new po("Cannot register abstract class");
      const i = a ? r.blotName : n ? r.attrName : void 0;
      return this.types[i] = r, n ? typeof r.keyName == "string" && (this.attributes[r.keyName] = r) : a && (r.className && (this.classes[r.className] = r), r.tagName && (Array.isArray(r.tagName) ? r.tagName = r.tagName.map((s) => s.toUpperCase()) : r.tagName = r.tagName.toUpperCase(), (Array.isArray(r.tagName) ? r.tagName : [r.tagName]).forEach((s) => {
        (this.tags[s] == null || r.className == null) && (this.tags[s] = r);
      }))), r;
    });
  }
};
R3.blots = /* @__PURE__ */ new WeakMap();
let wo = R3;
function Sw(e, t) {
  return (e.getAttribute("class") || "").split(/\s+/).filter((r) => r.indexOf(`${t}-`) === 0);
}
class _ne extends ui {
  static keys(t) {
    return (t.getAttribute("class") || "").split(/\s+/).map((r) => r.split("-").slice(0, -1).join("-"));
  }
  add(t, r) {
    return this.canAdd(t, r) ? (this.remove(t), t.classList.add(`${this.keyName}-${r}`), !0) : !1;
  }
  remove(t) {
    Sw(t, this.keyName).forEach((r) => {
      t.classList.remove(r);
    }), t.classList.length === 0 && t.removeAttribute("class");
  }
  value(t) {
    const r = (Sw(t, this.keyName)[0] || "").slice(this.keyName.length + 1);
    return this.canAdd(t, r) ? r : "";
  }
}
const zn = _ne;
function sp(e) {
  const t = e.split("-"), r = t.slice(1).map((a) => a[0].toUpperCase() + a.slice(1)).join("");
  return t[0] + r;
}
class xne extends ui {
  static keys(t) {
    return (t.getAttribute("style") || "").split(";").map((r) => r.split(":")[0].trim());
  }
  add(t, r) {
    return this.canAdd(t, r) ? (t.style[sp(this.keyName)] = r, !0) : !1;
  }
  remove(t) {
    t.style[sp(this.keyName)] = "", t.getAttribute("style") || t.removeAttribute("style");
  }
  value(t) {
    const r = t.style[sp(this.keyName)];
    return this.canAdd(t, r) ? r : "";
  }
}
const hs = xne;
class wne {
  constructor(t) {
    this.attributes = {}, this.domNode = t, this.build();
  }
  attribute(t, r) {
    r ? t.add(this.domNode, r) && (t.value(this.domNode) != null ? this.attributes[t.attrName] = t : delete this.attributes[t.attrName]) : (t.remove(this.domNode), delete this.attributes[t.attrName]);
  }
  build() {
    this.attributes = {};
    const t = wo.find(this.domNode);
    if (t == null)
      return;
    const r = ui.keys(this.domNode), a = zn.keys(this.domNode), n = hs.keys(this.domNode);
    r.concat(a).concat(n).forEach((i) => {
      const s = t.scroll.query(i, vt.ATTRIBUTE);
      s instanceof ui && (this.attributes[s.attrName] = s);
    });
  }
  copy(t) {
    Object.keys(this.attributes).forEach((r) => {
      const a = this.attributes[r].value(this.domNode);
      t.format(r, a);
    });
  }
  move(t) {
    this.copy(t), Object.keys(this.attributes).forEach((r) => {
      this.attributes[r].remove(this.domNode);
    }), this.attributes = {};
  }
  values() {
    return Object.keys(this.attributes).reduce(
      (t, r) => (t[r] = this.attributes[r].value(this.domNode), t),
      {}
    );
  }
}
const nf = wne, j3 = class {
  constructor(t, r) {
    this.scroll = t, this.domNode = r, wo.blots.set(r, this), this.prev = null, this.next = null;
  }
  static create(t) {
    if (this.tagName == null)
      throw new po("Blot definition missing tagName");
    let r, a;
    return Array.isArray(this.tagName) ? (typeof t == "string" ? (a = t.toUpperCase(), parseInt(a, 10).toString() === a && (a = parseInt(a, 10))) : typeof t == "number" && (a = t), typeof a == "number" ? r = document.createElement(this.tagName[a - 1]) : a && this.tagName.indexOf(a) > -1 ? r = document.createElement(a) : r = document.createElement(this.tagName[0])) : r = document.createElement(this.tagName), this.className && r.classList.add(this.className), r;
  }
  // Hack for accessing inherited static methods
  get statics() {
    return this.constructor;
  }
  attach() {
  }
  clone() {
    const t = this.domNode.cloneNode(!1);
    return this.scroll.create(t);
  }
  detach() {
    this.parent != null && this.parent.removeChild(this), wo.blots.delete(this.domNode);
  }
  deleteAt(t, r) {
    this.isolate(t, r).remove();
  }
  formatAt(t, r, a, n) {
    const i = this.isolate(t, r);
    if (this.scroll.query(a, vt.BLOT) != null && n)
      i.wrap(a, n);
    else if (this.scroll.query(a, vt.ATTRIBUTE) != null) {
      const s = this.scroll.create(this.statics.scope);
      i.wrap(s), s.format(a, n);
    }
  }
  insertAt(t, r, a) {
    const n = a == null ? this.scroll.create("text", r) : this.scroll.create(r, a), i = this.split(t);
    this.parent.insertBefore(n, i || void 0);
  }
  isolate(t, r) {
    const a = this.split(t);
    if (a == null)
      throw new Error("Attempt to isolate at end");
    return a.split(r), a;
  }
  length() {
    return 1;
  }
  offset(t = this.parent) {
    return this.parent == null || this === t ? 0 : this.parent.children.offset(this) + this.parent.offset(t);
  }
  optimize(t) {
    this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
  }
  remove() {
    this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
  }
  replaceWith(t, r) {
    const a = typeof t == "string" ? this.scroll.create(t, r) : t;
    return this.parent != null && (this.parent.insertBefore(a, this.next || void 0), this.remove()), a;
  }
  split(t, r) {
    return t === 0 ? this : this.next;
  }
  update(t, r) {
  }
  wrap(t, r) {
    const a = typeof t == "string" ? this.scroll.create(t, r) : t;
    if (this.parent != null && this.parent.insertBefore(a, this.next || void 0), typeof a.appendChild != "function")
      throw new po(`Cannot wrap ${t}`);
    return a.appendChild(this), a;
  }
};
j3.blotName = "abstract";
let F3 = j3;
const B3 = class extends F3 {
  /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */
  static value(t) {
    return !0;
  }
  /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */
  index(t, r) {
    return this.domNode === t || this.domNode.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(r, 1) : -1;
  }
  /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */
  position(t, r) {
    let a = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
    return t > 0 && (a += 1), [this.parent.domNode, a];
  }
  /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */
  value() {
    return {
      [this.statics.blotName]: this.statics.value(this.domNode) || !0
    };
  }
};
B3.scope = vt.INLINE_BLOT;
let Tne = B3;
const ma = Tne;
class Sne {
  constructor() {
    this.head = null, this.tail = null, this.length = 0;
  }
  append(...t) {
    if (this.insertBefore(t[0], null), t.length > 1) {
      const r = t.slice(1);
      this.append(...r);
    }
  }
  at(t) {
    const r = this.iterator();
    let a = r();
    for (; a && t > 0; )
      t -= 1, a = r();
    return a;
  }
  contains(t) {
    const r = this.iterator();
    let a = r();
    for (; a; ) {
      if (a === t)
        return !0;
      a = r();
    }
    return !1;
  }
  indexOf(t) {
    const r = this.iterator();
    let a = r(), n = 0;
    for (; a; ) {
      if (a === t)
        return n;
      n += 1, a = r();
    }
    return -1;
  }
  insertBefore(t, r) {
    t != null && (this.remove(t), t.next = r, r != null ? (t.prev = r.prev, r.prev != null && (r.prev.next = t), r.prev = t, r === this.head && (this.head = t)) : this.tail != null ? (this.tail.next = t, t.prev = this.tail, this.tail = t) : (t.prev = null, this.head = this.tail = t), this.length += 1);
  }
  offset(t) {
    let r = 0, a = this.head;
    for (; a != null; ) {
      if (a === t)
        return r;
      r += a.length(), a = a.next;
    }
    return -1;
  }
  remove(t) {
    this.contains(t) && (t.prev != null && (t.prev.next = t.next), t.next != null && (t.next.prev = t.prev), t === this.head && (this.head = t.next), t === this.tail && (this.tail = t.prev), this.length -= 1);
  }
  iterator(t = this.head) {
    return () => {
      const r = t;
      return t != null && (t = t.next), r;
    };
  }
  find(t, r = !1) {
    const a = this.iterator();
    let n = a();
    for (; n; ) {
      const i = n.length();
      if (t < i || r && t === i && (n.next == null || n.next.length() !== 0))
        return [n, t];
      t -= i, n = a();
    }
    return [null, 0];
  }
  forEach(t) {
    const r = this.iterator();
    let a = r();
    for (; a; )
      t(a), a = r();
  }
  forEachAt(t, r, a) {
    if (r <= 0)
      return;
    const [n, i] = this.find(t);
    let s = t - i;
    const o = this.iterator(n);
    let l = o();
    for (; l && s < t + r; ) {
      const u = l.length();
      t > s ? a(
        l,
        t - s,
        Math.min(r, s + u - t)
      ) : a(l, 0, Math.min(u, t + r - s)), s += u, l = o();
    }
  }
  map(t) {
    return this.reduce((r, a) => (r.push(t(a)), r), []);
  }
  reduce(t, r) {
    const a = this.iterator();
    let n = a();
    for (; n; )
      r = t(r, n), n = a();
    return r;
  }
}
function Ew(e, t) {
  const r = t.find(e);
  if (r)
    return r;
  try {
    return t.create(e);
  } catch {
    const a = t.create(vt.INLINE);
    return Array.from(e.childNodes).forEach((n) => {
      a.domNode.appendChild(n);
    }), e.parentNode && e.parentNode.replaceChild(a.domNode, e), a.attach(), a;
  }
}
const q3 = class Vi extends F3 {
  constructor(t, r) {
    super(t, r), this.uiNode = null, this.build();
  }
  appendChild(t) {
    this.insertBefore(t);
  }
  attach() {
    super.attach(), this.children.forEach((t) => {
      t.attach();
    });
  }
  attachUI(t) {
    this.uiNode != null && this.uiNode.remove(), this.uiNode = t, Vi.uiClass && this.uiNode.classList.add(Vi.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
  }
  /**
   * Called during construction, should fill its own children LinkedList.
   */
  build() {
    this.children = new Sne(), Array.from(this.domNode.childNodes).filter((t) => t !== this.uiNode).reverse().forEach((t) => {
      try {
        const r = Ew(t, this.scroll);
        this.insertBefore(r, this.children.head || void 0);
      } catch (r) {
        if (r instanceof po)
          return;
        throw r;
      }
    });
  }
  deleteAt(t, r) {
    if (t === 0 && r === this.length())
      return this.remove();
    this.children.forEachAt(t, r, (a, n, i) => {
      a.deleteAt(n, i);
    });
  }
  descendant(t, r = 0) {
    const [a, n] = this.children.find(r);
    return t.blotName == null && t(a) || t.blotName != null && a instanceof t ? [a, n] : a instanceof Vi ? a.descendant(t, n) : [null, -1];
  }
  descendants(t, r = 0, a = Number.MAX_VALUE) {
    let n = [], i = a;
    return this.children.forEachAt(
      r,
      a,
      (s, o, l) => {
        (t.blotName == null && t(s) || t.blotName != null && s instanceof t) && n.push(s), s instanceof Vi && (n = n.concat(
          s.descendants(t, o, i)
        )), i -= l;
      }
    ), n;
  }
  detach() {
    this.children.forEach((t) => {
      t.detach();
    }), super.detach();
  }
  enforceAllowedChildren() {
    let t = !1;
    this.children.forEach((r) => {
      t || this.statics.allowedChildren.some(
        (a) => r instanceof a
      ) || (r.statics.scope === vt.BLOCK_BLOT ? (r.next != null && this.splitAfter(r), r.prev != null && this.splitAfter(r.prev), r.parent.unwrap(), t = !0) : r instanceof Vi ? r.unwrap() : r.remove());
    });
  }
  formatAt(t, r, a, n) {
    this.children.forEachAt(t, r, (i, s, o) => {
      i.formatAt(s, o, a, n);
    });
  }
  insertAt(t, r, a) {
    const [n, i] = this.children.find(t);
    if (n)
      n.insertAt(i, r, a);
    else {
      const s = a == null ? this.scroll.create("text", r) : this.scroll.create(r, a);
      this.appendChild(s);
    }
  }
  insertBefore(t, r) {
    t.parent != null && t.parent.children.remove(t);
    let a = null;
    this.children.insertBefore(t, r || null), t.parent = this, r != null && (a = r.domNode), (this.domNode.parentNode !== t.domNode || this.domNode.nextSibling !== a) && this.domNode.insertBefore(t.domNode, a), t.attach();
  }
  length() {
    return this.children.reduce((t, r) => t + r.length(), 0);
  }
  moveChildren(t, r) {
    this.children.forEach((a) => {
      t.insertBefore(a, r);
    });
  }
  optimize(t) {
    if (super.optimize(t), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0)
      if (this.statics.defaultChild != null) {
        const r = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(r);
      } else
        this.remove();
  }
  path(t, r = !1) {
    const [a, n] = this.children.find(t, r), i = [[this, t]];
    return a instanceof Vi ? i.concat(a.path(n, r)) : (a != null && i.push([a, n]), i);
  }
  removeChild(t) {
    this.children.remove(t);
  }
  replaceWith(t, r) {
    const a = typeof t == "string" ? this.scroll.create(t, r) : t;
    return a instanceof Vi && this.moveChildren(a), super.replaceWith(a);
  }
  split(t, r = !1) {
    if (!r) {
      if (t === 0)
        return this;
      if (t === this.length())
        return this.next;
    }
    const a = this.clone();
    return this.parent && this.parent.insertBefore(a, this.next || void 0), this.children.forEachAt(t, this.length(), (n, i, s) => {
      const o = n.split(i, r);
      o != null && a.appendChild(o);
    }), a;
  }
  splitAfter(t) {
    const r = this.clone();
    for (; t.next != null; )
      r.appendChild(t.next);
    return this.parent && this.parent.insertBefore(r, this.next || void 0), r;
  }
  unwrap() {
    this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
  }
  update(t, r) {
    const a = [], n = [];
    t.forEach((i) => {
      i.target === this.domNode && i.type === "childList" && (a.push(...i.addedNodes), n.push(...i.removedNodes));
    }), n.forEach((i) => {
      if (i.parentNode != null && // @ts-expect-error Fix me later
      i.tagName !== "IFRAME" && document.body.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_CONTAINED_BY)
        return;
      const s = this.scroll.find(i);
      s != null && (s.domNode.parentNode == null || s.domNode.parentNode === this.domNode) && s.detach();
    }), a.filter((i) => i.parentNode === this.domNode && i !== this.uiNode).sort((i, s) => i === s ? 0 : i.compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((i) => {
      let s = null;
      i.nextSibling != null && (s = this.scroll.find(i.nextSibling));
      const o = Ew(i, this.scroll);
      (o.next !== s || o.next == null) && (o.parent != null && o.parent.removeChild(this), this.insertBefore(o, s || void 0));
    }), this.enforceAllowedChildren();
  }
};
q3.uiClass = "";
let Ene = q3;
const Rn = Ene;
function One(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
const ao = class no extends Rn {
  static create(t) {
    return super.create(t);
  }
  static formats(t, r) {
    const a = r.query(no.blotName);
    if (!(a != null && t.tagName === a.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return t.tagName.toLowerCase();
    }
  }
  constructor(t, r) {
    super(t, r), this.attributes = new nf(this.domNode);
  }
  format(t, r) {
    if (t === this.statics.blotName && !r)
      this.children.forEach((a) => {
        a instanceof no || (a = a.wrap(no.blotName, !0)), this.attributes.copy(a);
      }), this.unwrap();
    else {
      const a = this.scroll.query(t, vt.INLINE);
      if (a == null)
        return;
      a instanceof ui ? this.attributes.attribute(a, r) : r && (t !== this.statics.blotName || this.formats()[t] !== r) && this.replaceWith(t, r);
    }
  }
  formats() {
    const t = this.attributes.values(), r = this.statics.formats(this.domNode, this.scroll);
    return r != null && (t[this.statics.blotName] = r), t;
  }
  formatAt(t, r, a, n) {
    this.formats()[a] != null || this.scroll.query(a, vt.ATTRIBUTE) ? this.isolate(t, r).format(a, n) : super.formatAt(t, r, a, n);
  }
  optimize(t) {
    super.optimize(t);
    const r = this.formats();
    if (Object.keys(r).length === 0)
      return this.unwrap();
    const a = this.next;
    a instanceof no && a.prev === this && One(r, a.formats()) && (a.moveChildren(this), a.remove());
  }
  replaceWith(t, r) {
    const a = super.replaceWith(t, r);
    return this.attributes.copy(a), a;
  }
  update(t, r) {
    super.update(t, r), t.some(
      (a) => a.target === this.domNode && a.type === "attributes"
    ) && this.attributes.build();
  }
  wrap(t, r) {
    const a = super.wrap(t, r);
    return a instanceof no && this.attributes.move(a), a;
  }
};
ao.allowedChildren = [ao, ma], ao.blotName = "inline", ao.scope = vt.INLINE_BLOT, ao.tagName = "SPAN";
let Cne = ao;
const ly = Cne, io = class h1 extends Rn {
  static create(t) {
    return super.create(t);
  }
  static formats(t, r) {
    const a = r.query(h1.blotName);
    if (!(a != null && t.tagName === a.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return t.tagName.toLowerCase();
    }
  }
  constructor(t, r) {
    super(t, r), this.attributes = new nf(this.domNode);
  }
  format(t, r) {
    const a = this.scroll.query(t, vt.BLOCK);
    a != null && (a instanceof ui ? this.attributes.attribute(a, r) : t === this.statics.blotName && !r ? this.replaceWith(h1.blotName) : r && (t !== this.statics.blotName || this.formats()[t] !== r) && this.replaceWith(t, r));
  }
  formats() {
    const t = this.attributes.values(), r = this.statics.formats(this.domNode, this.scroll);
    return r != null && (t[this.statics.blotName] = r), t;
  }
  formatAt(t, r, a, n) {
    this.scroll.query(a, vt.BLOCK) != null ? this.format(a, n) : super.formatAt(t, r, a, n);
  }
  insertAt(t, r, a) {
    if (a == null || this.scroll.query(r, vt.INLINE) != null)
      super.insertAt(t, r, a);
    else {
      const n = this.split(t);
      if (n != null) {
        const i = this.scroll.create(r, a);
        n.parent.insertBefore(i, n);
      } else
        throw new Error("Attempt to insertAt after block boundaries");
    }
  }
  replaceWith(t, r) {
    const a = super.replaceWith(t, r);
    return this.attributes.copy(a), a;
  }
  update(t, r) {
    super.update(t, r), t.some(
      (a) => a.target === this.domNode && a.type === "attributes"
    ) && this.attributes.build();
  }
};
io.blotName = "block", io.scope = vt.BLOCK_BLOT, io.tagName = "P", io.allowedChildren = [
  ly,
  io,
  ma
];
let kne = io;
const au = kne, g1 = class extends Rn {
  checkMerge() {
    return this.next !== null && this.next.statics.blotName === this.statics.blotName;
  }
  deleteAt(t, r) {
    super.deleteAt(t, r), this.enforceAllowedChildren();
  }
  formatAt(t, r, a, n) {
    super.formatAt(t, r, a, n), this.enforceAllowedChildren();
  }
  insertAt(t, r, a) {
    super.insertAt(t, r, a), this.enforceAllowedChildren();
  }
  optimize(t) {
    super.optimize(t), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
  }
};
g1.blotName = "container", g1.scope = vt.BLOCK_BLOT;
let Pne = g1;
const sf = Pne;
class Mne extends ma {
  static formats(t, r) {
  }
  format(t, r) {
    super.formatAt(0, this.length(), t, r);
  }
  formatAt(t, r, a, n) {
    t === 0 && r === this.length() ? this.format(a, n) : super.formatAt(t, r, a, n);
  }
  formats() {
    return this.statics.formats(this.domNode, this.scroll);
  }
}
const tn = Mne, Ane = {
  attributes: !0,
  characterData: !0,
  characterDataOldValue: !0,
  childList: !0,
  subtree: !0
}, Dne = 100, so = class extends Rn {
  constructor(t, r) {
    super(null, r), this.registry = t, this.scroll = this, this.build(), this.observer = new MutationObserver((a) => {
      this.update(a);
    }), this.observer.observe(this.domNode, Ane), this.attach();
  }
  create(t, r) {
    return this.registry.create(this, t, r);
  }
  find(t, r = !1) {
    const a = this.registry.find(t, r);
    return a ? a.scroll === this ? a : r ? this.find(a.scroll.domNode.parentNode, !0) : null : null;
  }
  query(t, r = vt.ANY) {
    return this.registry.query(t, r);
  }
  register(...t) {
    return this.registry.register(...t);
  }
  build() {
    this.scroll != null && super.build();
  }
  detach() {
    super.detach(), this.observer.disconnect();
  }
  deleteAt(t, r) {
    this.update(), t === 0 && r === this.length() ? this.children.forEach((a) => {
      a.remove();
    }) : super.deleteAt(t, r);
  }
  formatAt(t, r, a, n) {
    this.update(), super.formatAt(t, r, a, n);
  }
  insertAt(t, r, a) {
    this.update(), super.insertAt(t, r, a);
  }
  optimize(t = [], r = {}) {
    super.optimize(r);
    const a = r.mutationsMap || /* @__PURE__ */ new WeakMap();
    let n = Array.from(this.observer.takeRecords());
    for (; n.length > 0; )
      t.push(n.pop());
    const i = (l, u = !0) => {
      l == null || l === this || l.domNode.parentNode != null && (a.has(l.domNode) || a.set(l.domNode, []), u && i(l.parent));
    }, s = (l) => {
      a.has(l.domNode) && (l instanceof Rn && l.children.forEach(s), a.delete(l.domNode), l.optimize(r));
    };
    let o = t;
    for (let l = 0; o.length > 0; l += 1) {
      if (l >= Dne)
        throw new Error("[Parchment] Maximum optimize iterations reached");
      for (o.forEach((u) => {
        const d = this.find(u.target, !0);
        d != null && (d.domNode === u.target && (u.type === "childList" ? (i(this.find(u.previousSibling, !1)), Array.from(u.addedNodes).forEach((f) => {
          const c = this.find(f, !1);
          i(c, !1), c instanceof Rn && c.children.forEach((p) => {
            i(p, !1);
          });
        })) : u.type === "attributes" && i(d.prev)), i(d));
      }), this.children.forEach(s), o = Array.from(this.observer.takeRecords()), n = o.slice(); n.length > 0; )
        t.push(n.pop());
    }
  }
  update(t, r = {}) {
    t = t || this.observer.takeRecords();
    const a = /* @__PURE__ */ new WeakMap();
    t.map((n) => {
      const i = this.find(n.target, !0);
      return i == null ? null : a.has(i.domNode) ? (a.get(i.domNode).push(n), null) : (a.set(i.domNode, [n]), i);
    }).forEach((n) => {
      n != null && n !== this && a.has(n.domNode) && n.update(a.get(n.domNode) || [], r);
    }), r.mutationsMap = a, a.has(this.domNode) && super.update(a.get(this.domNode), r), this.optimize(t, r);
  }
};
so.blotName = "scroll", so.defaultChild = au, so.allowedChildren = [au, sf], so.scope = vt.BLOCK_BLOT, so.tagName = "DIV";
let Ine = so;
const uy = Ine, b1 = class H3 extends ma {
  static create(t) {
    return document.createTextNode(t);
  }
  static value(t) {
    return t.data;
  }
  constructor(t, r) {
    super(t, r), this.text = this.statics.value(this.domNode);
  }
  deleteAt(t, r) {
    this.domNode.data = this.text = this.text.slice(0, t) + this.text.slice(t + r);
  }
  index(t, r) {
    return this.domNode === t ? r : -1;
  }
  insertAt(t, r, a) {
    a == null ? (this.text = this.text.slice(0, t) + r + this.text.slice(t), this.domNode.data = this.text) : super.insertAt(t, r, a);
  }
  length() {
    return this.text.length;
  }
  optimize(t) {
    super.optimize(t), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof H3 && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
  }
  position(t, r = !1) {
    return [this.domNode, t];
  }
  split(t, r = !1) {
    if (!r) {
      if (t === 0)
        return this;
      if (t === this.length())
        return this.next;
    }
    const a = this.scroll.create(this.domNode.splitText(t));
    return this.parent.insertBefore(a, this.next || void 0), this.text = this.statics.value(this.domNode), a;
  }
  update(t, r) {
    t.some((a) => a.type === "characterData" && a.target === this.domNode) && (this.text = this.statics.value(this.domNode));
  }
  value() {
    return this.text;
  }
};
b1.blotName = "text", b1.scope = vt.INLINE_BLOT;
let Nne = b1;
const Dd = Nne, $ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Attributor: ui,
  AttributorStore: nf,
  BlockBlot: au,
  ClassAttributor: zn,
  ContainerBlot: sf,
  EmbedBlot: tn,
  InlineBlot: ly,
  LeafBlot: ma,
  ParentBlot: Rn,
  Registry: wo,
  Scope: vt,
  ScrollBlot: uy,
  StyleAttributor: hs,
  TextBlot: Dd
}, Symbol.toStringTag, { value: "Module" }));
var y1 = { exports: {} }, Ja = -1, Na = 1, Zr = 0;
function nu(e, t, r, a, n) {
  if (e === t)
    return e ? [[Zr, e]] : [];
  if (r != null) {
    var i = Une(e, t, r);
    if (i)
      return i;
  }
  var s = dy(e, t), o = e.substring(0, s);
  e = e.substring(s), t = t.substring(s), s = of(e, t);
  var l = e.substring(e.length - s);
  e = e.substring(0, e.length - s), t = t.substring(0, t.length - s);
  var u = Lne(e, t);
  return o && u.unshift([Zr, o]), l && u.push([Zr, l]), cy(u, n), a && Fne(u), u;
}
function Lne(e, t) {
  var r;
  if (!e)
    return [[Na, t]];
  if (!t)
    return [[Ja, e]];
  var a = e.length > t.length ? e : t, n = e.length > t.length ? t : e, i = a.indexOf(n);
  if (i !== -1)
    return r = [
      [Na, a.substring(0, i)],
      [Zr, n],
      [Na, a.substring(i + n.length)]
    ], e.length > t.length && (r[0][0] = r[2][0] = Ja), r;
  if (n.length === 1)
    return [
      [Ja, e],
      [Na, t]
    ];
  var s = jne(e, t);
  if (s) {
    var o = s[0], l = s[1], u = s[2], d = s[3], f = s[4], c = nu(o, u), p = nu(l, d);
    return c.concat([[Zr, f]], p);
  }
  return Rne(e, t);
}
function Rne(e, t) {
  for (var r = e.length, a = t.length, n = Math.ceil((r + a) / 2), i = n, s = 2 * n, o = new Array(s), l = new Array(s), u = 0; u < s; u++)
    o[u] = -1, l[u] = -1;
  o[i + 1] = 0, l[i + 1] = 0;
  for (var d = r - a, f = d % 2 !== 0, c = 0, p = 0, v = 0, h = 0, g = 0; g < n; g++) {
    for (var m = -g + c; m <= g - p; m += 2) {
      var b = i + m, y;
      m === -g || m !== g && o[b - 1] < o[b + 1] ? y = o[b + 1] : y = o[b - 1] + 1;
      for (var _ = y - m; y < r && _ < a && e.charAt(y) === t.charAt(_); )
        y++, _++;
      if (o[b] = y, y > r)
        p += 2;
      else if (_ > a)
        c += 2;
      else if (f) {
        var x = i + d - m;
        if (x >= 0 && x < s && l[x] !== -1) {
          var w = r - l[x];
          if (y >= w)
            return Ow(e, t, y, _);
        }
      }
    }
    for (var k = -g + v; k <= g - h; k += 2) {
      var x = i + k, w;
      k === -g || k !== g && l[x - 1] < l[x + 1] ? w = l[x + 1] : w = l[x - 1] + 1;
      for (var S = w - k; w < r && S < a && e.charAt(r - w - 1) === t.charAt(a - S - 1); )
        w++, S++;
      if (l[x] = w, w > r)
        h += 2;
      else if (S > a)
        v += 2;
      else if (!f) {
        var b = i + d - k;
        if (b >= 0 && b < s && o[b] !== -1) {
          var y = o[b], _ = i + y - b;
          if (w = r - w, y >= w)
            return Ow(e, t, y, _);
        }
      }
    }
  }
  return [
    [Ja, e],
    [Na, t]
  ];
}
function Ow(e, t, r, a) {
  var n = e.substring(0, r), i = t.substring(0, a), s = e.substring(r), o = t.substring(a), l = nu(n, i), u = nu(s, o);
  return l.concat(u);
}
function dy(e, t) {
  if (!e || !t || e.charAt(0) !== t.charAt(0))
    return 0;
  for (var r = 0, a = Math.min(e.length, t.length), n = a, i = 0; r < n; )
    e.substring(i, n) == t.substring(i, n) ? (r = n, i = r) : a = n, n = Math.floor((a - r) / 2 + r);
  return V3(e.charCodeAt(n - 1)) && n--, n;
}
function Cw(e, t) {
  var r = e.length, a = t.length;
  if (r == 0 || a == 0)
    return 0;
  r > a ? e = e.substring(r - a) : r < a && (t = t.substring(0, r));
  var n = Math.min(r, a);
  if (e == t)
    return n;
  for (var i = 0, s = 1; ; ) {
    var o = e.substring(n - s), l = t.indexOf(o);
    if (l == -1)
      return i;
    s += l, (l == 0 || e.substring(n - s) == t.substring(0, s)) && (i = s, s++);
  }
}
function of(e, t) {
  if (!e || !t || e.slice(-1) !== t.slice(-1))
    return 0;
  for (var r = 0, a = Math.min(e.length, t.length), n = a, i = 0; r < n; )
    e.substring(e.length - n, e.length - i) == t.substring(t.length - n, t.length - i) ? (r = n, i = r) : a = n, n = Math.floor((a - r) / 2 + r);
  return U3(e.charCodeAt(e.length - n)) && n--, n;
}
function jne(e, t) {
  var r = e.length > t.length ? e : t, a = e.length > t.length ? t : e;
  if (r.length < 4 || a.length * 2 < r.length)
    return null;
  function n(p, v, h) {
    for (var g = p.substring(h, h + Math.floor(p.length / 4)), m = -1, b = "", y, _, x, w; (m = v.indexOf(g, m + 1)) !== -1; ) {
      var k = dy(
        p.substring(h),
        v.substring(m)
      ), S = of(
        p.substring(0, h),
        v.substring(0, m)
      );
      b.length < S + k && (b = v.substring(m - S, m) + v.substring(m, m + k), y = p.substring(0, h - S), _ = p.substring(h + k), x = v.substring(0, m - S), w = v.substring(m + k));
    }
    return b.length * 2 >= p.length ? [
      y,
      _,
      x,
      w,
      b
    ] : null;
  }
  var i = n(
    r,
    a,
    Math.ceil(r.length / 4)
  ), s = n(
    r,
    a,
    Math.ceil(r.length / 2)
  ), o;
  if (!i && !s)
    return null;
  s ? i ? o = i[4].length > s[4].length ? i : s : o = s : o = i;
  var l, u, d, f;
  e.length > t.length ? (l = o[0], u = o[1], d = o[2], f = o[3]) : (d = o[0], f = o[1], l = o[2], u = o[3]);
  var c = o[4];
  return [l, u, d, f, c];
}
function Fne(e) {
  for (var t = !1, r = [], a = 0, n = null, i = 0, s = 0, o = 0, l = 0, u = 0; i < e.length; )
    e[i][0] == Zr ? (r[a++] = i, s = l, o = u, l = 0, u = 0, n = e[i][1]) : (e[i][0] == Na ? l += e[i][1].length : u += e[i][1].length, n && n.length <= Math.max(s, o) && n.length <= Math.max(l, u) && (e.splice(r[a - 1], 0, [
      Ja,
      n
    ]), e[r[a - 1] + 1][0] = Na, a--, a--, i = a > 0 ? r[a - 1] : -1, s = 0, o = 0, l = 0, u = 0, n = null, t = !0)), i++;
  for (t && cy(e), Hne(e), i = 1; i < e.length; ) {
    if (e[i - 1][0] == Ja && e[i][0] == Na) {
      var d = e[i - 1][1], f = e[i][1], c = Cw(d, f), p = Cw(f, d);
      c >= p ? (c >= d.length / 2 || c >= f.length / 2) && (e.splice(i, 0, [
        Zr,
        f.substring(0, c)
      ]), e[i - 1][1] = d.substring(
        0,
        d.length - c
      ), e[i + 1][1] = f.substring(c), i++) : (p >= d.length / 2 || p >= f.length / 2) && (e.splice(i, 0, [
        Zr,
        d.substring(0, p)
      ]), e[i - 1][0] = Na, e[i - 1][1] = f.substring(
        0,
        f.length - p
      ), e[i + 1][0] = Ja, e[i + 1][1] = d.substring(p), i++), i++;
    }
    i++;
  }
}
var kw = /[^a-zA-Z0-9]/, Pw = /\s/, Mw = /[\r\n]/, Bne = /\n\r?\n$/, qne = /^\r?\n\r?\n/;
function Hne(e) {
  function t(p, v) {
    if (!p || !v)
      return 6;
    var h = p.charAt(p.length - 1), g = v.charAt(0), m = h.match(kw), b = g.match(kw), y = m && h.match(Pw), _ = b && g.match(Pw), x = y && h.match(Mw), w = _ && g.match(Mw), k = x && p.match(Bne), S = w && v.match(qne);
    return k || S ? 5 : x || w ? 4 : m && !y && _ ? 3 : y || _ ? 2 : m || b ? 1 : 0;
  }
  for (var r = 1; r < e.length - 1; ) {
    if (e[r - 1][0] == Zr && e[r + 1][0] == Zr) {
      var a = e[r - 1][1], n = e[r][1], i = e[r + 1][1], s = of(a, n);
      if (s) {
        var o = n.substring(n.length - s);
        a = a.substring(0, a.length - s), n = o + n.substring(0, n.length - s), i = o + i;
      }
      for (var l = a, u = n, d = i, f = t(a, n) + t(n, i); n.charAt(0) === i.charAt(0); ) {
        a += n.charAt(0), n = n.substring(1) + i.charAt(0), i = i.substring(1);
        var c = t(a, n) + t(n, i);
        c >= f && (f = c, l = a, u = n, d = i);
      }
      e[r - 1][1] != l && (l ? e[r - 1][1] = l : (e.splice(r - 1, 1), r--), e[r][1] = u, d ? e[r + 1][1] = d : (e.splice(r + 1, 1), r--));
    }
    r++;
  }
}
function cy(e, t) {
  e.push([Zr, ""]);
  for (var r = 0, a = 0, n = 0, i = "", s = "", o; r < e.length; ) {
    if (r < e.length - 1 && !e[r][1]) {
      e.splice(r, 1);
      continue;
    }
    switch (e[r][0]) {
      case Na:
        n++, s += e[r][1], r++;
        break;
      case Ja:
        a++, i += e[r][1], r++;
        break;
      case Zr:
        var l = r - n - a - 1;
        if (t) {
          if (l >= 0 && Y3(e[l][1])) {
            var u = e[l][1].slice(-1);
            if (e[l][1] = e[l][1].slice(
              0,
              -1
            ), i = u + i, s = u + s, !e[l][1]) {
              e.splice(l, 1), r--;
              var d = l - 1;
              e[d] && e[d][0] === Na && (n++, s = e[d][1] + s, d--), e[d] && e[d][0] === Ja && (a++, i = e[d][1] + i, d--), l = d;
            }
          }
          if (z3(e[r][1])) {
            var u = e[r][1].charAt(0);
            e[r][1] = e[r][1].slice(1), i += u, s += u;
          }
        }
        if (r < e.length - 1 && !e[r][1]) {
          e.splice(r, 1);
          break;
        }
        if (i.length > 0 || s.length > 0) {
          i.length > 0 && s.length > 0 && (o = dy(s, i), o !== 0 && (l >= 0 ? e[l][1] += s.substring(
            0,
            o
          ) : (e.splice(0, 0, [
            Zr,
            s.substring(0, o)
          ]), r++), s = s.substring(o), i = i.substring(o)), o = of(s, i), o !== 0 && (e[r][1] = s.substring(s.length - o) + e[r][1], s = s.substring(
            0,
            s.length - o
          ), i = i.substring(
            0,
            i.length - o
          )));
          var f = n + a;
          i.length === 0 && s.length === 0 ? (e.splice(r - f, f), r = r - f) : i.length === 0 ? (e.splice(r - f, f, [Na, s]), r = r - f + 1) : s.length === 0 ? (e.splice(r - f, f, [Ja, i]), r = r - f + 1) : (e.splice(
            r - f,
            f,
            [Ja, i],
            [Na, s]
          ), r = r - f + 2);
        }
        r !== 0 && e[r - 1][0] === Zr ? (e[r - 1][1] += e[r][1], e.splice(r, 1)) : r++, n = 0, a = 0, i = "", s = "";
        break;
    }
  }
  e[e.length - 1][1] === "" && e.pop();
  var c = !1;
  for (r = 1; r < e.length - 1; )
    e[r - 1][0] === Zr && e[r + 1][0] === Zr && (e[r][1].substring(
      e[r][1].length - e[r - 1][1].length
    ) === e[r - 1][1] ? (e[r][1] = e[r - 1][1] + e[r][1].substring(
      0,
      e[r][1].length - e[r - 1][1].length
    ), e[r + 1][1] = e[r - 1][1] + e[r + 1][1], e.splice(r - 1, 1), c = !0) : e[r][1].substring(0, e[r + 1][1].length) == e[r + 1][1] && (e[r - 1][1] += e[r + 1][1], e[r][1] = e[r][1].substring(e[r + 1][1].length) + e[r + 1][1], e.splice(r + 1, 1), c = !0)), r++;
  c && cy(e, t);
}
function V3(e) {
  return e >= 55296 && e <= 56319;
}
function U3(e) {
  return e >= 56320 && e <= 57343;
}
function z3(e) {
  return U3(e.charCodeAt(0));
}
function Y3(e) {
  return V3(e.charCodeAt(e.length - 1));
}
function Vne(e) {
  for (var t = [], r = 0; r < e.length; r++)
    e[r][1].length > 0 && t.push(e[r]);
  return t;
}
function op(e, t, r, a) {
  return Y3(e) || z3(a) ? null : Vne([
    [Zr, e],
    [Ja, t],
    [Na, r],
    [Zr, a]
  ]);
}
function Une(e, t, r) {
  var a = typeof r == "number" ? { index: r, length: 0 } : r.oldRange, n = typeof r == "number" ? null : r.newRange, i = e.length, s = t.length;
  if (a.length === 0 && (n === null || n.length === 0)) {
    var o = a.index, l = e.slice(0, o), u = e.slice(o), d = n ? n.index : null;
    e: {
      var f = o + s - i;
      if (d !== null && d !== f || f < 0 || f > s)
        break e;
      var c = t.slice(0, f), p = t.slice(f);
      if (p !== u)
        break e;
      var v = Math.min(o, f), h = l.slice(0, v), g = c.slice(0, v);
      if (h !== g)
        break e;
      var m = l.slice(v), b = c.slice(v);
      return op(h, m, b, u);
    }
    e: {
      if (d !== null && d !== o)
        break e;
      var y = o, c = t.slice(0, y), p = t.slice(y);
      if (c !== l)
        break e;
      var _ = Math.min(i - y, s - y), x = u.slice(u.length - _), w = p.slice(p.length - _);
      if (x !== w)
        break e;
      var m = u.slice(0, u.length - _), b = p.slice(0, p.length - _);
      return op(l, m, b, x);
    }
  }
  if (a.length > 0 && n && n.length === 0)
    e: {
      var h = e.slice(0, a.index), x = e.slice(a.index + a.length), v = h.length, _ = x.length;
      if (s < v + _)
        break e;
      var g = t.slice(0, v), w = t.slice(s - _);
      if (h !== g || x !== w)
        break e;
      var m = e.slice(v, i - _), b = t.slice(v, s - _);
      return op(h, m, b, x);
    }
  return null;
}
function lf(e, t, r, a) {
  return nu(e, t, r, a, !0);
}
lf.INSERT = Na;
lf.DELETE = Ja;
lf.EQUAL = Zr;
var zne = lf, Id = { exports: {} };
Id.exports;
(function(e, t) {
  var r = 200, a = "__lodash_hash_undefined__", n = 9007199254740991, i = "[object Arguments]", s = "[object Array]", o = "[object Boolean]", l = "[object Date]", u = "[object Error]", d = "[object Function]", f = "[object GeneratorFunction]", c = "[object Map]", p = "[object Number]", v = "[object Object]", h = "[object Promise]", g = "[object RegExp]", m = "[object Set]", b = "[object String]", y = "[object Symbol]", _ = "[object WeakMap]", x = "[object ArrayBuffer]", w = "[object DataView]", k = "[object Float32Array]", S = "[object Float64Array]", P = "[object Int8Array]", A = "[object Int16Array]", E = "[object Int32Array]", O = "[object Uint8Array]", T = "[object Uint8ClampedArray]", D = "[object Uint16Array]", $ = "[object Uint32Array]", I = /[\\^$.*+?()[\]{}|]/g, F = /\w*$/, j = /^\[object .+?Constructor\]$/, M = /^(?:0|[1-9]\d*)$/, q = {};
  q[i] = q[s] = q[x] = q[w] = q[o] = q[l] = q[k] = q[S] = q[P] = q[A] = q[E] = q[c] = q[p] = q[v] = q[g] = q[m] = q[b] = q[y] = q[O] = q[T] = q[D] = q[$] = !0, q[u] = q[d] = q[_] = !1;
  var le = typeof Ba == "object" && Ba && Ba.Object === Object && Ba, Z = typeof self == "object" && self && self.Object === Object && self, G = le || Z || Function("return this")(), H = t && !t.nodeType && t, W = H && !0 && e && !e.nodeType && e, ie = W && W.exports === H;
  function we(C, V) {
    return C.set(V[0], V[1]), C;
  }
  function Be(C, V) {
    return C.add(V), C;
  }
  function Ve(C, V) {
    for (var oe = -1, Ee = C ? C.length : 0; ++oe < Ee && V(C[oe], oe, C) !== !1; )
      ;
    return C;
  }
  function et(C, V) {
    for (var oe = -1, Ee = V.length, wt = C.length; ++oe < Ee; )
      C[wt + oe] = V[oe];
    return C;
  }
  function nt(C, V, oe, Ee) {
    var wt = -1, ht = C ? C.length : 0;
    for (Ee && ht && (oe = C[++wt]); ++wt < ht; )
      oe = V(oe, C[wt], wt, C);
    return oe;
  }
  function xe(C, V) {
    for (var oe = -1, Ee = Array(C); ++oe < C; )
      Ee[oe] = V(oe);
    return Ee;
  }
  function J(C, V) {
    return C == null ? void 0 : C[V];
  }
  function se(C) {
    var V = !1;
    if (C != null && typeof C.toString != "function")
      try {
        V = !!(C + "");
      } catch {
      }
    return V;
  }
  function _e(C) {
    var V = -1, oe = Array(C.size);
    return C.forEach(function(Ee, wt) {
      oe[++V] = [wt, Ee];
    }), oe;
  }
  function Se(C, V) {
    return function(oe) {
      return C(V(oe));
    };
  }
  function Re(C) {
    var V = -1, oe = Array(C.size);
    return C.forEach(function(Ee) {
      oe[++V] = Ee;
    }), oe;
  }
  var rt = Array.prototype, Dt = Function.prototype, It = Object.prototype, Ye = G["__core-js_shared__"], at = function() {
    var C = /[^.]+$/.exec(Ye && Ye.keys && Ye.keys.IE_PROTO || "");
    return C ? "Symbol(src)_1." + C : "";
  }(), ut = Dt.toString, Gt = It.hasOwnProperty, Je = It.toString, he = RegExp(
    "^" + ut.call(Gt).replace(I, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ye = ie ? G.Buffer : void 0, Ke = G.Symbol, Q = G.Uint8Array, L = Se(Object.getPrototypeOf, Object), Te = Object.create, Oe = It.propertyIsEnumerable, Y = rt.splice, de = Object.getOwnPropertySymbols, Ne = ye ? ye.isBuffer : void 0, We = Se(Object.keys, Object), mt = z(G, "DataView"), Nt = z(G, "Map"), St = z(G, "Promise"), me = z(G, "Set"), Ue = z(G, "WeakMap"), bt = z(Object, "create"), _t = ze(mt), pr = ze(Nt), Ze = ze(St), vr = ze(me), yt = ze(Ue), Xr = Ke ? Ke.prototype : void 0, La = Xr ? Xr.valueOf : void 0;
  function Ar(C) {
    var V = -1, oe = C ? C.length : 0;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function rn() {
    this.__data__ = bt ? bt(null) : {};
  }
  function Gn(C) {
    return this.has(C) && delete this.__data__[C];
  }
  function pi(C) {
    var V = this.__data__;
    if (bt) {
      var oe = V[C];
      return oe === a ? void 0 : oe;
    }
    return Gt.call(V, C) ? V[C] : void 0;
  }
  function Cn(C) {
    var V = this.__data__;
    return bt ? V[C] !== void 0 : Gt.call(V, C);
  }
  function Va(C, V) {
    var oe = this.__data__;
    return oe[C] = bt && V === void 0 ? a : V, this;
  }
  Ar.prototype.clear = rn, Ar.prototype.delete = Gn, Ar.prototype.get = pi, Ar.prototype.has = Cn, Ar.prototype.set = Va;
  function Er(C) {
    var V = -1, oe = C ? C.length : 0;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function an() {
    this.__data__ = [];
  }
  function kn(C) {
    var V = this.__data__, oe = da(V, C);
    if (oe < 0)
      return !1;
    var Ee = V.length - 1;
    return oe == Ee ? V.pop() : Y.call(V, oe, 1), !0;
  }
  function Pn(C) {
    var V = this.__data__, oe = da(V, C);
    return oe < 0 ? void 0 : V[oe][1];
  }
  function Xn(C) {
    return da(this.__data__, C) > -1;
  }
  function Kn(C, V) {
    var oe = this.__data__, Ee = da(oe, C);
    return Ee < 0 ? oe.push([C, V]) : oe[Ee][1] = V, this;
  }
  Er.prototype.clear = an, Er.prototype.delete = kn, Er.prototype.get = Pn, Er.prototype.has = Xn, Er.prototype.set = Kn;
  function Or(C) {
    var V = -1, oe = C ? C.length : 0;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function Mn() {
    this.__data__ = {
      hash: new Ar(),
      map: new (Nt || Er)(),
      string: new Ar()
    };
  }
  function xa(C) {
    return B(this, C).delete(C);
  }
  function wa(C) {
    return B(this, C).get(C);
  }
  function Ta(C) {
    return B(this, C).has(C);
  }
  function Ua(C, V) {
    return B(this, C).set(C, V), this;
  }
  Or.prototype.clear = Mn, Or.prototype.delete = xa, Or.prototype.get = wa, Or.prototype.has = Ta, Or.prototype.set = Ua;
  function lr(C) {
    this.__data__ = new Er(C);
  }
  function vi() {
    this.__data__ = new Er();
  }
  function Jn(C) {
    return this.__data__.delete(C);
  }
  function nn(C) {
    return this.__data__.get(C);
  }
  function Vr(C) {
    return this.__data__.has(C);
  }
  function Ra(C, V) {
    var oe = this.__data__;
    if (oe instanceof Er) {
      var Ee = oe.__data__;
      if (!Nt || Ee.length < r - 1)
        return Ee.push([C, V]), this;
      oe = this.__data__ = new Or(Ee);
    }
    return oe.set(C, V), this;
  }
  lr.prototype.clear = vi, lr.prototype.delete = Jn, lr.prototype.get = nn, lr.prototype.has = Vr, lr.prototype.set = Ra;
  function qr(C, V) {
    var oe = ar(C) || tt(C) ? xe(C.length, String) : [], Ee = oe.length, wt = !!Ee;
    for (var ht in C)
      (V || Gt.call(C, ht)) && !(wt && (ht == "length" || te(ht, Ee))) && oe.push(ht);
    return oe;
  }
  function Ur(C, V, oe) {
    var Ee = C[V];
    (!(Gt.call(C, V) && xt(Ee, oe)) || oe === void 0 && !(V in C)) && (C[V] = oe);
  }
  function da(C, V) {
    for (var oe = C.length; oe--; )
      if (xt(C[oe][0], V))
        return oe;
    return -1;
  }
  function hr(C, V) {
    return C && Oa(V, Zn(V), C);
  }
  function Kr(C, V, oe, Ee, wt, ht, Rt) {
    var Ft;
    if (Ee && (Ft = ht ? Ee(C, wt, ht, Rt) : Ee(C)), Ft !== void 0)
      return Ft;
    if (!ur(C))
      return C;
    var Rr = ar(C);
    if (Rr) {
      if (Ft = $e(C), !V)
        return ln(C, Ft);
    } else {
      var Jt = be(C), ta = Jt == d || Jt == f;
      if (tr(C))
        return ia(C, V);
      if (Jt == v || Jt == i || ta && !ht) {
        if (se(C))
          return ht ? C : {};
        if (Ft = Ge(ta ? {} : C), !V)
          return mi(C, hr(Ft, C));
      } else {
        if (!q[Jt])
          return ht ? C : {};
        Ft = Et(C, Jt, Kr, V);
      }
    }
    Rt || (Rt = new lr());
    var fa = Rt.get(C);
    if (fa)
      return fa;
    if (Rt.set(C, Ft), !Rr)
      var Hr = oe ? hi(C) : Zn(C);
    return Ve(Hr || C, function(ra, Qr) {
      Hr && (Qr = ra, ra = C[Qr]), Ur(Ft, Qr, Kr(ra, V, oe, Ee, Qr, C, Rt));
    }), Ft;
  }
  function Qn(C) {
    return ur(C) ? Te(C) : {};
  }
  function sn(C, V, oe) {
    var Ee = V(C);
    return ar(C) ? Ee : et(Ee, oe(C));
  }
  function on(C) {
    return Je.call(C);
  }
  function Dr(C) {
    if (!ur(C) || ge(C))
      return !1;
    var V = Lt(C) || se(C) ? he : j;
    return V.test(ze(C));
  }
  function Xt(C) {
    if (!Me(C))
      return We(C);
    var V = [];
    for (var oe in Object(C))
      Gt.call(C, oe) && oe != "constructor" && V.push(oe);
    return V;
  }
  function ia(C, V) {
    if (V)
      return C.slice();
    var oe = new C.constructor(C.length);
    return C.copy(oe), oe;
  }
  function Sa(C) {
    var V = new C.constructor(C.byteLength);
    return new Q(V).set(new Q(C)), V;
  }
  function ca(C, V) {
    var oe = V ? Sa(C.buffer) : C.buffer;
    return new C.constructor(oe, C.byteOffset, C.byteLength);
  }
  function za(C, V, oe) {
    var Ee = V ? oe(_e(C), !0) : _e(C);
    return nt(Ee, we, new C.constructor());
  }
  function Ya(C) {
    var V = new C.constructor(C.source, F.exec(C));
    return V.lastIndex = C.lastIndex, V;
  }
  function Jr(C, V, oe) {
    var Ee = V ? oe(Re(C), !0) : Re(C);
    return nt(Ee, Be, new C.constructor());
  }
  function Ea(C) {
    return La ? Object(La.call(C)) : {};
  }
  function An(C, V) {
    var oe = V ? Sa(C.buffer) : C.buffer;
    return new C.constructor(oe, C.byteOffset, C.length);
  }
  function ln(C, V) {
    var oe = -1, Ee = C.length;
    for (V || (V = Array(Ee)); ++oe < Ee; )
      V[oe] = C[oe];
    return V;
  }
  function Oa(C, V, oe, Ee) {
    oe || (oe = {});
    for (var wt = -1, ht = V.length; ++wt < ht; ) {
      var Rt = V[wt], Ft = Ee ? Ee(oe[Rt], C[Rt], Rt, oe, C) : void 0;
      Ur(oe, Rt, Ft === void 0 ? C[Rt] : Ft);
    }
    return oe;
  }
  function mi(C, V) {
    return Oa(C, ae(C), V);
  }
  function hi(C) {
    return sn(C, Zn, ae);
  }
  function B(C, V) {
    var oe = C.__data__;
    return ce(V) ? oe[typeof V == "string" ? "string" : "hash"] : oe.map;
  }
  function z(C, V) {
    var oe = J(C, V);
    return Dr(oe) ? oe : void 0;
  }
  var ae = de ? Se(de, Object) : gi, be = on;
  (mt && be(new mt(new ArrayBuffer(1))) != w || Nt && be(new Nt()) != c || St && be(St.resolve()) != h || me && be(new me()) != m || Ue && be(new Ue()) != _) && (be = function(C) {
    var V = Je.call(C), oe = V == v ? C.constructor : void 0, Ee = oe ? ze(oe) : void 0;
    if (Ee)
      switch (Ee) {
        case _t:
          return w;
        case pr:
          return c;
        case Ze:
          return h;
        case vr:
          return m;
        case yt:
          return _;
      }
    return V;
  });
  function $e(C) {
    var V = C.length, oe = C.constructor(V);
    return V && typeof C[0] == "string" && Gt.call(C, "index") && (oe.index = C.index, oe.input = C.input), oe;
  }
  function Ge(C) {
    return typeof C.constructor == "function" && !Me(C) ? Qn(L(C)) : {};
  }
  function Et(C, V, oe, Ee) {
    var wt = C.constructor;
    switch (V) {
      case x:
        return Sa(C);
      case o:
      case l:
        return new wt(+C);
      case w:
        return ca(C, Ee);
      case k:
      case S:
      case P:
      case A:
      case E:
      case O:
      case T:
      case D:
      case $:
        return An(C, Ee);
      case c:
        return za(C, Ee, oe);
      case p:
      case b:
        return new wt(C);
      case g:
        return Ya(C);
      case m:
        return Jr(C, Ee, oe);
      case y:
        return Ea(C);
    }
  }
  function te(C, V) {
    return V = V ?? n, !!V && (typeof C == "number" || M.test(C)) && C > -1 && C % 1 == 0 && C < V;
  }
  function ce(C) {
    var V = typeof C;
    return V == "string" || V == "number" || V == "symbol" || V == "boolean" ? C !== "__proto__" : C === null;
  }
  function ge(C) {
    return !!at && at in C;
  }
  function Me(C) {
    var V = C && C.constructor, oe = typeof V == "function" && V.prototype || It;
    return C === oe;
  }
  function ze(C) {
    if (C != null) {
      try {
        return ut.call(C);
      } catch {
      }
      try {
        return C + "";
      } catch {
      }
    }
    return "";
  }
  function Xe(C) {
    return Kr(C, !0, !0);
  }
  function xt(C, V) {
    return C === V || C !== C && V !== V;
  }
  function tt(C) {
    return Kt(C) && Gt.call(C, "callee") && (!Oe.call(C, "callee") || Je.call(C) == i);
  }
  var ar = Array.isArray;
  function er(C) {
    return C != null && gr(C.length) && !Lt(C);
  }
  function Kt(C) {
    return dr(C) && er(C);
  }
  var tr = Ne || Bi;
  function Lt(C) {
    var V = ur(C) ? Je.call(C) : "";
    return V == d || V == f;
  }
  function gr(C) {
    return typeof C == "number" && C > -1 && C % 1 == 0 && C <= n;
  }
  function ur(C) {
    var V = typeof C;
    return !!C && (V == "object" || V == "function");
  }
  function dr(C) {
    return !!C && typeof C == "object";
  }
  function Zn(C) {
    return er(C) ? qr(C) : Xt(C);
  }
  function gi() {
    return [];
  }
  function Bi() {
    return !1;
  }
  e.exports = Xe;
})(Id, Id.exports);
var W3 = Id.exports, Nd = { exports: {} };
Nd.exports;
(function(e, t) {
  var r = 200, a = "__lodash_hash_undefined__", n = 1, i = 2, s = 9007199254740991, o = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", d = "[object Boolean]", f = "[object Date]", c = "[object Error]", p = "[object Function]", v = "[object GeneratorFunction]", h = "[object Map]", g = "[object Number]", m = "[object Null]", b = "[object Object]", y = "[object Promise]", _ = "[object Proxy]", x = "[object RegExp]", w = "[object Set]", k = "[object String]", S = "[object Symbol]", P = "[object Undefined]", A = "[object WeakMap]", E = "[object ArrayBuffer]", O = "[object DataView]", T = "[object Float32Array]", D = "[object Float64Array]", $ = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", j = "[object Uint8Array]", M = "[object Uint8ClampedArray]", q = "[object Uint16Array]", le = "[object Uint32Array]", Z = /[\\^$.*+?()[\]{}|]/g, G = /^\[object .+?Constructor\]$/, H = /^(?:0|[1-9]\d*)$/, W = {};
  W[T] = W[D] = W[$] = W[I] = W[F] = W[j] = W[M] = W[q] = W[le] = !0, W[o] = W[l] = W[E] = W[d] = W[O] = W[f] = W[c] = W[p] = W[h] = W[g] = W[b] = W[x] = W[w] = W[k] = W[A] = !1;
  var ie = typeof Ba == "object" && Ba && Ba.Object === Object && Ba, we = typeof self == "object" && self && self.Object === Object && self, Be = ie || we || Function("return this")(), Ve = t && !t.nodeType && t, et = Ve && !0 && e && !e.nodeType && e, nt = et && et.exports === Ve, xe = nt && ie.process, J = function() {
    try {
      return xe && xe.binding && xe.binding("util");
    } catch {
    }
  }(), se = J && J.isTypedArray;
  function _e(C, V) {
    for (var oe = -1, Ee = C == null ? 0 : C.length, wt = 0, ht = []; ++oe < Ee; ) {
      var Rt = C[oe];
      V(Rt, oe, C) && (ht[wt++] = Rt);
    }
    return ht;
  }
  function Se(C, V) {
    for (var oe = -1, Ee = V.length, wt = C.length; ++oe < Ee; )
      C[wt + oe] = V[oe];
    return C;
  }
  function Re(C, V) {
    for (var oe = -1, Ee = C == null ? 0 : C.length; ++oe < Ee; )
      if (V(C[oe], oe, C))
        return !0;
    return !1;
  }
  function rt(C, V) {
    for (var oe = -1, Ee = Array(C); ++oe < C; )
      Ee[oe] = V(oe);
    return Ee;
  }
  function Dt(C) {
    return function(V) {
      return C(V);
    };
  }
  function It(C, V) {
    return C.has(V);
  }
  function Ye(C, V) {
    return C == null ? void 0 : C[V];
  }
  function at(C) {
    var V = -1, oe = Array(C.size);
    return C.forEach(function(Ee, wt) {
      oe[++V] = [wt, Ee];
    }), oe;
  }
  function ut(C, V) {
    return function(oe) {
      return C(V(oe));
    };
  }
  function Gt(C) {
    var V = -1, oe = Array(C.size);
    return C.forEach(function(Ee) {
      oe[++V] = Ee;
    }), oe;
  }
  var Je = Array.prototype, he = Function.prototype, ye = Object.prototype, Ke = Be["__core-js_shared__"], Q = he.toString, L = ye.hasOwnProperty, Te = function() {
    var C = /[^.]+$/.exec(Ke && Ke.keys && Ke.keys.IE_PROTO || "");
    return C ? "Symbol(src)_1." + C : "";
  }(), Oe = ye.toString, Y = RegExp(
    "^" + Q.call(L).replace(Z, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), de = nt ? Be.Buffer : void 0, Ne = Be.Symbol, We = Be.Uint8Array, mt = ye.propertyIsEnumerable, Nt = Je.splice, St = Ne ? Ne.toStringTag : void 0, me = Object.getOwnPropertySymbols, Ue = de ? de.isBuffer : void 0, bt = ut(Object.keys, Object), _t = ae(Be, "DataView"), pr = ae(Be, "Map"), Ze = ae(Be, "Promise"), vr = ae(Be, "Set"), yt = ae(Be, "WeakMap"), Xr = ae(Object, "create"), La = ze(_t), Ar = ze(pr), rn = ze(Ze), Gn = ze(vr), pi = ze(yt), Cn = Ne ? Ne.prototype : void 0, Va = Cn ? Cn.valueOf : void 0;
  function Er(C) {
    var V = -1, oe = C == null ? 0 : C.length;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function an() {
    this.__data__ = Xr ? Xr(null) : {}, this.size = 0;
  }
  function kn(C) {
    var V = this.has(C) && delete this.__data__[C];
    return this.size -= V ? 1 : 0, V;
  }
  function Pn(C) {
    var V = this.__data__;
    if (Xr) {
      var oe = V[C];
      return oe === a ? void 0 : oe;
    }
    return L.call(V, C) ? V[C] : void 0;
  }
  function Xn(C) {
    var V = this.__data__;
    return Xr ? V[C] !== void 0 : L.call(V, C);
  }
  function Kn(C, V) {
    var oe = this.__data__;
    return this.size += this.has(C) ? 0 : 1, oe[C] = Xr && V === void 0 ? a : V, this;
  }
  Er.prototype.clear = an, Er.prototype.delete = kn, Er.prototype.get = Pn, Er.prototype.has = Xn, Er.prototype.set = Kn;
  function Or(C) {
    var V = -1, oe = C == null ? 0 : C.length;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function Mn() {
    this.__data__ = [], this.size = 0;
  }
  function xa(C) {
    var V = this.__data__, oe = ia(V, C);
    if (oe < 0)
      return !1;
    var Ee = V.length - 1;
    return oe == Ee ? V.pop() : Nt.call(V, oe, 1), --this.size, !0;
  }
  function wa(C) {
    var V = this.__data__, oe = ia(V, C);
    return oe < 0 ? void 0 : V[oe][1];
  }
  function Ta(C) {
    return ia(this.__data__, C) > -1;
  }
  function Ua(C, V) {
    var oe = this.__data__, Ee = ia(oe, C);
    return Ee < 0 ? (++this.size, oe.push([C, V])) : oe[Ee][1] = V, this;
  }
  Or.prototype.clear = Mn, Or.prototype.delete = xa, Or.prototype.get = wa, Or.prototype.has = Ta, Or.prototype.set = Ua;
  function lr(C) {
    var V = -1, oe = C == null ? 0 : C.length;
    for (this.clear(); ++V < oe; ) {
      var Ee = C[V];
      this.set(Ee[0], Ee[1]);
    }
  }
  function vi() {
    this.size = 0, this.__data__ = {
      hash: new Er(),
      map: new (pr || Or)(),
      string: new Er()
    };
  }
  function Jn(C) {
    var V = z(this, C).delete(C);
    return this.size -= V ? 1 : 0, V;
  }
  function nn(C) {
    return z(this, C).get(C);
  }
  function Vr(C) {
    return z(this, C).has(C);
  }
  function Ra(C, V) {
    var oe = z(this, C), Ee = oe.size;
    return oe.set(C, V), this.size += oe.size == Ee ? 0 : 1, this;
  }
  lr.prototype.clear = vi, lr.prototype.delete = Jn, lr.prototype.get = nn, lr.prototype.has = Vr, lr.prototype.set = Ra;
  function qr(C) {
    var V = -1, oe = C == null ? 0 : C.length;
    for (this.__data__ = new lr(); ++V < oe; )
      this.add(C[V]);
  }
  function Ur(C) {
    return this.__data__.set(C, a), this;
  }
  function da(C) {
    return this.__data__.has(C);
  }
  qr.prototype.add = qr.prototype.push = Ur, qr.prototype.has = da;
  function hr(C) {
    var V = this.__data__ = new Or(C);
    this.size = V.size;
  }
  function Kr() {
    this.__data__ = new Or(), this.size = 0;
  }
  function Qn(C) {
    var V = this.__data__, oe = V.delete(C);
    return this.size = V.size, oe;
  }
  function sn(C) {
    return this.__data__.get(C);
  }
  function on(C) {
    return this.__data__.has(C);
  }
  function Dr(C, V) {
    var oe = this.__data__;
    if (oe instanceof Or) {
      var Ee = oe.__data__;
      if (!pr || Ee.length < r - 1)
        return Ee.push([C, V]), this.size = ++oe.size, this;
      oe = this.__data__ = new lr(Ee);
    }
    return oe.set(C, V), this.size = oe.size, this;
  }
  hr.prototype.clear = Kr, hr.prototype.delete = Qn, hr.prototype.get = sn, hr.prototype.has = on, hr.prototype.set = Dr;
  function Xt(C, V) {
    var oe = tt(C), Ee = !oe && xt(C), wt = !oe && !Ee && er(C), ht = !oe && !Ee && !wt && dr(C), Rt = oe || Ee || wt || ht, Ft = Rt ? rt(C.length, String) : [], Rr = Ft.length;
    for (var Jt in C)
      (V || L.call(C, Jt)) && !(Rt && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Jt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      wt && (Jt == "offset" || Jt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ht && (Jt == "buffer" || Jt == "byteLength" || Jt == "byteOffset") || // Skip index properties.
      Et(Jt, Rr))) && Ft.push(Jt);
    return Ft;
  }
  function ia(C, V) {
    for (var oe = C.length; oe--; )
      if (Xe(C[oe][0], V))
        return oe;
    return -1;
  }
  function Sa(C, V, oe) {
    var Ee = V(C);
    return tt(C) ? Ee : Se(Ee, oe(C));
  }
  function ca(C) {
    return C == null ? C === void 0 ? P : m : St && St in Object(C) ? be(C) : Me(C);
  }
  function za(C) {
    return ur(C) && ca(C) == o;
  }
  function Ya(C, V, oe, Ee, wt) {
    return C === V ? !0 : C == null || V == null || !ur(C) && !ur(V) ? C !== C && V !== V : Jr(C, V, oe, Ee, Ya, wt);
  }
  function Jr(C, V, oe, Ee, wt, ht) {
    var Rt = tt(C), Ft = tt(V), Rr = Rt ? l : Ge(C), Jt = Ft ? l : Ge(V);
    Rr = Rr == o ? b : Rr, Jt = Jt == o ? b : Jt;
    var ta = Rr == b, fa = Jt == b, Hr = Rr == Jt;
    if (Hr && er(C)) {
      if (!er(V))
        return !1;
      Rt = !0, ta = !1;
    }
    if (Hr && !ta)
      return ht || (ht = new hr()), Rt || dr(C) ? Oa(C, V, oe, Ee, wt, ht) : mi(C, V, Rr, oe, Ee, wt, ht);
    if (!(oe & n)) {
      var ra = ta && L.call(C, "__wrapped__"), Qr = fa && L.call(V, "__wrapped__");
      if (ra || Qr) {
        var ei = ra ? C.value() : C, Dn = Qr ? V.value() : V;
        return ht || (ht = new hr()), wt(ei, Dn, oe, Ee, ht);
      }
    }
    return Hr ? (ht || (ht = new hr()), hi(C, V, oe, Ee, wt, ht)) : !1;
  }
  function Ea(C) {
    if (!gr(C) || ce(C))
      return !1;
    var V = tr(C) ? Y : G;
    return V.test(ze(C));
  }
  function An(C) {
    return ur(C) && Lt(C.length) && !!W[ca(C)];
  }
  function ln(C) {
    if (!ge(C))
      return bt(C);
    var V = [];
    for (var oe in Object(C))
      L.call(C, oe) && oe != "constructor" && V.push(oe);
    return V;
  }
  function Oa(C, V, oe, Ee, wt, ht) {
    var Rt = oe & n, Ft = C.length, Rr = V.length;
    if (Ft != Rr && !(Rt && Rr > Ft))
      return !1;
    var Jt = ht.get(C);
    if (Jt && ht.get(V))
      return Jt == V;
    var ta = -1, fa = !0, Hr = oe & i ? new qr() : void 0;
    for (ht.set(C, V), ht.set(V, C); ++ta < Ft; ) {
      var ra = C[ta], Qr = V[ta];
      if (Ee)
        var ei = Rt ? Ee(Qr, ra, ta, V, C, ht) : Ee(ra, Qr, ta, C, V, ht);
      if (ei !== void 0) {
        if (ei)
          continue;
        fa = !1;
        break;
      }
      if (Hr) {
        if (!Re(V, function(Dn, bi) {
          if (!It(Hr, bi) && (ra === Dn || wt(ra, Dn, oe, Ee, ht)))
            return Hr.push(bi);
        })) {
          fa = !1;
          break;
        }
      } else if (!(ra === Qr || wt(ra, Qr, oe, Ee, ht))) {
        fa = !1;
        break;
      }
    }
    return ht.delete(C), ht.delete(V), fa;
  }
  function mi(C, V, oe, Ee, wt, ht, Rt) {
    switch (oe) {
      case O:
        if (C.byteLength != V.byteLength || C.byteOffset != V.byteOffset)
          return !1;
        C = C.buffer, V = V.buffer;
      case E:
        return !(C.byteLength != V.byteLength || !ht(new We(C), new We(V)));
      case d:
      case f:
      case g:
        return Xe(+C, +V);
      case c:
        return C.name == V.name && C.message == V.message;
      case x:
      case k:
        return C == V + "";
      case h:
        var Ft = at;
      case w:
        var Rr = Ee & n;
        if (Ft || (Ft = Gt), C.size != V.size && !Rr)
          return !1;
        var Jt = Rt.get(C);
        if (Jt)
          return Jt == V;
        Ee |= i, Rt.set(C, V);
        var ta = Oa(Ft(C), Ft(V), Ee, wt, ht, Rt);
        return Rt.delete(C), ta;
      case S:
        if (Va)
          return Va.call(C) == Va.call(V);
    }
    return !1;
  }
  function hi(C, V, oe, Ee, wt, ht) {
    var Rt = oe & n, Ft = B(C), Rr = Ft.length, Jt = B(V), ta = Jt.length;
    if (Rr != ta && !Rt)
      return !1;
    for (var fa = Rr; fa--; ) {
      var Hr = Ft[fa];
      if (!(Rt ? Hr in V : L.call(V, Hr)))
        return !1;
    }
    var ra = ht.get(C);
    if (ra && ht.get(V))
      return ra == V;
    var Qr = !0;
    ht.set(C, V), ht.set(V, C);
    for (var ei = Rt; ++fa < Rr; ) {
      Hr = Ft[fa];
      var Dn = C[Hr], bi = V[Hr];
      if (Ee)
        var Ru = Rt ? Ee(bi, Dn, Hr, V, C, ht) : Ee(Dn, bi, Hr, C, V, ht);
      if (!(Ru === void 0 ? Dn === bi || wt(Dn, bi, oe, Ee, ht) : Ru)) {
        Qr = !1;
        break;
      }
      ei || (ei = Hr == "constructor");
    }
    if (Qr && !ei) {
      var Xs = C.constructor, Ks = V.constructor;
      Xs != Ks && "constructor" in C && "constructor" in V && !(typeof Xs == "function" && Xs instanceof Xs && typeof Ks == "function" && Ks instanceof Ks) && (Qr = !1);
    }
    return ht.delete(C), ht.delete(V), Qr;
  }
  function B(C) {
    return Sa(C, Zn, $e);
  }
  function z(C, V) {
    var oe = C.__data__;
    return te(V) ? oe[typeof V == "string" ? "string" : "hash"] : oe.map;
  }
  function ae(C, V) {
    var oe = Ye(C, V);
    return Ea(oe) ? oe : void 0;
  }
  function be(C) {
    var V = L.call(C, St), oe = C[St];
    try {
      C[St] = void 0;
      var Ee = !0;
    } catch {
    }
    var wt = Oe.call(C);
    return Ee && (V ? C[St] = oe : delete C[St]), wt;
  }
  var $e = me ? function(C) {
    return C == null ? [] : (C = Object(C), _e(me(C), function(V) {
      return mt.call(C, V);
    }));
  } : gi, Ge = ca;
  (_t && Ge(new _t(new ArrayBuffer(1))) != O || pr && Ge(new pr()) != h || Ze && Ge(Ze.resolve()) != y || vr && Ge(new vr()) != w || yt && Ge(new yt()) != A) && (Ge = function(C) {
    var V = ca(C), oe = V == b ? C.constructor : void 0, Ee = oe ? ze(oe) : "";
    if (Ee)
      switch (Ee) {
        case La:
          return O;
        case Ar:
          return h;
        case rn:
          return y;
        case Gn:
          return w;
        case pi:
          return A;
      }
    return V;
  });
  function Et(C, V) {
    return V = V ?? s, !!V && (typeof C == "number" || H.test(C)) && C > -1 && C % 1 == 0 && C < V;
  }
  function te(C) {
    var V = typeof C;
    return V == "string" || V == "number" || V == "symbol" || V == "boolean" ? C !== "__proto__" : C === null;
  }
  function ce(C) {
    return !!Te && Te in C;
  }
  function ge(C) {
    var V = C && C.constructor, oe = typeof V == "function" && V.prototype || ye;
    return C === oe;
  }
  function Me(C) {
    return Oe.call(C);
  }
  function ze(C) {
    if (C != null) {
      try {
        return Q.call(C);
      } catch {
      }
      try {
        return C + "";
      } catch {
      }
    }
    return "";
  }
  function Xe(C, V) {
    return C === V || C !== C && V !== V;
  }
  var xt = za(function() {
    return arguments;
  }()) ? za : function(C) {
    return ur(C) && L.call(C, "callee") && !mt.call(C, "callee");
  }, tt = Array.isArray;
  function ar(C) {
    return C != null && Lt(C.length) && !tr(C);
  }
  var er = Ue || Bi;
  function Kt(C, V) {
    return Ya(C, V);
  }
  function tr(C) {
    if (!gr(C))
      return !1;
    var V = ca(C);
    return V == p || V == v || V == u || V == _;
  }
  function Lt(C) {
    return typeof C == "number" && C > -1 && C % 1 == 0 && C <= s;
  }
  function gr(C) {
    var V = typeof C;
    return C != null && (V == "object" || V == "function");
  }
  function ur(C) {
    return C != null && typeof C == "object";
  }
  var dr = se ? Dt(se) : An;
  function Zn(C) {
    return ar(C) ? Xt(C) : ln(C);
  }
  function gi() {
    return [];
  }
  function Bi() {
    return !1;
  }
  e.exports = Kt;
})(Nd, Nd.exports);
var G3 = Nd.exports, fy = {};
Object.defineProperty(fy, "__esModule", { value: !0 });
const Yne = W3, Wne = G3;
var _1;
(function(e) {
  function t(i = {}, s = {}, o = !1) {
    typeof i != "object" && (i = {}), typeof s != "object" && (s = {});
    let l = Yne(s);
    o || (l = Object.keys(l).reduce((u, d) => (l[d] != null && (u[d] = l[d]), u), {}));
    for (const u in i)
      i[u] !== void 0 && s[u] === void 0 && (l[u] = i[u]);
    return Object.keys(l).length > 0 ? l : void 0;
  }
  e.compose = t;
  function r(i = {}, s = {}) {
    typeof i != "object" && (i = {}), typeof s != "object" && (s = {});
    const o = Object.keys(i).concat(Object.keys(s)).reduce((l, u) => (Wne(i[u], s[u]) || (l[u] = s[u] === void 0 ? null : s[u]), l), {});
    return Object.keys(o).length > 0 ? o : void 0;
  }
  e.diff = r;
  function a(i = {}, s = {}) {
    i = i || {};
    const o = Object.keys(s).reduce((l, u) => (s[u] !== i[u] && i[u] !== void 0 && (l[u] = s[u]), l), {});
    return Object.keys(i).reduce((l, u) => (i[u] !== s[u] && s[u] === void 0 && (l[u] = null), l), o);
  }
  e.invert = a;
  function n(i, s, o = !1) {
    if (typeof i != "object")
      return s;
    if (typeof s != "object")
      return;
    if (!o)
      return s;
    const l = Object.keys(s).reduce((u, d) => (i[d] === void 0 && (u[d] = s[d]), u), {});
    return Object.keys(l).length > 0 ? l : void 0;
  }
  e.transform = n;
})(_1 || (_1 = {}));
fy.default = _1;
var uf = {};
Object.defineProperty(uf, "__esModule", { value: !0 });
var x1;
(function(e) {
  function t(r) {
    return typeof r.delete == "number" ? r.delete : typeof r.retain == "number" ? r.retain : typeof r.retain == "object" && r.retain !== null ? 1 : typeof r.insert == "string" ? r.insert.length : 1;
  }
  e.length = t;
})(x1 || (x1 = {}));
uf.default = x1;
var py = {};
Object.defineProperty(py, "__esModule", { value: !0 });
const Aw = uf;
class Gne {
  constructor(t) {
    this.ops = t, this.index = 0, this.offset = 0;
  }
  hasNext() {
    return this.peekLength() < 1 / 0;
  }
  next(t) {
    t || (t = 1 / 0);
    const r = this.ops[this.index];
    if (r) {
      const a = this.offset, n = Aw.default.length(r);
      if (t >= n - a ? (t = n - a, this.index += 1, this.offset = 0) : this.offset += t, typeof r.delete == "number")
        return { delete: t };
      {
        const i = {};
        return r.attributes && (i.attributes = r.attributes), typeof r.retain == "number" ? i.retain = t : typeof r.retain == "object" && r.retain !== null ? i.retain = r.retain : typeof r.insert == "string" ? i.insert = r.insert.substr(a, t) : i.insert = r.insert, i;
      }
    } else
      return { retain: 1 / 0 };
  }
  peek() {
    return this.ops[this.index];
  }
  peekLength() {
    return this.ops[this.index] ? Aw.default.length(this.ops[this.index]) - this.offset : 1 / 0;
  }
  peekType() {
    const t = this.ops[this.index];
    return t ? typeof t.delete == "number" ? "delete" : typeof t.retain == "number" || typeof t.retain == "object" && t.retain !== null ? "retain" : "insert" : "retain";
  }
  rest() {
    if (this.hasNext()) {
      if (this.offset === 0)
        return this.ops.slice(this.index);
      {
        const t = this.offset, r = this.index, a = this.next(), n = this.ops.slice(this.index);
        return this.offset = t, this.index = r, [a].concat(n);
      }
    } else
      return [];
  }
}
py.default = Gne;
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.AttributeMap = t.OpIterator = t.Op = void 0;
  const r = zne, a = W3, n = G3, i = fy;
  t.AttributeMap = i.default;
  const s = uf;
  t.Op = s.default;
  const o = py;
  t.OpIterator = o.default;
  const l = String.fromCharCode(0), u = (f, c) => {
    if (typeof f != "object" || f === null)
      throw new Error(`cannot retain a ${typeof f}`);
    if (typeof c != "object" || c === null)
      throw new Error(`cannot retain a ${typeof c}`);
    const p = Object.keys(f)[0];
    if (!p || p !== Object.keys(c)[0])
      throw new Error(`embed types not matched: ${p} != ${Object.keys(c)[0]}`);
    return [p, f[p], c[p]];
  };
  class d {
    constructor(c) {
      Array.isArray(c) ? this.ops = c : c != null && Array.isArray(c.ops) ? this.ops = c.ops : this.ops = [];
    }
    static registerEmbed(c, p) {
      this.handlers[c] = p;
    }
    static unregisterEmbed(c) {
      delete this.handlers[c];
    }
    static getHandler(c) {
      const p = this.handlers[c];
      if (!p)
        throw new Error(`no handlers for embed type "${c}"`);
      return p;
    }
    insert(c, p) {
      const v = {};
      return typeof c == "string" && c.length === 0 ? this : (v.insert = c, p != null && typeof p == "object" && Object.keys(p).length > 0 && (v.attributes = p), this.push(v));
    }
    delete(c) {
      return c <= 0 ? this : this.push({ delete: c });
    }
    retain(c, p) {
      if (typeof c == "number" && c <= 0)
        return this;
      const v = { retain: c };
      return p != null && typeof p == "object" && Object.keys(p).length > 0 && (v.attributes = p), this.push(v);
    }
    push(c) {
      let p = this.ops.length, v = this.ops[p - 1];
      if (c = a(c), typeof v == "object") {
        if (typeof c.delete == "number" && typeof v.delete == "number")
          return this.ops[p - 1] = { delete: v.delete + c.delete }, this;
        if (typeof v.delete == "number" && c.insert != null && (p -= 1, v = this.ops[p - 1], typeof v != "object"))
          return this.ops.unshift(c), this;
        if (n(c.attributes, v.attributes)) {
          if (typeof c.insert == "string" && typeof v.insert == "string")
            return this.ops[p - 1] = { insert: v.insert + c.insert }, typeof c.attributes == "object" && (this.ops[p - 1].attributes = c.attributes), this;
          if (typeof c.retain == "number" && typeof v.retain == "number")
            return this.ops[p - 1] = { retain: v.retain + c.retain }, typeof c.attributes == "object" && (this.ops[p - 1].attributes = c.attributes), this;
        }
      }
      return p === this.ops.length ? this.ops.push(c) : this.ops.splice(p, 0, c), this;
    }
    chop() {
      const c = this.ops[this.ops.length - 1];
      return c && typeof c.retain == "number" && !c.attributes && this.ops.pop(), this;
    }
    filter(c) {
      return this.ops.filter(c);
    }
    forEach(c) {
      this.ops.forEach(c);
    }
    map(c) {
      return this.ops.map(c);
    }
    partition(c) {
      const p = [], v = [];
      return this.forEach((h) => {
        (c(h) ? p : v).push(h);
      }), [p, v];
    }
    reduce(c, p) {
      return this.ops.reduce(c, p);
    }
    changeLength() {
      return this.reduce((c, p) => p.insert ? c + s.default.length(p) : p.delete ? c - p.delete : c, 0);
    }
    length() {
      return this.reduce((c, p) => c + s.default.length(p), 0);
    }
    slice(c = 0, p = 1 / 0) {
      const v = [], h = new o.default(this.ops);
      let g = 0;
      for (; g < p && h.hasNext(); ) {
        let m;
        g < c ? m = h.next(c - g) : (m = h.next(p - g), v.push(m)), g += s.default.length(m);
      }
      return new d(v);
    }
    compose(c) {
      const p = new o.default(this.ops), v = new o.default(c.ops), h = [], g = v.peek();
      if (g != null && typeof g.retain == "number" && g.attributes == null) {
        let b = g.retain;
        for (; p.peekType() === "insert" && p.peekLength() <= b; )
          b -= p.peekLength(), h.push(p.next());
        g.retain - b > 0 && v.next(g.retain - b);
      }
      const m = new d(h);
      for (; p.hasNext() || v.hasNext(); )
        if (v.peekType() === "insert")
          m.push(v.next());
        else if (p.peekType() === "delete")
          m.push(p.next());
        else {
          const b = Math.min(p.peekLength(), v.peekLength()), y = p.next(b), _ = v.next(b);
          if (_.retain) {
            const x = {};
            if (typeof y.retain == "number")
              x.retain = typeof _.retain == "number" ? b : _.retain;
            else if (typeof _.retain == "number")
              y.retain == null ? x.insert = y.insert : x.retain = y.retain;
            else {
              const k = y.retain == null ? "insert" : "retain", [S, P, A] = u(y[k], _.retain), E = d.getHandler(S);
              x[k] = {
                [S]: E.compose(P, A, k === "retain")
              };
            }
            const w = i.default.compose(y.attributes, _.attributes, typeof y.retain == "number");
            if (w && (x.attributes = w), m.push(x), !v.hasNext() && n(m.ops[m.ops.length - 1], x)) {
              const k = new d(p.rest());
              return m.concat(k).chop();
            }
          } else
            typeof _.delete == "number" && (typeof y.retain == "number" || typeof y.retain == "object" && y.retain !== null) && m.push(_);
        }
      return m.chop();
    }
    concat(c) {
      const p = new d(this.ops.slice());
      return c.ops.length > 0 && (p.push(c.ops[0]), p.ops = p.ops.concat(c.ops.slice(1))), p;
    }
    diff(c, p) {
      if (this.ops === c.ops)
        return new d();
      const v = [this, c].map((y) => y.map((_) => {
        if (_.insert != null)
          return typeof _.insert == "string" ? _.insert : l;
        const x = y === c ? "on" : "with";
        throw new Error("diff() called " + x + " non-document");
      }).join("")), h = new d(), g = r(v[0], v[1], p, !0), m = new o.default(this.ops), b = new o.default(c.ops);
      return g.forEach((y) => {
        let _ = y[1].length;
        for (; _ > 0; ) {
          let x = 0;
          switch (y[0]) {
            case r.INSERT:
              x = Math.min(b.peekLength(), _), h.push(b.next(x));
              break;
            case r.DELETE:
              x = Math.min(_, m.peekLength()), m.next(x), h.delete(x);
              break;
            case r.EQUAL:
              x = Math.min(m.peekLength(), b.peekLength(), _);
              const w = m.next(x), k = b.next(x);
              n(w.insert, k.insert) ? h.retain(x, i.default.diff(w.attributes, k.attributes)) : h.push(k).delete(x);
              break;
          }
          _ -= x;
        }
      }), h.chop();
    }
    eachLine(c, p = `
`) {
      const v = new o.default(this.ops);
      let h = new d(), g = 0;
      for (; v.hasNext(); ) {
        if (v.peekType() !== "insert")
          return;
        const m = v.peek(), b = s.default.length(m) - v.peekLength(), y = typeof m.insert == "string" ? m.insert.indexOf(p, b) - b : -1;
        if (y < 0)
          h.push(v.next());
        else if (y > 0)
          h.push(v.next(y));
        else {
          if (c(h, v.next(1).attributes || {}, g) === !1)
            return;
          g += 1, h = new d();
        }
      }
      h.length() > 0 && c(h, {}, g);
    }
    invert(c) {
      const p = new d();
      return this.reduce((v, h) => {
        if (h.insert)
          p.delete(s.default.length(h));
        else {
          if (typeof h.retain == "number" && h.attributes == null)
            return p.retain(h.retain), v + h.retain;
          if (h.delete || typeof h.retain == "number") {
            const g = h.delete || h.retain;
            return c.slice(v, v + g).forEach((b) => {
              h.delete ? p.push(b) : h.retain && h.attributes && p.retain(s.default.length(b), i.default.invert(h.attributes, b.attributes));
            }), v + g;
          } else if (typeof h.retain == "object" && h.retain !== null) {
            const g = c.slice(v, v + 1), m = new o.default(g.ops).next(), [b, y, _] = u(h.retain, m.insert), x = d.getHandler(b);
            return p.retain({ [b]: x.invert(y, _) }, i.default.invert(h.attributes, m.attributes)), v + 1;
          }
        }
        return v;
      }, 0), p.chop();
    }
    transform(c, p = !1) {
      if (p = !!p, typeof c == "number")
        return this.transformPosition(c, p);
      const v = c, h = new o.default(this.ops), g = new o.default(v.ops), m = new d();
      for (; h.hasNext() || g.hasNext(); )
        if (h.peekType() === "insert" && (p || g.peekType() !== "insert"))
          m.retain(s.default.length(h.next()));
        else if (g.peekType() === "insert")
          m.push(g.next());
        else {
          const b = Math.min(h.peekLength(), g.peekLength()), y = h.next(b), _ = g.next(b);
          if (y.delete)
            continue;
          if (_.delete)
            m.push(_);
          else {
            const x = y.retain, w = _.retain;
            let k = typeof w == "object" && w !== null ? w : b;
            if (typeof x == "object" && x !== null && typeof w == "object" && w !== null) {
              const S = Object.keys(x)[0];
              if (S === Object.keys(w)[0]) {
                const P = d.getHandler(S);
                P && (k = {
                  [S]: P.transform(x[S], w[S], p)
                });
              }
            }
            m.retain(k, i.default.transform(y.attributes, _.attributes, p));
          }
        }
      return m.chop();
    }
    transformPosition(c, p = !1) {
      p = !!p;
      const v = new o.default(this.ops);
      let h = 0;
      for (; v.hasNext() && h <= c; ) {
        const g = v.peekLength(), m = v.peekType();
        if (v.next(), m === "delete") {
          c -= Math.min(g, c - h);
          continue;
        } else
          m === "insert" && (h < c || !p) && (c += g);
        h += g;
      }
      return c;
    }
  }
  d.Op = s.default, d.OpIterator = o.default, d.AttributeMap = i.default, d.handlers = {}, t.default = d, e.exports = d, e.exports.default = d;
})(y1, y1.exports);
var bn = y1.exports;
const ft = /* @__PURE__ */ Rd(bn);
class Yn extends tn {
  static value() {
  }
  optimize() {
    (this.prev || this.next) && this.remove();
  }
  length() {
    return 0;
  }
  value() {
    return "";
  }
}
Yn.blotName = "break";
Yn.tagName = "BR";
let qn = class extends Dd {
};
const Xne = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function df(e) {
  return e.replace(/[&<>"']/g, (t) => Xne[t]);
}
const ri = class ri extends ly {
  static compare(t, r) {
    const a = ri.order.indexOf(t), n = ri.order.indexOf(r);
    return a >= 0 || n >= 0 ? a - n : t === r ? 0 : t < r ? -1 : 1;
  }
  formatAt(t, r, a, n) {
    if (ri.compare(this.statics.blotName, a) < 0 && this.scroll.query(a, vt.BLOT)) {
      const i = this.isolate(t, r);
      n && i.wrap(a, n);
    } else
      super.formatAt(t, r, a, n);
  }
  optimize(t) {
    if (super.optimize(t), this.parent instanceof ri && ri.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
      const r = this.parent.isolate(this.offset(), this.length());
      this.moveChildren(r), r.wrap(this);
    }
  }
};
it(ri, "allowedChildren", [ri, Yn, tn, qn]), // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
it(ri, "order", [
  "cursor",
  "inline",
  // Must be lower
  "link",
  // Chrome wants <a> to be lower
  "underline",
  "strike",
  "italic",
  "bold",
  "script",
  "code"
  // Must be higher
]);
let di = ri;
const Dw = 1;
class ua extends au {
  constructor() {
    super(...arguments);
    it(this, "cache", {});
  }
  delta() {
    return this.cache.delta == null && (this.cache.delta = X3(this)), this.cache.delta;
  }
  deleteAt(r, a) {
    super.deleteAt(r, a), this.cache = {};
  }
  formatAt(r, a, n, i) {
    a <= 0 || (this.scroll.query(n, vt.BLOCK) ? r + a === this.length() && this.format(n, i) : super.formatAt(r, Math.min(a, this.length() - r - 1), n, i), this.cache = {});
  }
  insertAt(r, a, n) {
    if (n != null) {
      super.insertAt(r, a, n), this.cache = {};
      return;
    }
    if (a.length === 0)
      return;
    const i = a.split(`
`), s = i.shift();
    s.length > 0 && (r < this.length() - 1 || this.children.tail == null ? super.insertAt(Math.min(r, this.length() - 1), s) : this.children.tail.insertAt(this.children.tail.length(), s), this.cache = {});
    let o = this;
    i.reduce((l, u) => (o = o.split(l, !0), o.insertAt(0, u), u.length), r + s.length);
  }
  insertBefore(r, a) {
    const {
      head: n
    } = this.children;
    super.insertBefore(r, a), n instanceof Yn && n.remove(), this.cache = {};
  }
  length() {
    return this.cache.length == null && (this.cache.length = super.length() + Dw), this.cache.length;
  }
  moveChildren(r, a) {
    super.moveChildren(r, a), this.cache = {};
  }
  optimize(r) {
    super.optimize(r), this.cache = {};
  }
  path(r) {
    return super.path(r, !0);
  }
  removeChild(r) {
    super.removeChild(r), this.cache = {};
  }
  split(r) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (a && (r === 0 || r >= this.length() - Dw)) {
      const i = this.clone();
      return r === 0 ? (this.parent.insertBefore(i, this), this) : (this.parent.insertBefore(i, this.next), i);
    }
    const n = super.split(r, a);
    return this.cache = {}, n;
  }
}
ua.blotName = "block";
ua.tagName = "P";
ua.defaultChild = Yn;
ua.allowedChildren = [Yn, di, tn, qn];
class hn extends tn {
  attach() {
    super.attach(), this.attributes = new nf(this.domNode);
  }
  delta() {
    return new ft().insert(this.value(), {
      ...this.formats(),
      ...this.attributes.values()
    });
  }
  format(t, r) {
    const a = this.scroll.query(t, vt.BLOCK_ATTRIBUTE);
    a != null && this.attributes.attribute(a, r);
  }
  formatAt(t, r, a, n) {
    this.format(a, n);
  }
  insertAt(t, r, a) {
    if (a != null) {
      super.insertAt(t, r, a);
      return;
    }
    const n = r.split(`
`), i = n.pop(), s = n.map((l) => {
      const u = this.scroll.create(ua.blotName);
      return u.insertAt(0, l), u;
    }), o = this.split(t);
    s.forEach((l) => {
      this.parent.insertBefore(l, o);
    }), i && this.parent.insertBefore(this.scroll.create("text", i), o);
  }
}
hn.scope = vt.BLOCK_BLOT;
function X3(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.descendants(ma).reduce((r, a) => a.length() === 0 ? r : r.insert(a.value(), fn(a, {}, t)), new ft()).insert(`
`, fn(e));
}
function fn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return e == null || ("formats" in e && typeof e.formats == "function" && (t = {
    ...t,
    ...e.formats()
  }, r && delete t["code-token"]), e.parent == null || e.parent.statics.blotName === "scroll" || e.parent.statics.scope !== e.statics.scope) ? t : fn(e.parent, t, r);
}
const un = class un extends tn {
  // Zero width no break space
  static value() {
  }
  constructor(t, r, a) {
    super(t, r), this.selection = a, this.textNode = document.createTextNode(un.CONTENTS), this.domNode.appendChild(this.textNode), this.savedLength = 0;
  }
  detach() {
    this.parent != null && this.parent.removeChild(this);
  }
  format(t, r) {
    if (this.savedLength !== 0) {
      super.format(t, r);
      return;
    }
    let a = this, n = 0;
    for (; a != null && a.statics.scope !== vt.BLOCK_BLOT; )
      n += a.offset(a.parent), a = a.parent;
    a != null && (this.savedLength = un.CONTENTS.length, a.optimize(), a.formatAt(n, un.CONTENTS.length, t, r), this.savedLength = 0);
  }
  index(t, r) {
    return t === this.textNode ? 0 : super.index(t, r);
  }
  length() {
    return this.savedLength;
  }
  position() {
    return [this.textNode, this.textNode.data.length];
  }
  remove() {
    super.remove(), this.parent = null;
  }
  restore() {
    if (this.selection.composing || this.parent == null)
      return null;
    const t = this.selection.getNativeRange();
    for (; this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode; )
      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
    const r = this.prev instanceof qn ? this.prev : null, a = r ? r.length() : 0, n = this.next instanceof qn ? this.next : null, i = n ? n.text : "", {
      textNode: s
    } = this, o = s.data.split(un.CONTENTS).join("");
    s.data = un.CONTENTS;
    let l;
    if (r)
      l = r, (o || n) && (r.insertAt(r.length(), o + i), n && n.remove());
    else if (n)
      l = n, n.insertAt(0, o);
    else {
      const u = document.createTextNode(o);
      l = this.scroll.create(u), this.parent.insertBefore(l, this);
    }
    if (this.remove(), t) {
      const u = (c, p) => r && c === r.domNode ? p : c === s ? a + p - 1 : n && c === n.domNode ? a + o.length + p : null, d = u(t.start.node, t.start.offset), f = u(t.end.node, t.end.offset);
      if (d !== null && f !== null)
        return {
          startNode: l.domNode,
          startOffset: d,
          endNode: l.domNode,
          endOffset: f
        };
    }
    return null;
  }
  update(t, r) {
    if (t.some((a) => a.type === "characterData" && a.target === this.textNode)) {
      const a = this.restore();
      a && (r.range = a);
    }
  }
  // Avoid .ql-cursor being a descendant of `<a/>`.
  // The reason is Safari pushes down `<a/>` on text insertion.
  // That will cause DOM nodes not sync with the model.
  //
  // For example ({I} is the caret), given the markup:
  //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
  // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
  //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
  // And then "x" will be inserted after `<a/>`:
  //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
  optimize(t) {
    super.optimize(t);
    let {
      parent: r
    } = this;
    for (; r; ) {
      if (r.domNode.tagName === "A") {
        this.savedLength = un.CONTENTS.length, r.isolate(this.offset(r), this.length()).unwrap(), this.savedLength = 0;
        break;
      }
      r = r.parent;
    }
  }
  value() {
    return "";
  }
};
it(un, "blotName", "cursor"), it(un, "className", "ql-cursor"), it(un, "tagName", "span"), it(un, "CONTENTS", "\uFEFF");
let To = un;
var K3 = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function a() {
  }
  Object.create && (a.prototype = /* @__PURE__ */ Object.create(null), new a().__proto__ || (r = !1));
  function n(l, u, d) {
    this.fn = l, this.context = u, this.once = d || !1;
  }
  function i(l, u, d, f, c) {
    if (typeof d != "function")
      throw new TypeError("The listener must be a function");
    var p = new n(d, f || l, c), v = r ? r + u : u;
    return l._events[v] ? l._events[v].fn ? l._events[v] = [l._events[v], p] : l._events[v].push(p) : (l._events[v] = p, l._eventsCount++), l;
  }
  function s(l, u) {
    --l._eventsCount === 0 ? l._events = new a() : delete l._events[u];
  }
  function o() {
    this._events = new a(), this._eventsCount = 0;
  }
  o.prototype.eventNames = function() {
    var u = [], d, f;
    if (this._eventsCount === 0)
      return u;
    for (f in d = this._events)
      t.call(d, f) && u.push(r ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(d)) : u;
  }, o.prototype.listeners = function(u) {
    var d = r ? r + u : u, f = this._events[d];
    if (!f)
      return [];
    if (f.fn)
      return [f.fn];
    for (var c = 0, p = f.length, v = new Array(p); c < p; c++)
      v[c] = f[c].fn;
    return v;
  }, o.prototype.listenerCount = function(u) {
    var d = r ? r + u : u, f = this._events[d];
    return f ? f.fn ? 1 : f.length : 0;
  }, o.prototype.emit = function(u, d, f, c, p, v) {
    var h = r ? r + u : u;
    if (!this._events[h])
      return !1;
    var g = this._events[h], m = arguments.length, b, y;
    if (g.fn) {
      switch (g.once && this.removeListener(u, g.fn, void 0, !0), m) {
        case 1:
          return g.fn.call(g.context), !0;
        case 2:
          return g.fn.call(g.context, d), !0;
        case 3:
          return g.fn.call(g.context, d, f), !0;
        case 4:
          return g.fn.call(g.context, d, f, c), !0;
        case 5:
          return g.fn.call(g.context, d, f, c, p), !0;
        case 6:
          return g.fn.call(g.context, d, f, c, p, v), !0;
      }
      for (y = 1, b = new Array(m - 1); y < m; y++)
        b[y - 1] = arguments[y];
      g.fn.apply(g.context, b);
    } else {
      var _ = g.length, x;
      for (y = 0; y < _; y++)
        switch (g[y].once && this.removeListener(u, g[y].fn, void 0, !0), m) {
          case 1:
            g[y].fn.call(g[y].context);
            break;
          case 2:
            g[y].fn.call(g[y].context, d);
            break;
          case 3:
            g[y].fn.call(g[y].context, d, f);
            break;
          case 4:
            g[y].fn.call(g[y].context, d, f, c);
            break;
          default:
            if (!b)
              for (x = 1, b = new Array(m - 1); x < m; x++)
                b[x - 1] = arguments[x];
            g[y].fn.apply(g[y].context, b);
        }
    }
    return !0;
  }, o.prototype.on = function(u, d, f) {
    return i(this, u, d, f, !1);
  }, o.prototype.once = function(u, d, f) {
    return i(this, u, d, f, !0);
  }, o.prototype.removeListener = function(u, d, f, c) {
    var p = r ? r + u : u;
    if (!this._events[p])
      return this;
    if (!d)
      return s(this, p), this;
    var v = this._events[p];
    if (v.fn)
      v.fn === d && (!c || v.once) && (!f || v.context === f) && s(this, p);
    else {
      for (var h = 0, g = [], m = v.length; h < m; h++)
        (v[h].fn !== d || c && !v[h].once || f && v[h].context !== f) && g.push(v[h]);
      g.length ? this._events[p] = g.length === 1 ? g[0] : g : s(this, p);
    }
    return this;
  }, o.prototype.removeAllListeners = function(u) {
    var d;
    return u ? (d = r ? r + u : u, this._events[d] && s(this, d)) : (this._events = new a(), this._eventsCount = 0), this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = r, o.EventEmitter = o, e.exports = o;
})(K3);
var Kne = K3.exports;
const Jne = /* @__PURE__ */ Rd(Kne), w1 = /* @__PURE__ */ new WeakMap(), T1 = ["error", "warn", "log", "info"];
let S1 = "warn";
function J3(e) {
  if (S1 && T1.indexOf(e) <= T1.indexOf(S1)) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      r[a - 1] = arguments[a];
    console[e](...r);
  }
}
function Fi(e) {
  return T1.reduce((t, r) => (t[r] = J3.bind(console, r, e), t), {});
}
Fi.level = (e) => {
  S1 = e;
};
J3.level = Fi.level;
const lp = Fi("quill:events"), Qne = ["selectionchange", "mousedown", "mouseup", "click"];
Qne.forEach((e) => {
  document.addEventListener(e, function() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    Array.from(document.querySelectorAll(".ql-container")).forEach((n) => {
      const i = w1.get(n);
      i && i.emitter && i.emitter.handleDOM(...r);
    });
  });
});
class ot extends Jne {
  constructor() {
    super(), this.domListeners = {}, this.on("error", lp.error);
  }
  emit() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return lp.log.call(lp, ...r), super.emit(...r);
  }
  handleDOM(t) {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    (this.domListeners[t.type] || []).forEach((i) => {
      let {
        node: s,
        handler: o
      } = i;
      (t.target === s || s.contains(t.target)) && o(t, ...a);
    });
  }
  listenDOM(t, r, a) {
    this.domListeners[t] || (this.domListeners[t] = []), this.domListeners[t].push({
      node: r,
      handler: a
    });
  }
}
it(ot, "events", {
  EDITOR_CHANGE: "editor-change",
  SCROLL_BEFORE_UPDATE: "scroll-before-update",
  SCROLL_BLOT_MOUNT: "scroll-blot-mount",
  SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
  SCROLL_OPTIMIZE: "scroll-optimize",
  SCROLL_UPDATE: "scroll-update",
  SCROLL_EMBED_UPDATE: "scroll-embed-update",
  SELECTION_CHANGE: "selection-change",
  TEXT_CHANGE: "text-change",
  COMPOSITION_BEFORE_START: "composition-before-start",
  COMPOSITION_START: "composition-start",
  COMPOSITION_BEFORE_END: "composition-before-end",
  COMPOSITION_END: "composition-end"
}), it(ot, "sources", {
  API: "api",
  SILENT: "silent",
  USER: "user"
});
const up = Fi("quill:selection");
class Is {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.index = t, this.length = r;
  }
}
class Zne {
  constructor(t, r) {
    this.emitter = r, this.scroll = t, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = this.scroll.create("cursor", this), this.savedRange = new Is(0, 0), this.lastRange = this.savedRange, this.lastNative = null, this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, () => {
      !this.mouseDown && !this.composing && setTimeout(this.update.bind(this, ot.sources.USER), 1);
    }), this.emitter.on(ot.events.SCROLL_BEFORE_UPDATE, () => {
      if (!this.hasFocus())
        return;
      const a = this.getNativeRange();
      a != null && a.start.node !== this.cursor.textNode && this.emitter.once(ot.events.SCROLL_UPDATE, (n, i) => {
        try {
          this.root.contains(a.start.node) && this.root.contains(a.end.node) && this.setNativeRange(a.start.node, a.start.offset, a.end.node, a.end.offset);
          const s = i.some((o) => o.type === "characterData" || o.type === "childList" || o.type === "attributes" && o.target === this.root);
          this.update(s ? ot.sources.SILENT : n);
        } catch {
        }
      });
    }), this.emitter.on(ot.events.SCROLL_OPTIMIZE, (a, n) => {
      if (n.range) {
        const {
          startNode: i,
          startOffset: s,
          endNode: o,
          endOffset: l
        } = n.range;
        this.setNativeRange(i, s, o, l), this.update(ot.sources.SILENT);
      }
    }), this.update(ot.sources.SILENT);
  }
  handleComposition() {
    this.emitter.on(ot.events.COMPOSITION_BEFORE_START, () => {
      this.composing = !0;
    }), this.emitter.on(ot.events.COMPOSITION_END, () => {
      if (this.composing = !1, this.cursor.parent) {
        const t = this.cursor.restore();
        if (!t)
          return;
        setTimeout(() => {
          this.setNativeRange(t.startNode, t.startOffset, t.endNode, t.endOffset);
        }, 1);
      }
    });
  }
  handleDragging() {
    this.emitter.listenDOM("mousedown", document.body, () => {
      this.mouseDown = !0;
    }), this.emitter.listenDOM("mouseup", document.body, () => {
      this.mouseDown = !1, this.update(ot.sources.USER);
    });
  }
  focus() {
    this.hasFocus() || (this.root.focus({
      preventScroll: !0
    }), this.setRange(this.savedRange));
  }
  format(t, r) {
    this.scroll.update();
    const a = this.getNativeRange();
    if (!(a == null || !a.native.collapsed || this.scroll.query(t, vt.BLOCK))) {
      if (a.start.node !== this.cursor.textNode) {
        const n = this.scroll.find(a.start.node, !1);
        if (n == null)
          return;
        if (n instanceof ma) {
          const i = n.split(a.start.offset);
          n.parent.insertBefore(this.cursor, i);
        } else
          n.insertBefore(this.cursor, a.start.node);
        this.cursor.attach();
      }
      this.cursor.format(t, r), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
    }
  }
  getBounds(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const a = this.scroll.length();
    t = Math.min(t, a - 1), r = Math.min(t + r, a - 1) - t;
    let n, [i, s] = this.scroll.leaf(t);
    if (i == null)
      return null;
    if (r > 0 && s === i.length()) {
      const [d] = this.scroll.leaf(t + 1);
      if (d) {
        const [f] = this.scroll.line(t), [c] = this.scroll.line(t + 1);
        f === c && (i = d, s = 0);
      }
    }
    [n, s] = i.position(s, !0);
    const o = document.createRange();
    if (r > 0)
      return o.setStart(n, s), [i, s] = this.scroll.leaf(t + r), i == null ? null : ([n, s] = i.position(s, !0), o.setEnd(n, s), o.getBoundingClientRect());
    let l = "left", u;
    if (n instanceof Text) {
      if (!n.data.length)
        return null;
      s < n.data.length ? (o.setStart(n, s), o.setEnd(n, s + 1)) : (o.setStart(n, s - 1), o.setEnd(n, s), l = "right"), u = o.getBoundingClientRect();
    } else {
      if (!(i.domNode instanceof Element))
        return null;
      u = i.domNode.getBoundingClientRect(), s > 0 && (l = "right");
    }
    return {
      bottom: u.top + u.height,
      height: u.height,
      left: u[l],
      right: u[l],
      top: u.top,
      width: 0
    };
  }
  getNativeRange() {
    const t = document.getSelection();
    if (t == null || t.rangeCount <= 0)
      return null;
    const r = t.getRangeAt(0);
    if (r == null)
      return null;
    const a = this.normalizeNative(r);
    return up.info("getNativeRange", a), a;
  }
  getRange() {
    const t = this.scroll.domNode;
    if ("isConnected" in t && !t.isConnected)
      return [null, null];
    const r = this.getNativeRange();
    return r == null ? [null, null] : [this.normalizedToRange(r), r];
  }
  hasFocus() {
    return document.activeElement === this.root || document.activeElement != null && dp(this.root, document.activeElement);
  }
  normalizedToRange(t) {
    const r = [[t.start.node, t.start.offset]];
    t.native.collapsed || r.push([t.end.node, t.end.offset]);
    const a = r.map((s) => {
      const [o, l] = s, u = this.scroll.find(o, !0), d = u.offset(this.scroll);
      return l === 0 ? d : u instanceof ma ? d + u.index(o, l) : d + u.length();
    }), n = Math.min(Math.max(...a), this.scroll.length() - 1), i = Math.min(n, ...a);
    return new Is(i, n - i);
  }
  normalizeNative(t) {
    if (!dp(this.root, t.startContainer) || !t.collapsed && !dp(this.root, t.endContainer))
      return null;
    const r = {
      start: {
        node: t.startContainer,
        offset: t.startOffset
      },
      end: {
        node: t.endContainer,
        offset: t.endOffset
      },
      native: t
    };
    return [r.start, r.end].forEach((a) => {
      let {
        node: n,
        offset: i
      } = a;
      for (; !(n instanceof Text) && n.childNodes.length > 0; )
        if (n.childNodes.length > i)
          n = n.childNodes[i], i = 0;
        else if (n.childNodes.length === i)
          n = n.lastChild, n instanceof Text ? i = n.data.length : n.childNodes.length > 0 ? i = n.childNodes.length : i = n.childNodes.length + 1;
        else
          break;
      a.node = n, a.offset = i;
    }), r;
  }
  rangeToNative(t) {
    const r = this.scroll.length(), a = (n, i) => {
      n = Math.min(r - 1, n);
      const [s, o] = this.scroll.leaf(n);
      return s ? s.position(o, i) : [null, -1];
    };
    return [...a(t.index, !1), ...a(t.index + t.length, !0)];
  }
  setNativeRange(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : r, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    if (up.info("setNativeRange", t, r, a, n), t != null && (this.root.parentNode == null || t.parentNode == null || // @ts-expect-error Fix me later
    a.parentNode == null))
      return;
    const s = document.getSelection();
    if (s != null)
      if (t != null) {
        this.hasFocus() || this.root.focus({
          preventScroll: !0
        });
        const {
          native: o
        } = this.getNativeRange() || {};
        if (o == null || i || t !== o.startContainer || r !== o.startOffset || a !== o.endContainer || n !== o.endOffset) {
          t instanceof Element && t.tagName === "BR" && (r = Array.from(t.parentNode.childNodes).indexOf(t), t = t.parentNode), a instanceof Element && a.tagName === "BR" && (n = Array.from(a.parentNode.childNodes).indexOf(a), a = a.parentNode);
          const l = document.createRange();
          l.setStart(t, r), l.setEnd(a, n), s.removeAllRanges(), s.addRange(l);
        }
      } else
        s.removeAllRanges(), this.root.blur();
  }
  setRange(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ot.sources.API;
    if (typeof r == "string" && (a = r, r = !1), up.info("setRange", t), t != null) {
      const n = this.rangeToNative(t);
      this.setNativeRange(...n, r);
    } else
      this.setNativeRange(null);
    this.update(a);
  }
  update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ot.sources.USER;
    const r = this.lastRange, [a, n] = this.getRange();
    if (this.lastRange = a, this.lastNative = n, this.lastRange != null && (this.savedRange = this.lastRange), !oy(r, this.lastRange)) {
      if (!this.composing && n != null && n.native.collapsed && n.start.node !== this.cursor.textNode) {
        const s = this.cursor.restore();
        s && this.setNativeRange(s.startNode, s.startOffset, s.endNode, s.endOffset);
      }
      const i = [ot.events.SELECTION_CHANGE, fo(this.lastRange), fo(r), t];
      this.emitter.emit(ot.events.EDITOR_CHANGE, ...i), t !== ot.sources.SILENT && this.emitter.emit(...i);
    }
  }
}
function dp(e, t) {
  try {
    t.parentNode;
  } catch {
    return !1;
  }
  return e.contains(t);
}
const eie = /^[ -~]*$/;
class tie {
  constructor(t) {
    this.scroll = t, this.delta = this.getDelta();
  }
  applyDelta(t) {
    this.scroll.update();
    let r = this.scroll.length();
    this.scroll.batchStart();
    const a = Iw(t), n = new ft();
    return aie(a.ops.slice()).reduce((s, o) => {
      const l = bn.Op.length(o);
      let u = o.attributes || {}, d = !1, f = !1;
      if (o.insert != null) {
        if (n.retain(l), typeof o.insert == "string") {
          const v = o.insert;
          f = !v.endsWith(`
`) && (r <= s || !!this.scroll.descendant(hn, s)[0]), this.scroll.insertAt(s, v);
          const [h, g] = this.scroll.line(s);
          let m = Qi({}, fn(h));
          if (h instanceof ua) {
            const [b] = h.descendant(ma, g);
            b && (m = Qi(m, fn(b)));
          }
          u = bn.AttributeMap.diff(m, u) || {};
        } else if (typeof o.insert == "object") {
          const v = Object.keys(o.insert)[0];
          if (v == null)
            return s;
          const h = this.scroll.query(v, vt.INLINE) != null;
          if (h)
            (r <= s || this.scroll.descendant(hn, s)[0]) && (f = !0);
          else if (s > 0) {
            const [g, m] = this.scroll.descendant(ma, s - 1);
            g instanceof qn ? g.value()[m] !== `
` && (d = !0) : g instanceof tn && g.statics.scope === vt.INLINE_BLOT && (d = !0);
          }
          if (this.scroll.insertAt(s, v, o.insert[v]), h) {
            const [g] = this.scroll.descendant(ma, s);
            if (g) {
              const m = Qi({}, fn(g));
              u = bn.AttributeMap.diff(m, u) || {};
            }
          }
        }
        r += l;
      } else if (n.push(o), o.retain !== null && typeof o.retain == "object") {
        const v = Object.keys(o.retain)[0];
        if (v == null)
          return s;
        this.scroll.updateEmbedAt(s, v, o.retain[v]);
      }
      Object.keys(u).forEach((v) => {
        this.scroll.formatAt(s, l, v, u[v]);
      });
      const c = d ? 1 : 0, p = f ? 1 : 0;
      return r += c + p, n.retain(c), n.delete(p), s + l + c + p;
    }, 0), n.reduce((s, o) => typeof o.delete == "number" ? (this.scroll.deleteAt(s, o.delete), s) : s + bn.Op.length(o), 0), this.scroll.batchEnd(), this.scroll.optimize(), this.update(a);
  }
  deleteText(t, r) {
    return this.scroll.deleteAt(t, r), this.update(new ft().retain(t).delete(r));
  }
  formatLine(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.scroll.update(), Object.keys(a).forEach((i) => {
      this.scroll.lines(t, Math.max(r, 1)).forEach((s) => {
        s.format(i, a[i]);
      });
    }), this.scroll.optimize();
    const n = new ft().retain(t).retain(r, fo(a));
    return this.update(n);
  }
  formatText(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Object.keys(a).forEach((i) => {
      this.scroll.formatAt(t, r, i, a[i]);
    });
    const n = new ft().retain(t).retain(r, fo(a));
    return this.update(n);
  }
  getContents(t, r) {
    return this.delta.slice(t, t + r);
  }
  getDelta() {
    return this.scroll.lines().reduce((t, r) => t.concat(r.delta()), new ft());
  }
  getFormat(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = [], n = [];
    r === 0 ? this.scroll.path(t).forEach((o) => {
      const [l] = o;
      l instanceof ua ? a.push(l) : l instanceof ma && n.push(l);
    }) : (a = this.scroll.lines(t, r), n = this.scroll.descendants(ma, t, r));
    const [i, s] = [a, n].map((o) => {
      const l = o.shift();
      if (l == null)
        return {};
      let u = fn(l);
      for (; Object.keys(u).length > 0; ) {
        const d = o.shift();
        if (d == null)
          return u;
        u = rie(fn(d), u);
      }
      return u;
    });
    return {
      ...i,
      ...s
    };
  }
  getHTML(t, r) {
    const [a, n] = this.scroll.line(t);
    if (a) {
      const i = a.length();
      return a.length() >= n + r && !(n === 0 && r === i) ? iu(a, n, r, !0) : iu(this.scroll, t, r, !0);
    }
    return "";
  }
  getText(t, r) {
    return this.getContents(t, r).filter((a) => typeof a.insert == "string").map((a) => a.insert).join("");
  }
  insertContents(t, r) {
    const a = Iw(r), n = new ft().retain(t).concat(a);
    return this.scroll.insertContents(t, a), this.update(n);
  }
  insertEmbed(t, r, a) {
    return this.scroll.insertAt(t, r, a), this.update(new ft().retain(t).insert({
      [r]: a
    }));
  }
  insertText(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return r = r.replace(/\r\n/g, `
`).replace(/\r/g, `
`), this.scroll.insertAt(t, r), Object.keys(a).forEach((n) => {
      this.scroll.formatAt(t, r.length, n, a[n]);
    }), this.update(new ft().retain(t).insert(r, fo(a)));
  }
  isBlank() {
    if (this.scroll.children.length === 0)
      return !0;
    if (this.scroll.children.length > 1)
      return !1;
    const t = this.scroll.children.head;
    if ((t == null ? void 0 : t.statics.blotName) !== ua.blotName)
      return !1;
    const r = t;
    return r.children.length > 1 ? !1 : r.children.head instanceof Yn;
  }
  removeFormat(t, r) {
    const a = this.getText(t, r), [n, i] = this.scroll.line(t + r);
    let s = 0, o = new ft();
    n != null && (s = n.length() - i, o = n.delta().slice(i, i + s - 1).insert(`
`));
    const u = this.getContents(t, r + s).diff(new ft().insert(a).concat(o)), d = new ft().retain(t).concat(u);
    return this.applyDelta(d);
  }
  update(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    const n = this.delta;
    if (r.length === 1 && r[0].type === "characterData" && // @ts-expect-error Fix me later
    r[0].target.data.match(eie) && this.scroll.find(r[0].target)) {
      const i = this.scroll.find(r[0].target), s = fn(i), o = i.offset(this.scroll), l = r[0].oldValue.replace(To.CONTENTS, ""), u = new ft().insert(l), d = new ft().insert(i.value()), f = a && {
        oldRange: Nw(a.oldRange, -o),
        newRange: Nw(a.newRange, -o)
      };
      t = new ft().retain(o).concat(u.diff(d, f)).reduce((p, v) => v.insert ? p.insert(v.insert, s) : p.push(v), new ft()), this.delta = n.compose(t);
    } else
      this.delta = this.getDelta(), (!t || !oy(n.compose(t), this.delta)) && (t = n.diff(this.delta, a));
    return t;
  }
}
function oo(e, t, r) {
  if (e.length === 0) {
    const [p] = cp(r.pop());
    return t <= 0 ? `</li></${p}>` : `</li></${p}>${oo([], t - 1, r)}`;
  }
  const [{
    child: a,
    offset: n,
    length: i,
    indent: s,
    type: o
  }, ...l] = e, [u, d] = cp(o);
  if (s > t)
    return r.push(o), s === t + 1 ? `<${u}><li${d}>${iu(a, n, i)}${oo(l, s, r)}` : `<${u}><li>${oo(e, t + 1, r)}`;
  const f = r[r.length - 1];
  if (s === t && o === f)
    return `</li><li${d}>${iu(a, n, i)}${oo(l, s, r)}`;
  const [c] = cp(r.pop());
  return `</li></${c}>${oo(e, t - 1, r)}`;
}
function iu(e, t, r) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if ("html" in e && typeof e.html == "function")
    return e.html(t, r);
  if (e instanceof qn)
    return df(e.value().slice(t, t + r)).replaceAll(" ", "&nbsp;");
  if (e instanceof Rn) {
    if (e.statics.blotName === "list-container") {
      const u = [];
      return e.children.forEachAt(t, r, (d, f, c) => {
        const p = "formats" in d && typeof d.formats == "function" ? d.formats() : {};
        u.push({
          child: d,
          offset: f,
          length: c,
          indent: p.indent || 0,
          type: p.list
        });
      }), oo(u, -1, []);
    }
    const n = [];
    if (e.children.forEachAt(t, r, (u, d, f) => {
      n.push(iu(u, d, f));
    }), a || e.statics.blotName === "list")
      return n.join("");
    const {
      outerHTML: i,
      innerHTML: s
    } = e.domNode, [o, l] = i.split(`>${s}<`);
    return o === "<table" ? `<table style="border: 1px solid #000;">${n.join("")}<${l}` : `${o}>${n.join("")}<${l}`;
  }
  return e.domNode instanceof Element ? e.domNode.outerHTML : "";
}
function rie(e, t) {
  return Object.keys(t).reduce((r, a) => {
    if (e[a] == null)
      return r;
    const n = t[a];
    return n === e[a] ? r[a] = n : Array.isArray(n) ? n.indexOf(e[a]) < 0 ? r[a] = n.concat([e[a]]) : r[a] = n : r[a] = [n, e[a]], r;
  }, {});
}
function cp(e) {
  const t = e === "ordered" ? "ol" : "ul";
  switch (e) {
    case "checked":
      return [t, ' data-list="checked"'];
    case "unchecked":
      return [t, ' data-list="unchecked"'];
    default:
      return [t, ""];
  }
}
function Iw(e) {
  return e.reduce((t, r) => {
    if (typeof r.insert == "string") {
      const a = r.insert.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
      return t.insert(a, r.attributes);
    }
    return t.push(r);
  }, new ft());
}
function Nw(e, t) {
  let {
    index: r,
    length: a
  } = e;
  return new Is(r + t, a);
}
function aie(e) {
  const t = [];
  return e.forEach((r) => {
    typeof r.insert == "string" ? r.insert.split(`
`).forEach((n, i) => {
      i && t.push({
        insert: `
`,
        attributes: r.attributes
      }), n && t.push({
        insert: n,
        attributes: r.attributes
      });
    }) : t.push(r);
  }), t;
}
class Wn {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.quill = t, this.options = r;
  }
}
it(Wn, "DEFAULTS", {});
const Ju = "\uFEFF";
class vy extends tn {
  constructor(t, r) {
    super(t, r), this.contentNode = document.createElement("span"), this.contentNode.setAttribute("contenteditable", "false"), Array.from(this.domNode.childNodes).forEach((a) => {
      this.contentNode.appendChild(a);
    }), this.leftGuard = document.createTextNode(Ju), this.rightGuard = document.createTextNode(Ju), this.domNode.appendChild(this.leftGuard), this.domNode.appendChild(this.contentNode), this.domNode.appendChild(this.rightGuard);
  }
  index(t, r) {
    return t === this.leftGuard ? 0 : t === this.rightGuard ? 1 : super.index(t, r);
  }
  restore(t) {
    let r = null, a;
    const n = t.data.split(Ju).join("");
    if (t === this.leftGuard)
      if (this.prev instanceof qn) {
        const i = this.prev.length();
        this.prev.insertAt(i, n), r = {
          startNode: this.prev.domNode,
          startOffset: i + n.length
        };
      } else
        a = document.createTextNode(n), this.parent.insertBefore(this.scroll.create(a), this), r = {
          startNode: a,
          startOffset: n.length
        };
    else
      t === this.rightGuard && (this.next instanceof qn ? (this.next.insertAt(0, n), r = {
        startNode: this.next.domNode,
        startOffset: n.length
      }) : (a = document.createTextNode(n), this.parent.insertBefore(this.scroll.create(a), this.next), r = {
        startNode: a,
        startOffset: n.length
      }));
    return t.data = Ju, r;
  }
  update(t, r) {
    t.forEach((a) => {
      if (a.type === "characterData" && (a.target === this.leftGuard || a.target === this.rightGuard)) {
        const n = this.restore(a.target);
        n && (r.range = n);
      }
    });
  }
}
class nie {
  constructor(t, r) {
    it(this, "isComposing", !1);
    this.scroll = t, this.emitter = r, this.setupListeners();
  }
  setupListeners() {
    this.scroll.domNode.addEventListener("compositionstart", (t) => {
      this.isComposing || this.handleCompositionStart(t);
    }), this.scroll.domNode.addEventListener("compositionend", (t) => {
      this.isComposing && queueMicrotask(() => {
        this.handleCompositionEnd(t);
      });
    });
  }
  handleCompositionStart(t) {
    const r = t.target instanceof Node ? this.scroll.find(t.target, !0) : null;
    r && !(r instanceof vy) && (this.emitter.emit(ot.events.COMPOSITION_BEFORE_START, t), this.scroll.batchStart(), this.emitter.emit(ot.events.COMPOSITION_START, t), this.isComposing = !0);
  }
  handleCompositionEnd(t) {
    this.emitter.emit(ot.events.COMPOSITION_BEFORE_END, t), this.scroll.batchEnd(), this.emitter.emit(ot.events.COMPOSITION_END, t), this.isComposing = !1;
  }
}
const Fl = class Fl {
  constructor(t, r) {
    it(this, "modules", {});
    this.quill = t, this.options = r;
  }
  init() {
    Object.keys(this.options.modules).forEach((t) => {
      this.modules[t] == null && this.addModule(t);
    });
  }
  addModule(t) {
    const r = this.quill.constructor.import(`modules/${t}`);
    return this.modules[t] = new r(this.quill, this.options.modules[t] || {}), this.modules[t];
  }
};
it(Fl, "DEFAULTS", {
  modules: {}
}), it(Fl, "themes", {
  default: Fl
});
let So = Fl;
const iie = (e) => e.parentElement || e.getRootNode().host || null, sie = (e) => {
  const t = e.getBoundingClientRect(), r = "offsetWidth" in e && Math.abs(t.width) / e.offsetWidth || 1, a = "offsetHeight" in e && Math.abs(t.height) / e.offsetHeight || 1;
  return {
    top: t.top,
    right: t.left + e.clientWidth * r,
    bottom: t.top + e.clientHeight * a,
    left: t.left
  };
}, Qu = (e) => {
  const t = parseInt(e, 10);
  return Number.isNaN(t) ? 0 : t;
}, $w = (e, t, r, a, n, i) => e < r && t > a ? 0 : e < r ? -(r - e + n) : t > a ? t - e > a - r ? e + n - r : t - a + i : 0, oie = (e, t) => {
  var i, s, o;
  const r = e.ownerDocument;
  let a = t, n = e;
  for (; n; ) {
    const l = n === r.body, u = l ? {
      top: 0,
      right: ((i = window.visualViewport) == null ? void 0 : i.width) ?? r.documentElement.clientWidth,
      bottom: ((s = window.visualViewport) == null ? void 0 : s.height) ?? r.documentElement.clientHeight,
      left: 0
    } : sie(n), d = getComputedStyle(n), f = $w(a.left, a.right, u.left, u.right, Qu(d.scrollPaddingLeft), Qu(d.scrollPaddingRight)), c = $w(a.top, a.bottom, u.top, u.bottom, Qu(d.scrollPaddingTop), Qu(d.scrollPaddingBottom));
    if (f || c)
      if (l)
        (o = r.defaultView) == null || o.scrollBy(f, c);
      else {
        const {
          scrollLeft: p,
          scrollTop: v
        } = n;
        c && (n.scrollTop += c), f && (n.scrollLeft += f);
        const h = n.scrollLeft - p, g = n.scrollTop - v;
        a = {
          left: a.left - h,
          top: a.top - g,
          right: a.right - h,
          bottom: a.bottom - g
        };
      }
    n = l || d.position === "fixed" ? null : iie(n);
  }
}, lie = 100, uie = ["block", "break", "cursor", "inline", "scroll", "text"], die = (e, t, r) => {
  const a = new wo();
  return uie.forEach((n) => {
    const i = t.query(n);
    i && a.register(i);
  }), e.forEach((n) => {
    let i = t.query(n);
    i || r.error(`Cannot register "${n}" specified in "formats" config. Are you sure it was registered?`);
    let s = 0;
    for (; i; )
      if (a.register(i), i = "blotName" in i ? i.requiredContainer ?? null : null, s += 1, s > lie) {
        r.error(`Cycle detected in registering blot requiredContainer: "${n}"`);
        break;
      }
  }), a;
}, vo = Fi("quill"), Zu = new wo();
Rn.uiClass = "ql-ui";
const Nn = class Nn {
  static debug(t) {
    t === !0 && (t = "log"), Fi.level(t);
  }
  static find(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return w1.get(t) || Zu.find(t, r);
  }
  static import(t) {
    return this.imports[t] == null && vo.error(`Cannot import ${t}. Are you sure it was registered?`), this.imports[t];
  }
  static register() {
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) != "string") {
      const t = arguments.length <= 0 ? void 0 : arguments[0], r = !!(!(arguments.length <= 1) && arguments[1]), a = "attrName" in t ? t.attrName : t.blotName;
      typeof a == "string" ? this.register(`formats/${a}`, t, r) : Object.keys(t).forEach((n) => {
        this.register(n, t[n], r);
      });
    } else {
      const t = arguments.length <= 0 ? void 0 : arguments[0], r = arguments.length <= 1 ? void 0 : arguments[1], a = !!(!(arguments.length <= 2) && arguments[2]);
      this.imports[t] != null && !a && vo.warn(`Overwriting ${t} with`, r), this.imports[t] = r, (t.startsWith("blots/") || t.startsWith("formats/")) && r && typeof r != "boolean" && r.blotName !== "abstract" && Zu.register(r), typeof r.register == "function" && r.register(Zu);
    }
  }
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.options = cie(t, r), this.container = this.options.container, this.container == null) {
      vo.error("Invalid Quill container", t);
      return;
    }
    this.options.debug && Nn.debug(this.options.debug);
    const a = this.container.innerHTML.trim();
    this.container.classList.add("ql-container"), this.container.innerHTML = "", w1.set(this.container, this), this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.emitter = new ot();
    const n = uy.blotName, i = this.options.registry.query(n);
    if (!i || !("blotName" in i))
      throw new Error(`Cannot initialize Quill without "${n}" blot`);
    if (this.scroll = new i(this.options.registry, this.root, {
      emitter: this.emitter
    }), this.editor = new tie(this.scroll), this.selection = new Zne(this.scroll, this.emitter), this.composition = new nie(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.uploader = this.theme.addModule("uploader"), this.theme.addModule("input"), this.theme.addModule("uiNode"), this.theme.init(), this.emitter.on(ot.events.EDITOR_CHANGE, (s) => {
      s === ot.events.TEXT_CHANGE && this.root.classList.toggle("ql-blank", this.editor.isBlank());
    }), this.emitter.on(ot.events.SCROLL_UPDATE, (s, o) => {
      const l = this.selection.lastRange, [u] = this.selection.getRange(), d = l && u ? {
        oldRange: l,
        newRange: u
      } : void 0;
      In.call(this, () => this.editor.update(null, o, d), s);
    }), this.emitter.on(ot.events.SCROLL_EMBED_UPDATE, (s, o) => {
      const l = this.selection.lastRange, [u] = this.selection.getRange(), d = l && u ? {
        oldRange: l,
        newRange: u
      } : void 0;
      In.call(this, () => {
        const f = new ft().retain(s.offset(this)).retain({
          [s.statics.blotName]: o
        });
        return this.editor.update(f, [], d);
      }, Nn.sources.USER);
    }), a) {
      const s = this.clipboard.convert({
        html: `${a}<p><br></p>`,
        text: `
`
      });
      this.setContents(s);
    }
    this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable(), this.allowReadOnlyEdits = !1;
  }
  addContainer(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (typeof t == "string") {
      const a = t;
      t = document.createElement("div"), t.classList.add(a);
    }
    return this.container.insertBefore(t, r), t;
  }
  blur() {
    this.selection.setRange(null);
  }
  deleteText(t, r, a) {
    return [t, r, , a] = _i(t, r, a), In.call(this, () => this.editor.deleteText(t, r), a, t, -1 * r);
  }
  disable() {
    this.enable(!1);
  }
  editReadOnly(t) {
    this.allowReadOnlyEdits = !0;
    const r = t();
    return this.allowReadOnlyEdits = !1, r;
  }
  enable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.scroll.enable(t), this.container.classList.toggle("ql-disabled", !t);
  }
  focus() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.selection.focus(), t.preventScroll || this.scrollSelectionIntoView();
  }
  format(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ot.sources.API;
    return In.call(this, () => {
      const n = this.getSelection(!0);
      let i = new ft();
      if (n == null)
        return i;
      if (this.scroll.query(t, vt.BLOCK))
        i = this.editor.formatLine(n.index, n.length, {
          [t]: r
        });
      else {
        if (n.length === 0)
          return this.selection.format(t, r), i;
        i = this.editor.formatText(n.index, n.length, {
          [t]: r
        });
      }
      return this.setSelection(n, ot.sources.SILENT), i;
    }, a);
  }
  formatLine(t, r, a, n, i) {
    let s;
    return [t, r, s, i] = _i(
      t,
      r,
      // @ts-expect-error
      a,
      n,
      i
    ), In.call(this, () => this.editor.formatLine(t, r, s), i, t, 0);
  }
  formatText(t, r, a, n, i) {
    let s;
    return [t, r, s, i] = _i(
      // @ts-expect-error
      t,
      r,
      a,
      n,
      i
    ), In.call(this, () => this.editor.formatText(t, r, s), i, t, 0);
  }
  getBounds(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = null;
    if (typeof t == "number" ? a = this.selection.getBounds(t, r) : a = this.selection.getBounds(t.index, t.length), !a)
      return null;
    const n = this.container.getBoundingClientRect();
    return {
      bottom: a.bottom - n.top,
      height: a.height,
      left: a.left - n.left,
      right: a.right - n.left,
      top: a.top - n.top,
      width: a.width
    };
  }
  getContents() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - t;
    return [t, r] = _i(t, r), this.editor.getContents(t, r);
  }
  getFormat() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(!0), r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return typeof t == "number" ? this.editor.getFormat(t, r) : this.editor.getFormat(t.index, t.length);
  }
  getIndex(t) {
    return t.offset(this.scroll);
  }
  getLength() {
    return this.scroll.length();
  }
  getLeaf(t) {
    return this.scroll.leaf(t);
  }
  getLine(t) {
    return this.scroll.line(t);
  }
  getLines() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    return typeof t != "number" ? this.scroll.lines(t.index, t.length) : this.scroll.lines(t, r);
  }
  getModule(t) {
    return this.theme.modules[t];
  }
  getSelection() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) && this.focus(), this.update(), this.selection.getRange()[0];
  }
  getSemanticHTML() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 ? arguments[1] : void 0;
    return typeof t == "number" && (r = r ?? this.getLength() - t), [t, r] = _i(t, r), this.editor.getHTML(t, r);
  }
  getText() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 ? arguments[1] : void 0;
    return typeof t == "number" && (r = r ?? this.getLength() - t), [t, r] = _i(t, r), this.editor.getText(t, r);
  }
  hasFocus() {
    return this.selection.hasFocus();
  }
  insertEmbed(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Nn.sources.API;
    return In.call(this, () => this.editor.insertEmbed(t, r, a), n, t);
  }
  insertText(t, r, a, n, i) {
    let s;
    return [t, , s, i] = _i(t, 0, a, n, i), In.call(this, () => this.editor.insertText(t, r, s), i, t, r.length);
  }
  isEnabled() {
    return this.scroll.isEnabled();
  }
  off() {
    return this.emitter.off(...arguments);
  }
  on() {
    return this.emitter.on(...arguments);
  }
  once() {
    return this.emitter.once(...arguments);
  }
  removeFormat(t, r, a) {
    return [t, r, , a] = _i(t, r, a), In.call(this, () => this.editor.removeFormat(t, r), a, t);
  }
  scrollRectIntoView(t) {
    oie(this.root, t);
  }
  /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */
  scrollIntoView() {
    console.warn("Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead."), this.scrollSelectionIntoView();
  }
  /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */
  scrollSelectionIntoView() {
    const t = this.selection.lastRange, r = t && this.selection.getBounds(t.index, t.length);
    r && this.scrollRectIntoView(r);
  }
  setContents(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ot.sources.API;
    return In.call(this, () => {
      t = new ft(t);
      const a = this.getLength(), n = this.editor.deleteText(0, a), i = this.editor.insertContents(0, t), s = this.editor.deleteText(this.getLength() - 1, 1);
      return n.compose(i).compose(s);
    }, r);
  }
  setSelection(t, r, a) {
    t == null ? this.selection.setRange(null, r || Nn.sources.API) : ([t, r, , a] = _i(t, r, a), this.selection.setRange(new Is(Math.max(0, t), r), a), a !== ot.sources.SILENT && this.scrollSelectionIntoView());
  }
  setText(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ot.sources.API;
    const a = new ft().insert(t);
    return this.setContents(a, r);
  }
  update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ot.sources.USER;
    const r = this.scroll.update(t);
    return this.selection.update(t), r;
  }
  updateContents(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ot.sources.API;
    return In.call(this, () => (t = new ft(t), this.editor.applyDelta(t)), r, !0);
  }
};
it(Nn, "DEFAULTS", {
  bounds: null,
  modules: {
    clipboard: !0,
    keyboard: !0,
    history: !0,
    uploader: !0
  },
  placeholder: "",
  readOnly: !1,
  registry: Zu,
  theme: "default"
}), it(Nn, "events", ot.events), it(Nn, "sources", ot.sources), it(Nn, "version", "2.0.3"), it(Nn, "imports", {
  delta: ft,
  parchment: $ne,
  "core/module": Wn,
  "core/theme": So
});
let De = Nn;
function Lw(e) {
  return typeof e == "string" ? document.querySelector(e) : e;
}
function fp(e) {
  return Object.entries(e ?? {}).reduce((t, r) => {
    let [a, n] = r;
    return {
      ...t,
      [a]: n === !0 ? {} : n
    };
  }, {});
}
function Rw(e) {
  return Object.fromEntries(Object.entries(e).filter((t) => t[1] !== void 0));
}
function cie(e, t) {
  const r = Lw(e);
  if (!r)
    throw new Error("Invalid Quill container");
  const n = !t.theme || t.theme === De.DEFAULTS.theme ? So : De.import(`themes/${t.theme}`);
  if (!n)
    throw new Error(`Invalid theme ${t.theme}. Did you register it?`);
  const {
    modules: i,
    ...s
  } = De.DEFAULTS, {
    modules: o,
    ...l
  } = n.DEFAULTS;
  let u = fp(t.modules);
  u != null && u.toolbar && u.toolbar.constructor !== Object && (u = {
    ...u,
    toolbar: {
      container: u.toolbar
    }
  });
  const d = Qi({}, fp(i), fp(o), u), f = {
    ...s,
    ...Rw(l),
    ...Rw(t)
  };
  let c = t.registry;
  return c ? t.formats && vo.warn('Ignoring "formats" option because "registry" is specified') : c = t.formats ? die(t.formats, f.registry, vo) : f.registry, {
    ...f,
    registry: c,
    container: r,
    theme: n,
    modules: Object.entries(d).reduce((p, v) => {
      let [h, g] = v;
      if (!g)
        return p;
      const m = De.import(`modules/${h}`);
      return m == null ? (vo.error(`Cannot load ${h} module. Are you sure you registered it?`), p) : {
        ...p,
        // @ts-expect-error
        [h]: Qi({}, m.DEFAULTS || {}, g)
      };
    }, {}),
    bounds: Lw(f.bounds)
  };
}
function In(e, t, r, a) {
  if (!this.isEnabled() && t === ot.sources.USER && !this.allowReadOnlyEdits)
    return new ft();
  let n = r == null ? null : this.getSelection();
  const i = this.editor.delta, s = e();
  if (n != null && (r === !0 && (r = n.index), a == null ? n = jw(n, s, t) : a !== 0 && (n = jw(n, r, a, t)), this.setSelection(n, ot.sources.SILENT)), s.length() > 0) {
    const o = [ot.events.TEXT_CHANGE, s, i, t];
    this.emitter.emit(ot.events.EDITOR_CHANGE, ...o), t !== ot.sources.SILENT && this.emitter.emit(...o);
  }
  return s;
}
function _i(e, t, r, a, n) {
  let i = {};
  return typeof e.index == "number" && typeof e.length == "number" ? typeof t != "number" ? (n = a, a = r, r = t, t = e.length, e = e.index) : (t = e.length, e = e.index) : typeof t != "number" && (n = a, a = r, r = t, t = 0), typeof r == "object" ? (i = r, n = a) : typeof r == "string" && (a != null ? i[r] = a : n = r), n = n || ot.sources.API, [e, t, i, n];
}
function jw(e, t, r, a) {
  const n = typeof r == "number" ? r : 0;
  if (e == null)
    return null;
  let i, s;
  return t && typeof t.transformPosition == "function" ? [i, s] = [e.index, e.index + e.length].map((o) => (
    // @ts-expect-error -- TODO: add a better type guard around `index`
    t.transformPosition(o, a !== ot.sources.USER)
  )) : [i, s] = [e.index, e.index + e.length].map((o) => o < t || o === t && a === ot.sources.USER ? o : n >= 0 ? o + n : Math.max(t, o + n)), new Is(i, s - i);
}
class Ys extends sf {
}
function Fw(e) {
  return e instanceof ua || e instanceof hn;
}
function Bw(e) {
  return typeof e.updateContent == "function";
}
class lo extends uy {
  constructor(t, r, a) {
    let {
      emitter: n
    } = a;
    super(t, r), this.emitter = n, this.batch = !1, this.optimize(), this.enable(), this.domNode.addEventListener("dragstart", (i) => this.handleDragStart(i));
  }
  batchStart() {
    Array.isArray(this.batch) || (this.batch = []);
  }
  batchEnd() {
    if (!this.batch)
      return;
    const t = this.batch;
    this.batch = !1, this.update(t);
  }
  emitMount(t) {
    this.emitter.emit(ot.events.SCROLL_BLOT_MOUNT, t);
  }
  emitUnmount(t) {
    this.emitter.emit(ot.events.SCROLL_BLOT_UNMOUNT, t);
  }
  emitEmbedUpdate(t, r) {
    this.emitter.emit(ot.events.SCROLL_EMBED_UPDATE, t, r);
  }
  deleteAt(t, r) {
    const [a, n] = this.line(t), [i] = this.line(t + r);
    if (super.deleteAt(t, r), i != null && a !== i && n > 0) {
      if (a instanceof hn || i instanceof hn) {
        this.optimize();
        return;
      }
      const s = i.children.head instanceof Yn ? null : i.children.head;
      a.moveChildren(i, s), a.remove();
    }
    this.optimize();
  }
  enable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.domNode.setAttribute("contenteditable", t ? "true" : "false");
  }
  formatAt(t, r, a, n) {
    super.formatAt(t, r, a, n), this.optimize();
  }
  insertAt(t, r, a) {
    if (t >= this.length())
      if (a == null || this.scroll.query(r, vt.BLOCK) == null) {
        const n = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(n), a == null && r.endsWith(`
`) ? n.insertAt(0, r.slice(0, -1), a) : n.insertAt(0, r, a);
      } else {
        const n = this.scroll.create(r, a);
        this.appendChild(n);
      }
    else
      super.insertAt(t, r, a);
    this.optimize();
  }
  insertBefore(t, r) {
    if (t.statics.scope === vt.INLINE_BLOT) {
      const a = this.scroll.create(this.statics.defaultChild.blotName);
      a.appendChild(t), super.insertBefore(a, r);
    } else
      super.insertBefore(t, r);
  }
  insertContents(t, r) {
    const a = this.deltaToRenderBlocks(r.concat(new ft().insert(`
`))), n = a.pop();
    if (n == null)
      return;
    this.batchStart();
    const i = a.shift();
    if (i) {
      const l = i.type === "block" && (i.delta.length() === 0 || !this.descendant(hn, t)[0] && t < this.length()), u = i.type === "block" ? i.delta : new ft().insert({
        [i.key]: i.value
      });
      pp(this, t, u);
      const d = i.type === "block" ? 1 : 0, f = t + u.length() + d;
      l && this.insertAt(f - 1, `
`);
      const c = fn(this.line(t)[0]), p = bn.AttributeMap.diff(c, i.attributes) || {};
      Object.keys(p).forEach((v) => {
        this.formatAt(f - 1, 1, v, p[v]);
      }), t = f;
    }
    let [s, o] = this.children.find(t);
    if (a.length && (s && (s = s.split(o), o = 0), a.forEach((l) => {
      if (l.type === "block") {
        const u = this.createBlock(l.attributes, s || void 0);
        pp(u, 0, l.delta);
      } else {
        const u = this.create(l.key, l.value);
        this.insertBefore(u, s || void 0), Object.keys(l.attributes).forEach((d) => {
          u.format(d, l.attributes[d]);
        });
      }
    })), n.type === "block" && n.delta.length()) {
      const l = s ? s.offset(s.scroll) + o : this.length();
      pp(this, l, n.delta);
    }
    this.batchEnd(), this.optimize();
  }
  isEnabled() {
    return this.domNode.getAttribute("contenteditable") === "true";
  }
  leaf(t) {
    const r = this.path(t).pop();
    if (!r)
      return [null, -1];
    const [a, n] = r;
    return a instanceof ma ? [a, n] : [null, -1];
  }
  line(t) {
    return t === this.length() ? this.line(t - 1) : this.descendant(Fw, t);
  }
  lines() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    const a = (n, i, s) => {
      let o = [], l = s;
      return n.children.forEachAt(i, s, (u, d, f) => {
        Fw(u) ? o.push(u) : u instanceof sf && (o = o.concat(a(u, d, l))), l -= f;
      }), o;
    };
    return a(this, t, r);
  }
  optimize() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.batch || (super.optimize(t, r), t.length > 0 && this.emitter.emit(ot.events.SCROLL_OPTIMIZE, t, r));
  }
  path(t) {
    return super.path(t).slice(1);
  }
  remove() {
  }
  update(t) {
    if (this.batch) {
      Array.isArray(t) && (this.batch = this.batch.concat(t));
      return;
    }
    let r = ot.sources.USER;
    typeof t == "string" && (r = t), Array.isArray(t) || (t = this.observer.takeRecords()), t = t.filter((a) => {
      let {
        target: n
      } = a;
      const i = this.find(n, !0);
      return i && !Bw(i);
    }), t.length > 0 && this.emitter.emit(ot.events.SCROLL_BEFORE_UPDATE, r, t), super.update(t.concat([])), t.length > 0 && this.emitter.emit(ot.events.SCROLL_UPDATE, r, t);
  }
  updateEmbedAt(t, r, a) {
    const [n] = this.descendant((i) => i instanceof hn, t);
    n && n.statics.blotName === r && Bw(n) && n.updateContent(a);
  }
  handleDragStart(t) {
    t.preventDefault();
  }
  deltaToRenderBlocks(t) {
    const r = [];
    let a = new ft();
    return t.forEach((n) => {
      const i = n == null ? void 0 : n.insert;
      if (i)
        if (typeof i == "string") {
          const s = i.split(`
`);
          s.slice(0, -1).forEach((l) => {
            a.insert(l, n.attributes), r.push({
              type: "block",
              delta: a,
              attributes: n.attributes ?? {}
            }), a = new ft();
          });
          const o = s[s.length - 1];
          o && a.insert(o, n.attributes);
        } else {
          const s = Object.keys(i)[0];
          if (!s)
            return;
          this.query(s, vt.INLINE) ? a.push(n) : (a.length() && r.push({
            type: "block",
            delta: a,
            attributes: {}
          }), a = new ft(), r.push({
            type: "blockEmbed",
            key: s,
            value: i[s],
            attributes: n.attributes ?? {}
          }));
        }
    }), a.length() && r.push({
      type: "block",
      delta: a,
      attributes: {}
    }), r;
  }
  createBlock(t, r) {
    let a;
    const n = {};
    Object.entries(t).forEach((o) => {
      let [l, u] = o;
      this.query(l, vt.BLOCK & vt.BLOT) != null ? a = l : n[l] = u;
    });
    const i = this.create(a || this.statics.defaultChild.blotName, a ? t[a] : void 0);
    this.insertBefore(i, r || void 0);
    const s = i.length();
    return Object.entries(n).forEach((o) => {
      let [l, u] = o;
      i.formatAt(0, s, l, u);
    }), i;
  }
}
it(lo, "blotName", "scroll"), it(lo, "className", "ql-editor"), it(lo, "tagName", "DIV"), it(lo, "defaultChild", ua), it(lo, "allowedChildren", [ua, hn, Ys]);
function pp(e, t, r) {
  r.reduce((a, n) => {
    const i = bn.Op.length(n);
    let s = n.attributes || {};
    if (n.insert != null) {
      if (typeof n.insert == "string") {
        const o = n.insert;
        e.insertAt(a, o);
        const [l] = e.descendant(ma, a), u = fn(l);
        s = bn.AttributeMap.diff(u, s) || {};
      } else if (typeof n.insert == "object") {
        const o = Object.keys(n.insert)[0];
        if (o == null)
          return a;
        if (e.insertAt(a, o, n.insert[o]), e.scroll.query(o, vt.INLINE) != null) {
          const [u] = e.descendant(ma, a), d = fn(u);
          s = bn.AttributeMap.diff(d, s) || {};
        }
      }
    }
    return Object.keys(s).forEach((o) => {
      e.formatAt(a, i, o, s[o]);
    }), a + i;
  }, t);
}
const my = {
  scope: vt.BLOCK,
  whitelist: ["right", "center", "justify"]
}, fie = new ui("align", "align", my), Q3 = new zn("align", "ql-align", my), Z3 = new hs("align", "text-align", my);
class eC extends hs {
  value(t) {
    let r = super.value(t);
    return r.startsWith("rgb(") ? (r = r.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), `#${r.split(",").map((n) => `00${parseInt(n, 10).toString(16)}`.slice(-2)).join("")}`) : r;
  }
}
const pie = new zn("color", "ql-color", {
  scope: vt.INLINE
}), hy = new eC("color", "color", {
  scope: vt.INLINE
}), vie = new zn("background", "ql-bg", {
  scope: vt.INLINE
}), gy = new eC("background", "background-color", {
  scope: vt.INLINE
});
class Ws extends Ys {
  static create(t) {
    const r = super.create(t);
    return r.setAttribute("spellcheck", "false"), r;
  }
  code(t, r) {
    return this.children.map((a) => a.length() <= 1 ? "" : a.domNode.innerText).join(`
`).slice(t, t + r);
  }
  html(t, r) {
    return `<pre>
${df(this.code(t, r))}
</pre>`;
  }
}
class ya extends ua {
  static register() {
    De.register(Ws);
  }
}
it(ya, "TAB", "  ");
class by extends di {
}
by.blotName = "code";
by.tagName = "CODE";
ya.blotName = "code-block";
ya.className = "ql-code-block";
ya.tagName = "DIV";
Ws.blotName = "code-block-container";
Ws.className = "ql-code-block-container";
Ws.tagName = "DIV";
Ws.allowedChildren = [ya];
ya.allowedChildren = [qn, Yn, To];
ya.requiredContainer = Ws;
const yy = {
  scope: vt.BLOCK,
  whitelist: ["rtl"]
}, tC = new ui("direction", "dir", yy), rC = new zn("direction", "ql-direction", yy), aC = new hs("direction", "direction", yy), nC = {
  scope: vt.INLINE,
  whitelist: ["serif", "monospace"]
}, iC = new zn("font", "ql-font", nC);
class mie extends hs {
  value(t) {
    return super.value(t).replace(/["']/g, "");
  }
}
const sC = new mie("font", "font-family", nC), oC = new zn("size", "ql-size", {
  scope: vt.INLINE,
  whitelist: ["small", "large", "huge"]
}), lC = new hs("size", "font-size", {
  scope: vt.INLINE,
  whitelist: ["10px", "18px", "32px"]
}), hie = Fi("quill:keyboard"), gie = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
class cf extends Wn {
  static match(t, r) {
    return ["altKey", "ctrlKey", "metaKey", "shiftKey"].some((a) => !!r[a] !== t[a] && r[a] !== null) ? !1 : r.key === t.key || r.key === t.which;
  }
  constructor(t, r) {
    super(t, r), this.bindings = {}, Object.keys(this.options.bindings).forEach((a) => {
      this.options.bindings[a] && this.addBinding(this.options.bindings[a]);
    }), this.addBinding({
      key: "Enter",
      shiftKey: null
    }, this.handleEnter), this.addBinding({
      key: "Enter",
      metaKey: null,
      ctrlKey: null,
      altKey: null
    }, () => {
    }), /Firefox/i.test(navigator.userAgent) ? (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0
    }, this.handleDelete)) : (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0,
      prefix: /^.?$/
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0,
      suffix: /^.?$/
    }, this.handleDelete)), this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Backspace",
      altKey: null,
      ctrlKey: null,
      metaKey: null,
      shiftKey: null
    }, {
      collapsed: !0,
      offset: 0
    }, this.handleBackspace), this.listen();
  }
  addBinding(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const n = yie(t);
    if (n == null) {
      hie.warn("Attempted to add invalid keyboard binding", n);
      return;
    }
    typeof r == "function" && (r = {
      handler: r
    }), typeof a == "function" && (a = {
      handler: a
    }), (Array.isArray(n.key) ? n.key : [n.key]).forEach((s) => {
      const o = {
        ...n,
        key: s,
        ...r,
        ...a
      };
      this.bindings[o.key] = this.bindings[o.key] || [], this.bindings[o.key].push(o);
    });
  }
  listen() {
    this.quill.root.addEventListener("keydown", (t) => {
      if (t.defaultPrevented || t.isComposing || t.keyCode === 229 && (t.key === "Enter" || t.key === "Backspace"))
        return;
      const n = (this.bindings[t.key] || []).concat(this.bindings[t.which] || []).filter((m) => cf.match(t, m));
      if (n.length === 0)
        return;
      const i = De.find(t.target, !0);
      if (i && i.scroll !== this.quill.scroll)
        return;
      const s = this.quill.getSelection();
      if (s == null || !this.quill.hasFocus())
        return;
      const [o, l] = this.quill.getLine(s.index), [u, d] = this.quill.getLeaf(s.index), [f, c] = s.length === 0 ? [u, d] : this.quill.getLeaf(s.index + s.length), p = u instanceof Dd ? u.value().slice(0, d) : "", v = f instanceof Dd ? f.value().slice(c) : "", h = {
        collapsed: s.length === 0,
        // @ts-expect-error Fix me later
        empty: s.length === 0 && o.length() <= 1,
        format: this.quill.getFormat(s),
        line: o,
        offset: l,
        prefix: p,
        suffix: v,
        event: t
      };
      n.some((m) => {
        if (m.collapsed != null && m.collapsed !== h.collapsed || m.empty != null && m.empty !== h.empty || m.offset != null && m.offset !== h.offset)
          return !1;
        if (Array.isArray(m.format)) {
          if (m.format.every((b) => h.format[b] == null))
            return !1;
        } else if (typeof m.format == "object" && !Object.keys(m.format).every((b) => m.format[b] === !0 ? h.format[b] != null : m.format[b] === !1 ? h.format[b] == null : oy(m.format[b], h.format[b])))
          return !1;
        return m.prefix != null && !m.prefix.test(h.prefix) || m.suffix != null && !m.suffix.test(h.suffix) ? !1 : m.handler.call(this, s, h, m) !== !0;
      }) && t.preventDefault();
    });
  }
  handleBackspace(t, r) {
    const a = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(r.prefix) ? 2 : 1;
    if (t.index === 0 || this.quill.getLength() <= 1)
      return;
    let n = {};
    const [i] = this.quill.getLine(t.index);
    let s = new ft().retain(t.index - a).delete(a);
    if (r.offset === 0) {
      const [o] = this.quill.getLine(t.index - 1);
      if (o && !(o.statics.blotName === "block" && o.length() <= 1)) {
        const u = i.formats(), d = this.quill.getFormat(t.index - 1, 1);
        if (n = bn.AttributeMap.diff(u, d) || {}, Object.keys(n).length > 0) {
          const f = new ft().retain(t.index + i.length() - 2).retain(1, n);
          s = s.compose(f);
        }
      }
    }
    this.quill.updateContents(s, De.sources.USER), this.quill.focus();
  }
  handleDelete(t, r) {
    const a = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(r.suffix) ? 2 : 1;
    if (t.index >= this.quill.getLength() - a)
      return;
    let n = {};
    const [i] = this.quill.getLine(t.index);
    let s = new ft().retain(t.index).delete(a);
    if (r.offset >= i.length() - 1) {
      const [o] = this.quill.getLine(t.index + 1);
      if (o) {
        const l = i.formats(), u = this.quill.getFormat(t.index, 1);
        n = bn.AttributeMap.diff(l, u) || {}, Object.keys(n).length > 0 && (s = s.retain(o.length() - 1).retain(1, n));
      }
    }
    this.quill.updateContents(s, De.sources.USER), this.quill.focus();
  }
  handleDeleteRange(t) {
    _y({
      range: t,
      quill: this.quill
    }), this.quill.focus();
  }
  handleEnter(t, r) {
    const a = Object.keys(r.format).reduce((i, s) => (this.quill.scroll.query(s, vt.BLOCK) && !Array.isArray(r.format[s]) && (i[s] = r.format[s]), i), {}), n = new ft().retain(t.index).delete(t.length).insert(`
`, a);
    this.quill.updateContents(n, De.sources.USER), this.quill.setSelection(t.index + 1, De.sources.SILENT), this.quill.focus();
  }
}
const bie = {
  bindings: {
    bold: vp("bold"),
    italic: vp("italic"),
    underline: vp("underline"),
    indent: {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: "Tab",
      format: ["blockquote", "indent", "list"],
      handler(e, t) {
        return t.collapsed && t.offset !== 0 ? !0 : (this.quill.format("indent", "+1", De.sources.USER), !1);
      }
    },
    outdent: {
      key: "Tab",
      shiftKey: !0,
      format: ["blockquote", "indent", "list"],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler(e, t) {
        return t.collapsed && t.offset !== 0 ? !0 : (this.quill.format("indent", "-1", De.sources.USER), !1);
      }
    },
    "outdent backspace": {
      key: "Backspace",
      collapsed: !0,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ["indent", "list"],
      offset: 0,
      handler(e, t) {
        t.format.indent != null ? this.quill.format("indent", "-1", De.sources.USER) : t.format.list != null && this.quill.format("list", !1, De.sources.USER);
      }
    },
    "indent code-block": qw(!0),
    "outdent code-block": qw(!1),
    "remove tab": {
      key: "Tab",
      shiftKey: !0,
      collapsed: !0,
      prefix: /\t$/,
      handler(e) {
        this.quill.deleteText(e.index - 1, 1, De.sources.USER);
      }
    },
    tab: {
      key: "Tab",
      handler(e, t) {
        if (t.format.table)
          return !0;
        this.quill.history.cutoff();
        const r = new ft().retain(e.index).delete(e.length).insert("	");
        return this.quill.updateContents(r, De.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(e.index + 1, De.sources.SILENT), !1;
      }
    },
    "blockquote empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["blockquote"],
      empty: !0,
      handler() {
        this.quill.format("blockquote", !1, De.sources.USER);
      }
    },
    "list empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["list"],
      empty: !0,
      handler(e, t) {
        const r = {
          list: !1
        };
        t.format.indent && (r.indent = !1), this.quill.formatLine(e.index, e.length, r, De.sources.USER);
      }
    },
    "checklist enter": {
      key: "Enter",
      collapsed: !0,
      format: {
        list: "checked"
      },
      handler(e) {
        const [t, r] = this.quill.getLine(e.index), a = {
          // @ts-expect-error Fix me later
          ...t.formats(),
          list: "checked"
        }, n = new ft().retain(e.index).insert(`
`, a).retain(t.length() - r - 1).retain(1, {
          list: "unchecked"
        });
        this.quill.updateContents(n, De.sources.USER), this.quill.setSelection(e.index + 1, De.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "header enter": {
      key: "Enter",
      collapsed: !0,
      format: ["header"],
      suffix: /^$/,
      handler(e, t) {
        const [r, a] = this.quill.getLine(e.index), n = new ft().retain(e.index).insert(`
`, t.format).retain(r.length() - a - 1).retain(1, {
          header: null
        });
        this.quill.updateContents(n, De.sources.USER), this.quill.setSelection(e.index + 1, De.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "table backspace": {
      key: "Backspace",
      format: ["table"],
      collapsed: !0,
      offset: 0,
      handler() {
      }
    },
    "table delete": {
      key: "Delete",
      format: ["table"],
      collapsed: !0,
      suffix: /^$/,
      handler() {
      }
    },
    "table enter": {
      key: "Enter",
      shiftKey: null,
      format: ["table"],
      handler(e) {
        const t = this.quill.getModule("table");
        if (t) {
          const [r, a, n, i] = t.getTable(e), s = _ie(r, a, n, i);
          if (s == null)
            return;
          let o = r.offset();
          if (s < 0) {
            const l = new ft().retain(o).insert(`
`);
            this.quill.updateContents(l, De.sources.USER), this.quill.setSelection(e.index + 1, e.length, De.sources.SILENT);
          } else if (s > 0) {
            o += r.length();
            const l = new ft().retain(o).insert(`
`);
            this.quill.updateContents(l, De.sources.USER), this.quill.setSelection(o, De.sources.USER);
          }
        }
      }
    },
    "table tab": {
      key: "Tab",
      shiftKey: null,
      format: ["table"],
      handler(e, t) {
        const {
          event: r,
          line: a
        } = t, n = a.offset(this.quill.scroll);
        r.shiftKey ? this.quill.setSelection(n - 1, De.sources.USER) : this.quill.setSelection(n + a.length(), De.sources.USER);
      }
    },
    "list autofill": {
      key: " ",
      shiftKey: null,
      collapsed: !0,
      format: {
        "code-block": !1,
        blockquote: !1,
        table: !1
      },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler(e, t) {
        if (this.quill.scroll.query("list") == null)
          return !0;
        const {
          length: r
        } = t.prefix, [a, n] = this.quill.getLine(e.index);
        if (n > r)
          return !0;
        let i;
        switch (t.prefix.trim()) {
          case "[]":
          case "[ ]":
            i = "unchecked";
            break;
          case "[x]":
            i = "checked";
            break;
          case "-":
          case "*":
            i = "bullet";
            break;
          default:
            i = "ordered";
        }
        this.quill.insertText(e.index, " ", De.sources.USER), this.quill.history.cutoff();
        const s = new ft().retain(e.index - n).delete(r + 1).retain(a.length() - 2 - n).retain(1, {
          list: i
        });
        return this.quill.updateContents(s, De.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(e.index - r, De.sources.SILENT), !1;
      }
    },
    "code exit": {
      key: "Enter",
      collapsed: !0,
      format: ["code-block"],
      prefix: /^$/,
      suffix: /^\s*$/,
      handler(e) {
        const [t, r] = this.quill.getLine(e.index);
        let a = 2, n = t;
        for (; n != null && n.length() <= 1 && n.formats()["code-block"]; )
          if (n = n.prev, a -= 1, a <= 0) {
            const i = new ft().retain(e.index + t.length() - r - 2).retain(1, {
              "code-block": null
            }).delete(1);
            return this.quill.updateContents(i, De.sources.USER), this.quill.setSelection(e.index - 1, De.sources.SILENT), !1;
          }
        return !0;
      }
    },
    "embed left": ed("ArrowLeft", !1),
    "embed left shift": ed("ArrowLeft", !0),
    "embed right": ed("ArrowRight", !1),
    "embed right shift": ed("ArrowRight", !0),
    "table down": Hw(!1),
    "table up": Hw(!0)
  }
};
cf.DEFAULTS = bie;
function qw(e) {
  return {
    key: "Tab",
    shiftKey: !e,
    format: {
      "code-block": !0
    },
    handler(t, r) {
      let {
        event: a
      } = r;
      const n = this.quill.scroll.query("code-block"), {
        TAB: i
      } = n;
      if (t.length === 0 && !a.shiftKey) {
        this.quill.insertText(t.index, i, De.sources.USER), this.quill.setSelection(t.index + i.length, De.sources.SILENT);
        return;
      }
      const s = t.length === 0 ? this.quill.getLines(t.index, 1) : this.quill.getLines(t);
      let {
        index: o,
        length: l
      } = t;
      s.forEach((u, d) => {
        e ? (u.insertAt(0, i), d === 0 ? o += i.length : l += i.length) : u.domNode.textContent.startsWith(i) && (u.deleteAt(0, i.length), d === 0 ? o -= i.length : l -= i.length);
      }), this.quill.update(De.sources.USER), this.quill.setSelection(o, l, De.sources.SILENT);
    }
  };
}
function ed(e, t) {
  return {
    key: e,
    shiftKey: t,
    altKey: null,
    [e === "ArrowLeft" ? "prefix" : "suffix"]: /^$/,
    handler(a) {
      let {
        index: n
      } = a;
      e === "ArrowRight" && (n += a.length + 1);
      const [i] = this.quill.getLeaf(n);
      return i instanceof tn ? (e === "ArrowLeft" ? t ? this.quill.setSelection(a.index - 1, a.length + 1, De.sources.USER) : this.quill.setSelection(a.index - 1, De.sources.USER) : t ? this.quill.setSelection(a.index, a.length + 1, De.sources.USER) : this.quill.setSelection(a.index + a.length + 1, De.sources.USER), !1) : !0;
    }
  };
}
function vp(e) {
  return {
    key: e[0],
    shortKey: !0,
    handler(t, r) {
      this.quill.format(e, !r.format[e], De.sources.USER);
    }
  };
}
function Hw(e) {
  return {
    key: e ? "ArrowUp" : "ArrowDown",
    collapsed: !0,
    format: ["table"],
    handler(t, r) {
      const a = e ? "prev" : "next", n = r.line, i = n.parent[a];
      if (i != null) {
        if (i.statics.blotName === "table-row") {
          let s = i.children.head, o = n;
          for (; o.prev != null; )
            o = o.prev, s = s.next;
          const l = s.offset(this.quill.scroll) + Math.min(r.offset, s.length() - 1);
          this.quill.setSelection(l, 0, De.sources.USER);
        }
      } else {
        const s = n.table()[a];
        s != null && (e ? this.quill.setSelection(s.offset(this.quill.scroll) + s.length() - 1, 0, De.sources.USER) : this.quill.setSelection(s.offset(this.quill.scroll), 0, De.sources.USER));
      }
      return !1;
    }
  };
}
function yie(e) {
  if (typeof e == "string" || typeof e == "number")
    e = {
      key: e
    };
  else if (typeof e == "object")
    e = fo(e);
  else
    return null;
  return e.shortKey && (e[gie] = e.shortKey, delete e.shortKey), e;
}
function _y(e) {
  let {
    quill: t,
    range: r
  } = e;
  const a = t.getLines(r);
  let n = {};
  if (a.length > 1) {
    const i = a[0].formats(), s = a[a.length - 1].formats();
    n = bn.AttributeMap.diff(s, i) || {};
  }
  t.deleteText(r, De.sources.USER), Object.keys(n).length > 0 && t.formatLine(r.index, 1, n, De.sources.USER), t.setSelection(r.index, De.sources.SILENT);
}
function _ie(e, t, r, a) {
  return t.prev == null && t.next == null ? r.prev == null && r.next == null ? a === 0 ? -1 : 1 : r.prev == null ? -1 : 1 : t.prev == null ? -1 : t.next == null ? 1 : null;
}
const xie = /font-weight:\s*normal/, wie = ["P", "OL", "UL"], Vw = (e) => e && wie.includes(e.tagName), Tie = (e) => {
  Array.from(e.querySelectorAll("br")).filter((t) => Vw(t.previousElementSibling) && Vw(t.nextElementSibling)).forEach((t) => {
    var r;
    (r = t.parentNode) == null || r.removeChild(t);
  });
}, Sie = (e) => {
  Array.from(e.querySelectorAll('b[style*="font-weight"]')).filter((t) => {
    var r;
    return (r = t.getAttribute("style")) == null ? void 0 : r.match(xie);
  }).forEach((t) => {
    var a;
    const r = e.createDocumentFragment();
    r.append(...t.childNodes), (a = t.parentNode) == null || a.replaceChild(r, t);
  });
};
function Eie(e) {
  e.querySelector('[id^="docs-internal-guid-"]') && (Sie(e), Tie(e));
}
const Oie = /\bmso-list:[^;]*ignore/i, Cie = /\bmso-list:[^;]*\bl(\d+)/i, kie = /\bmso-list:[^;]*\blevel(\d+)/i, Pie = (e, t) => {
  const r = e.getAttribute("style"), a = r == null ? void 0 : r.match(Cie);
  if (!a)
    return null;
  const n = Number(a[1]), i = r == null ? void 0 : r.match(kie), s = i ? Number(i[1]) : 1, o = new RegExp(`@list l${n}:level${s}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i"), l = t.match(o), u = l && l[1] === "bullet" ? "bullet" : "ordered";
  return {
    id: n,
    indent: s,
    type: u,
    element: e
  };
}, Mie = (e) => {
  var s, o;
  const t = Array.from(e.querySelectorAll("[style*=mso-list]")), r = [], a = [];
  t.forEach((l) => {
    (l.getAttribute("style") || "").match(Oie) ? r.push(l) : a.push(l);
  }), r.forEach((l) => {
    var u;
    return (u = l.parentNode) == null ? void 0 : u.removeChild(l);
  });
  const n = e.documentElement.innerHTML, i = a.map((l) => Pie(l, n)).filter((l) => l);
  for (; i.length; ) {
    const l = [];
    let u = i.shift();
    for (; u; )
      l.push(u), u = i.length && ((s = i[0]) == null ? void 0 : s.element) === u.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
      i[0].id === u.id ? i.shift() : null;
    const d = document.createElement("ul");
    l.forEach((p) => {
      const v = document.createElement("li");
      v.setAttribute("data-list", p.type), p.indent > 1 && v.setAttribute("class", `ql-indent-${p.indent - 1}`), v.innerHTML = p.element.innerHTML, d.appendChild(v);
    });
    const f = (o = l[0]) == null ? void 0 : o.element, {
      parentNode: c
    } = f ?? {};
    f && (c == null || c.replaceChild(d, f)), l.slice(1).forEach((p) => {
      let {
        element: v
      } = p;
      c == null || c.removeChild(v);
    });
  }
};
function Aie(e) {
  e.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word" && Mie(e);
}
const Die = [Aie, Eie], Iie = (e) => {
  e.documentElement && Die.forEach((t) => {
    t(e);
  });
}, Nie = Fi("quill:clipboard"), $ie = [[Node.TEXT_NODE, Wie], [Node.TEXT_NODE, zw], ["br", Bie], [Node.ELEMENT_NODE, zw], [Node.ELEMENT_NODE, Fie], [Node.ELEMENT_NODE, jie], [Node.ELEMENT_NODE, zie], ["li", Vie], ["ol, ul", Uie], ["pre", qie], ["tr", Yie], ["b", mp("bold")], ["i", mp("italic")], ["strike", mp("strike")], ["style", Hie]], Lie = [fie, tC].reduce((e, t) => (e[t.keyName] = t, e), {}), Uw = [Z3, gy, hy, aC, sC, lC].reduce((e, t) => (e[t.keyName] = t, e), {});
class uC extends Wn {
  constructor(t, r) {
    super(t, r), this.quill.root.addEventListener("copy", (a) => this.onCaptureCopy(a, !1)), this.quill.root.addEventListener("cut", (a) => this.onCaptureCopy(a, !0)), this.quill.root.addEventListener("paste", this.onCapturePaste.bind(this)), this.matchers = [], $ie.concat(this.options.matchers ?? []).forEach((a) => {
      let [n, i] = a;
      this.addMatcher(n, i);
    });
  }
  addMatcher(t, r) {
    this.matchers.push([t, r]);
  }
  convert(t) {
    let {
      html: r,
      text: a
    } = t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (n[ya.blotName])
      return new ft().insert(a || "", {
        [ya.blotName]: n[ya.blotName]
      });
    if (!r)
      return new ft().insert(a || "", n);
    const i = this.convertHTML(r);
    return Iu(i, `
`) && (i.ops[i.ops.length - 1].attributes == null || n.table) ? i.compose(new ft().retain(i.length() - 1).delete(1)) : i;
  }
  normalizeHTML(t) {
    Iie(t);
  }
  convertHTML(t) {
    const r = new DOMParser().parseFromString(t, "text/html");
    this.normalizeHTML(r);
    const a = r.body, n = /* @__PURE__ */ new WeakMap(), [i, s] = this.prepareMatching(a, n);
    return xy(this.quill.scroll, a, i, s, n);
  }
  dangerouslyPasteHTML(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : De.sources.API;
    if (typeof t == "string") {
      const n = this.convert({
        html: t,
        text: ""
      });
      this.quill.setContents(n, r), this.quill.setSelection(0, De.sources.SILENT);
    } else {
      const n = this.convert({
        html: r,
        text: ""
      });
      this.quill.updateContents(new ft().retain(t).concat(n), a), this.quill.setSelection(t + n.length(), De.sources.SILENT);
    }
  }
  onCaptureCopy(t) {
    var s, o;
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (t.defaultPrevented)
      return;
    t.preventDefault();
    const [a] = this.quill.selection.getRange();
    if (a == null)
      return;
    const {
      html: n,
      text: i
    } = this.onCopy(a, r);
    (s = t.clipboardData) == null || s.setData("text/plain", i), (o = t.clipboardData) == null || o.setData("text/html", n), r && _y({
      range: a,
      quill: this.quill
    });
  }
  /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */
  normalizeURIList(t) {
    return t.split(/\r?\n/).filter((r) => r[0] !== "#").join(`
`);
  }
  onCapturePaste(t) {
    var s, o, l, u, d;
    if (t.defaultPrevented || !this.quill.isEnabled())
      return;
    t.preventDefault();
    const r = this.quill.getSelection(!0);
    if (r == null)
      return;
    const a = (s = t.clipboardData) == null ? void 0 : s.getData("text/html");
    let n = (o = t.clipboardData) == null ? void 0 : o.getData("text/plain");
    if (!a && !n) {
      const f = (l = t.clipboardData) == null ? void 0 : l.getData("text/uri-list");
      f && (n = this.normalizeURIList(f));
    }
    const i = Array.from(((u = t.clipboardData) == null ? void 0 : u.files) || []);
    if (!a && i.length > 0) {
      this.quill.uploader.upload(r, i);
      return;
    }
    if (a && i.length > 0) {
      const f = new DOMParser().parseFromString(a, "text/html");
      if (f.body.childElementCount === 1 && ((d = f.body.firstElementChild) == null ? void 0 : d.tagName) === "IMG") {
        this.quill.uploader.upload(r, i);
        return;
      }
    }
    this.onPaste(r, {
      html: a,
      text: n
    });
  }
  onCopy(t) {
    const r = this.quill.getText(t);
    return {
      html: this.quill.getSemanticHTML(t),
      text: r
    };
  }
  onPaste(t, r) {
    let {
      text: a,
      html: n
    } = r;
    const i = this.quill.getFormat(t.index), s = this.convert({
      text: a,
      html: n
    }, i);
    Nie.log("onPaste", s, {
      text: a,
      html: n
    });
    const o = new ft().retain(t.index).delete(t.length).concat(s);
    this.quill.updateContents(o, De.sources.USER), this.quill.setSelection(o.length() - t.length, De.sources.SILENT), this.quill.scrollSelectionIntoView();
  }
  prepareMatching(t, r) {
    const a = [], n = [];
    return this.matchers.forEach((i) => {
      const [s, o] = i;
      switch (s) {
        case Node.TEXT_NODE:
          n.push(o);
          break;
        case Node.ELEMENT_NODE:
          a.push(o);
          break;
        default:
          Array.from(t.querySelectorAll(s)).forEach((l) => {
            if (r.has(l)) {
              const u = r.get(l);
              u == null || u.push(o);
            } else
              r.set(l, [o]);
          });
          break;
      }
    }), [a, n];
  }
}
it(uC, "DEFAULTS", {
  matchers: []
});
function Gs(e, t, r, a) {
  return a.query(t) ? e.reduce((n, i) => {
    if (!i.insert)
      return n;
    if (i.attributes && i.attributes[t])
      return n.push(i);
    const s = r ? {
      [t]: r
    } : {};
    return n.insert(i.insert, {
      ...s,
      ...i.attributes
    });
  }, new ft()) : e;
}
function Iu(e, t) {
  let r = "";
  for (let a = e.ops.length - 1; a >= 0 && r.length < t.length; --a) {
    const n = e.ops[a];
    if (typeof n.insert != "string")
      break;
    r = n.insert + r;
  }
  return r.slice(-1 * t.length) === t;
}
function Gi(e, t) {
  if (!(e instanceof Element))
    return !1;
  const r = t.query(e);
  return r && r.prototype instanceof tn ? !1 : ["address", "article", "blockquote", "canvas", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "iframe", "li", "main", "nav", "ol", "output", "p", "pre", "section", "table", "td", "tr", "ul", "video"].includes(e.tagName.toLowerCase());
}
function Rie(e, t) {
  return e.previousElementSibling && e.nextElementSibling && !Gi(e.previousElementSibling, t) && !Gi(e.nextElementSibling, t);
}
const td = /* @__PURE__ */ new WeakMap();
function dC(e) {
  return e == null ? !1 : (td.has(e) || (e.tagName === "PRE" ? td.set(e, !0) : td.set(e, dC(e.parentNode))), td.get(e));
}
function xy(e, t, r, a, n) {
  return t.nodeType === t.TEXT_NODE ? a.reduce((i, s) => s(t, i, e), new ft()) : t.nodeType === t.ELEMENT_NODE ? Array.from(t.childNodes || []).reduce((i, s) => {
    let o = xy(e, s, r, a, n);
    return s.nodeType === t.ELEMENT_NODE && (o = r.reduce((l, u) => u(s, l, e), o), o = (n.get(s) || []).reduce((l, u) => u(s, l, e), o)), i.concat(o);
  }, new ft()) : new ft();
}
function mp(e) {
  return (t, r, a) => Gs(r, e, !0, a);
}
function jie(e, t, r) {
  const a = ui.keys(e), n = zn.keys(e), i = hs.keys(e), s = {};
  return a.concat(n).concat(i).forEach((o) => {
    let l = r.query(o, vt.ATTRIBUTE);
    l != null && (s[l.attrName] = l.value(e), s[l.attrName]) || (l = Lie[o], l != null && (l.attrName === o || l.keyName === o) && (s[l.attrName] = l.value(e) || void 0), l = Uw[o], l != null && (l.attrName === o || l.keyName === o) && (l = Uw[o], s[l.attrName] = l.value(e) || void 0));
  }), Object.entries(s).reduce((o, l) => {
    let [u, d] = l;
    return Gs(o, u, d, r);
  }, t);
}
function Fie(e, t, r) {
  const a = r.query(e);
  if (a == null)
    return t;
  if (a.prototype instanceof tn) {
    const n = {}, i = a.value(e);
    if (i != null)
      return n[a.blotName] = i, new ft().insert(n, a.formats(e, r));
  } else if (a.prototype instanceof au && !Iu(t, `
`) && t.insert(`
`), "blotName" in a && "formats" in a && typeof a.formats == "function")
    return Gs(t, a.blotName, a.formats(e, r), r);
  return t;
}
function Bie(e, t) {
  return Iu(t, `
`) || t.insert(`
`), t;
}
function qie(e, t, r) {
  const a = r.query("code-block"), n = a && "formats" in a && typeof a.formats == "function" ? a.formats(e, r) : !0;
  return Gs(t, "code-block", n, r);
}
function Hie() {
  return new ft();
}
function Vie(e, t, r) {
  const a = r.query(e);
  if (a == null || // @ts-expect-error
  a.blotName !== "list" || !Iu(t, `
`))
    return t;
  let n = -1, i = e.parentNode;
  for (; i != null; )
    ["OL", "UL"].includes(i.tagName) && (n += 1), i = i.parentNode;
  return n <= 0 ? t : t.reduce((s, o) => o.insert ? o.attributes && typeof o.attributes.indent == "number" ? s.push(o) : s.insert(o.insert, {
    indent: n,
    ...o.attributes || {}
  }) : s, new ft());
}
function Uie(e, t, r) {
  const a = e;
  let n = a.tagName === "OL" ? "ordered" : "bullet";
  const i = a.getAttribute("data-checked");
  return i && (n = i === "true" ? "checked" : "unchecked"), Gs(t, "list", n, r);
}
function zw(e, t, r) {
  if (!Iu(t, `
`)) {
    if (Gi(e, r) && (e.childNodes.length > 0 || e instanceof HTMLParagraphElement))
      return t.insert(`
`);
    if (t.length() > 0 && e.nextSibling) {
      let a = e.nextSibling;
      for (; a != null; ) {
        if (Gi(a, r))
          return t.insert(`
`);
        const n = r.query(a);
        if (n && n.prototype instanceof hn)
          return t.insert(`
`);
        a = a.firstChild;
      }
    }
  }
  return t;
}
function zie(e, t, r) {
  var i;
  const a = {}, n = e.style || {};
  return n.fontStyle === "italic" && (a.italic = !0), n.textDecoration === "underline" && (a.underline = !0), n.textDecoration === "line-through" && (a.strike = !0), ((i = n.fontWeight) != null && i.startsWith("bold") || // @ts-expect-error Fix me later
  parseInt(n.fontWeight, 10) >= 700) && (a.bold = !0), t = Object.entries(a).reduce((s, o) => {
    let [l, u] = o;
    return Gs(s, l, u, r);
  }, t), parseFloat(n.textIndent || 0) > 0 ? new ft().insert("	").concat(t) : t;
}
function Yie(e, t, r) {
  var n, i;
  const a = ((n = e.parentElement) == null ? void 0 : n.tagName) === "TABLE" ? e.parentElement : (i = e.parentElement) == null ? void 0 : i.parentElement;
  if (a != null) {
    const o = Array.from(a.querySelectorAll("tr")).indexOf(e) + 1;
    return Gs(t, "table", o, r);
  }
  return t;
}
function Wie(e, t, r) {
  var n;
  let a = e.data;
  if (((n = e.parentElement) == null ? void 0 : n.tagName) === "O:P")
    return t.insert(a.trim());
  if (!dC(e)) {
    if (a.trim().length === 0 && a.includes(`
`) && !Rie(e, r))
      return t;
    a = a.replace(/[^\S\u00a0]/g, " "), a = a.replace(/ {2,}/g, " "), (e.previousSibling == null && e.parentElement != null && Gi(e.parentElement, r) || e.previousSibling instanceof Element && Gi(e.previousSibling, r)) && (a = a.replace(/^ /, "")), (e.nextSibling == null && e.parentElement != null && Gi(e.parentElement, r) || e.nextSibling instanceof Element && Gi(e.nextSibling, r)) && (a = a.replace(/ $/, "")), a = a.replaceAll(" ", " ");
  }
  return t.insert(a);
}
class cC extends Wn {
  constructor(r, a) {
    super(r, a);
    it(this, "lastRecorded", 0);
    it(this, "ignoreChange", !1);
    it(this, "stack", {
      undo: [],
      redo: []
    });
    it(this, "currentRange", null);
    this.quill.on(De.events.EDITOR_CHANGE, (n, i, s, o) => {
      n === De.events.SELECTION_CHANGE ? i && o !== De.sources.SILENT && (this.currentRange = i) : n === De.events.TEXT_CHANGE && (this.ignoreChange || (!this.options.userOnly || o === De.sources.USER ? this.record(i, s) : this.transform(i)), this.currentRange = E1(this.currentRange, i));
    }), this.quill.keyboard.addBinding({
      key: "z",
      shortKey: !0
    }, this.undo.bind(this)), this.quill.keyboard.addBinding({
      key: ["z", "Z"],
      shortKey: !0,
      shiftKey: !0
    }, this.redo.bind(this)), /Win/i.test(navigator.platform) && this.quill.keyboard.addBinding({
      key: "y",
      shortKey: !0
    }, this.redo.bind(this)), this.quill.root.addEventListener("beforeinput", (n) => {
      n.inputType === "historyUndo" ? (this.undo(), n.preventDefault()) : n.inputType === "historyRedo" && (this.redo(), n.preventDefault());
    });
  }
  change(r, a) {
    if (this.stack[r].length === 0)
      return;
    const n = this.stack[r].pop();
    if (!n)
      return;
    const i = this.quill.getContents(), s = n.delta.invert(i);
    this.stack[a].push({
      delta: s,
      range: E1(n.range, s)
    }), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(n.delta, De.sources.USER), this.ignoreChange = !1, this.restoreSelection(n);
  }
  clear() {
    this.stack = {
      undo: [],
      redo: []
    };
  }
  cutoff() {
    this.lastRecorded = 0;
  }
  record(r, a) {
    if (r.ops.length === 0)
      return;
    this.stack.redo = [];
    let n = r.invert(a), i = this.currentRange;
    const s = Date.now();
    if (
      // @ts-expect-error Fix me later
      this.lastRecorded + this.options.delay > s && this.stack.undo.length > 0
    ) {
      const o = this.stack.undo.pop();
      o && (n = n.compose(o.delta), i = o.range);
    } else
      this.lastRecorded = s;
    n.length() !== 0 && (this.stack.undo.push({
      delta: n,
      range: i
    }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift());
  }
  redo() {
    this.change("redo", "undo");
  }
  transform(r) {
    Yw(this.stack.undo, r), Yw(this.stack.redo, r);
  }
  undo() {
    this.change("undo", "redo");
  }
  restoreSelection(r) {
    if (r.range)
      this.quill.setSelection(r.range, De.sources.USER);
    else {
      const a = Xie(this.quill.scroll, r.delta);
      this.quill.setSelection(a, De.sources.USER);
    }
  }
}
it(cC, "DEFAULTS", {
  delay: 1e3,
  maxStack: 100,
  userOnly: !1
});
function Yw(e, t) {
  let r = t;
  for (let a = e.length - 1; a >= 0; a -= 1) {
    const n = e[a];
    e[a] = {
      delta: r.transform(n.delta, !0),
      range: n.range && E1(n.range, r)
    }, r = n.delta.transform(r), e[a].delta.length() === 0 && e.splice(a, 1);
  }
}
function Gie(e, t) {
  const r = t.ops[t.ops.length - 1];
  return r == null ? !1 : r.insert != null ? typeof r.insert == "string" && r.insert.endsWith(`
`) : r.attributes != null ? Object.keys(r.attributes).some((a) => e.query(a, vt.BLOCK) != null) : !1;
}
function Xie(e, t) {
  const r = t.reduce((n, i) => n + (i.delete || 0), 0);
  let a = t.length() - r;
  return Gie(e, t) && (a -= 1), a;
}
function E1(e, t) {
  if (!e)
    return e;
  const r = t.transformPosition(e.index), a = t.transformPosition(e.index + e.length);
  return {
    index: r,
    length: a - r
  };
}
class fC extends Wn {
  constructor(t, r) {
    super(t, r), t.root.addEventListener("drop", (a) => {
      var s;
      a.preventDefault();
      let n = null;
      if (document.caretRangeFromPoint)
        n = document.caretRangeFromPoint(a.clientX, a.clientY);
      else if (document.caretPositionFromPoint) {
        const o = document.caretPositionFromPoint(a.clientX, a.clientY);
        n = document.createRange(), n.setStart(o.offsetNode, o.offset), n.setEnd(o.offsetNode, o.offset);
      }
      const i = n && t.selection.normalizeNative(n);
      if (i) {
        const o = t.selection.normalizedToRange(i);
        (s = a.dataTransfer) != null && s.files && this.upload(o, a.dataTransfer.files);
      }
    });
  }
  upload(t, r) {
    const a = [];
    Array.from(r).forEach((n) => {
      var i;
      n && ((i = this.options.mimetypes) != null && i.includes(n.type)) && a.push(n);
    }), a.length > 0 && this.options.handler.call(this, t, a);
  }
}
fC.DEFAULTS = {
  mimetypes: ["image/png", "image/jpeg"],
  handler(e, t) {
    if (!this.quill.scroll.query("image"))
      return;
    const r = t.map((a) => new Promise((n) => {
      const i = new FileReader();
      i.onload = () => {
        n(i.result);
      }, i.readAsDataURL(a);
    }));
    Promise.all(r).then((a) => {
      const n = a.reduce((i, s) => i.insert({
        image: s
      }), new ft().retain(e.index).delete(e.length));
      this.quill.updateContents(n, ot.sources.USER), this.quill.setSelection(e.index + a.length, ot.sources.SILENT);
    });
  }
};
const Kie = ["insertText", "insertReplacementText"];
class Jie extends Wn {
  constructor(t, r) {
    super(t, r), t.root.addEventListener("beforeinput", (a) => {
      this.handleBeforeInput(a);
    }), /Android/i.test(navigator.userAgent) || t.on(De.events.COMPOSITION_BEFORE_START, () => {
      this.handleCompositionStart();
    });
  }
  deleteRange(t) {
    _y({
      range: t,
      quill: this.quill
    });
  }
  replaceText(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (t.length === 0)
      return !1;
    if (r) {
      const a = this.quill.getFormat(t.index, 1);
      this.deleteRange(t), this.quill.updateContents(new ft().retain(t.index).insert(r, a), De.sources.USER);
    } else
      this.deleteRange(t);
    return this.quill.setSelection(t.index + r.length, 0, De.sources.SILENT), !0;
  }
  handleBeforeInput(t) {
    if (this.quill.composition.isComposing || t.defaultPrevented || !Kie.includes(t.inputType))
      return;
    const r = t.getTargetRanges ? t.getTargetRanges()[0] : null;
    if (!r || r.collapsed === !0)
      return;
    const a = Qie(t);
    if (a == null)
      return;
    const n = this.quill.selection.normalizeNative(r), i = n ? this.quill.selection.normalizedToRange(n) : null;
    i && this.replaceText(i, a) && t.preventDefault();
  }
  handleCompositionStart() {
    const t = this.quill.getSelection();
    t && this.replaceText(t);
  }
}
function Qie(e) {
  var t;
  return typeof e.data == "string" ? e.data : (t = e.dataTransfer) != null && t.types.includes("text/plain") ? e.dataTransfer.getData("text/plain") : null;
}
const Zie = /Mac/i.test(navigator.platform), ese = 100, tse = (e) => !!(e.key === "ArrowLeft" || e.key === "ArrowRight" || // RTL scripts or moving from the end of the previous line
e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "Home" || Zie && e.key === "a" && e.ctrlKey === !0);
class rse extends Wn {
  constructor(r, a) {
    super(r, a);
    it(this, "isListening", !1);
    it(this, "selectionChangeDeadline", 0);
    this.handleArrowKeys(), this.handleNavigationShortcuts();
  }
  handleArrowKeys() {
    this.quill.keyboard.addBinding({
      key: ["ArrowLeft", "ArrowRight"],
      offset: 0,
      shiftKey: null,
      handler(r, a) {
        let {
          line: n,
          event: i
        } = a;
        if (!(n instanceof Rn) || !n.uiNode)
          return !0;
        const s = getComputedStyle(n.domNode).direction === "rtl";
        return s && i.key !== "ArrowRight" || !s && i.key !== "ArrowLeft" ? !0 : (this.quill.setSelection(r.index - 1, r.length + (i.shiftKey ? 1 : 0), De.sources.USER), !1);
      }
    });
  }
  handleNavigationShortcuts() {
    this.quill.root.addEventListener("keydown", (r) => {
      !r.defaultPrevented && tse(r) && this.ensureListeningToSelectionChange();
    });
  }
  /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */
  ensureListeningToSelectionChange() {
    if (this.selectionChangeDeadline = Date.now() + ese, this.isListening)
      return;
    this.isListening = !0;
    const r = () => {
      this.isListening = !1, Date.now() <= this.selectionChangeDeadline && this.handleSelectionChange();
    };
    document.addEventListener("selectionchange", r, {
      once: !0
    });
  }
  handleSelectionChange() {
    const r = document.getSelection();
    if (!r)
      return;
    const a = r.getRangeAt(0);
    if (a.collapsed !== !0 || a.startOffset !== 0)
      return;
    const n = this.quill.scroll.find(a.startContainer);
    if (!(n instanceof Rn) || !n.uiNode)
      return;
    const i = document.createRange();
    i.setStartAfter(n.uiNode), i.setEndAfter(n.uiNode), r.removeAllRanges(), r.addRange(i);
  }
}
De.register({
  "blots/block": ua,
  "blots/block/embed": hn,
  "blots/break": Yn,
  "blots/container": Ys,
  "blots/cursor": To,
  "blots/embed": vy,
  "blots/inline": di,
  "blots/scroll": lo,
  "blots/text": qn,
  "modules/clipboard": uC,
  "modules/history": cC,
  "modules/keyboard": cf,
  "modules/uploader": fC,
  "modules/input": Jie,
  "modules/uiNode": rse
});
class ase extends zn {
  add(t, r) {
    let a = 0;
    if (r === "+1" || r === "-1") {
      const n = this.value(t) || 0;
      a = r === "+1" ? n + 1 : n - 1;
    } else
      typeof r == "number" && (a = r);
    return a === 0 ? (this.remove(t), !0) : super.add(t, a.toString());
  }
  canAdd(t, r) {
    return super.canAdd(t, r) || super.canAdd(t, parseInt(r, 10));
  }
  value(t) {
    return parseInt(super.value(t), 10) || void 0;
  }
}
const nse = new ase("indent", "ql-indent", {
  scope: vt.BLOCK,
  // @ts-expect-error
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});
class O1 extends ua {
}
it(O1, "blotName", "blockquote"), it(O1, "tagName", "blockquote");
class C1 extends ua {
  static formats(t) {
    return this.tagName.indexOf(t.tagName) + 1;
  }
}
it(C1, "blotName", "header"), it(C1, "tagName", ["H1", "H2", "H3", "H4", "H5", "H6"]);
class Nu extends Ys {
}
Nu.blotName = "list-container";
Nu.tagName = "OL";
class $u extends ua {
  static create(t) {
    const r = super.create();
    return r.setAttribute("data-list", t), r;
  }
  static formats(t) {
    return t.getAttribute("data-list") || void 0;
  }
  static register() {
    De.register(Nu);
  }
  constructor(t, r) {
    super(t, r);
    const a = r.ownerDocument.createElement("span"), n = (i) => {
      if (!t.isEnabled())
        return;
      const s = this.statics.formats(r, t);
      s === "checked" ? (this.format("list", "unchecked"), i.preventDefault()) : s === "unchecked" && (this.format("list", "checked"), i.preventDefault());
    };
    a.addEventListener("mousedown", n), a.addEventListener("touchstart", n), this.attachUI(a);
  }
  format(t, r) {
    t === this.statics.blotName && r ? this.domNode.setAttribute("data-list", r) : super.format(t, r);
  }
}
$u.blotName = "list";
$u.tagName = "LI";
Nu.allowedChildren = [$u];
$u.requiredContainer = Nu;
class su extends di {
  static create() {
    return super.create();
  }
  static formats() {
    return !0;
  }
  optimize(t) {
    super.optimize(t), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
  }
}
it(su, "blotName", "bold"), it(su, "tagName", ["STRONG", "B"]);
class k1 extends su {
}
it(k1, "blotName", "italic"), it(k1, "tagName", ["EM", "I"]);
class Xi extends di {
  static create(t) {
    const r = super.create(t);
    return r.setAttribute("href", this.sanitize(t)), r.setAttribute("rel", "noopener noreferrer"), r.setAttribute("target", "_blank"), r;
  }
  static formats(t) {
    return t.getAttribute("href");
  }
  static sanitize(t) {
    return pC(t, this.PROTOCOL_WHITELIST) ? t : this.SANITIZED_URL;
  }
  format(t, r) {
    t !== this.statics.blotName || !r ? super.format(t, r) : this.domNode.setAttribute("href", this.constructor.sanitize(r));
  }
}
it(Xi, "blotName", "link"), it(Xi, "tagName", "A"), it(Xi, "SANITIZED_URL", "about:blank"), it(Xi, "PROTOCOL_WHITELIST", ["http", "https", "mailto", "tel", "sms"]);
function pC(e, t) {
  const r = document.createElement("a");
  r.href = e;
  const a = r.href.slice(0, r.href.indexOf(":"));
  return t.indexOf(a) > -1;
}
class P1 extends di {
  static create(t) {
    return t === "super" ? document.createElement("sup") : t === "sub" ? document.createElement("sub") : super.create(t);
  }
  static formats(t) {
    if (t.tagName === "SUB")
      return "sub";
    if (t.tagName === "SUP")
      return "super";
  }
}
it(P1, "blotName", "script"), it(P1, "tagName", ["SUB", "SUP"]);
class M1 extends su {
}
it(M1, "blotName", "strike"), it(M1, "tagName", ["S", "STRIKE"]);
class A1 extends di {
}
it(A1, "blotName", "underline"), it(A1, "tagName", "U");
class cd extends vy {
  static create(t) {
    if (window.katex == null)
      throw new Error("Formula module requires KaTeX.");
    const r = super.create(t);
    return typeof t == "string" && (window.katex.render(t, r, {
      throwOnError: !1,
      errorColor: "#f00"
    }), r.setAttribute("data-value", t)), r;
  }
  static value(t) {
    return t.getAttribute("data-value");
  }
  html() {
    const {
      formula: t
    } = this.value();
    return `<span>${t}</span>`;
  }
}
it(cd, "blotName", "formula"), it(cd, "className", "ql-formula"), it(cd, "tagName", "SPAN");
const Ww = ["alt", "height", "width"];
var rd;
let ise = (rd = class extends tn {
  static create(t) {
    const r = super.create(t);
    return typeof t == "string" && r.setAttribute("src", this.sanitize(t)), r;
  }
  static formats(t) {
    return Ww.reduce((r, a) => (t.hasAttribute(a) && (r[a] = t.getAttribute(a)), r), {});
  }
  static match(t) {
    return /\.(jpe?g|gif|png)$/.test(t) || /^data:image\/.+;base64/.test(t);
  }
  static sanitize(t) {
    return pC(t, ["http", "https", "data"]) ? t : "//:0";
  }
  static value(t) {
    return t.getAttribute("src");
  }
  format(t, r) {
    Ww.indexOf(t) > -1 ? r ? this.domNode.setAttribute(t, r) : this.domNode.removeAttribute(t) : super.format(t, r);
  }
}, it(rd, "blotName", "image"), it(rd, "tagName", "IMG"), rd);
const Gw = ["height", "width"];
class fd extends hn {
  static create(t) {
    const r = super.create(t);
    return r.setAttribute("frameborder", "0"), r.setAttribute("allowfullscreen", "true"), r.setAttribute("src", this.sanitize(t)), r;
  }
  static formats(t) {
    return Gw.reduce((r, a) => (t.hasAttribute(a) && (r[a] = t.getAttribute(a)), r), {});
  }
  static sanitize(t) {
    return Xi.sanitize(t);
  }
  static value(t) {
    return t.getAttribute("src");
  }
  format(t, r) {
    Gw.indexOf(t) > -1 ? r ? this.domNode.setAttribute(t, r) : this.domNode.removeAttribute(t) : super.format(t, r);
  }
  html() {
    const {
      video: t
    } = this.value();
    return `<a href="${t}">${t}</a>`;
  }
}
it(fd, "blotName", "video"), it(fd, "className", "ql-video"), it(fd, "tagName", "IFRAME");
const Al = new zn("code-token", "hljs", {
  scope: vt.INLINE
});
class ki extends di {
  static formats(t, r) {
    for (; t != null && t !== r.domNode; ) {
      if (t.classList && t.classList.contains(ya.className))
        return super.formats(t, r);
      t = t.parentNode;
    }
  }
  constructor(t, r, a) {
    super(t, r, a), Al.add(this.domNode, a);
  }
  format(t, r) {
    t !== ki.blotName ? super.format(t, r) : r ? Al.add(this.domNode, r) : (Al.remove(this.domNode), this.domNode.classList.remove(this.statics.className));
  }
  optimize() {
    super.optimize(...arguments), Al.value(this.domNode) || this.unwrap();
  }
}
ki.blotName = "code-token";
ki.className = "ql-token";
class pn extends ya {
  static create(t) {
    const r = super.create(t);
    return typeof t == "string" && r.setAttribute("data-language", t), r;
  }
  static formats(t) {
    return t.getAttribute("data-language") || "plain";
  }
  static register() {
  }
  // Syntax module will register
  format(t, r) {
    t === this.statics.blotName && r ? this.domNode.setAttribute("data-language", r) : super.format(t, r);
  }
  replaceWith(t, r) {
    return this.formatAt(0, this.length(), ki.blotName, !1), super.replaceWith(t, r);
  }
}
class jl extends Ws {
  attach() {
    super.attach(), this.forceNext = !1, this.scroll.emitMount(this);
  }
  format(t, r) {
    t === pn.blotName && (this.forceNext = !0, this.children.forEach((a) => {
      a.format(t, r);
    }));
  }
  formatAt(t, r, a, n) {
    a === pn.blotName && (this.forceNext = !0), super.formatAt(t, r, a, n);
  }
  highlight(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.children.head == null)
      return;
    const n = `${Array.from(this.domNode.childNodes).filter((s) => s !== this.uiNode).map((s) => s.textContent).join(`
`)}
`, i = pn.formats(this.children.head.domNode);
    if (r || this.forceNext || this.cachedText !== n) {
      if (n.trim().length > 0 || this.cachedText == null) {
        const s = this.children.reduce((l, u) => l.concat(X3(u, !1)), new ft()), o = t(n, i);
        s.diff(o).reduce((l, u) => {
          let {
            retain: d,
            attributes: f
          } = u;
          return d ? (f && Object.keys(f).forEach((c) => {
            [pn.blotName, ki.blotName].includes(c) && this.formatAt(l, d, c, f[c]);
          }), l + d) : l;
        }, 0);
      }
      this.cachedText = n, this.forceNext = !1;
    }
  }
  html(t, r) {
    const [a] = this.children.find(t);
    return `<pre data-language="${a ? pn.formats(a.domNode) : "plain"}">
${df(this.code(t, r))}
</pre>`;
  }
  optimize(t) {
    if (super.optimize(t), this.parent != null && this.children.head != null && this.uiNode != null) {
      const r = pn.formats(this.children.head.domNode);
      r !== this.uiNode.value && (this.uiNode.value = r);
    }
  }
}
jl.allowedChildren = [pn];
pn.requiredContainer = jl;
pn.allowedChildren = [ki, To, qn, Yn];
const sse = (e, t, r) => {
  if (typeof e.versionString == "string") {
    const a = e.versionString.split(".")[0];
    if (parseInt(a, 10) >= 11)
      return e.highlight(r, {
        language: t
      }).value;
  }
  return e.highlight(t, r).value;
};
class vC extends Wn {
  static register() {
    De.register(ki, !0), De.register(pn, !0), De.register(jl, !0);
  }
  constructor(t, r) {
    if (super(t, r), this.options.hljs == null)
      throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
    this.languages = this.options.languages.reduce((a, n) => {
      let {
        key: i
      } = n;
      return a[i] = !0, a;
    }, {}), this.highlightBlot = this.highlightBlot.bind(this), this.initListener(), this.initTimer();
  }
  initListener() {
    this.quill.on(De.events.SCROLL_BLOT_MOUNT, (t) => {
      if (!(t instanceof jl))
        return;
      const r = this.quill.root.ownerDocument.createElement("select");
      this.options.languages.forEach((a) => {
        let {
          key: n,
          label: i
        } = a;
        const s = r.ownerDocument.createElement("option");
        s.textContent = i, s.setAttribute("value", n), r.appendChild(s);
      }), r.addEventListener("change", () => {
        t.format(pn.blotName, r.value), this.quill.root.focus(), this.highlight(t, !0);
      }), t.uiNode == null && (t.attachUI(r), t.children.head && (r.value = pn.formats(t.children.head.domNode)));
    });
  }
  initTimer() {
    let t = null;
    this.quill.on(De.events.SCROLL_OPTIMIZE, () => {
      t && clearTimeout(t), t = setTimeout(() => {
        this.highlight(), t = null;
      }, this.options.interval);
    });
  }
  highlight() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.quill.selection.composing)
      return;
    this.quill.update(De.sources.USER);
    const a = this.quill.getSelection();
    (t == null ? this.quill.scroll.descendants(jl) : [t]).forEach((i) => {
      i.highlight(this.highlightBlot, r);
    }), this.quill.update(De.sources.SILENT), a != null && this.quill.setSelection(a, De.sources.SILENT);
  }
  highlightBlot(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "plain";
    if (r = this.languages[r] ? r : "plain", r === "plain")
      return df(t).split(`
`).reduce((n, i, s) => (s !== 0 && n.insert(`
`, {
        [ya.blotName]: r
      }), n.insert(i)), new ft());
    const a = this.quill.root.ownerDocument.createElement("div");
    return a.classList.add(ya.className), a.innerHTML = sse(this.options.hljs, r, t), xy(this.quill.scroll, a, [(n, i) => {
      const s = Al.value(n);
      return s ? i.compose(new ft().retain(i.length(), {
        [ki.blotName]: s
      })) : i;
    }], [(n, i) => n.data.split(`
`).reduce((s, o, l) => (l !== 0 && s.insert(`
`, {
      [ya.blotName]: r
    }), s.insert(o)), i)], /* @__PURE__ */ new WeakMap());
  }
}
vC.DEFAULTS = {
  hljs: (() => window.hljs)(),
  interval: 1e3,
  languages: [{
    key: "plain",
    label: "Plain"
  }, {
    key: "bash",
    label: "Bash"
  }, {
    key: "cpp",
    label: "C++"
  }, {
    key: "cs",
    label: "C#"
  }, {
    key: "css",
    label: "CSS"
  }, {
    key: "diff",
    label: "Diff"
  }, {
    key: "xml",
    label: "HTML/XML"
  }, {
    key: "java",
    label: "Java"
  }, {
    key: "javascript",
    label: "JavaScript"
  }, {
    key: "markdown",
    label: "Markdown"
  }, {
    key: "php",
    label: "PHP"
  }, {
    key: "python",
    label: "Python"
  }, {
    key: "ruby",
    label: "Ruby"
  }, {
    key: "sql",
    label: "SQL"
  }]
};
const Bl = class Bl extends ua {
  static create(t) {
    const r = super.create();
    return t ? r.setAttribute("data-row", t) : r.setAttribute("data-row", wy()), r;
  }
  static formats(t) {
    if (t.hasAttribute("data-row"))
      return t.getAttribute("data-row");
  }
  cellOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  format(t, r) {
    t === Bl.blotName && r ? this.domNode.setAttribute("data-row", r) : super.format(t, r);
  }
  row() {
    return this.parent;
  }
  rowOffset() {
    return this.row() ? this.row().rowOffset() : -1;
  }
  table() {
    return this.row() && this.row().table();
  }
};
it(Bl, "blotName", "table"), it(Bl, "tagName", "TD");
let $n = Bl;
class Pi extends Ys {
  checkMerge() {
    if (super.checkMerge() && this.next.children.head != null) {
      const t = this.children.head.formats(), r = this.children.tail.formats(), a = this.next.children.head.formats(), n = this.next.children.tail.formats();
      return t.table === r.table && t.table === a.table && t.table === n.table;
    }
    return !1;
  }
  optimize(t) {
    super.optimize(t), this.children.forEach((r) => {
      if (r.next == null)
        return;
      const a = r.formats(), n = r.next.formats();
      if (a.table !== n.table) {
        const i = this.splitAfter(r);
        i && i.optimize(), this.prev && this.prev.optimize();
      }
    });
  }
  rowOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  table() {
    return this.parent && this.parent.parent;
  }
}
it(Pi, "blotName", "table-row"), it(Pi, "tagName", "TR");
class oi extends Ys {
}
it(oi, "blotName", "table-body"), it(oi, "tagName", "TBODY");
class Eo extends Ys {
  balanceCells() {
    const t = this.descendants(Pi), r = t.reduce((a, n) => Math.max(n.children.length, a), 0);
    t.forEach((a) => {
      new Array(r - a.children.length).fill(0).forEach(() => {
        let n;
        a.children.head != null && (n = $n.formats(a.children.head.domNode));
        const i = this.scroll.create($n.blotName, n);
        a.appendChild(i), i.optimize();
      });
    });
  }
  cells(t) {
    return this.rows().map((r) => r.children.at(t));
  }
  deleteColumn(t) {
    const [r] = this.descendant(oi);
    r == null || r.children.head == null || r.children.forEach((a) => {
      const n = a.children.at(t);
      n != null && n.remove();
    });
  }
  insertColumn(t) {
    const [r] = this.descendant(oi);
    r == null || r.children.head == null || r.children.forEach((a) => {
      const n = a.children.at(t), i = $n.formats(a.children.head.domNode), s = this.scroll.create($n.blotName, i);
      a.insertBefore(s, n);
    });
  }
  insertRow(t) {
    const [r] = this.descendant(oi);
    if (r == null || r.children.head == null)
      return;
    const a = wy(), n = this.scroll.create(Pi.blotName);
    r.children.head.children.forEach(() => {
      const s = this.scroll.create($n.blotName, a);
      n.appendChild(s);
    });
    const i = r.children.at(t);
    r.insertBefore(n, i);
  }
  rows() {
    const t = this.children.head;
    return t == null ? [] : t.children.map((r) => r);
  }
}
it(Eo, "blotName", "table-container"), it(Eo, "tagName", "TABLE");
Eo.allowedChildren = [oi];
oi.requiredContainer = Eo;
oi.allowedChildren = [Pi];
Pi.requiredContainer = oi;
Pi.allowedChildren = [$n];
$n.requiredContainer = Pi;
function wy() {
  return `row-${Math.random().toString(36).slice(2, 6)}`;
}
class ose extends Wn {
  static register() {
    De.register($n), De.register(Pi), De.register(oi), De.register(Eo);
  }
  constructor() {
    super(...arguments), this.listenBalanceCells();
  }
  balanceTables() {
    this.quill.scroll.descendants(Eo).forEach((t) => {
      t.balanceCells();
    });
  }
  deleteColumn() {
    const [t, , r] = this.getTable();
    r != null && (t.deleteColumn(r.cellOffset()), this.quill.update(De.sources.USER));
  }
  deleteRow() {
    const [, t] = this.getTable();
    t != null && (t.remove(), this.quill.update(De.sources.USER));
  }
  deleteTable() {
    const [t] = this.getTable();
    if (t == null)
      return;
    const r = t.offset();
    t.remove(), this.quill.update(De.sources.USER), this.quill.setSelection(r, De.sources.SILENT);
  }
  getTable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.quill.getSelection();
    if (t == null)
      return [null, null, null, -1];
    const [r, a] = this.quill.getLine(t.index);
    if (r == null || r.statics.blotName !== $n.blotName)
      return [null, null, null, -1];
    const n = r.parent;
    return [n.parent.parent, n, r, a];
  }
  insertColumn(t) {
    const r = this.quill.getSelection();
    if (!r)
      return;
    const [a, n, i] = this.getTable(r);
    if (i == null)
      return;
    const s = i.cellOffset();
    a.insertColumn(s + t), this.quill.update(De.sources.USER);
    let o = n.rowOffset();
    t === 0 && (o += 1), this.quill.setSelection(r.index + o, r.length, De.sources.SILENT);
  }
  insertColumnLeft() {
    this.insertColumn(0);
  }
  insertColumnRight() {
    this.insertColumn(1);
  }
  insertRow(t) {
    const r = this.quill.getSelection();
    if (!r)
      return;
    const [a, n, i] = this.getTable(r);
    if (i == null)
      return;
    const s = n.rowOffset();
    a.insertRow(s + t), this.quill.update(De.sources.USER), t > 0 ? this.quill.setSelection(r, De.sources.SILENT) : this.quill.setSelection(r.index + n.children.length, r.length, De.sources.SILENT);
  }
  insertRowAbove() {
    this.insertRow(0);
  }
  insertRowBelow() {
    this.insertRow(1);
  }
  insertTable(t, r) {
    const a = this.quill.getSelection();
    if (a == null)
      return;
    const n = new Array(t).fill(0).reduce((i) => {
      const s = new Array(r).fill(`
`).join("");
      return i.insert(s, {
        table: wy()
      });
    }, new ft().retain(a.index));
    this.quill.updateContents(n, De.sources.USER), this.quill.setSelection(a.index, De.sources.SILENT), this.balanceTables();
  }
  listenBalanceCells() {
    this.quill.on(De.events.SCROLL_OPTIMIZE, (t) => {
      t.some((r) => ["TD", "TR", "TBODY", "TABLE"].includes(r.target.tagName) ? (this.quill.once(De.events.TEXT_CHANGE, (a, n, i) => {
        i === De.sources.USER && this.balanceTables();
      }), !0) : !1);
    });
  }
}
const Xw = Fi("quill:toolbar");
class Ty extends Wn {
  constructor(t, r) {
    var a, n;
    if (super(t, r), Array.isArray(this.options.container)) {
      const i = document.createElement("div");
      i.setAttribute("role", "toolbar"), lse(i, this.options.container), (n = (a = t.container) == null ? void 0 : a.parentNode) == null || n.insertBefore(i, t.container), this.container = i;
    } else
      typeof this.options.container == "string" ? this.container = document.querySelector(this.options.container) : this.container = this.options.container;
    if (!(this.container instanceof HTMLElement)) {
      Xw.error("Container required for toolbar", this.options);
      return;
    }
    this.container.classList.add("ql-toolbar"), this.controls = [], this.handlers = {}, this.options.handlers && Object.keys(this.options.handlers).forEach((i) => {
      var o;
      const s = (o = this.options.handlers) == null ? void 0 : o[i];
      s && this.addHandler(i, s);
    }), Array.from(this.container.querySelectorAll("button, select")).forEach((i) => {
      this.attach(i);
    }), this.quill.on(De.events.EDITOR_CHANGE, () => {
      const [i] = this.quill.selection.getRange();
      this.update(i);
    });
  }
  addHandler(t, r) {
    this.handlers[t] = r;
  }
  attach(t) {
    let r = Array.from(t.classList).find((n) => n.indexOf("ql-") === 0);
    if (!r)
      return;
    if (r = r.slice(3), t.tagName === "BUTTON" && t.setAttribute("type", "button"), this.handlers[r] == null && this.quill.scroll.query(r) == null) {
      Xw.warn("ignoring attaching to nonexistent format", r, t);
      return;
    }
    const a = t.tagName === "SELECT" ? "change" : "click";
    t.addEventListener(a, (n) => {
      let i;
      if (t.tagName === "SELECT") {
        if (t.selectedIndex < 0)
          return;
        const o = t.options[t.selectedIndex];
        o.hasAttribute("selected") ? i = !1 : i = o.value || !1;
      } else
        t.classList.contains("ql-active") ? i = !1 : i = t.value || !t.hasAttribute("value"), n.preventDefault();
      this.quill.focus();
      const [s] = this.quill.selection.getRange();
      if (this.handlers[r] != null)
        this.handlers[r].call(this, i);
      else if (
        // @ts-expect-error
        this.quill.scroll.query(r).prototype instanceof tn
      ) {
        if (i = prompt(`Enter ${r}`), !i)
          return;
        this.quill.updateContents(new ft().retain(s.index).delete(s.length).insert({
          [r]: i
        }), De.sources.USER);
      } else
        this.quill.format(r, i, De.sources.USER);
      this.update(s);
    }), this.controls.push([r, t]);
  }
  update(t) {
    const r = t == null ? {} : this.quill.getFormat(t);
    this.controls.forEach((a) => {
      const [n, i] = a;
      if (i.tagName === "SELECT") {
        let s = null;
        if (t == null)
          s = null;
        else if (r[n] == null)
          s = i.querySelector("option[selected]");
        else if (!Array.isArray(r[n])) {
          let o = r[n];
          typeof o == "string" && (o = o.replace(/"/g, '\\"')), s = i.querySelector(`option[value="${o}"]`);
        }
        s == null ? (i.value = "", i.selectedIndex = -1) : s.selected = !0;
      } else if (t == null)
        i.classList.remove("ql-active"), i.setAttribute("aria-pressed", "false");
      else if (i.hasAttribute("value")) {
        const s = r[n], o = s === i.getAttribute("value") || s != null && s.toString() === i.getAttribute("value") || s == null && !i.getAttribute("value");
        i.classList.toggle("ql-active", o), i.setAttribute("aria-pressed", o.toString());
      } else {
        const s = r[n] != null;
        i.classList.toggle("ql-active", s), i.setAttribute("aria-pressed", s.toString());
      }
    });
  }
}
Ty.DEFAULTS = {};
function Kw(e, t, r) {
  const a = document.createElement("button");
  a.setAttribute("type", "button"), a.classList.add(`ql-${t}`), a.setAttribute("aria-pressed", "false"), r != null ? (a.value = r, a.setAttribute("aria-label", `${t}: ${r}`)) : a.setAttribute("aria-label", t), e.appendChild(a);
}
function lse(e, t) {
  Array.isArray(t[0]) || (t = [t]), t.forEach((r) => {
    const a = document.createElement("span");
    a.classList.add("ql-formats"), r.forEach((n) => {
      if (typeof n == "string")
        Kw(a, n);
      else {
        const i = Object.keys(n)[0], s = n[i];
        Array.isArray(s) ? use(a, i, s) : Kw(a, i, s);
      }
    }), e.appendChild(a);
  });
}
function use(e, t, r) {
  const a = document.createElement("select");
  a.classList.add(`ql-${t}`), r.forEach((n) => {
    const i = document.createElement("option");
    n !== !1 ? i.setAttribute("value", String(n)) : i.setAttribute("selected", "selected"), a.appendChild(i);
  }), e.appendChild(a);
}
Ty.DEFAULTS = {
  container: null,
  handlers: {
    clean() {
      const e = this.quill.getSelection();
      if (e != null)
        if (e.length === 0) {
          const t = this.quill.getFormat();
          Object.keys(t).forEach((r) => {
            this.quill.scroll.query(r, vt.INLINE) != null && this.quill.format(r, !1, De.sources.USER);
          });
        } else
          this.quill.removeFormat(e.index, e.length, De.sources.USER);
    },
    direction(e) {
      const {
        align: t
      } = this.quill.getFormat();
      e === "rtl" && t == null ? this.quill.format("align", "right", De.sources.USER) : !e && t === "right" && this.quill.format("align", !1, De.sources.USER), this.quill.format("direction", e, De.sources.USER);
    },
    indent(e) {
      const t = this.quill.getSelection(), r = this.quill.getFormat(t), a = parseInt(r.indent || 0, 10);
      if (e === "+1" || e === "-1") {
        let n = e === "+1" ? 1 : -1;
        r.direction === "rtl" && (n *= -1), this.quill.format("indent", a + n, De.sources.USER);
      }
    },
    link(e) {
      e === !0 && (e = prompt("Enter link URL:")), this.quill.format("link", e, De.sources.USER);
    },
    list(e) {
      const t = this.quill.getSelection(), r = this.quill.getFormat(t);
      e === "check" ? r.list === "checked" || r.list === "unchecked" ? this.quill.format("list", !1, De.sources.USER) : this.quill.format("list", "unchecked", De.sources.USER) : this.quill.format("list", e, De.sources.USER);
    }
  }
};
const dse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"/></svg>', cse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"/><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"/></svg>', fse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"/></svg>', pse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"/></svg>', vse = '<svg viewbox="0 0 18 18"><g class="ql-fill ql-color-label"><polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"/><rect height="1" width="1" x="4" y="4"/><polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"/><rect height="1" width="1" x="2" y="6"/><rect height="1" width="1" x="3" y="5"/><rect height="1" width="1" x="4" y="7"/><polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"/><rect height="1" width="1" x="2" y="12"/><rect height="1" width="1" x="2" y="9"/><rect height="1" width="1" x="2" y="15"/><polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"/><rect height="1" width="1" x="3" y="8"/><path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"/><path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"/><path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"/><rect height="1" width="1" x="12" y="2"/><rect height="1" width="1" x="11" y="3"/><path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"/><rect height="1" width="1" x="2" y="3"/><rect height="1" width="1" x="6" y="2"/><rect height="1" width="1" x="3" y="2"/><rect height="1" width="1" x="5" y="3"/><rect height="1" width="1" x="9" y="2"/><rect height="1" width="1" x="15" y="14"/><polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"/><rect height="1" width="1" x="13" y="7"/><rect height="1" width="1" x="15" y="5"/><rect height="1" width="1" x="14" y="6"/><rect height="1" width="1" x="15" y="8"/><rect height="1" width="1" x="14" y="9"/><path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"/><rect height="1" width="1" x="14" y="3"/><polygon points="12 6.868 12 6 11.62 6 12 6.868"/><rect height="1" width="1" x="15" y="2"/><rect height="1" width="1" x="12" y="5"/><rect height="1" width="1" x="13" y="4"/><polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"/><rect height="1" width="1" x="9" y="14"/><rect height="1" width="1" x="8" y="15"/><path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"/><rect height="1" width="1" x="5" y="15"/><path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"/><rect height="1" width="1" x="11" y="15"/><path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"/><rect height="1" width="1" x="14" y="15"/><rect height="1" width="1" x="15" y="11"/></g><polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"/></svg>', mse = '<svg viewbox="0 0 18 18"><rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"/><rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"/><path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"/><path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"/></svg>', hse = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"/><path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"/></svg>', gse = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"/><line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"/><line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"/><line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"/></svg>', Jw = '<svg viewbox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"/><polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"/><line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"/></svg>', bse = '<svg viewbox="0 0 18 18"><line class="ql-color-label ql-stroke ql-transparent" x1="3" x2="15" y1="15" y2="15"/><polyline class="ql-stroke" points="5.5 11 9 3 12.5 11"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="9" y2="9"/></svg>', yse = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"/><line class="ql-stroke ql-fill" x1="15" x2="11" y1="4" y2="4"/><path class="ql-fill" d="M11,3a3,3,0,0,0,0,6h1V3H11Z"/><rect class="ql-fill" height="11" width="1" x="11" y="4"/><rect class="ql-fill" height="11" width="1" x="13" y="4"/></svg>', _se = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"/><line class="ql-stroke ql-fill" x1="9" x2="5" y1="4" y2="4"/><path class="ql-fill" d="M5,3A3,3,0,0,0,5,9H6V3H5Z"/><rect class="ql-fill" height="11" width="1" x="5" y="4"/><rect class="ql-fill" height="11" width="1" x="7" y="4"/></svg>', xse = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z"/><rect class="ql-fill" height="1.6" rx="0.8" ry="0.8" width="5" x="5.15" y="6.2"/><path class="ql-fill" d="M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z"/></svg>', wse = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z"/></svg>', Tse = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Sse = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Ese = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z"/></svg>', Ose = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Cse = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z"/></svg>', kse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"/><line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"/><line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"/></svg>', Pse = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"/><circle class="ql-fill" cx="6" cy="7" r="1"/><polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"/></svg>', Mse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"/></svg>', Ase = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"/></svg>', Dse = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"/><path class="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"/><path class="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"/></svg>', Ise = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"/><line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"/></svg>', Nse = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="9" x2="15" y1="4" y2="4"/><polyline class="ql-stroke" points="3 4 4 5 6 3"/><line class="ql-stroke" x1="9" x2="15" y1="14" y2="14"/><polyline class="ql-stroke" points="3 14 4 15 6 13"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="3 9 4 10 6 8"/></svg>', $se = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"/><path class="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"/><path class="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"/><path class="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"/></svg>', Lse = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"/><path class="ql-fill" d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"/></svg>', Rse = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"/><path class="ql-fill" d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"/></svg>', jse = '<svg viewbox="0 0 18 18"><line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"/><path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"/><path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"/></svg>', Fse = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="2" width="3" x="5" y="5"/><rect class="ql-fill" height="2" width="4" x="9" y="5"/><g class="ql-fill ql-transparent"><rect height="2" width="3" x="5" y="8"/><rect height="2" width="4" x="9" y="8"/><rect height="2" width="3" x="5" y="11"/><rect height="2" width="4" x="9" y="11"/></g></svg>', Bse = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"/></svg>', qse = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="12" width="1" x="5" y="3"/><rect class="ql-fill" height="12" width="1" x="12" y="3"/><rect class="ql-fill" height="2" width="8" x="5" y="8"/><rect class="ql-fill" height="1" width="3" x="3" y="5"/><rect class="ql-fill" height="1" width="3" x="3" y="7"/><rect class="ql-fill" height="1" width="3" x="3" y="10"/><rect class="ql-fill" height="1" width="3" x="3" y="12"/><rect class="ql-fill" height="1" width="3" x="12" y="5"/><rect class="ql-fill" height="1" width="3" x="12" y="7"/><rect class="ql-fill" height="1" width="3" x="12" y="10"/><rect class="ql-fill" height="1" width="3" x="12" y="12"/></svg>', ou = {
  align: {
    "": dse,
    center: cse,
    right: fse,
    justify: pse
  },
  background: vse,
  blockquote: mse,
  bold: hse,
  clean: gse,
  code: Jw,
  "code-block": Jw,
  color: bse,
  direction: {
    "": yse,
    rtl: _se
  },
  formula: xse,
  header: {
    1: wse,
    2: Tse,
    3: Sse,
    4: Ese,
    5: Ose,
    6: Cse
  },
  italic: kse,
  image: Pse,
  indent: {
    "+1": Mse,
    "-1": Ase
  },
  link: Dse,
  list: {
    bullet: Ise,
    check: Nse,
    ordered: $se
  },
  script: {
    sub: Lse,
    super: Rse
  },
  strike: jse,
  table: Fse,
  underline: Bse,
  video: qse
}, Hse = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"/><polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"/></svg>';
let Qw = 0;
function Zw(e, t) {
  e.setAttribute(t, `${e.getAttribute(t) !== "true"}`);
}
class ff {
  constructor(t) {
    this.select = t, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", () => {
      this.togglePicker();
    }), this.label.addEventListener("keydown", (r) => {
      switch (r.key) {
        case "Enter":
          this.togglePicker();
          break;
        case "Escape":
          this.escape(), r.preventDefault();
          break;
      }
    }), this.select.addEventListener("change", this.update.bind(this));
  }
  togglePicker() {
    this.container.classList.toggle("ql-expanded"), Zw(this.label, "aria-expanded"), Zw(this.options, "aria-hidden");
  }
  buildItem(t) {
    const r = document.createElement("span");
    r.tabIndex = "0", r.setAttribute("role", "button"), r.classList.add("ql-picker-item");
    const a = t.getAttribute("value");
    return a && r.setAttribute("data-value", a), t.textContent && r.setAttribute("data-label", t.textContent), r.addEventListener("click", () => {
      this.selectItem(r, !0);
    }), r.addEventListener("keydown", (n) => {
      switch (n.key) {
        case "Enter":
          this.selectItem(r, !0), n.preventDefault();
          break;
        case "Escape":
          this.escape(), n.preventDefault();
          break;
      }
    }), r;
  }
  buildLabel() {
    const t = document.createElement("span");
    return t.classList.add("ql-picker-label"), t.innerHTML = Hse, t.tabIndex = "0", t.setAttribute("role", "button"), t.setAttribute("aria-expanded", "false"), this.container.appendChild(t), t;
  }
  buildOptions() {
    const t = document.createElement("span");
    t.classList.add("ql-picker-options"), t.setAttribute("aria-hidden", "true"), t.tabIndex = "-1", t.id = `ql-picker-options-${Qw}`, Qw += 1, this.label.setAttribute("aria-controls", t.id), this.options = t, Array.from(this.select.options).forEach((r) => {
      const a = this.buildItem(r);
      t.appendChild(a), r.selected === !0 && this.selectItem(a);
    }), this.container.appendChild(t);
  }
  buildPicker() {
    Array.from(this.select.attributes).forEach((t) => {
      this.container.setAttribute(t.name, t.value);
    }), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions();
  }
  escape() {
    this.close(), setTimeout(() => this.label.focus(), 1);
  }
  close() {
    this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true");
  }
  selectItem(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const a = this.container.querySelector(".ql-selected");
    t !== a && (a != null && a.classList.remove("ql-selected"), t != null && (t.classList.add("ql-selected"), this.select.selectedIndex = Array.from(t.parentNode.children).indexOf(t), t.hasAttribute("data-value") ? this.label.setAttribute("data-value", t.getAttribute("data-value")) : this.label.removeAttribute("data-value"), t.hasAttribute("data-label") ? this.label.setAttribute("data-label", t.getAttribute("data-label")) : this.label.removeAttribute("data-label"), r && (this.select.dispatchEvent(new Event("change")), this.close())));
  }
  update() {
    let t;
    if (this.select.selectedIndex > -1) {
      const a = (
        // @ts-expect-error Fix me later
        this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex]
      );
      t = this.select.options[this.select.selectedIndex], this.selectItem(a);
    } else
      this.selectItem(null);
    const r = t != null && t !== this.select.querySelector("option[selected]");
    this.label.classList.toggle("ql-active", r);
  }
}
class mC extends ff {
  constructor(t, r) {
    super(t), this.label.innerHTML = r, this.container.classList.add("ql-color-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).slice(0, 7).forEach((a) => {
      a.classList.add("ql-primary");
    });
  }
  buildItem(t) {
    const r = super.buildItem(t);
    return r.style.backgroundColor = t.getAttribute("value") || "", r;
  }
  selectItem(t, r) {
    super.selectItem(t, r);
    const a = this.label.querySelector(".ql-color-label"), n = t && t.getAttribute("data-value") || "";
    a && (a.tagName === "line" ? a.style.stroke = n : a.style.fill = n);
  }
}
class hC extends ff {
  constructor(t, r) {
    super(t), this.container.classList.add("ql-icon-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).forEach((a) => {
      a.innerHTML = r[a.getAttribute("data-value") || ""];
    }), this.defaultItem = this.container.querySelector(".ql-selected"), this.selectItem(this.defaultItem);
  }
  selectItem(t, r) {
    super.selectItem(t, r);
    const a = t || this.defaultItem;
    if (a != null) {
      if (this.label.innerHTML === a.innerHTML)
        return;
      this.label.innerHTML = a.innerHTML;
    }
  }
}
const Vse = (e) => {
  const {
    overflowY: t
  } = getComputedStyle(e, null);
  return t !== "visible" && t !== "clip";
};
class gC {
  constructor(t, r) {
    this.quill = t, this.boundsContainer = r || document.body, this.root = t.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, Vse(this.quill.root) && this.quill.root.addEventListener("scroll", () => {
      this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
    }), this.hide();
  }
  hide() {
    this.root.classList.add("ql-hidden");
  }
  position(t) {
    const r = t.left + t.width / 2 - this.root.offsetWidth / 2, a = t.bottom + this.quill.root.scrollTop;
    this.root.style.left = `${r}px`, this.root.style.top = `${a}px`, this.root.classList.remove("ql-flip");
    const n = this.boundsContainer.getBoundingClientRect(), i = this.root.getBoundingClientRect();
    let s = 0;
    if (i.right > n.right && (s = n.right - i.right, this.root.style.left = `${r + s}px`), i.left < n.left && (s = n.left - i.left, this.root.style.left = `${r + s}px`), i.bottom > n.bottom) {
      const o = i.bottom - i.top, l = t.bottom - t.top + o;
      this.root.style.top = `${a - l}px`, this.root.classList.add("ql-flip");
    }
    return s;
  }
  show() {
    this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden");
  }
}
const Use = [!1, "center", "right", "justify"], zse = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"], Yse = [!1, "serif", "monospace"], Wse = ["1", "2", "3", !1], Gse = ["small", !1, "large", "huge"];
class Lu extends So {
  constructor(t, r) {
    super(t, r);
    const a = (n) => {
      if (!document.body.contains(t.root)) {
        document.body.removeEventListener("click", a);
        return;
      }
      this.tooltip != null && // @ts-expect-error
      !this.tooltip.root.contains(n.target) && // @ts-expect-error
      document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus() && this.tooltip.hide(), this.pickers != null && this.pickers.forEach((i) => {
        i.container.contains(n.target) || i.close();
      });
    };
    t.emitter.listenDOM("click", document.body, a);
  }
  addModule(t) {
    const r = super.addModule(t);
    return t === "toolbar" && this.extendToolbar(r), r;
  }
  buildButtons(t, r) {
    Array.from(t).forEach((a) => {
      (a.getAttribute("class") || "").split(/\s+/).forEach((i) => {
        if (i.startsWith("ql-") && (i = i.slice(3), r[i] != null))
          if (i === "direction")
            a.innerHTML = r[i][""] + r[i].rtl;
          else if (typeof r[i] == "string")
            a.innerHTML = r[i];
          else {
            const s = a.value || "";
            s != null && r[i][s] && (a.innerHTML = r[i][s]);
          }
      });
    });
  }
  buildPickers(t, r) {
    this.pickers = Array.from(t).map((n) => {
      if (n.classList.contains("ql-align") && (n.querySelector("option") == null && Ol(n, Use), typeof r.align == "object"))
        return new hC(n, r.align);
      if (n.classList.contains("ql-background") || n.classList.contains("ql-color")) {
        const i = n.classList.contains("ql-background") ? "background" : "color";
        return n.querySelector("option") == null && Ol(n, zse, i === "background" ? "#ffffff" : "#000000"), new mC(n, r[i]);
      }
      return n.querySelector("option") == null && (n.classList.contains("ql-font") ? Ol(n, Yse) : n.classList.contains("ql-header") ? Ol(n, Wse) : n.classList.contains("ql-size") && Ol(n, Gse)), new ff(n);
    });
    const a = () => {
      this.pickers.forEach((n) => {
        n.update();
      });
    };
    this.quill.on(ot.events.EDITOR_CHANGE, a);
  }
}
Lu.DEFAULTS = Qi({}, So.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula() {
          this.quill.theme.tooltip.edit("formula");
        },
        image() {
          let e = this.container.querySelector("input.ql-image[type=file]");
          e == null && (e = document.createElement("input"), e.setAttribute("type", "file"), e.setAttribute("accept", this.quill.uploader.options.mimetypes.join(", ")), e.classList.add("ql-image"), e.addEventListener("change", () => {
            const t = this.quill.getSelection(!0);
            this.quill.uploader.upload(t, e.files), e.value = "";
          }), this.container.appendChild(e)), e.click();
        },
        video() {
          this.quill.theme.tooltip.edit("video");
        }
      }
    }
  }
});
class bC extends gC {
  constructor(t, r) {
    super(t, r), this.textbox = this.root.querySelector('input[type="text"]'), this.listen();
  }
  listen() {
    this.textbox.addEventListener("keydown", (t) => {
      t.key === "Enter" ? (this.save(), t.preventDefault()) : t.key === "Escape" && (this.cancel(), t.preventDefault());
    });
  }
  cancel() {
    this.hide(), this.restoreFocus();
  }
  edit() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link", r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), this.textbox == null)
      return;
    r != null ? this.textbox.value = r : t !== this.root.getAttribute("data-mode") && (this.textbox.value = "");
    const a = this.quill.getBounds(this.quill.selection.savedRange);
    a != null && this.position(a), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute(`data-${t}`) || ""), this.root.setAttribute("data-mode", t);
  }
  restoreFocus() {
    this.quill.focus({
      preventScroll: !0
    });
  }
  save() {
    let {
      value: t
    } = this.textbox;
    switch (this.root.getAttribute("data-mode")) {
      case "link": {
        const {
          scrollTop: r
        } = this.quill.root;
        this.linkRange ? (this.quill.formatText(this.linkRange, "link", t, ot.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", t, ot.sources.USER)), this.quill.root.scrollTop = r;
        break;
      }
      case "video":
        t = Xse(t);
      case "formula": {
        if (!t)
          break;
        const r = this.quill.getSelection(!0);
        if (r != null) {
          const a = r.index + r.length;
          this.quill.insertEmbed(
            a,
            // @ts-expect-error Fix me later
            this.root.getAttribute("data-mode"),
            t,
            ot.sources.USER
          ), this.root.getAttribute("data-mode") === "formula" && this.quill.insertText(a + 1, " ", ot.sources.USER), this.quill.setSelection(a + 2, ot.sources.USER);
        }
        break;
      }
    }
    this.textbox.value = "", this.hide();
  }
}
function Xse(e) {
  let t = e.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || e.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  return t ? `${t[1] || "https"}://www.youtube.com/embed/${t[2]}?showinfo=0` : (t = e.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? `${t[1] || "https"}://player.vimeo.com/video/${t[2]}/` : e;
}
function Ol(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  t.forEach((a) => {
    const n = document.createElement("option");
    a === r ? n.setAttribute("selected", "selected") : n.setAttribute("value", String(a)), e.appendChild(n);
  });
}
const Kse = [["bold", "italic", "link"], [{
  header: 1
}, {
  header: 2
}, "blockquote"]];
class yC extends bC {
  constructor(t, r) {
    super(t, r), this.quill.on(ot.events.EDITOR_CHANGE, (a, n, i, s) => {
      if (a === ot.events.SELECTION_CHANGE)
        if (n != null && n.length > 0 && s === ot.sources.USER) {
          this.show(), this.root.style.left = "0px", this.root.style.width = "", this.root.style.width = `${this.root.offsetWidth}px`;
          const o = this.quill.getLines(n.index, n.length);
          if (o.length === 1) {
            const l = this.quill.getBounds(n);
            l != null && this.position(l);
          } else {
            const l = o[o.length - 1], u = this.quill.getIndex(l), d = Math.min(l.length() - 1, n.index + n.length - u), f = this.quill.getBounds(new Is(u, d));
            f != null && this.position(f);
          }
        } else
          document.activeElement !== this.textbox && this.quill.hasFocus() && this.hide();
    });
  }
  listen() {
    super.listen(), this.root.querySelector(".ql-close").addEventListener("click", () => {
      this.root.classList.remove("ql-editing");
    }), this.quill.on(ot.events.SCROLL_OPTIMIZE, () => {
      setTimeout(() => {
        if (this.root.classList.contains("ql-hidden"))
          return;
        const t = this.quill.getSelection();
        if (t != null) {
          const r = this.quill.getBounds(t);
          r != null && this.position(r);
        }
      }, 1);
    });
  }
  cancel() {
    this.show();
  }
  position(t) {
    const r = super.position(t), a = this.root.querySelector(".ql-tooltip-arrow");
    return a.style.marginLeft = "", r !== 0 && (a.style.marginLeft = `${-1 * r - a.offsetWidth / 2}px`), r;
  }
}
it(yC, "TEMPLATE", ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""));
class _C extends Lu {
  constructor(t, r) {
    r.modules.toolbar != null && r.modules.toolbar.container == null && (r.modules.toolbar.container = Kse), super(t, r), this.quill.container.classList.add("ql-bubble");
  }
  extendToolbar(t) {
    this.tooltip = new yC(this.quill, this.options.bounds), t.container != null && (this.tooltip.root.appendChild(t.container), this.buildButtons(t.container.querySelectorAll("button"), ou), this.buildPickers(t.container.querySelectorAll("select"), ou));
  }
}
_C.DEFAULTS = Qi({}, Lu.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(e) {
          e ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1, De.sources.USER);
        }
      }
    }
  }
});
const Jse = [[{
  header: ["1", "2", "3", !1]
}], ["bold", "italic", "underline", "link"], [{
  list: "ordered"
}, {
  list: "bullet"
}], ["clean"]];
class xC extends bC {
  constructor() {
    super(...arguments);
    it(this, "preview", this.root.querySelector("a.ql-preview"));
  }
  listen() {
    super.listen(), this.root.querySelector("a.ql-action").addEventListener("click", (r) => {
      this.root.classList.contains("ql-editing") ? this.save() : this.edit("link", this.preview.textContent), r.preventDefault();
    }), this.root.querySelector("a.ql-remove").addEventListener("click", (r) => {
      if (this.linkRange != null) {
        const a = this.linkRange;
        this.restoreFocus(), this.quill.formatText(a, "link", !1, ot.sources.USER), delete this.linkRange;
      }
      r.preventDefault(), this.hide();
    }), this.quill.on(ot.events.SELECTION_CHANGE, (r, a, n) => {
      if (r != null) {
        if (r.length === 0 && n === ot.sources.USER) {
          const [i, s] = this.quill.scroll.descendant(Xi, r.index);
          if (i != null) {
            this.linkRange = new Is(r.index - s, i.length());
            const o = Xi.formats(i.domNode);
            this.preview.textContent = o, this.preview.setAttribute("href", o), this.show();
            const l = this.quill.getBounds(this.linkRange);
            l != null && this.position(l);
            return;
          }
        } else
          delete this.linkRange;
        this.hide();
      }
    });
  }
  show() {
    super.show(), this.root.removeAttribute("data-mode");
  }
}
it(xC, "TEMPLATE", ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""));
class wC extends Lu {
  constructor(t, r) {
    r.modules.toolbar != null && r.modules.toolbar.container == null && (r.modules.toolbar.container = Jse), super(t, r), this.quill.container.classList.add("ql-snow");
  }
  extendToolbar(t) {
    t.container != null && (t.container.classList.add("ql-snow"), this.buildButtons(t.container.querySelectorAll("button"), ou), this.buildPickers(t.container.querySelectorAll("select"), ou), this.tooltip = new xC(this.quill, this.options.bounds), t.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({
      key: "k",
      shortKey: !0
    }, (r, a) => {
      t.handlers.link.call(t, !a.format.link);
    }));
  }
}
wC.DEFAULTS = Qi({}, Lu.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(e) {
          if (e) {
            const t = this.quill.getSelection();
            if (t == null || t.length === 0)
              return;
            let r = this.quill.getText(t);
            /^\S+@\S+\.\S+$/.test(r) && r.indexOf("mailto:") !== 0 && (r = `mailto:${r}`);
            const {
              tooltip: a
            } = this.quill.theme;
            a.edit("link", r);
          } else
            this.quill.format("link", !1, De.sources.USER);
        }
      }
    }
  }
});
De.register({
  "attributors/attribute/direction": tC,
  "attributors/class/align": Q3,
  "attributors/class/background": vie,
  "attributors/class/color": pie,
  "attributors/class/direction": rC,
  "attributors/class/font": iC,
  "attributors/class/size": oC,
  "attributors/style/align": Z3,
  "attributors/style/background": gy,
  "attributors/style/color": hy,
  "attributors/style/direction": aC,
  "attributors/style/font": sC,
  "attributors/style/size": lC
}, !0);
De.register({
  "formats/align": Q3,
  "formats/direction": rC,
  "formats/indent": nse,
  "formats/background": gy,
  "formats/color": hy,
  "formats/font": iC,
  "formats/size": oC,
  "formats/blockquote": O1,
  "formats/code-block": ya,
  "formats/header": C1,
  "formats/list": $u,
  "formats/bold": su,
  "formats/code": by,
  "formats/italic": k1,
  "formats/link": Xi,
  "formats/script": P1,
  "formats/strike": M1,
  "formats/underline": A1,
  "formats/formula": cd,
  "formats/image": ise,
  "formats/video": fd,
  "modules/syntax": vC,
  "modules/table": ose,
  "modules/toolbar": Ty,
  "themes/bubble": _C,
  "themes/snow": wC,
  "ui/icons": ou,
  "ui/picker": ff,
  "ui/icon-picker": hC,
  "ui/color-picker": mC,
  "ui/tooltip": gC
}, !0);
const Qse = /<[^>]*>/g, Zse = [
  [{ size: ["small", !1, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, !1] }],
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "link"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }]
];
const eoe = { class: "input" }, toe = {
  key: 1,
  class: "input__error mt-4"
}, cle = /* @__PURE__ */ Ae({
  inheritAttrs: !1,
  __name: "JRichText",
  props: {
    modelValue: {},
    label: { default: "" },
    error: {},
    placeholder: { default: "" },
    contentType: { default: "html" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    toolbar: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = $r(r, "modelValue", t), i = ne(null), s = ne(null), o = Gr(), l = N(() => o("required", !0)), u = N(() => !!r.label), d = N(
      () => l.value && !u.value ? `${r.placeholder} *` : r.placeholder
    ), f = N(() => ({
      modules: {
        toolbar: !r.disabled && (r.toolbar || Zse)
      },
      placeholder: d.value,
      readOnly: r.disabled || r.readonly,
      contentType: r.contentType,
      theme: "snow"
    }));
    function c() {
      i.value && i.value.on("text-change", (v, h, g) => {
        var y;
        if (g !== "user" || r.disabled || r.readonly)
          return;
        const m = (y = i.value) == null ? void 0 : y.getSemanticHTML(), b = m == null ? void 0 : m.replace(Qse, "").trim();
        n.value = b ? m : "";
      });
    }
    async function p() {
      const v = s.value;
      v && (i.value = new De(v, f.value), await Pt(), i.value && (i.value.root.innerHTML = n.value ? n.value : "", c()));
    }
    return ct(p), (v, h) => (R(), K("div", eoe, [
      v.label ? (R(), K("span", {
        key: 0,
        class: pe(["input__label", l.value && "input--required"])
      }, Ie(v.label), 3)) : fe("", !0),
      ue("div", Mt({
        ref_key: "quillElementRef",
        ref: s
      }, v.$attrs, {
        class: [{ "ql-container__disabled bg-gray-300": v.disabled }]
      }), null, 16),
      v.error ? (R(), K("span", toe, Ie(v.error), 1)) : fe("", !0)
    ]));
  }
});
const roe = { class: "flex w-fit select-none items-center gap-x-8 rounded-md bg-gray-200 px-8 py-6" }, aoe = {
  key: 0,
  class: "flex items-baseline gap-x-8 [&>b]:font-bold [&>b]:text-dark [&>span]:text-metadata-limited [&>span]:text-gray-500"
}, noe = /* @__PURE__ */ ue("span", null, "day", -1), ioe = /* @__PURE__ */ ue("span", null, "hr", -1), soe = /* @__PURE__ */ ue("span", null, "min", -1), ooe = {
  key: 1,
  class: "font-medium text-gray-500"
}, fle = /* @__PURE__ */ Ae({
  __name: "JCountDownTimer",
  props: {
    targetDate: {}
  },
  setup(e) {
    const t = e;
    function r(c) {
      if (c instanceof Date) {
        if (Number.isNaN(c.getTime()))
          throw new TypeError(
            "Invalid targetDate prop provided to JCountDownTimer."
          );
        return c;
      }
      const p = new Date(c);
      if (Number.isNaN(p.getTime()))
        throw new TypeError("Invalid targetDate prop provided to JCountDownTimer.");
      return p;
    }
    const a = N(() => r(t.targetDate)), n = ne(/* @__PURE__ */ new Date()), i = ne(null), s = N(() => {
      const c = a.value.getTime() - n.value.getTime();
      return c > 0 ? c : 0;
    }), o = N(() => Math.floor(s.value / (1e3 * 60 * 60 * 24))), l = N(() => Math.floor(s.value / (1e3 * 60 * 60) % 24)), u = N(() => Math.floor(s.value / (1e3 * 60) % 60)), d = N(() => s.value === 0);
    function f() {
      n.value = /* @__PURE__ */ new Date();
    }
    return ct(() => {
      i.value = window.setInterval(f, 1e3 * 1);
    }), Tr(() => {
      i.value && clearInterval(i.value);
    }), He(() => t.targetDate, f), (c, p) => (R(), K("div", roe, [
      Fe(U(gt), {
        name: "timer",
        size: "16",
        class: pe([d.value ? "text-gray-500" : "text-primary"])
      }, null, 8, ["class"]),
      d.value ? (R(), K("span", ooe, " Time's Up! ")) : (R(), K("span", aoe, [
        ue("b", null, Ie(o.value), 1),
        jt(),
        noe,
        jt(),
        ue("b", null, Ie(l.value), 1),
        jt(),
        ioe,
        ue("b", null, Ie(u.value), 1),
        jt(),
        soe
      ]))
    ]));
  }
});
export {
  qa as BG_COLORS,
  Yl as BORDER_COLORS,
  ID as CHECKED_BG_COLORS,
  vJ as COUNTRIES,
  DD as HOVER_BG_COLORS,
  voe as ICONS,
  EM as JAccordion,
  foe as JAccordionGroup,
  goe as JAlert,
  GD as JBottomSheet,
  ale as JBreadcrumb,
  Wl as JButton,
  boe as JButtonDropdown,
  yoe as JButtonDropdownItem,
  _oe as JCard,
  xoe as JCarousel,
  Toe as JCarouselItem,
  TN as JCheckBox,
  Soe as JChip,
  h2 as JCol,
  woe as JCollapse,
  Eoe as JConfirmation,
  Doe as JContainer,
  Ooe as JCountDown,
  fle as JCountDownTimer,
  $N as JCounter,
  Coe as JCounterInput,
  koe as JDateTimePicker,
  Poe as JDrawer,
  Moe as JErrorBoundary,
  rle as JFileInput,
  Aoe as JFlag,
  gt as JIcon,
  BH as JImage,
  nle as JImageUploader,
  RD as JLoading,
  Ioe as JLogo,
  Noe as JMap,
  $oe as JMenu,
  Loe as JMenuItem,
  vV as JModal,
  Roe as JMultiSelect,
  joe as JOTP,
  Qd as JOverlay,
  Foe as JPagination,
  IK as JRadio,
  Boe as JRadioGroup,
  qoe as JRating,
  cle as JRichText,
  RH as JRow,
  Hoe as JSelect,
  Voe as JSkeleton,
  JK as JSlider,
  Uoe as JStepper,
  ZK as JStepperItem,
  zoe as JSwitch,
  Yoe as JTable,
  Woe as JTabs,
  Goe as JTelInput,
  Xoe as JTextArea,
  Koe as JTextInput,
  Qoe as JTimeSlider,
  Joe as JTimeline,
  ele as JToast,
  Zoe as JToggle,
  tle as JTooltip,
  J0 as LazyStatus,
  MD as N_MARGIN_X_LG,
  PD as N_MARGIN_X_MD,
  kD as N_MARGIN_X_SM,
  AD as N_MARGIN_X_XL,
  Zd as OUTLINE_COLORS,
  OD as PADDING_X_LG,
  ED as PADDING_X_MD,
  SD as PADDING_X_SM,
  CD as PADDING_X_XL,
  moe as SIZES,
  gn as TEXT_COLORS,
  hoe as VARIANTS,
  co as openPopups,
  g5 as useCurrentInstance,
  pT as useDevicePlatform,
  W1 as useDropdownPosition,
  Gr as useHasAttr,
  Vn as useHasSlot,
  Ii as useLocale,
  G1 as usePopup,
  wM as usePopupHistorySync,
  UT as useTouchHoldOutside,
  cu as useUid,
  pu as useZIndex
};
